import React__default, { useState, useEffect, useContext, createElement, Fragment as Fragment$1, useReducer, useRef, PureComponent } from 'react';
import AsyncSelect from 'react-select/async';
import { observer } from 'mobx-react-lite';
import { computed } from 'mobx';
import { ThemeContext, common as common$1, Modal as Modal$1, IconButton as IconButton$1, SessionContext, AppContext } from 'kalenis-portal-frontend-main';
import Select from 'react-select';
import moment from 'moment';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { Editor } from '@tinymce/tinymce-react';
import { RgbaStringColorPicker } from 'react-colorful';
import { colord } from 'colord';
import ReactTooltipLite from 'react-tooltip-lite';
import Draggable from 'react-draggable';
import { ResponsiveLine } from '@nivo/line';
import { ResponsiveBar } from '@nivo/bar';
import { ResponsivePie } from '@nivo/pie';
import 'react-virtualized/styles.css';
import { Grid, ScrollSync, AutoSizer, CellMeasurerCache, List, CellMeasurer } from 'react-virtualized';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { momentLocalizer, Calendar as Calendar$1 } from 'react-big-calendar';
import 'moment/locale/es';
import 'react-big-calendar/lib/Toolbar';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

function Paper(props) {
  var classNames = " bg-white";
  var default_shadow = " shadow-xl";

  var getClassName = function getClassName() {
    var cls = props.className ? clsx(classNames, props.className) : classNames;
    cls = props.shadowClass ? clsx(cls, props.shadowClass) : clsx(cls, default_shadow);
    return cls;
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: getClassName(),
    style: props.style || {}
  }, props.children);
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var base_cls = "bg-transparent focus:placeholder-transparent placeholder-gray-900  placeholder-opacity-50 focus:outline-none rounded-lg w-full appearance-none leading-normal";
var types = {
  'char': {
    type: '',
    validateKey: false,
    caretPosition: true
  },
  'float': {
    type: '',
    align: 'right',
    validateKey: function validateKey(key) {
      return /[0-9]|[-]|[.]|[,]|[e]|[E]/.test(key);
    },
    caretPosition: true,
    formatValue: function formatValue(value) {
      return parseFloat(value);
    }
  },
  'integer': {
    type: 'number',
    align: 'right',
    validateKey: function validateKey(key) {
      return /^\d+$/.test(key);
    },
    caretPosition: false
  }
};

function BaseField(props) {
  var field = props.field,
      state_attrs = props.state_attrs,
      onFocus = props.onFocus;
  var type = field.formula_field_widget ? field.formula_field_widget : field.type;
  var inputType = types[type].type;

  function handleKeyPress(e) {
    if (types[type]) {
      if (types[type].validateKey) {
        if (!types[type].validateKey(e.key)) {
          return e.preventDefault();
        }
      }
    }
  }

  return /*#__PURE__*/React__default.createElement("input", {
    id: props.id || props.name,
    autoFocus: props.autoFocus,
    ref: props.inputRef,
    name: props.name,
    label: props.label,
    required: state_attrs.required,
    readOnly: state_attrs.readonly,
    className: base_cls,
    value: props.value,
    onChange: function onChange(e) {
      props.onChange(e, e.target.value);
    },
    onBlur: props.onBlur,
    type: field.hide_value ? 'password' : inputType,
    placeholder: field.description,
    onKeyPress: handleKeyPress,
    onKeyDown: props.handleKeyDown,
    style: props.style,
    autoComplete: "off",
    onFocus: onFocus
  });
}

var customStyles = {
  menu: function menu(provided, state) {
    return _extends({}, provided, {
      borderRadius: '0px',
      marginTop: '0px'
    });
  },
  container: function container(provided, state) {
    return _extends({}, provided, {
      height: '100%'
    });
  },
  control: function control(provided, state) {
    return _extends({}, provided, {
      border: '0px',
      backgroundColor: 'transparent',
      boxShadow: 'none',
      minHeight: '0px',
      top: '10%'
    });
  },
  clearIndicator: function clearIndicator(provided, state) {
    return _extends({}, provided, {
      cursor: 'pointer',
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: '1.5rem',
      ':hover': {
        color: 'red'
      }
    });
  },
  indicatorSeparator: function indicatorSeparator(provided, state) {
    return _extends({}, provided, {
      cursor: 'pointer',
      margin: 0
    });
  },
  dropdownIndicator: function dropdownIndicator(provided, state) {
    return _extends({}, provided, {
      cursor: 'pointer',
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: '1.5rem'
    });
  },
  input: function input(provided, state) {
    return _extends({}, provided, {
      margin: 0,
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: '1.5rem',
      top: '40%'
    });
  },
  valueContainer: function valueContainer(provided, state) {
    return _extends({}, provided, {
      cursor: 'pointer',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0
    });
  },
  placeholder: function placeholder(provided, state) {
    return _extends({}, provided, {
      cursor: 'pointer',
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: '1.5rem',
      top: '40%'
    });
  },
  singleValue: function singleValue(provided, state) {
    return _extends({}, provided, {
      cursor: 'pointer',
      padding: 0,
      maxHeight: '1.5rem',
      overflow: 'unset',
      top: '40%'
    });
  },
  menuPortal: function menuPortal(provided, state) {
    return _extends({}, provided, {
      zIndex: 9999,
      minWidth: 200
    });
  }
};
var AsyncSelectField = observer(function AsyncSelectField(props) {
  var field = props.field,
      record = props.record,
      onBlur = props.onBlur;
  var value = field.get_value(record);

  var _useState = useState(""),
      wKey = _useState[0],
      setWkey = _useState[1];

  var key_fields = computed(function () {
    return field.get_key_fields_values(record);
  }).get();
  useEffect(function () {
    var newK = "";

    for (var k in key_fields) {
      newK = newK.concat(key_fields[k]);
    }

    if (newK !== wKey) {
      console.log("I HAVE A NEW KEY");
      console.log(field.name);
      console.log(newK);
      console.log(wKey);
      setWkey(newK);
    }
  }, [key_fields]);

  var loadOptions = function loadOptions(inputValue, callback) {
    if (props.state_attrs.readonly) {
      return callback([]);
    }

    field.getOptions(record, inputValue).then(function (options) {
      if (inputValue) {
        options = options.filter(function (i) {
          return i.rec_name.toLowerCase().includes(inputValue.toLowerCase());
        });
      }

      callback(options);
    });
  };

  return /*#__PURE__*/React__default.createElement(AsyncSelect, {
    id: props.name,
    name: props.name,
    key: wKey ? wKey : props.name,
    ref: props.inputRef,
    isSearchable: true,
    isClearable: true,
    placeholder: !props.value ? field.description : "",
    noOptionsMessage: function noOptionsMessage() {
      return "";
    },
    value: value,
    getOptionLabel: function getOptionLabel(option) {
      return option.rec_name;
    },
    getOptionValue: function getOptionValue(option) {
      return option.id;
    },
    required: props.state_attrs.required,
    isDisabled: props.state_attrs.readonly,
    menuPortalTarget: document.body,
    menuPosition: 'fixed',
    onChange: function onChange(value) {
      field.set_value(value, record);
      onBlur(false, value);
    },
    cacheOptions: true,
    defaultOptions: true,
    onBlur: props.saveOnBlur,
    styles: customStyles,
    onKeyDown: props.handleKeyDown,
    loadOptions: loadOptions,
    autoFocus: props.autoFocus,
    isMulti: props.multi
  });
});

var customStyles$1 = {
  menu: function menu(provided, state) {
    return _extends({}, provided, {
      borderRadius: '0px',
      marginTop: '0px'
    });
  },
  container: function container(provided, state) {
    return _extends({}, provided, {
      height: '100%'
    });
  },
  control: function control(provided, state) {
    return _extends({}, provided, {
      border: '0px',
      backgroundColor: 'transparent',
      boxShadow: 'none',
      minHeight: '0px',
      top: '10%'
    });
  },
  clearIndicator: function clearIndicator(provided, state) {
    return _extends({}, provided, {
      cursor: 'pointer',
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: '1.5rem',
      ':hover': {
        color: 'red'
      }
    });
  },
  indicatorSeparator: function indicatorSeparator(provided, state) {
    return _extends({}, provided, {
      cursor: 'pointer',
      margin: 0
    });
  },
  dropdownIndicator: function dropdownIndicator(provided, state) {
    return _extends({}, provided, {
      cursor: 'pointer',
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: '1.5rem'
    });
  },
  input: function input(provided, state) {
    return _extends({}, provided, {
      margin: 0,
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: '1.5rem'
    });
  },
  valueContainer: function valueContainer(provided, state) {
    return _extends({}, provided, {
      cursor: 'pointer',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      maxHeight: '1.5rem'
    });
  },
  placeholder: function placeholder(provided, state) {
    return _extends({}, provided, {
      cursor: 'pointer',
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: '1.5rem',
      top: '40%'
    });
  },
  singleValue: function singleValue(provided, state) {
    return _extends({}, provided, {
      cursor: 'pointer',
      padding: 0,
      maxHeight: '1.5rem',
      overflow: 'unset',
      top: '40%',
      color: state.data.color ? state.data.color : "inherit"
    });
  },
  menuPortal: function menuPortal(provided, state) {
    return _extends({}, provided, {
      zIndex: 9999,
      minWidth: 200
    });
  },
  option: function option(provided, state) {
    return _extends({}, provided, {
      color: state.data.color ? state.data.color : "inherit"
    });
  }
};

function SelectField(props) {
  var field = props.field,
      record = props.record,
      onBlur = props.onBlur;
  var value = field.get_value(record);
  var general_theme = useContext(ThemeContext);
  return /*#__PURE__*/React__default.createElement(Select, {
    isSearchable: true,
    autoFocus: props.autoFocus,
    ref: props.inputRef,
    value: value,
    required: props.state_attrs.required,
    isDisabled: props.state_attrs.readonly,
    styles: customStyles$1,
    menuPortalTarget: document.body,
    menuPosition: 'fixed',
    placeholder: field.description,
    onChange: function onChange(value) {
      props.onChange(false, value);
      onBlur(false, value);
    },
    theme: function theme(_theme) {
      return _extends({}, _theme, {
        borderRadius: 0,
        colors: _extends({}, _theme.colors, {
          primary25: general_theme.values.light_selected,
          primary: general_theme.values.light_selected
        })
      });
    },
    onKeyDown: props.handleKeyDown,
    options: field.selection_options,
    isMulti: props.multi,
    onBlur: props.saveOnBlur
  });
}

var _path;

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$1.apply(this, arguments);
}

function SvgNavigationMore(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/createElement("path", {
    d: "M4 12a2 2 0 110-4 2 2 0 010 4zm6 0a2 2 0 110-4 2 2 0 010 4zm6 0a2 2 0 110-4 2 2 0 010 4z"
  })));
}

var base_cls$1 = "bg-transparent focus:placeholder-transparent placeholder-gray-900  placeholder-opacity-50 focus:outline-none rounded-lg w-full appearance-none leading-normal";
var LookUpField = observer(function LookUpField(props) {
  var field = props.field,
      state_attrs = props.state_attrs,
      record = props.record;
  var value = field.get_value(record);
  var loading = value ? value.loading : true;
  return /*#__PURE__*/React__default.createElement(Fragment$1, null, loading ? /*#__PURE__*/React__default.createElement("div", {
    className: "flex justify-end content-end",
    style: {
      minHeight: '1.5rem'
    }
  }, /*#__PURE__*/React__default.createElement(SvgNavigationMore, {
    style: {
      width: '1.2em',
      height: '1.2em'
    },
    className: "fill-current text-xl cursor-pointer w-4 h-2 scale-left-to-right"
  })) : /*#__PURE__*/React__default.createElement("input", {
    id: props.id || props.name,
    autoFocus: props.autoFocus,
    ref: props.inputRef,
    name: props.name,
    label: props.label,
    required: state_attrs.required,
    readOnly: true,
    className: base_cls$1,
    value: loading ? 'Loading...' : value,
    type: field.hide_value ? 'password' : '',
    placeholder: field.description,
    style: props.style,
    autoComplete: "off"
  }));
});

var base_cls$2 = "field-wraper bg-transparent focus:outline-none rounded-lg py-2 px-4 block w-full appearance-none leading-normal";
var cls_modifiers = {
  "error": " border-red-600 border-2",
  "outlined": " focus-within:border-primary focus-within:border-2 border border-gray-400",
  "readonly": " border border-gray-300 bg-gray-200",
  "outlined_no_focus": " border border-gray-400"
};
var shrinkLabel = {
  transform: 'translateY(-1.5em)',
  display: 'inline-block'
};
var fixedLabels = ['boolean', 'one2many', 'html'];
var no_focus_fields = ['html'];
var reducedPadding = ['selection'];
var FieldWrapper = observer(function FieldWrapper(props) {
  var field = props.field,
      value = props.value,
      state_attrs = props.state_attrs,
      record = props.record;
  var error = record._errors[field.name];

  var cls = function cls() {
    if (error) {
      return base_cls$2.concat(cls_modifiers["error"]);
    }

    if (state_attrs.readonly) {
      return base_cls$2.concat(cls_modifiers['readonly']);
    }

    if (no_focus_fields.includes(field.type)) {
      return base_cls$2.concat(cls_modifiers['outlined_no_focus']);
    }

    return base_cls$2.concat(cls_modifiers[props.variant]);
  };

  var style = {
    padding: reducedPadding.includes(props.type) ? "0.13rem" : ""
  };
  return /*#__PURE__*/React__default.createElement(Fragment$1, null, /*#__PURE__*/React__default.createElement("div", {
    style: _extends({}, props.style, style),
    className: cls()
  }, /*#__PURE__*/React__default.createElement("div", {
    style: value || fixedLabels.includes(field.type) || state_attrs.readonly ? shrinkLabel : {},
    className: "field-label rounded text-xs bg-white font-medium text-primary px-2 absolute"
  }, field.description), props.children));
});

var formats = {
  'date': 'DD-MM-YYYY',
  'datetime': 'DD-MM-YYYY HH:mm:ss',
  'time': 'h:mm:ss'
};
var server_formats = {
  'date': 'YYYY-MM-DD',
  'datetime': 'YYYY-MM-DD HH:mm:ss',
  'time': 'hh:mm:ss'
};
var sheet_navigation_signals = ['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Tab', 'Enter'];
var formatDate = function formatDate(value, type) {
  if (value) {
    var format = formats[type];

    if (type === 'date') {
      value = moment.utc(value).format(format);
    } else {
      value = moment.utc(value).local().format(format);
    }
  } else {
    value = "";
  }

  return value;
};
var validateNumber = function validateNumber(value) {
  value = value.replace(',', '.');
  return parseFloat(value);
};
var validateDate = function validateDate(value, type) {
  if (value) {
    var format = server_formats[type];
    value = moment.utc(value).format(format);
  } else {
    value = null;
  }

  return value;
};
var validateInput = {
  'integer': validateNumber,
  'float': validateNumber,
  'numeric': validateNumber,
  'char': function char(value) {
    return value;
  }
};
var extractFilters = function extractFilters(params) {
  var extracted = {
    'current_search': [],
    'order': [],
    'action_params': [],
    'action_id': undefined
  };

  var extract = function extract(p) {
    var filter_value = p[1].split(';');
    var val = filter_value[1];

    if (val.startsWith('[') && val.endsWith(']')) {
      val = val.replace('[', "").replace(']', "");
      val = val.split(',');
    }

    var f = [p[0], filter_value[0], val];
    return f;
  };

  for (var _iterator = _createForOfIteratorHelperLoose(params), _step; !(_step = _iterator()).done;) {
    var p = _step.value;

    if (p[0] === "_order") {
      extracted['order'] = [p[1].split(',')];
    } else if (p[0] === "_action_id") {
      extracted['action_id'] = parseInt(p[1]);
    } else if (p[0] === "_ap") {
      extracted['action_params'].push(p[1].split(';'));
    } else {
      extracted['current_search'].push(extract(p));
    }
  }

  return extracted;
};
var createUrl = function createUrl(params) {
  var query = "?";
  Object.keys(params).map(function (field) {
    if (field === "current_search") {
      var current_search = params[field];
      current_search.forEach(function (domain) {
        var field = domain[0];
        var operator = domain[1];
        var value = domain[2];

        if (value !== "" && value !== undefined) {
          if (operator) {
            if (Array.isArray(value)) {
              value = value.toString();
              value = '['.concat(value).concat(']');
            }
          }

          value = operator.concat(";").concat(value);
        }

        query = query.concat(field).concat('=').concat(value).concat('&');
      });
    } else if (field === 'action_params') {
      var action_params = params[field];

      if (action_params.length) {
        query = query.concat('_ap=');
        action_params.forEach(function (domain) {
          var field = domain[0];
          var operator = domain[1];
          var value = domain[2];

          if (value !== "" && value !== undefined) {
            if (operator) {
              if (Array.isArray(value)) {
                value = value.toString();
                value = '['.concat(value).concat(']');
              }
            }

            value = operator.concat(";").concat(value);
          }

          query = query.concat(field).concat(';').concat(value).concat('&');
        });
      }
    } else if (field === "order") {
      if (params[field].length) {
        query = query.concat('_order').concat("=").concat(params[field].toString());
      }
    } else if (field === "action_id") {
      if (params[field]) {
        query = query.concat('_action_id').concat("=").concat(params[field]);
      }
    }
  });
  return query;
};
var evalExpr = function evalExpr(data, expr, _parent_record) {
  if (!expr) {
    return "";
  }

  var variables_obj = {};
  var variables = expr.match(/{([^}]+)}/g);
  var str = expr;

  if (!data) {
    if (variables) {
      variables.forEach(function (v) {
        str = str.replace(v, "");
      });
    }

    return str;
  }

  if (variables) {
    variables.forEach(function (v) {
      var value = browseObject(data, v, {}, [], _parent_record) || "";
      str = str.replace(v, value);
      variables_obj[v.substring(1, v.length - 1)] = value.toString();
    });
  }

  return {
    str: str,
    variables: variables_obj
  };
};
var browseObject = function browseObject(data, expr, user_context, fields, _parent_record) {
  var value;

  if (expr.includes('{')) {
    expr = expr.replace('{', "").replace('}', "");
  }

  if (expr.startsWith('_parent_record')) {
    if (!_parent_record) {
      return "";
    }

    data = _parent_record;
    expr = expr.replace('_parent_record.', '');
  }

  if (user_context) {
    data['user_context'] = user_context;
  }

  if (!data || !expr) {
    return "";
  }

  var res = [];

  if (expr.split('.').length > 1) {
    var spl = expr.split('.');
    value = data[spl[0]];

    if (data[spl[0].concat('.')]) {
      value = data[spl[0].concat('.')];
    }

    var expr_array = spl.slice(1, spl.length);

    if (Array.isArray(value)) {
      value.forEach(function (val, index) {
        var expression = expr_array.join('.');
        var new_val = browseObject(val, expression, false);

        if (new_val) {
          if (!res.includes(new_val)) {
            res.push(new_val);
          }
        }
      });
      return res;
    }

    expr_array.forEach(function (dot, index) {
      if (!value) {
        return false;
      }

      if (value[dot.concat('.')]) {
        dot = dot.concat('.');
      }

      if (!value[dot]) {
        value = "";
        return "";
      }

      value = value[dot];
    });
  } else if (data.hasOwnProperty(expr)) {
    value = data[expr];
  } else {
    value = expr;
  }

  return value;
};
var flatten = function flatten(arr) {
  return arr.reduce(function (flat, toFlatten) {
    return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
  }, []);
};
var common = {
  validateNumber: validateNumber,
  validateInput: validateInput,
  validateDate: validateDate,
  createUrl: createUrl,
  evalExpr: evalExpr,
  browseObject: browseObject,
  formatDate: formatDate,
  flatten: flatten,
  extractFilters: extractFilters
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var scheduler_production_min = createCommonjsModule(function (module, exports) {

  function f(a, b) {
    var c = a.length;
    a.push(b);

    a: for (; 0 < c;) {
      var d = c - 1 >>> 1,
          e = a[d];
      if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;else break a;
    }
  }

  function h(a) {
    return 0 === a.length ? null : a[0];
  }

  function k(a) {
    if (0 === a.length) return null;
    var b = a[0],
        c = a.pop();

    if (c !== b) {
      a[0] = c;

      a: for (var d = 0, e = a.length, w = e >>> 1; d < w;) {
        var m = 2 * (d + 1) - 1,
            C = a[m],
            n = m + 1,
            x = a[n];
        if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;else break a;
      }
    }

    return b;
  }

  function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
  }

  if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;

    exports.unstable_now = function () {
      return l.now();
    };
  } else {
    var p = Date,
        q = p.now();

    exports.unstable_now = function () {
      return p.now() - q;
    };
  }

  var r = [],
      t = [],
      u = 1,
      v = null,
      y = 3,
      z = !1,
      A = !1,
      B = !1,
      D = "function" === typeof setTimeout ? setTimeout : null,
      E = "function" === typeof clearTimeout ? clearTimeout : null,
      F = "undefined" !== typeof setImmediate ? setImmediate : null;
  "undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);

  function G(a) {
    for (var b = h(t); null !== b;) {
      if (null === b.callback) k(t);else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);else break;
      b = h(t);
    }
  }

  function H(a) {
    B = !1;
    G(a);
    if (!A) if (null !== h(r)) A = !0, I(J);else {
      var b = h(t);
      null !== b && K(H, b.startTime - a);
    }
  }

  function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;

    try {
      G(b);

      for (v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());) {
        var d = v.callback;

        if ("function" === typeof d) {
          v.callback = null;
          y = v.priorityLevel;
          var e = d(v.expirationTime <= b);
          b = exports.unstable_now();
          "function" === typeof e ? v.callback = e : v === h(r) && k(r);
          G(b);
        } else k(r);

        v = h(r);
      }

      if (null !== v) var w = !0;else {
        var m = h(t);
        null !== m && K(H, m.startTime - b);
        w = !1;
      }
      return w;
    } finally {
      v = null, y = c, z = !1;
    }
  }

  var N = !1,
      O = null,
      L = -1,
      P = 5,
      Q = -1;

  function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
  }

  function R() {
    if (null !== O) {
      var a = exports.unstable_now();
      Q = a;
      var b = !0;

      try {
        b = O(!0, a);
      } finally {
        b ? S() : (N = !1, O = null);
      }
    } else N = !1;
  }

  var S;
  if ("function" === typeof F) S = function S() {
    F(R);
  };else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel(),
        U = T.port2;
    T.port1.onmessage = R;

    S = function S() {
      U.postMessage(null);
    };
  } else S = function S() {
    D(R, 0);
  };

  function I(a) {
    O = a;
    N || (N = !0, S());
  }

  function K(a, b) {
    L = D(function () {
      a(exports.unstable_now());
    }, b);
  }

  exports.unstable_IdlePriority = 5;
  exports.unstable_ImmediatePriority = 1;
  exports.unstable_LowPriority = 4;
  exports.unstable_NormalPriority = 3;
  exports.unstable_Profiling = null;
  exports.unstable_UserBlockingPriority = 2;

  exports.unstable_cancelCallback = function (a) {
    a.callback = null;
  };

  exports.unstable_continueExecution = function () {
    A || z || (A = !0, I(J));
  };

  exports.unstable_forceFrameRate = function (a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
  };

  exports.unstable_getCurrentPriorityLevel = function () {
    return y;
  };

  exports.unstable_getFirstCallbackNode = function () {
    return h(r);
  };

  exports.unstable_next = function (a) {
    switch (y) {
      case 1:
      case 2:
      case 3:
        var b = 3;
        break;

      default:
        b = y;
    }

    var c = y;
    y = b;

    try {
      return a();
    } finally {
      y = c;
    }
  };

  exports.unstable_pauseExecution = function () {};

  exports.unstable_requestPaint = function () {};

  exports.unstable_runWithPriority = function (a, b) {
    switch (a) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;

      default:
        a = 3;
    }

    var c = y;
    y = a;

    try {
      return b();
    } finally {
      y = c;
    }
  };

  exports.unstable_scheduleCallback = function (a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;

    switch (a) {
      case 1:
        var e = -1;
        break;

      case 2:
        e = 250;
        break;

      case 5:
        e = 1073741823;
        break;

      case 4:
        e = 1E4;
        break;

      default:
        e = 5E3;
    }

    e = c + e;
    a = {
      id: u++,
      callback: b,
      priorityLevel: a,
      startTime: c,
      expirationTime: e,
      sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
  };

  exports.unstable_shouldYield = M;

  exports.unstable_wrapCallback = function (a) {
    var b = y;
    return function () {
      var c = y;
      y = b;

      try {
        return a.apply(this, arguments);
      } finally {
        y = c;
      }
    };
  };
});

var scheduler_development = createCommonjsModule(function (module, exports) {

  if (process.env.NODE_ENV !== "production") {
    (function () {

      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      }

      var enableSchedulerDebugging = false;
      var enableProfiling = false;
      var frameYieldMs = 5;

      function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
      }

      function peek(heap) {
        return heap.length === 0 ? null : heap[0];
      }

      function pop(heap) {
        if (heap.length === 0) {
          return null;
        }

        var first = heap[0];
        var last = heap.pop();

        if (last !== first) {
          heap[0] = last;
          siftDown(heap, last, 0);
        }

        return first;
      }

      function siftUp(heap, node, i) {
        var index = i;

        while (index > 0) {
          var parentIndex = index - 1 >>> 1;
          var parent = heap[parentIndex];

          if (compare(parent, node) > 0) {
            heap[parentIndex] = node;
            heap[index] = parent;
            index = parentIndex;
          } else {
            return;
          }
        }
      }

      function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        var halfLength = length >>> 1;

        while (index < halfLength) {
          var leftIndex = (index + 1) * 2 - 1;
          var left = heap[leftIndex];
          var rightIndex = leftIndex + 1;
          var right = heap[rightIndex];

          if (compare(left, node) < 0) {
            if (rightIndex < length && compare(right, left) < 0) {
              heap[index] = right;
              heap[rightIndex] = node;
              index = rightIndex;
            } else {
              heap[index] = left;
              heap[leftIndex] = node;
              index = leftIndex;
            }
          } else if (rightIndex < length && compare(right, node) < 0) {
            heap[index] = right;
            heap[rightIndex] = node;
            index = rightIndex;
          } else {
            return;
          }
        }
      }

      function compare(a, b) {
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
      }

      var ImmediatePriority = 1;
      var UserBlockingPriority = 2;
      var NormalPriority = 3;
      var LowPriority = 4;
      var IdlePriority = 5;

      function markTaskErrored(task, ms) {}

      var hasPerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';

      if (hasPerformanceNow) {
        var localPerformance = performance;

        exports.unstable_now = function () {
          return localPerformance.now();
        };
      } else {
        var localDate = Date;
        var initialTime = localDate.now();

        exports.unstable_now = function () {
          return localDate.now() - initialTime;
        };
      }

      var maxSigned31BitInt = 1073741823;
      var IMMEDIATE_PRIORITY_TIMEOUT = -1;
      var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
      var NORMAL_PRIORITY_TIMEOUT = 5000;
      var LOW_PRIORITY_TIMEOUT = 10000;
      var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt;
      var taskQueue = [];
      var timerQueue = [];
      var taskIdCounter = 1;
      var currentTask = null;
      var currentPriorityLevel = NormalPriority;
      var isPerformingWork = false;
      var isHostCallbackScheduled = false;
      var isHostTimeoutScheduled = false;
      var localSetTimeout = typeof setTimeout === 'function' ? setTimeout : null;
      var localClearTimeout = typeof clearTimeout === 'function' ? clearTimeout : null;
      var localSetImmediate = typeof setImmediate !== 'undefined' ? setImmediate : null;
      var isInputPending = typeof navigator !== 'undefined' && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;

      function advanceTimers(currentTime) {
        var timer = peek(timerQueue);

        while (timer !== null) {
          if (timer.callback === null) {
            pop(timerQueue);
          } else if (timer.startTime <= currentTime) {
            pop(timerQueue);
            timer.sortIndex = timer.expirationTime;
            push(taskQueue, timer);
          } else {
            return;
          }

          timer = peek(timerQueue);
        }
      }

      function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);

        if (!isHostCallbackScheduled) {
          if (peek(taskQueue) !== null) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
          } else {
            var firstTimer = peek(timerQueue);

            if (firstTimer !== null) {
              requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
          }
        }
      }

      function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;

        if (isHostTimeoutScheduled) {
          isHostTimeoutScheduled = false;
          cancelHostTimeout();
        }

        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;

        try {
          if (enableProfiling) {
            try {
              return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
              if (currentTask !== null) {
                var currentTime = exports.unstable_now();
                markTaskErrored(currentTask, currentTime);
                currentTask.isQueued = false;
              }

              throw error;
            }
          } else {
            return workLoop(hasTimeRemaining, initialTime);
          }
        } finally {
          currentTask = null;
          currentPriorityLevel = previousPriorityLevel;
          isPerformingWork = false;
        }
      }

      function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);

        while (currentTask !== null && !enableSchedulerDebugging) {
          if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) {
            break;
          }

          var callback = currentTask.callback;

          if (typeof callback === 'function') {
            currentTask.callback = null;
            currentPriorityLevel = currentTask.priorityLevel;
            var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
            var continuationCallback = callback(didUserCallbackTimeout);
            currentTime = exports.unstable_now();

            if (typeof continuationCallback === 'function') {
              currentTask.callback = continuationCallback;
            } else {
              if (currentTask === peek(taskQueue)) {
                pop(taskQueue);
              }
            }

            advanceTimers(currentTime);
          } else {
            pop(taskQueue);
          }

          currentTask = peek(taskQueue);
        }

        if (currentTask !== null) {
          return true;
        } else {
          var firstTimer = peek(timerQueue);

          if (firstTimer !== null) {
            requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
          }

          return false;
        }
      }

      function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch (priorityLevel) {
          case ImmediatePriority:
          case UserBlockingPriority:
          case NormalPriority:
          case LowPriority:
          case IdlePriority:
            break;

          default:
            priorityLevel = NormalPriority;
        }

        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;

        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      }

      function unstable_next(eventHandler) {
        var priorityLevel;

        switch (currentPriorityLevel) {
          case ImmediatePriority:
          case UserBlockingPriority:
          case NormalPriority:
            priorityLevel = NormalPriority;
            break;

          default:
            priorityLevel = currentPriorityLevel;
            break;
        }

        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;

        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      }

      function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function () {
          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = parentPriorityLevel;

          try {
            return callback.apply(this, arguments);
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        };
      }

      function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = exports.unstable_now();
        var startTime;

        if (typeof options === 'object' && options !== null) {
          var delay = options.delay;

          if (typeof delay === 'number' && delay > 0) {
            startTime = currentTime + delay;
          } else {
            startTime = currentTime;
          }
        } else {
          startTime = currentTime;
        }

        var timeout;

        switch (priorityLevel) {
          case ImmediatePriority:
            timeout = IMMEDIATE_PRIORITY_TIMEOUT;
            break;

          case UserBlockingPriority:
            timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
            break;

          case IdlePriority:
            timeout = IDLE_PRIORITY_TIMEOUT;
            break;

          case LowPriority:
            timeout = LOW_PRIORITY_TIMEOUT;
            break;

          case NormalPriority:
          default:
            timeout = NORMAL_PRIORITY_TIMEOUT;
            break;
        }

        var expirationTime = startTime + timeout;
        var newTask = {
          id: taskIdCounter++,
          callback: callback,
          priorityLevel: priorityLevel,
          startTime: startTime,
          expirationTime: expirationTime,
          sortIndex: -1
        };

        if (startTime > currentTime) {
          newTask.sortIndex = startTime;
          push(timerQueue, newTask);

          if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
            if (isHostTimeoutScheduled) {
              cancelHostTimeout();
            } else {
              isHostTimeoutScheduled = true;
            }

            requestHostTimeout(handleTimeout, startTime - currentTime);
          }
        } else {
          newTask.sortIndex = expirationTime;
          push(taskQueue, newTask);

          if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
          }
        }

        return newTask;
      }

      function unstable_pauseExecution() {}

      function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
          isHostCallbackScheduled = true;
          requestHostCallback(flushWork);
        }
      }

      function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
      }

      function unstable_cancelCallback(task) {
        task.callback = null;
      }

      function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
      }

      var isMessageLoopRunning = false;
      var scheduledHostCallback = null;
      var taskTimeoutID = -1;
      var frameInterval = frameYieldMs;
      var startTime = -1;

      function shouldYieldToHost() {
        var timeElapsed = exports.unstable_now() - startTime;

        if (timeElapsed < frameInterval) {
          return false;
        }

        return true;
      }

      function requestPaint() {}

      function forceFrameRate(fps) {
        if (fps < 0 || fps > 125) {
          console['error']('forceFrameRate takes a positive int between 0 and 125, ' + 'forcing frame rates higher than 125 fps is not supported');
          return;
        }

        if (fps > 0) {
          frameInterval = Math.floor(1000 / fps);
        } else {
          frameInterval = frameYieldMs;
        }
      }

      var performWorkUntilDeadline = function performWorkUntilDeadline() {
        if (scheduledHostCallback !== null) {
          var currentTime = exports.unstable_now();
          startTime = currentTime;
          var hasTimeRemaining = true;
          var hasMoreWork = true;

          try {
            hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
          } finally {
            if (hasMoreWork) {
              schedulePerformWorkUntilDeadline();
            } else {
              isMessageLoopRunning = false;
              scheduledHostCallback = null;
            }
          }
        } else {
          isMessageLoopRunning = false;
        }
      };

      var schedulePerformWorkUntilDeadline;

      if (typeof localSetImmediate === 'function') {
        schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
          localSetImmediate(performWorkUntilDeadline);
        };
      } else if (typeof MessageChannel !== 'undefined') {
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;

        schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
          port.postMessage(null);
        };
      } else {
        schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
          localSetTimeout(performWorkUntilDeadline, 0);
        };
      }

      function requestHostCallback(callback) {
        scheduledHostCallback = callback;

        if (!isMessageLoopRunning) {
          isMessageLoopRunning = true;
          schedulePerformWorkUntilDeadline();
        }
      }

      function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function () {
          callback(exports.unstable_now());
        }, ms);
      }

      function cancelHostTimeout() {
        localClearTimeout(taskTimeoutID);
        taskTimeoutID = -1;
      }

      var unstable_requestPaint = requestPaint;
      var unstable_Profiling = null;
      exports.unstable_IdlePriority = IdlePriority;
      exports.unstable_ImmediatePriority = ImmediatePriority;
      exports.unstable_LowPriority = LowPriority;
      exports.unstable_NormalPriority = NormalPriority;
      exports.unstable_Profiling = unstable_Profiling;
      exports.unstable_UserBlockingPriority = UserBlockingPriority;
      exports.unstable_cancelCallback = unstable_cancelCallback;
      exports.unstable_continueExecution = unstable_continueExecution;
      exports.unstable_forceFrameRate = forceFrameRate;
      exports.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
      exports.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
      exports.unstable_next = unstable_next;
      exports.unstable_pauseExecution = unstable_pauseExecution;
      exports.unstable_requestPaint = unstable_requestPaint;
      exports.unstable_runWithPriority = unstable_runWithPriority;
      exports.unstable_scheduleCallback = unstable_scheduleCallback;
      exports.unstable_shouldYield = shouldYieldToHost;
      exports.unstable_wrapCallback = unstable_wrapCallback;

      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }
    })();
  }
});

var scheduler = createCommonjsModule(function (module) {

  if (process.env.NODE_ENV === 'production') {
    module.exports = scheduler_production_min;
  } else {
    module.exports = scheduler_development;
  }
});

function p(a) {
  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) {
    b += "&args[]=" + encodeURIComponent(arguments[c]);
  }

  return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}

var da = new Set(),
    ea = {};

function fa(a, b) {
  ha(a, b);
  ha(a + "Capture", b);
}

function ha(a, b) {
  ea[a] = b;

  for (a = 0; a < b.length; a++) {
    da.add(b[a]);
  }
}

var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement),
    ja = Object.prototype.hasOwnProperty,
    ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    la = {},
    ma = {};

function na(a) {
  if (ja.call(ma, a)) return !0;
  if (ja.call(la, a)) return !1;
  if (ka.test(a)) return ma[a] = !0;
  la[a] = !0;
  return !1;
}

function oa(a, b, c, d) {
  if (null !== c && 0 === c.type) return !1;

  switch (typeof b) {
    case "function":
    case "symbol":
      return !0;

    case "boolean":
      if (d) return !1;
      if (null !== c) return !c.acceptsBooleans;
      a = a.toLowerCase().slice(0, 5);
      return "data-" !== a && "aria-" !== a;

    default:
      return !1;
  }
}

function pa(a, b, c, d) {
  if (null === b || "undefined" === typeof b || oa(a, b, c, d)) return !0;
  if (d) return !1;
  if (null !== c) switch (c.type) {
    case 3:
      return !b;

    case 4:
      return !1 === b;

    case 5:
      return isNaN(b);

    case 6:
      return isNaN(b) || 1 > b;
  }
  return !1;
}

function t(a, b, c, d, e, f, g) {
  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
  this.attributeName = d;
  this.attributeNamespace = e;
  this.mustUseProperty = c;
  this.propertyName = a;
  this.type = b;
  this.sanitizeURL = f;
  this.removeEmptyString = g;
}

var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
  z[a] = new t(a, 0, !1, a, null, !1, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
  var b = a[0];
  z[b] = new t(b, 1, !1, a[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
  z[a] = new t(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a) {
  z[a] = new t(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
  z[a] = new t(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function (a) {
  z[a] = new t(a, 3, !0, a, null, !1, !1);
});
["capture", "download"].forEach(function (a) {
  z[a] = new t(a, 4, !1, a, null, !1, !1);
});
["cols", "rows", "size", "span"].forEach(function (a) {
  z[a] = new t(a, 6, !1, a, null, !1, !1);
});
["rowSpan", "start"].forEach(function (a) {
  z[a] = new t(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var qa = /[\-:]([a-z])/g;

function ra(a) {
  return a[1].toUpperCase();
}

"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
  var b = a.replace(qa, ra);
  z[b] = new t(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
  var b = a.replace(qa, ra);
  z[b] = new t(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
  var b = a.replace(qa, ra);
  z[b] = new t(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
["tabIndex", "crossOrigin"].forEach(function (a) {
  z[a] = new t(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new t("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
["src", "href", "action", "formAction"].forEach(function (a) {
  z[a] = new t(a, 1, !1, a.toLowerCase(), null, !0, !0);
});

function sa(a, b, c, d) {
  var e = z.hasOwnProperty(b) ? z[b] : null;
  if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) pa(b, c, e, d) && (c = null), d || null === e ? na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}

var ta = React__default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    ua = Symbol["for"]("react.element"),
    va = Symbol["for"]("react.portal"),
    wa = Symbol["for"]("react.fragment"),
    xa = Symbol["for"]("react.strict_mode"),
    za = Symbol["for"]("react.profiler"),
    Aa = Symbol["for"]("react.provider"),
    Ba = Symbol["for"]("react.context"),
    Ca = Symbol["for"]("react.forward_ref"),
    Da = Symbol["for"]("react.suspense"),
    Ea = Symbol["for"]("react.suspense_list"),
    Fa = Symbol["for"]("react.memo"),
    Ga = Symbol["for"]("react.lazy");
var Ha = Symbol["for"]("react.offscreen");
var Ia = Symbol.iterator;

function Ja(a) {
  if (null === a || "object" !== typeof a) return null;
  a = Ia && a[Ia] || a["@@iterator"];
  return "function" === typeof a ? a : null;
}

var A = Object.assign,
    Ka;

function La(a) {
  if (void 0 === Ka) try {
    throw Error();
  } catch (c) {
    var b = c.stack.trim().match(/\n( *(at )?)/);
    Ka = b && b[1] || "";
  }
  return "\n" + Ka + a;
}

var Ma = !1;

function Na(a, b) {
  if (!a || Ma) return "";
  Ma = !0;
  var c = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;

  try {
    if (b) {
      if (b = function b() {
        throw Error();
      }, Object.defineProperty(b.prototype, "props", {
        set: function set() {
          throw Error();
        }
      }), "object" === typeof Reflect && Reflect.construct) {
        try {
          Reflect.construct(b, []);
        } catch (l) {
          var d = l;
        }

        Reflect.construct(a, [], b);
      } else {
        try {
          b.call();
        } catch (l) {
          d = l;
        }

        a.call(b.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (l) {
        d = l;
      }

      a();
    }
  } catch (l) {
    if (l && d && "string" === typeof l.stack) {
      for (var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];) {
        h--;
      }

      for (; 1 <= g && 0 <= h; g--, h--) {
        if (e[g] !== f[h]) {
          if (1 !== g || 1 !== h) {
            do {
              if (g--, h--, 0 > h || e[g] !== f[h]) {
                var k = "\n" + e[g].replace(" at new ", " at ");
                a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                return k;
              }
            } while (1 <= g && 0 <= h);
          }

          break;
        }
      }
    }
  } finally {
    Ma = !1, Error.prepareStackTrace = c;
  }

  return (a = a ? a.displayName || a.name : "") ? La(a) : "";
}

function Oa(a) {
  switch (a.tag) {
    case 5:
      return La(a.type);

    case 16:
      return La("Lazy");

    case 13:
      return La("Suspense");

    case 19:
      return La("SuspenseList");

    case 0:
    case 2:
    case 15:
      return a = Na(a.type, !1), a;

    case 11:
      return a = Na(a.type.render, !1), a;

    case 1:
      return a = Na(a.type, !0), a;

    default:
      return "";
  }
}

function Pa(a) {
  if (null == a) return null;
  if ("function" === typeof a) return a.displayName || a.name || null;
  if ("string" === typeof a) return a;

  switch (a) {
    case wa:
      return "Fragment";

    case va:
      return "Portal";

    case za:
      return "Profiler";

    case xa:
      return "StrictMode";

    case Da:
      return "Suspense";

    case Ea:
      return "SuspenseList";
  }

  if ("object" === typeof a) switch (a.$$typeof) {
    case Ba:
      return (a.displayName || "Context") + ".Consumer";

    case Aa:
      return (a._context.displayName || "Context") + ".Provider";

    case Ca:
      var b = a.render;
      a = a.displayName;
      a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
      return a;

    case Fa:
      return b = a.displayName || null, null !== b ? b : Pa(a.type) || "Memo";

    case Ga:
      b = a._payload;
      a = a._init;

      try {
        return Pa(a(b));
      } catch (c) {}

  }
  return null;
}

function Qa(a) {
  var b = a.type;

  switch (a.tag) {
    case 24:
      return "Cache";

    case 9:
      return (b.displayName || "Context") + ".Consumer";

    case 10:
      return (b._context.displayName || "Context") + ".Provider";

    case 18:
      return "DehydratedFragment";

    case 11:
      return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");

    case 7:
      return "Fragment";

    case 5:
      return b;

    case 4:
      return "Portal";

    case 3:
      return "Root";

    case 6:
      return "Text";

    case 16:
      return Pa(b);

    case 8:
      return b === xa ? "StrictMode" : "Mode";

    case 22:
      return "Offscreen";

    case 12:
      return "Profiler";

    case 21:
      return "Scope";

    case 13:
      return "Suspense";

    case 19:
      return "SuspenseList";

    case 25:
      return "TracingMarker";

    case 1:
    case 0:
    case 17:
    case 2:
    case 14:
    case 15:
      if ("function" === typeof b) return b.displayName || b.name || null;
      if ("string" === typeof b) return b;
  }

  return null;
}

function Ra(a) {
  switch (typeof a) {
    case "boolean":
    case "number":
    case "string":
    case "undefined":
      return a;

    case "object":
      return a;

    default:
      return "";
  }
}

function Sa(a) {
  var b = a.type;
  return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}

function Ta(a) {
  var b = Sa(a) ? "checked" : "value",
      c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b),
      d = "" + a[b];

  if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
    var e = c.get,
        f = c.set;
    Object.defineProperty(a, b, {
      configurable: !0,
      get: function get() {
        return e.call(this);
      },
      set: function set(a) {
        d = "" + a;
        f.call(this, a);
      }
    });
    Object.defineProperty(a, b, {
      enumerable: c.enumerable
    });
    return {
      getValue: function getValue() {
        return d;
      },
      setValue: function setValue(a) {
        d = "" + a;
      },
      stopTracking: function stopTracking() {
        a._valueTracker = null;
        delete a[b];
      }
    };
  }
}

function Ua(a) {
  a._valueTracker || (a._valueTracker = Ta(a));
}

function Va(a) {
  if (!a) return !1;
  var b = a._valueTracker;
  if (!b) return !0;
  var c = b.getValue();
  var d = "";
  a && (d = Sa(a) ? a.checked ? "true" : "false" : a.value);
  a = d;
  return a !== c ? (b.setValue(a), !0) : !1;
}

function Wa(a) {
  a = a || ("undefined" !== typeof document ? document : void 0);
  if ("undefined" === typeof a) return null;

  try {
    return a.activeElement || a.body;
  } catch (b) {
    return a.body;
  }
}

function Xa(a, b) {
  var c = b.checked;
  return A({}, b, {
    defaultChecked: void 0,
    defaultValue: void 0,
    value: void 0,
    checked: null != c ? c : a._wrapperState.initialChecked
  });
}

function Ya(a, b) {
  var c = null == b.defaultValue ? "" : b.defaultValue,
      d = null != b.checked ? b.checked : b.defaultChecked;
  c = Ra(null != b.value ? b.value : c);
  a._wrapperState = {
    initialChecked: d,
    initialValue: c,
    controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
  };
}

function Za(a, b) {
  b = b.checked;
  null != b && sa(a, "checked", b, !1);
}

function $a(a, b) {
  Za(a, b);
  var c = Ra(b.value),
      d = b.type;
  if (null != c) {
    if ("number" === d) {
      if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
    } else a.value !== "" + c && (a.value = "" + c);
  } else if ("submit" === d || "reset" === d) {
    a.removeAttribute("value");
    return;
  }
  b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Ra(b.defaultValue));
  null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}

function cb(a, b, c) {
  if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
    var d = b.type;
    if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
    b = "" + a._wrapperState.initialValue;
    c || b === a.value || (a.value = b);
    a.defaultValue = b;
  }

  c = a.name;
  "" !== c && (a.name = "");
  a.defaultChecked = !!a._wrapperState.initialChecked;
  "" !== c && (a.name = c);
}

function bb(a, b, c) {
  if ("number" !== b || Wa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}

var db = Array.isArray;

function eb(a, b, c, d) {
  a = a.options;

  if (b) {
    b = {};

    for (var e = 0; e < c.length; e++) {
      b["$" + c[e]] = !0;
    }

    for (c = 0; c < a.length; c++) {
      e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    }
  } else {
    c = "" + Ra(c);
    b = null;

    for (e = 0; e < a.length; e++) {
      if (a[e].value === c) {
        a[e].selected = !0;
        d && (a[e].defaultSelected = !0);
        return;
      }

      null !== b || a[e].disabled || (b = a[e]);
    }

    null !== b && (b.selected = !0);
  }
}

function fb(a, b) {
  if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
  return A({}, b, {
    value: void 0,
    defaultValue: void 0,
    children: "" + a._wrapperState.initialValue
  });
}

function gb(a, b) {
  var c = b.value;

  if (null == c) {
    c = b.children;
    b = b.defaultValue;

    if (null != c) {
      if (null != b) throw Error(p(92));

      if (db(c)) {
        if (1 < c.length) throw Error(p(93));
        c = c[0];
      }

      b = c;
    }

    null == b && (b = "");
    c = b;
  }

  a._wrapperState = {
    initialValue: Ra(c)
  };
}

function hb(a, b) {
  var c = Ra(b.value),
      d = Ra(b.defaultValue);
  null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
  null != d && (a.defaultValue = "" + d);
}

function ib(a) {
  var b = a.textContent;
  b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}

function jb(a) {
  switch (a) {
    case "svg":
      return "http://www.w3.org/2000/svg";

    case "math":
      return "http://www.w3.org/1998/Math/MathML";

    default:
      return "http://www.w3.org/1999/xhtml";
  }
}

function kb(a, b) {
  return null == a || "http://www.w3.org/1999/xhtml" === a ? jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}

var lb,
    mb = function (a) {
  return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function (b, c, d, e) {
    MSApp.execUnsafeLocalFunction(function () {
      return a(b, c, d, e);
    });
  } : a;
}(function (a, b) {
  if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;else {
    lb = lb || document.createElement("div");
    lb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";

    for (b = lb.firstChild; a.firstChild;) {
      a.removeChild(a.firstChild);
    }

    for (; b.firstChild;) {
      a.appendChild(b.firstChild);
    }
  }
});

function nb(a, b) {
  if (b) {
    var c = a.firstChild;

    if (c && c === a.lastChild && 3 === c.nodeType) {
      c.nodeValue = b;
      return;
    }
  }

  a.textContent = b;
}

var ob = {
  animationIterationCount: !0,
  aspectRatio: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridArea: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
},
    pb = ["Webkit", "ms", "Moz", "O"];
Object.keys(ob).forEach(function (a) {
  pb.forEach(function (b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);
    ob[b] = ob[a];
  });
});

function qb(a, b, c) {
  return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || ob.hasOwnProperty(a) && ob[a] ? ("" + b).trim() : b + "px";
}

function rb(a, b) {
  a = a.style;

  for (var c in b) {
    if (b.hasOwnProperty(c)) {
      var d = 0 === c.indexOf("--"),
          e = qb(c, b[c], d);
      "float" === c && (c = "cssFloat");
      d ? a.setProperty(c, e) : a[c] = e;
    }
  }
}

var sb = A({
  menuitem: !0
}, {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  keygen: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
});

function tb(a, b) {
  if (b) {
    if (sb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));

    if (null != b.dangerouslySetInnerHTML) {
      if (null != b.children) throw Error(p(60));
      if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
    }

    if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
  }
}

function ub(a, b) {
  if (-1 === a.indexOf("-")) return "string" === typeof b.is;

  switch (a) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;

    default:
      return !0;
  }
}

var vb = null;

function wb(a) {
  a = a.target || a.srcElement || window;
  a.correspondingUseElement && (a = a.correspondingUseElement);
  return 3 === a.nodeType ? a.parentNode : a;
}

var xb = null,
    yb = null,
    zb = null;

function Ab(a) {
  if (a = Bb(a)) {
    if ("function" !== typeof xb) throw Error(p(280));
    var b = a.stateNode;
    b && (b = Cb(b), xb(a.stateNode, a.type, b));
  }
}

function Db(a) {
  yb ? zb ? zb.push(a) : zb = [a] : yb = a;
}

function Eb() {
  if (yb) {
    var a = yb,
        b = zb;
    zb = yb = null;
    Ab(a);
    if (b) for (a = 0; a < b.length; a++) {
      Ab(b[a]);
    }
  }
}

function Fb(a, b) {
  return a(b);
}

function Gb() {}

var Hb = !1;

function Ib(a, b, c) {
  if (Hb) return a(b, c);
  Hb = !0;

  try {
    return Fb(a, b, c);
  } finally {
    if (Hb = !1, null !== yb || null !== zb) Gb(), Eb();
  }
}

function Jb(a, b) {
  var c = a.stateNode;
  if (null === c) return null;
  var d = Cb(c);
  if (null === d) return null;
  c = d[b];

  a: switch (b) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
      a = !d;
      break a;

    default:
      a = !1;
  }

  if (a) return null;
  if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
  return c;
}

var Kb = !1;
if (ia) try {
  var Lb = {};
  Object.defineProperty(Lb, "passive", {
    get: function get() {
      Kb = !0;
    }
  });
  window.addEventListener("test", Lb, Lb);
  window.removeEventListener("test", Lb, Lb);
} catch (a) {
  Kb = !1;
}

function Mb(a, b, c, d, e, f, g, h, k) {
  var l = Array.prototype.slice.call(arguments, 3);

  try {
    b.apply(c, l);
  } catch (n) {
    this.onError(n);
  }
}

var Nb = !1,
    Ob = null,
    Pb = !1,
    Qb = null,
    Rb = {
  onError: function onError(a) {
    Nb = !0;
    Ob = a;
  }
};

function Sb(a, b, c, d, e, f, g, h, k) {
  Nb = !1;
  Ob = null;
  Mb.apply(Rb, arguments);
}

function Tb(a, b, c, d, e, f, g, h, k) {
  Sb.apply(this, arguments);

  if (Nb) {
    if (Nb) {
      var l = Ob;
      Nb = !1;
      Ob = null;
    } else throw Error(p(198));

    Pb || (Pb = !0, Qb = l);
  }
}

function Ub(a) {
  var b = a,
      c = a;
  if (a.alternate) for (; b["return"];) {
    b = b["return"];
  } else {
    a = b;

    do {
      b = a, 0 !== (b.flags & 4098) && (c = b["return"]), a = b["return"];
    } while (a);
  }
  return 3 === b.tag ? c : null;
}

function Vb(a) {
  if (13 === a.tag) {
    var b = a.memoizedState;
    null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
    if (null !== b) return b.dehydrated;
  }

  return null;
}

function Wb(a) {
  if (Ub(a) !== a) throw Error(p(188));
}

function Xb(a) {
  var b = a.alternate;

  if (!b) {
    b = Ub(a);
    if (null === b) throw Error(p(188));
    return b !== a ? null : a;
  }

  for (var c = a, d = b;;) {
    var e = c["return"];
    if (null === e) break;
    var f = e.alternate;

    if (null === f) {
      d = e["return"];

      if (null !== d) {
        c = d;
        continue;
      }

      break;
    }

    if (e.child === f.child) {
      for (f = e.child; f;) {
        if (f === c) return Wb(e), a;
        if (f === d) return Wb(e), b;
        f = f.sibling;
      }

      throw Error(p(188));
    }

    if (c["return"] !== d["return"]) c = e, d = f;else {
      for (var g = !1, h = e.child; h;) {
        if (h === c) {
          g = !0;
          c = e;
          d = f;
          break;
        }

        if (h === d) {
          g = !0;
          d = e;
          c = f;
          break;
        }

        h = h.sibling;
      }

      if (!g) {
        for (h = f.child; h;) {
          if (h === c) {
            g = !0;
            c = f;
            d = e;
            break;
          }

          if (h === d) {
            g = !0;
            d = f;
            c = e;
            break;
          }

          h = h.sibling;
        }

        if (!g) throw Error(p(189));
      }
    }
    if (c.alternate !== d) throw Error(p(190));
  }

  if (3 !== c.tag) throw Error(p(188));
  return c.stateNode.current === c ? a : b;
}

function Yb(a) {
  a = Xb(a);
  return null !== a ? Zb(a) : null;
}

function Zb(a) {
  if (5 === a.tag || 6 === a.tag) return a;

  for (a = a.child; null !== a;) {
    var b = Zb(a);
    if (null !== b) return b;
    a = a.sibling;
  }

  return null;
}

var $b = scheduler.unstable_scheduleCallback,
    ac = scheduler.unstable_cancelCallback,
    bc = scheduler.unstable_shouldYield,
    cc = scheduler.unstable_requestPaint,
    B = scheduler.unstable_now,
    dc = scheduler.unstable_getCurrentPriorityLevel,
    ec = scheduler.unstable_ImmediatePriority,
    fc = scheduler.unstable_UserBlockingPriority,
    gc = scheduler.unstable_NormalPriority,
    hc = scheduler.unstable_LowPriority,
    ic = scheduler.unstable_IdlePriority,
    jc = null,
    kc = null;

function lc(a) {
  if (kc && "function" === typeof kc.onCommitFiberRoot) try {
    kc.onCommitFiberRoot(jc, a, void 0, 128 === (a.current.flags & 128));
  } catch (b) {}
}

var nc = Math.clz32 ? Math.clz32 : mc,
    oc = Math.log,
    pc = Math.LN2;

function mc(a) {
  a >>>= 0;
  return 0 === a ? 32 : 31 - (oc(a) / pc | 0) | 0;
}

var qc = 64,
    rc = 4194304;

function sc(a) {
  switch (a & -a) {
    case 1:
      return 1;

    case 2:
      return 2;

    case 4:
      return 4;

    case 8:
      return 8;

    case 16:
      return 16;

    case 32:
      return 32;

    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return a & 4194240;

    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return a & 130023424;

    case 134217728:
      return 134217728;

    case 268435456:
      return 268435456;

    case 536870912:
      return 536870912;

    case 1073741824:
      return 1073741824;

    default:
      return a;
  }
}

function tc(a, b) {
  var c = a.pendingLanes;
  if (0 === c) return 0;
  var d = 0,
      e = a.suspendedLanes,
      f = a.pingedLanes,
      g = c & 268435455;

  if (0 !== g) {
    var h = g & ~e;
    0 !== h ? d = sc(h) : (f &= g, 0 !== f && (d = sc(f)));
  } else g = c & ~e, 0 !== g ? d = sc(g) : 0 !== f && (d = sc(f));

  if (0 === d) return 0;
  if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
  0 !== (d & 4) && (d |= c & 16);
  b = a.entangledLanes;
  if (0 !== b) for (a = a.entanglements, b &= d; 0 < b;) {
    c = 31 - nc(b), e = 1 << c, d |= a[c], b &= ~e;
  }
  return d;
}

function uc(a, b) {
  switch (a) {
    case 1:
    case 2:
    case 4:
      return b + 250;

    case 8:
    case 16:
    case 32:
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return b + 5E3;

    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return -1;

    case 134217728:
    case 268435456:
    case 536870912:
    case 1073741824:
      return -1;

    default:
      return -1;
  }
}

function vc(a, b) {
  for (var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;) {
    var g = 31 - nc(f),
        h = 1 << g,
        k = e[g];

    if (-1 === k) {
      if (0 === (h & c) || 0 !== (h & d)) e[g] = uc(h, b);
    } else k <= b && (a.expiredLanes |= h);

    f &= ~h;
  }
}

function wc(a) {
  a = a.pendingLanes & -1073741825;
  return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}

function xc() {
  var a = qc;
  qc <<= 1;
  0 === (qc & 4194240) && (qc = 64);
  return a;
}

function yc(a) {
  for (var b = [], c = 0; 31 > c; c++) {
    b.push(a);
  }

  return b;
}

function zc(a, b, c) {
  a.pendingLanes |= b;
  536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
  a = a.eventTimes;
  b = 31 - nc(b);
  a[b] = c;
}

function Ac(a, b) {
  var c = a.pendingLanes & ~b;
  a.pendingLanes = b;
  a.suspendedLanes = 0;
  a.pingedLanes = 0;
  a.expiredLanes &= b;
  a.mutableReadLanes &= b;
  a.entangledLanes &= b;
  b = a.entanglements;
  var d = a.eventTimes;

  for (a = a.expirationTimes; 0 < c;) {
    var e = 31 - nc(c),
        f = 1 << e;
    b[e] = 0;
    d[e] = -1;
    a[e] = -1;
    c &= ~f;
  }
}

function Bc(a, b) {
  var c = a.entangledLanes |= b;

  for (a = a.entanglements; c;) {
    var d = 31 - nc(c),
        e = 1 << d;
    e & b | a[d] & b && (a[d] |= b);
    c &= ~e;
  }
}

var C = 0;

function Cc(a) {
  a &= -a;
  return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}

var Dc,
    Ec,
    Fc,
    Gc,
    Hc,
    Ic = !1,
    Jc = [],
    Kc = null,
    Lc = null,
    Mc = null,
    Nc = new Map(),
    Oc = new Map(),
    Pc = [],
    Qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");

function Rc(a, b) {
  switch (a) {
    case "focusin":
    case "focusout":
      Kc = null;
      break;

    case "dragenter":
    case "dragleave":
      Lc = null;
      break;

    case "mouseover":
    case "mouseout":
      Mc = null;
      break;

    case "pointerover":
    case "pointerout":
      Nc["delete"](b.pointerId);
      break;

    case "gotpointercapture":
    case "lostpointercapture":
      Oc["delete"](b.pointerId);
  }
}

function Sc(a, b, c, d, e, f) {
  if (null === a || a.nativeEvent !== f) return a = {
    blockedOn: b,
    domEventName: c,
    eventSystemFlags: d,
    nativeEvent: f,
    targetContainers: [e]
  }, null !== b && (b = Bb(b), null !== b && Ec(b)), a;
  a.eventSystemFlags |= d;
  b = a.targetContainers;
  null !== e && -1 === b.indexOf(e) && b.push(e);
  return a;
}

function Tc(a, b, c, d, e) {
  switch (b) {
    case "focusin":
      return Kc = Sc(Kc, a, b, c, d, e), !0;

    case "dragenter":
      return Lc = Sc(Lc, a, b, c, d, e), !0;

    case "mouseover":
      return Mc = Sc(Mc, a, b, c, d, e), !0;

    case "pointerover":
      var f = e.pointerId;
      Nc.set(f, Sc(Nc.get(f) || null, a, b, c, d, e));
      return !0;

    case "gotpointercapture":
      return f = e.pointerId, Oc.set(f, Sc(Oc.get(f) || null, a, b, c, d, e)), !0;
  }

  return !1;
}

function Uc(a) {
  var b = Vc(a.target);

  if (null !== b) {
    var c = Ub(b);
    if (null !== c) if (b = c.tag, 13 === b) {
      if (b = Vb(c), null !== b) {
        a.blockedOn = b;
        Hc(a.priority, function () {
          Fc(c);
        });
        return;
      }
    } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
      a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
      return;
    }
  }

  a.blockedOn = null;
}

function Wc(a) {
  if (null !== a.blockedOn) return !1;

  for (var b = a.targetContainers; 0 < b.length;) {
    var c = Xc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);

    if (null === c) {
      c = a.nativeEvent;
      var d = new c.constructor(c.type, c);
      vb = d;
      c.target.dispatchEvent(d);
      vb = null;
    } else return b = Bb(c), null !== b && Ec(b), a.blockedOn = c, !1;

    b.shift();
  }

  return !0;
}

function Yc(a, b, c) {
  Wc(a) && c["delete"](b);
}

function Zc() {
  Ic = !1;
  null !== Kc && Wc(Kc) && (Kc = null);
  null !== Lc && Wc(Lc) && (Lc = null);
  null !== Mc && Wc(Mc) && (Mc = null);
  Nc.forEach(Yc);
  Oc.forEach(Yc);
}

function $c(a, b) {
  a.blockedOn === b && (a.blockedOn = null, Ic || (Ic = !0, scheduler.unstable_scheduleCallback(scheduler.unstable_NormalPriority, Zc)));
}

function ad(a) {
  function b(b) {
    return $c(b, a);
  }

  if (0 < Jc.length) {
    $c(Jc[0], a);

    for (var c = 1; c < Jc.length; c++) {
      var d = Jc[c];
      d.blockedOn === a && (d.blockedOn = null);
    }
  }

  null !== Kc && $c(Kc, a);
  null !== Lc && $c(Lc, a);
  null !== Mc && $c(Mc, a);
  Nc.forEach(b);
  Oc.forEach(b);

  for (c = 0; c < Pc.length; c++) {
    d = Pc[c], d.blockedOn === a && (d.blockedOn = null);
  }

  for (; 0 < Pc.length && (c = Pc[0], null === c.blockedOn);) {
    Uc(c), null === c.blockedOn && Pc.shift();
  }
}

var bd = ta.ReactCurrentBatchConfig,
    cd = !0;

function dd(a, b, c, d) {
  var e = C,
      f = bd.transition;
  bd.transition = null;

  try {
    C = 1, ed(a, b, c, d);
  } finally {
    C = e, bd.transition = f;
  }
}

function fd(a, b, c, d) {
  var e = C,
      f = bd.transition;
  bd.transition = null;

  try {
    C = 4, ed(a, b, c, d);
  } finally {
    C = e, bd.transition = f;
  }
}

function ed(a, b, c, d) {
  if (cd) {
    var e = Xc(a, b, c, d);
    if (null === e) gd(a, b, d, hd, c), Rc(a, d);else if (Tc(e, a, b, c, d)) d.stopPropagation();else if (Rc(a, d), b & 4 && -1 < Qc.indexOf(a)) {
      for (; null !== e;) {
        var f = Bb(e);
        null !== f && Dc(f);
        f = Xc(a, b, c, d);
        null === f && gd(a, b, d, hd, c);
        if (f === e) break;
        e = f;
      }

      null !== e && d.stopPropagation();
    } else gd(a, b, d, null, c);
  }
}

var hd = null;

function Xc(a, b, c, d) {
  hd = null;
  a = wb(d);
  a = Vc(a);
  if (null !== a) if (b = Ub(a), null === b) a = null;else if (c = b.tag, 13 === c) {
    a = Vb(b);
    if (null !== a) return a;
    a = null;
  } else if (3 === c) {
    if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
    a = null;
  } else b !== a && (a = null);
  hd = a;
  return null;
}

function id(a) {
  switch (a) {
    case "cancel":
    case "click":
    case "close":
    case "contextmenu":
    case "copy":
    case "cut":
    case "auxclick":
    case "dblclick":
    case "dragend":
    case "dragstart":
    case "drop":
    case "focusin":
    case "focusout":
    case "input":
    case "invalid":
    case "keydown":
    case "keypress":
    case "keyup":
    case "mousedown":
    case "mouseup":
    case "paste":
    case "pause":
    case "play":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
    case "ratechange":
    case "reset":
    case "resize":
    case "seeked":
    case "submit":
    case "touchcancel":
    case "touchend":
    case "touchstart":
    case "volumechange":
    case "change":
    case "selectionchange":
    case "textInput":
    case "compositionstart":
    case "compositionend":
    case "compositionupdate":
    case "beforeblur":
    case "afterblur":
    case "beforeinput":
    case "blur":
    case "fullscreenchange":
    case "focus":
    case "hashchange":
    case "popstate":
    case "select":
    case "selectstart":
      return 1;

    case "drag":
    case "dragenter":
    case "dragexit":
    case "dragleave":
    case "dragover":
    case "mousemove":
    case "mouseout":
    case "mouseover":
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "scroll":
    case "toggle":
    case "touchmove":
    case "wheel":
    case "mouseenter":
    case "mouseleave":
    case "pointerenter":
    case "pointerleave":
      return 4;

    case "message":
      switch (dc()) {
        case ec:
          return 1;

        case fc:
          return 4;

        case gc:
        case hc:
          return 16;

        case ic:
          return 536870912;

        default:
          return 16;
      }

    default:
      return 16;
  }
}

var jd = null,
    kd = null,
    ld = null;

function md() {
  if (ld) return ld;
  var a,
      b = kd,
      c = b.length,
      d,
      e = "value" in jd ? jd.value : jd.textContent,
      f = e.length;

  for (a = 0; a < c && b[a] === e[a]; a++) {
  }

  var g = c - a;

  for (d = 1; d <= g && b[c - d] === e[f - d]; d++) {
  }

  return ld = e.slice(a, 1 < d ? 1 - d : void 0);
}

function nd(a) {
  var b = a.keyCode;
  "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
  10 === a && (a = 13);
  return 32 <= a || 13 === a ? a : 0;
}

function od() {
  return !0;
}

function pd() {
  return !1;
}

function qd(a) {
  function b(b, d, e, f, g) {
    this._reactName = b;
    this._targetInst = e;
    this.type = d;
    this.nativeEvent = f;
    this.target = g;
    this.currentTarget = null;

    for (var c in a) {
      a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
    }

    this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? od : pd;
    this.isPropagationStopped = pd;
    return this;
  }

  A(b.prototype, {
    preventDefault: function preventDefault() {
      this.defaultPrevented = !0;
      var a = this.nativeEvent;
      a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = od);
    },
    stopPropagation: function stopPropagation() {
      var a = this.nativeEvent;
      a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = od);
    },
    persist: function persist() {},
    isPersistent: od
  });
  return b;
}

var rd = {
  eventPhase: 0,
  bubbles: 0,
  cancelable: 0,
  timeStamp: function timeStamp(a) {
    return a.timeStamp || Date.now();
  },
  defaultPrevented: 0,
  isTrusted: 0
},
    sd = qd(rd),
    td = A({}, rd, {
  view: 0,
  detail: 0
}),
    ud = qd(td),
    vd,
    wd,
    xd,
    zd = A({}, td, {
  screenX: 0,
  screenY: 0,
  clientX: 0,
  clientY: 0,
  pageX: 0,
  pageY: 0,
  ctrlKey: 0,
  shiftKey: 0,
  altKey: 0,
  metaKey: 0,
  getModifierState: yd,
  button: 0,
  buttons: 0,
  relatedTarget: function relatedTarget(a) {
    return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
  },
  movementX: function movementX(a) {
    if ("movementX" in a) return a.movementX;
    a !== xd && (xd && "mousemove" === a.type ? (vd = a.screenX - xd.screenX, wd = a.screenY - xd.screenY) : wd = vd = 0, xd = a);
    return vd;
  },
  movementY: function movementY(a) {
    return "movementY" in a ? a.movementY : wd;
  }
}),
    Ad = qd(zd),
    Bd = A({}, zd, {
  dataTransfer: 0
}),
    Cd = qd(Bd),
    Dd = A({}, td, {
  relatedTarget: 0
}),
    Ed = qd(Dd),
    Fd = A({}, rd, {
  animationName: 0,
  elapsedTime: 0,
  pseudoElement: 0
}),
    Gd = qd(Fd),
    Hd = A({}, rd, {
  clipboardData: function clipboardData(a) {
    return "clipboardData" in a ? a.clipboardData : window.clipboardData;
  }
}),
    Id = qd(Hd),
    Jd = A({}, rd, {
  data: 0
}),
    Kd = qd(Jd),
    Ld = {
  Esc: "Escape",
  Spacebar: " ",
  Left: "ArrowLeft",
  Up: "ArrowUp",
  Right: "ArrowRight",
  Down: "ArrowDown",
  Del: "Delete",
  Win: "OS",
  Menu: "ContextMenu",
  Apps: "ContextMenu",
  Scroll: "ScrollLock",
  MozPrintableKey: "Unidentified"
},
    Md = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
},
    Nd = {
  Alt: "altKey",
  Control: "ctrlKey",
  Meta: "metaKey",
  Shift: "shiftKey"
};

function Od(a) {
  var b = this.nativeEvent;
  return b.getModifierState ? b.getModifierState(a) : (a = Nd[a]) ? !!b[a] : !1;
}

function yd() {
  return Od;
}

var Pd = A({}, td, {
  key: function key(a) {
    if (a.key) {
      var b = Ld[a.key] || a.key;
      if ("Unidentified" !== b) return b;
    }

    return "keypress" === a.type ? (a = nd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Md[a.keyCode] || "Unidentified" : "";
  },
  code: 0,
  location: 0,
  ctrlKey: 0,
  shiftKey: 0,
  altKey: 0,
  metaKey: 0,
  repeat: 0,
  locale: 0,
  getModifierState: yd,
  charCode: function charCode(a) {
    return "keypress" === a.type ? nd(a) : 0;
  },
  keyCode: function keyCode(a) {
    return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  },
  which: function which(a) {
    return "keypress" === a.type ? nd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  }
}),
    Qd = qd(Pd),
    Rd = A({}, zd, {
  pointerId: 0,
  width: 0,
  height: 0,
  pressure: 0,
  tangentialPressure: 0,
  tiltX: 0,
  tiltY: 0,
  twist: 0,
  pointerType: 0,
  isPrimary: 0
}),
    Sd = qd(Rd),
    Td = A({}, td, {
  touches: 0,
  targetTouches: 0,
  changedTouches: 0,
  altKey: 0,
  metaKey: 0,
  ctrlKey: 0,
  shiftKey: 0,
  getModifierState: yd
}),
    Ud = qd(Td),
    Vd = A({}, rd, {
  propertyName: 0,
  elapsedTime: 0,
  pseudoElement: 0
}),
    Wd = qd(Vd),
    Xd = A({}, zd, {
  deltaX: function deltaX(a) {
    return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
  },
  deltaY: function deltaY(a) {
    return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
  },
  deltaZ: 0,
  deltaMode: 0
}),
    Yd = qd(Xd),
    Zd = [9, 13, 27, 32],
    $d = ia && "CompositionEvent" in window,
    ae = null;
ia && "documentMode" in document && (ae = document.documentMode);
var be = ia && "TextEvent" in window && !ae,
    ce = ia && (!$d || ae && 8 < ae && 11 >= ae),
    de = String.fromCharCode(32),
    ee = !1;

function fe(a, b) {
  switch (a) {
    case "keyup":
      return -1 !== Zd.indexOf(b.keyCode);

    case "keydown":
      return 229 !== b.keyCode;

    case "keypress":
    case "mousedown":
    case "focusout":
      return !0;

    default:
      return !1;
  }
}

function ge(a) {
  a = a.detail;
  return "object" === typeof a && "data" in a ? a.data : null;
}

var he = !1;

function ie(a, b) {
  switch (a) {
    case "compositionend":
      return ge(b);

    case "keypress":
      if (32 !== b.which) return null;
      ee = !0;
      return de;

    case "textInput":
      return a = b.data, a === de && ee ? null : a;

    default:
      return null;
  }
}

function je(a, b) {
  if (he) return "compositionend" === a || !$d && fe(a, b) ? (a = md(), ld = kd = jd = null, he = !1, a) : null;

  switch (a) {
    case "paste":
      return null;

    case "keypress":
      if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
        if (b["char"] && 1 < b["char"].length) return b["char"];
        if (b.which) return String.fromCharCode(b.which);
      }

      return null;

    case "compositionend":
      return ce && "ko" !== b.locale ? null : b.data;

    default:
      return null;
  }
}

var ke = {
  color: !0,
  date: !0,
  datetime: !0,
  "datetime-local": !0,
  email: !0,
  month: !0,
  number: !0,
  password: !0,
  range: !0,
  search: !0,
  tel: !0,
  text: !0,
  time: !0,
  url: !0,
  week: !0
};

function le(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return "input" === b ? !!ke[a.type] : "textarea" === b ? !0 : !1;
}

function me(a, b, c, d) {
  Db(d);
  b = ne(b, "onChange");
  0 < b.length && (c = new sd("onChange", "change", null, c, d), a.push({
    event: c,
    listeners: b
  }));
}

var oe = null,
    pe = null;

function qe(a) {
  re(a, 0);
}

function se(a) {
  var b = te(a);
  if (Va(b)) return a;
}

function ue(a, b) {
  if ("change" === a) return b;
}

var ve = !1;

if (ia) {
  var we;

  if (ia) {
    var xe = ("oninput" in document);

    if (!xe) {
      var ye = document.createElement("div");
      ye.setAttribute("oninput", "return;");
      xe = "function" === typeof ye.oninput;
    }

    we = xe;
  } else we = !1;

  ve = we && (!document.documentMode || 9 < document.documentMode);
}

function ze() {
  oe && (oe.detachEvent("onpropertychange", Ae), pe = oe = null);
}

function Ae(a) {
  if ("value" === a.propertyName && se(pe)) {
    var b = [];
    me(b, pe, a, wb(a));
    Ib(qe, b);
  }
}

function Be(a, b, c) {
  "focusin" === a ? (ze(), oe = b, pe = c, oe.attachEvent("onpropertychange", Ae)) : "focusout" === a && ze();
}

function Ce(a) {
  if ("selectionchange" === a || "keyup" === a || "keydown" === a) return se(pe);
}

function De(a, b) {
  if ("click" === a) return se(b);
}

function Ee(a, b) {
  if ("input" === a || "change" === a) return se(b);
}

function Fe(a, b) {
  return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}

var Ge = "function" === typeof Object.is ? Object.is : Fe;

function He(a, b) {
  if (Ge(a, b)) return !0;
  if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
  var c = Object.keys(a),
      d = Object.keys(b);
  if (c.length !== d.length) return !1;

  for (d = 0; d < c.length; d++) {
    var e = c[d];
    if (!ja.call(b, e) || !Ge(a[e], b[e])) return !1;
  }

  return !0;
}

function Ie(a) {
  for (; a && a.firstChild;) {
    a = a.firstChild;
  }

  return a;
}

function Je(a, b) {
  var c = Ie(a);
  a = 0;

  for (var d; c;) {
    if (3 === c.nodeType) {
      d = a + c.textContent.length;
      if (a <= b && d >= b) return {
        node: c,
        offset: b - a
      };
      a = d;
    }

    a: {
      for (; c;) {
        if (c.nextSibling) {
          c = c.nextSibling;
          break a;
        }

        c = c.parentNode;
      }

      c = void 0;
    }

    c = Ie(c);
  }
}

function Ke(a, b) {
  return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Ke(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}

function Le() {
  for (var a = window, b = Wa(); b instanceof a.HTMLIFrameElement;) {
    try {
      var c = "string" === typeof b.contentWindow.location.href;
    } catch (d) {
      c = !1;
    }

    if (c) a = b.contentWindow;else break;
    b = Wa(a.document);
  }

  return b;
}

function Me(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}

function Ne(a) {
  var b = Le(),
      c = a.focusedElem,
      d = a.selectionRange;

  if (b !== c && c && c.ownerDocument && Ke(c.ownerDocument.documentElement, c)) {
    if (null !== d && Me(c)) if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
      a = a.getSelection();
      var e = c.textContent.length,
          f = Math.min(d.start, e);
      d = void 0 === d.end ? f : Math.min(d.end, e);
      !a.extend && f > d && (e = d, d = f, f = e);
      e = Je(c, f);
      var g = Je(c, d);
      e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
    }
    b = [];

    for (a = c; a = a.parentNode;) {
      1 === a.nodeType && b.push({
        element: a,
        left: a.scrollLeft,
        top: a.scrollTop
      });
    }

    "function" === typeof c.focus && c.focus();

    for (c = 0; c < b.length; c++) {
      a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
  }
}

var Oe = ia && "documentMode" in document && 11 >= document.documentMode,
    Pe = null,
    Qe = null,
    Re = null,
    Se = !1;

function Te(a, b, c) {
  var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
  Se || null == Pe || Pe !== Wa(d) || (d = Pe, "selectionStart" in d && Me(d) ? d = {
    start: d.selectionStart,
    end: d.selectionEnd
  } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
    anchorNode: d.anchorNode,
    anchorOffset: d.anchorOffset,
    focusNode: d.focusNode,
    focusOffset: d.focusOffset
  }), Re && He(Re, d) || (Re = d, d = ne(Qe, "onSelect"), 0 < d.length && (b = new sd("onSelect", "select", null, b, c), a.push({
    event: b,
    listeners: d
  }), b.target = Pe)));
}

function Ue(a, b) {
  var c = {};
  c[a.toLowerCase()] = b.toLowerCase();
  c["Webkit" + a] = "webkit" + b;
  c["Moz" + a] = "moz" + b;
  return c;
}

var Ve = {
  animationend: Ue("Animation", "AnimationEnd"),
  animationiteration: Ue("Animation", "AnimationIteration"),
  animationstart: Ue("Animation", "AnimationStart"),
  transitionend: Ue("Transition", "TransitionEnd")
},
    We = {},
    Xe = {};
ia && (Xe = document.createElement("div").style, "AnimationEvent" in window || (delete Ve.animationend.animation, delete Ve.animationiteration.animation, delete Ve.animationstart.animation), "TransitionEvent" in window || delete Ve.transitionend.transition);

function Ye(a) {
  if (We[a]) return We[a];
  if (!Ve[a]) return a;
  var b = Ve[a],
      c;

  for (c in b) {
    if (b.hasOwnProperty(c) && c in Xe) return We[a] = b[c];
  }

  return a;
}

var Ze = Ye("animationend"),
    $e = Ye("animationiteration"),
    af = Ye("animationstart"),
    bf = Ye("transitionend"),
    cf = new Map(),
    df = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");

function ef(a, b) {
  cf.set(a, b);
  fa(b, [a]);
}

for (var ff = 0; ff < df.length; ff++) {
  var gf = df[ff],
      hf = gf.toLowerCase(),
      jf = gf[0].toUpperCase() + gf.slice(1);
  ef(hf, "on" + jf);
}

ef(Ze, "onAnimationEnd");
ef($e, "onAnimationIteration");
ef(af, "onAnimationStart");
ef("dblclick", "onDoubleClick");
ef("focusin", "onFocus");
ef("focusout", "onBlur");
ef(bf, "onTransitionEnd");
ha("onMouseEnter", ["mouseout", "mouseover"]);
ha("onMouseLeave", ["mouseout", "mouseover"]);
ha("onPointerEnter", ["pointerout", "pointerover"]);
ha("onPointerLeave", ["pointerout", "pointerover"]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var kf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
    lf = new Set("cancel close invalid load scroll toggle".split(" ").concat(kf));

function mf(a, b, c) {
  var d = a.type || "unknown-event";
  a.currentTarget = c;
  Tb(d, b, void 0, a);
  a.currentTarget = null;
}

function re(a, b) {
  b = 0 !== (b & 4);

  for (var c = 0; c < a.length; c++) {
    var d = a[c],
        e = d.event;
    d = d.listeners;

    a: {
      var f = void 0;
      if (b) for (var g = d.length - 1; 0 <= g; g--) {
        var h = d[g],
            k = h.instance,
            l = h.currentTarget;
        h = h.listener;
        if (k !== f && e.isPropagationStopped()) break a;
        mf(e, h, l);
        f = k;
      } else for (g = 0; g < d.length; g++) {
        h = d[g];
        k = h.instance;
        l = h.currentTarget;
        h = h.listener;
        if (k !== f && e.isPropagationStopped()) break a;
        mf(e, h, l);
        f = k;
      }
    }
  }

  if (Pb) throw a = Qb, Pb = !1, Qb = null, a;
}

function D(a, b) {
  var c = b[nf];
  void 0 === c && (c = b[nf] = new Set());
  var d = a + "__bubble";
  c.has(d) || (of(b, a, 2, !1), c.add(d));
}

function pf(a, b, c) {
  var d = 0;
  b && (d |= 4);
  of(c, a, d, b);
}

var qf = "_reactListening" + Math.random().toString(36).slice(2);

function rf(a) {
  if (!a[qf]) {
    a[qf] = !0;
    da.forEach(function (b) {
      "selectionchange" !== b && (lf.has(b) || pf(b, !1, a), pf(b, !0, a));
    });
    var b = 9 === a.nodeType ? a : a.ownerDocument;
    null === b || b[qf] || (b[qf] = !0, pf("selectionchange", !1, b));
  }
}

function of(a, b, c, d) {
  switch (id(b)) {
    case 1:
      var e = dd;
      break;

    case 4:
      e = fd;
      break;

    default:
      e = ed;
  }

  c = e.bind(null, b, c, a);
  e = void 0;
  !Kb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
  d ? void 0 !== e ? a.addEventListener(b, c, {
    capture: !0,
    passive: e
  }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
    passive: e
  }) : a.addEventListener(b, c, !1);
}

function gd(a, b, c, d, e) {
  var f = d;
  if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for (;;) {
    if (null === d) return;
    var g = d.tag;

    if (3 === g || 4 === g) {
      var h = d.stateNode.containerInfo;
      if (h === e || 8 === h.nodeType && h.parentNode === e) break;
      if (4 === g) for (g = d["return"]; null !== g;) {
        var k = g.tag;
        if (3 === k || 4 === k) if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
        g = g["return"];
      }

      for (; null !== h;) {
        g = Vc(h);
        if (null === g) return;
        k = g.tag;

        if (5 === k || 6 === k) {
          d = f = g;
          continue a;
        }

        h = h.parentNode;
      }
    }

    d = d["return"];
  }
  Ib(function () {
    var d = f,
        e = wb(c),
        g = [];

    a: {
      var h = cf.get(a);

      if (void 0 !== h) {
        var k = sd,
            m = a;

        switch (a) {
          case "keypress":
            if (0 === nd(c)) break a;

          case "keydown":
          case "keyup":
            k = Qd;
            break;

          case "focusin":
            m = "focus";
            k = Ed;
            break;

          case "focusout":
            m = "blur";
            k = Ed;
            break;

          case "beforeblur":
          case "afterblur":
            k = Ed;
            break;

          case "click":
            if (2 === c.button) break a;

          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            k = Ad;
            break;

          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            k = Cd;
            break;

          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            k = Ud;
            break;

          case Ze:
          case $e:
          case af:
            k = Gd;
            break;

          case bf:
            k = Wd;
            break;

          case "scroll":
            k = ud;
            break;

          case "wheel":
            k = Yd;
            break;

          case "copy":
          case "cut":
          case "paste":
            k = Id;
            break;

          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            k = Sd;
        }

        var w = 0 !== (b & 4),
            J = !w && "scroll" === a,
            v = w ? null !== h ? h + "Capture" : null : h;
        w = [];

        for (var x = d, r; null !== x;) {
          r = x;
          var F = r.stateNode;
          5 === r.tag && null !== F && (r = F, null !== v && (F = Jb(x, v), null != F && w.push(sf(x, F, r))));
          if (J) break;
          x = x["return"];
        }

        0 < w.length && (h = new k(h, m, null, c, e), g.push({
          event: h,
          listeners: w
        }));
      }
    }

    if (0 === (b & 7)) {
      a: {
        h = "mouseover" === a || "pointerover" === a;
        k = "mouseout" === a || "pointerout" === a;
        if (h && c !== vb && (m = c.relatedTarget || c.fromElement) && (Vc(m) || m[tf])) break a;

        if (k || h) {
          h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;

          if (k) {
            if (m = c.relatedTarget || c.toElement, k = d, m = m ? Vc(m) : null, null !== m && (J = Ub(m), m !== J || 5 !== m.tag && 6 !== m.tag)) m = null;
          } else k = null, m = d;

          if (k !== m) {
            w = Ad;
            F = "onMouseLeave";
            v = "onMouseEnter";
            x = "mouse";
            if ("pointerout" === a || "pointerover" === a) w = Sd, F = "onPointerLeave", v = "onPointerEnter", x = "pointer";
            J = null == k ? h : te(k);
            r = null == m ? h : te(m);
            h = new w(F, x + "leave", k, c, e);
            h.target = J;
            h.relatedTarget = r;
            F = null;
            Vc(e) === d && (w = new w(v, x + "enter", m, c, e), w.target = r, w.relatedTarget = J, F = w);
            J = F;
            if (k && m) b: {
              w = k;
              v = m;
              x = 0;

              for (r = w; r; r = uf(r)) {
                x++;
              }

              r = 0;

              for (F = v; F; F = uf(F)) {
                r++;
              }

              for (; 0 < x - r;) {
                w = uf(w), x--;
              }

              for (; 0 < r - x;) {
                v = uf(v), r--;
              }

              for (; x--;) {
                if (w === v || null !== v && w === v.alternate) break b;
                w = uf(w);
                v = uf(v);
              }

              w = null;
            } else w = null;
            null !== k && vf(g, h, k, w, !1);
            null !== m && null !== J && vf(g, J, m, w, !0);
          }
        }
      }

      a: {
        h = d ? te(d) : window;
        k = h.nodeName && h.nodeName.toLowerCase();
        if ("select" === k || "input" === k && "file" === h.type) var Z = ue;else if (le(h)) {
          if (ve) Z = Ee;else {
            Z = Ce;
            var ya = Be;
          }
        } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (Z = De);

        if (Z && (Z = Z(a, d))) {
          me(g, Z, c, e);
          break a;
        }

        ya && ya(a, h, d);
        "focusout" === a && (ya = h._wrapperState) && ya.controlled && "number" === h.type && bb(h, "number", h.value);
      }

      ya = d ? te(d) : window;

      switch (a) {
        case "focusin":
          if (le(ya) || "true" === ya.contentEditable) Pe = ya, Qe = d, Re = null;
          break;

        case "focusout":
          Re = Qe = Pe = null;
          break;

        case "mousedown":
          Se = !0;
          break;

        case "contextmenu":
        case "mouseup":
        case "dragend":
          Se = !1;
          Te(g, c, e);
          break;

        case "selectionchange":
          if (Oe) break;

        case "keydown":
        case "keyup":
          Te(g, c, e);
      }

      var ab;
      if ($d) b: {
        switch (a) {
          case "compositionstart":
            var ca = "onCompositionStart";
            break b;

          case "compositionend":
            ca = "onCompositionEnd";
            break b;

          case "compositionupdate":
            ca = "onCompositionUpdate";
            break b;
        }

        ca = void 0;
      } else he ? fe(a, c) && (ca = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ca = "onCompositionStart");
      ca && (ce && "ko" !== c.locale && (he || "onCompositionStart" !== ca ? "onCompositionEnd" === ca && he && (ab = md()) : (jd = e, kd = "value" in jd ? jd.value : jd.textContent, he = !0)), ya = ne(d, ca), 0 < ya.length && (ca = new Kd(ca, a, null, c, e), g.push({
        event: ca,
        listeners: ya
      }), ab ? ca.data = ab : (ab = ge(c), null !== ab && (ca.data = ab))));
      if (ab = be ? ie(a, c) : je(a, c)) d = ne(d, "onBeforeInput"), 0 < d.length && (e = new Kd("onBeforeInput", "beforeinput", null, c, e), g.push({
        event: e,
        listeners: d
      }), e.data = ab);
    }

    re(g, b);
  });
}

function sf(a, b, c) {
  return {
    instance: a,
    listener: b,
    currentTarget: c
  };
}

function ne(a, b) {
  for (var c = b + "Capture", d = []; null !== a;) {
    var e = a,
        f = e.stateNode;
    5 === e.tag && null !== f && (e = f, f = Jb(a, c), null != f && d.unshift(sf(a, f, e)), f = Jb(a, b), null != f && d.push(sf(a, f, e)));
    a = a["return"];
  }

  return d;
}

function uf(a) {
  if (null === a) return null;

  do {
    a = a["return"];
  } while (a && 5 !== a.tag);

  return a ? a : null;
}

function vf(a, b, c, d, e) {
  for (var f = b._reactName, g = []; null !== c && c !== d;) {
    var h = c,
        k = h.alternate,
        l = h.stateNode;
    if (null !== k && k === d) break;
    5 === h.tag && null !== l && (h = l, e ? (k = Jb(c, f), null != k && g.unshift(sf(c, k, h))) : e || (k = Jb(c, f), null != k && g.push(sf(c, k, h))));
    c = c["return"];
  }

  0 !== g.length && a.push({
    event: b,
    listeners: g
  });
}

var wf = /\r\n?/g,
    xf = /\u0000|\uFFFD/g;

function yf(a) {
  return ("string" === typeof a ? a : "" + a).replace(wf, "\n").replace(xf, "");
}

function zf(a, b, c) {
  b = yf(b);
  if (yf(a) !== b && c) throw Error(p(425));
}

function Af() {}

var Bf = null,
    Cf = null;

function Df(a, b) {
  return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}

var Ef = "function" === typeof setTimeout ? setTimeout : void 0,
    Ff = "function" === typeof clearTimeout ? clearTimeout : void 0,
    Gf = "function" === typeof Promise ? Promise : void 0,
    If = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Gf ? function (a) {
  return Gf.resolve(null).then(a)["catch"](Hf);
} : Ef;

function Hf(a) {
  setTimeout(function () {
    throw a;
  });
}

function Jf(a, b) {
  var c = b,
      d = 0;

  do {
    var e = c.nextSibling;
    a.removeChild(c);
    if (e && 8 === e.nodeType) if (c = e.data, "/$" === c) {
      if (0 === d) {
        a.removeChild(e);
        ad(b);
        return;
      }

      d--;
    } else "$" !== c && "$?" !== c && "$!" !== c || d++;
    c = e;
  } while (c);

  ad(b);
}

function Kf(a) {
  for (; null != a; a = a.nextSibling) {
    var b = a.nodeType;
    if (1 === b || 3 === b) break;

    if (8 === b) {
      b = a.data;
      if ("$" === b || "$!" === b || "$?" === b) break;
      if ("/$" === b) return null;
    }
  }

  return a;
}

function Lf(a) {
  a = a.previousSibling;

  for (var b = 0; a;) {
    if (8 === a.nodeType) {
      var c = a.data;

      if ("$" === c || "$!" === c || "$?" === c) {
        if (0 === b) return a;
        b--;
      } else "/$" === c && b++;
    }

    a = a.previousSibling;
  }

  return null;
}

var Mf = Math.random().toString(36).slice(2),
    Nf = "__reactFiber$" + Mf,
    Of = "__reactProps$" + Mf,
    tf = "__reactContainer$" + Mf,
    nf = "__reactEvents$" + Mf,
    Pf = "__reactListeners$" + Mf,
    Qf = "__reactHandles$" + Mf;

function Vc(a) {
  var b = a[Nf];
  if (b) return b;

  for (var c = a.parentNode; c;) {
    if (b = c[tf] || c[Nf]) {
      c = b.alternate;
      if (null !== b.child || null !== c && null !== c.child) for (a = Lf(a); null !== a;) {
        if (c = a[Nf]) return c;
        a = Lf(a);
      }
      return b;
    }

    a = c;
    c = a.parentNode;
  }

  return null;
}

function Bb(a) {
  a = a[Nf] || a[tf];
  return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}

function te(a) {
  if (5 === a.tag || 6 === a.tag) return a.stateNode;
  throw Error(p(33));
}

function Cb(a) {
  return a[Of] || null;
}

var Rf = [],
    Sf = -1;

function Tf(a) {
  return {
    current: a
  };
}

function E(a) {
  0 > Sf || (a.current = Rf[Sf], Rf[Sf] = null, Sf--);
}

function G(a, b) {
  Sf++;
  Rf[Sf] = a.current;
  a.current = b;
}

var Uf = {},
    H = Tf(Uf),
    Vf = Tf(!1),
    Wf = Uf;

function Xf(a, b) {
  var c = a.type.contextTypes;
  if (!c) return Uf;
  var d = a.stateNode;
  if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
  var e = {},
      f;

  for (f in c) {
    e[f] = b[f];
  }

  d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
  return e;
}

function Yf(a) {
  a = a.childContextTypes;
  return null !== a && void 0 !== a;
}

function Zf() {
  E(Vf);
  E(H);
}

function $f(a, b, c) {
  if (H.current !== Uf) throw Error(p(168));
  G(H, b);
  G(Vf, c);
}

function ag(a, b, c) {
  var d = a.stateNode;
  b = b.childContextTypes;
  if ("function" !== typeof d.getChildContext) return c;
  d = d.getChildContext();

  for (var e in d) {
    if (!(e in b)) throw Error(p(108, Qa(a) || "Unknown", e));
  }

  return A({}, c, d);
}

function bg(a) {
  a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Uf;
  Wf = H.current;
  G(H, a);
  G(Vf, Vf.current);
  return !0;
}

function cg(a, b, c) {
  var d = a.stateNode;
  if (!d) throw Error(p(169));
  c ? (a = ag(a, b, Wf), d.__reactInternalMemoizedMergedChildContext = a, E(Vf), E(H), G(H, a)) : E(Vf);
  G(Vf, c);
}

var dg = null,
    eg = !1,
    fg = !1;

function gg(a) {
  null === dg ? dg = [a] : dg.push(a);
}

function hg(a) {
  eg = !0;
  gg(a);
}

function ig() {
  if (!fg && null !== dg) {
    fg = !0;
    var a = 0,
        b = C;

    try {
      var c = dg;

      for (C = 1; a < c.length; a++) {
        var d = c[a];

        do {
          d = d(!0);
        } while (null !== d);
      }

      dg = null;
      eg = !1;
    } catch (e) {
      throw null !== dg && (dg = dg.slice(a + 1)), $b(ec, ig), e;
    } finally {
      C = b, fg = !1;
    }
  }

  return null;
}

var jg = ta.ReactCurrentBatchConfig;

function kg(a, b) {
  if (a && a.defaultProps) {
    b = A({}, b);
    a = a.defaultProps;

    for (var c in a) {
      void 0 === b[c] && (b[c] = a[c]);
    }

    return b;
  }

  return b;
}

var lg = Tf(null),
    mg = null,
    ng = null,
    og = null;

function pg() {
  og = ng = mg = null;
}

function qg(a) {
  var b = lg.current;
  E(lg);
  a._currentValue = b;
}

function rg(a, b, c) {
  for (; null !== a;) {
    var d = a.alternate;
    (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
    if (a === c) break;
    a = a["return"];
  }
}

function sg(a, b) {
  mg = a;
  og = ng = null;
  a = a.dependencies;
  null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (tg = !0), a.firstContext = null);
}

function ug(a) {
  var b = a._currentValue;
  if (og !== a) if (a = {
    context: a,
    memoizedValue: b,
    next: null
  }, null === ng) {
    if (null === mg) throw Error(p(308));
    ng = a;
    mg.dependencies = {
      lanes: 0,
      firstContext: a
    };
  } else ng = ng.next = a;
  return b;
}

var vg = null,
    wg = !1;

function xg(a) {
  a.updateQueue = {
    baseState: a.memoizedState,
    firstBaseUpdate: null,
    lastBaseUpdate: null,
    shared: {
      pending: null,
      interleaved: null,
      lanes: 0
    },
    effects: null
  };
}

function yg(a, b) {
  a = a.updateQueue;
  b.updateQueue === a && (b.updateQueue = {
    baseState: a.baseState,
    firstBaseUpdate: a.firstBaseUpdate,
    lastBaseUpdate: a.lastBaseUpdate,
    shared: a.shared,
    effects: a.effects
  });
}

function zg(a, b) {
  return {
    eventTime: a,
    lane: b,
    tag: 0,
    payload: null,
    callback: null,
    next: null
  };
}

function Ag(a, b) {
  var c = a.updateQueue;
  null !== c && (c = c.shared, Bg(a) ? (a = c.interleaved, null === a ? (b.next = b, null === vg ? vg = [c] : vg.push(c)) : (b.next = a.next, a.next = b), c.interleaved = b) : (a = c.pending, null === a ? b.next = b : (b.next = a.next, a.next = b), c.pending = b));
}

function Cg(a, b, c) {
  b = b.updateQueue;

  if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
    var d = b.lanes;
    d &= a.pendingLanes;
    c |= d;
    b.lanes = c;
    Bc(a, c);
  }
}

function Dg(a, b) {
  var c = a.updateQueue,
      d = a.alternate;

  if (null !== d && (d = d.updateQueue, c === d)) {
    var e = null,
        f = null;
    c = c.firstBaseUpdate;

    if (null !== c) {
      do {
        var g = {
          eventTime: c.eventTime,
          lane: c.lane,
          tag: c.tag,
          payload: c.payload,
          callback: c.callback,
          next: null
        };
        null === f ? e = f = g : f = f.next = g;
        c = c.next;
      } while (null !== c);

      null === f ? e = f = b : f = f.next = b;
    } else e = f = b;

    c = {
      baseState: d.baseState,
      firstBaseUpdate: e,
      lastBaseUpdate: f,
      shared: d.shared,
      effects: d.effects
    };
    a.updateQueue = c;
    return;
  }

  a = c.lastBaseUpdate;
  null === a ? c.firstBaseUpdate = b : a.next = b;
  c.lastBaseUpdate = b;
}

function Eg(a, b, c, d) {
  var e = a.updateQueue;
  wg = !1;
  var f = e.firstBaseUpdate,
      g = e.lastBaseUpdate,
      h = e.shared.pending;

  if (null !== h) {
    e.shared.pending = null;
    var k = h,
        l = k.next;
    k.next = null;
    null === g ? f = l : g.next = l;
    g = k;
    var n = a.alternate;
    null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
  }

  if (null !== f) {
    var u = e.baseState;
    g = 0;
    n = l = k = null;
    h = f;

    do {
      var q = h.lane,
          y = h.eventTime;

      if ((d & q) === q) {
        null !== n && (n = n.next = {
          eventTime: y,
          lane: 0,
          tag: h.tag,
          payload: h.payload,
          callback: h.callback,
          next: null
        });

        a: {
          var m = a,
              w = h;
          q = b;
          y = c;

          switch (w.tag) {
            case 1:
              m = w.payload;

              if ("function" === typeof m) {
                u = m.call(y, u, q);
                break a;
              }

              u = m;
              break a;

            case 3:
              m.flags = m.flags & -65537 | 128;

            case 0:
              m = w.payload;
              q = "function" === typeof m ? m.call(y, u, q) : m;
              if (null === q || void 0 === q) break a;
              u = A({}, u, q);
              break a;

            case 2:
              wg = !0;
          }
        }

        null !== h.callback && 0 !== h.lane && (a.flags |= 64, q = e.effects, null === q ? e.effects = [h] : q.push(h));
      } else y = {
        eventTime: y,
        lane: q,
        tag: h.tag,
        payload: h.payload,
        callback: h.callback,
        next: null
      }, null === n ? (l = n = y, k = u) : n = n.next = y, g |= q;

      h = h.next;
      if (null === h) if (h = e.shared.pending, null === h) break;else q = h, h = q.next, q.next = null, e.lastBaseUpdate = q, e.shared.pending = null;
    } while (1);

    null === n && (k = u);
    e.baseState = k;
    e.firstBaseUpdate = l;
    e.lastBaseUpdate = n;
    b = e.shared.interleaved;

    if (null !== b) {
      e = b;

      do {
        g |= e.lane, e = e.next;
      } while (e !== b);
    } else null === f && (e.shared.lanes = 0);

    Fg |= g;
    a.lanes = g;
    a.memoizedState = u;
  }
}

function Gg(a, b, c) {
  a = b.effects;
  b.effects = null;
  if (null !== a) for (b = 0; b < a.length; b++) {
    var d = a[b],
        e = d.callback;

    if (null !== e) {
      d.callback = null;
      d = c;
      if ("function" !== typeof e) throw Error(p(191, e));
      e.call(d);
    }
  }
}

var Hg = new React__default.Component().refs;

function Ig(a, b, c, d) {
  b = a.memoizedState;
  c = c(d, b);
  c = null === c || void 0 === c ? b : A({}, b, c);
  a.memoizedState = c;
  0 === a.lanes && (a.updateQueue.baseState = c);
}

var Mg = {
  isMounted: function isMounted(a) {
    return (a = a._reactInternals) ? Ub(a) === a : !1;
  },
  enqueueSetState: function enqueueSetState(a, b, c) {
    a = a._reactInternals;
    var d = Jg(),
        e = Kg(a),
        f = zg(d, e);
    f.payload = b;
    void 0 !== c && null !== c && (f.callback = c);
    Ag(a, f);
    b = Lg(a, e, d);
    null !== b && Cg(b, a, e);
  },
  enqueueReplaceState: function enqueueReplaceState(a, b, c) {
    a = a._reactInternals;
    var d = Jg(),
        e = Kg(a),
        f = zg(d, e);
    f.tag = 1;
    f.payload = b;
    void 0 !== c && null !== c && (f.callback = c);
    Ag(a, f);
    b = Lg(a, e, d);
    null !== b && Cg(b, a, e);
  },
  enqueueForceUpdate: function enqueueForceUpdate(a, b) {
    a = a._reactInternals;
    var c = Jg(),
        d = Kg(a),
        e = zg(c, d);
    e.tag = 2;
    void 0 !== b && null !== b && (e.callback = b);
    Ag(a, e);
    b = Lg(a, d, c);
    null !== b && Cg(b, a, d);
  }
};

function Ng(a, b, c, d, e, f, g) {
  a = a.stateNode;
  return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !He(c, d) || !He(e, f) : !0;
}

function Og(a, b, c) {
  var d = !1,
      e = Uf;
  var f = b.contextType;
  "object" === typeof f && null !== f ? f = ug(f) : (e = Yf(b) ? Wf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Xf(a, e) : Uf);
  b = new b(c, f);
  a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
  b.updater = Mg;
  a.stateNode = b;
  b._reactInternals = a;
  d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
  return b;
}

function Pg(a, b, c, d) {
  a = b.state;
  "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
  "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
  b.state !== a && Mg.enqueueReplaceState(b, b.state, null);
}

function Qg(a, b, c, d) {
  var e = a.stateNode;
  e.props = c;
  e.state = a.memoizedState;
  e.refs = Hg;
  xg(a);
  var f = b.contextType;
  "object" === typeof f && null !== f ? e.context = ug(f) : (f = Yf(b) ? Wf : H.current, e.context = Xf(a, f));
  e.state = a.memoizedState;
  f = b.getDerivedStateFromProps;
  "function" === typeof f && (Ig(a, b, f, c), e.state = a.memoizedState);
  "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Mg.enqueueReplaceState(e, e.state, null), Eg(a, c, e, d), e.state = a.memoizedState);
  "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}

var Rg = [],
    Sg = 0,
    Tg = null,
    Ug = 0,
    Vg = [],
    Wg = 0,
    Xg = null,
    Yg = 1,
    Zg = "";

function $g(a, b) {
  Rg[Sg++] = Ug;
  Rg[Sg++] = Tg;
  Tg = a;
  Ug = b;
}

function ah(a, b, c) {
  Vg[Wg++] = Yg;
  Vg[Wg++] = Zg;
  Vg[Wg++] = Xg;
  Xg = a;
  var d = Yg;
  a = Zg;
  var e = 32 - nc(d) - 1;
  d &= ~(1 << e);
  c += 1;
  var f = 32 - nc(b) + e;

  if (30 < f) {
    var g = e - e % 5;
    f = (d & (1 << g) - 1).toString(32);
    d >>= g;
    e -= g;
    Yg = 1 << 32 - nc(b) + e | c << e | d;
    Zg = f + a;
  } else Yg = 1 << f | c << e | d, Zg = a;
}

function bh(a) {
  null !== a["return"] && ($g(a, 1), ah(a, 1, 0));
}

function ch(a) {
  for (; a === Tg;) {
    Tg = Rg[--Sg], Rg[Sg] = null, Ug = Rg[--Sg], Rg[Sg] = null;
  }

  for (; a === Xg;) {
    Xg = Vg[--Wg], Vg[Wg] = null, Zg = Vg[--Wg], Vg[Wg] = null, Yg = Vg[--Wg], Vg[Wg] = null;
  }
}

var dh = null,
    eh = null,
    I = !1,
    fh = null;

function gh(a, b) {
  var c = hh(5, null, null, 0);
  c.elementType = "DELETED";
  c.stateNode = b;
  c["return"] = a;
  b = a.deletions;
  null === b ? (a.deletions = [c], a.flags |= 16) : b.push(c);
}

function ih(a, b) {
  switch (a.tag) {
    case 5:
      var c = a.type;
      b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
      return null !== b ? (a.stateNode = b, dh = a, eh = Kf(b.firstChild), !0) : !1;

    case 6:
      return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, dh = a, eh = null, !0) : !1;

    case 13:
      return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== Xg ? {
        id: Yg,
        overflow: Zg
      } : null, a.memoizedState = {
        dehydrated: b,
        treeContext: c,
        retryLane: 1073741824
      }, c = hh(18, null, null, 0), c.stateNode = b, c["return"] = a, a.child = c, dh = a, eh = null, !0) : !1;

    default:
      return !1;
  }
}

function jh(a) {
  return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}

function kh(a) {
  if (I) {
    var b = eh;

    if (b) {
      var c = b;

      if (!ih(a, b)) {
        if (jh(a)) throw Error(p(418));
        b = Kf(c.nextSibling);
        var d = dh;
        b && ih(a, b) ? gh(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, dh = a);
      }
    } else {
      if (jh(a)) throw Error(p(418));
      a.flags = a.flags & -4097 | 2;
      I = !1;
      dh = a;
    }
  }
}

function lh(a) {
  for (a = a["return"]; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;) {
    a = a["return"];
  }

  dh = a;
}

function mh(a) {
  if (a !== dh) return !1;
  if (!I) return lh(a), I = !0, !1;
  var b;
  (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Df(a.type, a.memoizedProps));

  if (b && (b = eh)) {
    if (jh(a)) {
      for (a = eh; a;) {
        a = Kf(a.nextSibling);
      }

      throw Error(p(418));
    }

    for (; b;) {
      gh(a, b), b = Kf(b.nextSibling);
    }
  }

  lh(a);

  if (13 === a.tag) {
    a = a.memoizedState;
    a = null !== a ? a.dehydrated : null;
    if (!a) throw Error(p(317));

    a: {
      a = a.nextSibling;

      for (b = 0; a;) {
        if (8 === a.nodeType) {
          var c = a.data;

          if ("/$" === c) {
            if (0 === b) {
              eh = Kf(a.nextSibling);
              break a;
            }

            b--;
          } else "$" !== c && "$!" !== c && "$?" !== c || b++;
        }

        a = a.nextSibling;
      }

      eh = null;
    }
  } else eh = dh ? Kf(a.stateNode.nextSibling) : null;

  return !0;
}

function nh() {
  eh = dh = null;
  I = !1;
}

function oh(a) {
  null === fh ? fh = [a] : fh.push(a);
}

function ph(a, b, c) {
  a = c.ref;

  if (null !== a && "function" !== typeof a && "object" !== typeof a) {
    if (c._owner) {
      c = c._owner;

      if (c) {
        if (1 !== c.tag) throw Error(p(309));
        var d = c.stateNode;
      }

      if (!d) throw Error(p(147, a));
      var e = d,
          f = "" + a;
      if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;

      b = function b(a) {
        var b = e.refs;
        b === Hg && (b = e.refs = {});
        null === a ? delete b[f] : b[f] = a;
      };

      b._stringRef = f;
      return b;
    }

    if ("string" !== typeof a) throw Error(p(284));
    if (!c._owner) throw Error(p(290, a));
  }

  return a;
}

function qh(a, b) {
  a = Object.prototype.toString.call(b);
  throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}

function rh(a) {
  var b = a._init;
  return b(a._payload);
}

function sh(a) {
  function b(b, c) {
    if (a) {
      var d = b.deletions;
      null === d ? (b.deletions = [c], b.flags |= 16) : d.push(c);
    }
  }

  function c(c, d) {
    if (!a) return null;

    for (; null !== d;) {
      b(c, d), d = d.sibling;
    }

    return null;
  }

  function d(a, b) {
    for (a = new Map(); null !== b;) {
      null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
    }

    return a;
  }

  function e(a, b) {
    a = th(a, b);
    a.index = 0;
    a.sibling = null;
    return a;
  }

  function f(b, c, d) {
    b.index = d;
    if (!a) return b.flags |= 1048576, c;
    d = b.alternate;
    if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
    b.flags |= 2;
    return c;
  }

  function g(b) {
    a && null === b.alternate && (b.flags |= 2);
    return b;
  }

  function h(a, b, c, d) {
    if (null === b || 6 !== b.tag) return b = uh(c, a.mode, d), b["return"] = a, b;
    b = e(b, c);
    b["return"] = a;
    return b;
  }

  function k(a, b, c, d) {
    var f = c.type;
    if (f === wa) return n(a, b, c.props.children, d, c.key);
    if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ga && rh(f) === b.type)) return d = e(b, c.props), d.ref = ph(a, b, c), d["return"] = a, d;
    d = vh(c.type, c.key, c.props, null, a.mode, d);
    d.ref = ph(a, b, c);
    d["return"] = a;
    return d;
  }

  function l(a, b, c, d) {
    if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = wh(c, a.mode, d), b["return"] = a, b;
    b = e(b, c.children || []);
    b["return"] = a;
    return b;
  }

  function n(a, b, c, d, f) {
    if (null === b || 7 !== b.tag) return b = xh(c, a.mode, d, f), b["return"] = a, b;
    b = e(b, c);
    b["return"] = a;
    return b;
  }

  function u(a, b, c) {
    if ("string" === typeof b && "" !== b || "number" === typeof b) return b = uh("" + b, a.mode, c), b["return"] = a, b;

    if ("object" === typeof b && null !== b) {
      switch (b.$$typeof) {
        case ua:
          return c = vh(b.type, b.key, b.props, null, a.mode, c), c.ref = ph(a, null, b), c["return"] = a, c;

        case va:
          return b = wh(b, a.mode, c), b["return"] = a, b;

        case Ga:
          var d = b._init;
          return u(a, d(b._payload), c);
      }

      if (db(b) || Ja(b)) return b = xh(b, a.mode, c, null), b["return"] = a, b;
      qh(a, b);
    }

    return null;
  }

  function q(a, b, c, d) {
    var e = null !== b ? b.key : null;
    if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);

    if ("object" === typeof c && null !== c) {
      switch (c.$$typeof) {
        case ua:
          return c.key === e ? k(a, b, c, d) : null;

        case va:
          return c.key === e ? l(a, b, c, d) : null;

        case Ga:
          return e = c._init, q(a, b, e(c._payload), d);
      }

      if (db(c) || Ja(c)) return null !== e ? null : n(a, b, c, d, null);
      qh(a, c);
    }

    return null;
  }

  function y(a, b, c, d, e) {
    if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);

    if ("object" === typeof d && null !== d) {
      switch (d.$$typeof) {
        case ua:
          return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);

        case va:
          return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);

        case Ga:
          var f = d._init;
          return y(a, b, c, f(d._payload), e);
      }

      if (db(d) || Ja(d)) return a = a.get(c) || null, n(b, a, d, e, null);
      qh(b, d);
    }

    return null;
  }

  function m(e, g, h, k) {
    for (var l = null, n = null, r = g, m = g = 0, x = null; null !== r && m < h.length; m++) {
      r.index > m ? (x = r, r = null) : x = r.sibling;
      var v = q(e, r, h[m], k);

      if (null === v) {
        null === r && (r = x);
        break;
      }

      a && r && null === v.alternate && b(e, r);
      g = f(v, g, m);
      null === n ? l = v : n.sibling = v;
      n = v;
      r = x;
    }

    if (m === h.length) return c(e, r), I && $g(e, m), l;

    if (null === r) {
      for (; m < h.length; m++) {
        r = u(e, h[m], k), null !== r && (g = f(r, g, m), null === n ? l = r : n.sibling = r, n = r);
      }

      I && $g(e, m);
      return l;
    }

    for (r = d(e, r); m < h.length; m++) {
      x = y(r, e, m, h[m], k), null !== x && (a && null !== x.alternate && r["delete"](null === x.key ? m : x.key), g = f(x, g, m), null === n ? l = x : n.sibling = x, n = x);
    }

    a && r.forEach(function (a) {
      return b(e, a);
    });
    I && $g(e, m);
    return l;
  }

  function w(e, g, h, k) {
    var l = Ja(h);
    if ("function" !== typeof l) throw Error(p(150));
    h = l.call(h);
    if (null == h) throw Error(p(151));

    for (var n = l = null, m = g, r = g = 0, x = null, v = h.next(); null !== m && !v.done; r++, v = h.next()) {
      m.index > r ? (x = m, m = null) : x = m.sibling;
      var w = q(e, m, v.value, k);

      if (null === w) {
        null === m && (m = x);
        break;
      }

      a && m && null === w.alternate && b(e, m);
      g = f(w, g, r);
      null === n ? l = w : n.sibling = w;
      n = w;
      m = x;
    }

    if (v.done) return c(e, m), I && $g(e, r), l;

    if (null === m) {
      for (; !v.done; r++, v = h.next()) {
        v = u(e, v.value, k), null !== v && (g = f(v, g, r), null === n ? l = v : n.sibling = v, n = v);
      }

      I && $g(e, r);
      return l;
    }

    for (m = d(e, m); !v.done; r++, v = h.next()) {
      v = y(m, e, r, v.value, k), null !== v && (a && null !== v.alternate && m["delete"](null === v.key ? r : v.key), g = f(v, g, r), null === n ? l = v : n.sibling = v, n = v);
    }

    a && m.forEach(function (a) {
      return b(e, a);
    });
    I && $g(e, r);
    return l;
  }

  function J(a, d, f, h) {
    "object" === typeof f && null !== f && f.type === wa && null === f.key && (f = f.props.children);

    if ("object" === typeof f && null !== f) {
      switch (f.$$typeof) {
        case ua:
          a: {
            for (var k = f.key, l = d; null !== l;) {
              if (l.key === k) {
                k = f.type;

                if (k === wa) {
                  if (7 === l.tag) {
                    c(a, l.sibling);
                    d = e(l, f.props.children);
                    d["return"] = a;
                    a = d;
                    break a;
                  }
                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ga && rh(k) === l.type) {
                  c(a, l.sibling);
                  d = e(l, f.props);
                  d.ref = ph(a, l, f);
                  d["return"] = a;
                  a = d;
                  break a;
                }

                c(a, l);
                break;
              } else b(a, l);

              l = l.sibling;
            }

            f.type === wa ? (d = xh(f.props.children, a.mode, h, f.key), d["return"] = a, a = d) : (h = vh(f.type, f.key, f.props, null, a.mode, h), h.ref = ph(a, d, f), h["return"] = a, a = h);
          }

          return g(a);

        case va:
          a: {
            for (l = f.key; null !== d;) {
              if (d.key === l) {
                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                  c(a, d.sibling);
                  d = e(d, f.children || []);
                  d["return"] = a;
                  a = d;
                  break a;
                } else {
                  c(a, d);
                  break;
                }
              } else b(a, d);
              d = d.sibling;
            }

            d = wh(f, a.mode, h);
            d["return"] = a;
            a = d;
          }

          return g(a);

        case Ga:
          return l = f._init, J(a, d, l(f._payload), h);
      }

      if (db(f)) return m(a, d, f, h);
      if (Ja(f)) return w(a, d, f, h);
      qh(a, f);
    }

    return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d["return"] = a, a = d) : (c(a, d), d = uh(f, a.mode, h), d["return"] = a, a = d), g(a)) : c(a, d);
  }

  return J;
}

var yh = sh(!0),
    zh = sh(!1),
    Ah = {},
    Bh = Tf(Ah),
    Ch = Tf(Ah),
    Dh = Tf(Ah);

function Eh(a) {
  if (a === Ah) throw Error(p(174));
  return a;
}

function Fh(a, b) {
  G(Dh, b);
  G(Ch, a);
  G(Bh, Ah);
  a = b.nodeType;

  switch (a) {
    case 9:
    case 11:
      b = (b = b.documentElement) ? b.namespaceURI : kb(null, "");
      break;

    default:
      a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = kb(b, a);
  }

  E(Bh);
  G(Bh, b);
}

function Gh() {
  E(Bh);
  E(Ch);
  E(Dh);
}

function Hh(a) {
  Eh(Dh.current);
  var b = Eh(Bh.current);
  var c = kb(b, a.type);
  b !== c && (G(Ch, a), G(Bh, c));
}

function Ih(a) {
  Ch.current === a && (E(Bh), E(Ch));
}

var K = Tf(0);

function Jh(a) {
  for (var b = a; null !== b;) {
    if (13 === b.tag) {
      var c = b.memoizedState;
      if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
    } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
      if (0 !== (b.flags & 128)) return b;
    } else if (null !== b.child) {
      b.child["return"] = b;
      b = b.child;
      continue;
    }

    if (b === a) break;

    for (; null === b.sibling;) {
      if (null === b["return"] || b["return"] === a) return null;
      b = b["return"];
    }

    b.sibling["return"] = b["return"];
    b = b.sibling;
  }

  return null;
}

var Kh = [];

function Lh() {
  for (var a = 0; a < Kh.length; a++) {
    Kh[a]._workInProgressVersionPrimary = null;
  }

  Kh.length = 0;
}

var Mh = ta.ReactCurrentDispatcher,
    Nh = ta.ReactCurrentBatchConfig,
    Oh = 0,
    L = null,
    M = null,
    N = null,
    Ph = !1,
    Qh = !1,
    Rh = 0,
    Sh = 0;

function O() {
  throw Error(p(321));
}

function Th(a, b) {
  if (null === b) return !1;

  for (var c = 0; c < b.length && c < a.length; c++) {
    if (!Ge(a[c], b[c])) return !1;
  }

  return !0;
}

function Uh(a, b, c, d, e, f) {
  Oh = f;
  L = b;
  b.memoizedState = null;
  b.updateQueue = null;
  b.lanes = 0;
  Mh.current = null === a || null === a.memoizedState ? Vh : Wh;
  a = c(d, e);

  if (Qh) {
    f = 0;

    do {
      Qh = !1;
      Rh = 0;
      if (25 <= f) throw Error(p(301));
      f += 1;
      N = M = null;
      b.updateQueue = null;
      Mh.current = Xh;
      a = c(d, e);
    } while (Qh);
  }

  Mh.current = Yh;
  b = null !== M && null !== M.next;
  Oh = 0;
  N = M = L = null;
  Ph = !1;
  if (b) throw Error(p(300));
  return a;
}

function Zh() {
  var a = 0 !== Rh;
  Rh = 0;
  return a;
}

function $h() {
  var a = {
    memoizedState: null,
    baseState: null,
    baseQueue: null,
    queue: null,
    next: null
  };
  null === N ? L.memoizedState = N = a : N = N.next = a;
  return N;
}

function ai() {
  if (null === M) {
    var a = L.alternate;
    a = null !== a ? a.memoizedState : null;
  } else a = M.next;

  var b = null === N ? L.memoizedState : N.next;
  if (null !== b) N = b, M = a;else {
    if (null === a) throw Error(p(310));
    M = a;
    a = {
      memoizedState: M.memoizedState,
      baseState: M.baseState,
      baseQueue: M.baseQueue,
      queue: M.queue,
      next: null
    };
    null === N ? L.memoizedState = N = a : N = N.next = a;
  }
  return N;
}

function bi(a, b) {
  return "function" === typeof b ? b(a) : b;
}

function ci(a) {
  var b = ai(),
      c = b.queue;
  if (null === c) throw Error(p(311));
  c.lastRenderedReducer = a;
  var d = M,
      e = d.baseQueue,
      f = c.pending;

  if (null !== f) {
    if (null !== e) {
      var g = e.next;
      e.next = f.next;
      f.next = g;
    }

    d.baseQueue = e = f;
    c.pending = null;
  }

  if (null !== e) {
    f = e.next;
    d = d.baseState;
    var h = g = null,
        k = null,
        l = f;

    do {
      var n = l.lane;
      if ((Oh & n) === n) null !== k && (k = k.next = {
        lane: 0,
        action: l.action,
        hasEagerState: l.hasEagerState,
        eagerState: l.eagerState,
        next: null
      }), d = l.hasEagerState ? l.eagerState : a(d, l.action);else {
        var u = {
          lane: n,
          action: l.action,
          hasEagerState: l.hasEagerState,
          eagerState: l.eagerState,
          next: null
        };
        null === k ? (h = k = u, g = d) : k = k.next = u;
        L.lanes |= n;
        Fg |= n;
      }
      l = l.next;
    } while (null !== l && l !== f);

    null === k ? g = d : k.next = h;
    Ge(d, b.memoizedState) || (tg = !0);
    b.memoizedState = d;
    b.baseState = g;
    b.baseQueue = k;
    c.lastRenderedState = d;
  }

  a = c.interleaved;

  if (null !== a) {
    e = a;

    do {
      f = e.lane, L.lanes |= f, Fg |= f, e = e.next;
    } while (e !== a);
  } else null === e && (c.lanes = 0);

  return [b.memoizedState, c.dispatch];
}

function di(a) {
  var b = ai(),
      c = b.queue;
  if (null === c) throw Error(p(311));
  c.lastRenderedReducer = a;
  var d = c.dispatch,
      e = c.pending,
      f = b.memoizedState;

  if (null !== e) {
    c.pending = null;
    var g = e = e.next;

    do {
      f = a(f, g.action), g = g.next;
    } while (g !== e);

    Ge(f, b.memoizedState) || (tg = !0);
    b.memoizedState = f;
    null === b.baseQueue && (b.baseState = f);
    c.lastRenderedState = f;
  }

  return [f, d];
}

function ei() {}

function fi(a, b) {
  var c = L,
      d = ai(),
      e = b(),
      f = !Ge(d.memoizedState, e);
  f && (d.memoizedState = e, tg = !0);
  d = d.queue;
  gi(hi.bind(null, c, d, a), [a]);

  if (d.getSnapshot !== b || f || null !== N && N.memoizedState.tag & 1) {
    c.flags |= 2048;
    ii(9, ji.bind(null, c, d, e, b), void 0, null);
    if (null === P) throw Error(p(349));
    0 !== (Oh & 30) || ki(c, b, e);
  }

  return e;
}

function ki(a, b, c) {
  a.flags |= 16384;
  a = {
    getSnapshot: b,
    value: c
  };
  b = L.updateQueue;
  null === b ? (b = {
    lastEffect: null,
    stores: null
  }, L.updateQueue = b, b.stores = [a]) : (c = b.stores, null === c ? b.stores = [a] : c.push(a));
}

function ji(a, b, c, d) {
  b.value = c;
  b.getSnapshot = d;
  li(b) && Lg(a, 1, -1);
}

function hi(a, b, c) {
  return c(function () {
    li(b) && Lg(a, 1, -1);
  });
}

function li(a) {
  var b = a.getSnapshot;
  a = a.value;

  try {
    var c = b();
    return !Ge(a, c);
  } catch (d) {
    return !0;
  }
}

function mi(a) {
  var b = $h();
  "function" === typeof a && (a = a());
  b.memoizedState = b.baseState = a;
  a = {
    pending: null,
    interleaved: null,
    lanes: 0,
    dispatch: null,
    lastRenderedReducer: bi,
    lastRenderedState: a
  };
  b.queue = a;
  a = a.dispatch = ni.bind(null, L, a);
  return [b.memoizedState, a];
}

function ii(a, b, c, d) {
  a = {
    tag: a,
    create: b,
    destroy: c,
    deps: d,
    next: null
  };
  b = L.updateQueue;
  null === b ? (b = {
    lastEffect: null,
    stores: null
  }, L.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
  return a;
}

function oi() {
  return ai().memoizedState;
}

function pi(a, b, c, d) {
  var e = $h();
  L.flags |= a;
  e.memoizedState = ii(1 | b, c, void 0, void 0 === d ? null : d);
}

function qi(a, b, c, d) {
  var e = ai();
  d = void 0 === d ? null : d;
  var f = void 0;

  if (null !== M) {
    var g = M.memoizedState;
    f = g.destroy;

    if (null !== d && Th(d, g.deps)) {
      e.memoizedState = ii(b, c, f, d);
      return;
    }
  }

  L.flags |= a;
  e.memoizedState = ii(1 | b, c, f, d);
}

function ri(a, b) {
  return pi(8390656, 8, a, b);
}

function gi(a, b) {
  return qi(2048, 8, a, b);
}

function si(a, b) {
  return qi(4, 2, a, b);
}

function ti(a, b) {
  return qi(4, 4, a, b);
}

function ui(a, b) {
  if ("function" === typeof b) return a = a(), b(a), function () {
    b(null);
  };
  if (null !== b && void 0 !== b) return a = a(), b.current = a, function () {
    b.current = null;
  };
}

function vi(a, b, c) {
  c = null !== c && void 0 !== c ? c.concat([a]) : null;
  return qi(4, 4, ui.bind(null, b, a), c);
}

function wi() {}

function xi(a, b) {
  var c = ai();
  b = void 0 === b ? null : b;
  var d = c.memoizedState;
  if (null !== d && null !== b && Th(b, d[1])) return d[0];
  c.memoizedState = [a, b];
  return a;
}

function yi(a, b) {
  var c = ai();
  b = void 0 === b ? null : b;
  var d = c.memoizedState;
  if (null !== d && null !== b && Th(b, d[1])) return d[0];
  a = a();
  c.memoizedState = [a, b];
  return a;
}

function zi(a, b, c) {
  if (0 === (Oh & 21)) return a.baseState && (a.baseState = !1, tg = !0), a.memoizedState = c;
  Ge(c, b) || (c = xc(), L.lanes |= c, Fg |= c, a.baseState = !0);
  return b;
}

function Ai(a, b) {
  var c = C;
  C = 0 !== c && 4 > c ? c : 4;
  a(!0);
  var d = Nh.transition;
  Nh.transition = {};

  try {
    a(!1), b();
  } finally {
    C = c, Nh.transition = d;
  }
}

function Bi() {
  return ai().memoizedState;
}

function Ci(a, b, c) {
  var d = Kg(a);
  c = {
    lane: d,
    action: c,
    hasEagerState: !1,
    eagerState: null,
    next: null
  };
  Di(a) ? Ei(b, c) : (Fi(a, b, c), c = Jg(), a = Lg(a, d, c), null !== a && Gi(a, b, d));
}

function ni(a, b, c) {
  var d = Kg(a),
      e = {
    lane: d,
    action: c,
    hasEagerState: !1,
    eagerState: null,
    next: null
  };
  if (Di(a)) Ei(b, e);else {
    Fi(a, b, e);
    var f = a.alternate;
    if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
      var g = b.lastRenderedState,
          h = f(g, c);
      e.hasEagerState = !0;
      e.eagerState = h;
      if (Ge(h, g)) return;
    } catch (k) {} finally {}
    c = Jg();
    a = Lg(a, d, c);
    null !== a && Gi(a, b, d);
  }
}

function Di(a) {
  var b = a.alternate;
  return a === L || null !== b && b === L;
}

function Ei(a, b) {
  Qh = Ph = !0;
  var c = a.pending;
  null === c ? b.next = b : (b.next = c.next, c.next = b);
  a.pending = b;
}

function Fi(a, b, c) {
  Bg(a) ? (a = b.interleaved, null === a ? (c.next = c, null === vg ? vg = [b] : vg.push(b)) : (c.next = a.next, a.next = c), b.interleaved = c) : (a = b.pending, null === a ? c.next = c : (c.next = a.next, a.next = c), b.pending = c);
}

function Gi(a, b, c) {
  if (0 !== (c & 4194240)) {
    var d = b.lanes;
    d &= a.pendingLanes;
    c |= d;
    b.lanes = c;
    Bc(a, c);
  }
}

var Yh = {
  readContext: ug,
  useCallback: O,
  useContext: O,
  useEffect: O,
  useImperativeHandle: O,
  useInsertionEffect: O,
  useLayoutEffect: O,
  useMemo: O,
  useReducer: O,
  useRef: O,
  useState: O,
  useDebugValue: O,
  useDeferredValue: O,
  useTransition: O,
  useMutableSource: O,
  useSyncExternalStore: O,
  useId: O,
  unstable_isNewReconciler: !1
},
    Vh = {
  readContext: ug,
  useCallback: function useCallback(a, b) {
    $h().memoizedState = [a, void 0 === b ? null : b];
    return a;
  },
  useContext: ug,
  useEffect: ri,
  useImperativeHandle: function useImperativeHandle(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([a]) : null;
    return pi(4194308, 4, ui.bind(null, b, a), c);
  },
  useLayoutEffect: function useLayoutEffect(a, b) {
    return pi(4194308, 4, a, b);
  },
  useInsertionEffect: function useInsertionEffect(a, b) {
    return pi(4, 2, a, b);
  },
  useMemo: function useMemo(a, b) {
    var c = $h();
    b = void 0 === b ? null : b;
    a = a();
    c.memoizedState = [a, b];
    return a;
  },
  useReducer: function useReducer(a, b, c) {
    var d = $h();
    b = void 0 !== c ? c(b) : b;
    d.memoizedState = d.baseState = b;
    a = {
      pending: null,
      interleaved: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: a,
      lastRenderedState: b
    };
    d.queue = a;
    a = a.dispatch = Ci.bind(null, L, a);
    return [d.memoizedState, a];
  },
  useRef: function useRef(a) {
    var b = $h();
    a = {
      current: a
    };
    return b.memoizedState = a;
  },
  useState: mi,
  useDebugValue: wi,
  useDeferredValue: function useDeferredValue(a) {
    return $h().memoizedState = a;
  },
  useTransition: function useTransition() {
    var a = mi(!1),
        b = a[0];
    a = Ai.bind(null, a[1]);
    $h().memoizedState = a;
    return [b, a];
  },
  useMutableSource: function useMutableSource() {},
  useSyncExternalStore: function useSyncExternalStore(a, b, c) {
    var d = L,
        e = $h();

    if (I) {
      if (void 0 === c) throw Error(p(407));
      c = c();
    } else {
      c = b();
      if (null === P) throw Error(p(349));
      0 !== (Oh & 30) || ki(d, b, c);
    }

    e.memoizedState = c;
    var f = {
      value: c,
      getSnapshot: b
    };
    e.queue = f;
    ri(hi.bind(null, d, f, a), [a]);
    d.flags |= 2048;
    ii(9, ji.bind(null, d, f, c, b), void 0, null);
    return c;
  },
  useId: function useId() {
    var a = $h(),
        b = P.identifierPrefix;

    if (I) {
      var c = Zg;
      var d = Yg;
      c = (d & ~(1 << 32 - nc(d) - 1)).toString(32) + c;
      b = ":" + b + "R" + c;
      c = Rh++;
      0 < c && (b += "H" + c.toString(32));
      b += ":";
    } else c = Sh++, b = ":" + b + "r" + c.toString(32) + ":";

    return a.memoizedState = b;
  },
  unstable_isNewReconciler: !1
},
    Wh = {
  readContext: ug,
  useCallback: xi,
  useContext: ug,
  useEffect: gi,
  useImperativeHandle: vi,
  useInsertionEffect: si,
  useLayoutEffect: ti,
  useMemo: yi,
  useReducer: ci,
  useRef: oi,
  useState: function useState() {
    return ci(bi);
  },
  useDebugValue: wi,
  useDeferredValue: function useDeferredValue(a) {
    var b = ai();
    return zi(b, M.memoizedState, a);
  },
  useTransition: function useTransition() {
    var a = ci(bi)[0],
        b = ai().memoizedState;
    return [a, b];
  },
  useMutableSource: ei,
  useSyncExternalStore: fi,
  useId: Bi,
  unstable_isNewReconciler: !1
},
    Xh = {
  readContext: ug,
  useCallback: xi,
  useContext: ug,
  useEffect: gi,
  useImperativeHandle: vi,
  useInsertionEffect: si,
  useLayoutEffect: ti,
  useMemo: yi,
  useReducer: di,
  useRef: oi,
  useState: function useState() {
    return di(bi);
  },
  useDebugValue: wi,
  useDeferredValue: function useDeferredValue(a) {
    var b = ai();
    return null === M ? b.memoizedState = a : zi(b, M.memoizedState, a);
  },
  useTransition: function useTransition() {
    var a = di(bi)[0],
        b = ai().memoizedState;
    return [a, b];
  },
  useMutableSource: ei,
  useSyncExternalStore: fi,
  useId: Bi,
  unstable_isNewReconciler: !1
};

function Hi(a, b) {
  try {
    var c = "",
        d = b;

    do {
      c += Oa(d), d = d["return"];
    } while (d);

    var e = c;
  } catch (f) {
    e = "\nError generating stack: " + f.message + "\n" + f.stack;
  }

  return {
    value: a,
    source: b,
    stack: e
  };
}

function Ii(a, b) {
  try {
    console.error(b.value);
  } catch (c) {
    setTimeout(function () {
      throw c;
    });
  }
}

var Ji = "function" === typeof WeakMap ? WeakMap : Map;

function Ki(a, b, c) {
  c = zg(-1, c);
  c.tag = 3;
  c.payload = {
    element: null
  };
  var d = b.value;

  c.callback = function () {
    Li || (Li = !0, Mi = d);
    Ii(a, b);
  };

  return c;
}

function Ni(a, b, c) {
  c = zg(-1, c);
  c.tag = 3;
  var d = a.type.getDerivedStateFromError;

  if ("function" === typeof d) {
    var e = b.value;

    c.payload = function () {
      return d(e);
    };

    c.callback = function () {
      Ii(a, b);
    };
  }

  var f = a.stateNode;
  null !== f && "function" === typeof f.componentDidCatch && (c.callback = function () {
    Ii(a, b);
    "function" !== typeof d && (null === Oi ? Oi = new Set([this]) : Oi.add(this));
    var c = b.stack;
    this.componentDidCatch(b.value, {
      componentStack: null !== c ? c : ""
    });
  });
  return c;
}

function Pi(a, b, c) {
  var d = a.pingCache;

  if (null === d) {
    d = a.pingCache = new Ji();
    var e = new Set();
    d.set(b, e);
  } else e = d.get(b), void 0 === e && (e = new Set(), d.set(b, e));

  e.has(c) || (e.add(c), a = Qi.bind(null, a, b, c), b.then(a, a));
}

function Ri(a) {
  do {
    var b;
    if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
    if (b) return a;
    a = a["return"];
  } while (null !== a);

  return null;
}

function Si(a, b, c, d, e) {
  if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = zg(-1, 1), b.tag = 2, Ag(c, b))), c.lanes |= 1), a;
  a.flags |= 65536;
  a.lanes = e;
  return a;
}

var Ti, Ui, Vi, Wi;

Ti = function Ti(a, b) {
  for (var c = b.child; null !== c;) {
    if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);else if (4 !== c.tag && null !== c.child) {
      c.child["return"] = c;
      c = c.child;
      continue;
    }
    if (c === b) break;

    for (; null === c.sibling;) {
      if (null === c["return"] || c["return"] === b) return;
      c = c["return"];
    }

    c.sibling["return"] = c["return"];
    c = c.sibling;
  }
};

Ui = function Ui() {};

Vi = function Vi(a, b, c, d) {
  var e = a.memoizedProps;

  if (e !== d) {
    a = b.stateNode;
    Eh(Bh.current);
    var f = null;

    switch (c) {
      case "input":
        e = Xa(a, e);
        d = Xa(a, d);
        f = [];
        break;

      case "select":
        e = A({}, e, {
          value: void 0
        });
        d = A({}, d, {
          value: void 0
        });
        f = [];
        break;

      case "textarea":
        e = fb(a, e);
        d = fb(a, d);
        f = [];
        break;

      default:
        "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Af);
    }

    tb(c, d);
    var g;
    c = null;

    for (l in e) {
      if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) if ("style" === l) {
        var h = e[l];

        for (g in h) {
          h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
        }
      } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
    }

    for (l in d) {
      var k = d[l];
      h = null != e ? e[l] : void 0;
      if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) if ("style" === l) {
        if (h) {
          for (g in h) {
            !h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
          }

          for (g in k) {
            k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
          }
        } else c || (f || (f = []), f.push(l, c)), c = k;
      } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
    }

    c && (f = f || []).push("style", c);
    var l = f;
    if (b.updateQueue = l) b.flags |= 4;
  }
};

Wi = function Wi(a, b, c, d) {
  c !== d && (b.flags |= 4);
};

function Xi(a, b) {
  if (!I) switch (a.tailMode) {
    case "hidden":
      b = a.tail;

      for (var c = null; null !== b;) {
        null !== b.alternate && (c = b), b = b.sibling;
      }

      null === c ? a.tail = null : c.sibling = null;
      break;

    case "collapsed":
      c = a.tail;

      for (var d = null; null !== c;) {
        null !== c.alternate && (d = c), c = c.sibling;
      }

      null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
  }
}

function Q(a) {
  var b = null !== a.alternate && a.alternate.child === a.child,
      c = 0,
      d = 0;
  if (b) for (var e = a.child; null !== e;) {
    c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e["return"] = a, e = e.sibling;
  } else for (e = a.child; null !== e;) {
    c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e["return"] = a, e = e.sibling;
  }
  a.subtreeFlags |= d;
  a.childLanes = c;
  return b;
}

function Yi(a, b, c) {
  var d = b.pendingProps;
  ch(b);

  switch (b.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return Q(b), null;

    case 1:
      return Yf(b.type) && Zf(), Q(b), null;

    case 3:
      d = b.stateNode;
      Gh();
      E(Vf);
      E(H);
      Lh();
      d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
      if (null === a || null === a.child) mh(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== fh && (Zi(fh), fh = null));
      Ui(a, b);
      Q(b);
      return null;

    case 5:
      Ih(b);
      var e = Eh(Dh.current);
      c = b.type;
      if (null !== a && null != b.stateNode) Vi(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);else {
        if (!d) {
          if (null === b.stateNode) throw Error(p(166));
          Q(b);
          return null;
        }

        a = Eh(Bh.current);

        if (mh(b)) {
          d = b.stateNode;
          c = b.type;
          var f = b.memoizedProps;
          d[Nf] = b;
          d[Of] = f;
          a = 0 !== (b.mode & 1);

          switch (c) {
            case "dialog":
              D("cancel", d);
              D("close", d);
              break;

            case "iframe":
            case "object":
            case "embed":
              D("load", d);
              break;

            case "video":
            case "audio":
              for (e = 0; e < kf.length; e++) {
                D(kf[e], d);
              }

              break;

            case "source":
              D("error", d);
              break;

            case "img":
            case "image":
            case "link":
              D("error", d);
              D("load", d);
              break;

            case "details":
              D("toggle", d);
              break;

            case "input":
              Ya(d, f);
              D("invalid", d);
              break;

            case "select":
              d._wrapperState = {
                wasMultiple: !!f.multiple
              };
              D("invalid", d);
              break;

            case "textarea":
              gb(d, f), D("invalid", d);
          }

          tb(c, f);
          e = null;

          for (var g in f) {
            if (f.hasOwnProperty(g)) {
              var h = f[g];
              "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && zf(d.textContent, h, a), e = ["children", h]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && zf(d.textContent, h, a), e = ["children", "" + h]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
            }
          }

          switch (c) {
            case "input":
              Ua(d);
              cb(d, f, !0);
              break;

            case "textarea":
              Ua(d);
              ib(d);
              break;

            case "select":
            case "option":
              break;

            default:
              "function" === typeof f.onClick && (d.onclick = Af);
          }

          d = e;
          b.updateQueue = d;
          null !== d && (b.flags |= 4);
        } else {
          g = 9 === e.nodeType ? e : e.ownerDocument;
          "http://www.w3.org/1999/xhtml" === a && (a = jb(c));
          "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
            is: d.is
          }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
          a[Nf] = b;
          a[Of] = d;
          Ti(a, b, !1, !1);
          b.stateNode = a;

          a: {
            g = ub(c, d);

            switch (c) {
              case "dialog":
                D("cancel", a);
                D("close", a);
                e = d;
                break;

              case "iframe":
              case "object":
              case "embed":
                D("load", a);
                e = d;
                break;

              case "video":
              case "audio":
                for (e = 0; e < kf.length; e++) {
                  D(kf[e], a);
                }

                e = d;
                break;

              case "source":
                D("error", a);
                e = d;
                break;

              case "img":
              case "image":
              case "link":
                D("error", a);
                D("load", a);
                e = d;
                break;

              case "details":
                D("toggle", a);
                e = d;
                break;

              case "input":
                Ya(a, d);
                e = Xa(a, d);
                D("invalid", a);
                break;

              case "option":
                e = d;
                break;

              case "select":
                a._wrapperState = {
                  wasMultiple: !!d.multiple
                };
                e = A({}, d, {
                  value: void 0
                });
                D("invalid", a);
                break;

              case "textarea":
                gb(a, d);
                e = fb(a, d);
                D("invalid", a);
                break;

              default:
                e = d;
            }

            tb(c, e);
            h = e;

            for (f in h) {
              if (h.hasOwnProperty(f)) {
                var k = h[f];
                "style" === f ? rb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && mb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && nb(a, k) : "number" === typeof k && nb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && sa(a, f, k, g));
              }
            }

            switch (c) {
              case "input":
                Ua(a);
                cb(a, d, !1);
                break;

              case "textarea":
                Ua(a);
                ib(a);
                break;

              case "option":
                null != d.value && a.setAttribute("value", "" + Ra(d.value));
                break;

              case "select":
                a.multiple = !!d.multiple;
                f = d.value;
                null != f ? eb(a, !!d.multiple, f, !1) : null != d.defaultValue && eb(a, !!d.multiple, d.defaultValue, !0);
                break;

              default:
                "function" === typeof e.onClick && (a.onclick = Af);
            }

            switch (c) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                d = !!d.autoFocus;
                break a;

              case "img":
                d = !0;
                break a;

              default:
                d = !1;
            }
          }

          d && (b.flags |= 4);
        }

        null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
      }
      Q(b);
      return null;

    case 6:
      if (a && null != b.stateNode) Wi(a, b, a.memoizedProps, d);else {
        if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
        c = Eh(Dh.current);
        Eh(Bh.current);

        if (mh(b)) {
          d = b.stateNode;
          c = b.memoizedProps;
          d[Nf] = b;
          if (f = d.nodeValue !== c) if (a = dh, null !== a) switch (a.tag) {
            case 3:
              zf(d.nodeValue, c, 0 !== (a.mode & 1));
              break;

            case 5:
              !0 !== a.memoizedProps.suppressHydrationWarning && zf(d.nodeValue, c, 0 !== (a.mode & 1));
          }
          f && (b.flags |= 4);
        } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Nf] = b, b.stateNode = d;
      }
      Q(b);
      return null;

    case 13:
      E(K);
      d = b.memoizedState;

      if (I && null !== eh && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) {
        for (d = eh; d;) {
          d = Kf(d.nextSibling);
        }

        nh();
        b.flags |= 98560;
        return b;
      }

      if (null !== d && null !== d.dehydrated) {
        d = mh(b);

        if (null === a) {
          if (!d) throw Error(p(318));
          d = b.memoizedState;
          d = null !== d ? d.dehydrated : null;
          if (!d) throw Error(p(317));
          d[Nf] = b;
        } else nh(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;

        Q(b);
        return null;
      }

      null !== fh && (Zi(fh), fh = null);
      if (0 !== (b.flags & 128)) return b.lanes = c, b;
      d = null !== d;
      c = !1;
      null === a ? mh(b) : c = null !== a.memoizedState;
      d !== c && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (K.current & 1) ? 0 === R && (R = 3) : $i()));
      null !== b.updateQueue && (b.flags |= 4);
      Q(b);
      return null;

    case 4:
      return Gh(), Ui(a, b), null === a && rf(b.stateNode.containerInfo), Q(b), null;

    case 10:
      return qg(b.type._context), Q(b), null;

    case 17:
      return Yf(b.type) && Zf(), Q(b), null;

    case 19:
      E(K);
      f = b.memoizedState;
      if (null === f) return Q(b), null;
      d = 0 !== (b.flags & 128);
      g = f.rendering;
      if (null === g) {
        if (d) Xi(f, !1);else {
          if (0 !== R || null !== a && 0 !== (a.flags & 128)) for (a = b.child; null !== a;) {
            g = Jh(a);

            if (null !== g) {
              b.flags |= 128;
              Xi(f, !1);
              d = g.updateQueue;
              null !== d && (b.updateQueue = d, b.flags |= 4);
              b.subtreeFlags = 0;
              d = c;

              for (c = b.child; null !== c;) {
                f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                  lanes: a.lanes,
                  firstContext: a.firstContext
                }), c = c.sibling;
              }

              G(K, K.current & 1 | 2);
              return b.child;
            }

            a = a.sibling;
          }
          null !== f.tail && B() > aj && (b.flags |= 128, d = !0, Xi(f, !1), b.lanes = 4194304);
        }
      } else {
        if (!d) if (a = Jh(g), null !== a) {
          if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Xi(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return Q(b), null;
        } else 2 * B() - f.renderingStartTime > aj && 1073741824 !== c && (b.flags |= 128, d = !0, Xi(f, !1), b.lanes = 4194304);
        f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
      }
      if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = K.current, G(K, d ? c & 1 | 2 : c & 1), b;
      Q(b);
      return null;

    case 22:
    case 23:
      return bj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (cj & 1073741824) && (Q(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : Q(b), null;

    case 24:
      return null;

    case 25:
      return null;
  }

  throw Error(p(156, b.tag));
}

var dj = ta.ReactCurrentOwner,
    tg = !1;

function ej(a, b, c, d) {
  b.child = null === a ? zh(b, null, c, d) : yh(b, a.child, c, d);
}

function fj(a, b, c, d, e) {
  c = c.render;
  var f = b.ref;
  sg(b, e);
  d = Uh(a, b, c, d, f, e);
  c = Zh();
  if (null !== a && !tg) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, gj(a, b, e);
  I && c && bh(b);
  b.flags |= 1;
  ej(a, b, d, e);
  return b.child;
}

function hj(a, b, c, d, e) {
  if (null === a) {
    var f = c.type;
    if ("function" === typeof f && !ij(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, jj(a, b, f, d, e);
    a = vh(c.type, null, d, b, b.mode, e);
    a.ref = b.ref;
    a["return"] = b;
    return b.child = a;
  }

  f = a.child;

  if (0 === (a.lanes & e)) {
    var g = f.memoizedProps;
    c = c.compare;
    c = null !== c ? c : He;
    if (c(g, d) && a.ref === b.ref) return gj(a, b, e);
  }

  b.flags |= 1;
  a = th(f, d);
  a.ref = b.ref;
  a["return"] = b;
  return b.child = a;
}

function jj(a, b, c, d, e) {
  if (null !== a) {
    var f = a.memoizedProps;
    if (He(f, d) && a.ref === b.ref) if (tg = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (tg = !0);else return b.lanes = a.lanes, gj(a, b, e);
  }

  return kj(a, b, c, d, e);
}

function lj(a, b, c) {
  var d = b.pendingProps,
      e = d.children,
      f = null !== a ? a.memoizedState : null;
  if ("hidden" === d.mode) {
    if (0 === (b.mode & 1)) b.memoizedState = {
      baseLanes: 0,
      cachePool: null,
      transitions: null
    }, G(mj, cj), cj |= c;else if (0 !== (c & 1073741824)) b.memoizedState = {
      baseLanes: 0,
      cachePool: null,
      transitions: null
    }, d = null !== f ? f.baseLanes : c, G(mj, cj), cj |= d;else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
      baseLanes: a,
      cachePool: null,
      transitions: null
    }, b.updateQueue = null, G(mj, cj), cj |= a, null;
  } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(mj, cj), cj |= d;
  ej(a, b, e, c);
  return b.child;
}

function nj(a, b) {
  var c = b.ref;
  if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}

function kj(a, b, c, d, e) {
  var f = Yf(c) ? Wf : H.current;
  f = Xf(b, f);
  sg(b, e);
  c = Uh(a, b, c, d, f, e);
  d = Zh();
  if (null !== a && !tg) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, gj(a, b, e);
  I && d && bh(b);
  b.flags |= 1;
  ej(a, b, c, e);
  return b.child;
}

function oj(a, b, c, d, e) {
  if (Yf(c)) {
    var f = !0;
    bg(b);
  } else f = !1;

  sg(b, e);
  if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Og(b, c, d), Qg(b, c, d, e), d = !0;else if (null === a) {
    var g = b.stateNode,
        h = b.memoizedProps;
    g.props = h;
    var k = g.context,
        l = c.contextType;
    "object" === typeof l && null !== l ? l = ug(l) : (l = Yf(c) ? Wf : H.current, l = Xf(b, l));
    var n = c.getDerivedStateFromProps,
        u = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
    u || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Pg(b, g, d, l);
    wg = !1;
    var q = b.memoizedState;
    g.state = q;
    Eg(b, d, g, e);
    k = b.memoizedState;
    h !== d || q !== k || Vf.current || wg ? ("function" === typeof n && (Ig(b, c, n, d), k = b.memoizedState), (h = wg || Ng(b, c, h, d, q, k, l)) ? (u || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
  } else {
    g = b.stateNode;
    yg(a, b);
    h = b.memoizedProps;
    l = b.type === b.elementType ? h : kg(b.type, h);
    g.props = l;
    u = b.pendingProps;
    q = g.context;
    k = c.contextType;
    "object" === typeof k && null !== k ? k = ug(k) : (k = Yf(c) ? Wf : H.current, k = Xf(b, k));
    var y = c.getDerivedStateFromProps;
    (n = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== u || q !== k) && Pg(b, g, d, k);
    wg = !1;
    q = b.memoizedState;
    g.state = q;
    Eg(b, d, g, e);
    var m = b.memoizedState;
    h !== u || q !== m || Vf.current || wg ? ("function" === typeof y && (Ig(b, c, y, d), m = b.memoizedState), (l = wg || Ng(b, c, l, d, q, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 1024), d = !1);
  }
  return pj(a, b, c, d, f, e);
}

function pj(a, b, c, d, e, f) {
  nj(a, b);
  var g = 0 !== (b.flags & 128);
  if (!d && !g) return e && cg(b, c, !1), gj(a, b, f);
  d = b.stateNode;
  dj.current = b;
  var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
  b.flags |= 1;
  null !== a && g ? (b.child = yh(b, a.child, null, f), b.child = yh(b, null, h, f)) : ej(a, b, h, f);
  b.memoizedState = d.state;
  e && cg(b, c, !0);
  return b.child;
}

function qj(a) {
  var b = a.stateNode;
  b.pendingContext ? $f(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $f(a, b.context, !1);
  Fh(a, b.containerInfo);
}

function rj(a, b, c, d, e) {
  nh();
  oh(e);
  b.flags |= 256;
  ej(a, b, c, d);
  return b.child;
}

var sj = {
  dehydrated: null,
  treeContext: null,
  retryLane: 0
};

function tj(a) {
  return {
    baseLanes: a,
    cachePool: null,
    transitions: null
  };
}

function uj(a, b) {
  return {
    baseLanes: a.baseLanes | b,
    cachePool: null,
    transitions: a.transitions
  };
}

function vj(a, b, c) {
  var d = b.pendingProps,
      e = K.current,
      f = !1,
      g = 0 !== (b.flags & 128),
      h;
  (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
  if (h) f = !0, b.flags &= -129;else if (null === a || null !== a.memoizedState) e |= 1;
  G(K, e & 1);

  if (null === a) {
    kh(b);
    a = b.memoizedState;
    if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
    e = d.children;
    a = d.fallback;
    return f ? (d = b.mode, f = b.child, e = {
      mode: "hidden",
      children: e
    }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = e) : f = wj(e, d, 0, null), a = xh(a, d, c, null), f["return"] = b, a["return"] = b, f.sibling = a, b.child = f, b.child.memoizedState = tj(c), b.memoizedState = sj, a) : xj(b, e);
  }

  e = a.memoizedState;

  if (null !== e) {
    h = e.dehydrated;

    if (null !== h) {
      if (g) {
        if (b.flags & 256) return b.flags &= -257, yj(a, b, c, Error(p(422)));
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = wj({
          mode: "visible",
          children: d.children
        }, e, 0, null);
        f = xh(f, e, c, null);
        f.flags |= 2;
        d["return"] = b;
        f["return"] = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && yh(b, a.child, null, c);
        b.child.memoizedState = tj(c);
        b.memoizedState = sj;
        return f;
      }

      if (0 === (b.mode & 1)) b = yj(a, b, c, null);else if ("$!" === h.data) b = yj(a, b, c, Error(p(419)));else if (d = 0 !== (c & a.childLanes), tg || d) {
        d = P;

        if (null !== d) {
          switch (c & -c) {
            case 4:
              f = 2;
              break;

            case 16:
              f = 8;
              break;

            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
              f = 32;
              break;

            case 536870912:
              f = 268435456;
              break;

            default:
              f = 0;
          }

          d = 0 !== (f & (d.suspendedLanes | c)) ? 0 : f;
          0 !== d && d !== e.retryLane && (e.retryLane = d, Lg(a, d, -1));
        }

        $i();
        b = yj(a, b, c, Error(p(421)));
      } else "$?" === h.data ? (b.flags |= 128, b.child = a.child, b = zj.bind(null, a), h._reactRetry = b, b = null) : (c = e.treeContext, eh = Kf(h.nextSibling), dh = b, I = !0, fh = null, null !== c && (Vg[Wg++] = Yg, Vg[Wg++] = Zg, Vg[Wg++] = Xg, Yg = c.id, Zg = c.overflow, Xg = b), b = xj(b, b.pendingProps.children), b.flags |= 4096);
      return b;
    }

    if (f) return d = Aj(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? tj(c) : uj(e, c), f.childLanes = a.childLanes & ~c, b.memoizedState = sj, d;
    c = Bj(a, b, d.children, c);
    b.memoizedState = null;
    return c;
  }

  if (f) return d = Aj(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? tj(c) : uj(e, c), f.childLanes = a.childLanes & ~c, b.memoizedState = sj, d;
  c = Bj(a, b, d.children, c);
  b.memoizedState = null;
  return c;
}

function xj(a, b) {
  b = wj({
    mode: "visible",
    children: b
  }, a.mode, 0, null);
  b["return"] = a;
  return a.child = b;
}

function Bj(a, b, c, d) {
  var e = a.child;
  a = e.sibling;
  c = th(e, {
    mode: "visible",
    children: c
  });
  0 === (b.mode & 1) && (c.lanes = d);
  c["return"] = b;
  c.sibling = null;
  null !== a && (d = b.deletions, null === d ? (b.deletions = [a], b.flags |= 16) : d.push(a));
  return b.child = c;
}

function Aj(a, b, c, d, e) {
  var f = b.mode;
  a = a.child;
  var g = a.sibling,
      h = {
    mode: "hidden",
    children: c
  };
  0 === (f & 1) && b.child !== a ? (c = b.child, c.childLanes = 0, c.pendingProps = h, b.deletions = null) : (c = th(a, h), c.subtreeFlags = a.subtreeFlags & 14680064);
  null !== g ? d = th(g, d) : (d = xh(d, f, e, null), d.flags |= 2);
  d["return"] = b;
  c["return"] = b;
  c.sibling = d;
  b.child = c;
  return d;
}

function yj(a, b, c, d) {
  null !== d && oh(d);
  yh(b, a.child, null, c);
  a = xj(b, b.pendingProps.children);
  a.flags |= 2;
  b.memoizedState = null;
  return a;
}

function Cj(a, b, c) {
  a.lanes |= b;
  var d = a.alternate;
  null !== d && (d.lanes |= b);
  rg(a["return"], b, c);
}

function Dj(a, b, c, d, e) {
  var f = a.memoizedState;
  null === f ? a.memoizedState = {
    isBackwards: b,
    rendering: null,
    renderingStartTime: 0,
    last: d,
    tail: c,
    tailMode: e
  } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}

function Ej(a, b, c) {
  var d = b.pendingProps,
      e = d.revealOrder,
      f = d.tail;
  ej(a, b, d.children, c);
  d = K.current;
  if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;else {
    if (null !== a && 0 !== (a.flags & 128)) a: for (a = b.child; null !== a;) {
      if (13 === a.tag) null !== a.memoizedState && Cj(a, c, b);else if (19 === a.tag) Cj(a, c, b);else if (null !== a.child) {
        a.child["return"] = a;
        a = a.child;
        continue;
      }
      if (a === b) break a;

      for (; null === a.sibling;) {
        if (null === a["return"] || a["return"] === b) break a;
        a = a["return"];
      }

      a.sibling["return"] = a["return"];
      a = a.sibling;
    }
    d &= 1;
  }
  G(K, d);
  if (0 === (b.mode & 1)) b.memoizedState = null;else switch (e) {
    case "forwards":
      c = b.child;

      for (e = null; null !== c;) {
        a = c.alternate, null !== a && null === Jh(a) && (e = c), c = c.sibling;
      }

      c = e;
      null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
      Dj(b, !1, e, c, f);
      break;

    case "backwards":
      c = null;
      e = b.child;

      for (b.child = null; null !== e;) {
        a = e.alternate;

        if (null !== a && null === Jh(a)) {
          b.child = e;
          break;
        }

        a = e.sibling;
        e.sibling = c;
        c = e;
        e = a;
      }

      Dj(b, !0, c, null, f);
      break;

    case "together":
      Dj(b, !1, null, null, void 0);
      break;

    default:
      b.memoizedState = null;
  }
  return b.child;
}

function gj(a, b, c) {
  null !== a && (b.dependencies = a.dependencies);
  Fg |= b.lanes;
  if (0 === (c & b.childLanes)) return null;
  if (null !== a && b.child !== a.child) throw Error(p(153));

  if (null !== b.child) {
    a = b.child;
    c = th(a, a.pendingProps);
    b.child = c;

    for (c["return"] = b; null !== a.sibling;) {
      a = a.sibling, c = c.sibling = th(a, a.pendingProps), c["return"] = b;
    }

    c.sibling = null;
  }

  return b.child;
}

function Fj(a, b, c) {
  switch (b.tag) {
    case 3:
      qj(b);
      nh();
      break;

    case 5:
      Hh(b);
      break;

    case 1:
      Yf(b.type) && bg(b);
      break;

    case 4:
      Fh(b, b.stateNode.containerInfo);
      break;

    case 10:
      var d = b.type._context,
          e = b.memoizedProps.value;
      G(lg, d._currentValue);
      d._currentValue = e;
      break;

    case 13:
      d = b.memoizedState;

      if (null !== d) {
        if (null !== d.dehydrated) return G(K, K.current & 1), b.flags |= 128, null;
        if (0 !== (c & b.child.childLanes)) return vj(a, b, c);
        G(K, K.current & 1);
        a = gj(a, b, c);
        return null !== a ? a.sibling : null;
      }

      G(K, K.current & 1);
      break;

    case 19:
      d = 0 !== (c & b.childLanes);

      if (0 !== (a.flags & 128)) {
        if (d) return Ej(a, b, c);
        b.flags |= 128;
      }

      e = b.memoizedState;
      null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
      G(K, K.current);
      if (d) break;else return null;

    case 22:
    case 23:
      return b.lanes = 0, lj(a, b, c);
  }

  return gj(a, b, c);
}

function Gj(a, b) {
  ch(b);

  switch (b.tag) {
    case 1:
      return Yf(b.type) && Zf(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;

    case 3:
      return Gh(), E(Vf), E(H), Lh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;

    case 5:
      return Ih(b), null;

    case 13:
      E(K);
      a = b.memoizedState;

      if (null !== a && null !== a.dehydrated) {
        if (null === b.alternate) throw Error(p(340));
        nh();
      }

      a = b.flags;
      return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;

    case 19:
      return E(K), null;

    case 4:
      return Gh(), null;

    case 10:
      return qg(b.type._context), null;

    case 22:
    case 23:
      return bj(), null;

    case 24:
      return null;

    default:
      return null;
  }
}

var Hj = !1,
    S = !1,
    Ij = "function" === typeof WeakSet ? WeakSet : Set,
    T = null;

function Jj(a, b) {
  var c = a.ref;
  if (null !== c) if ("function" === typeof c) try {
    c(null);
  } catch (d) {
    U(a, b, d);
  } else c.current = null;
}

function Kj(a, b, c) {
  try {
    c();
  } catch (d) {
    U(a, b, d);
  }
}

var Lj = !1;

function Mj(a, b) {
  Bf = cd;
  a = Le();

  if (Me(a)) {
    if ("selectionStart" in a) var c = {
      start: a.selectionStart,
      end: a.selectionEnd
    };else a: {
      c = (c = a.ownerDocument) && c.defaultView || window;
      var d = c.getSelection && c.getSelection();

      if (d && 0 !== d.rangeCount) {
        c = d.anchorNode;
        var e = d.anchorOffset,
            f = d.focusNode;
        d = d.focusOffset;

        try {
          c.nodeType, f.nodeType;
        } catch (Z) {
          c = null;
          break a;
        }

        var g = 0,
            h = -1,
            k = -1,
            l = 0,
            n = 0,
            u = a,
            q = null;

        b: for (;;) {
          for (var y;;) {
            u !== c || 0 !== e && 3 !== u.nodeType || (h = g + e);
            u !== f || 0 !== d && 3 !== u.nodeType || (k = g + d);
            3 === u.nodeType && (g += u.nodeValue.length);
            if (null === (y = u.firstChild)) break;
            q = u;
            u = y;
          }

          for (;;) {
            if (u === a) break b;
            q === c && ++l === e && (h = g);
            q === f && ++n === d && (k = g);
            if (null !== (y = u.nextSibling)) break;
            u = q;
            q = u.parentNode;
          }

          u = y;
        }

        c = -1 === h || -1 === k ? null : {
          start: h,
          end: k
        };
      } else c = null;
    }
    c = c || {
      start: 0,
      end: 0
    };
  } else c = null;

  Cf = {
    focusedElem: a,
    selectionRange: c
  };
  cd = !1;

  for (T = b; null !== T;) {
    if (b = T, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a["return"] = b, T = a;else for (; null !== T;) {
      b = T;

      try {
        var m = b.alternate;
        if (0 !== (b.flags & 1024)) switch (b.tag) {
          case 0:
          case 11:
          case 15:
            break;

          case 1:
            if (null !== m) {
              var w = m.memoizedProps,
                  J = m.memoizedState,
                  v = b.stateNode,
                  x = v.getSnapshotBeforeUpdate(b.elementType === b.type ? w : kg(b.type, w), J);
              v.__reactInternalSnapshotBeforeUpdate = x;
            }

            break;

          case 3:
            var r = b.stateNode.containerInfo;
            if (1 === r.nodeType) r.textContent = "";else if (9 === r.nodeType) {
              var F = r.body;
              null != F && (F.textContent = "");
            }
            break;

          case 5:
          case 6:
          case 4:
          case 17:
            break;

          default:
            throw Error(p(163));
        }
      } catch (Z) {
        U(b, b["return"], Z);
      }

      a = b.sibling;

      if (null !== a) {
        a["return"] = b["return"];
        T = a;
        break;
      }

      T = b["return"];
    }
  }

  m = Lj;
  Lj = !1;
  return m;
}

function Nj(a, b, c) {
  var d = b.updateQueue;
  d = null !== d ? d.lastEffect : null;

  if (null !== d) {
    var e = d = d.next;

    do {
      if ((e.tag & a) === a) {
        var f = e.destroy;
        e.destroy = void 0;
        void 0 !== f && Kj(b, c, f);
      }

      e = e.next;
    } while (e !== d);
  }
}

function Oj(a, b) {
  b = b.updateQueue;
  b = null !== b ? b.lastEffect : null;

  if (null !== b) {
    var c = b = b.next;

    do {
      if ((c.tag & a) === a) {
        var d = c.create;
        c.destroy = d();
      }

      c = c.next;
    } while (c !== b);
  }
}

function Pj(a) {
  var b = a.ref;

  if (null !== b) {
    var c = a.stateNode;

    switch (a.tag) {
      case 5:
        a = c;
        break;

      default:
        a = c;
    }

    "function" === typeof b ? b(a) : b.current = a;
  }
}

function Qj(a) {
  var b = a.alternate;
  null !== b && (a.alternate = null, Qj(b));
  a.child = null;
  a.deletions = null;
  a.sibling = null;
  5 === a.tag && (b = a.stateNode, null !== b && (delete b[Nf], delete b[Of], delete b[nf], delete b[Pf], delete b[Qf]));
  a.stateNode = null;
  a["return"] = null;
  a.dependencies = null;
  a.memoizedProps = null;
  a.memoizedState = null;
  a.pendingProps = null;
  a.stateNode = null;
  a.updateQueue = null;
}

function Rj(a) {
  return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}

function Sj(a) {
  a: for (;;) {
    for (; null === a.sibling;) {
      if (null === a["return"] || Rj(a["return"])) return null;
      a = a["return"];
    }

    a.sibling["return"] = a["return"];

    for (a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;) {
      if (a.flags & 2) continue a;
      if (null === a.child || 4 === a.tag) continue a;else a.child["return"] = a, a = a.child;
    }

    if (!(a.flags & 2)) return a.stateNode;
  }
}

function Tj(a, b, c) {
  var d = a.tag;
  if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Af));else if (4 !== d && (a = a.child, null !== a)) for (Tj(a, b, c), a = a.sibling; null !== a;) {
    Tj(a, b, c), a = a.sibling;
  }
}

function Uj(a, b, c) {
  var d = a.tag;
  if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);else if (4 !== d && (a = a.child, null !== a)) for (Uj(a, b, c), a = a.sibling; null !== a;) {
    Uj(a, b, c), a = a.sibling;
  }
}

var V = null,
    Vj = !1;

function Wj(a, b, c) {
  for (c = c.child; null !== c;) {
    Xj(a, b, c), c = c.sibling;
  }
}

function Xj(a, b, c) {
  if (kc && "function" === typeof kc.onCommitFiberUnmount) try {
    kc.onCommitFiberUnmount(jc, c);
  } catch (h) {}

  switch (c.tag) {
    case 5:
      S || Jj(c, b);

    case 6:
      var d = V,
          e = Vj;
      V = null;
      Wj(a, b, c);
      V = d;
      Vj = e;
      null !== V && (Vj ? (a = V, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : V.removeChild(c.stateNode));
      break;

    case 18:
      null !== V && (Vj ? (a = V, c = c.stateNode, 8 === a.nodeType ? Jf(a.parentNode, c) : 1 === a.nodeType && Jf(a, c), ad(a)) : Jf(V, c.stateNode));
      break;

    case 4:
      d = V;
      e = Vj;
      V = c.stateNode.containerInfo;
      Vj = !0;
      Wj(a, b, c);
      V = d;
      Vj = e;
      break;

    case 0:
    case 11:
    case 14:
    case 15:
      if (!S && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
        e = d = d.next;

        do {
          var f = e,
              g = f.destroy;
          f = f.tag;
          void 0 !== g && (0 !== (f & 2) ? Kj(c, b, g) : 0 !== (f & 4) && Kj(c, b, g));
          e = e.next;
        } while (e !== d);
      }

      Wj(a, b, c);
      break;

    case 1:
      if (!S && (Jj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
        d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
      } catch (h) {
        U(c, b, h);
      }
      Wj(a, b, c);
      break;

    case 21:
      Wj(a, b, c);
      break;

    case 22:
      c.mode & 1 ? (S = (d = S) || null !== c.memoizedState, Wj(a, b, c), S = d) : Wj(a, b, c);
      break;

    default:
      Wj(a, b, c);
  }
}

function Yj(a) {
  var b = a.updateQueue;

  if (null !== b) {
    a.updateQueue = null;
    var c = a.stateNode;
    null === c && (c = a.stateNode = new Ij());
    b.forEach(function (b) {
      var d = Zj.bind(null, a, b);
      c.has(b) || (c.add(b), b.then(d, d));
    });
  }
}

function ak(a, b) {
  var c = b.deletions;
  if (null !== c) for (var d = 0; d < c.length; d++) {
    var e = c[d];

    try {
      var f = a,
          g = b,
          h = g;

      a: for (; null !== h;) {
        switch (h.tag) {
          case 5:
            V = h.stateNode;
            Vj = !1;
            break a;

          case 3:
            V = h.stateNode.containerInfo;
            Vj = !0;
            break a;

          case 4:
            V = h.stateNode.containerInfo;
            Vj = !0;
            break a;
        }

        h = h["return"];
      }

      if (null === V) throw Error(p(160));
      Xj(f, g, e);
      V = null;
      Vj = !1;
      var k = e.alternate;
      null !== k && (k["return"] = null);
      e["return"] = null;
    } catch (l) {
      U(e, b, l);
    }
  }
  if (b.subtreeFlags & 12854) for (b = b.child; null !== b;) {
    bk(b, a), b = b.sibling;
  }
}

function bk(a, b) {
  var c = a.alternate,
      d = a.flags;

  switch (a.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      ak(b, a);
      ck(a);

      if (d & 4) {
        try {
          Nj(3, a, a["return"]), Oj(3, a);
        } catch (m) {
          U(a, a["return"], m);
        }

        try {
          Nj(5, a, a["return"]);
        } catch (m) {
          U(a, a["return"], m);
        }
      }

      break;

    case 1:
      ak(b, a);
      ck(a);
      d & 512 && null !== c && Jj(c, c["return"]);
      break;

    case 5:
      ak(b, a);
      ck(a);
      d & 512 && null !== c && Jj(c, c["return"]);

      if (a.flags & 32) {
        var e = a.stateNode;

        try {
          nb(e, "");
        } catch (m) {
          U(a, a["return"], m);
        }
      }

      if (d & 4 && (e = a.stateNode, null != e)) {
        var f = a.memoizedProps,
            g = null !== c ? c.memoizedProps : f,
            h = a.type,
            k = a.updateQueue;
        a.updateQueue = null;
        if (null !== k) try {
          "input" === h && "radio" === f.type && null != f.name && Za(e, f);
          ub(h, g);
          var l = ub(h, f);

          for (g = 0; g < k.length; g += 2) {
            var n = k[g],
                u = k[g + 1];
            "style" === n ? rb(e, u) : "dangerouslySetInnerHTML" === n ? mb(e, u) : "children" === n ? nb(e, u) : sa(e, n, u, l);
          }

          switch (h) {
            case "input":
              $a(e, f);
              break;

            case "textarea":
              hb(e, f);
              break;

            case "select":
              var q = e._wrapperState.wasMultiple;
              e._wrapperState.wasMultiple = !!f.multiple;
              var y = f.value;
              null != y ? eb(e, !!f.multiple, y, !1) : q !== !!f.multiple && (null != f.defaultValue ? eb(e, !!f.multiple, f.defaultValue, !0) : eb(e, !!f.multiple, f.multiple ? [] : "", !1));
          }

          e[Of] = f;
        } catch (m) {
          U(a, a["return"], m);
        }
      }

      break;

    case 6:
      ak(b, a);
      ck(a);

      if (d & 4) {
        if (null === a.stateNode) throw Error(p(162));
        l = a.stateNode;
        n = a.memoizedProps;

        try {
          l.nodeValue = n;
        } catch (m) {
          U(a, a["return"], m);
        }
      }

      break;

    case 3:
      ak(b, a);
      ck(a);
      if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
        ad(b.containerInfo);
      } catch (m) {
        U(a, a["return"], m);
      }
      break;

    case 4:
      ak(b, a);
      ck(a);
      break;

    case 13:
      ak(b, a);
      ck(a);
      l = a.child;
      l.flags & 8192 && null !== l.memoizedState && (null === l.alternate || null === l.alternate.memoizedState) && (dk = B());
      d & 4 && Yj(a);
      break;

    case 22:
      l = null !== c && null !== c.memoizedState;
      a.mode & 1 ? (S = (n = S) || l, ak(b, a), S = n) : ak(b, a);
      ck(a);

      if (d & 8192) {
        n = null !== a.memoizedState;

        a: for (u = null, q = a;;) {
          if (5 === q.tag) {
            if (null === u) {
              u = q;

              try {
                e = q.stateNode, n ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = qb("display", g));
              } catch (m) {
                U(a, a["return"], m);
              }
            }
          } else if (6 === q.tag) {
            if (null === u) try {
              q.stateNode.nodeValue = n ? "" : q.memoizedProps;
            } catch (m) {
              U(a, a["return"], m);
            }
          } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
            q.child["return"] = q;
            q = q.child;
            continue;
          }

          if (q === a) break a;

          for (; null === q.sibling;) {
            if (null === q["return"] || q["return"] === a) break a;
            u === q && (u = null);
            q = q["return"];
          }

          u === q && (u = null);
          q.sibling["return"] = q["return"];
          q = q.sibling;
        }

        if (n && !l && 0 !== (a.mode & 1)) for (T = a, a = a.child; null !== a;) {
          for (l = T = a; null !== T;) {
            n = T;
            u = n.child;

            switch (n.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                Nj(4, n, n["return"]);
                break;

              case 1:
                Jj(n, n["return"]);
                f = n.stateNode;

                if ("function" === typeof f.componentWillUnmount) {
                  q = n;
                  y = n["return"];

                  try {
                    e = q, f.props = e.memoizedProps, f.state = e.memoizedState, f.componentWillUnmount();
                  } catch (m) {
                    U(q, y, m);
                  }
                }

                break;

              case 5:
                Jj(n, n["return"]);
                break;

              case 22:
                if (null !== n.memoizedState) {
                  ek(l);
                  continue;
                }

            }

            null !== u ? (u["return"] = n, T = u) : ek(l);
          }

          a = a.sibling;
        }
      }

      break;

    case 19:
      ak(b, a);
      ck(a);
      d & 4 && Yj(a);
      break;

    case 21:
      break;

    default:
      ak(b, a), ck(a);
  }
}

function ck(a) {
  var b = a.flags;

  if (b & 2) {
    try {
      a: {
        for (var c = a["return"]; null !== c;) {
          if (Rj(c)) {
            var d = c;
            break a;
          }

          c = c["return"];
        }

        throw Error(p(160));
      }

      switch (d.tag) {
        case 5:
          var e = d.stateNode;
          d.flags & 32 && (nb(e, ""), d.flags &= -33);
          var f = Sj(a);
          Uj(a, f, e);
          break;

        case 3:
        case 4:
          var g = d.stateNode.containerInfo,
              h = Sj(a);
          Tj(a, h, g);
          break;

        default:
          throw Error(p(161));
      }
    } catch (k) {
      U(a, a["return"], k);
    }

    a.flags &= -3;
  }

  b & 4096 && (a.flags &= -4097);
}

function fk(a, b, c) {
  T = a;
  gk(a);
}

function gk(a, b, c) {
  for (var d = 0 !== (a.mode & 1); null !== T;) {
    var e = T,
        f = e.child;

    if (22 === e.tag && d) {
      var g = null !== e.memoizedState || Hj;

      if (!g) {
        var h = e.alternate,
            k = null !== h && null !== h.memoizedState || S;
        h = Hj;
        var l = S;
        Hj = g;
        if ((S = k) && !l) for (T = e; null !== T;) {
          g = T, k = g.child, 22 === g.tag && null !== g.memoizedState ? hk(e) : null !== k ? (k["return"] = g, T = k) : hk(e);
        }

        for (; null !== f;) {
          T = f, gk(f), f = f.sibling;
        }

        T = e;
        Hj = h;
        S = l;
      }

      ik(a);
    } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f["return"] = e, T = f) : ik(a);
  }
}

function ik(a) {
  for (; null !== T;) {
    var b = T;

    if (0 !== (b.flags & 8772)) {
      var c = b.alternate;

      try {
        if (0 !== (b.flags & 8772)) switch (b.tag) {
          case 0:
          case 11:
          case 15:
            S || Oj(5, b);
            break;

          case 1:
            var d = b.stateNode;
            if (b.flags & 4 && !S) if (null === c) d.componentDidMount();else {
              var e = b.elementType === b.type ? c.memoizedProps : kg(b.type, c.memoizedProps);
              d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
            }
            var f = b.updateQueue;
            null !== f && Gg(b, f, d);
            break;

          case 3:
            var g = b.updateQueue;

            if (null !== g) {
              c = null;
              if (null !== b.child) switch (b.child.tag) {
                case 5:
                  c = b.child.stateNode;
                  break;

                case 1:
                  c = b.child.stateNode;
              }
              Gg(b, g, c);
            }

            break;

          case 5:
            var h = b.stateNode;

            if (null === c && b.flags & 4) {
              c = h;
              var k = b.memoizedProps;

              switch (b.type) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  k.autoFocus && c.focus();
                  break;

                case "img":
                  k.src && (c.src = k.src);
              }
            }

            break;

          case 6:
            break;

          case 4:
            break;

          case 12:
            break;

          case 13:
            if (null === b.memoizedState) {
              var l = b.alternate;

              if (null !== l) {
                var n = l.memoizedState;

                if (null !== n) {
                  var u = n.dehydrated;
                  null !== u && ad(u);
                }
              }
            }

            break;

          case 19:
          case 17:
          case 21:
          case 22:
          case 23:
            break;

          default:
            throw Error(p(163));
        }
        S || b.flags & 512 && Pj(b);
      } catch (q) {
        U(b, b["return"], q);
      }
    }

    if (b === a) {
      T = null;
      break;
    }

    c = b.sibling;

    if (null !== c) {
      c["return"] = b["return"];
      T = c;
      break;
    }

    T = b["return"];
  }
}

function ek(a) {
  for (; null !== T;) {
    var b = T;

    if (b === a) {
      T = null;
      break;
    }

    var c = b.sibling;

    if (null !== c) {
      c["return"] = b["return"];
      T = c;
      break;
    }

    T = b["return"];
  }
}

function hk(a) {
  for (; null !== T;) {
    var b = T;

    try {
      switch (b.tag) {
        case 0:
        case 11:
        case 15:
          var c = b["return"];

          try {
            Oj(4, b);
          } catch (k) {
            U(b, c, k);
          }

          break;

        case 1:
          var d = b.stateNode;

          if ("function" === typeof d.componentDidMount) {
            var e = b["return"];

            try {
              d.componentDidMount();
            } catch (k) {
              U(b, e, k);
            }
          }

          var f = b["return"];

          try {
            Pj(b);
          } catch (k) {
            U(b, f, k);
          }

          break;

        case 5:
          var g = b["return"];

          try {
            Pj(b);
          } catch (k) {
            U(b, g, k);
          }

      }
    } catch (k) {
      U(b, b["return"], k);
    }

    if (b === a) {
      T = null;
      break;
    }

    var h = b.sibling;

    if (null !== h) {
      h["return"] = b["return"];
      T = h;
      break;
    }

    T = b["return"];
  }
}

var jk = Math.ceil,
    kk = ta.ReactCurrentDispatcher,
    lk = ta.ReactCurrentOwner,
    mk = ta.ReactCurrentBatchConfig,
    W = 0,
    P = null,
    X = null,
    Y = 0,
    cj = 0,
    mj = Tf(0),
    R = 0,
    nk = null,
    Fg = 0,
    ok = 0,
    pk = 0,
    qk = null,
    rk = null,
    dk = 0,
    aj = Infinity,
    sk = null,
    Li = !1,
    Mi = null,
    Oi = null,
    tk = !1,
    uk = null,
    vk = 0,
    wk = 0,
    xk = null,
    yk = -1,
    zk = 0;

function Jg() {
  return 0 !== (W & 6) ? B() : -1 !== yk ? yk : yk = B();
}

function Kg(a) {
  if (0 === (a.mode & 1)) return 1;
  if (0 !== (W & 2) && 0 !== Y) return Y & -Y;
  if (null !== jg.transition) return 0 === zk && (zk = xc()), zk;
  a = C;
  if (0 !== a) return a;
  a = window.event;
  a = void 0 === a ? 16 : id(a.type);
  return a;
}

function Lg(a, b, c) {
  if (50 < wk) throw wk = 0, xk = null, Error(p(185));
  var d = Ak(a, b);
  if (null === d) return null;
  zc(d, b, c);
  if (0 === (W & 2) || d !== P) d === P && (0 === (W & 2) && (ok |= b), 4 === R && Bk(d, Y)), Ck(d, c), 1 === b && 0 === W && 0 === (a.mode & 1) && (aj = B() + 500, eg && ig());
  return d;
}

function Ak(a, b) {
  a.lanes |= b;
  var c = a.alternate;
  null !== c && (c.lanes |= b);
  c = a;

  for (a = a["return"]; null !== a;) {
    a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a["return"];
  }

  return 3 === c.tag ? c.stateNode : null;
}

function Bg(a) {
  return (null !== P || null !== vg) && 0 !== (a.mode & 1) && 0 === (W & 2);
}

function Ck(a, b) {
  var c = a.callbackNode;
  vc(a, b);
  var d = tc(a, a === P ? Y : 0);
  if (0 === d) null !== c && ac(c), a.callbackNode = null, a.callbackPriority = 0;else if (b = d & -d, a.callbackPriority !== b) {
    null != c && ac(c);
    if (1 === b) 0 === a.tag ? hg(Dk.bind(null, a)) : gg(Dk.bind(null, a)), If(function () {
      0 === W && ig();
    }), c = null;else {
      switch (Cc(d)) {
        case 1:
          c = ec;
          break;

        case 4:
          c = fc;
          break;

        case 16:
          c = gc;
          break;

        case 536870912:
          c = ic;
          break;

        default:
          c = gc;
      }

      c = Ek(c, Fk.bind(null, a));
    }
    a.callbackPriority = b;
    a.callbackNode = c;
  }
}

function Fk(a, b) {
  yk = -1;
  zk = 0;
  if (0 !== (W & 6)) throw Error(p(327));
  var c = a.callbackNode;
  if (Gk() && a.callbackNode !== c) return null;
  var d = tc(a, a === P ? Y : 0);
  if (0 === d) return null;
  if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Hk(a, d);else {
    b = d;
    var e = W;
    W |= 2;
    var f = Ik();
    if (P !== a || Y !== b) sk = null, aj = B() + 500, Jk(a, b);

    do {
      try {
        Kk();
        break;
      } catch (h) {
        Lk(a, h);
      }
    } while (1);

    pg();
    kk.current = f;
    W = e;
    null !== X ? b = 0 : (P = null, Y = 0, b = R);
  }

  if (0 !== b) {
    2 === b && (e = wc(a), 0 !== e && (d = e, b = Mk(a, e)));
    if (1 === b) throw c = nk, Jk(a, 0), Bk(a, d), Ck(a, B()), c;
    if (6 === b) Bk(a, d);else {
      e = a.current.alternate;
      if (0 === (d & 30) && !Nk(e) && (b = Hk(a, d), 2 === b && (f = wc(a), 0 !== f && (d = f, b = Mk(a, f))), 1 === b)) throw c = nk, Jk(a, 0), Bk(a, d), Ck(a, B()), c;
      a.finishedWork = e;
      a.finishedLanes = d;

      switch (b) {
        case 0:
        case 1:
          throw Error(p(345));

        case 2:
          Ok(a, rk, sk);
          break;

        case 3:
          Bk(a, d);

          if ((d & 130023424) === d && (b = dk + 500 - B(), 10 < b)) {
            if (0 !== tc(a, 0)) break;
            e = a.suspendedLanes;

            if ((e & d) !== d) {
              Jg();
              a.pingedLanes |= a.suspendedLanes & e;
              break;
            }

            a.timeoutHandle = Ef(Ok.bind(null, a, rk, sk), b);
            break;
          }

          Ok(a, rk, sk);
          break;

        case 4:
          Bk(a, d);
          if ((d & 4194240) === d) break;
          b = a.eventTimes;

          for (e = -1; 0 < d;) {
            var g = 31 - nc(d);
            f = 1 << g;
            g = b[g];
            g > e && (e = g);
            d &= ~f;
          }

          d = e;
          d = B() - d;
          d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * jk(d / 1960)) - d;

          if (10 < d) {
            a.timeoutHandle = Ef(Ok.bind(null, a, rk, sk), d);
            break;
          }

          Ok(a, rk, sk);
          break;

        case 5:
          Ok(a, rk, sk);
          break;

        default:
          throw Error(p(329));
      }
    }
  }

  Ck(a, B());
  return a.callbackNode === c ? Fk.bind(null, a) : null;
}

function Mk(a, b) {
  var c = qk;
  a.current.memoizedState.isDehydrated && (Jk(a, b).flags |= 256);
  a = Hk(a, b);
  2 !== a && (b = rk, rk = c, null !== b && Zi(b));
  return a;
}

function Zi(a) {
  null === rk ? rk = a : rk.push.apply(rk, a);
}

function Nk(a) {
  for (var b = a;;) {
    if (b.flags & 16384) {
      var c = b.updateQueue;
      if (null !== c && (c = c.stores, null !== c)) for (var d = 0; d < c.length; d++) {
        var e = c[d],
            f = e.getSnapshot;
        e = e.value;

        try {
          if (!Ge(f(), e)) return !1;
        } catch (g) {
          return !1;
        }
      }
    }

    c = b.child;
    if (b.subtreeFlags & 16384 && null !== c) c["return"] = b, b = c;else {
      if (b === a) break;

      for (; null === b.sibling;) {
        if (null === b["return"] || b["return"] === a) return !0;
        b = b["return"];
      }

      b.sibling["return"] = b["return"];
      b = b.sibling;
    }
  }

  return !0;
}

function Bk(a, b) {
  b &= ~pk;
  b &= ~ok;
  a.suspendedLanes |= b;
  a.pingedLanes &= ~b;

  for (a = a.expirationTimes; 0 < b;) {
    var c = 31 - nc(b),
        d = 1 << c;
    a[c] = -1;
    b &= ~d;
  }
}

function Dk(a) {
  if (0 !== (W & 6)) throw Error(p(327));
  Gk();
  var b = tc(a, 0);
  if (0 === (b & 1)) return Ck(a, B()), null;
  var c = Hk(a, b);

  if (0 !== a.tag && 2 === c) {
    var d = wc(a);
    0 !== d && (b = d, c = Mk(a, d));
  }

  if (1 === c) throw c = nk, Jk(a, 0), Bk(a, b), Ck(a, B()), c;
  if (6 === c) throw Error(p(345));
  a.finishedWork = a.current.alternate;
  a.finishedLanes = b;
  Ok(a, rk, sk);
  Ck(a, B());
  return null;
}

function Pk(a, b) {
  var c = W;
  W |= 1;

  try {
    return a(b);
  } finally {
    W = c, 0 === W && (aj = B() + 500, eg && ig());
  }
}

function Qk(a) {
  null !== uk && 0 === uk.tag && 0 === (W & 6) && Gk();
  var b = W;
  W |= 1;
  var c = mk.transition,
      d = C;

  try {
    if (mk.transition = null, C = 1, a) return a();
  } finally {
    C = d, mk.transition = c, W = b, 0 === (W & 6) && ig();
  }
}

function bj() {
  cj = mj.current;
  E(mj);
}

function Jk(a, b) {
  a.finishedWork = null;
  a.finishedLanes = 0;
  var c = a.timeoutHandle;
  -1 !== c && (a.timeoutHandle = -1, Ff(c));
  if (null !== X) for (c = X["return"]; null !== c;) {
    var d = c;
    ch(d);

    switch (d.tag) {
      case 1:
        d = d.type.childContextTypes;
        null !== d && void 0 !== d && Zf();
        break;

      case 3:
        Gh();
        E(Vf);
        E(H);
        Lh();
        break;

      case 5:
        Ih(d);
        break;

      case 4:
        Gh();
        break;

      case 13:
        E(K);
        break;

      case 19:
        E(K);
        break;

      case 10:
        qg(d.type._context);
        break;

      case 22:
      case 23:
        bj();
    }

    c = c["return"];
  }
  P = a;
  X = a = th(a.current, null);
  Y = cj = b;
  R = 0;
  nk = null;
  pk = ok = Fg = 0;
  rk = qk = null;

  if (null !== vg) {
    for (b = 0; b < vg.length; b++) {
      if (c = vg[b], d = c.interleaved, null !== d) {
        c.interleaved = null;
        var e = d.next,
            f = c.pending;

        if (null !== f) {
          var g = f.next;
          f.next = e;
          d.next = g;
        }

        c.pending = d;
      }
    }

    vg = null;
  }

  return a;
}

function Lk(a, b) {
  do {
    var c = X;

    try {
      pg();
      Mh.current = Yh;

      if (Ph) {
        for (var d = L.memoizedState; null !== d;) {
          var e = d.queue;
          null !== e && (e.pending = null);
          d = d.next;
        }

        Ph = !1;
      }

      Oh = 0;
      N = M = L = null;
      Qh = !1;
      Rh = 0;
      lk.current = null;

      if (null === c || null === c["return"]) {
        R = 1;
        nk = b;
        X = null;
        break;
      }

      a: {
        var f = a,
            g = c["return"],
            h = c,
            k = b;
        b = Y;
        h.flags |= 32768;

        if (null !== k && "object" === typeof k && "function" === typeof k.then) {
          var l = k,
              n = h,
              u = n.tag;

          if (0 === (n.mode & 1) && (0 === u || 11 === u || 15 === u)) {
            var q = n.alternate;
            q ? (n.updateQueue = q.updateQueue, n.memoizedState = q.memoizedState, n.lanes = q.lanes) : (n.updateQueue = null, n.memoizedState = null);
          }

          var y = Ri(g);

          if (null !== y) {
            y.flags &= -257;
            Si(y, g, h, f, b);
            y.mode & 1 && Pi(f, l, b);
            b = y;
            k = l;
            var m = b.updateQueue;

            if (null === m) {
              var w = new Set();
              w.add(k);
              b.updateQueue = w;
            } else m.add(k);

            break a;
          } else {
            if (0 === (b & 1)) {
              Pi(f, l, b);
              $i();
              break a;
            }

            k = Error(p(426));
          }
        } else if (I && h.mode & 1) {
          var J = Ri(g);

          if (null !== J) {
            0 === (J.flags & 65536) && (J.flags |= 256);
            Si(J, g, h, f, b);
            oh(k);
            break a;
          }
        }

        f = k;
        4 !== R && (R = 2);
        null === qk ? qk = [f] : qk.push(f);
        k = Hi(k, h);
        h = g;

        do {
          switch (h.tag) {
            case 3:
              h.flags |= 65536;
              b &= -b;
              h.lanes |= b;
              var v = Ki(h, k, b);
              Dg(h, v);
              break a;

            case 1:
              f = k;
              var x = h.type,
                  r = h.stateNode;

              if (0 === (h.flags & 128) && ("function" === typeof x.getDerivedStateFromError || null !== r && "function" === typeof r.componentDidCatch && (null === Oi || !Oi.has(r)))) {
                h.flags |= 65536;
                b &= -b;
                h.lanes |= b;
                var F = Ni(h, f, b);
                Dg(h, F);
                break a;
              }

          }

          h = h["return"];
        } while (null !== h);
      }

      Rk(c);
    } catch (Z) {
      b = Z;
      X === c && null !== c && (X = c = c["return"]);
      continue;
    }

    break;
  } while (1);
}

function Ik() {
  var a = kk.current;
  kk.current = Yh;
  return null === a ? Yh : a;
}

function $i() {
  if (0 === R || 3 === R || 2 === R) R = 4;
  null === P || 0 === (Fg & 268435455) && 0 === (ok & 268435455) || Bk(P, Y);
}

function Hk(a, b) {
  var c = W;
  W |= 2;
  var d = Ik();
  if (P !== a || Y !== b) sk = null, Jk(a, b);

  do {
    try {
      Sk();
      break;
    } catch (e) {
      Lk(a, e);
    }
  } while (1);

  pg();
  W = c;
  kk.current = d;
  if (null !== X) throw Error(p(261));
  P = null;
  Y = 0;
  return R;
}

function Sk() {
  for (; null !== X;) {
    Tk(X);
  }
}

function Kk() {
  for (; null !== X && !bc();) {
    Tk(X);
  }
}

function Tk(a) {
  var b = Uk(a.alternate, a, cj);
  a.memoizedProps = a.pendingProps;
  null === b ? Rk(a) : X = b;
  lk.current = null;
}

function Rk(a) {
  var b = a;

  do {
    var c = b.alternate;
    a = b["return"];

    if (0 === (b.flags & 32768)) {
      if (c = Yi(c, b, cj), null !== c) {
        X = c;
        return;
      }
    } else {
      c = Gj(c, b);

      if (null !== c) {
        c.flags &= 32767;
        X = c;
        return;
      }

      if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;else {
        R = 6;
        X = null;
        return;
      }
    }

    b = b.sibling;

    if (null !== b) {
      X = b;
      return;
    }

    X = b = a;
  } while (null !== b);

  0 === R && (R = 5);
}

function Ok(a, b, c) {
  var d = C,
      e = mk.transition;

  try {
    mk.transition = null, C = 1, Vk(a, b, c, d);
  } finally {
    mk.transition = e, C = d;
  }

  return null;
}

function Vk(a, b, c, d) {
  do {
    Gk();
  } while (null !== uk);

  if (0 !== (W & 6)) throw Error(p(327));
  c = a.finishedWork;
  var e = a.finishedLanes;
  if (null === c) return null;
  a.finishedWork = null;
  a.finishedLanes = 0;
  if (c === a.current) throw Error(p(177));
  a.callbackNode = null;
  a.callbackPriority = 0;
  var f = c.lanes | c.childLanes;
  Ac(a, f);
  a === P && (X = P = null, Y = 0);
  0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || tk || (tk = !0, Ek(gc, function () {
    Gk();
    return null;
  }));
  f = 0 !== (c.flags & 15990);

  if (0 !== (c.subtreeFlags & 15990) || f) {
    f = mk.transition;
    mk.transition = null;
    var g = C;
    C = 1;
    var h = W;
    W |= 4;
    lk.current = null;
    Mj(a, c);
    bk(c, a);
    Ne(Cf);
    cd = !!Bf;
    Cf = Bf = null;
    a.current = c;
    fk(c);
    cc();
    W = h;
    C = g;
    mk.transition = f;
  } else a.current = c;

  tk && (tk = !1, uk = a, vk = e);
  f = a.pendingLanes;
  0 === f && (Oi = null);
  lc(c.stateNode);
  Ck(a, B());
  if (null !== b) for (d = a.onRecoverableError, c = 0; c < b.length; c++) {
    d(b[c]);
  }
  if (Li) throw Li = !1, a = Mi, Mi = null, a;
  0 !== (vk & 1) && 0 !== a.tag && Gk();
  f = a.pendingLanes;
  0 !== (f & 1) ? a === xk ? wk++ : (wk = 0, xk = a) : wk = 0;
  ig();
  return null;
}

function Gk() {
  if (null !== uk) {
    var a = Cc(vk),
        b = mk.transition,
        c = C;

    try {
      mk.transition = null;
      C = 16 > a ? 16 : a;
      if (null === uk) var d = !1;else {
        a = uk;
        uk = null;
        vk = 0;
        if (0 !== (W & 6)) throw Error(p(331));
        var e = W;
        W |= 4;

        for (T = a.current; null !== T;) {
          var f = T,
              g = f.child;

          if (0 !== (T.flags & 16)) {
            var h = f.deletions;

            if (null !== h) {
              for (var k = 0; k < h.length; k++) {
                var l = h[k];

                for (T = l; null !== T;) {
                  var n = T;

                  switch (n.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Nj(8, n, f);
                  }

                  var u = n.child;
                  if (null !== u) u["return"] = n, T = u;else for (; null !== T;) {
                    n = T;
                    var q = n.sibling,
                        y = n["return"];
                    Qj(n);

                    if (n === l) {
                      T = null;
                      break;
                    }

                    if (null !== q) {
                      q["return"] = y;
                      T = q;
                      break;
                    }

                    T = y;
                  }
                }
              }

              var m = f.alternate;

              if (null !== m) {
                var w = m.child;

                if (null !== w) {
                  m.child = null;

                  do {
                    var J = w.sibling;
                    w.sibling = null;
                    w = J;
                  } while (null !== w);
                }
              }

              T = f;
            }
          }

          if (0 !== (f.subtreeFlags & 2064) && null !== g) g["return"] = f, T = g;else b: for (; null !== T;) {
            f = T;
            if (0 !== (f.flags & 2048)) switch (f.tag) {
              case 0:
              case 11:
              case 15:
                Nj(9, f, f["return"]);
            }
            var v = f.sibling;

            if (null !== v) {
              v["return"] = f["return"];
              T = v;
              break b;
            }

            T = f["return"];
          }
        }

        var x = a.current;

        for (T = x; null !== T;) {
          g = T;
          var r = g.child;
          if (0 !== (g.subtreeFlags & 2064) && null !== r) r["return"] = g, T = r;else b: for (g = x; null !== T;) {
            h = T;
            if (0 !== (h.flags & 2048)) try {
              switch (h.tag) {
                case 0:
                case 11:
                case 15:
                  Oj(9, h);
              }
            } catch (Z) {
              U(h, h["return"], Z);
            }

            if (h === g) {
              T = null;
              break b;
            }

            var F = h.sibling;

            if (null !== F) {
              F["return"] = h["return"];
              T = F;
              break b;
            }

            T = h["return"];
          }
        }

        W = e;
        ig();
        if (kc && "function" === typeof kc.onPostCommitFiberRoot) try {
          kc.onPostCommitFiberRoot(jc, a);
        } catch (Z) {}
        d = !0;
      }
      return d;
    } finally {
      C = c, mk.transition = b;
    }
  }

  return !1;
}

function Wk(a, b, c) {
  b = Hi(c, b);
  b = Ki(a, b, 1);
  Ag(a, b);
  b = Jg();
  a = Ak(a, 1);
  null !== a && (zc(a, 1, b), Ck(a, b));
}

function U(a, b, c) {
  if (3 === a.tag) Wk(a, a, c);else for (; null !== b;) {
    if (3 === b.tag) {
      Wk(b, a, c);
      break;
    } else if (1 === b.tag) {
      var d = b.stateNode;

      if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Oi || !Oi.has(d))) {
        a = Hi(c, a);
        a = Ni(b, a, 1);
        Ag(b, a);
        a = Jg();
        b = Ak(b, 1);
        null !== b && (zc(b, 1, a), Ck(b, a));
        break;
      }
    }

    b = b["return"];
  }
}

function Qi(a, b, c) {
  var d = a.pingCache;
  null !== d && d["delete"](b);
  b = Jg();
  a.pingedLanes |= a.suspendedLanes & c;
  P === a && (Y & c) === c && (4 === R || 3 === R && (Y & 130023424) === Y && 500 > B() - dk ? Jk(a, 0) : pk |= c);
  Ck(a, b);
}

function Xk(a, b) {
  0 === b && (0 === (a.mode & 1) ? b = 1 : (b = rc, rc <<= 1, 0 === (rc & 130023424) && (rc = 4194304)));
  var c = Jg();
  a = Ak(a, b);
  null !== a && (zc(a, b, c), Ck(a, c));
}

function zj(a) {
  var b = a.memoizedState,
      c = 0;
  null !== b && (c = b.retryLane);
  Xk(a, c);
}

function Zj(a, b) {
  var c = 0;

  switch (a.tag) {
    case 13:
      var d = a.stateNode;
      var e = a.memoizedState;
      null !== e && (c = e.retryLane);
      break;

    case 19:
      d = a.stateNode;
      break;

    default:
      throw Error(p(314));
  }

  null !== d && d["delete"](b);
  Xk(a, c);
}

var Uk;

Uk = function Uk(a, b, c) {
  if (null !== a) {
    if (a.memoizedProps !== b.pendingProps || Vf.current) tg = !0;else {
      if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return tg = !1, Fj(a, b, c);
      tg = 0 !== (a.flags & 131072) ? !0 : !1;
    }
  } else tg = !1, I && 0 !== (b.flags & 1048576) && ah(b, Ug, b.index);
  b.lanes = 0;

  switch (b.tag) {
    case 2:
      var d = b.type;
      null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
      a = b.pendingProps;
      var e = Xf(b, H.current);
      sg(b, c);
      e = Uh(null, b, d, a, e, c);
      var f = Zh();
      b.flags |= 1;
      "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Yf(d) ? (f = !0, bg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, xg(b), e.updater = Mg, b.stateNode = e, e._reactInternals = b, Qg(b, d, a, c), b = pj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && bh(b), ej(null, b, e, c), b = b.child);
      return b;

    case 16:
      d = b.elementType;

      a: {
        null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
        a = b.pendingProps;
        e = d._init;
        d = e(d._payload);
        b.type = d;
        e = b.tag = Yk(d);
        a = kg(d, a);

        switch (e) {
          case 0:
            b = kj(null, b, d, a, c);
            break a;

          case 1:
            b = oj(null, b, d, a, c);
            break a;

          case 11:
            b = fj(null, b, d, a, c);
            break a;

          case 14:
            b = hj(null, b, d, kg(d.type, a), c);
            break a;
        }

        throw Error(p(306, d, ""));
      }

      return b;

    case 0:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : kg(d, e), kj(a, b, d, e, c);

    case 1:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : kg(d, e), oj(a, b, d, e, c);

    case 3:
      a: {
        qj(b);
        if (null === a) throw Error(p(387));
        d = b.pendingProps;
        f = b.memoizedState;
        e = f.element;
        yg(a, b);
        Eg(b, d, null, c);
        var g = b.memoizedState;
        d = g.element;
        if (f.isDehydrated) {
          if (f = {
            element: d,
            isDehydrated: !1,
            cache: g.cache,
            pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
            transitions: g.transitions
          }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
            e = Error(p(423));
            b = rj(a, b, d, c, e);
            break a;
          } else if (d !== e) {
            e = Error(p(424));
            b = rj(a, b, d, c, e);
            break a;
          } else for (eh = Kf(b.stateNode.containerInfo.firstChild), dh = b, I = !0, fh = null, c = zh(b, null, d, c), b.child = c; c;) {
            c.flags = c.flags & -3 | 4096, c = c.sibling;
          }
        } else {
          nh();

          if (d === e) {
            b = gj(a, b, c);
            break a;
          }

          ej(a, b, d, c);
        }
        b = b.child;
      }

      return b;

    case 5:
      return Hh(b), null === a && kh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Df(d, e) ? g = null : null !== f && Df(d, f) && (b.flags |= 32), nj(a, b), ej(a, b, g, c), b.child;

    case 6:
      return null === a && kh(b), null;

    case 13:
      return vj(a, b, c);

    case 4:
      return Fh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = yh(b, null, d, c) : ej(a, b, d, c), b.child;

    case 11:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : kg(d, e), fj(a, b, d, e, c);

    case 7:
      return ej(a, b, b.pendingProps, c), b.child;

    case 8:
      return ej(a, b, b.pendingProps.children, c), b.child;

    case 12:
      return ej(a, b, b.pendingProps.children, c), b.child;

    case 10:
      a: {
        d = b.type._context;
        e = b.pendingProps;
        f = b.memoizedProps;
        g = e.value;
        G(lg, d._currentValue);
        d._currentValue = g;
        if (null !== f) if (Ge(f.value, g)) {
          if (f.children === e.children && !Vf.current) {
            b = gj(a, b, c);
            break a;
          }
        } else for (f = b.child, null !== f && (f["return"] = b); null !== f;) {
          var h = f.dependencies;

          if (null !== h) {
            g = f.child;

            for (var k = h.firstContext; null !== k;) {
              if (k.context === d) {
                if (1 === f.tag) {
                  k = zg(-1, c & -c);
                  k.tag = 2;
                  var l = f.updateQueue;

                  if (null !== l) {
                    l = l.shared;
                    var n = l.pending;
                    null === n ? k.next = k : (k.next = n.next, n.next = k);
                    l.pending = k;
                  }
                }

                f.lanes |= c;
                k = f.alternate;
                null !== k && (k.lanes |= c);
                rg(f["return"], c, b);
                h.lanes |= c;
                break;
              }

              k = k.next;
            }
          } else if (10 === f.tag) g = f.type === b.type ? null : f.child;else if (18 === f.tag) {
            g = f["return"];
            if (null === g) throw Error(p(341));
            g.lanes |= c;
            h = g.alternate;
            null !== h && (h.lanes |= c);
            rg(g, c, b);
            g = f.sibling;
          } else g = f.child;

          if (null !== g) g["return"] = f;else for (g = f; null !== g;) {
            if (g === b) {
              g = null;
              break;
            }

            f = g.sibling;

            if (null !== f) {
              f["return"] = g["return"];
              g = f;
              break;
            }

            g = g["return"];
          }
          f = g;
        }
        ej(a, b, e.children, c);
        b = b.child;
      }

      return b;

    case 9:
      return e = b.type, d = b.pendingProps.children, sg(b, c), e = ug(e), d = d(e), b.flags |= 1, ej(a, b, d, c), b.child;

    case 14:
      return d = b.type, e = kg(d, b.pendingProps), e = kg(d.type, e), hj(a, b, d, e, c);

    case 15:
      return jj(a, b, b.type, b.pendingProps, c);

    case 17:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : kg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Yf(d) ? (a = !0, bg(b)) : a = !1, sg(b, c), Og(b, d, e), Qg(b, d, e, c), pj(null, b, d, !0, a, c);

    case 19:
      return Ej(a, b, c);

    case 22:
      return lj(a, b, c);
  }

  throw Error(p(156, b.tag));
};

function Ek(a, b) {
  return $b(a, b);
}

function Zk(a, b, c, d) {
  this.tag = a;
  this.key = c;
  this.sibling = this.child = this["return"] = this.stateNode = this.type = this.elementType = null;
  this.index = 0;
  this.ref = null;
  this.pendingProps = b;
  this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
  this.mode = d;
  this.subtreeFlags = this.flags = 0;
  this.deletions = null;
  this.childLanes = this.lanes = 0;
  this.alternate = null;
}

function hh(a, b, c, d) {
  return new Zk(a, b, c, d);
}

function ij(a) {
  a = a.prototype;
  return !(!a || !a.isReactComponent);
}

function Yk(a) {
  if ("function" === typeof a) return ij(a) ? 1 : 0;

  if (void 0 !== a && null !== a) {
    a = a.$$typeof;
    if (a === Ca) return 11;
    if (a === Fa) return 14;
  }

  return 2;
}

function th(a, b) {
  var c = a.alternate;
  null === c ? (c = hh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
  c.flags = a.flags & 14680064;
  c.childLanes = a.childLanes;
  c.lanes = a.lanes;
  c.child = a.child;
  c.memoizedProps = a.memoizedProps;
  c.memoizedState = a.memoizedState;
  c.updateQueue = a.updateQueue;
  b = a.dependencies;
  c.dependencies = null === b ? null : {
    lanes: b.lanes,
    firstContext: b.firstContext
  };
  c.sibling = a.sibling;
  c.index = a.index;
  c.ref = a.ref;
  return c;
}

function vh(a, b, c, d, e, f) {
  var g = 2;
  d = a;
  if ("function" === typeof a) ij(a) && (g = 1);else if ("string" === typeof a) g = 5;else a: switch (a) {
    case wa:
      return xh(c.children, e, f, b);

    case xa:
      g = 8;
      e |= 8;
      break;

    case za:
      return a = hh(12, c, b, e | 2), a.elementType = za, a.lanes = f, a;

    case Da:
      return a = hh(13, c, b, e), a.elementType = Da, a.lanes = f, a;

    case Ea:
      return a = hh(19, c, b, e), a.elementType = Ea, a.lanes = f, a;

    case Ha:
      return wj(c, e, f, b);

    default:
      if ("object" === typeof a && null !== a) switch (a.$$typeof) {
        case Aa:
          g = 10;
          break a;

        case Ba:
          g = 9;
          break a;

        case Ca:
          g = 11;
          break a;

        case Fa:
          g = 14;
          break a;

        case Ga:
          g = 16;
          d = null;
          break a;
      }
      throw Error(p(130, null == a ? a : typeof a, ""));
  }
  b = hh(g, c, b, e);
  b.elementType = a;
  b.type = d;
  b.lanes = f;
  return b;
}

function xh(a, b, c, d) {
  a = hh(7, a, d, b);
  a.lanes = c;
  return a;
}

function wj(a, b, c, d) {
  a = hh(22, a, d, b);
  a.elementType = Ha;
  a.lanes = c;
  a.stateNode = {};
  return a;
}

function uh(a, b, c) {
  a = hh(6, a, null, b);
  a.lanes = c;
  return a;
}

function wh(a, b, c) {
  b = hh(4, null !== a.children ? a.children : [], a.key, b);
  b.lanes = c;
  b.stateNode = {
    containerInfo: a.containerInfo,
    pendingChildren: null,
    implementation: a.implementation
  };
  return b;
}

function $k(a, b, c, d, e) {
  this.tag = b;
  this.containerInfo = a;
  this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
  this.timeoutHandle = -1;
  this.callbackNode = this.pendingContext = this.context = null;
  this.callbackPriority = 0;
  this.eventTimes = yc(0);
  this.expirationTimes = yc(-1);
  this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
  this.entanglements = yc(0);
  this.identifierPrefix = d;
  this.onRecoverableError = e;
  this.mutableSourceEagerHydrationData = null;
}

function al(a, b, c, d, e, f, g, h, k) {
  a = new $k(a, b, c, h, k);
  1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
  f = hh(3, null, null, b);
  a.current = f;
  f.stateNode = a;
  f.memoizedState = {
    element: d,
    isDehydrated: c,
    cache: null,
    transitions: null,
    pendingSuspenseBoundaries: null
  };
  xg(f);
  return a;
}

function bl(a, b, c) {
  var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
  return {
    $$typeof: va,
    key: null == d ? null : "" + d,
    children: a,
    containerInfo: b,
    implementation: c
  };
}

function cl(a) {
  if (!a) return Uf;
  a = a._reactInternals;

  a: {
    if (Ub(a) !== a || 1 !== a.tag) throw Error(p(170));
    var b = a;

    do {
      switch (b.tag) {
        case 3:
          b = b.stateNode.context;
          break a;

        case 1:
          if (Yf(b.type)) {
            b = b.stateNode.__reactInternalMemoizedMergedChildContext;
            break a;
          }

      }

      b = b["return"];
    } while (null !== b);

    throw Error(p(171));
  }

  if (1 === a.tag) {
    var c = a.type;
    if (Yf(c)) return ag(a, c, b);
  }

  return b;
}

function dl(a, b, c, d, e, f, g, h, k) {
  a = al(c, d, !0, a, e, f, g, h, k);
  a.context = cl(null);
  c = a.current;
  d = Jg();
  e = Kg(c);
  f = zg(d, e);
  f.callback = void 0 !== b && null !== b ? b : null;
  Ag(c, f);
  a.current.lanes = e;
  zc(a, e, d);
  Ck(a, d);
  return a;
}

function el(a, b, c, d) {
  var e = b.current,
      f = Jg(),
      g = Kg(e);
  c = cl(c);
  null === b.context ? b.context = c : b.pendingContext = c;
  b = zg(f, g);
  b.payload = {
    element: a
  };
  d = void 0 === d ? null : d;
  null !== d && (b.callback = d);
  Ag(e, b);
  a = Lg(e, g, f);
  null !== a && Cg(a, e, g);
  return g;
}

function fl(a) {
  a = a.current;
  if (!a.child) return null;

  switch (a.child.tag) {
    case 5:
      return a.child.stateNode;

    default:
      return a.child.stateNode;
  }
}

function gl(a, b) {
  a = a.memoizedState;

  if (null !== a && null !== a.dehydrated) {
    var c = a.retryLane;
    a.retryLane = 0 !== c && c < b ? c : b;
  }
}

function hl(a, b) {
  gl(a, b);
  (a = a.alternate) && gl(a, b);
}

function il() {
  return null;
}

var jl = "function" === typeof reportError ? reportError : function (a) {
  console.error(a);
};

function kl(a) {
  this._internalRoot = a;
}

ll.prototype.render = kl.prototype.render = function (a) {
  var b = this._internalRoot;
  if (null === b) throw Error(p(409));
  el(a, b, null, null);
};

ll.prototype.unmount = kl.prototype.unmount = function () {
  var a = this._internalRoot;

  if (null !== a) {
    this._internalRoot = null;
    var b = a.containerInfo;
    Qk(function () {
      el(null, a, null, null);
    });
    b[tf] = null;
  }
};

function ll(a) {
  this._internalRoot = a;
}

ll.prototype.unstable_scheduleHydration = function (a) {
  if (a) {
    var b = Gc();
    a = {
      blockedOn: null,
      target: a,
      priority: b
    };

    for (var c = 0; c < Pc.length && 0 !== b && b < Pc[c].priority; c++) {
    }

    Pc.splice(c, 0, a);
    0 === c && Uc(a);
  }
};

function ml(a) {
  return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}

function nl(a) {
  return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}

function ol() {}

function pl(a, b, c, d, e) {
  if (e) {
    if ("function" === typeof d) {
      var f = d;

      d = function d() {
        var a = fl(g);
        f.call(a);
      };
    }

    var g = dl(b, d, a, 0, null, !1, !1, "", ol);
    a._reactRootContainer = g;
    a[tf] = g.current;
    rf(8 === a.nodeType ? a.parentNode : a);
    Qk();
    return g;
  }

  for (; e = a.lastChild;) {
    a.removeChild(e);
  }

  if ("function" === typeof d) {
    var h = d;

    d = function d() {
      var a = fl(k);
      h.call(a);
    };
  }

  var k = al(a, 0, !1, null, null, !1, !1, "", ol);
  a._reactRootContainer = k;
  a[tf] = k.current;
  rf(8 === a.nodeType ? a.parentNode : a);
  Qk(function () {
    el(b, k, c, d);
  });
  return k;
}

function ql(a, b, c, d, e) {
  var f = c._reactRootContainer;

  if (f) {
    var g = f;

    if ("function" === typeof e) {
      var h = e;

      e = function e() {
        var a = fl(g);
        h.call(a);
      };
    }

    el(b, g, a, e);
  } else g = pl(c, b, a, e, d);

  return fl(g);
}

Dc = function Dc(a) {
  switch (a.tag) {
    case 3:
      var b = a.stateNode;

      if (b.current.memoizedState.isDehydrated) {
        var c = sc(b.pendingLanes);
        0 !== c && (Bc(b, c | 1), Ck(b, B()), 0 === (W & 6) && (aj = B() + 500, ig()));
      }

      break;

    case 13:
      var d = Jg();
      Qk(function () {
        return Lg(a, 1, d);
      });
      hl(a, 1);
  }
};

Ec = function Ec(a) {
  if (13 === a.tag) {
    var b = Jg();
    Lg(a, 134217728, b);
    hl(a, 134217728);
  }
};

Fc = function Fc(a) {
  if (13 === a.tag) {
    var b = Jg(),
        c = Kg(a);
    Lg(a, c, b);
    hl(a, c);
  }
};

Gc = function Gc() {
  return C;
};

Hc = function Hc(a, b) {
  var c = C;

  try {
    return C = a, b();
  } finally {
    C = c;
  }
};

xb = function xb(a, b, c) {
  switch (b) {
    case "input":
      $a(a, c);
      b = c.name;

      if ("radio" === c.type && null != b) {
        for (c = a; c.parentNode;) {
          c = c.parentNode;
        }

        c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');

        for (b = 0; b < c.length; b++) {
          var d = c[b];

          if (d !== a && d.form === a.form) {
            var e = Cb(d);
            if (!e) throw Error(p(90));
            Va(d);
            $a(d, e);
          }
        }
      }

      break;

    case "textarea":
      hb(a, c);
      break;

    case "select":
      b = c.value, null != b && eb(a, !!c.multiple, b, !1);
  }
};

Fb = Pk;
Gb = Qk;
var rl = {
  usingClientEntryPoint: !1,
  Events: [Bb, te, Cb, Db, Eb, Pk]
},
    sl = {
  findFiberByHostInstance: Vc,
  bundleType: 0,
  version: "18.1.0",
  rendererPackageName: "react-dom"
};
var tl = {
  bundleType: sl.bundleType,
  version: sl.version,
  rendererPackageName: sl.rendererPackageName,
  rendererConfig: sl.rendererConfig,
  overrideHookState: null,
  overrideHookStateDeletePath: null,
  overrideHookStateRenamePath: null,
  overrideProps: null,
  overridePropsDeletePath: null,
  overridePropsRenamePath: null,
  setErrorHandler: null,
  setSuspenseHandler: null,
  scheduleUpdate: null,
  currentDispatcherRef: ta.ReactCurrentDispatcher,
  findHostInstanceByFiber: function findHostInstanceByFiber(a) {
    a = Yb(a);
    return null === a ? null : a.stateNode;
  },
  findFiberByHostInstance: sl.findFiberByHostInstance || il,
  findHostInstancesForRefresh: null,
  scheduleRefresh: null,
  scheduleRoot: null,
  setRefreshHandler: null,
  getCurrentFiber: null,
  reconcilerVersion: "18.1.0-next-22edb9f77-20220426"
};

if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
  var ul = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!ul.isDisabled && ul.supportsFiber) try {
    jc = ul.inject(tl), kc = ul;
  } catch (a) {}
}

var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = rl;

var createPortal = function createPortal(a, b) {
  var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
  if (!ml(b)) throw Error(p(200));
  return bl(a, b, null, c);
};

var createRoot = function createRoot(a, b) {
  if (!ml(a)) throw Error(p(299));
  var c = !1,
      d = "",
      e = jl;
  null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
  b = al(a, 1, !1, null, null, c, !1, d, e);
  a[tf] = b.current;
  rf(8 === a.nodeType ? a.parentNode : a);
  return new kl(b);
};

var findDOMNode = function findDOMNode(a) {
  if (null == a) return null;
  if (1 === a.nodeType) return a;
  var b = a._reactInternals;

  if (void 0 === b) {
    if ("function" === typeof a.render) throw Error(p(188));
    a = Object.keys(a).join(",");
    throw Error(p(268, a));
  }

  a = Yb(b);
  a = null === a ? null : a.stateNode;
  return a;
};

var flushSync = function flushSync(a) {
  return Qk(a);
};

var hydrate = function hydrate(a, b, c) {
  if (!nl(b)) throw Error(p(200));
  return ql(null, a, b, !0, c);
};

var hydrateRoot = function hydrateRoot(a, b, c) {
  if (!ml(a)) throw Error(p(405));
  var d = null != c && c.hydratedSources || null,
      e = !1,
      f = "",
      g = jl;
  null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
  b = dl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
  a[tf] = b.current;
  rf(a);
  if (d) for (a = 0; a < d.length; a++) {
    c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [c, e] : b.mutableSourceEagerHydrationData.push(c, e);
  }
  return new ll(b);
};

var render = function render(a, b, c) {
  if (!nl(b)) throw Error(p(200));
  return ql(null, a, b, !1, c);
};

var unmountComponentAtNode = function unmountComponentAtNode(a) {
  if (!nl(a)) throw Error(p(40));
  return a._reactRootContainer ? (Qk(function () {
    ql(null, null, a, !1, function () {
      a._reactRootContainer = null;
      a[tf] = null;
    });
  }), !0) : !1;
};

var unstable_batchedUpdates = Pk;

var unstable_renderSubtreeIntoContainer = function unstable_renderSubtreeIntoContainer(a, b, c, d) {
  if (!nl(c)) throw Error(p(200));
  if (null == a || void 0 === a._reactInternals) throw Error(p(38));
  return ql(a, b, c, !1, d);
};

var version = "18.1.0-next-22edb9f77-20220426";
var reactDom_production_min = {
  __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
  createPortal: createPortal,
  createRoot: createRoot,
  findDOMNode: findDOMNode,
  flushSync: flushSync,
  hydrate: hydrate,
  hydrateRoot: hydrateRoot,
  render: render,
  unmountComponentAtNode: unmountComponentAtNode,
  unstable_batchedUpdates: unstable_batchedUpdates,
  unstable_renderSubtreeIntoContainer: unstable_renderSubtreeIntoContainer,
  version: version
};

var reactDom_development = createCommonjsModule(function (module, exports) {

  if (process.env.NODE_ENV !== "production") {
    (function () {

      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      }

      var React = React__default;
      var Scheduler = scheduler;
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      var suppressWarning = false;

      function setSuppressWarning(newSuppressWarning) {
        {
          suppressWarning = newSuppressWarning;
        }
      }

      function warn(format) {
        {
          if (!suppressWarning) {
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }

            printWarning('warn', format, args);
          }
        }
      }

      function error(format) {
        {
          if (!suppressWarning) {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            printWarning('error', format, args);
          }
        }
      }

      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame.getStackAddendum();

          if (stack !== '') {
            format += '%s';
            args = args.concat([stack]);
          }

          var argsWithFormat = args.map(function (item) {
            return String(item);
          });
          argsWithFormat.unshift('Warning: ' + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }

      var FunctionComponent = 0;
      var ClassComponent = 1;
      var IndeterminateComponent = 2;
      var HostRoot = 3;
      var HostPortal = 4;
      var HostComponent = 5;
      var HostText = 6;
      var Fragment = 7;
      var Mode = 8;
      var ContextConsumer = 9;
      var ContextProvider = 10;
      var ForwardRef = 11;
      var Profiler = 12;
      var SuspenseComponent = 13;
      var MemoComponent = 14;
      var SimpleMemoComponent = 15;
      var LazyComponent = 16;
      var IncompleteClassComponent = 17;
      var DehydratedFragment = 18;
      var SuspenseListComponent = 19;
      var ScopeComponent = 21;
      var OffscreenComponent = 22;
      var LegacyHiddenComponent = 23;
      var CacheComponent = 24;
      var TracingMarkerComponent = 25;
      var enableClientRenderFallbackOnTextMismatch = true;
      var enableNewReconciler = false;
      var enableLazyContextPropagation = false;
      var enableLegacyHidden = false;
      var enableSuspenseAvoidThisFallback = false;
      var disableCommentsAsDOMContainers = true;
      var enableCustomElementPropertySupport = false;
      var warnAboutStringRefs = false;
      var enableSchedulingProfiler = true;
      var enableProfilerTimer = true;
      var enableProfilerCommitHooks = true;
      var allNativeEvents = new Set();
      var registrationNameDependencies = {};
      var possibleRegistrationNames = {};

      function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + 'Capture', dependencies);
      }

      function registerDirectEvent(registrationName, dependencies) {
        {
          if (registrationNameDependencies[registrationName]) {
            error('EventRegistry: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName);
          }
        }
        registrationNameDependencies[registrationName] = dependencies;
        {
          var lowerCasedName = registrationName.toLowerCase();
          possibleRegistrationNames[lowerCasedName] = registrationName;

          if (registrationName === 'onDoubleClick') {
            possibleRegistrationNames.ondblclick = registrationName;
          }
        }

        for (var i = 0; i < dependencies.length; i++) {
          allNativeEvents.add(dependencies[i]);
        }
      }

      var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
      var hasOwnProperty = Object.prototype.hasOwnProperty;

      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
          return type;
        }
      }

      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }

      function testStringCoercion(value) {
        return '' + value;
      }

      function checkAttributeStringCoercion(value, attributeName) {
        {
          if (willCoercionThrow(value)) {
            error('The provided `%s` attribute is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', attributeName, typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      function checkPropStringCoercion(value, propName) {
        {
          if (willCoercionThrow(value)) {
            error('The provided `%s` prop is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', propName, typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      function checkCSSPropertyStringCoercion(value, propName) {
        {
          if (willCoercionThrow(value)) {
            error('The provided `%s` CSS property is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', propName, typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      function checkHtmlStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error('The provided HTML markup uses a value of unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      function checkFormFieldValueStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error('Form field values (value, checked, defaultValue, or defaultChecked props)' + ' must be strings, not %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      var RESERVED = 0;
      var STRING = 1;
      var BOOLEANISH_STRING = 2;
      var BOOLEAN = 3;
      var OVERLOADED_BOOLEAN = 4;
      var NUMERIC = 5;
      var POSITIVE_NUMERIC = 6;
      var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
      var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
      var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
      var illegalAttributeNameCache = {};
      var validatedAttributeNameCache = {};

      function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) {
          return true;
        }

        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) {
          return false;
        }

        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
          validatedAttributeNameCache[attributeName] = true;
          return true;
        }

        illegalAttributeNameCache[attributeName] = true;
        {
          error('Invalid attribute name: `%s`', attributeName);
        }
        return false;
      }

      function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) {
          return propertyInfo.type === RESERVED;
        }

        if (isCustomComponentTag) {
          return false;
        }

        if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) {
          return true;
        }

        return false;
      }

      function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) {
          return false;
        }

        switch (typeof value) {
          case 'function':
          case 'symbol':
            return true;

          case 'boolean':
            {
              if (isCustomComponentTag) {
                return false;
              }

              if (propertyInfo !== null) {
                return !propertyInfo.acceptsBooleans;
              } else {
                var prefix = name.toLowerCase().slice(0, 5);
                return prefix !== 'data-' && prefix !== 'aria-';
              }
            }

          default:
            return false;
        }
      }

      function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === 'undefined') {
          return true;
        }

        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) {
          return true;
        }

        if (isCustomComponentTag) {
          return false;
        }

        if (propertyInfo !== null) {
          switch (propertyInfo.type) {
            case BOOLEAN:
              return !value;

            case OVERLOADED_BOOLEAN:
              return value === false;

            case NUMERIC:
              return isNaN(value);

            case POSITIVE_NUMERIC:
              return isNaN(value) || value < 1;
          }
        }

        return false;
      }

      function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
      }

      function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
      }

      var properties = {};
      var reservedProps = ['children', 'dangerouslySetInnerHTML', 'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
      reservedProps.forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
      });
      [['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
        var name = _ref[0],
            attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
      });
      ['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
      });
      ['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
      });
      ['allowFullScreen', 'async', 'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless', 'itemScope'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
      });
      ['checked', 'multiple', 'muted', 'selected'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
      });
      ['capture', 'download'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
      });
      ['cols', 'rows', 'size', 'span'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
      });
      ['rowSpan', 'start'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
      });
      var CAMELIZE = /[\-\:]([a-z])/g;

      var capitalize = function capitalize(token) {
        return token[1].toUpperCase();
      };

      ['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height'].forEach(function (attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
      });
      ['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type'].forEach(function (attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/1999/xlink', false, false);
      });
      ['xml:base', 'xml:lang', 'xml:space'].forEach(function (attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/XML/1998/namespace', false, false);
      });
      ['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
      });
      var xlinkHref = 'xlinkHref';
      properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, 'xlink:href', 'http://www.w3.org/1999/xlink', true, false);
      ['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
      });
      var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
      var didWarn = false;

      function sanitizeURL(url) {
        {
          if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error('A future version of React will block javascript: URLs as a security precaution. ' + 'Use event handlers instead if you can. If you need to generate unsafe HTML try ' + 'using dangerouslySetInnerHTML instead. React was passed %s.', JSON.stringify(url));
          }
        }
      }

      function getValueForProperty(node, name, expected, propertyInfo) {
        {
          if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
          } else {
            {
              checkAttributeStringCoercion(expected, name);
            }

            if (propertyInfo.sanitizeURL) {
              sanitizeURL('' + expected);
            }

            var attributeName = propertyInfo.attributeName;
            var stringValue = null;

            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
              if (node.hasAttribute(attributeName)) {
                var value = node.getAttribute(attributeName);

                if (value === '') {
                  return true;
                }

                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                  return value;
                }

                if (value === '' + expected) {
                  return expected;
                }

                return value;
              }
            } else if (node.hasAttribute(attributeName)) {
              if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                return node.getAttribute(attributeName);
              }

              if (propertyInfo.type === BOOLEAN) {
                return expected;
              }

              stringValue = node.getAttribute(attributeName);
            }

            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
              return stringValue === null ? expected : stringValue;
            } else if (stringValue === '' + expected) {
              return expected;
            } else {
              return stringValue;
            }
          }
        }
      }

      function getValueForAttribute(node, name, expected) {
        {
          if (!isAttributeNameSafe(name)) {
            return;
          }

          if (!node.hasAttribute(name)) {
            return expected === undefined ? undefined : null;
          }

          var value = node.getAttribute(name);
          {
            checkAttributeStringCoercion(expected, name);
          }

          if (value === '' + expected) {
            return expected;
          }

          return value;
        }
      }

      function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);

        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) {
          return;
        }

        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) {
          value = null;
        }

        if (isCustomComponentTag || propertyInfo === null) {
          if (isAttributeNameSafe(name)) {
            var _attributeName = name;

            if (value === null) {
              node.removeAttribute(_attributeName);
            } else {
              {
                checkAttributeStringCoercion(value, name);
              }
              node.setAttribute(_attributeName, '' + value);
            }
          }

          return;
        }

        var mustUseProperty = propertyInfo.mustUseProperty;

        if (mustUseProperty) {
          var propertyName = propertyInfo.propertyName;

          if (value === null) {
            var type = propertyInfo.type;
            node[propertyName] = type === BOOLEAN ? false : '';
          } else {
            node[propertyName] = value;
          }

          return;
        }

        var attributeName = propertyInfo.attributeName,
            attributeNamespace = propertyInfo.attributeNamespace;

        if (value === null) {
          node.removeAttribute(attributeName);
        } else {
          var _type = propertyInfo.type;
          var attributeValue;

          if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) {
            attributeValue = '';
          } else {
            {
              {
                checkAttributeStringCoercion(value, attributeName);
              }
              attributeValue = '' + value;
            }

            if (propertyInfo.sanitizeURL) {
              sanitizeURL(attributeValue.toString());
            }
          }

          if (attributeNamespace) {
            node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
          } else {
            node.setAttribute(attributeName, attributeValue);
          }
        }
      }

      var REACT_ELEMENT_TYPE = Symbol["for"]('react.element');
      var REACT_PORTAL_TYPE = Symbol["for"]('react.portal');
      var REACT_FRAGMENT_TYPE = Symbol["for"]('react.fragment');
      var REACT_STRICT_MODE_TYPE = Symbol["for"]('react.strict_mode');
      var REACT_PROFILER_TYPE = Symbol["for"]('react.profiler');
      var REACT_PROVIDER_TYPE = Symbol["for"]('react.provider');
      var REACT_CONTEXT_TYPE = Symbol["for"]('react.context');
      var REACT_FORWARD_REF_TYPE = Symbol["for"]('react.forward_ref');
      var REACT_SUSPENSE_TYPE = Symbol["for"]('react.suspense');
      var REACT_SUSPENSE_LIST_TYPE = Symbol["for"]('react.suspense_list');
      var REACT_MEMO_TYPE = Symbol["for"]('react.memo');
      var REACT_LAZY_TYPE = Symbol["for"]('react.lazy');
      var REACT_SCOPE_TYPE = Symbol["for"]('react.scope');
      var REACT_DEBUG_TRACING_MODE_TYPE = Symbol["for"]('react.debug_trace_mode');
      var REACT_OFFSCREEN_TYPE = Symbol["for"]('react.offscreen');
      var REACT_LEGACY_HIDDEN_TYPE = Symbol["for"]('react.legacy_hidden');
      var REACT_CACHE_TYPE = Symbol["for"]('react.cache');
      var REACT_TRACING_MARKER_TYPE = Symbol["for"]('react.tracing_marker');
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator';

      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') {
          return null;
        }

        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

        if (typeof maybeIterator === 'function') {
          return maybeIterator;
        }

        return null;
      }

      var assign = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;

      function disabledLog() {}

      disabledLog.__reactDisabledLog = true;

      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }

          disabledDepth++;
        }
      }

      function reenableLogs() {
        {
          disabledDepth--;

          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
          }

          if (disabledDepth < 0) {
            error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
          }
        }
      }

      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;

      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === undefined) {
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || '';
            }
          }

          return '\n' + prefix + name;
        }
      }

      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }

      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return '';
        }

        {
          var frame = componentFrameCache.get(fn);

          if (frame !== undefined) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }

        try {
          if (construct) {
            var Fake = function Fake() {
              throw Error();
            };

            Object.defineProperty(Fake.prototype, 'props', {
              set: function set() {
                throw Error();
              }
            });

            if (typeof Reflect === 'object' && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }

              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }

              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }

            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === 'string') {
            var sampleLines = sample.stack.split('\n');
            var controlLines = control.stack.split('\n');
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;

            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              c--;
            }

            for (; s >= 1 && c >= 0; s--, c--) {
              if (sampleLines[s] !== controlLines[c]) {
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--;

                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                      if (fn.displayName && _frame.includes('<anonymous>')) {
                        _frame = _frame.replace('<anonymous>', fn.displayName);
                      }

                      {
                        if (typeof fn === 'function') {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }

                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }

        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        {
          if (typeof fn === 'function') {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }

      function describeClassComponentFrame(ctor, source, ownerFn) {
        {
          return describeNativeComponentFrame(ctor, true);
        }
      }

      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }

      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }

      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return '';
        }

        if (typeof type === 'function') {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }

        if (typeof type === 'string') {
          return describeBuiltInComponentFrame(type);
        }

        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame('Suspense');

          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame('SuspenseList');
        }

        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);

            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
              }
          }
        }

        return '';
      }

      function describeFiber(fiber) {

        switch (fiber.tag) {
          case HostComponent:
            return describeBuiltInComponentFrame(fiber.type);

          case LazyComponent:
            return describeBuiltInComponentFrame('Lazy');

          case SuspenseComponent:
            return describeBuiltInComponentFrame('Suspense');

          case SuspenseListComponent:
            return describeBuiltInComponentFrame('SuspenseList');

          case FunctionComponent:
          case IndeterminateComponent:
          case SimpleMemoComponent:
            return describeFunctionComponentFrame(fiber.type);

          case ForwardRef:
            return describeFunctionComponentFrame(fiber.type.render);

          case ClassComponent:
            return describeClassComponentFrame(fiber.type);

          default:
            return '';
        }
      }

      function getStackByFiberInDevAndProd(workInProgress) {
        try {
          var info = '';
          var node = workInProgress;

          do {
            info += describeFiber(node);
            node = node["return"];
          } while (node);

          return info;
        } catch (x) {
          return '\nError generating stack: ' + x.message + '\n' + x.stack;
        }
      }

      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;

        if (displayName) {
          return displayName;
        }

        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
      }

      function getContextName(type) {
        return type.displayName || 'Context';
      }

      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }

        {
          if (typeof type.tag === 'number') {
            error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
          }
        }

        if (typeof type === 'function') {
          return type.displayName || type.name || null;
        }

        if (typeof type === 'string') {
          return type;
        }

        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return 'Fragment';

          case REACT_PORTAL_TYPE:
            return 'Portal';

          case REACT_PROFILER_TYPE:
            return 'Profiler';

          case REACT_STRICT_MODE_TYPE:
            return 'StrictMode';

          case REACT_SUSPENSE_TYPE:
            return 'Suspense';

          case REACT_SUSPENSE_LIST_TYPE:
            return 'SuspenseList';
        }

        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + '.Consumer';

            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + '.Provider';

            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, 'ForwardRef');

            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;

              if (outerName !== null) {
                return outerName;
              }

              return getComponentNameFromType(type.type) || 'Memo';

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  return getComponentNameFromType(init(payload));
                } catch (x) {
                  return null;
                }
              }
          }
        }

        return null;
      }

      function getWrappedName$1(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
      }

      function getContextName$1(type) {
        return type.displayName || 'Context';
      }

      function getComponentNameFromFiber(fiber) {
        var tag = fiber.tag,
            type = fiber.type;

        switch (tag) {
          case CacheComponent:
            return 'Cache';

          case ContextConsumer:
            var context = type;
            return getContextName$1(context) + '.Consumer';

          case ContextProvider:
            var provider = type;
            return getContextName$1(provider._context) + '.Provider';

          case DehydratedFragment:
            return 'DehydratedFragment';

          case ForwardRef:
            return getWrappedName$1(type, type.render, 'ForwardRef');

          case Fragment:
            return 'Fragment';

          case HostComponent:
            return type;

          case HostPortal:
            return 'Portal';

          case HostRoot:
            return 'Root';

          case HostText:
            return 'Text';

          case LazyComponent:
            return getComponentNameFromType(type);

          case Mode:
            if (type === REACT_STRICT_MODE_TYPE) {
              return 'StrictMode';
            }

            return 'Mode';

          case OffscreenComponent:
            return 'Offscreen';

          case Profiler:
            return 'Profiler';

          case ScopeComponent:
            return 'Scope';

          case SuspenseComponent:
            return 'Suspense';

          case SuspenseListComponent:
            return 'SuspenseList';

          case TracingMarkerComponent:
            return 'TracingMarker';

          case ClassComponent:
          case FunctionComponent:
          case IncompleteClassComponent:
          case IndeterminateComponent:
          case MemoComponent:
          case SimpleMemoComponent:
            if (typeof type === 'function') {
              return type.displayName || type.name || null;
            }

            if (typeof type === 'string') {
              return type;
            }

            break;
        }

        return null;
      }

      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      var current = null;
      var isRendering = false;

      function getCurrentFiberOwnerNameInDevOrNull() {
        {
          if (current === null) {
            return null;
          }

          var owner = current._debugOwner;

          if (owner !== null && typeof owner !== 'undefined') {
            return getComponentNameFromFiber(owner);
          }
        }
        return null;
      }

      function getCurrentFiberStackInDev() {
        {
          if (current === null) {
            return '';
          }

          return getStackByFiberInDevAndProd(current);
        }
      }

      function resetCurrentFiber() {
        {
          ReactDebugCurrentFrame.getCurrentStack = null;
          current = null;
          isRendering = false;
        }
      }

      function setCurrentFiber(fiber) {
        {
          ReactDebugCurrentFrame.getCurrentStack = fiber === null ? null : getCurrentFiberStackInDev;
          current = fiber;
          isRendering = false;
        }
      }

      function getCurrentFiber() {
        {
          return current;
        }
      }

      function setIsRendering(rendering) {
        {
          isRendering = rendering;
        }
      }

      function toString(value) {
        return '' + value;
      }

      function getToStringValue(value) {
        switch (typeof value) {
          case 'boolean':
          case 'number':
          case 'string':
          case 'undefined':
            return value;

          case 'object':
            {
              checkFormFieldValueStringCoercion(value);
            }
            return value;

          default:
            return '';
        }
      }

      var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
      };

      function checkControlledValueProps(tagName, props) {
        {
          if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) {
            error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
          }

          if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) {
            error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
          }
        }
      }

      function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
      }

      function getTracker(node) {
        return node._valueTracker;
      }

      function detachTracker(node) {
        node._valueTracker = null;
      }

      function getValueFromNode(node) {
        var value = '';

        if (!node) {
          return value;
        }

        if (isCheckable(node)) {
          value = node.checked ? 'true' : 'false';
        } else {
          value = node.value;
        }

        return value;
      }

      function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? 'checked' : 'value';
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        {
          checkFormFieldValueStringCoercion(node[valueField]);
        }
        var currentValue = '' + node[valueField];

        if (node.hasOwnProperty(valueField) || typeof descriptor === 'undefined' || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
          return;
        }

        var _get = descriptor.get,
            _set = descriptor.set;
        Object.defineProperty(node, valueField, {
          configurable: true,
          get: function get() {
            return _get.call(this);
          },
          set: function set(value) {
            {
              checkFormFieldValueStringCoercion(value);
            }
            currentValue = '' + value;

            _set.call(this, value);
          }
        });
        Object.defineProperty(node, valueField, {
          enumerable: descriptor.enumerable
        });
        var tracker = {
          getValue: function getValue() {
            return currentValue;
          },
          setValue: function setValue(value) {
            {
              checkFormFieldValueStringCoercion(value);
            }
            currentValue = '' + value;
          },
          stopTracking: function stopTracking() {
            detachTracker(node);
            delete node[valueField];
          }
        };
        return tracker;
      }

      function track(node) {
        if (getTracker(node)) {
          return;
        }

        node._valueTracker = trackValueOnNode(node);
      }

      function updateValueIfChanged(node) {
        if (!node) {
          return false;
        }

        var tracker = getTracker(node);

        if (!tracker) {
          return true;
        }

        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);

        if (nextValue !== lastValue) {
          tracker.setValue(nextValue);
          return true;
        }

        return false;
      }

      function getActiveElement(doc) {
        doc = doc || (typeof document !== 'undefined' ? document : undefined);

        if (typeof doc === 'undefined') {
          return null;
        }

        try {
          return doc.activeElement || doc.body;
        } catch (e) {
          return doc.body;
        }
      }

      var didWarnValueDefaultValue = false;
      var didWarnCheckedDefaultChecked = false;
      var didWarnControlledToUncontrolled = false;
      var didWarnUncontrolledToControlled = false;

      function isControlled(props) {
        var usesChecked = props.type === 'checkbox' || props.type === 'radio';
        return usesChecked ? props.checked != null : props.value != null;
      }

      function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = assign({}, props, {
          defaultChecked: undefined,
          defaultValue: undefined,
          value: undefined,
          checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
      }

      function initWrapperState(element, props) {
        {
          checkControlledValueProps('input', props);

          if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error('%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnCheckedDefaultChecked = true;
          }

          if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error('%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnValueDefaultValue = true;
          }
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? '' : props.defaultValue;
        node._wrapperState = {
          initialChecked: props.checked != null ? props.checked : props.defaultChecked,
          initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
          controlled: isControlled(props)
        };
      }

      function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;

        if (checked != null) {
          setValueForProperty(node, 'checked', checked, false);
        }
      }

      function updateWrapper(element, props) {
        var node = element;
        {
          var controlled = isControlled(props);

          if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error('A component is changing an uncontrolled input to be controlled. ' + 'This is likely caused by the value changing from undefined to ' + 'a defined value, which should not happen. ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components');
            didWarnUncontrolledToControlled = true;
          }

          if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error('A component is changing a controlled input to be uncontrolled. ' + 'This is likely caused by the value changing from a defined to ' + 'undefined, which should not happen. ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components');
            didWarnControlledToUncontrolled = true;
          }
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;

        if (value != null) {
          if (type === 'number') {
            if (value === 0 && node.value === '' || node.value != value) {
              node.value = toString(value);
            }
          } else if (node.value !== toString(value)) {
            node.value = toString(value);
          }
        } else if (type === 'submit' || type === 'reset') {
          node.removeAttribute('value');
          return;
        }

        {
          if (props.hasOwnProperty('value')) {
            setDefaultValue(node, props.type, value);
          } else if (props.hasOwnProperty('defaultValue')) {
            setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
          }
        }
        {
          if (props.checked == null && props.defaultChecked != null) {
            node.defaultChecked = !!props.defaultChecked;
          }
        }
      }

      function postMountWrapper(element, props, isHydrating) {
        var node = element;

        if (props.hasOwnProperty('value') || props.hasOwnProperty('defaultValue')) {
          var type = props.type;
          var isButton = type === 'submit' || type === 'reset';

          if (isButton && (props.value === undefined || props.value === null)) {
            return;
          }

          var initialValue = toString(node._wrapperState.initialValue);

          if (!isHydrating) {
            {
              if (initialValue !== node.value) {
                node.value = initialValue;
              }
            }
          }

          {
            node.defaultValue = initialValue;
          }
        }

        var name = node.name;

        if (name !== '') {
          node.name = '';
        }

        {
          node.defaultChecked = !node.defaultChecked;
          node.defaultChecked = !!node._wrapperState.initialChecked;
        }

        if (name !== '') {
          node.name = name;
        }
      }

      function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
      }

      function updateNamedCousins(rootNode, props) {
        var name = props.name;

        if (props.type === 'radio' && name != null) {
          var queryRoot = rootNode;

          while (queryRoot.parentNode) {
            queryRoot = queryRoot.parentNode;
          }

          {
            checkAttributeStringCoercion(name, 'name');
          }
          var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

          for (var i = 0; i < group.length; i++) {
            var otherNode = group[i];

            if (otherNode === rootNode || otherNode.form !== rootNode.form) {
              continue;
            }

            var otherProps = getFiberCurrentPropsFromNode(otherNode);

            if (!otherProps) {
              throw new Error('ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.');
            }

            updateValueIfChanged(otherNode);
            updateWrapper(otherNode, otherProps);
          }
        }
      }

      function setDefaultValue(node, type, value) {
        if (type !== 'number' || getActiveElement(node.ownerDocument) !== node) {
          if (value == null) {
            node.defaultValue = toString(node._wrapperState.initialValue);
          } else if (node.defaultValue !== toString(value)) {
            node.defaultValue = toString(value);
          }
        }
      }

      var didWarnSelectedSetOnOption = false;
      var didWarnInvalidChild = false;
      var didWarnInvalidInnerHTML = false;

      function validateProps(element, props) {
        {
          if (props.value == null) {
            if (typeof props.children === 'object' && props.children !== null) {
              React.Children.forEach(props.children, function (child) {
                if (child == null) {
                  return;
                }

                if (typeof child === 'string' || typeof child === 'number') {
                  return;
                }

                if (!didWarnInvalidChild) {
                  didWarnInvalidChild = true;
                  error('Cannot infer the option value of complex children. ' + 'Pass a `value` prop or use a plain string as children to <option>.');
                }
              });
            } else if (props.dangerouslySetInnerHTML != null) {
              if (!didWarnInvalidInnerHTML) {
                didWarnInvalidInnerHTML = true;
                error('Pass a `value` prop if you set dangerouslyInnerHTML so React knows ' + 'which value should be selected.');
              }
            }
          }

          if (props.selected != null && !didWarnSelectedSetOnOption) {
            error('Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.');
            didWarnSelectedSetOnOption = true;
          }
        }
      }

      function postMountWrapper$1(element, props) {
        if (props.value != null) {
          element.setAttribute('value', toString(getToStringValue(props.value)));
        }
      }

      var isArrayImpl = Array.isArray;

      function isArray(a) {
        return isArrayImpl(a);
      }

      var didWarnValueDefaultValue$1;
      {
        didWarnValueDefaultValue$1 = false;
      }

      function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();

        if (ownerName) {
          return '\n\nCheck the render method of `' + ownerName + '`.';
        }

        return '';
      }

      var valuePropNames = ['value', 'defaultValue'];

      function checkSelectPropTypes(props) {
        {
          checkControlledValueProps('select', props);

          for (var i = 0; i < valuePropNames.length; i++) {
            var propName = valuePropNames[i];

            if (props[propName] == null) {
              continue;
            }

            var propNameIsArray = isArray(props[propName]);

            if (props.multiple && !propNameIsArray) {
              error('The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum());
            } else if (!props.multiple && propNameIsArray) {
              error('The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum());
            }
          }
        }
      }

      function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;

        if (multiple) {
          var selectedValues = propValue;
          var selectedValue = {};

          for (var i = 0; i < selectedValues.length; i++) {
            selectedValue['$' + selectedValues[i]] = true;
          }

          for (var _i = 0; _i < options.length; _i++) {
            var selected = selectedValue.hasOwnProperty('$' + options[_i].value);

            if (options[_i].selected !== selected) {
              options[_i].selected = selected;
            }

            if (selected && setDefaultSelected) {
              options[_i].defaultSelected = true;
            }
          }
        } else {
          var _selectedValue = toString(getToStringValue(propValue));

          var defaultSelected = null;

          for (var _i2 = 0; _i2 < options.length; _i2++) {
            if (options[_i2].value === _selectedValue) {
              options[_i2].selected = true;

              if (setDefaultSelected) {
                options[_i2].defaultSelected = true;
              }

              return;
            }

            if (defaultSelected === null && !options[_i2].disabled) {
              defaultSelected = options[_i2];
            }
          }

          if (defaultSelected !== null) {
            defaultSelected.selected = true;
          }
        }
      }

      function getHostProps$1(element, props) {
        return assign({}, props, {
          value: undefined
        });
      }

      function initWrapperState$1(element, props) {
        var node = element;
        {
          checkSelectPropTypes(props);
        }
        node._wrapperState = {
          wasMultiple: !!props.multiple
        };
        {
          if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error('Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components');
            didWarnValueDefaultValue$1 = true;
          }
        }
      }

      function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;

        if (value != null) {
          updateOptions(node, !!props.multiple, value, false);
        } else if (props.defaultValue != null) {
          updateOptions(node, !!props.multiple, props.defaultValue, true);
        }
      }

      function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;

        if (value != null) {
          updateOptions(node, !!props.multiple, value, false);
        } else if (wasMultiple !== !!props.multiple) {
          if (props.defaultValue != null) {
            updateOptions(node, !!props.multiple, props.defaultValue, true);
          } else {
            updateOptions(node, !!props.multiple, props.multiple ? [] : '', false);
          }
        }
      }

      function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;

        if (value != null) {
          updateOptions(node, !!props.multiple, value, false);
        }
      }

      var didWarnValDefaultVal = false;

      function getHostProps$2(element, props) {
        var node = element;

        if (props.dangerouslySetInnerHTML != null) {
          throw new Error('`dangerouslySetInnerHTML` does not make sense on <textarea>.');
        }

        var hostProps = assign({}, props, {
          value: undefined,
          defaultValue: undefined,
          children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
      }

      function initWrapperState$2(element, props) {
        var node = element;
        {
          checkControlledValueProps('textarea', props);

          if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error('%s contains a textarea with both value and defaultValue props. ' + 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component');
            didWarnValDefaultVal = true;
          }
        }
        var initialValue = props.value;

        if (initialValue == null) {
          var children = props.children,
              defaultValue = props.defaultValue;

          if (children != null) {
            {
              error('Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.');
            }
            {
              if (defaultValue != null) {
                throw new Error('If you supply `defaultValue` on a <textarea>, do not pass children.');
              }

              if (isArray(children)) {
                if (children.length > 1) {
                  throw new Error('<textarea> can only have at most one child.');
                }

                children = children[0];
              }

              defaultValue = children;
            }
          }

          if (defaultValue == null) {
            defaultValue = '';
          }

          initialValue = defaultValue;
        }

        node._wrapperState = {
          initialValue: getToStringValue(initialValue)
        };
      }

      function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);

        if (value != null) {
          var newValue = toString(value);

          if (newValue !== node.value) {
            node.value = newValue;
          }

          if (props.defaultValue == null && node.defaultValue !== newValue) {
            node.defaultValue = newValue;
          }
        }

        if (defaultValue != null) {
          node.defaultValue = toString(defaultValue);
        }
      }

      function postMountWrapper$3(element, props) {
        var node = element;
        var textContent = node.textContent;

        if (textContent === node._wrapperState.initialValue) {
          if (textContent !== '' && textContent !== null) {
            node.value = textContent;
          }
        }
      }

      function restoreControlledState$2(element, props) {
        updateWrapper$1(element, props);
      }

      var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
      var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
      var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';

      function getIntrinsicNamespace(type) {
        switch (type) {
          case 'svg':
            return SVG_NAMESPACE;

          case 'math':
            return MATH_NAMESPACE;

          default:
            return HTML_NAMESPACE;
        }
      }

      function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) {
          return getIntrinsicNamespace(type);
        }

        if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') {
          return HTML_NAMESPACE;
        }

        return parentNamespace;
      }

      var createMicrosoftUnsafeLocalFunction = function createMicrosoftUnsafeLocalFunction(func) {
        if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
          return function (arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function () {
              return func(arg0, arg1, arg2, arg3);
            });
          };
        } else {
          return func;
        }
      };

      var reusableSVGContainer;
      var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
        if (node.namespaceURI === SVG_NAMESPACE) {
          if (!('innerHTML' in node)) {
            reusableSVGContainer = reusableSVGContainer || document.createElement('div');
            reusableSVGContainer.innerHTML = '<svg>' + html.valueOf().toString() + '</svg>';
            var svgNode = reusableSVGContainer.firstChild;

            while (node.firstChild) {
              node.removeChild(node.firstChild);
            }

            while (svgNode.firstChild) {
              node.appendChild(svgNode.firstChild);
            }

            return;
          }
        }

        node.innerHTML = html;
      });
      var ELEMENT_NODE = 1;
      var TEXT_NODE = 3;
      var COMMENT_NODE = 8;
      var DOCUMENT_NODE = 9;
      var DOCUMENT_FRAGMENT_NODE = 11;

      var setTextContent = function setTextContent(node, text) {
        if (text) {
          var firstChild = node.firstChild;

          if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
            firstChild.nodeValue = text;
            return;
          }
        }

        node.textContent = text;
      };

      var shorthandToLonghand = {
        animation: ['animationDelay', 'animationDirection', 'animationDuration', 'animationFillMode', 'animationIterationCount', 'animationName', 'animationPlayState', 'animationTimingFunction'],
        background: ['backgroundAttachment', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundSize'],
        backgroundPosition: ['backgroundPositionX', 'backgroundPositionY'],
        border: ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderTopColor', 'borderTopStyle', 'borderTopWidth'],
        borderBlockEnd: ['borderBlockEndColor', 'borderBlockEndStyle', 'borderBlockEndWidth'],
        borderBlockStart: ['borderBlockStartColor', 'borderBlockStartStyle', 'borderBlockStartWidth'],
        borderBottom: ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth'],
        borderColor: ['borderBottomColor', 'borderLeftColor', 'borderRightColor', 'borderTopColor'],
        borderImage: ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
        borderInlineEnd: ['borderInlineEndColor', 'borderInlineEndStyle', 'borderInlineEndWidth'],
        borderInlineStart: ['borderInlineStartColor', 'borderInlineStartStyle', 'borderInlineStartWidth'],
        borderLeft: ['borderLeftColor', 'borderLeftStyle', 'borderLeftWidth'],
        borderRadius: ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
        borderRight: ['borderRightColor', 'borderRightStyle', 'borderRightWidth'],
        borderStyle: ['borderBottomStyle', 'borderLeftStyle', 'borderRightStyle', 'borderTopStyle'],
        borderTop: ['borderTopColor', 'borderTopStyle', 'borderTopWidth'],
        borderWidth: ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth'],
        columnRule: ['columnRuleColor', 'columnRuleStyle', 'columnRuleWidth'],
        columns: ['columnCount', 'columnWidth'],
        flex: ['flexBasis', 'flexGrow', 'flexShrink'],
        flexFlow: ['flexDirection', 'flexWrap'],
        font: ['fontFamily', 'fontFeatureSettings', 'fontKerning', 'fontLanguageOverride', 'fontSize', 'fontSizeAdjust', 'fontStretch', 'fontStyle', 'fontVariant', 'fontVariantAlternates', 'fontVariantCaps', 'fontVariantEastAsian', 'fontVariantLigatures', 'fontVariantNumeric', 'fontVariantPosition', 'fontWeight', 'lineHeight'],
        fontVariant: ['fontVariantAlternates', 'fontVariantCaps', 'fontVariantEastAsian', 'fontVariantLigatures', 'fontVariantNumeric', 'fontVariantPosition'],
        gap: ['columnGap', 'rowGap'],
        grid: ['gridAutoColumns', 'gridAutoFlow', 'gridAutoRows', 'gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows'],
        gridArea: ['gridColumnEnd', 'gridColumnStart', 'gridRowEnd', 'gridRowStart'],
        gridColumn: ['gridColumnEnd', 'gridColumnStart'],
        gridColumnGap: ['columnGap'],
        gridGap: ['columnGap', 'rowGap'],
        gridRow: ['gridRowEnd', 'gridRowStart'],
        gridRowGap: ['rowGap'],
        gridTemplate: ['gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows'],
        listStyle: ['listStyleImage', 'listStylePosition', 'listStyleType'],
        margin: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
        marker: ['markerEnd', 'markerMid', 'markerStart'],
        mask: ['maskClip', 'maskComposite', 'maskImage', 'maskMode', 'maskOrigin', 'maskPositionX', 'maskPositionY', 'maskRepeat', 'maskSize'],
        maskPosition: ['maskPositionX', 'maskPositionY'],
        outline: ['outlineColor', 'outlineStyle', 'outlineWidth'],
        overflow: ['overflowX', 'overflowY'],
        padding: ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
        placeContent: ['alignContent', 'justifyContent'],
        placeItems: ['alignItems', 'justifyItems'],
        placeSelf: ['alignSelf', 'justifySelf'],
        textDecoration: ['textDecorationColor', 'textDecorationLine', 'textDecorationStyle'],
        textEmphasis: ['textEmphasisColor', 'textEmphasisStyle'],
        transition: ['transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction'],
        wordWrap: ['overflowWrap']
      };
      var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
      };

      function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
      }

      var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
      Object.keys(isUnitlessNumber).forEach(function (prop) {
        prefixes.forEach(function (prefix) {
          isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
      });

      function dangerousStyleValue(name, value, isCustomProperty) {
        var isEmpty = value == null || typeof value === 'boolean' || value === '';

        if (isEmpty) {
          return '';
        }

        if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) {
          return value + 'px';
        }

        {
          checkCSSPropertyStringCoercion(value, name);
        }
        return ('' + value).trim();
      }

      var uppercasePattern = /([A-Z])/g;
      var msPattern = /^ms-/;

      function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
      }

      var warnValidStyle = function warnValidStyle() {};

      {
        var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
        var msPattern$1 = /^-ms-/;
        var hyphenPattern = /-(.)/g;
        var badStyleValueWithSemicolonPattern = /;\s*$/;
        var warnedStyleNames = {};
        var warnedStyleValues = {};
        var warnedForNaNValue = false;
        var warnedForInfinityValue = false;

        var camelize = function camelize(string) {
          return string.replace(hyphenPattern, function (_, character) {
            return character.toUpperCase();
          });
        };

        var warnHyphenatedStyleName = function warnHyphenatedStyleName(name) {
          if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
            return;
          }

          warnedStyleNames[name] = true;
          error('Unsupported style property %s. Did you mean %s?', name, camelize(name.replace(msPattern$1, 'ms-')));
        };

        var warnBadVendoredStyleName = function warnBadVendoredStyleName(name) {
          if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
            return;
          }

          warnedStyleNames[name] = true;
          error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
        };

        var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value) {
          if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
            return;
          }

          warnedStyleValues[value] = true;
          error("Style property values shouldn't contain a semicolon. " + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
        };

        var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value) {
          if (warnedForNaNValue) {
            return;
          }

          warnedForNaNValue = true;
          error('`NaN` is an invalid value for the `%s` css style property.', name);
        };

        var warnStyleValueIsInfinity = function warnStyleValueIsInfinity(name, value) {
          if (warnedForInfinityValue) {
            return;
          }

          warnedForInfinityValue = true;
          error('`Infinity` is an invalid value for the `%s` css style property.', name);
        };

        warnValidStyle = function warnValidStyle(name, value) {
          if (name.indexOf('-') > -1) {
            warnHyphenatedStyleName(name);
          } else if (badVendoredStyleNamePattern.test(name)) {
            warnBadVendoredStyleName(name);
          } else if (badStyleValueWithSemicolonPattern.test(value)) {
            warnStyleValueWithSemicolon(name, value);
          }

          if (typeof value === 'number') {
            if (isNaN(value)) {
              warnStyleValueIsNaN(name, value);
            } else if (!isFinite(value)) {
              warnStyleValueIsInfinity(name, value);
            }
          }
        };
      }
      var warnValidStyle$1 = warnValidStyle;

      function createDangerousStringForStyles(styles) {
        {
          var serialized = '';
          var delimiter = '';

          for (var styleName in styles) {
            if (!styles.hasOwnProperty(styleName)) {
              continue;
            }

            var styleValue = styles[styleName];

            if (styleValue != null) {
              var isCustomProperty = styleName.indexOf('--') === 0;
              serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ':';
              serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
              delimiter = ';';
            }
          }

          return serialized || null;
        }
      }

      function setValueForStyles(node, styles) {
        var style = node.style;

        for (var styleName in styles) {
          if (!styles.hasOwnProperty(styleName)) {
            continue;
          }

          var isCustomProperty = styleName.indexOf('--') === 0;
          {
            if (!isCustomProperty) {
              warnValidStyle$1(styleName, styles[styleName]);
            }
          }
          var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);

          if (styleName === 'float') {
            styleName = 'cssFloat';
          }

          if (isCustomProperty) {
            style.setProperty(styleName, styleValue);
          } else {
            style[styleName] = styleValue;
          }
        }
      }

      function isValueEmpty(value) {
        return value == null || typeof value === 'boolean' || value === '';
      }

      function expandShorthandMap(styles) {
        var expanded = {};

        for (var key in styles) {
          var longhands = shorthandToLonghand[key] || [key];

          for (var i = 0; i < longhands.length; i++) {
            expanded[longhands[i]] = key;
          }
        }

        return expanded;
      }

      function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        {
          if (!nextStyles) {
            return;
          }

          var expandedUpdates = expandShorthandMap(styleUpdates);
          var expandedStyles = expandShorthandMap(nextStyles);
          var warnedAbout = {};

          for (var key in expandedUpdates) {
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];

            if (correctOriginalKey && originalKey !== correctOriginalKey) {
              var warningKey = originalKey + ',' + correctOriginalKey;

              if (warnedAbout[warningKey]) {
                continue;
              }

              warnedAbout[warningKey] = true;
              error('%s a style property during rerender (%s) when a ' + 'conflicting property is set (%s) can lead to styling bugs. To ' + "avoid this, don't mix shorthand and non-shorthand properties " + 'for the same value; instead, replace the shorthand with ' + 'separate values.', isValueEmpty(styleUpdates[originalKey]) ? 'Removing' : 'Updating', originalKey, correctOriginalKey);
            }
          }
        }
      }

      var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true
      };
      var voidElementTags = assign({
        menuitem: true
      }, omittedCloseTags);
      var HTML = '__html';

      function assertValidProps(tag, props) {
        if (!props) {
          return;
        }

        if (voidElementTags[tag]) {
          if (props.children != null || props.dangerouslySetInnerHTML != null) {
            throw new Error(tag + " is a void element tag and must neither have `children` nor " + 'use `dangerouslySetInnerHTML`.');
          }
        }

        if (props.dangerouslySetInnerHTML != null) {
          if (props.children != null) {
            throw new Error('Can only set one of `children` or `props.dangerouslySetInnerHTML`.');
          }

          if (typeof props.dangerouslySetInnerHTML !== 'object' || !(HTML in props.dangerouslySetInnerHTML)) {
            throw new Error('`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://reactjs.org/link/dangerously-set-inner-html ' + 'for more information.');
          }
        }

        {
          if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
            error('A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.');
          }
        }

        if (props.style != null && typeof props.style !== 'object') {
          throw new Error('The `style` prop expects a mapping from style properties to values, ' + "not a string. For example, style={{marginRight: spacing + 'em'}} when " + 'using JSX.');
        }
      }

      function isCustomComponent(tagName, props) {
        if (tagName.indexOf('-') === -1) {
          return typeof props.is === 'string';
        }

        switch (tagName) {
          case 'annotation-xml':
          case 'color-profile':
          case 'font-face':
          case 'font-face-src':
          case 'font-face-uri':
          case 'font-face-format':
          case 'font-face-name':
          case 'missing-glyph':
            return false;

          default:
            return true;
        }
      }

      var possibleStandardNames = {
        accept: 'accept',
        acceptcharset: 'acceptCharset',
        'accept-charset': 'acceptCharset',
        accesskey: 'accessKey',
        action: 'action',
        allowfullscreen: 'allowFullScreen',
        alt: 'alt',
        as: 'as',
        async: 'async',
        autocapitalize: 'autoCapitalize',
        autocomplete: 'autoComplete',
        autocorrect: 'autoCorrect',
        autofocus: 'autoFocus',
        autoplay: 'autoPlay',
        autosave: 'autoSave',
        capture: 'capture',
        cellpadding: 'cellPadding',
        cellspacing: 'cellSpacing',
        challenge: 'challenge',
        charset: 'charSet',
        checked: 'checked',
        children: 'children',
        cite: 'cite',
        "class": 'className',
        classid: 'classID',
        classname: 'className',
        cols: 'cols',
        colspan: 'colSpan',
        content: 'content',
        contenteditable: 'contentEditable',
        contextmenu: 'contextMenu',
        controls: 'controls',
        controlslist: 'controlsList',
        coords: 'coords',
        crossorigin: 'crossOrigin',
        dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
        data: 'data',
        datetime: 'dateTime',
        "default": 'default',
        defaultchecked: 'defaultChecked',
        defaultvalue: 'defaultValue',
        defer: 'defer',
        dir: 'dir',
        disabled: 'disabled',
        disablepictureinpicture: 'disablePictureInPicture',
        disableremoteplayback: 'disableRemotePlayback',
        download: 'download',
        draggable: 'draggable',
        enctype: 'encType',
        enterkeyhint: 'enterKeyHint',
        "for": 'htmlFor',
        form: 'form',
        formmethod: 'formMethod',
        formaction: 'formAction',
        formenctype: 'formEncType',
        formnovalidate: 'formNoValidate',
        formtarget: 'formTarget',
        frameborder: 'frameBorder',
        headers: 'headers',
        height: 'height',
        hidden: 'hidden',
        high: 'high',
        href: 'href',
        hreflang: 'hrefLang',
        htmlfor: 'htmlFor',
        httpequiv: 'httpEquiv',
        'http-equiv': 'httpEquiv',
        icon: 'icon',
        id: 'id',
        imagesizes: 'imageSizes',
        imagesrcset: 'imageSrcSet',
        innerhtml: 'innerHTML',
        inputmode: 'inputMode',
        integrity: 'integrity',
        is: 'is',
        itemid: 'itemID',
        itemprop: 'itemProp',
        itemref: 'itemRef',
        itemscope: 'itemScope',
        itemtype: 'itemType',
        keyparams: 'keyParams',
        keytype: 'keyType',
        kind: 'kind',
        label: 'label',
        lang: 'lang',
        list: 'list',
        loop: 'loop',
        low: 'low',
        manifest: 'manifest',
        marginwidth: 'marginWidth',
        marginheight: 'marginHeight',
        max: 'max',
        maxlength: 'maxLength',
        media: 'media',
        mediagroup: 'mediaGroup',
        method: 'method',
        min: 'min',
        minlength: 'minLength',
        multiple: 'multiple',
        muted: 'muted',
        name: 'name',
        nomodule: 'noModule',
        nonce: 'nonce',
        novalidate: 'noValidate',
        open: 'open',
        optimum: 'optimum',
        pattern: 'pattern',
        placeholder: 'placeholder',
        playsinline: 'playsInline',
        poster: 'poster',
        preload: 'preload',
        profile: 'profile',
        radiogroup: 'radioGroup',
        readonly: 'readOnly',
        referrerpolicy: 'referrerPolicy',
        rel: 'rel',
        required: 'required',
        reversed: 'reversed',
        role: 'role',
        rows: 'rows',
        rowspan: 'rowSpan',
        sandbox: 'sandbox',
        scope: 'scope',
        scoped: 'scoped',
        scrolling: 'scrolling',
        seamless: 'seamless',
        selected: 'selected',
        shape: 'shape',
        size: 'size',
        sizes: 'sizes',
        span: 'span',
        spellcheck: 'spellCheck',
        src: 'src',
        srcdoc: 'srcDoc',
        srclang: 'srcLang',
        srcset: 'srcSet',
        start: 'start',
        step: 'step',
        style: 'style',
        summary: 'summary',
        tabindex: 'tabIndex',
        target: 'target',
        title: 'title',
        type: 'type',
        usemap: 'useMap',
        value: 'value',
        width: 'width',
        wmode: 'wmode',
        wrap: 'wrap',
        about: 'about',
        accentheight: 'accentHeight',
        'accent-height': 'accentHeight',
        accumulate: 'accumulate',
        additive: 'additive',
        alignmentbaseline: 'alignmentBaseline',
        'alignment-baseline': 'alignmentBaseline',
        allowreorder: 'allowReorder',
        alphabetic: 'alphabetic',
        amplitude: 'amplitude',
        arabicform: 'arabicForm',
        'arabic-form': 'arabicForm',
        ascent: 'ascent',
        attributename: 'attributeName',
        attributetype: 'attributeType',
        autoreverse: 'autoReverse',
        azimuth: 'azimuth',
        basefrequency: 'baseFrequency',
        baselineshift: 'baselineShift',
        'baseline-shift': 'baselineShift',
        baseprofile: 'baseProfile',
        bbox: 'bbox',
        begin: 'begin',
        bias: 'bias',
        by: 'by',
        calcmode: 'calcMode',
        capheight: 'capHeight',
        'cap-height': 'capHeight',
        clip: 'clip',
        clippath: 'clipPath',
        'clip-path': 'clipPath',
        clippathunits: 'clipPathUnits',
        cliprule: 'clipRule',
        'clip-rule': 'clipRule',
        color: 'color',
        colorinterpolation: 'colorInterpolation',
        'color-interpolation': 'colorInterpolation',
        colorinterpolationfilters: 'colorInterpolationFilters',
        'color-interpolation-filters': 'colorInterpolationFilters',
        colorprofile: 'colorProfile',
        'color-profile': 'colorProfile',
        colorrendering: 'colorRendering',
        'color-rendering': 'colorRendering',
        contentscripttype: 'contentScriptType',
        contentstyletype: 'contentStyleType',
        cursor: 'cursor',
        cx: 'cx',
        cy: 'cy',
        d: 'd',
        datatype: 'datatype',
        decelerate: 'decelerate',
        descent: 'descent',
        diffuseconstant: 'diffuseConstant',
        direction: 'direction',
        display: 'display',
        divisor: 'divisor',
        dominantbaseline: 'dominantBaseline',
        'dominant-baseline': 'dominantBaseline',
        dur: 'dur',
        dx: 'dx',
        dy: 'dy',
        edgemode: 'edgeMode',
        elevation: 'elevation',
        enablebackground: 'enableBackground',
        'enable-background': 'enableBackground',
        end: 'end',
        exponent: 'exponent',
        externalresourcesrequired: 'externalResourcesRequired',
        fill: 'fill',
        fillopacity: 'fillOpacity',
        'fill-opacity': 'fillOpacity',
        fillrule: 'fillRule',
        'fill-rule': 'fillRule',
        filter: 'filter',
        filterres: 'filterRes',
        filterunits: 'filterUnits',
        floodopacity: 'floodOpacity',
        'flood-opacity': 'floodOpacity',
        floodcolor: 'floodColor',
        'flood-color': 'floodColor',
        focusable: 'focusable',
        fontfamily: 'fontFamily',
        'font-family': 'fontFamily',
        fontsize: 'fontSize',
        'font-size': 'fontSize',
        fontsizeadjust: 'fontSizeAdjust',
        'font-size-adjust': 'fontSizeAdjust',
        fontstretch: 'fontStretch',
        'font-stretch': 'fontStretch',
        fontstyle: 'fontStyle',
        'font-style': 'fontStyle',
        fontvariant: 'fontVariant',
        'font-variant': 'fontVariant',
        fontweight: 'fontWeight',
        'font-weight': 'fontWeight',
        format: 'format',
        from: 'from',
        fx: 'fx',
        fy: 'fy',
        g1: 'g1',
        g2: 'g2',
        glyphname: 'glyphName',
        'glyph-name': 'glyphName',
        glyphorientationhorizontal: 'glyphOrientationHorizontal',
        'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
        glyphorientationvertical: 'glyphOrientationVertical',
        'glyph-orientation-vertical': 'glyphOrientationVertical',
        glyphref: 'glyphRef',
        gradienttransform: 'gradientTransform',
        gradientunits: 'gradientUnits',
        hanging: 'hanging',
        horizadvx: 'horizAdvX',
        'horiz-adv-x': 'horizAdvX',
        horizoriginx: 'horizOriginX',
        'horiz-origin-x': 'horizOriginX',
        ideographic: 'ideographic',
        imagerendering: 'imageRendering',
        'image-rendering': 'imageRendering',
        in2: 'in2',
        "in": 'in',
        inlist: 'inlist',
        intercept: 'intercept',
        k1: 'k1',
        k2: 'k2',
        k3: 'k3',
        k4: 'k4',
        k: 'k',
        kernelmatrix: 'kernelMatrix',
        kernelunitlength: 'kernelUnitLength',
        kerning: 'kerning',
        keypoints: 'keyPoints',
        keysplines: 'keySplines',
        keytimes: 'keyTimes',
        lengthadjust: 'lengthAdjust',
        letterspacing: 'letterSpacing',
        'letter-spacing': 'letterSpacing',
        lightingcolor: 'lightingColor',
        'lighting-color': 'lightingColor',
        limitingconeangle: 'limitingConeAngle',
        local: 'local',
        markerend: 'markerEnd',
        'marker-end': 'markerEnd',
        markerheight: 'markerHeight',
        markermid: 'markerMid',
        'marker-mid': 'markerMid',
        markerstart: 'markerStart',
        'marker-start': 'markerStart',
        markerunits: 'markerUnits',
        markerwidth: 'markerWidth',
        mask: 'mask',
        maskcontentunits: 'maskContentUnits',
        maskunits: 'maskUnits',
        mathematical: 'mathematical',
        mode: 'mode',
        numoctaves: 'numOctaves',
        offset: 'offset',
        opacity: 'opacity',
        operator: 'operator',
        order: 'order',
        orient: 'orient',
        orientation: 'orientation',
        origin: 'origin',
        overflow: 'overflow',
        overlineposition: 'overlinePosition',
        'overline-position': 'overlinePosition',
        overlinethickness: 'overlineThickness',
        'overline-thickness': 'overlineThickness',
        paintorder: 'paintOrder',
        'paint-order': 'paintOrder',
        panose1: 'panose1',
        'panose-1': 'panose1',
        pathlength: 'pathLength',
        patterncontentunits: 'patternContentUnits',
        patterntransform: 'patternTransform',
        patternunits: 'patternUnits',
        pointerevents: 'pointerEvents',
        'pointer-events': 'pointerEvents',
        points: 'points',
        pointsatx: 'pointsAtX',
        pointsaty: 'pointsAtY',
        pointsatz: 'pointsAtZ',
        prefix: 'prefix',
        preservealpha: 'preserveAlpha',
        preserveaspectratio: 'preserveAspectRatio',
        primitiveunits: 'primitiveUnits',
        property: 'property',
        r: 'r',
        radius: 'radius',
        refx: 'refX',
        refy: 'refY',
        renderingintent: 'renderingIntent',
        'rendering-intent': 'renderingIntent',
        repeatcount: 'repeatCount',
        repeatdur: 'repeatDur',
        requiredextensions: 'requiredExtensions',
        requiredfeatures: 'requiredFeatures',
        resource: 'resource',
        restart: 'restart',
        result: 'result',
        results: 'results',
        rotate: 'rotate',
        rx: 'rx',
        ry: 'ry',
        scale: 'scale',
        security: 'security',
        seed: 'seed',
        shaperendering: 'shapeRendering',
        'shape-rendering': 'shapeRendering',
        slope: 'slope',
        spacing: 'spacing',
        specularconstant: 'specularConstant',
        specularexponent: 'specularExponent',
        speed: 'speed',
        spreadmethod: 'spreadMethod',
        startoffset: 'startOffset',
        stddeviation: 'stdDeviation',
        stemh: 'stemh',
        stemv: 'stemv',
        stitchtiles: 'stitchTiles',
        stopcolor: 'stopColor',
        'stop-color': 'stopColor',
        stopopacity: 'stopOpacity',
        'stop-opacity': 'stopOpacity',
        strikethroughposition: 'strikethroughPosition',
        'strikethrough-position': 'strikethroughPosition',
        strikethroughthickness: 'strikethroughThickness',
        'strikethrough-thickness': 'strikethroughThickness',
        string: 'string',
        stroke: 'stroke',
        strokedasharray: 'strokeDasharray',
        'stroke-dasharray': 'strokeDasharray',
        strokedashoffset: 'strokeDashoffset',
        'stroke-dashoffset': 'strokeDashoffset',
        strokelinecap: 'strokeLinecap',
        'stroke-linecap': 'strokeLinecap',
        strokelinejoin: 'strokeLinejoin',
        'stroke-linejoin': 'strokeLinejoin',
        strokemiterlimit: 'strokeMiterlimit',
        'stroke-miterlimit': 'strokeMiterlimit',
        strokewidth: 'strokeWidth',
        'stroke-width': 'strokeWidth',
        strokeopacity: 'strokeOpacity',
        'stroke-opacity': 'strokeOpacity',
        suppresscontenteditablewarning: 'suppressContentEditableWarning',
        suppresshydrationwarning: 'suppressHydrationWarning',
        surfacescale: 'surfaceScale',
        systemlanguage: 'systemLanguage',
        tablevalues: 'tableValues',
        targetx: 'targetX',
        targety: 'targetY',
        textanchor: 'textAnchor',
        'text-anchor': 'textAnchor',
        textdecoration: 'textDecoration',
        'text-decoration': 'textDecoration',
        textlength: 'textLength',
        textrendering: 'textRendering',
        'text-rendering': 'textRendering',
        to: 'to',
        transform: 'transform',
        "typeof": 'typeof',
        u1: 'u1',
        u2: 'u2',
        underlineposition: 'underlinePosition',
        'underline-position': 'underlinePosition',
        underlinethickness: 'underlineThickness',
        'underline-thickness': 'underlineThickness',
        unicode: 'unicode',
        unicodebidi: 'unicodeBidi',
        'unicode-bidi': 'unicodeBidi',
        unicoderange: 'unicodeRange',
        'unicode-range': 'unicodeRange',
        unitsperem: 'unitsPerEm',
        'units-per-em': 'unitsPerEm',
        unselectable: 'unselectable',
        valphabetic: 'vAlphabetic',
        'v-alphabetic': 'vAlphabetic',
        values: 'values',
        vectoreffect: 'vectorEffect',
        'vector-effect': 'vectorEffect',
        version: 'version',
        vertadvy: 'vertAdvY',
        'vert-adv-y': 'vertAdvY',
        vertoriginx: 'vertOriginX',
        'vert-origin-x': 'vertOriginX',
        vertoriginy: 'vertOriginY',
        'vert-origin-y': 'vertOriginY',
        vhanging: 'vHanging',
        'v-hanging': 'vHanging',
        videographic: 'vIdeographic',
        'v-ideographic': 'vIdeographic',
        viewbox: 'viewBox',
        viewtarget: 'viewTarget',
        visibility: 'visibility',
        vmathematical: 'vMathematical',
        'v-mathematical': 'vMathematical',
        vocab: 'vocab',
        widths: 'widths',
        wordspacing: 'wordSpacing',
        'word-spacing': 'wordSpacing',
        writingmode: 'writingMode',
        'writing-mode': 'writingMode',
        x1: 'x1',
        x2: 'x2',
        x: 'x',
        xchannelselector: 'xChannelSelector',
        xheight: 'xHeight',
        'x-height': 'xHeight',
        xlinkactuate: 'xlinkActuate',
        'xlink:actuate': 'xlinkActuate',
        xlinkarcrole: 'xlinkArcrole',
        'xlink:arcrole': 'xlinkArcrole',
        xlinkhref: 'xlinkHref',
        'xlink:href': 'xlinkHref',
        xlinkrole: 'xlinkRole',
        'xlink:role': 'xlinkRole',
        xlinkshow: 'xlinkShow',
        'xlink:show': 'xlinkShow',
        xlinktitle: 'xlinkTitle',
        'xlink:title': 'xlinkTitle',
        xlinktype: 'xlinkType',
        'xlink:type': 'xlinkType',
        xmlbase: 'xmlBase',
        'xml:base': 'xmlBase',
        xmllang: 'xmlLang',
        'xml:lang': 'xmlLang',
        xmlns: 'xmlns',
        'xml:space': 'xmlSpace',
        xmlnsxlink: 'xmlnsXlink',
        'xmlns:xlink': 'xmlnsXlink',
        xmlspace: 'xmlSpace',
        y1: 'y1',
        y2: 'y2',
        y: 'y',
        ychannelselector: 'yChannelSelector',
        z: 'z',
        zoomandpan: 'zoomAndPan'
      };
      var ariaProperties = {
        'aria-current': 0,
        'aria-description': 0,
        'aria-details': 0,
        'aria-disabled': 0,
        'aria-hidden': 0,
        'aria-invalid': 0,
        'aria-keyshortcuts': 0,
        'aria-label': 0,
        'aria-roledescription': 0,
        'aria-autocomplete': 0,
        'aria-checked': 0,
        'aria-expanded': 0,
        'aria-haspopup': 0,
        'aria-level': 0,
        'aria-modal': 0,
        'aria-multiline': 0,
        'aria-multiselectable': 0,
        'aria-orientation': 0,
        'aria-placeholder': 0,
        'aria-pressed': 0,
        'aria-readonly': 0,
        'aria-required': 0,
        'aria-selected': 0,
        'aria-sort': 0,
        'aria-valuemax': 0,
        'aria-valuemin': 0,
        'aria-valuenow': 0,
        'aria-valuetext': 0,
        'aria-atomic': 0,
        'aria-busy': 0,
        'aria-live': 0,
        'aria-relevant': 0,
        'aria-dropeffect': 0,
        'aria-grabbed': 0,
        'aria-activedescendant': 0,
        'aria-colcount': 0,
        'aria-colindex': 0,
        'aria-colspan': 0,
        'aria-controls': 0,
        'aria-describedby': 0,
        'aria-errormessage': 0,
        'aria-flowto': 0,
        'aria-labelledby': 0,
        'aria-owns': 0,
        'aria-posinset': 0,
        'aria-rowcount': 0,
        'aria-rowindex': 0,
        'aria-rowspan': 0,
        'aria-setsize': 0
      };
      var warnedProperties = {};
      var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
      var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');

      function validateProperty(tagName, name) {
        {
          if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) {
            return true;
          }

          if (rARIACamel.test(name)) {
            var ariaName = 'aria-' + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null;

            if (correctName == null) {
              error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);
              warnedProperties[name] = true;
              return true;
            }

            if (name !== correctName) {
              error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);
              warnedProperties[name] = true;
              return true;
            }
          }

          if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null;

            if (standardName == null) {
              warnedProperties[name] = true;
              return false;
            }

            if (name !== standardName) {
              error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);
              warnedProperties[name] = true;
              return true;
            }
          }
        }
        return true;
      }

      function warnInvalidARIAProps(type, props) {
        {
          var invalidProps = [];

          for (var key in props) {
            var isValid = validateProperty(type, key);

            if (!isValid) {
              invalidProps.push(key);
            }
          }

          var unknownPropString = invalidProps.map(function (prop) {
            return '`' + prop + '`';
          }).join(', ');

          if (invalidProps.length === 1) {
            error('Invalid aria prop %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
          } else if (invalidProps.length > 1) {
            error('Invalid aria props %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
          }
        }
      }

      function validateProperties(type, props) {
        if (isCustomComponent(type, props)) {
          return;
        }

        warnInvalidARIAProps(type, props);
      }

      var didWarnValueNull = false;

      function validateProperties$1(type, props) {
        {
          if (type !== 'input' && type !== 'textarea' && type !== 'select') {
            return;
          }

          if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;

            if (type === 'select' && props.multiple) {
              error('`value` prop on `%s` should not be null. ' + 'Consider using an empty array when `multiple` is set to `true` ' + 'to clear the component or `undefined` for uncontrolled components.', type);
            } else {
              error('`value` prop on `%s` should not be null. ' + 'Consider using an empty string to clear the component or `undefined` ' + 'for uncontrolled components.', type);
            }
          }
        }
      }

      var validateProperty$1 = function validateProperty$1() {};

      {
        var warnedProperties$1 = {};
        var EVENT_NAME_REGEX = /^on./;
        var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
        var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
        var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');

        validateProperty$1 = function validateProperty$1(tagName, name, value, eventRegistry) {
          if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
            return true;
          }

          var lowerCasedName = name.toLowerCase();

          if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
            error('React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.');
            warnedProperties$1[name] = true;
            return true;
          }

          if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies,
                possibleRegistrationNames = eventRegistry.possibleRegistrationNames;

            if (registrationNameDependencies.hasOwnProperty(name)) {
              return true;
            }

            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;

            if (registrationName != null) {
              error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);
              warnedProperties$1[name] = true;
              return true;
            }

            if (EVENT_NAME_REGEX.test(name)) {
              error('Unknown event handler property `%s`. It will be ignored.', name);
              warnedProperties$1[name] = true;
              return true;
            }
          } else if (EVENT_NAME_REGEX.test(name)) {
            if (INVALID_EVENT_NAME_REGEX.test(name)) {
              error('Invalid event handler property `%s`. ' + 'React events use the camelCase naming convention, for example `onClick`.', name);
            }

            warnedProperties$1[name] = true;
            return true;
          }

          if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
            return true;
          }

          if (lowerCasedName === 'innerhtml') {
            error('Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.');
            warnedProperties$1[name] = true;
            return true;
          }

          if (lowerCasedName === 'aria') {
            error('The `aria` attribute is reserved for future use in React. ' + 'Pass individual `aria-` attributes instead.');
            warnedProperties$1[name] = true;
            return true;
          }

          if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
            error('Received a `%s` for a string attribute `is`. If this is expected, cast ' + 'the value to a string.', typeof value);
            warnedProperties$1[name] = true;
            return true;
          }

          if (typeof value === 'number' && isNaN(value)) {
            error('Received NaN for the `%s` attribute. If this is expected, cast ' + 'the value to a string.', name);
            warnedProperties$1[name] = true;
            return true;
          }

          var propertyInfo = getPropertyInfo(name);
          var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED;

          if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];

            if (standardName !== name) {
              error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);
              warnedProperties$1[name] = true;
              return true;
            }
          } else if (!isReserved && name !== lowerCasedName) {
            error('React does not recognize the `%s` prop on a DOM element. If you ' + 'intentionally want it to appear in the DOM as a custom ' + 'attribute, spell it as lowercase `%s` instead. ' + 'If you accidentally passed it from a parent component, remove ' + 'it from the DOM element.', name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
          }

          if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) {
              error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.', value, name, name, value, name);
            } else {
              error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            }

            warnedProperties$1[name] = true;
            return true;
          }

          if (isReserved) {
            return true;
          }

          if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
          }

          if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error('Received the string `%s` for the boolean attribute `%s`. ' + '%s ' + 'Did you mean %s={%s}?', value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
          }

          return true;
        };
      }

      var warnUnknownProperties = function warnUnknownProperties(type, props, eventRegistry) {
        {
          var unknownProps = [];

          for (var key in props) {
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);

            if (!isValid) {
              unknownProps.push(key);
            }
          }

          var unknownPropString = unknownProps.map(function (prop) {
            return '`' + prop + '`';
          }).join(', ');

          if (unknownProps.length === 1) {
            error('Invalid value for prop %s on <%s> tag. Either remove it from the element, ' + 'or pass a string or number value to keep it in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
          } else if (unknownProps.length > 1) {
            error('Invalid values for props %s on <%s> tag. Either remove them from the element, ' + 'or pass a string or number value to keep them in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
          }
        }
      };

      function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) {
          return;
        }

        warnUnknownProperties(type, props, eventRegistry);
      }

      var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
      var IS_NON_DELEGATED = 1 << 1;
      var IS_CAPTURE_PHASE = 1 << 2;
      var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
      var currentReplayingEvent = null;

      function setReplayingEvent(event) {
        {
          if (currentReplayingEvent !== null) {
            error('Expected currently replaying event to be null. This error ' + 'is likely caused by a bug in React. Please file an issue.');
          }
        }
        currentReplayingEvent = event;
      }

      function resetReplayingEvent() {
        {
          if (currentReplayingEvent === null) {
            error('Expected currently replaying event to not be null. This error ' + 'is likely caused by a bug in React. Please file an issue.');
          }
        }
        currentReplayingEvent = null;
      }

      function isReplayingEvent(event) {
        return event === currentReplayingEvent;
      }

      function getEventTarget(nativeEvent) {
        var target = nativeEvent.target || nativeEvent.srcElement || window;

        if (target.correspondingUseElement) {
          target = target.correspondingUseElement;
        }

        return target.nodeType === TEXT_NODE ? target.parentNode : target;
      }

      var restoreImpl = null;
      var restoreTarget = null;
      var restoreQueue = null;

      function restoreStateOfTarget(target) {
        var internalInstance = getInstanceFromNode(target);

        if (!internalInstance) {
          return;
        }

        if (typeof restoreImpl !== 'function') {
          throw new Error('setRestoreImplementation() needs to be called to handle a target for controlled ' + 'events. This error is likely caused by a bug in React. Please file an issue.');
        }

        var stateNode = internalInstance.stateNode;

        if (stateNode) {
          var _props = getFiberCurrentPropsFromNode(stateNode);

          restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
      }

      function setRestoreImplementation(impl) {
        restoreImpl = impl;
      }

      function enqueueStateRestore(target) {
        if (restoreTarget) {
          if (restoreQueue) {
            restoreQueue.push(target);
          } else {
            restoreQueue = [target];
          }
        } else {
          restoreTarget = target;
        }
      }

      function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
      }

      function restoreStateIfNeeded() {
        if (!restoreTarget) {
          return;
        }

        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);

        if (queuedTargets) {
          for (var i = 0; i < queuedTargets.length; i++) {
            restoreStateOfTarget(queuedTargets[i]);
          }
        }
      }

      var batchedUpdatesImpl = function batchedUpdatesImpl(fn, bookkeeping) {
        return fn(bookkeeping);
      };

      var flushSyncImpl = function flushSyncImpl() {};

      var isInsideEventHandler = false;

      function finishEventHandler() {
        var controlledComponentsHavePendingUpdates = needsStateRestore();

        if (controlledComponentsHavePendingUpdates) {
          flushSyncImpl();
          restoreStateIfNeeded();
        }
      }

      function batchedUpdates(fn, a, b) {
        if (isInsideEventHandler) {
          return fn(a, b);
        }

        isInsideEventHandler = true;

        try {
          return batchedUpdatesImpl(fn, a, b);
        } finally {
          isInsideEventHandler = false;
          finishEventHandler();
        }
      }

      function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushSyncImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        flushSyncImpl = _flushSyncImpl;
      }

      function isInteractive(tag) {
        return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
      }

      function shouldPreventMouseEvent(name, type, props) {
        switch (name) {
          case 'onClick':
          case 'onClickCapture':
          case 'onDoubleClick':
          case 'onDoubleClickCapture':
          case 'onMouseDown':
          case 'onMouseDownCapture':
          case 'onMouseMove':
          case 'onMouseMoveCapture':
          case 'onMouseUp':
          case 'onMouseUpCapture':
          case 'onMouseEnter':
            return !!(props.disabled && isInteractive(type));

          default:
            return false;
        }
      }

      function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;

        if (stateNode === null) {
          return null;
        }

        var props = getFiberCurrentPropsFromNode(stateNode);

        if (props === null) {
          return null;
        }

        var listener = props[registrationName];

        if (shouldPreventMouseEvent(registrationName, inst.type, props)) {
          return null;
        }

        if (listener && typeof listener !== 'function') {
          throw new Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        }

        return listener;
      }

      var passiveBrowserEventsSupported = false;

      if (canUseDOM) {
        try {
          var options = {};
          Object.defineProperty(options, 'passive', {
            get: function get() {
              passiveBrowserEventsSupported = true;
            }
          });
          window.addEventListener('test', options, options);
          window.removeEventListener('test', options, options);
        } catch (e) {
          passiveBrowserEventsSupported = false;
        }
      }

      function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);

        try {
          func.apply(context, funcArgs);
        } catch (error) {
          this.onError(error);
        }
      }

      var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
      {
        if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
          var fakeNode = document.createElement('react');

          invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            if (typeof document === 'undefined' || document === null) {
              throw new Error('The `document` global was defined when React was initialized, but is not ' + 'defined anymore. This can happen in a test environment if a component ' + 'schedules an update from an asynchronous callback, but the test has already ' + 'finished running. To solve this, you can either unmount the component at ' + 'the end of your test (and ensure that any asynchronous operations get ' + 'canceled in `componentWillUnmount`), or you can change the test itself ' + 'to be asynchronous.');
            }

            var evt = document.createEvent('Event');
            var didCall = false;
            var didError = true;
            var windowEvent = window.event;
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event');

            function restoreAfterDispatch() {
              fakeNode.removeEventListener(evtType, callCallback, false);

              if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) {
                window.event = windowEvent;
              }
            }

            var funcArgs = Array.prototype.slice.call(arguments, 3);

            function callCallback() {
              didCall = true;
              restoreAfterDispatch();
              func.apply(context, funcArgs);
              didError = false;
            }

            var error;
            var didSetError = false;
            var isCrossOriginError = false;

            function handleWindowError(event) {
              error = event.error;
              didSetError = true;

              if (error === null && event.colno === 0 && event.lineno === 0) {
                isCrossOriginError = true;
              }

              if (event.defaultPrevented) {
                if (error != null && typeof error === 'object') {
                  try {
                    error._suppressLogging = true;
                  } catch (inner) {}
                }
              }
            }

            var evtType = "react-" + (name ? name : 'invokeguardedcallback');
            window.addEventListener('error', handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false);
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);

            if (windowEventDescriptor) {
              Object.defineProperty(window, 'event', windowEventDescriptor);
            }

            if (didCall && didError) {
              if (!didSetError) {
                error = new Error('An error was thrown inside one of your components, but React ' + "doesn't know what it was. This is likely due to browser " + 'flakiness. React does its best to preserve the "Pause on ' + 'exceptions" behavior of the DevTools, which requires some ' + "DEV-mode only tricks. It's possible that these don't work in " + 'your browser. Try triggering the error in production mode, ' + 'or switching to a modern browser. If you suspect that this is ' + 'actually an issue with React, please file an issue.');
              } else if (isCrossOriginError) {
                error = new Error("A cross-origin error was thrown. React doesn't have access to " + 'the actual error object in development. ' + 'See https://reactjs.org/link/crossorigin-error for more information.');
              }

              this.onError(error);
            }

            window.removeEventListener('error', handleWindowError);

            if (!didCall) {
              restoreAfterDispatch();
              return invokeGuardedCallbackProd.apply(this, arguments);
            }
          };
        }
      }
      var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
      var hasError = false;
      var caughtError = null;
      var hasRethrowError = false;
      var rethrowError = null;
      var reporter = {
        onError: function onError(error) {
          hasError = true;
          caughtError = error;
        }
      };

      function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
      }

      function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);

        if (hasError) {
          var error = clearCaughtError();

          if (!hasRethrowError) {
            hasRethrowError = true;
            rethrowError = error;
          }
        }
      }

      function rethrowCaughtError() {
        if (hasRethrowError) {
          var error = rethrowError;
          hasRethrowError = false;
          rethrowError = null;
          throw error;
        }
      }

      function hasCaughtError() {
        return hasError;
      }

      function clearCaughtError() {
        if (hasError) {
          var error = caughtError;
          hasError = false;
          caughtError = null;
          return error;
        } else {
          throw new Error('clearCaughtError was called but no error was captured. This error ' + 'is likely caused by a bug in React. Please file an issue.');
        }
      }

      function get(key) {
        return key._reactInternals;
      }

      function has(key) {
        return key._reactInternals !== undefined;
      }

      function set(key, value) {
        key._reactInternals = value;
      }

      var NoFlags = 0;
      var PerformedWork = 1;
      var Placement = 2;
      var Update = 4;
      var ChildDeletion = 16;
      var ContentReset = 32;
      var Callback = 64;
      var DidCapture = 128;
      var ForceClientRender = 256;
      var Ref = 512;
      var Snapshot = 1024;
      var Passive = 2048;
      var Hydrating = 4096;
      var Visibility = 8192;
      var StoreConsistency = 16384;
      var LifecycleEffectMask = Passive | Update | Callback | Ref | Snapshot | StoreConsistency;
      var HostEffectMask = 32767;
      var Incomplete = 32768;
      var ShouldCapture = 65536;
      var ForceUpdateForLegacySuspense = 131072;
      var Forked = 1048576;
      var RefStatic = 2097152;
      var LayoutStatic = 4194304;
      var PassiveStatic = 8388608;
      var MountLayoutDev = 16777216;
      var MountPassiveDev = 33554432;
      var BeforeMutationMask = Update | Snapshot | 0;
      var MutationMask = Placement | Update | ChildDeletion | ContentReset | Ref | Hydrating | Visibility;
      var LayoutMask = Update | Callback | Ref | Visibility;
      var PassiveMask = Passive | ChildDeletion;
      var StaticMask = LayoutStatic | PassiveStatic | RefStatic;
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;

      function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;

        if (!fiber.alternate) {
          var nextNode = node;

          do {
            node = nextNode;

            if ((node.flags & (Placement | Hydrating)) !== NoFlags) {
              nearestMounted = node["return"];
            }

            nextNode = node["return"];
          } while (nextNode);
        } else {
          while (node["return"]) {
            node = node["return"];
          }
        }

        if (node.tag === HostRoot) {
          return nearestMounted;
        }

        return null;
      }

      function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
          var suspenseState = fiber.memoizedState;

          if (suspenseState === null) {
            var current = fiber.alternate;

            if (current !== null) {
              suspenseState = current.memoizedState;
            }
          }

          if (suspenseState !== null) {
            return suspenseState.dehydrated;
          }
        }

        return null;
      }

      function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
      }

      function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
      }

      function isMounted(component) {
        {
          var owner = ReactCurrentOwner.current;

          if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;

            if (!instance._warnedAboutRefsInRender) {
              error('%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentNameFromFiber(ownerFiber) || 'A component');
            }

            instance._warnedAboutRefsInRender = true;
          }
        }
        var fiber = get(component);

        if (!fiber) {
          return false;
        }

        return getNearestMountedFiber(fiber) === fiber;
      }

      function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) {
          throw new Error('Unable to find node on an unmounted component.');
        }
      }

      function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;

        if (!alternate) {
          var nearestMounted = getNearestMountedFiber(fiber);

          if (nearestMounted === null) {
            throw new Error('Unable to find node on an unmounted component.');
          }

          if (nearestMounted !== fiber) {
            return null;
          }

          return fiber;
        }

        var a = fiber;
        var b = alternate;

        while (true) {
          var parentA = a["return"];

          if (parentA === null) {
            break;
          }

          var parentB = parentA.alternate;

          if (parentB === null) {
            var nextParent = parentA["return"];

            if (nextParent !== null) {
              a = b = nextParent;
              continue;
            }

            break;
          }

          if (parentA.child === parentB.child) {
            var child = parentA.child;

            while (child) {
              if (child === a) {
                assertIsMounted(parentA);
                return fiber;
              }

              if (child === b) {
                assertIsMounted(parentA);
                return alternate;
              }

              child = child.sibling;
            }

            throw new Error('Unable to find node on an unmounted component.');
          }

          if (a["return"] !== b["return"]) {
            a = parentA;
            b = parentB;
          } else {
            var didFindChild = false;
            var _child = parentA.child;

            while (_child) {
              if (_child === a) {
                didFindChild = true;
                a = parentA;
                b = parentB;
                break;
              }

              if (_child === b) {
                didFindChild = true;
                b = parentA;
                a = parentB;
                break;
              }

              _child = _child.sibling;
            }

            if (!didFindChild) {
              _child = parentB.child;

              while (_child) {
                if (_child === a) {
                  didFindChild = true;
                  a = parentB;
                  b = parentA;
                  break;
                }

                if (_child === b) {
                  didFindChild = true;
                  b = parentB;
                  a = parentA;
                  break;
                }

                _child = _child.sibling;
              }

              if (!didFindChild) {
                throw new Error('Child was not found in either parent set. This indicates a bug ' + 'in React related to the return pointer. Please file an issue.');
              }
            }
          }

          if (a.alternate !== b) {
            throw new Error("Return fibers should always be each others' alternates. " + 'This error is likely caused by a bug in React. Please file an issue.');
          }
        }

        if (a.tag !== HostRoot) {
          throw new Error('Unable to find node on an unmounted component.');
        }

        if (a.stateNode.current === a) {
          return fiber;
        }

        return alternate;
      }

      function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberImpl(currentParent) : null;
      }

      function findCurrentHostFiberImpl(node) {
        if (node.tag === HostComponent || node.tag === HostText) {
          return node;
        }

        var child = node.child;

        while (child !== null) {
          var match = findCurrentHostFiberImpl(child);

          if (match !== null) {
            return match;
          }

          child = child.sibling;
        }

        return null;
      }

      function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberWithNoPortalsImpl(currentParent) : null;
      }

      function findCurrentHostFiberWithNoPortalsImpl(node) {
        if (node.tag === HostComponent || node.tag === HostText) {
          return node;
        }

        var child = node.child;

        while (child !== null) {
          if (child.tag !== HostPortal) {
            var match = findCurrentHostFiberWithNoPortalsImpl(child);

            if (match !== null) {
              return match;
            }
          }

          child = child.sibling;
        }

        return null;
      }

      var scheduleCallback = Scheduler.unstable_scheduleCallback;
      var cancelCallback = Scheduler.unstable_cancelCallback;
      var shouldYield = Scheduler.unstable_shouldYield;
      var requestPaint = Scheduler.unstable_requestPaint;
      var now = Scheduler.unstable_now;
      var getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel;
      var ImmediatePriority = Scheduler.unstable_ImmediatePriority;
      var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority;
      var NormalPriority = Scheduler.unstable_NormalPriority;
      var LowPriority = Scheduler.unstable_LowPriority;
      var IdlePriority = Scheduler.unstable_IdlePriority;
      var unstable_yieldValue = Scheduler.unstable_yieldValue;
      var unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue;
      var rendererID = null;
      var injectedHook = null;
      var injectedProfilingHooks = null;
      var hasLoggedError = false;
      var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';

      function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
          return false;
        }

        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;

        if (hook.isDisabled) {
          return true;
        }

        if (!hook.supportsFiber) {
          {
            error('The installed version of React DevTools is too old and will not work ' + 'with the current version of React. Please update React DevTools. ' + 'https://reactjs.org/link/react-devtools');
          }
          return true;
        }

        try {
          if (enableSchedulingProfiler) {
            internals = assign({}, internals, {
              getLaneLabelMap: getLaneLabelMap,
              injectProfilingHooks: injectProfilingHooks
            });
          }

          rendererID = hook.inject(internals);
          injectedHook = hook;
        } catch (err) {
          {
            error('React instrumentation encountered an error: %s.', err);
          }
        }

        if (hook.checkDCE) {
          return true;
        } else {
          return false;
        }
      }

      function onScheduleRoot(root, children) {
        {
          if (injectedHook && typeof injectedHook.onScheduleFiberRoot === 'function') {
            try {
              injectedHook.onScheduleFiberRoot(rendererID, root, children);
            } catch (err) {
              if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
              }
            }
          }
        }
      }

      function onCommitRoot(root, eventPriority) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === 'function') {
          try {
            var didError = (root.current.flags & DidCapture) === DidCapture;

            if (enableProfilerTimer) {
              var schedulerPriority;

              switch (eventPriority) {
                case DiscreteEventPriority:
                  schedulerPriority = ImmediatePriority;
                  break;

                case ContinuousEventPriority:
                  schedulerPriority = UserBlockingPriority;
                  break;

                case DefaultEventPriority:
                  schedulerPriority = NormalPriority;
                  break;

                case IdleEventPriority:
                  schedulerPriority = IdlePriority;
                  break;

                default:
                  schedulerPriority = NormalPriority;
                  break;
              }

              injectedHook.onCommitFiberRoot(rendererID, root, schedulerPriority, didError);
            } else {
              injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
            }
          } catch (err) {
            {
              if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
              }
            }
          }
        }
      }

      function onPostCommitRoot(root) {
        if (injectedHook && typeof injectedHook.onPostCommitFiberRoot === 'function') {
          try {
            injectedHook.onPostCommitFiberRoot(rendererID, root);
          } catch (err) {
            {
              if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
              }
            }
          }
        }
      }

      function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === 'function') {
          try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
          } catch (err) {
            {
              if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
              }
            }
          }
        }
      }

      function setIsStrictModeForDevtools(newIsStrictMode) {
        {
          if (typeof unstable_yieldValue === 'function') {
            unstable_setDisableYieldValue(newIsStrictMode);
            setSuppressWarning(newIsStrictMode);
          }

          if (injectedHook && typeof injectedHook.setStrictMode === 'function') {
            try {
              injectedHook.setStrictMode(rendererID, newIsStrictMode);
            } catch (err) {
              {
                if (!hasLoggedError) {
                  hasLoggedError = true;
                  error('React instrumentation encountered an error: %s', err);
                }
              }
            }
          }
        }
      }

      function injectProfilingHooks(profilingHooks) {
        injectedProfilingHooks = profilingHooks;
      }

      function getLaneLabelMap() {
        {
          var map = new Map();
          var lane = 1;

          for (var index = 0; index < TotalLanes; index++) {
            var label = getLabelForLane(lane);
            map.set(lane, label);
            lane *= 2;
          }

          return map;
        }
      }

      function markCommitStarted(lanes) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStarted === 'function') {
            injectedProfilingHooks.markCommitStarted(lanes);
          }
        }
      }

      function markCommitStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStopped === 'function') {
            injectedProfilingHooks.markCommitStopped();
          }
        }
      }

      function markComponentRenderStarted(fiber) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStarted === 'function') {
            injectedProfilingHooks.markComponentRenderStarted(fiber);
          }
        }
      }

      function markComponentRenderStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStopped === 'function') {
            injectedProfilingHooks.markComponentRenderStopped();
          }
        }
      }

      function markComponentPassiveEffectMountStarted(fiber) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted === 'function') {
            injectedProfilingHooks.markComponentPassiveEffectMountStarted(fiber);
          }
        }
      }

      function markComponentPassiveEffectMountStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped === 'function') {
            injectedProfilingHooks.markComponentPassiveEffectMountStopped();
          }
        }
      }

      function markComponentPassiveEffectUnmountStarted(fiber) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted === 'function') {
            injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(fiber);
          }
        }
      }

      function markComponentPassiveEffectUnmountStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped === 'function') {
            injectedProfilingHooks.markComponentPassiveEffectUnmountStopped();
          }
        }
      }

      function markComponentLayoutEffectMountStarted(fiber) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted === 'function') {
            injectedProfilingHooks.markComponentLayoutEffectMountStarted(fiber);
          }
        }
      }

      function markComponentLayoutEffectMountStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped === 'function') {
            injectedProfilingHooks.markComponentLayoutEffectMountStopped();
          }
        }
      }

      function markComponentLayoutEffectUnmountStarted(fiber) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted === 'function') {
            injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(fiber);
          }
        }
      }

      function markComponentLayoutEffectUnmountStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped === 'function') {
            injectedProfilingHooks.markComponentLayoutEffectUnmountStopped();
          }
        }
      }

      function markComponentErrored(fiber, thrownValue, lanes) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentErrored === 'function') {
            injectedProfilingHooks.markComponentErrored(fiber, thrownValue, lanes);
          }
        }
      }

      function markComponentSuspended(fiber, wakeable, lanes) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentSuspended === 'function') {
            injectedProfilingHooks.markComponentSuspended(fiber, wakeable, lanes);
          }
        }
      }

      function markLayoutEffectsStarted(lanes) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStarted === 'function') {
            injectedProfilingHooks.markLayoutEffectsStarted(lanes);
          }
        }
      }

      function markLayoutEffectsStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStopped === 'function') {
            injectedProfilingHooks.markLayoutEffectsStopped();
          }
        }
      }

      function markPassiveEffectsStarted(lanes) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStarted === 'function') {
            injectedProfilingHooks.markPassiveEffectsStarted(lanes);
          }
        }
      }

      function markPassiveEffectsStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStopped === 'function') {
            injectedProfilingHooks.markPassiveEffectsStopped();
          }
        }
      }

      function markRenderStarted(lanes) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStarted === 'function') {
            injectedProfilingHooks.markRenderStarted(lanes);
          }
        }
      }

      function markRenderYielded() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderYielded === 'function') {
            injectedProfilingHooks.markRenderYielded();
          }
        }
      }

      function markRenderStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStopped === 'function') {
            injectedProfilingHooks.markRenderStopped();
          }
        }
      }

      function markRenderScheduled(lane) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderScheduled === 'function') {
            injectedProfilingHooks.markRenderScheduled(lane);
          }
        }
      }

      function markForceUpdateScheduled(fiber, lane) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markForceUpdateScheduled === 'function') {
            injectedProfilingHooks.markForceUpdateScheduled(fiber, lane);
          }
        }
      }

      function markStateUpdateScheduled(fiber, lane) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markStateUpdateScheduled === 'function') {
            injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
          }
        }
      }

      var NoMode = 0;
      var ConcurrentMode = 1;
      var ProfileMode = 2;
      var StrictLegacyMode = 8;
      var StrictEffectsMode = 16;
      var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback;
      var log = Math.log;
      var LN2 = Math.LN2;

      function clz32Fallback(x) {
        var asUint = x >>> 0;

        if (asUint === 0) {
          return 32;
        }

        return 31 - (log(asUint) / LN2 | 0) | 0;
      }

      var TotalLanes = 31;
      var NoLanes = 0;
      var NoLane = 0;
      var SyncLane = 1;
      var InputContinuousHydrationLane = 2;
      var InputContinuousLane = 4;
      var DefaultHydrationLane = 8;
      var DefaultLane = 16;
      var TransitionHydrationLane = 32;
      var TransitionLanes = 4194240;
      var TransitionLane1 = 64;
      var TransitionLane2 = 128;
      var TransitionLane3 = 256;
      var TransitionLane4 = 512;
      var TransitionLane5 = 1024;
      var TransitionLane6 = 2048;
      var TransitionLane7 = 4096;
      var TransitionLane8 = 8192;
      var TransitionLane9 = 16384;
      var TransitionLane10 = 32768;
      var TransitionLane11 = 65536;
      var TransitionLane12 = 131072;
      var TransitionLane13 = 262144;
      var TransitionLane14 = 524288;
      var TransitionLane15 = 1048576;
      var TransitionLane16 = 2097152;
      var RetryLanes = 130023424;
      var RetryLane1 = 4194304;
      var RetryLane2 = 8388608;
      var RetryLane3 = 16777216;
      var RetryLane4 = 33554432;
      var RetryLane5 = 67108864;
      var SomeRetryLane = RetryLane1;
      var SelectiveHydrationLane = 134217728;
      var NonIdleLanes = 268435455;
      var IdleHydrationLane = 268435456;
      var IdleLane = 536870912;
      var OffscreenLane = 1073741824;

      function getLabelForLane(lane) {
        {
          if (lane & SyncLane) {
            return 'Sync';
          }

          if (lane & InputContinuousHydrationLane) {
            return 'InputContinuousHydration';
          }

          if (lane & InputContinuousLane) {
            return 'InputContinuous';
          }

          if (lane & DefaultHydrationLane) {
            return 'DefaultHydration';
          }

          if (lane & DefaultLane) {
            return 'Default';
          }

          if (lane & TransitionHydrationLane) {
            return 'TransitionHydration';
          }

          if (lane & TransitionLanes) {
            return 'Transition';
          }

          if (lane & RetryLanes) {
            return 'Retry';
          }

          if (lane & SelectiveHydrationLane) {
            return 'SelectiveHydration';
          }

          if (lane & IdleHydrationLane) {
            return 'IdleHydration';
          }

          if (lane & IdleLane) {
            return 'Idle';
          }

          if (lane & OffscreenLane) {
            return 'Offscreen';
          }
        }
      }

      var NoTimestamp = -1;
      var nextTransitionLane = TransitionLane1;
      var nextRetryLane = RetryLane1;

      function getHighestPriorityLanes(lanes) {
        switch (getHighestPriorityLane(lanes)) {
          case SyncLane:
            return SyncLane;

          case InputContinuousHydrationLane:
            return InputContinuousHydrationLane;

          case InputContinuousLane:
            return InputContinuousLane;

          case DefaultHydrationLane:
            return DefaultHydrationLane;

          case DefaultLane:
            return DefaultLane;

          case TransitionHydrationLane:
            return TransitionHydrationLane;

          case TransitionLane1:
          case TransitionLane2:
          case TransitionLane3:
          case TransitionLane4:
          case TransitionLane5:
          case TransitionLane6:
          case TransitionLane7:
          case TransitionLane8:
          case TransitionLane9:
          case TransitionLane10:
          case TransitionLane11:
          case TransitionLane12:
          case TransitionLane13:
          case TransitionLane14:
          case TransitionLane15:
          case TransitionLane16:
            return lanes & TransitionLanes;

          case RetryLane1:
          case RetryLane2:
          case RetryLane3:
          case RetryLane4:
          case RetryLane5:
            return lanes & RetryLanes;

          case SelectiveHydrationLane:
            return SelectiveHydrationLane;

          case IdleHydrationLane:
            return IdleHydrationLane;

          case IdleLane:
            return IdleLane;

          case OffscreenLane:
            return OffscreenLane;

          default:
            {
              error('Should have found matching lanes. This is a bug in React.');
            }
            return lanes;
        }
      }

      function getNextLanes(root, wipLanes) {
        var pendingLanes = root.pendingLanes;

        if (pendingLanes === NoLanes) {
          return NoLanes;
        }

        var nextLanes = NoLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var nonIdlePendingLanes = pendingLanes & NonIdleLanes;

        if (nonIdlePendingLanes !== NoLanes) {
          var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;

          if (nonIdleUnblockedLanes !== NoLanes) {
            nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
          } else {
            var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;

            if (nonIdlePingedLanes !== NoLanes) {
              nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
            }
          }
        } else {
          var unblockedLanes = pendingLanes & ~suspendedLanes;

          if (unblockedLanes !== NoLanes) {
            nextLanes = getHighestPriorityLanes(unblockedLanes);
          } else {
            if (pingedLanes !== NoLanes) {
              nextLanes = getHighestPriorityLanes(pingedLanes);
            }
          }
        }

        if (nextLanes === NoLanes) {
          return NoLanes;
        }

        if (wipLanes !== NoLanes && wipLanes !== nextLanes && (wipLanes & suspendedLanes) === NoLanes) {
          var nextLane = getHighestPriorityLane(nextLanes);
          var wipLane = getHighestPriorityLane(wipLanes);

          if (nextLane >= wipLane || nextLane === DefaultLane && (wipLane & TransitionLanes) !== NoLanes) {
            return wipLanes;
          }
        }

        if ((nextLanes & InputContinuousLane) !== NoLanes) {
          nextLanes |= pendingLanes & DefaultLane;
        }

        var entangledLanes = root.entangledLanes;

        if (entangledLanes !== NoLanes) {
          var entanglements = root.entanglements;
          var lanes = nextLanes & entangledLanes;

          while (lanes > 0) {
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            nextLanes |= entanglements[index];
            lanes &= ~lane;
          }
        }

        return nextLanes;
      }

      function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;

        while (lanes > 0) {
          var index = pickArbitraryLaneIndex(lanes);
          var lane = 1 << index;
          var eventTime = eventTimes[index];

          if (eventTime > mostRecentEventTime) {
            mostRecentEventTime = eventTime;
          }

          lanes &= ~lane;
        }

        return mostRecentEventTime;
      }

      function computeExpirationTime(lane, currentTime) {
        switch (lane) {
          case SyncLane:
          case InputContinuousHydrationLane:
          case InputContinuousLane:
            return currentTime + 250;

          case DefaultHydrationLane:
          case DefaultLane:
          case TransitionHydrationLane:
          case TransitionLane1:
          case TransitionLane2:
          case TransitionLane3:
          case TransitionLane4:
          case TransitionLane5:
          case TransitionLane6:
          case TransitionLane7:
          case TransitionLane8:
          case TransitionLane9:
          case TransitionLane10:
          case TransitionLane11:
          case TransitionLane12:
          case TransitionLane13:
          case TransitionLane14:
          case TransitionLane15:
          case TransitionLane16:
            return currentTime + 5000;

          case RetryLane1:
          case RetryLane2:
          case RetryLane3:
          case RetryLane4:
          case RetryLane5:
            return NoTimestamp;

          case SelectiveHydrationLane:
          case IdleHydrationLane:
          case IdleLane:
          case OffscreenLane:
            return NoTimestamp;

          default:
            {
              error('Should have found matching lanes. This is a bug in React.');
            }
            return NoTimestamp;
        }
      }

      function markStarvedLanesAsExpired(root, currentTime) {
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes;
        var lanes = pendingLanes;

        while (lanes > 0) {
          var index = pickArbitraryLaneIndex(lanes);
          var lane = 1 << index;
          var expirationTime = expirationTimes[index];

          if (expirationTime === NoTimestamp) {
            if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) {
              expirationTimes[index] = computeExpirationTime(lane, currentTime);
            }
          } else if (expirationTime <= currentTime) {
            root.expiredLanes |= lane;
          }

          lanes &= ~lane;
        }
      }

      function getHighestPriorityPendingLanes(root) {
        return getHighestPriorityLanes(root.pendingLanes);
      }

      function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;

        if (everythingButOffscreen !== NoLanes) {
          return everythingButOffscreen;
        }

        if (everythingButOffscreen & OffscreenLane) {
          return OffscreenLane;
        }

        return NoLanes;
      }

      function includesSyncLane(lanes) {
        return (lanes & SyncLane) !== NoLanes;
      }

      function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
      }

      function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
      }

      function includesOnlyNonUrgentLanes(lanes) {
        var UrgentLanes = SyncLane | InputContinuousLane | DefaultLane;
        return (lanes & UrgentLanes) === NoLanes;
      }

      function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
      }

      function includesBlockingLane(root, lanes) {
        var SyncDefaultLanes = InputContinuousHydrationLane | InputContinuousLane | DefaultHydrationLane | DefaultLane;
        return (lanes & SyncDefaultLanes) !== NoLanes;
      }

      function includesExpiredLane(root, lanes) {
        return (lanes & root.expiredLanes) !== NoLanes;
      }

      function isTransitionLane(lane) {
        return (lane & TransitionLanes) !== NoLanes;
      }

      function claimNextTransitionLane() {
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;

        if ((nextTransitionLane & TransitionLanes) === NoLanes) {
          nextTransitionLane = TransitionLane1;
        }

        return lane;
      }

      function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;

        if ((nextRetryLane & RetryLanes) === NoLanes) {
          nextRetryLane = RetryLane1;
        }

        return lane;
      }

      function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
      }

      function pickArbitraryLane(lanes) {
        return getHighestPriorityLane(lanes);
      }

      function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
      }

      function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
      }

      function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
      }

      function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
      }

      function mergeLanes(a, b) {
        return a | b;
      }

      function removeLanes(set, subset) {
        return set & ~subset;
      }

      function intersectLanes(a, b) {
        return a & b;
      }

      function laneToLanes(lane) {
        return lane;
      }

      function higherPriorityLane(a, b) {
        return a !== NoLane && a < b ? a : b;
      }

      function createLaneMap(initial) {
        var laneMap = [];

        for (var i = 0; i < TotalLanes; i++) {
          laneMap.push(initial);
        }

        return laneMap;
      }

      function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane;

        if (updateLane !== IdleLane) {
          root.suspendedLanes = NoLanes;
          root.pingedLanes = NoLanes;
        }

        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane);
        eventTimes[index] = eventTime;
      }

      function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes;
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;

        while (lanes > 0) {
          var index = pickArbitraryLaneIndex(lanes);
          var lane = 1 << index;
          expirationTimes[index] = NoTimestamp;
          lanes &= ~lane;
        }
      }

      function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
      }

      function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes;
        root.suspendedLanes = NoLanes;
        root.pingedLanes = NoLanes;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes;
        var lanes = noLongerPendingLanes;

        while (lanes > 0) {
          var index = pickArbitraryLaneIndex(lanes);
          var lane = 1 << index;
          entanglements[index] = NoLanes;
          eventTimes[index] = NoTimestamp;
          expirationTimes[index] = NoTimestamp;
          lanes &= ~lane;
        }
      }

      function markRootEntangled(root, entangledLanes) {
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = rootEntangledLanes;

        while (lanes) {
          var index = pickArbitraryLaneIndex(lanes);
          var lane = 1 << index;

          if (lane & entangledLanes | entanglements[index] & entangledLanes) {
            entanglements[index] |= entangledLanes;
          }

          lanes &= ~lane;
        }
      }

      function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = getHighestPriorityLane(renderLanes);
        var lane;

        switch (renderLane) {
          case InputContinuousLane:
            lane = InputContinuousHydrationLane;
            break;

          case DefaultLane:
            lane = DefaultHydrationLane;
            break;

          case TransitionLane1:
          case TransitionLane2:
          case TransitionLane3:
          case TransitionLane4:
          case TransitionLane5:
          case TransitionLane6:
          case TransitionLane7:
          case TransitionLane8:
          case TransitionLane9:
          case TransitionLane10:
          case TransitionLane11:
          case TransitionLane12:
          case TransitionLane13:
          case TransitionLane14:
          case TransitionLane15:
          case TransitionLane16:
          case RetryLane1:
          case RetryLane2:
          case RetryLane3:
          case RetryLane4:
          case RetryLane5:
            lane = TransitionHydrationLane;
            break;

          case IdleLane:
            lane = IdleHydrationLane;
            break;

          default:
            lane = NoLane;
            break;
        }

        if ((lane & (root.suspendedLanes | renderLanes)) !== NoLane) {
          return NoLane;
        }

        return lane;
      }

      function addFiberToLanesMap(root, fiber, lanes) {
        if (!isDevToolsPresent) {
          return;
        }

        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;

        while (lanes > 0) {
          var index = laneToIndex(lanes);
          var lane = 1 << index;
          var updaters = pendingUpdatersLaneMap[index];
          updaters.add(fiber);
          lanes &= ~lane;
        }
      }

      function movePendingFibersToMemoized(root, lanes) {
        if (!isDevToolsPresent) {
          return;
        }

        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        var memoizedUpdaters = root.memoizedUpdaters;

        while (lanes > 0) {
          var index = laneToIndex(lanes);
          var lane = 1 << index;
          var updaters = pendingUpdatersLaneMap[index];

          if (updaters.size > 0) {
            updaters.forEach(function (fiber) {
              var alternate = fiber.alternate;

              if (alternate === null || !memoizedUpdaters.has(alternate)) {
                memoizedUpdaters.add(fiber);
              }
            });
            updaters.clear();
          }

          lanes &= ~lane;
        }
      }

      function getTransitionsForLanes(root, lanes) {
        {
          return null;
        }
      }

      var DiscreteEventPriority = SyncLane;
      var ContinuousEventPriority = InputContinuousLane;
      var DefaultEventPriority = DefaultLane;
      var IdleEventPriority = IdleLane;
      var currentUpdatePriority = NoLane;

      function getCurrentUpdatePriority() {
        return currentUpdatePriority;
      }

      function setCurrentUpdatePriority(newPriority) {
        currentUpdatePriority = newPriority;
      }

      function runWithPriority(priority, fn) {
        var previousPriority = currentUpdatePriority;

        try {
          currentUpdatePriority = priority;
          return fn();
        } finally {
          currentUpdatePriority = previousPriority;
        }
      }

      function higherEventPriority(a, b) {
        return a !== 0 && a < b ? a : b;
      }

      function lowerEventPriority(a, b) {
        return a === 0 || a > b ? a : b;
      }

      function isHigherEventPriority(a, b) {
        return a !== 0 && a < b;
      }

      function lanesToEventPriority(lanes) {
        var lane = getHighestPriorityLane(lanes);

        if (!isHigherEventPriority(DiscreteEventPriority, lane)) {
          return DiscreteEventPriority;
        }

        if (!isHigherEventPriority(ContinuousEventPriority, lane)) {
          return ContinuousEventPriority;
        }

        if (includesNonIdleWork(lane)) {
          return DefaultEventPriority;
        }

        return IdleEventPriority;
      }

      function isRootDehydrated(root) {
        var currentState = root.current.memoizedState;
        return currentState.isDehydrated;
      }

      var _attemptSynchronousHydration;

      function setAttemptSynchronousHydration(fn) {
        _attemptSynchronousHydration = fn;
      }

      function attemptSynchronousHydration(fiber) {
        _attemptSynchronousHydration(fiber);
      }

      var attemptContinuousHydration;

      function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
      }

      var attemptHydrationAtCurrentPriority;

      function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
      }

      var getCurrentUpdatePriority$1;

      function setGetCurrentUpdatePriority(fn) {
        getCurrentUpdatePriority$1 = fn;
      }

      var attemptHydrationAtPriority;

      function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
      }

      var hasScheduledReplayAttempt = false;
      var queuedDiscreteEvents = [];
      var queuedFocus = null;
      var queuedDrag = null;
      var queuedMouse = null;
      var queuedPointers = new Map();
      var queuedPointerCaptures = new Map();
      var queuedExplicitHydrationTargets = [];
      var discreteReplayableEvents = ['mousedown', 'mouseup', 'touchcancel', 'touchend', 'touchstart', 'auxclick', 'dblclick', 'pointercancel', 'pointerdown', 'pointerup', 'dragend', 'dragstart', 'drop', 'compositionend', 'compositionstart', 'keydown', 'keypress', 'keyup', 'input', 'textInput', 'copy', 'cut', 'paste', 'click', 'change', 'contextmenu', 'reset', 'submit'];

      function isDiscreteEventThatRequiresHydration(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
      }

      function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
          blockedOn: blockedOn,
          domEventName: domEventName,
          eventSystemFlags: eventSystemFlags,
          nativeEvent: nativeEvent,
          targetContainers: [targetContainer]
        };
      }

      function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch (domEventName) {
          case 'focusin':
          case 'focusout':
            queuedFocus = null;
            break;

          case 'dragenter':
          case 'dragleave':
            queuedDrag = null;
            break;

          case 'mouseover':
          case 'mouseout':
            queuedMouse = null;
            break;

          case 'pointerover':
          case 'pointerout':
            {
              var pointerId = nativeEvent.pointerId;
              queuedPointers["delete"](pointerId);
              break;
            }

          case 'gotpointercapture':
          case 'lostpointercapture':
            {
              var _pointerId = nativeEvent.pointerId;
              queuedPointerCaptures["delete"](_pointerId);
              break;
            }
        }
      }

      function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
          var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);

          if (blockedOn !== null) {
            var _fiber2 = getInstanceFromNode(blockedOn);

            if (_fiber2 !== null) {
              attemptContinuousHydration(_fiber2);
            }
          }

          return queuedEvent;
        }

        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;

        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) {
          targetContainers.push(targetContainer);
        }

        return existingQueuedEvent;
      }

      function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        switch (domEventName) {
          case 'focusin':
            {
              var focusEvent = nativeEvent;
              queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
              return true;
            }

          case 'dragenter':
            {
              var dragEvent = nativeEvent;
              queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
              return true;
            }

          case 'mouseover':
            {
              var mouseEvent = nativeEvent;
              queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
              return true;
            }

          case 'pointerover':
            {
              var pointerEvent = nativeEvent;
              var pointerId = pointerEvent.pointerId;
              queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
              return true;
            }

          case 'gotpointercapture':
            {
              var _pointerEvent = nativeEvent;
              var _pointerId2 = _pointerEvent.pointerId;
              queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
              return true;
            }
        }

        return false;
      }

      function attemptExplicitHydrationTarget(queuedTarget) {
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);

        if (targetInst !== null) {
          var nearestMounted = getNearestMountedFiber(targetInst);

          if (nearestMounted !== null) {
            var tag = nearestMounted.tag;

            if (tag === SuspenseComponent) {
              var instance = getSuspenseInstanceFromFiber(nearestMounted);

              if (instance !== null) {
                queuedTarget.blockedOn = instance;
                attemptHydrationAtPriority(queuedTarget.priority, function () {
                  attemptHydrationAtCurrentPriority(nearestMounted);
                });
                return;
              }
            } else if (tag === HostRoot) {
              var root = nearestMounted.stateNode;

              if (isRootDehydrated(root)) {
                queuedTarget.blockedOn = getContainerFromFiber(nearestMounted);
                return;
              }
            }
          }
        }

        queuedTarget.blockedOn = null;
      }

      function queueExplicitHydrationTarget(target) {
        var updatePriority = getCurrentUpdatePriority$1();
        var queuedTarget = {
          blockedOn: null,
          target: target,
          priority: updatePriority
        };
        var i = 0;

        for (; i < queuedExplicitHydrationTargets.length; i++) {
          if (!isHigherEventPriority(updatePriority, queuedExplicitHydrationTargets[i].priority)) {
            break;
          }
        }

        queuedExplicitHydrationTargets.splice(i, 0, queuedTarget);

        if (i === 0) {
          attemptExplicitHydrationTarget(queuedTarget);
        }
      }

      function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) {
          return false;
        }

        var targetContainers = queuedEvent.targetContainers;

        while (targetContainers.length > 0) {
          var targetContainer = targetContainers[0];
          var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);

          if (nextBlockedOn === null) {
            {
              var nativeEvent = queuedEvent.nativeEvent;
              var nativeEventClone = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
              setReplayingEvent(nativeEventClone);
              nativeEvent.target.dispatchEvent(nativeEventClone);
              resetReplayingEvent();
            }
          } else {
            var _fiber3 = getInstanceFromNode(nextBlockedOn);

            if (_fiber3 !== null) {
              attemptContinuousHydration(_fiber3);
            }

            queuedEvent.blockedOn = nextBlockedOn;
            return false;
          }

          targetContainers.shift();
        }

        return true;
      }

      function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) {
          map["delete"](key);
        }
      }

      function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false;

        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) {
          queuedFocus = null;
        }

        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) {
          queuedDrag = null;
        }

        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) {
          queuedMouse = null;
        }

        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
      }

      function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
          queuedEvent.blockedOn = null;

          if (!hasScheduledReplayAttempt) {
            hasScheduledReplayAttempt = true;
            Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
          }
        }
      }

      function retryIfBlockedOn(unblocked) {
        if (queuedDiscreteEvents.length > 0) {
          scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked);

          for (var i = 1; i < queuedDiscreteEvents.length; i++) {
            var queuedEvent = queuedDiscreteEvents[i];

            if (queuedEvent.blockedOn === unblocked) {
              queuedEvent.blockedOn = null;
            }
          }
        }

        if (queuedFocus !== null) {
          scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        }

        if (queuedDrag !== null) {
          scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        }

        if (queuedMouse !== null) {
          scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        }

        var unblock = function unblock(queuedEvent) {
          return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };

        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);

        for (var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++) {
          var queuedTarget = queuedExplicitHydrationTargets[_i];

          if (queuedTarget.blockedOn === unblocked) {
            queuedTarget.blockedOn = null;
          }
        }

        while (queuedExplicitHydrationTargets.length > 0) {
          var nextExplicitTarget = queuedExplicitHydrationTargets[0];

          if (nextExplicitTarget.blockedOn !== null) {
            break;
          } else {
            attemptExplicitHydrationTarget(nextExplicitTarget);

            if (nextExplicitTarget.blockedOn === null) {
              queuedExplicitHydrationTargets.shift();
            }
          }
        }
      }

      var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
      var _enabled = true;

      function setEnabled(enabled) {
        _enabled = !!enabled;
      }

      function isEnabled() {
        return _enabled;
      }

      function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriority(domEventName);
        var listenerWrapper;

        switch (eventPriority) {
          case DiscreteEventPriority:
            listenerWrapper = dispatchDiscreteEvent;
            break;

          case ContinuousEventPriority:
            listenerWrapper = dispatchContinuousEvent;
            break;

          case DefaultEventPriority:
          default:
            listenerWrapper = dispatchEvent;
            break;
        }

        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
      }

      function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;

        try {
          setCurrentUpdatePriority(DiscreteEventPriority);
          dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally {
          setCurrentUpdatePriority(previousPriority);
          ReactCurrentBatchConfig.transition = prevTransition;
        }
      }

      function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;

        try {
          setCurrentUpdatePriority(ContinuousEventPriority);
          dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally {
          setCurrentUpdatePriority(previousPriority);
          ReactCurrentBatchConfig.transition = prevTransition;
        }
      }

      function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) {
          return;
        }

        {
          dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        }
      }

      function dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var blockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);

        if (blockedOn === null) {
          dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
          clearIfContinuousEvent(domEventName, nativeEvent);
          return;
        }

        if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
          nativeEvent.stopPropagation();
          return;
        }

        clearIfContinuousEvent(domEventName, nativeEvent);

        if (eventSystemFlags & IS_CAPTURE_PHASE && isDiscreteEventThatRequiresHydration(domEventName)) {
          while (blockedOn !== null) {
            var fiber = getInstanceFromNode(blockedOn);

            if (fiber !== null) {
              attemptSynchronousHydration(fiber);
            }

            var nextBlockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);

            if (nextBlockedOn === null) {
              dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
            }

            if (nextBlockedOn === blockedOn) {
              break;
            }

            blockedOn = nextBlockedOn;
          }

          if (blockedOn !== null) {
            nativeEvent.stopPropagation();
          }

          return;
        }

        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
      }

      var return_targetInst = null;

      function findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return_targetInst = null;
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);

        if (targetInst !== null) {
          var nearestMounted = getNearestMountedFiber(targetInst);

          if (nearestMounted === null) {
            targetInst = null;
          } else {
            var tag = nearestMounted.tag;

            if (tag === SuspenseComponent) {
              var instance = getSuspenseInstanceFromFiber(nearestMounted);

              if (instance !== null) {
                return instance;
              }

              targetInst = null;
            } else if (tag === HostRoot) {
              var root = nearestMounted.stateNode;

              if (isRootDehydrated(root)) {
                return getContainerFromFiber(nearestMounted);
              }

              targetInst = null;
            } else if (nearestMounted !== targetInst) {
              targetInst = null;
            }
          }
        }

        return_targetInst = targetInst;
        return null;
      }

      function getEventPriority(domEventName) {
        switch (domEventName) {
          case 'cancel':
          case 'click':
          case 'close':
          case 'contextmenu':
          case 'copy':
          case 'cut':
          case 'auxclick':
          case 'dblclick':
          case 'dragend':
          case 'dragstart':
          case 'drop':
          case 'focusin':
          case 'focusout':
          case 'input':
          case 'invalid':
          case 'keydown':
          case 'keypress':
          case 'keyup':
          case 'mousedown':
          case 'mouseup':
          case 'paste':
          case 'pause':
          case 'play':
          case 'pointercancel':
          case 'pointerdown':
          case 'pointerup':
          case 'ratechange':
          case 'reset':
          case 'resize':
          case 'seeked':
          case 'submit':
          case 'touchcancel':
          case 'touchend':
          case 'touchstart':
          case 'volumechange':
          case 'change':
          case 'selectionchange':
          case 'textInput':
          case 'compositionstart':
          case 'compositionend':
          case 'compositionupdate':
          case 'beforeblur':
          case 'afterblur':
          case 'beforeinput':
          case 'blur':
          case 'fullscreenchange':
          case 'focus':
          case 'hashchange':
          case 'popstate':
          case 'select':
          case 'selectstart':
            return DiscreteEventPriority;

          case 'drag':
          case 'dragenter':
          case 'dragexit':
          case 'dragleave':
          case 'dragover':
          case 'mousemove':
          case 'mouseout':
          case 'mouseover':
          case 'pointermove':
          case 'pointerout':
          case 'pointerover':
          case 'scroll':
          case 'toggle':
          case 'touchmove':
          case 'wheel':
          case 'mouseenter':
          case 'mouseleave':
          case 'pointerenter':
          case 'pointerleave':
            return ContinuousEventPriority;

          case 'message':
            {
              var schedulerPriority = getCurrentPriorityLevel();

              switch (schedulerPriority) {
                case ImmediatePriority:
                  return DiscreteEventPriority;

                case UserBlockingPriority:
                  return ContinuousEventPriority;

                case NormalPriority:
                case LowPriority:
                  return DefaultEventPriority;

                case IdlePriority:
                  return IdleEventPriority;

                default:
                  return DefaultEventPriority;
              }
            }

          default:
            return DefaultEventPriority;
        }
      }

      function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
      }

      function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
      }

      function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
          capture: true,
          passive: passive
        });
        return listener;
      }

      function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
          passive: passive
        });
        return listener;
      }

      var root = null;
      var startText = null;
      var fallbackText = null;

      function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
      }

      function reset() {
        root = null;
        startText = null;
        fallbackText = null;
      }

      function getData() {
        if (fallbackText) {
          return fallbackText;
        }

        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;

        for (start = 0; start < startLength; start++) {
          if (startValue[start] !== endValue[start]) {
            break;
          }
        }

        var minEnd = startLength - start;

        for (end = 1; end <= minEnd; end++) {
          if (startValue[startLength - end] !== endValue[endLength - end]) {
            break;
          }
        }

        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
      }

      function getText() {
        if ('value' in root) {
          return root.value;
        }

        return root.textContent;
      }

      function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;

        if ('charCode' in nativeEvent) {
          charCode = nativeEvent.charCode;

          if (charCode === 0 && keyCode === 13) {
            charCode = 13;
          }
        } else {
          charCode = keyCode;
        }

        if (charCode === 10) {
          charCode = 13;
        }

        if (charCode >= 32 || charCode === 13) {
          return charCode;
        }

        return 0;
      }

      function functionThatReturnsTrue() {
        return true;
      }

      function functionThatReturnsFalse() {
        return false;
      }

      function createSyntheticEvent(Interface) {
        function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
          this._reactName = reactName;
          this._targetInst = targetInst;
          this.type = reactEventType;
          this.nativeEvent = nativeEvent;
          this.target = nativeEventTarget;
          this.currentTarget = null;

          for (var _propName in Interface) {
            if (!Interface.hasOwnProperty(_propName)) {
              continue;
            }

            var normalize = Interface[_propName];

            if (normalize) {
              this[_propName] = normalize(nativeEvent);
            } else {
              this[_propName] = nativeEvent[_propName];
            }
          }

          var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;

          if (defaultPrevented) {
            this.isDefaultPrevented = functionThatReturnsTrue;
          } else {
            this.isDefaultPrevented = functionThatReturnsFalse;
          }

          this.isPropagationStopped = functionThatReturnsFalse;
          return this;
        }

        assign(SyntheticBaseEvent.prototype, {
          preventDefault: function preventDefault() {
            this.defaultPrevented = true;
            var event = this.nativeEvent;

            if (!event) {
              return;
            }

            if (event.preventDefault) {
              event.preventDefault();
            } else if (typeof event.returnValue !== 'unknown') {
              event.returnValue = false;
            }

            this.isDefaultPrevented = functionThatReturnsTrue;
          },
          stopPropagation: function stopPropagation() {
            var event = this.nativeEvent;

            if (!event) {
              return;
            }

            if (event.stopPropagation) {
              event.stopPropagation();
            } else if (typeof event.cancelBubble !== 'unknown') {
              event.cancelBubble = true;
            }

            this.isPropagationStopped = functionThatReturnsTrue;
          },
          persist: function persist() {},
          isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
      }

      var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function timeStamp(event) {
          return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
      };
      var SyntheticEvent = createSyntheticEvent(EventInterface);
      var UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
      });
      var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
      var lastMovementX;
      var lastMovementY;
      var lastMouseEvent;

      function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
          if (lastMouseEvent && event.type === 'mousemove') {
            lastMovementX = event.screenX - lastMouseEvent.screenX;
            lastMovementY = event.screenY - lastMouseEvent.screenY;
          } else {
            lastMovementX = 0;
            lastMovementY = 0;
          }

          lastMouseEvent = event;
        }
      }

      var MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function relatedTarget(event) {
          if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
          return event.relatedTarget;
        },
        movementX: function movementX(event) {
          if ('movementX' in event) {
            return event.movementX;
          }

          updateMouseMovementPolyfillState(event);
          return lastMovementX;
        },
        movementY: function movementY(event) {
          if ('movementY' in event) {
            return event.movementY;
          }

          return lastMovementY;
        }
      });
      var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
      var DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
      });
      var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
      var FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
      });
      var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
      var AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      });
      var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
      var ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function clipboardData(event) {
          return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
        }
      });
      var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
      var CompositionEventInterface = assign({}, EventInterface, {
        data: 0
      });
      var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
      var SyntheticInputEvent = SyntheticCompositionEvent;
      var normalizeKey = {
        Esc: 'Escape',
        Spacebar: ' ',
        Left: 'ArrowLeft',
        Up: 'ArrowUp',
        Right: 'ArrowRight',
        Down: 'ArrowDown',
        Del: 'Delete',
        Win: 'OS',
        Menu: 'ContextMenu',
        Apps: 'ContextMenu',
        Scroll: 'ScrollLock',
        MozPrintableKey: 'Unidentified'
      };
      var translateToKey = {
        '8': 'Backspace',
        '9': 'Tab',
        '12': 'Clear',
        '13': 'Enter',
        '16': 'Shift',
        '17': 'Control',
        '18': 'Alt',
        '19': 'Pause',
        '20': 'CapsLock',
        '27': 'Escape',
        '32': ' ',
        '33': 'PageUp',
        '34': 'PageDown',
        '35': 'End',
        '36': 'Home',
        '37': 'ArrowLeft',
        '38': 'ArrowUp',
        '39': 'ArrowRight',
        '40': 'ArrowDown',
        '45': 'Insert',
        '46': 'Delete',
        '112': 'F1',
        '113': 'F2',
        '114': 'F3',
        '115': 'F4',
        '116': 'F5',
        '117': 'F6',
        '118': 'F7',
        '119': 'F8',
        '120': 'F9',
        '121': 'F10',
        '122': 'F11',
        '123': 'F12',
        '144': 'NumLock',
        '145': 'ScrollLock',
        '224': 'Meta'
      };

      function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
          var key = normalizeKey[nativeEvent.key] || nativeEvent.key;

          if (key !== 'Unidentified') {
            return key;
          }
        }

        if (nativeEvent.type === 'keypress') {
          var charCode = getEventCharCode(nativeEvent);
          return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
        }

        if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
          return translateToKey[nativeEvent.keyCode] || 'Unidentified';
        }

        return '';
      }

      var modifierKeyToProp = {
        Alt: 'altKey',
        Control: 'ctrlKey',
        Meta: 'metaKey',
        Shift: 'shiftKey'
      };

      function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;

        if (nativeEvent.getModifierState) {
          return nativeEvent.getModifierState(keyArg);
        }

        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
      }

      function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
      }

      var KeyboardEventInterface = assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        charCode: function charCode(event) {
          if (event.type === 'keypress') {
            return getEventCharCode(event);
          }

          return 0;
        },
        keyCode: function keyCode(event) {
          if (event.type === 'keydown' || event.type === 'keyup') {
            return event.keyCode;
          }

          return 0;
        },
        which: function which(event) {
          if (event.type === 'keypress') {
            return getEventCharCode(event);
          }

          if (event.type === 'keydown' || event.type === 'keyup') {
            return event.keyCode;
          }

          return 0;
        }
      });
      var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
      var PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
      });
      var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
      var TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
      });
      var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
      var TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      });
      var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
      var WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function deltaX(event) {
          return 'deltaX' in event ? event.deltaX : 'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function deltaY(event) {
          return 'deltaY' in event ? event.deltaY : 'wheelDeltaY' in event ? -event.wheelDeltaY : 'wheelDelta' in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        deltaMode: 0
      });
      var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
      var END_KEYCODES = [9, 13, 27, 32];
      var START_KEYCODE = 229;
      var canUseCompositionEvent = canUseDOM && 'CompositionEvent' in window;
      var documentMode = null;

      if (canUseDOM && 'documentMode' in document) {
        documentMode = document.documentMode;
      }

      var canUseTextInputEvent = canUseDOM && 'TextEvent' in window && !documentMode;
      var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
      var SPACEBAR_CODE = 32;
      var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

      function registerEvents() {
        registerTwoPhaseEvent('onBeforeInput', ['compositionend', 'keypress', 'textInput', 'paste']);
        registerTwoPhaseEvent('onCompositionEnd', ['compositionend', 'focusout', 'keydown', 'keypress', 'keyup', 'mousedown']);
        registerTwoPhaseEvent('onCompositionStart', ['compositionstart', 'focusout', 'keydown', 'keypress', 'keyup', 'mousedown']);
        registerTwoPhaseEvent('onCompositionUpdate', ['compositionupdate', 'focusout', 'keydown', 'keypress', 'keyup', 'mousedown']);
      }

      var hasSpaceKeypress = false;

      function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && !(nativeEvent.ctrlKey && nativeEvent.altKey);
      }

      function getCompositionEventType(domEventName) {
        switch (domEventName) {
          case 'compositionstart':
            return 'onCompositionStart';

          case 'compositionend':
            return 'onCompositionEnd';

          case 'compositionupdate':
            return 'onCompositionUpdate';
        }
      }

      function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === 'keydown' && nativeEvent.keyCode === START_KEYCODE;
      }

      function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch (domEventName) {
          case 'keyup':
            return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;

          case 'keydown':
            return nativeEvent.keyCode !== START_KEYCODE;

          case 'keypress':
          case 'mousedown':
          case 'focusout':
            return true;

          default:
            return false;
        }
      }

      function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;

        if (typeof detail === 'object' && 'data' in detail) {
          return detail.data;
        }

        return null;
      }

      function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === 'ko';
      }

      var isComposing = false;

      function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;

        if (canUseCompositionEvent) {
          eventType = getCompositionEventType(domEventName);
        } else if (!isComposing) {
          if (isFallbackCompositionStart(domEventName, nativeEvent)) {
            eventType = 'onCompositionStart';
          }
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) {
          eventType = 'onCompositionEnd';
        }

        if (!eventType) {
          return null;
        }

        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
          if (!isComposing && eventType === 'onCompositionStart') {
            isComposing = initialize(nativeEventTarget);
          } else if (eventType === 'onCompositionEnd') {
            if (isComposing) {
              fallbackData = getData();
            }
          }
        }

        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);

        if (listeners.length > 0) {
          var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
          dispatchQueue.push({
            event: event,
            listeners: listeners
          });

          if (fallbackData) {
            event.data = fallbackData;
          } else {
            var customData = getDataFromCustomEvent(nativeEvent);

            if (customData !== null) {
              event.data = customData;
            }
          }
        }
      }

      function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch (domEventName) {
          case 'compositionend':
            return getDataFromCustomEvent(nativeEvent);

          case 'keypress':
            var which = nativeEvent.which;

            if (which !== SPACEBAR_CODE) {
              return null;
            }

            hasSpaceKeypress = true;
            return SPACEBAR_CHAR;

          case 'textInput':
            var chars = nativeEvent.data;

            if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
              return null;
            }

            return chars;

          default:
            return null;
        }
      }

      function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        if (isComposing) {
          if (domEventName === 'compositionend' || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
            var chars = getData();
            reset();
            isComposing = false;
            return chars;
          }

          return null;
        }

        switch (domEventName) {
          case 'paste':
            return null;

          case 'keypress':
            if (!isKeypressCommand(nativeEvent)) {
              if (nativeEvent["char"] && nativeEvent["char"].length > 1) {
                return nativeEvent["char"];
              } else if (nativeEvent.which) {
                return String.fromCharCode(nativeEvent.which);
              }
            }

            return null;

          case 'compositionend':
            return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;

          default:
            return null;
        }
      }

      function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;

        if (canUseTextInputEvent) {
          chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        } else {
          chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
        }

        if (!chars) {
          return null;
        }

        var listeners = accumulateTwoPhaseListeners(targetInst, 'onBeforeInput');

        if (listeners.length > 0) {
          var event = new SyntheticInputEvent('onBeforeInput', 'beforeinput', null, nativeEvent, nativeEventTarget);
          dispatchQueue.push({
            event: event,
            listeners: listeners
          });
          event.data = chars;
        }
      }

      function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
      }

      var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
      };

      function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

        if (nodeName === 'input') {
          return !!supportedInputTypes[elem.type];
        }

        if (nodeName === 'textarea') {
          return true;
        }

        return false;
      }

      function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) {
          return false;
        }

        var eventName = 'on' + eventNameSuffix;
        var isSupported = (eventName in document);

        if (!isSupported) {
          var element = document.createElement('div');
          element.setAttribute(eventName, 'return;');
          isSupported = typeof element[eventName] === 'function';
        }

        return isSupported;
      }

      function registerEvents$1() {
        registerTwoPhaseEvent('onChange', ['change', 'click', 'focusin', 'focusout', 'input', 'keydown', 'keyup', 'selectionchange']);
      }

      function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, 'onChange');

        if (listeners.length > 0) {
          var event = new SyntheticEvent('onChange', 'change', null, nativeEvent, target);
          dispatchQueue.push({
            event: event,
            listeners: listeners
          });
        }
      }

      var activeElement = null;
      var activeElementInst = null;

      function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
      }

      function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
        batchedUpdates(runEventInBatch, dispatchQueue);
      }

      function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
      }

      function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);

        if (updateValueIfChanged(targetNode)) {
          return targetInst;
        }
      }

      function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === 'change') {
          return targetInst;
        }
      }

      var isInputEventSupported = false;

      if (canUseDOM) {
        isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
      }

      function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent('onpropertychange', handlePropertyChange);
      }

      function stopWatchingForValueChange() {
        if (!activeElement) {
          return;
        }

        activeElement.detachEvent('onpropertychange', handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
      }

      function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== 'value') {
          return;
        }

        if (getInstIfValueChanged(activeElementInst)) {
          manualDispatchChangeEvent(nativeEvent);
        }
      }

      function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === 'focusin') {
          stopWatchingForValueChange();
          startWatchingForValueChange(target, targetInst);
        } else if (domEventName === 'focusout') {
          stopWatchingForValueChange();
        }
      }

      function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === 'selectionchange' || domEventName === 'keyup' || domEventName === 'keydown') {
          return getInstIfValueChanged(activeElementInst);
        }
      }

      function shouldUseClickEvent(elem) {
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
      }

      function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === 'click') {
          return getInstIfValueChanged(targetInst);
        }
      }

      function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === 'input' || domEventName === 'change') {
          return getInstIfValueChanged(targetInst);
        }
      }

      function handleControlledInputBlur(node) {
        var state = node._wrapperState;

        if (!state || !state.controlled || node.type !== 'number') {
          return;
        }

        {
          setDefaultValue(node, 'number', node.value);
        }
      }

      function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;

        if (shouldUseChangeEvent(targetNode)) {
          getTargetInstFunc = getTargetInstForChangeEvent;
        } else if (isTextInputElement(targetNode)) {
          if (isInputEventSupported) {
            getTargetInstFunc = getTargetInstForInputOrChangeEvent;
          } else {
            getTargetInstFunc = getTargetInstForInputEventPolyfill;
            handleEventFunc = handleEventsForInputEventPolyfill;
          }
        } else if (shouldUseClickEvent(targetNode)) {
          getTargetInstFunc = getTargetInstForClickEvent;
        }

        if (getTargetInstFunc) {
          var inst = getTargetInstFunc(domEventName, targetInst);

          if (inst) {
            createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
            return;
          }
        }

        if (handleEventFunc) {
          handleEventFunc(domEventName, targetNode, targetInst);
        }

        if (domEventName === 'focusout') {
          handleControlledInputBlur(targetNode);
        }
      }

      function registerEvents$2() {
        registerDirectEvent('onMouseEnter', ['mouseout', 'mouseover']);
        registerDirectEvent('onMouseLeave', ['mouseout', 'mouseover']);
        registerDirectEvent('onPointerEnter', ['pointerout', 'pointerover']);
        registerDirectEvent('onPointerLeave', ['pointerout', 'pointerover']);
      }

      function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === 'mouseover' || domEventName === 'pointerover';
        var isOutEvent = domEventName === 'mouseout' || domEventName === 'pointerout';

        if (isOverEvent && !isReplayingEvent(nativeEvent)) {
          var related = nativeEvent.relatedTarget || nativeEvent.fromElement;

          if (related) {
            if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) {
              return;
            }
          }
        }

        if (!isOutEvent && !isOverEvent) {
          return;
        }

        var win;

        if (nativeEventTarget.window === nativeEventTarget) {
          win = nativeEventTarget;
        } else {
          var doc = nativeEventTarget.ownerDocument;

          if (doc) {
            win = doc.defaultView || doc.parentWindow;
          } else {
            win = window;
          }
        }

        var from;
        var to;

        if (isOutEvent) {
          var _related = nativeEvent.relatedTarget || nativeEvent.toElement;

          from = targetInst;
          to = _related ? getClosestInstanceFromNode(_related) : null;

          if (to !== null) {
            var nearestMounted = getNearestMountedFiber(to);

            if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) {
              to = null;
            }
          }
        } else {
          from = null;
          to = targetInst;
        }

        if (from === to) {
          return;
        }

        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = 'onMouseLeave';
        var enterEventType = 'onMouseEnter';
        var eventTypePrefix = 'mouse';

        if (domEventName === 'pointerout' || domEventName === 'pointerover') {
          SyntheticEventCtor = SyntheticPointerEvent;
          leaveEventType = 'onPointerLeave';
          enterEventType = 'onPointerEnter';
          eventTypePrefix = 'pointer';
        }

        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + 'leave', from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null;
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);

        if (nativeTargetInst === targetInst) {
          var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + 'enter', to, nativeEvent, nativeEventTarget);
          enterEvent.target = toNode;
          enterEvent.relatedTarget = fromNode;
          enter = enterEvent;
        }

        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
      }

      function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y;
      }

      var objectIs = typeof Object.is === 'function' ? Object.is : is;

      function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) {
          return true;
        }

        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
          return false;
        }

        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);

        if (keysA.length !== keysB.length) {
          return false;
        }

        for (var i = 0; i < keysA.length; i++) {
          var currentKey = keysA[i];

          if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) {
            return false;
          }
        }

        return true;
      }

      function getLeafNode(node) {
        while (node && node.firstChild) {
          node = node.firstChild;
        }

        return node;
      }

      function getSiblingNode(node) {
        while (node) {
          if (node.nextSibling) {
            return node.nextSibling;
          }

          node = node.parentNode;
        }
      }

      function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;

        while (node) {
          if (node.nodeType === TEXT_NODE) {
            nodeEnd = nodeStart + node.textContent.length;

            if (nodeStart <= offset && nodeEnd >= offset) {
              return {
                node: node,
                offset: offset - nodeStart
              };
            }

            nodeStart = nodeEnd;
          }

          node = getLeafNode(getSiblingNode(node));
        }
      }

      function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();

        if (!selection || selection.rangeCount === 0) {
          return null;
        }

        var anchorNode = selection.anchorNode,
            anchorOffset = selection.anchorOffset,
            focusNode = selection.focusNode,
            focusOffset = selection.focusOffset;

        try {
          anchorNode.nodeType;
          focusNode.nodeType;
        } catch (e) {
          return null;
        }

        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
      }

      function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;

        outer: while (true) {
          var next = null;

          while (true) {
            if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) {
              start = length + anchorOffset;
            }

            if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) {
              end = length + focusOffset;
            }

            if (node.nodeType === TEXT_NODE) {
              length += node.nodeValue.length;
            }

            if ((next = node.firstChild) === null) {
              break;
            }

            parentNode = node;
            node = next;
          }

          while (true) {
            if (node === outerNode) {
              break outer;
            }

            if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) {
              start = length;
            }

            if (parentNode === focusNode && ++indexWithinFocus === focusOffset) {
              end = length;
            }

            if ((next = node.nextSibling) !== null) {
              break;
            }

            node = parentNode;
            parentNode = node.parentNode;
          }

          node = next;
        }

        if (start === -1 || end === -1) {
          return null;
        }

        return {
          start: start,
          end: end
        };
      }

      function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window;

        if (!win.getSelection) {
          return;
        }

        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

        if (!selection.extend && start > end) {
          var temp = end;
          end = start;
          start = temp;
        }

        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);

        if (startMarker && endMarker) {
          if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) {
            return;
          }

          var range = doc.createRange();
          range.setStart(startMarker.node, startMarker.offset);
          selection.removeAllRanges();

          if (start > end) {
            selection.addRange(range);
            selection.extend(endMarker.node, endMarker.offset);
          } else {
            range.setEnd(endMarker.node, endMarker.offset);
            selection.addRange(range);
          }
        }
      }

      function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
      }

      function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) {
          return false;
        } else if (outerNode === innerNode) {
          return true;
        } else if (isTextNode(outerNode)) {
          return false;
        } else if (isTextNode(innerNode)) {
          return containsNode(outerNode, innerNode.parentNode);
        } else if ('contains' in outerNode) {
          return outerNode.contains(innerNode);
        } else if (outerNode.compareDocumentPosition) {
          return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        } else {
          return false;
        }
      }

      function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
      }

      function isSameOriginFrame(iframe) {
        try {
          return typeof iframe.contentWindow.location.href === 'string';
        } catch (err) {
          return false;
        }
      }

      function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();

        while (element instanceof win.HTMLIFrameElement) {
          if (isSameOriginFrame(element)) {
            win = element.contentWindow;
          } else {
            return element;
          }

          element = getActiveElement(win.document);
        }

        return element;
      }

      function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === 'input' && (elem.type === 'text' || elem.type === 'search' || elem.type === 'tel' || elem.type === 'url' || elem.type === 'password') || nodeName === 'textarea' || elem.contentEditable === 'true');
      }

      function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
          focusedElem: focusedElem,
          selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
      }

      function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;

        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
          if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) {
            setSelection(priorFocusedElem, priorSelectionRange);
          }

          var ancestors = [];
          var ancestor = priorFocusedElem;

          while (ancestor = ancestor.parentNode) {
            if (ancestor.nodeType === ELEMENT_NODE) {
              ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
              });
            }
          }

          if (typeof priorFocusedElem.focus === 'function') {
            priorFocusedElem.focus();
          }

          for (var i = 0; i < ancestors.length; i++) {
            var info = ancestors[i];
            info.element.scrollLeft = info.left;
            info.element.scrollTop = info.top;
          }
        }
      }

      function getSelection(input) {
        var selection;

        if ('selectionStart' in input) {
          selection = {
            start: input.selectionStart,
            end: input.selectionEnd
          };
        } else {
          selection = getOffsets(input);
        }

        return selection || {
          start: 0,
          end: 0
        };
      }

      function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;

        if (end === undefined) {
          end = start;
        }

        if ('selectionStart' in input) {
          input.selectionStart = start;
          input.selectionEnd = Math.min(end, input.value.length);
        } else {
          setOffsets(input, offsets);
        }
      }

      var skipSelectionChangeEvent = canUseDOM && 'documentMode' in document && document.documentMode <= 11;

      function registerEvents$3() {
        registerTwoPhaseEvent('onSelect', ['focusout', 'contextmenu', 'dragend', 'focusin', 'keydown', 'keyup', 'mousedown', 'mouseup', 'selectionchange']);
      }

      var activeElement$1 = null;
      var activeElementInst$1 = null;
      var lastSelection = null;
      var mouseDown = false;

      function getSelection$1(node) {
        if ('selectionStart' in node && hasSelectionCapabilities(node)) {
          return {
            start: node.selectionStart,
            end: node.selectionEnd
          };
        } else {
          var win = node.ownerDocument && node.ownerDocument.defaultView || window;
          var selection = win.getSelection();
          return {
            anchorNode: selection.anchorNode,
            anchorOffset: selection.anchorOffset,
            focusNode: selection.focusNode,
            focusOffset: selection.focusOffset
          };
        }
      }

      function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
      }

      function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        var doc = getEventTargetDocument(nativeEventTarget);

        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) {
          return;
        }

        var currentSelection = getSelection$1(activeElement$1);

        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
          lastSelection = currentSelection;
          var listeners = accumulateTwoPhaseListeners(activeElementInst$1, 'onSelect');

          if (listeners.length > 0) {
            var event = new SyntheticEvent('onSelect', 'select', null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
              event: event,
              listeners: listeners
            });
            event.target = activeElement$1;
          }
        }
      }

      function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;

        switch (domEventName) {
          case 'focusin':
            if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
              activeElement$1 = targetNode;
              activeElementInst$1 = targetInst;
              lastSelection = null;
            }

            break;

          case 'focusout':
            activeElement$1 = null;
            activeElementInst$1 = null;
            lastSelection = null;
            break;

          case 'mousedown':
            mouseDown = true;
            break;

          case 'contextmenu':
          case 'mouseup':
          case 'dragend':
            mouseDown = false;
            constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            break;

          case 'selectionchange':
            if (skipSelectionChangeEvent) {
              break;
            }

          case 'keydown':
          case 'keyup':
            constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
      }

      function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes['Webkit' + styleProp] = 'webkit' + eventName;
        prefixes['Moz' + styleProp] = 'moz' + eventName;
        return prefixes;
      }

      var vendorPrefixes = {
        animationend: makePrefixMap('Animation', 'AnimationEnd'),
        animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
        animationstart: makePrefixMap('Animation', 'AnimationStart'),
        transitionend: makePrefixMap('Transition', 'TransitionEnd')
      };
      var prefixedEventNames = {};
      var style = {};

      if (canUseDOM) {
        style = document.createElement('div').style;

        if (!('AnimationEvent' in window)) {
          delete vendorPrefixes.animationend.animation;
          delete vendorPrefixes.animationiteration.animation;
          delete vendorPrefixes.animationstart.animation;
        }

        if (!('TransitionEvent' in window)) {
          delete vendorPrefixes.transitionend.transition;
        }
      }

      function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) {
          return prefixedEventNames[eventName];
        } else if (!vendorPrefixes[eventName]) {
          return eventName;
        }

        var prefixMap = vendorPrefixes[eventName];

        for (var styleProp in prefixMap) {
          if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
            return prefixedEventNames[eventName] = prefixMap[styleProp];
          }
        }

        return eventName;
      }

      var ANIMATION_END = getVendorPrefixedEventName('animationend');
      var ANIMATION_ITERATION = getVendorPrefixedEventName('animationiteration');
      var ANIMATION_START = getVendorPrefixedEventName('animationstart');
      var TRANSITION_END = getVendorPrefixedEventName('transitionend');
      var topLevelEventsToReactNames = new Map();
      var simpleEventPluginEvents = ['abort', 'auxClick', 'cancel', 'canPlay', 'canPlayThrough', 'click', 'close', 'contextMenu', 'copy', 'cut', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'gotPointerCapture', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'lostPointerCapture', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'pointerCancel', 'pointerDown', 'pointerMove', 'pointerOut', 'pointerOver', 'pointerUp', 'progress', 'rateChange', 'reset', 'resize', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchStart', 'volumeChange', 'scroll', 'toggle', 'touchMove', 'waiting', 'wheel'];

      function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [domEventName]);
      }

      function registerSimpleEvents() {
        for (var i = 0; i < simpleEventPluginEvents.length; i++) {
          var eventName = simpleEventPluginEvents[i];
          var domEventName = eventName.toLowerCase();
          var capitalizedEvent = eventName[0].toUpperCase() + eventName.slice(1);
          registerSimpleEvent(domEventName, 'on' + capitalizedEvent);
        }

        registerSimpleEvent(ANIMATION_END, 'onAnimationEnd');
        registerSimpleEvent(ANIMATION_ITERATION, 'onAnimationIteration');
        registerSimpleEvent(ANIMATION_START, 'onAnimationStart');
        registerSimpleEvent('dblclick', 'onDoubleClick');
        registerSimpleEvent('focusin', 'onFocus');
        registerSimpleEvent('focusout', 'onBlur');
        registerSimpleEvent(TRANSITION_END, 'onTransitionEnd');
      }

      function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);

        if (reactName === undefined) {
          return;
        }

        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;

        switch (domEventName) {
          case 'keypress':
            if (getEventCharCode(nativeEvent) === 0) {
              return;
            }

          case 'keydown':
          case 'keyup':
            SyntheticEventCtor = SyntheticKeyboardEvent;
            break;

          case 'focusin':
            reactEventType = 'focus';
            SyntheticEventCtor = SyntheticFocusEvent;
            break;

          case 'focusout':
            reactEventType = 'blur';
            SyntheticEventCtor = SyntheticFocusEvent;
            break;

          case 'beforeblur':
          case 'afterblur':
            SyntheticEventCtor = SyntheticFocusEvent;
            break;

          case 'click':
            if (nativeEvent.button === 2) {
              return;
            }

          case 'auxclick':
          case 'dblclick':
          case 'mousedown':
          case 'mousemove':
          case 'mouseup':
          case 'mouseout':
          case 'mouseover':
          case 'contextmenu':
            SyntheticEventCtor = SyntheticMouseEvent;
            break;

          case 'drag':
          case 'dragend':
          case 'dragenter':
          case 'dragexit':
          case 'dragleave':
          case 'dragover':
          case 'dragstart':
          case 'drop':
            SyntheticEventCtor = SyntheticDragEvent;
            break;

          case 'touchcancel':
          case 'touchend':
          case 'touchmove':
          case 'touchstart':
            SyntheticEventCtor = SyntheticTouchEvent;
            break;

          case ANIMATION_END:
          case ANIMATION_ITERATION:
          case ANIMATION_START:
            SyntheticEventCtor = SyntheticAnimationEvent;
            break;

          case TRANSITION_END:
            SyntheticEventCtor = SyntheticTransitionEvent;
            break;

          case 'scroll':
            SyntheticEventCtor = SyntheticUIEvent;
            break;

          case 'wheel':
            SyntheticEventCtor = SyntheticWheelEvent;
            break;

          case 'copy':
          case 'cut':
          case 'paste':
            SyntheticEventCtor = SyntheticClipboardEvent;
            break;

          case 'gotpointercapture':
          case 'lostpointercapture':
          case 'pointercancel':
          case 'pointerdown':
          case 'pointermove':
          case 'pointerout':
          case 'pointerover':
          case 'pointerup':
            SyntheticEventCtor = SyntheticPointerEvent;
            break;
        }

        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        {
          var accumulateTargetOnly = !inCapturePhase && domEventName === 'scroll';

          var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);

          if (_listeners.length > 0) {
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);

            dispatchQueue.push({
              event: _event,
              listeners: _listeners
            });
          }
        }
      }

      registerSimpleEvents();
      registerEvents$2();
      registerEvents$1();
      registerEvents$3();
      registerEvents();

      function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0;

        if (shouldProcessPolyfillPlugins) {
          extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
          extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
          extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
          extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
      }

      var mediaEventTypes = ['abort', 'canplay', 'canplaythrough', 'durationchange', 'emptied', 'encrypted', 'ended', 'error', 'loadeddata', 'loadedmetadata', 'loadstart', 'pause', 'play', 'playing', 'progress', 'ratechange', 'resize', 'seeked', 'seeking', 'stalled', 'suspend', 'timeupdate', 'volumechange', 'waiting'];
      var nonDelegatedEvents = new Set(['cancel', 'close', 'invalid', 'load', 'scroll', 'toggle'].concat(mediaEventTypes));

      function executeDispatch(event, listener, currentTarget) {
        var type = event.type || 'unknown-event';
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
      }

      function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;

        if (inCapturePhase) {
          for (var i = dispatchListeners.length - 1; i >= 0; i--) {
            var _dispatchListeners$i = dispatchListeners[i],
                instance = _dispatchListeners$i.instance,
                currentTarget = _dispatchListeners$i.currentTarget,
                listener = _dispatchListeners$i.listener;

            if (instance !== previousInstance && event.isPropagationStopped()) {
              return;
            }

            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
          }
        } else {
          for (var _i = 0; _i < dispatchListeners.length; _i++) {
            var _dispatchListeners$_i = dispatchListeners[_i],
                _instance = _dispatchListeners$_i.instance,
                _currentTarget = _dispatchListeners$_i.currentTarget,
                _listener = _dispatchListeners$_i.listener;

            if (_instance !== previousInstance && event.isPropagationStopped()) {
              return;
            }

            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
          }
        }
      }

      function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;

        for (var i = 0; i < dispatchQueue.length; i++) {
          var _dispatchQueue$i = dispatchQueue[i],
              event = _dispatchQueue$i.event,
              listeners = _dispatchQueue$i.listeners;
          processDispatchQueueItemsInOrder(event, listeners, inCapturePhase);
        }

        rethrowCaughtError();
      }

      function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
      }

      function listenToNonDelegatedEvent(domEventName, targetElement) {
        {
          if (!nonDelegatedEvents.has(domEventName)) {
            error('Did not expect a listenToNonDelegatedEvent() call for "%s". ' + 'This is a bug in React. Please file an issue.', domEventName);
          }
        }
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);

        if (!listenerSet.has(listenerSetKey)) {
          addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
          listenerSet.add(listenerSetKey);
        }
      }

      function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        {
          if (nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener) {
            error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. ' + 'This is a bug in React. Please file an issue.', domEventName);
          }
        }
        var eventSystemFlags = 0;

        if (isCapturePhaseListener) {
          eventSystemFlags |= IS_CAPTURE_PHASE;
        }

        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
      }

      var listeningMarker = '_reactListening' + Math.random().toString(36).slice(2);

      function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
          rootContainerElement[listeningMarker] = true;
          allNativeEvents.forEach(function (domEventName) {
            if (domEventName !== 'selectionchange') {
              if (!nonDelegatedEvents.has(domEventName)) {
                listenToNativeEvent(domEventName, false, rootContainerElement);
              }

              listenToNativeEvent(domEventName, true, rootContainerElement);
            }
          });
          var ownerDocument = rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;

          if (ownerDocument !== null) {
            if (!ownerDocument[listeningMarker]) {
              ownerDocument[listeningMarker] = true;
              listenToNativeEvent('selectionchange', false, ownerDocument);
            }
          }
        }
      }

      function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags);
        var isPassiveListener = undefined;

        if (passiveBrowserEventsSupported) {
          if (domEventName === 'touchstart' || domEventName === 'touchmove' || domEventName === 'wheel') {
            isPassiveListener = true;
          }
        }

        targetContainer = targetContainer;
        var unsubscribeListener;

        if (isCapturePhaseListener) {
          if (isPassiveListener !== undefined) {
            unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
          } else {
            unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
          }
        } else {
          if (isPassiveListener !== undefined) {
            unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
          } else {
            unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
          }
        }
      }

      function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
      }

      function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;

        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
          var targetContainerNode = targetContainer;

          if (targetInst !== null) {
            var node = targetInst;

            mainLoop: while (true) {
              if (node === null) {
                return;
              }

              var nodeTag = node.tag;

              if (nodeTag === HostRoot || nodeTag === HostPortal) {
                var container = node.stateNode.containerInfo;

                if (isMatchingRootContainer(container, targetContainerNode)) {
                  break;
                }

                if (nodeTag === HostPortal) {
                  var grandNode = node["return"];

                  while (grandNode !== null) {
                    var grandTag = grandNode.tag;

                    if (grandTag === HostRoot || grandTag === HostPortal) {
                      var grandContainer = grandNode.stateNode.containerInfo;

                      if (isMatchingRootContainer(grandContainer, targetContainerNode)) {
                        return;
                      }
                    }

                    grandNode = grandNode["return"];
                  }
                }

                while (container !== null) {
                  var parentNode = getClosestInstanceFromNode(container);

                  if (parentNode === null) {
                    return;
                  }

                  var parentTag = parentNode.tag;

                  if (parentTag === HostComponent || parentTag === HostText) {
                    node = ancestorInst = parentNode;
                    continue mainLoop;
                  }

                  container = container.parentNode;
                }
              }

              node = node["return"];
            }
          }
        }

        batchedUpdates(function () {
          return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
      }

      function createDispatchListener(instance, listener, currentTarget) {
        return {
          instance: instance,
          listener: listener,
          currentTarget: currentTarget
        };
      }

      function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly, nativeEvent) {
        var captureName = reactName !== null ? reactName + 'Capture' : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null;

        while (instance !== null) {
          var _instance2 = instance,
              stateNode = _instance2.stateNode,
              tag = _instance2.tag;

          if (tag === HostComponent && stateNode !== null) {
            lastHostComponent = stateNode;

            if (reactEventName !== null) {
              var listener = getListener(instance, reactEventName);

              if (listener != null) {
                listeners.push(createDispatchListener(instance, listener, lastHostComponent));
              }
            }
          }

          if (accumulateTargetOnly) {
            break;
          }

          instance = instance["return"];
        }

        return listeners;
      }

      function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + 'Capture';
        var listeners = [];
        var instance = targetFiber;

        while (instance !== null) {
          var _instance3 = instance,
              stateNode = _instance3.stateNode,
              tag = _instance3.tag;

          if (tag === HostComponent && stateNode !== null) {
            var currentTarget = stateNode;
            var captureListener = getListener(instance, captureName);

            if (captureListener != null) {
              listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
            }

            var bubbleListener = getListener(instance, reactName);

            if (bubbleListener != null) {
              listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
          }

          instance = instance["return"];
        }

        return listeners;
      }

      function getParent(inst) {
        if (inst === null) {
          return null;
        }

        do {
          inst = inst["return"];
        } while (inst && inst.tag !== HostComponent);

        if (inst) {
          return inst;
        }

        return null;
      }

      function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;

        for (var tempA = nodeA; tempA; tempA = getParent(tempA)) {
          depthA++;
        }

        var depthB = 0;

        for (var tempB = nodeB; tempB; tempB = getParent(tempB)) {
          depthB++;
        }

        while (depthA - depthB > 0) {
          nodeA = getParent(nodeA);
          depthA--;
        }

        while (depthB - depthA > 0) {
          nodeB = getParent(nodeB);
          depthB--;
        }

        var depth = depthA;

        while (depth--) {
          if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) {
            return nodeA;
          }

          nodeA = getParent(nodeA);
          nodeB = getParent(nodeB);
        }

        return null;
      }

      function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;

        while (instance !== null) {
          if (instance === common) {
            break;
          }

          var _instance4 = instance,
              alternate = _instance4.alternate,
              stateNode = _instance4.stateNode,
              tag = _instance4.tag;

          if (alternate !== null && alternate === common) {
            break;
          }

          if (tag === HostComponent && stateNode !== null) {
            var currentTarget = stateNode;

            if (inCapturePhase) {
              var captureListener = getListener(instance, registrationName);

              if (captureListener != null) {
                listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
              }
            } else if (!inCapturePhase) {
              var bubbleListener = getListener(instance, registrationName);

              if (bubbleListener != null) {
                listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
              }
            }
          }

          instance = instance["return"];
        }

        if (listeners.length !== 0) {
          dispatchQueue.push({
            event: event,
            listeners: listeners
          });
        }
      }

      function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;

        if (from !== null) {
          accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        }

        if (to !== null && enterEvent !== null) {
          accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
        }
      }

      function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? 'capture' : 'bubble');
      }

      var didWarnInvalidHydration = false;
      var DANGEROUSLY_SET_INNER_HTML = 'dangerouslySetInnerHTML';
      var SUPPRESS_CONTENT_EDITABLE_WARNING = 'suppressContentEditableWarning';
      var SUPPRESS_HYDRATION_WARNING = 'suppressHydrationWarning';
      var AUTOFOCUS = 'autoFocus';
      var CHILDREN = 'children';
      var STYLE = 'style';
      var HTML$1 = '__html';
      var warnedUnknownTags;
      var validatePropertiesInDevelopment;
      var warnForPropDifference;
      var warnForExtraAttributes;
      var warnForInvalidEventListener;
      var canDiffStyleForHydrationWarning;
      var normalizeHTML;
      {
        warnedUnknownTags = {
          dialog: true,
          webview: true
        };

        validatePropertiesInDevelopment = function validatePropertiesInDevelopment(type, props) {
          validateProperties(type, props);
          validateProperties$1(type, props);
          validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
          });
        };

        canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode;

        warnForPropDifference = function warnForPropDifference(propName, serverValue, clientValue) {
          if (didWarnInvalidHydration) {
            return;
          }

          var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
          var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);

          if (normalizedServerValue === normalizedClientValue) {
            return;
          }

          didWarnInvalidHydration = true;
          error('Prop `%s` did not match. Server: %s Client: %s', propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
        };

        warnForExtraAttributes = function warnForExtraAttributes(attributeNames) {
          if (didWarnInvalidHydration) {
            return;
          }

          didWarnInvalidHydration = true;
          var names = [];
          attributeNames.forEach(function (name) {
            names.push(name);
          });
          error('Extra attributes from the server: %s', names);
        };

        warnForInvalidEventListener = function warnForInvalidEventListener(registrationName, listener) {
          if (listener === false) {
            error('Expected `%s` listener to be a function, instead got `false`.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', registrationName, registrationName, registrationName);
          } else {
            error('Expected `%s` listener to be a function, instead got a value of `%s` type.', registrationName, typeof listener);
          }
        };

        normalizeHTML = function normalizeHTML(parent, html) {
          var testElement = parent.namespaceURI === HTML_NAMESPACE ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
          testElement.innerHTML = html;
          return testElement.innerHTML;
        };
      }
      var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
      var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;

      function normalizeMarkupForTextOrAttribute(markup) {
        {
          checkHtmlStringCoercion(markup);
        }
        var markupString = typeof markup === 'string' ? markup : '' + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, '\n').replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, '');
      }

      function checkForUnmatchedText(serverText, clientText, isConcurrentMode, shouldWarnDev) {
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);

        if (normalizedServerText === normalizedClientText) {
          return;
        }

        if (shouldWarnDev) {
          {
            if (!didWarnInvalidHydration) {
              didWarnInvalidHydration = true;
              error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
            }
          }
        }

        if (isConcurrentMode && enableClientRenderFallbackOnTextMismatch) {
          throw new Error('Text content does not match server-rendered HTML.');
        }
      }

      function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
      }

      function noop() {}

      function trapClickOnNonInteractiveElement(node) {
        node.onclick = noop;
      }

      function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for (var propKey in nextProps) {
          if (!nextProps.hasOwnProperty(propKey)) {
            continue;
          }

          var nextProp = nextProps[propKey];

          if (propKey === STYLE) {
            {
              if (nextProp) {
                Object.freeze(nextProp);
              }
            }
            setValueForStyles(domElement, nextProp);
          } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
            var nextHtml = nextProp ? nextProp[HTML$1] : undefined;

            if (nextHtml != null) {
              setInnerHTML(domElement, nextHtml);
            }
          } else if (propKey === CHILDREN) {
            if (typeof nextProp === 'string') {
              var canSetTextContent = tag !== 'textarea' || nextProp !== '';

              if (canSetTextContent) {
                setTextContent(domElement, nextProp);
              }
            } else if (typeof nextProp === 'number') {
              setTextContent(domElement, '' + nextProp);
            }
          } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;else if (propKey === AUTOFOCUS) ;else if (registrationNameDependencies.hasOwnProperty(propKey)) {
            if (nextProp != null) {
              if (typeof nextProp !== 'function') {
                warnForInvalidEventListener(propKey, nextProp);
              }

              if (propKey === 'onScroll') {
                listenToNonDelegatedEvent('scroll', domElement);
              }
            }
          } else if (nextProp != null) {
            setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
          }
        }
      }

      function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        for (var i = 0; i < updatePayload.length; i += 2) {
          var propKey = updatePayload[i];
          var propValue = updatePayload[i + 1];

          if (propKey === STYLE) {
            setValueForStyles(domElement, propValue);
          } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
            setInnerHTML(domElement, propValue);
          } else if (propKey === CHILDREN) {
            setTextContent(domElement, propValue);
          } else {
            setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
          }
        }
      }

      function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag;
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;

        if (namespaceURI === HTML_NAMESPACE) {
          namespaceURI = getIntrinsicNamespace(type);
        }

        if (namespaceURI === HTML_NAMESPACE) {
          {
            isCustomComponentTag = isCustomComponent(type, props);

            if (!isCustomComponentTag && type !== type.toLowerCase()) {
              error('<%s /> is using incorrect casing. ' + 'Use PascalCase for React components, ' + 'or lowercase for HTML elements.', type);
            }
          }

          if (type === 'script') {
            var div = ownerDocument.createElement('div');
            div.innerHTML = '<script><' + '/script>';
            var firstChild = div.firstChild;
            domElement = div.removeChild(firstChild);
          } else if (typeof props.is === 'string') {
            domElement = ownerDocument.createElement(type, {
              is: props.is
            });
          } else {
            domElement = ownerDocument.createElement(type);

            if (type === 'select') {
              var node = domElement;

              if (props.multiple) {
                node.multiple = true;
              } else if (props.size) {
                node.size = props.size;
              }
            }
          }
        } else {
          domElement = ownerDocument.createElementNS(namespaceURI, type);
        }

        {
          if (namespaceURI === HTML_NAMESPACE) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === '[object HTMLUnknownElement]' && !hasOwnProperty.call(warnedUnknownTags, type)) {
              warnedUnknownTags[type] = true;
              error('The tag <%s> is unrecognized in this browser. ' + 'If you meant to render a React component, start its name with ' + 'an uppercase letter.', type);
            }
          }
        }
        return domElement;
      }

      function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
      }

      function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        {
          validatePropertiesInDevelopment(tag, rawProps);
        }
        var props;

        switch (tag) {
          case 'dialog':
            listenToNonDelegatedEvent('cancel', domElement);
            listenToNonDelegatedEvent('close', domElement);
            props = rawProps;
            break;

          case 'iframe':
          case 'object':
          case 'embed':
            listenToNonDelegatedEvent('load', domElement);
            props = rawProps;
            break;

          case 'video':
          case 'audio':
            for (var i = 0; i < mediaEventTypes.length; i++) {
              listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
            }

            props = rawProps;
            break;

          case 'source':
            listenToNonDelegatedEvent('error', domElement);
            props = rawProps;
            break;

          case 'img':
          case 'image':
          case 'link':
            listenToNonDelegatedEvent('error', domElement);
            listenToNonDelegatedEvent('load', domElement);
            props = rawProps;
            break;

          case 'details':
            listenToNonDelegatedEvent('toggle', domElement);
            props = rawProps;
            break;

          case 'input':
            initWrapperState(domElement, rawProps);
            props = getHostProps(domElement, rawProps);
            listenToNonDelegatedEvent('invalid', domElement);
            break;

          case 'option':
            validateProps(domElement, rawProps);
            props = rawProps;
            break;

          case 'select':
            initWrapperState$1(domElement, rawProps);
            props = getHostProps$1(domElement, rawProps);
            listenToNonDelegatedEvent('invalid', domElement);
            break;

          case 'textarea':
            initWrapperState$2(domElement, rawProps);
            props = getHostProps$2(domElement, rawProps);
            listenToNonDelegatedEvent('invalid', domElement);
            break;

          default:
            props = rawProps;
        }

        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);

        switch (tag) {
          case 'input':
            track(domElement);
            postMountWrapper(domElement, rawProps, false);
            break;

          case 'textarea':
            track(domElement);
            postMountWrapper$3(domElement);
            break;

          case 'option':
            postMountWrapper$1(domElement, rawProps);
            break;

          case 'select':
            postMountWrapper$2(domElement, rawProps);
            break;

          default:
            if (typeof props.onClick === 'function') {
              trapClickOnNonInteractiveElement(domElement);
            }

            break;
        }
      }

      function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        {
          validatePropertiesInDevelopment(tag, nextRawProps);
        }
        var updatePayload = null;
        var lastProps;
        var nextProps;

        switch (tag) {
          case 'input':
            lastProps = getHostProps(domElement, lastRawProps);
            nextProps = getHostProps(domElement, nextRawProps);
            updatePayload = [];
            break;

          case 'select':
            lastProps = getHostProps$1(domElement, lastRawProps);
            nextProps = getHostProps$1(domElement, nextRawProps);
            updatePayload = [];
            break;

          case 'textarea':
            lastProps = getHostProps$2(domElement, lastRawProps);
            nextProps = getHostProps$2(domElement, nextRawProps);
            updatePayload = [];
            break;

          default:
            lastProps = lastRawProps;
            nextProps = nextRawProps;

            if (typeof lastProps.onClick !== 'function' && typeof nextProps.onClick === 'function') {
              trapClickOnNonInteractiveElement(domElement);
            }

            break;
        }

        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;

        for (propKey in lastProps) {
          if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
            continue;
          }

          if (propKey === STYLE) {
            var lastStyle = lastProps[propKey];

            for (styleName in lastStyle) {
              if (lastStyle.hasOwnProperty(styleName)) {
                if (!styleUpdates) {
                  styleUpdates = {};
                }

                styleUpdates[styleName] = '';
              }
            }
          } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;else if (propKey === AUTOFOCUS) ;else if (registrationNameDependencies.hasOwnProperty(propKey)) {
            if (!updatePayload) {
              updatePayload = [];
            }
          } else {
            (updatePayload = updatePayload || []).push(propKey, null);
          }
        }

        for (propKey in nextProps) {
          var nextProp = nextProps[propKey];
          var lastProp = lastProps != null ? lastProps[propKey] : undefined;

          if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
            continue;
          }

          if (propKey === STYLE) {
            {
              if (nextProp) {
                Object.freeze(nextProp);
              }
            }

            if (lastProp) {
              for (styleName in lastProp) {
                if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                  if (!styleUpdates) {
                    styleUpdates = {};
                  }

                  styleUpdates[styleName] = '';
                }
              }

              for (styleName in nextProp) {
                if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                  if (!styleUpdates) {
                    styleUpdates = {};
                  }

                  styleUpdates[styleName] = nextProp[styleName];
                }
              }
            } else {
              if (!styleUpdates) {
                if (!updatePayload) {
                  updatePayload = [];
                }

                updatePayload.push(propKey, styleUpdates);
              }

              styleUpdates = nextProp;
            }
          } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
            var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
            var lastHtml = lastProp ? lastProp[HTML$1] : undefined;

            if (nextHtml != null) {
              if (lastHtml !== nextHtml) {
                (updatePayload = updatePayload || []).push(propKey, nextHtml);
              }
            }
          } else if (propKey === CHILDREN) {
            if (typeof nextProp === 'string' || typeof nextProp === 'number') {
              (updatePayload = updatePayload || []).push(propKey, '' + nextProp);
            }
          } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;else if (registrationNameDependencies.hasOwnProperty(propKey)) {
            if (nextProp != null) {
              if (typeof nextProp !== 'function') {
                warnForInvalidEventListener(propKey, nextProp);
              }

              if (propKey === 'onScroll') {
                listenToNonDelegatedEvent('scroll', domElement);
              }
            }

            if (!updatePayload && lastProp !== nextProp) {
              updatePayload = [];
            }
          } else {
            (updatePayload = updatePayload || []).push(propKey, nextProp);
          }
        }

        if (styleUpdates) {
          {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
          }
          (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }

        return updatePayload;
      }

      function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        if (tag === 'input' && nextRawProps.type === 'radio' && nextRawProps.name != null) {
          updateChecked(domElement, nextRawProps);
        }

        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps);
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag);

        switch (tag) {
          case 'input':
            updateWrapper(domElement, nextRawProps);
            break;

          case 'textarea':
            updateWrapper$1(domElement, nextRawProps);
            break;

          case 'select':
            postUpdateWrapper(domElement, nextRawProps);
            break;
        }
      }

      function getPossibleStandardName(propName) {
        {
          var lowerCasedName = propName.toLowerCase();

          if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            return null;
          }

          return possibleStandardNames[lowerCasedName] || null;
        }
      }

      function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement, isConcurrentMode, shouldWarnDev) {
        var isCustomComponentTag;
        var extraAttributeNames;
        {
          isCustomComponentTag = isCustomComponent(tag, rawProps);
          validatePropertiesInDevelopment(tag, rawProps);
        }

        switch (tag) {
          case 'dialog':
            listenToNonDelegatedEvent('cancel', domElement);
            listenToNonDelegatedEvent('close', domElement);
            break;

          case 'iframe':
          case 'object':
          case 'embed':
            listenToNonDelegatedEvent('load', domElement);
            break;

          case 'video':
          case 'audio':
            for (var i = 0; i < mediaEventTypes.length; i++) {
              listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
            }

            break;

          case 'source':
            listenToNonDelegatedEvent('error', domElement);
            break;

          case 'img':
          case 'image':
          case 'link':
            listenToNonDelegatedEvent('error', domElement);
            listenToNonDelegatedEvent('load', domElement);
            break;

          case 'details':
            listenToNonDelegatedEvent('toggle', domElement);
            break;

          case 'input':
            initWrapperState(domElement, rawProps);
            listenToNonDelegatedEvent('invalid', domElement);
            break;

          case 'option':
            validateProps(domElement, rawProps);
            break;

          case 'select':
            initWrapperState$1(domElement, rawProps);
            listenToNonDelegatedEvent('invalid', domElement);
            break;

          case 'textarea':
            initWrapperState$2(domElement, rawProps);
            listenToNonDelegatedEvent('invalid', domElement);
            break;
        }

        assertValidProps(tag, rawProps);
        {
          extraAttributeNames = new Set();
          var attributes = domElement.attributes;

          for (var _i = 0; _i < attributes.length; _i++) {
            var name = attributes[_i].name.toLowerCase();

            switch (name) {
              case 'value':
                break;

              case 'checked':
                break;

              case 'selected':
                break;

              default:
                extraAttributeNames.add(attributes[_i].name);
            }
          }
        }
        var updatePayload = null;

        for (var propKey in rawProps) {
          if (!rawProps.hasOwnProperty(propKey)) {
            continue;
          }

          var nextProp = rawProps[propKey];

          if (propKey === CHILDREN) {
            if (typeof nextProp === 'string') {
              if (domElement.textContent !== nextProp) {
                if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) {
                  checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                }

                updatePayload = [CHILDREN, nextProp];
              }
            } else if (typeof nextProp === 'number') {
              if (domElement.textContent !== '' + nextProp) {
                if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) {
                  checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                }

                updatePayload = [CHILDREN, '' + nextProp];
              }
            }
          } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
            if (nextProp != null) {
              if (typeof nextProp !== 'function') {
                warnForInvalidEventListener(propKey, nextProp);
              }

              if (propKey === 'onScroll') {
                listenToNonDelegatedEvent('scroll', domElement);
              }
            }
          } else if (shouldWarnDev && true && typeof isCustomComponentTag === 'boolean') {
            var serverValue = void 0;
            var propertyInfo = isCustomComponentTag && enableCustomElementPropertySupport ? null : getPropertyInfo(propKey);
            if (rawProps[SUPPRESS_HYDRATION_WARNING] === true) ;else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || propKey === 'value' || propKey === 'checked' || propKey === 'selected') ;else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
              var serverHTML = domElement.innerHTML;
              var nextHtml = nextProp ? nextProp[HTML$1] : undefined;

              if (nextHtml != null) {
                var expectedHTML = normalizeHTML(domElement, nextHtml);

                if (expectedHTML !== serverHTML) {
                  warnForPropDifference(propKey, serverHTML, expectedHTML);
                }
              }
            } else if (propKey === STYLE) {
              extraAttributeNames["delete"](propKey);

              if (canDiffStyleForHydrationWarning) {
                var expectedStyle = createDangerousStringForStyles(nextProp);
                serverValue = domElement.getAttribute('style');

                if (expectedStyle !== serverValue) {
                  warnForPropDifference(propKey, serverValue, expectedStyle);
                }
              }
            } else if (isCustomComponentTag && !enableCustomElementPropertySupport) {
              extraAttributeNames["delete"](propKey.toLowerCase());
              serverValue = getValueForAttribute(domElement, propKey, nextProp);

              if (nextProp !== serverValue) {
                warnForPropDifference(propKey, serverValue, nextProp);
              }
            } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
              var isMismatchDueToBadCasing = false;

              if (propertyInfo !== null) {
                extraAttributeNames["delete"](propertyInfo.attributeName);
                serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
              } else {
                var ownNamespace = parentNamespace;

                if (ownNamespace === HTML_NAMESPACE) {
                  ownNamespace = getIntrinsicNamespace(tag);
                }

                if (ownNamespace === HTML_NAMESPACE) {
                  extraAttributeNames["delete"](propKey.toLowerCase());
                } else {
                  var standardName = getPossibleStandardName(propKey);

                  if (standardName !== null && standardName !== propKey) {
                    isMismatchDueToBadCasing = true;
                    extraAttributeNames["delete"](standardName);
                  }

                  extraAttributeNames["delete"](propKey);
                }

                serverValue = getValueForAttribute(domElement, propKey, nextProp);
              }

              var dontWarnCustomElement = enableCustomElementPropertySupport;

              if (!dontWarnCustomElement && nextProp !== serverValue && !isMismatchDueToBadCasing) {
                warnForPropDifference(propKey, serverValue, nextProp);
              }
            }
          }
        }

        {
          if (shouldWarnDev) {
            if (extraAttributeNames.size > 0 && rawProps[SUPPRESS_HYDRATION_WARNING] !== true) {
              warnForExtraAttributes(extraAttributeNames);
            }
          }
        }

        switch (tag) {
          case 'input':
            track(domElement);
            postMountWrapper(domElement, rawProps, true);
            break;

          case 'textarea':
            track(domElement);
            postMountWrapper$3(domElement);
            break;

          case 'select':
          case 'option':
            break;

          default:
            if (typeof rawProps.onClick === 'function') {
              trapClickOnNonInteractiveElement(domElement);
            }

            break;
        }

        return updatePayload;
      }

      function diffHydratedText(textNode, text, isConcurrentMode) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
      }

      function warnForDeletedHydratableElement(parentNode, child) {
        {
          if (didWarnInvalidHydration) {
            return;
          }

          didWarnInvalidHydration = true;
          error('Did not expect server HTML to contain a <%s> in <%s>.', child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
        }
      }

      function warnForDeletedHydratableText(parentNode, child) {
        {
          if (didWarnInvalidHydration) {
            return;
          }

          didWarnInvalidHydration = true;
          error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
        }
      }

      function warnForInsertedHydratedElement(parentNode, tag, props) {
        {
          if (didWarnInvalidHydration) {
            return;
          }

          didWarnInvalidHydration = true;
          error('Expected server HTML to contain a matching <%s> in <%s>.', tag, parentNode.nodeName.toLowerCase());
        }
      }

      function warnForInsertedHydratedText(parentNode, text) {
        {
          if (text === '') {
            return;
          }

          if (didWarnInvalidHydration) {
            return;
          }

          didWarnInvalidHydration = true;
          error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
        }
      }

      function restoreControlledState$3(domElement, tag, props) {
        switch (tag) {
          case 'input':
            restoreControlledState(domElement, props);
            return;

          case 'textarea':
            restoreControlledState$2(domElement, props);
            return;

          case 'select':
            restoreControlledState$1(domElement, props);
            return;
        }
      }

      var validateDOMNesting = function validateDOMNesting() {};

      var updatedAncestorInfo = function updatedAncestorInfo() {};

      {
        var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
        var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template', 'foreignObject', 'desc', 'title'];
        var buttonScopeTags = inScopeTags.concat(['button']);
        var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
        var emptyAncestorInfo = {
          current: null,
          formTag: null,
          aTagInScope: null,
          buttonTagInScope: null,
          nobrTagInScope: null,
          pTagInButtonScope: null,
          listItemTagAutoclosing: null,
          dlItemTagAutoclosing: null
        };

        updatedAncestorInfo = function updatedAncestorInfo(oldInfo, tag) {
          var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
          var info = {
            tag: tag
          };

          if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
          }

          if (buttonScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.pTagInButtonScope = null;
          }

          if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
          }

          ancestorInfo.current = info;

          if (tag === 'form') {
            ancestorInfo.formTag = info;
          }

          if (tag === 'a') {
            ancestorInfo.aTagInScope = info;
          }

          if (tag === 'button') {
            ancestorInfo.buttonTagInScope = info;
          }

          if (tag === 'nobr') {
            ancestorInfo.nobrTagInScope = info;
          }

          if (tag === 'p') {
            ancestorInfo.pTagInButtonScope = info;
          }

          if (tag === 'li') {
            ancestorInfo.listItemTagAutoclosing = info;
          }

          if (tag === 'dd' || tag === 'dt') {
            ancestorInfo.dlItemTagAutoclosing = info;
          }

          return ancestorInfo;
        };

        var isTagValidWithParent = function isTagValidWithParent(tag, parentTag) {
          switch (parentTag) {
            case 'select':
              return tag === 'option' || tag === 'optgroup' || tag === '#text';

            case 'optgroup':
              return tag === 'option' || tag === '#text';

            case 'option':
              return tag === '#text';

            case 'tr':
              return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';

            case 'tbody':
            case 'thead':
            case 'tfoot':
              return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';

            case 'colgroup':
              return tag === 'col' || tag === 'template';

            case 'table':
              return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';

            case 'head':
              return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';

            case 'html':
              return tag === 'head' || tag === 'body' || tag === 'frameset';

            case 'frameset':
              return tag === 'frame';

            case '#document':
              return tag === 'html';
          }

          switch (tag) {
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
              return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

            case 'rp':
            case 'rt':
              return impliedEndTags.indexOf(parentTag) === -1;

            case 'body':
            case 'caption':
            case 'col':
            case 'colgroup':
            case 'frameset':
            case 'frame':
            case 'head':
            case 'html':
            case 'tbody':
            case 'td':
            case 'tfoot':
            case 'th':
            case 'thead':
            case 'tr':
              return parentTag == null;
          }

          return true;
        };

        var findInvalidAncestorForTag = function findInvalidAncestorForTag(tag, ancestorInfo) {
          switch (tag) {
            case 'address':
            case 'article':
            case 'aside':
            case 'blockquote':
            case 'center':
            case 'details':
            case 'dialog':
            case 'dir':
            case 'div':
            case 'dl':
            case 'fieldset':
            case 'figcaption':
            case 'figure':
            case 'footer':
            case 'header':
            case 'hgroup':
            case 'main':
            case 'menu':
            case 'nav':
            case 'ol':
            case 'p':
            case 'section':
            case 'summary':
            case 'ul':
            case 'pre':
            case 'listing':
            case 'table':
            case 'hr':
            case 'xmp':
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
              return ancestorInfo.pTagInButtonScope;

            case 'form':
              return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

            case 'li':
              return ancestorInfo.listItemTagAutoclosing;

            case 'dd':
            case 'dt':
              return ancestorInfo.dlItemTagAutoclosing;

            case 'button':
              return ancestorInfo.buttonTagInScope;

            case 'a':
              return ancestorInfo.aTagInScope;

            case 'nobr':
              return ancestorInfo.nobrTagInScope;
          }

          return null;
        };

        var didWarn$1 = {};

        validateDOMNesting = function validateDOMNesting(childTag, childText, ancestorInfo) {
          ancestorInfo = ancestorInfo || emptyAncestorInfo;
          var parentInfo = ancestorInfo.current;
          var parentTag = parentInfo && parentInfo.tag;

          if (childText != null) {
            if (childTag != null) {
              error('validateDOMNesting: when childText is passed, childTag should be null');
            }

            childTag = '#text';
          }

          var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
          var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
          var invalidParentOrAncestor = invalidParent || invalidAncestor;

          if (!invalidParentOrAncestor) {
            return;
          }

          var ancestorTag = invalidParentOrAncestor.tag;
          var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag;

          if (didWarn$1[warnKey]) {
            return;
          }

          didWarn$1[warnKey] = true;
          var tagDisplayName = childTag;
          var whitespaceInfo = '';

          if (childTag === '#text') {
            if (/\S/.test(childText)) {
              tagDisplayName = 'Text nodes';
            } else {
              tagDisplayName = 'Whitespace text nodes';
              whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
            }
          } else {
            tagDisplayName = '<' + childTag + '>';
          }

          if (invalidParent) {
            var info = '';

            if (ancestorTag === 'table' && childTag === 'tr') {
              info += ' Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by ' + 'the browser.';
            }

            error('validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s', tagDisplayName, ancestorTag, whitespaceInfo, info);
          } else {
            error('validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>.', tagDisplayName, ancestorTag);
          }
        };
      }
      var SUPPRESS_HYDRATION_WARNING$1 = 'suppressHydrationWarning';
      var SUSPENSE_START_DATA = '$';
      var SUSPENSE_END_DATA = '/$';
      var SUSPENSE_PENDING_START_DATA = '$?';
      var SUSPENSE_FALLBACK_START_DATA = '$!';
      var STYLE$1 = 'style';
      var eventsEnabled = null;
      var selectionInformation = null;

      function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;

        switch (nodeType) {
          case DOCUMENT_NODE:
          case DOCUMENT_FRAGMENT_NODE:
            {
              type = nodeType === DOCUMENT_NODE ? '#document' : '#fragment';
              var root = rootContainerInstance.documentElement;
              namespace = root ? root.namespaceURI : getChildNamespace(null, '');
              break;
            }

          default:
            {
              var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
              var ownNamespace = container.namespaceURI || null;
              type = container.tagName;
              namespace = getChildNamespace(ownNamespace, type);
              break;
            }
        }

        {
          var validatedTag = type.toLowerCase();
          var ancestorInfo = updatedAncestorInfo(null, validatedTag);
          return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
          };
        }
      }

      function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        {
          var parentHostContextDev = parentHostContext;
          var namespace = getChildNamespace(parentHostContextDev.namespace, type);
          var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
          return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
          };
        }
      }

      function getPublicInstance(instance) {
        return instance;
      }

      function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
      }

      function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
      }

      function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        {
          var hostContextDev = hostContext;
          validateDOMNesting(type, null, hostContextDev.ancestorInfo);

          if (typeof props.children === 'string' || typeof props.children === 'number') {
            var string = '' + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
          }

          parentNamespace = hostContextDev.namespace;
        }
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
      }

      function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
      }

      function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);

        switch (type) {
          case 'button':
          case 'input':
          case 'select':
          case 'textarea':
            return !!props.autoFocus;

          case 'img':
            return true;

          default:
            return false;
        }
      }

      function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        {
          var hostContextDev = hostContext;

          if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === 'string' || typeof newProps.children === 'number')) {
            var string = '' + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
          }
        }
        return diffProperties(domElement, type, oldProps, newProps);
      }

      function shouldSetTextContent(type, props) {
        return type === 'textarea' || type === 'noscript' || typeof props.children === 'string' || typeof props.children === 'number' || typeof props.dangerouslySetInnerHTML === 'object' && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
      }

      function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        {
          var hostContextDev = hostContext;
          validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        }
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
      }

      function getCurrentEventPriority() {
        var currentEvent = window.event;

        if (currentEvent === undefined) {
          return DefaultEventPriority;
        }

        return getEventPriority(currentEvent.type);
      }

      var scheduleTimeout = typeof setTimeout === 'function' ? setTimeout : undefined;
      var cancelTimeout = typeof clearTimeout === 'function' ? clearTimeout : undefined;
      var noTimeout = -1;
      var localPromise = typeof Promise === 'function' ? Promise : undefined;
      var scheduleMicrotask = typeof queueMicrotask === 'function' ? queueMicrotask : typeof localPromise !== 'undefined' ? function (callback) {
        return localPromise.resolve(null).then(callback)["catch"](handleErrorInNextTick);
      } : scheduleTimeout;

      function handleErrorInNextTick(error) {
        setTimeout(function () {
          throw error;
        });
      }

      function commitMount(domElement, type, newProps, internalInstanceHandle) {
        switch (type) {
          case 'button':
          case 'input':
          case 'select':
          case 'textarea':
            if (newProps.autoFocus) {
              domElement.focus();
            }

            return;

          case 'img':
            {
              if (newProps.src) {
                domElement.src = newProps.src;
              }

              return;
            }
        }
      }

      function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        updateProperties(domElement, updatePayload, type, oldProps, newProps);
        updateFiberProps(domElement, newProps);
      }

      function resetTextContent(domElement) {
        setTextContent(domElement, '');
      }

      function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
      }

      function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
      }

      function appendChildToContainer(container, child) {
        var parentNode;

        if (container.nodeType === COMMENT_NODE) {
          parentNode = container.parentNode;
          parentNode.insertBefore(child, container);
        } else {
          parentNode = container;
          parentNode.appendChild(child);
        }

        var reactRootContainer = container._reactRootContainer;

        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) {
          trapClickOnNonInteractiveElement(parentNode);
        }
      }

      function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
      }

      function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) {
          container.parentNode.insertBefore(child, beforeChild);
        } else {
          container.insertBefore(child, beforeChild);
        }
      }

      function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
      }

      function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) {
          container.parentNode.removeChild(child);
        } else {
          container.removeChild(child);
        }
      }

      function clearSuspenseBoundary(parentInstance, suspenseInstance) {
        var node = suspenseInstance;
        var depth = 0;

        do {
          var nextNode = node.nextSibling;
          parentInstance.removeChild(node);

          if (nextNode && nextNode.nodeType === COMMENT_NODE) {
            var data = nextNode.data;

            if (data === SUSPENSE_END_DATA) {
              if (depth === 0) {
                parentInstance.removeChild(nextNode);
                retryIfBlockedOn(suspenseInstance);
                return;
              } else {
                depth--;
              }
            } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_FALLBACK_START_DATA) {
              depth++;
            }
          }

          node = nextNode;
        } while (node);

        retryIfBlockedOn(suspenseInstance);
      }

      function clearSuspenseBoundaryFromContainer(container, suspenseInstance) {
        if (container.nodeType === COMMENT_NODE) {
          clearSuspenseBoundary(container.parentNode, suspenseInstance);
        } else if (container.nodeType === ELEMENT_NODE) {
          clearSuspenseBoundary(container, suspenseInstance);
        }

        retryIfBlockedOn(container);
      }

      function hideInstance(instance) {
        instance = instance;
        var style = instance.style;

        if (typeof style.setProperty === 'function') {
          style.setProperty('display', 'none', 'important');
        } else {
          style.display = 'none';
        }
      }

      function hideTextInstance(textInstance) {
        textInstance.nodeValue = '';
      }

      function unhideInstance(instance, props) {
        instance = instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty('display') ? styleProp.display : null;
        instance.style.display = dangerousStyleValue('display', display);
      }

      function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
      }

      function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) {
          container.textContent = '';
        } else if (container.nodeType === DOCUMENT_NODE) {
          var body = container.body;

          if (body != null) {
            body.textContent = '';
          }
        }
      }

      function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) {
          return null;
        }

        return instance;
      }

      function canHydrateTextInstance(instance, text) {
        if (text === '' || instance.nodeType !== TEXT_NODE) {
          return null;
        }

        return instance;
      }

      function canHydrateSuspenseInstance(instance) {
        if (instance.nodeType !== COMMENT_NODE) {
          return null;
        }

        return instance;
      }

      function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
      }

      function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
      }

      function registerSuspenseInstanceRetry(instance, callback) {
        instance._reactRetry = callback;
      }

      function getNextHydratable(node) {
        for (; node != null; node = node.nextSibling) {
          var nodeType = node.nodeType;

          if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) {
            break;
          }

          if (nodeType === COMMENT_NODE) {
            var nodeData = node.data;

            if (nodeData === SUSPENSE_START_DATA || nodeData === SUSPENSE_FALLBACK_START_DATA || nodeData === SUSPENSE_PENDING_START_DATA) {
              break;
            }

            if (nodeData === SUSPENSE_END_DATA) {
              return null;
            }
          }
        }

        return node;
      }

      function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
      }

      function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
      }

      function getFirstHydratableChildWithinContainer(parentContainer) {
        return getNextHydratable(parentContainer.firstChild);
      }

      function getFirstHydratableChildWithinSuspenseInstance(parentInstance) {
        return getNextHydratable(parentInstance.nextSibling);
      }

      function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, instance);
        updateFiberProps(instance, props);
        var parentNamespace;
        {
          var hostContextDev = hostContext;
          parentNamespace = hostContextDev.namespace;
        }
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance, isConcurrentMode, shouldWarnDev);
      }

      function hydrateTextInstance(textInstance, text, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, textInstance);
        return diffHydratedText(textInstance, text);
      }

      function hydrateSuspenseInstance(suspenseInstance, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, suspenseInstance);
      }

      function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling;
        var depth = 0;

        while (node) {
          if (node.nodeType === COMMENT_NODE) {
            var data = node.data;

            if (data === SUSPENSE_END_DATA) {
              if (depth === 0) {
                return getNextHydratableSibling(node);
              } else {
                depth--;
              }
            } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
              depth++;
            }
          }

          node = node.nextSibling;
        }

        return null;
      }

      function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling;
        var depth = 0;

        while (node) {
          if (node.nodeType === COMMENT_NODE) {
            var data = node.data;

            if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
              if (depth === 0) {
                return node;
              } else {
                depth--;
              }
            } else if (data === SUSPENSE_END_DATA) {
              depth++;
            }
          }

          node = node.previousSibling;
        }

        return null;
      }

      function commitHydratedContainer(container) {
        retryIfBlockedOn(container);
      }

      function commitHydratedSuspenseInstance(suspenseInstance) {
        retryIfBlockedOn(suspenseInstance);
      }

      function shouldDeleteUnhydratedTailInstances(parentType) {
        return parentType !== 'head' && parentType !== 'body';
      }

      function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text, isConcurrentMode) {
        var shouldWarnDev = true;
        checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
      }

      function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text, isConcurrentMode) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
          var shouldWarnDev = true;
          checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
        }
      }

      function didNotHydrateInstanceWithinContainer(parentContainer, instance) {
        {
          if (instance.nodeType === ELEMENT_NODE) {
            warnForDeletedHydratableElement(parentContainer, instance);
          } else if (instance.nodeType === COMMENT_NODE) ;else {
            warnForDeletedHydratableText(parentContainer, instance);
          }
        }
      }

      function didNotHydrateInstanceWithinSuspenseInstance(parentInstance, instance) {
        {
          var parentNode = parentInstance.parentNode;

          if (parentNode !== null) {
            if (instance.nodeType === ELEMENT_NODE) {
              warnForDeletedHydratableElement(parentNode, instance);
            } else if (instance.nodeType === COMMENT_NODE) ;else {
              warnForDeletedHydratableText(parentNode, instance);
            }
          }
        }
      }

      function didNotHydrateInstance(parentType, parentProps, parentInstance, instance, isConcurrentMode) {
        {
          if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) {
              warnForDeletedHydratableElement(parentInstance, instance);
            } else if (instance.nodeType === COMMENT_NODE) ;else {
              warnForDeletedHydratableText(parentInstance, instance);
            }
          }
        }
      }

      function didNotFindHydratableInstanceWithinContainer(parentContainer, type, props) {
        {
          warnForInsertedHydratedElement(parentContainer, type);
        }
      }

      function didNotFindHydratableTextInstanceWithinContainer(parentContainer, text) {
        {
          warnForInsertedHydratedText(parentContainer, text);
        }
      }

      function didNotFindHydratableInstanceWithinSuspenseInstance(parentInstance, type, props) {
        {
          var parentNode = parentInstance.parentNode;
          if (parentNode !== null) warnForInsertedHydratedElement(parentNode, type);
        }
      }

      function didNotFindHydratableTextInstanceWithinSuspenseInstance(parentInstance, text) {
        {
          var parentNode = parentInstance.parentNode;
          if (parentNode !== null) warnForInsertedHydratedText(parentNode, text);
        }
      }

      function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props, isConcurrentMode) {
        {
          if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            warnForInsertedHydratedElement(parentInstance, type);
          }
        }
      }

      function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text, isConcurrentMode) {
        {
          if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            warnForInsertedHydratedText(parentInstance, text);
          }
        }
      }

      function errorHydratingContainer(parentContainer) {
        {
          error('An error occurred during hydration. The server HTML was replaced with client content in <%s>.', parentContainer.nodeName.toLowerCase());
        }
      }

      function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
      }

      var randomKey = Math.random().toString(36).slice(2);
      var internalInstanceKey = '__reactFiber$' + randomKey;
      var internalPropsKey = '__reactProps$' + randomKey;
      var internalContainerInstanceKey = '__reactContainer$' + randomKey;
      var internalEventHandlersKey = '__reactEvents$' + randomKey;
      var internalEventHandlerListenersKey = '__reactListeners$' + randomKey;
      var internalEventHandlesSetKey = '__reactHandles$' + randomKey;

      function detachDeletedInstance(node) {
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
      }

      function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
      }

      function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
      }

      function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
      }

      function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
      }

      function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];

        if (targetInst) {
          return targetInst;
        }

        var parentNode = targetNode.parentNode;

        while (parentNode) {
          targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];

          if (targetInst) {
            var alternate = targetInst.alternate;

            if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
              var suspenseInstance = getParentSuspenseInstance(targetNode);

              while (suspenseInstance !== null) {
                var targetSuspenseInst = suspenseInstance[internalInstanceKey];

                if (targetSuspenseInst) {
                  return targetSuspenseInst;
                }

                suspenseInstance = getParentSuspenseInstance(suspenseInstance);
              }
            }

            return targetInst;
          }

          targetNode = parentNode;
          parentNode = targetNode.parentNode;
        }

        return null;
      }

      function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];

        if (inst) {
          if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) {
            return inst;
          } else {
            return null;
          }
        }

        return null;
      }

      function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) {
          return inst.stateNode;
        }

        throw new Error('getNodeFromInstance: Invalid argument.');
      }

      function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
      }

      function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
      }

      function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];

        if (elementListenerSet === undefined) {
          elementListenerSet = node[internalEventHandlersKey] = new Set();
        }

        return elementListenerSet;
      }

      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }

      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          var has = Function.call.bind(hasOwnProperty);

          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0;

              try {
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                  var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                  err.name = 'Invariant Violation';
                  throw err;
                }

                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
              } catch (ex) {
                error$1 = ex;
              }

              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }

              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }

      var valueStack = [];
      var fiberStack;
      {
        fiberStack = [];
      }
      var index = -1;

      function createCursor(defaultValue) {
        return {
          current: defaultValue
        };
      }

      function pop(cursor, fiber) {
        if (index < 0) {
          {
            error('Unexpected pop.');
          }
          return;
        }

        {
          if (fiber !== fiberStack[index]) {
            error('Unexpected Fiber popped.');
          }
        }
        cursor.current = valueStack[index];
        valueStack[index] = null;
        {
          fiberStack[index] = null;
        }
        index--;
      }

      function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        {
          fiberStack[index] = fiber;
        }
        cursor.current = value;
      }

      var warnedAboutMissingGetChildContext;
      {
        warnedAboutMissingGetChildContext = {};
      }
      var emptyContextObject = {};
      {
        Object.freeze(emptyContextObject);
      }
      var contextStackCursor = createCursor(emptyContextObject);
      var didPerformWorkStackCursor = createCursor(false);
      var previousContext = emptyContextObject;

      function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        {
          if (didPushOwnContextIfProvider && isContextProvider(Component)) {
            return previousContext;
          }

          return contextStackCursor.current;
        }
      }

      function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        {
          var instance = workInProgress.stateNode;
          instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
          instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
        }
      }

      function getMaskedContext(workInProgress, unmaskedContext) {
        {
          var type = workInProgress.type;
          var contextTypes = type.contextTypes;

          if (!contextTypes) {
            return emptyContextObject;
          }

          var instance = workInProgress.stateNode;

          if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) {
            return instance.__reactInternalMemoizedMaskedChildContext;
          }

          var context = {};

          for (var key in contextTypes) {
            context[key] = unmaskedContext[key];
          }

          {
            var name = getComponentNameFromFiber(workInProgress) || 'Unknown';
            checkPropTypes(contextTypes, context, 'context', name);
          }

          if (instance) {
            cacheContext(workInProgress, unmaskedContext, context);
          }

          return context;
        }
      }

      function hasContextChanged() {
        {
          return didPerformWorkStackCursor.current;
        }
      }

      function isContextProvider(type) {
        {
          var childContextTypes = type.childContextTypes;
          return childContextTypes !== null && childContextTypes !== undefined;
        }
      }

      function popContext(fiber) {
        {
          pop(didPerformWorkStackCursor, fiber);
          pop(contextStackCursor, fiber);
        }
      }

      function popTopLevelContextObject(fiber) {
        {
          pop(didPerformWorkStackCursor, fiber);
          pop(contextStackCursor, fiber);
        }
      }

      function pushTopLevelContextObject(fiber, context, didChange) {
        {
          if (contextStackCursor.current !== emptyContextObject) {
            throw new Error('Unexpected context found on stack. ' + 'This error is likely caused by a bug in React. Please file an issue.');
          }

          push(contextStackCursor, context, fiber);
          push(didPerformWorkStackCursor, didChange, fiber);
        }
      }

      function processChildContext(fiber, type, parentContext) {
        {
          var instance = fiber.stateNode;
          var childContextTypes = type.childContextTypes;

          if (typeof instance.getChildContext !== 'function') {
            {
              var componentName = getComponentNameFromFiber(fiber) || 'Unknown';

              if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error('%s.childContextTypes is specified but there is no getChildContext() method ' + 'on the instance. You can either define getChildContext() on %s or remove ' + 'childContextTypes from it.', componentName, componentName);
              }
            }
            return parentContext;
          }

          var childContext = instance.getChildContext();

          for (var contextKey in childContext) {
            if (!(contextKey in childContextTypes)) {
              throw new Error((getComponentNameFromFiber(fiber) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes.");
            }
          }

          {
            var name = getComponentNameFromFiber(fiber) || 'Unknown';
            checkPropTypes(childContextTypes, childContext, 'child context', name);
          }
          return assign({}, parentContext, childContext);
        }
      }

      function pushContextProvider(workInProgress) {
        {
          var instance = workInProgress.stateNode;
          var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject;
          previousContext = contextStackCursor.current;
          push(contextStackCursor, memoizedMergedChildContext, workInProgress);
          push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
          return true;
        }
      }

      function invalidateContextProvider(workInProgress, type, didChange) {
        {
          var instance = workInProgress.stateNode;

          if (!instance) {
            throw new Error('Expected to have an instance by this point. ' + 'This error is likely caused by a bug in React. Please file an issue.');
          }

          if (didChange) {
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext;
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress);
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
          } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
          }
        }
      }

      function findCurrentUnmaskedContext(fiber) {
        {
          if (!isFiberMounted(fiber) || fiber.tag !== ClassComponent) {
            throw new Error('Expected subtree parent to be a mounted class component. ' + 'This error is likely caused by a bug in React. Please file an issue.');
          }

          var node = fiber;

          do {
            switch (node.tag) {
              case HostRoot:
                return node.stateNode.context;

              case ClassComponent:
                {
                  var Component = node.type;

                  if (isContextProvider(Component)) {
                    return node.stateNode.__reactInternalMemoizedMergedChildContext;
                  }

                  break;
                }
            }

            node = node["return"];
          } while (node !== null);

          throw new Error('Found unexpected detached subtree parent. ' + 'This error is likely caused by a bug in React. Please file an issue.');
        }
      }

      var LegacyRoot = 0;
      var ConcurrentRoot = 1;
      var syncQueue = null;
      var includesLegacySyncCallbacks = false;
      var isFlushingSyncQueue = false;

      function scheduleSyncCallback(callback) {
        if (syncQueue === null) {
          syncQueue = [callback];
        } else {
          syncQueue.push(callback);
        }
      }

      function scheduleLegacySyncCallback(callback) {
        includesLegacySyncCallbacks = true;
        scheduleSyncCallback(callback);
      }

      function flushSyncCallbacksOnlyInLegacyMode() {
        if (includesLegacySyncCallbacks) {
          flushSyncCallbacks();
        }
      }

      function flushSyncCallbacks() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
          isFlushingSyncQueue = true;
          var i = 0;
          var previousUpdatePriority = getCurrentUpdatePriority();

          try {
            var isSync = true;
            var queue = syncQueue;
            setCurrentUpdatePriority(DiscreteEventPriority);

            for (; i < queue.length; i++) {
              var callback = queue[i];

              do {
                callback = callback(isSync);
              } while (callback !== null);
            }

            syncQueue = null;
            includesLegacySyncCallbacks = false;
          } catch (error) {
            if (syncQueue !== null) {
              syncQueue = syncQueue.slice(i + 1);
            }

            scheduleCallback(ImmediatePriority, flushSyncCallbacks);
            throw error;
          } finally {
            setCurrentUpdatePriority(previousUpdatePriority);
            isFlushingSyncQueue = false;
          }
        }

        return null;
      }

      var ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
      var NoTransition = null;

      function requestCurrentTransition() {
        return ReactCurrentBatchConfig$1.transition;
      }

      var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function recordUnsafeLifecycleWarnings(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function flushPendingUnsafeLifecycleWarnings() {},
        recordLegacyContextWarning: function recordLegacyContextWarning(fiber, instance) {},
        flushLegacyContextWarning: function flushLegacyContextWarning() {},
        discardPendingWarnings: function discardPendingWarnings() {}
      };
      {
        var findStrictRoot = function findStrictRoot(fiber) {
          var maybeStrictRoot = null;
          var node = fiber;

          while (node !== null) {
            if (node.mode & StrictLegacyMode) {
              maybeStrictRoot = node;
            }

            node = node["return"];
          }

          return maybeStrictRoot;
        };

        var setToSortedString = function setToSortedString(set) {
          var array = [];
          set.forEach(function (value) {
            array.push(value);
          });
          return array.sort().join(', ');
        };

        var pendingComponentWillMountWarnings = [];
        var pendingUNSAFE_ComponentWillMountWarnings = [];
        var pendingComponentWillReceivePropsWarnings = [];
        var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        var pendingComponentWillUpdateWarnings = [];
        var pendingUNSAFE_ComponentWillUpdateWarnings = [];
        var didWarnAboutUnsafeLifecycles = new Set();

        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function (fiber, instance) {
          if (didWarnAboutUnsafeLifecycles.has(fiber.type)) {
            return;
          }

          if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
            pendingComponentWillMountWarnings.push(fiber);
          }

          if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillMount === 'function') {
            pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
          }

          if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
            pendingComponentWillReceivePropsWarnings.push(fiber);
          }

          if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
          }

          if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
            pendingComponentWillUpdateWarnings.push(fiber);
          }

          if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillUpdate === 'function') {
            pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
          }
        };

        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function () {
          var componentWillMountUniqueNames = new Set();

          if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function (fiber) {
              componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
          }

          var UNSAFE_componentWillMountUniqueNames = new Set();

          if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function (fiber) {
              UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
          }

          var componentWillReceivePropsUniqueNames = new Set();

          if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function (fiber) {
              componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
          }

          var UNSAFE_componentWillReceivePropsUniqueNames = new Set();

          if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function (fiber) {
              UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
          }

          var componentWillUpdateUniqueNames = new Set();

          if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function (fiber) {
              componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
          }

          var UNSAFE_componentWillUpdateUniqueNames = new Set();

          if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function (fiber) {
              UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
          }

          if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error('Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '\nPlease update the following components: %s', sortedNames);
          }

          if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);

            error('Using UNSAFE_componentWillReceiveProps in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + "* If you're updating state whenever props change, " + 'refactor your code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n' + '\nPlease update the following components: %s', _sortedNames);
          }

          if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);

            error('Using UNSAFE_componentWillUpdate in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '\nPlease update the following components: %s', _sortedNames2);
          }

          if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);

            warn('componentWillMount has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '* Rename componentWillMount to UNSAFE_componentWillMount to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames3);
          }

          if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);

            warn('componentWillReceiveProps has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + "* If you're updating state whenever props change, refactor your " + 'code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n' + '* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames4);
          }

          if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);

            warn('componentWillUpdate has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames5);
          }
        };

        var pendingLegacyContextWarning = new Map();
        var didWarnAboutLegacyContext = new Set();

        ReactStrictModeWarnings.recordLegacyContextWarning = function (fiber, instance) {
          var strictRoot = findStrictRoot(fiber);

          if (strictRoot === null) {
            error('Expected to find a StrictMode component in a strict mode tree. ' + 'This error is likely caused by a bug in React. Please file an issue.');
            return;
          }

          if (didWarnAboutLegacyContext.has(fiber.type)) {
            return;
          }

          var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);

          if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
            if (warningsForRoot === undefined) {
              warningsForRoot = [];
              pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }

            warningsForRoot.push(fiber);
          }
        };

        ReactStrictModeWarnings.flushLegacyContextWarning = function () {
          pendingLegacyContextWarning.forEach(function (fiberArray, strictRoot) {
            if (fiberArray.length === 0) {
              return;
            }

            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function (fiber) {
              uniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
              didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);

            try {
              setCurrentFiber(firstFiber);
              error('Legacy context API has been detected within a strict-mode tree.' + '\n\nThe old API will be supported in all 16.x releases, but applications ' + 'using it should migrate to the new version.' + '\n\nPlease update the following components: %s' + '\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context', sortedNames);
            } finally {
              resetCurrentFiber();
            }
          });
        };

        ReactStrictModeWarnings.discardPendingWarnings = function () {
          pendingComponentWillMountWarnings = [];
          pendingUNSAFE_ComponentWillMountWarnings = [];
          pendingComponentWillReceivePropsWarnings = [];
          pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
          pendingComponentWillUpdateWarnings = [];
          pendingUNSAFE_ComponentWillUpdateWarnings = [];
          pendingLegacyContextWarning = new Map();
        };
      }

      function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
          var props = assign({}, baseProps);
          var defaultProps = Component.defaultProps;

          for (var propName in defaultProps) {
            if (props[propName] === undefined) {
              props[propName] = defaultProps[propName];
            }
          }

          return props;
        }

        return baseProps;
      }

      var valueCursor = createCursor(null);
      var rendererSigil;
      {
        rendererSigil = {};
      }
      var currentlyRenderingFiber = null;
      var lastContextDependency = null;
      var lastFullyObservedContext = null;
      var isDisallowedContextReadInDEV = false;

      function resetContextDependencies() {
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        {
          isDisallowedContextReadInDEV = false;
        }
      }

      function enterDisallowedContextReadInDEV() {
        {
          isDisallowedContextReadInDEV = true;
        }
      }

      function exitDisallowedContextReadInDEV() {
        {
          isDisallowedContextReadInDEV = false;
        }
      }

      function pushProvider(providerFiber, context, nextValue) {
        {
          push(valueCursor, context._currentValue, providerFiber);
          context._currentValue = nextValue;
          {
            if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) {
              error('Detected multiple renderers concurrently rendering the ' + 'same context provider. This is currently unsupported.');
            }

            context._currentRenderer = rendererSigil;
          }
        }
      }

      function popProvider(context, providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        {
          {
            context._currentValue = currentValue;
          }
        }
      }

      function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        var node = parent;

        while (node !== null) {
          var alternate = node.alternate;

          if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
            node.childLanes = mergeLanes(node.childLanes, renderLanes);

            if (alternate !== null) {
              alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            }
          } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) {
            alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
          }

          if (node === propagationRoot) {
            break;
          }

          node = node["return"];
        }

        {
          if (node !== propagationRoot) {
            error('Expected to find the propagation root when scheduling context work. ' + 'This error is likely caused by a bug in React. Please file an issue.');
          }
        }
      }

      function propagateContextChange(workInProgress, context, renderLanes) {
        {
          propagateContextChange_eager(workInProgress, context, renderLanes);
        }
      }

      function propagateContextChange_eager(workInProgress, context, renderLanes) {
        var fiber = workInProgress.child;

        if (fiber !== null) {
          fiber["return"] = workInProgress;
        }

        while (fiber !== null) {
          var nextFiber = void 0;
          var list = fiber.dependencies;

          if (list !== null) {
            nextFiber = fiber.child;
            var dependency = list.firstContext;

            while (dependency !== null) {
              if (dependency.context === context) {
                if (fiber.tag === ClassComponent) {
                  var lane = pickArbitraryLane(renderLanes);
                  var update = createUpdate(NoTimestamp, lane);
                  update.tag = ForceUpdate;
                  var updateQueue = fiber.updateQueue;
                  if (updateQueue === null) ;else {
                    var sharedQueue = updateQueue.shared;
                    var pending = sharedQueue.pending;

                    if (pending === null) {
                      update.next = update;
                    } else {
                      update.next = pending.next;
                      pending.next = update;
                    }

                    sharedQueue.pending = update;
                  }
                }

                fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                var alternate = fiber.alternate;

                if (alternate !== null) {
                  alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                }

                scheduleContextWorkOnParentPath(fiber["return"], renderLanes, workInProgress);
                list.lanes = mergeLanes(list.lanes, renderLanes);
                break;
              }

              dependency = dependency.next;
            }
          } else if (fiber.tag === ContextProvider) {
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
          } else if (fiber.tag === DehydratedFragment) {
            var parentSuspense = fiber["return"];

            if (parentSuspense === null) {
              throw new Error('We just came from a parent so we must have had a parent. This is a bug in React.');
            }

            parentSuspense.lanes = mergeLanes(parentSuspense.lanes, renderLanes);
            var _alternate = parentSuspense.alternate;

            if (_alternate !== null) {
              _alternate.lanes = mergeLanes(_alternate.lanes, renderLanes);
            }

            scheduleContextWorkOnParentPath(parentSuspense, renderLanes, workInProgress);
            nextFiber = fiber.sibling;
          } else {
            nextFiber = fiber.child;
          }

          if (nextFiber !== null) {
            nextFiber["return"] = fiber;
          } else {
            nextFiber = fiber;

            while (nextFiber !== null) {
              if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
              }

              var sibling = nextFiber.sibling;

              if (sibling !== null) {
                sibling["return"] = nextFiber["return"];
                nextFiber = sibling;
                break;
              }

              nextFiber = nextFiber["return"];
            }
          }

          fiber = nextFiber;
        }
      }

      function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        var dependencies = workInProgress.dependencies;

        if (dependencies !== null) {
          {
            var firstContext = dependencies.firstContext;

            if (firstContext !== null) {
              if (includesSomeLane(dependencies.lanes, renderLanes)) {
                markWorkInProgressReceivedUpdate();
              }

              dependencies.firstContext = null;
            }
          }
        }
      }

      function _readContext(context) {
        {
          if (isDisallowedContextReadInDEV) {
            error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
          }
        }
        var value = context._currentValue;
        if (lastFullyObservedContext === context) ;else {
          var contextItem = {
            context: context,
            memoizedValue: value,
            next: null
          };

          if (lastContextDependency === null) {
            if (currentlyRenderingFiber === null) {
              throw new Error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
            }

            lastContextDependency = contextItem;
            currentlyRenderingFiber.dependencies = {
              lanes: NoLanes,
              firstContext: contextItem
            };
          } else {
            lastContextDependency = lastContextDependency.next = contextItem;
          }
        }
        return value;
      }

      var interleavedQueues = null;

      function pushInterleavedQueue(queue) {
        if (interleavedQueues === null) {
          interleavedQueues = [queue];
        } else {
          interleavedQueues.push(queue);
        }
      }

      function hasInterleavedUpdates() {
        return interleavedQueues !== null;
      }

      function enqueueInterleavedUpdates() {
        if (interleavedQueues !== null) {
          for (var i = 0; i < interleavedQueues.length; i++) {
            var queue = interleavedQueues[i];
            var lastInterleavedUpdate = queue.interleaved;

            if (lastInterleavedUpdate !== null) {
              queue.interleaved = null;
              var firstInterleavedUpdate = lastInterleavedUpdate.next;
              var lastPendingUpdate = queue.pending;

              if (lastPendingUpdate !== null) {
                var firstPendingUpdate = lastPendingUpdate.next;
                lastPendingUpdate.next = firstInterleavedUpdate;
                lastInterleavedUpdate.next = firstPendingUpdate;
              }

              queue.pending = lastInterleavedUpdate;
            }
          }

          interleavedQueues = null;
        }
      }

      var UpdateState = 0;
      var ReplaceState = 1;
      var ForceUpdate = 2;
      var CaptureUpdate = 3;
      var hasForceUpdate = false;
      var didWarnUpdateInsideUpdate;
      var currentlyProcessingQueue;
      {
        didWarnUpdateInsideUpdate = false;
        currentlyProcessingQueue = null;
      }

      function initializeUpdateQueue(fiber) {
        var queue = {
          baseState: fiber.memoizedState,
          firstBaseUpdate: null,
          lastBaseUpdate: null,
          shared: {
            pending: null,
            interleaved: null,
            lanes: NoLanes
          },
          effects: null
        };
        fiber.updateQueue = queue;
      }

      function cloneUpdateQueue(current, workInProgress) {
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;

        if (queue === currentQueue) {
          var clone = {
            baseState: currentQueue.baseState,
            firstBaseUpdate: currentQueue.firstBaseUpdate,
            lastBaseUpdate: currentQueue.lastBaseUpdate,
            shared: currentQueue.shared,
            effects: currentQueue.effects
          };
          workInProgress.updateQueue = clone;
        }
      }

      function createUpdate(eventTime, lane) {
        var update = {
          eventTime: eventTime,
          lane: lane,
          tag: UpdateState,
          payload: null,
          callback: null,
          next: null
        };
        return update;
      }

      function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;

        if (updateQueue === null) {
          return;
        }

        var sharedQueue = updateQueue.shared;

        if (isInterleavedUpdate(fiber)) {
          var interleaved = sharedQueue.interleaved;

          if (interleaved === null) {
            update.next = update;
            pushInterleavedQueue(sharedQueue);
          } else {
            update.next = interleaved.next;
            interleaved.next = update;
          }

          sharedQueue.interleaved = update;
        } else {
          var pending = sharedQueue.pending;

          if (pending === null) {
            update.next = update;
          } else {
            update.next = pending.next;
            pending.next = update;
          }

          sharedQueue.pending = update;
        }

        {
          if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error('An update (setState, replaceState, or forceUpdate) was scheduled ' + 'from inside an update function. Update functions should be pure, ' + 'with zero side-effects. Consider using componentDidUpdate or a ' + 'callback.');
            didWarnUpdateInsideUpdate = true;
          }
        }
      }

      function entangleTransitions(root, fiber, lane) {
        var updateQueue = fiber.updateQueue;

        if (updateQueue === null) {
          return;
        }

        var sharedQueue = updateQueue.shared;

        if (isTransitionLane(lane)) {
          var queueLanes = sharedQueue.lanes;
          queueLanes = intersectLanes(queueLanes, root.pendingLanes);
          var newQueueLanes = mergeLanes(queueLanes, lane);
          sharedQueue.lanes = newQueueLanes;
          markRootEntangled(root, newQueueLanes);
        }
      }

      function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        var queue = workInProgress.updateQueue;
        var current = workInProgress.alternate;

        if (current !== null) {
          var currentQueue = current.updateQueue;

          if (queue === currentQueue) {
            var newFirst = null;
            var newLast = null;
            var firstBaseUpdate = queue.firstBaseUpdate;

            if (firstBaseUpdate !== null) {
              var update = firstBaseUpdate;

              do {
                var clone = {
                  eventTime: update.eventTime,
                  lane: update.lane,
                  tag: update.tag,
                  payload: update.payload,
                  callback: update.callback,
                  next: null
                };

                if (newLast === null) {
                  newFirst = newLast = clone;
                } else {
                  newLast.next = clone;
                  newLast = clone;
                }

                update = update.next;
              } while (update !== null);

              if (newLast === null) {
                newFirst = newLast = capturedUpdate;
              } else {
                newLast.next = capturedUpdate;
                newLast = capturedUpdate;
              }
            } else {
              newFirst = newLast = capturedUpdate;
            }

            queue = {
              baseState: currentQueue.baseState,
              firstBaseUpdate: newFirst,
              lastBaseUpdate: newLast,
              shared: currentQueue.shared,
              effects: currentQueue.effects
            };
            workInProgress.updateQueue = queue;
            return;
          }
        }

        var lastBaseUpdate = queue.lastBaseUpdate;

        if (lastBaseUpdate === null) {
          queue.firstBaseUpdate = capturedUpdate;
        } else {
          lastBaseUpdate.next = capturedUpdate;
        }

        queue.lastBaseUpdate = capturedUpdate;
      }

      function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch (update.tag) {
          case ReplaceState:
            {
              var payload = update.payload;

              if (typeof payload === 'function') {
                {
                  enterDisallowedContextReadInDEV();
                }
                var nextState = payload.call(instance, prevState, nextProps);
                {
                  if (workInProgress.mode & StrictLegacyMode) {
                    setIsStrictModeForDevtools(true);

                    try {
                      payload.call(instance, prevState, nextProps);
                    } finally {
                      setIsStrictModeForDevtools(false);
                    }
                  }

                  exitDisallowedContextReadInDEV();
                }
                return nextState;
              }

              return payload;
            }

          case CaptureUpdate:
            {
              workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            }

          case UpdateState:
            {
              var _payload = update.payload;
              var partialState;

              if (typeof _payload === 'function') {
                {
                  enterDisallowedContextReadInDEV();
                }
                partialState = _payload.call(instance, prevState, nextProps);
                {
                  if (workInProgress.mode & StrictLegacyMode) {
                    setIsStrictModeForDevtools(true);

                    try {
                      _payload.call(instance, prevState, nextProps);
                    } finally {
                      setIsStrictModeForDevtools(false);
                    }
                  }

                  exitDisallowedContextReadInDEV();
                }
              } else {
                partialState = _payload;
              }

              if (partialState === null || partialState === undefined) {
                return prevState;
              }

              return assign({}, prevState, partialState);
            }

          case ForceUpdate:
            {
              hasForceUpdate = true;
              return prevState;
            }
        }

        return prevState;
      }

      function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        {
          currentlyProcessingQueue = queue.shared;
        }
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate;
        var pendingQueue = queue.shared.pending;

        if (pendingQueue !== null) {
          queue.shared.pending = null;
          var lastPendingUpdate = pendingQueue;
          var firstPendingUpdate = lastPendingUpdate.next;
          lastPendingUpdate.next = null;

          if (lastBaseUpdate === null) {
            firstBaseUpdate = firstPendingUpdate;
          } else {
            lastBaseUpdate.next = firstPendingUpdate;
          }

          lastBaseUpdate = lastPendingUpdate;
          var current = workInProgress.alternate;

          if (current !== null) {
            var currentQueue = current.updateQueue;
            var currentLastBaseUpdate = currentQueue.lastBaseUpdate;

            if (currentLastBaseUpdate !== lastBaseUpdate) {
              if (currentLastBaseUpdate === null) {
                currentQueue.firstBaseUpdate = firstPendingUpdate;
              } else {
                currentLastBaseUpdate.next = firstPendingUpdate;
              }

              currentQueue.lastBaseUpdate = lastPendingUpdate;
            }
          }
        }

        if (firstBaseUpdate !== null) {
          var newState = queue.baseState;
          var newLanes = NoLanes;
          var newBaseState = null;
          var newFirstBaseUpdate = null;
          var newLastBaseUpdate = null;
          var update = firstBaseUpdate;

          do {
            var updateLane = update.lane;
            var updateEventTime = update.eventTime;

            if (!isSubsetOfLanes(renderLanes, updateLane)) {
              var clone = {
                eventTime: updateEventTime,
                lane: updateLane,
                tag: update.tag,
                payload: update.payload,
                callback: update.callback,
                next: null
              };

              if (newLastBaseUpdate === null) {
                newFirstBaseUpdate = newLastBaseUpdate = clone;
                newBaseState = newState;
              } else {
                newLastBaseUpdate = newLastBaseUpdate.next = clone;
              }

              newLanes = mergeLanes(newLanes, updateLane);
            } else {
              if (newLastBaseUpdate !== null) {
                var _clone = {
                  eventTime: updateEventTime,
                  lane: NoLane,
                  tag: update.tag,
                  payload: update.payload,
                  callback: update.callback,
                  next: null
                };
                newLastBaseUpdate = newLastBaseUpdate.next = _clone;
              }

              newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
              var callback = update.callback;

              if (callback !== null && update.lane !== NoLane) {
                workInProgress.flags |= Callback;
                var effects = queue.effects;

                if (effects === null) {
                  queue.effects = [update];
                } else {
                  effects.push(update);
                }
              }
            }

            update = update.next;

            if (update === null) {
              pendingQueue = queue.shared.pending;

              if (pendingQueue === null) {
                break;
              } else {
                var _lastPendingUpdate = pendingQueue;
                var _firstPendingUpdate = _lastPendingUpdate.next;
                _lastPendingUpdate.next = null;
                update = _firstPendingUpdate;
                queue.lastBaseUpdate = _lastPendingUpdate;
                queue.shared.pending = null;
              }
            }
          } while (true);

          if (newLastBaseUpdate === null) {
            newBaseState = newState;
          }

          queue.baseState = newBaseState;
          queue.firstBaseUpdate = newFirstBaseUpdate;
          queue.lastBaseUpdate = newLastBaseUpdate;
          var lastInterleaved = queue.shared.interleaved;

          if (lastInterleaved !== null) {
            var interleaved = lastInterleaved;

            do {
              newLanes = mergeLanes(newLanes, interleaved.lane);
              interleaved = interleaved.next;
            } while (interleaved !== lastInterleaved);
          } else if (firstBaseUpdate === null) {
            queue.shared.lanes = NoLanes;
          }

          markSkippedUpdateLanes(newLanes);
          workInProgress.lanes = newLanes;
          workInProgress.memoizedState = newState;
        }

        {
          currentlyProcessingQueue = null;
        }
      }

      function callCallback(callback, context) {
        if (typeof callback !== 'function') {
          throw new Error('Invalid argument passed as callback. Expected a function. Instead ' + ("received: " + callback));
        }

        callback.call(context);
      }

      function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
      }

      function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
      }

      function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;

        if (effects !== null) {
          for (var i = 0; i < effects.length; i++) {
            var effect = effects[i];
            var callback = effect.callback;

            if (callback !== null) {
              effect.callback = null;
              callCallback(callback, instance);
            }
          }
        }
      }

      var fakeInternalInstance = {};
      var emptyRefsObject = new React.Component().refs;
      var didWarnAboutStateAssignmentForComponent;
      var didWarnAboutUninitializedState;
      var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
      var didWarnAboutLegacyLifecyclesAndDerivedState;
      var didWarnAboutUndefinedDerivedState;
      var warnOnUndefinedDerivedState;
      var warnOnInvalidCallback;
      var didWarnAboutDirectlyAssigningPropsToState;
      var didWarnAboutContextTypeAndContextTypes;
      var didWarnAboutInvalidateContextType;
      {
        didWarnAboutStateAssignmentForComponent = new Set();
        didWarnAboutUninitializedState = new Set();
        didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
        didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
        didWarnAboutDirectlyAssigningPropsToState = new Set();
        didWarnAboutUndefinedDerivedState = new Set();
        didWarnAboutContextTypeAndContextTypes = new Set();
        didWarnAboutInvalidateContextType = new Set();
        var didWarnOnInvalidCallback = new Set();

        warnOnInvalidCallback = function warnOnInvalidCallback(callback, callerName) {
          if (callback === null || typeof callback === 'function') {
            return;
          }

          var key = callerName + '_' + callback;

          if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
          }
        };

        warnOnUndefinedDerivedState = function warnOnUndefinedDerivedState(type, partialState) {
          if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || 'Component';

            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
              didWarnAboutUndefinedDerivedState.add(componentName);
              error('%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. ' + 'You have returned undefined.', componentName);
            }
          }
        };

        Object.defineProperty(fakeInternalInstance, '_processChildContext', {
          enumerable: false,
          value: function value() {
            throw new Error('_processChildContext is not available in React 16+. This likely ' + 'means you have multiple copies of React and are attempting to nest ' + 'a React 15 tree inside a React 16 tree using ' + "unstable_renderSubtreeIntoContainer, which isn't supported. Try " + 'to make sure you have only one copy of React (and ideally, switch ' + 'to ReactDOM.createPortal).');
          }
        });
        Object.freeze(fakeInternalInstance);
      }

      function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        {
          if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);

            try {
              partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally {
              setIsStrictModeForDevtools(false);
            }
          }

          warnOnUndefinedDerivedState(ctor, partialState);
        }
        var memoizedState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState;

        if (workInProgress.lanes === NoLanes) {
          var updateQueue = workInProgress.updateQueue;
          updateQueue.baseState = memoizedState;
        }
      }

      var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function enqueueSetState(inst, payload, callback) {
          var fiber = get(inst);
          var eventTime = requestEventTime();
          var lane = requestUpdateLane(fiber);
          var update = createUpdate(eventTime, lane);
          update.payload = payload;

          if (callback !== undefined && callback !== null) {
            {
              warnOnInvalidCallback(callback, 'setState');
            }
            update.callback = callback;
          }

          enqueueUpdate(fiber, update);
          var root = scheduleUpdateOnFiber(fiber, lane, eventTime);

          if (root !== null) {
            entangleTransitions(root, fiber, lane);
          }

          {
            markStateUpdateScheduled(fiber, lane);
          }
        },
        enqueueReplaceState: function enqueueReplaceState(inst, payload, callback) {
          var fiber = get(inst);
          var eventTime = requestEventTime();
          var lane = requestUpdateLane(fiber);
          var update = createUpdate(eventTime, lane);
          update.tag = ReplaceState;
          update.payload = payload;

          if (callback !== undefined && callback !== null) {
            {
              warnOnInvalidCallback(callback, 'replaceState');
            }
            update.callback = callback;
          }

          enqueueUpdate(fiber, update);
          var root = scheduleUpdateOnFiber(fiber, lane, eventTime);

          if (root !== null) {
            entangleTransitions(root, fiber, lane);
          }

          {
            markStateUpdateScheduled(fiber, lane);
          }
        },
        enqueueForceUpdate: function enqueueForceUpdate(inst, callback) {
          var fiber = get(inst);
          var eventTime = requestEventTime();
          var lane = requestUpdateLane(fiber);
          var update = createUpdate(eventTime, lane);
          update.tag = ForceUpdate;

          if (callback !== undefined && callback !== null) {
            {
              warnOnInvalidCallback(callback, 'forceUpdate');
            }
            update.callback = callback;
          }

          enqueueUpdate(fiber, update);
          var root = scheduleUpdateOnFiber(fiber, lane, eventTime);

          if (root !== null) {
            entangleTransitions(root, fiber, lane);
          }

          {
            markForceUpdateScheduled(fiber, lane);
          }
        }
      };

      function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;

        if (typeof instance.shouldComponentUpdate === 'function') {
          var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
          {
            if (workInProgress.mode & StrictLegacyMode) {
              setIsStrictModeForDevtools(true);

              try {
                shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
              } finally {
                setIsStrictModeForDevtools(false);
              }
            }

            if (shouldUpdate === undefined) {
              error('%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', getComponentNameFromType(ctor) || 'Component');
            }
          }
          return shouldUpdate;
        }

        if (ctor.prototype && ctor.prototype.isPureReactComponent) {
          return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        }

        return true;
      }

      function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        {
          var name = getComponentNameFromType(ctor) || 'Component';
          var renderPresent = instance.render;

          if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === 'function') {
              error('%s(...): No `render` method found on the returned component ' + 'instance: did you accidentally return an object from the constructor?', name);
            } else {
              error('%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', name);
            }
          }

          if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
            error('getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', name);
          }

          if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
            error('getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', name);
          }

          if (instance.propTypes) {
            error('propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', name);
          }

          if (instance.contextType) {
            error('contextType was defined as an instance property on %s. Use a static ' + 'property to define contextType instead.', name);
          }

          {
            if (instance.contextTypes) {
              error('contextTypes was defined as an instance property on %s. Use a static ' + 'property to define contextTypes instead.', name);
            }

            if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
              didWarnAboutContextTypeAndContextTypes.add(ctor);
              error('%s declares both contextTypes and contextType static properties. ' + 'The legacy contextTypes property will be ignored.', name);
            }
          }

          if (typeof instance.componentShouldUpdate === 'function') {
            error('%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', name);
          }

          if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') {
            error('%s has a method called shouldComponentUpdate(). ' + 'shouldComponentUpdate should not be used when extending React.PureComponent. ' + 'Please extend React.Component if shouldComponentUpdate is used.', getComponentNameFromType(ctor) || 'A pure component');
          }

          if (typeof instance.componentDidUnmount === 'function') {
            error('%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', name);
          }

          if (typeof instance.componentDidReceiveProps === 'function') {
            error('%s has a method called ' + 'componentDidReceiveProps(). But there is no such lifecycle method. ' + 'If you meant to update the state in response to changing props, ' + 'use componentWillReceiveProps(). If you meant to fetch data or ' + 'run side-effects or mutations after React has updated the UI, use componentDidUpdate().', name);
          }

          if (typeof instance.componentWillRecieveProps === 'function') {
            error('%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', name);
          }

          if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') {
            error('%s has a method called ' + 'UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?', name);
          }

          var hasMutatedProps = instance.props !== newProps;

          if (instance.props !== undefined && hasMutatedProps) {
            error('%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", name, name);
          }

          if (instance.defaultProps) {
            error('Setting defaultProps as an instance property on %s is not supported and will be ignored.' + ' Instead, define defaultProps as a static property on %s.', name, name);
          }

          if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error('%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). ' + 'This component defines getSnapshotBeforeUpdate() only.', getComponentNameFromType(ctor));
          }

          if (typeof instance.getDerivedStateFromProps === 'function') {
            error('%s: getDerivedStateFromProps() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
          }

          if (typeof instance.getDerivedStateFromError === 'function') {
            error('%s: getDerivedStateFromError() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
          }

          if (typeof ctor.getSnapshotBeforeUpdate === 'function') {
            error('%s: getSnapshotBeforeUpdate() is defined as a static method ' + 'and will be ignored. Instead, declare it as an instance method.', name);
          }

          var _state = instance.state;

          if (_state && (typeof _state !== 'object' || isArray(_state))) {
            error('%s.state: must be set to an object or null', name);
          }

          if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') {
            error('%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', name);
          }
        }
      }

      function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance;
        set(instance, workInProgress);
        {
          instance._reactInternalInstance = fakeInternalInstance;
        }
      }

      function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        {
          if ('contextType' in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined;

            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
              didWarnAboutInvalidateContextType.add(ctor);
              var addendum = '';

              if (contextType === undefined) {
                addendum = ' However, it is set to undefined. ' + 'This can be caused by a typo or by mixing up named and default imports. ' + 'This can also happen due to a circular dependency, so ' + 'try moving the createContext() call to a separate file.';
              } else if (typeof contextType !== 'object') {
                addendum = ' However, it is set to a ' + typeof contextType + '.';
              } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
                addendum = ' Did you accidentally pass the Context.Provider instead?';
              } else if (contextType._context !== undefined) {
                addendum = ' Did you accidentally pass the Context.Consumer instead?';
              } else {
                addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
              }

              error('%s defines an invalid contextType. ' + 'contextType should point to the Context object returned by React.createContext().%s', getComponentNameFromType(ctor) || 'Component', addendum);
            }
          }
        }

        if (typeof contextType === 'object' && contextType !== null) {
          context = _readContext(contextType);
        } else {
          unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          var contextTypes = ctor.contextTypes;
          isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
          context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        }

        var instance = new ctor(props, context);
        {
          if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);

            try {
              instance = new ctor(props, context);
            } finally {
              setIsStrictModeForDevtools(false);
            }
          }
        }
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        {
          if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
            var componentName = getComponentNameFromType(ctor) || 'Component';

            if (!didWarnAboutUninitializedState.has(componentName)) {
              didWarnAboutUninitializedState.add(componentName);
              error('`%s` uses `getDerivedStateFromProps` but its initial state is ' + '%s. This is not recommended. Instead, define the initial state by ' + 'assigning an object to `this.state` in the constructor of `%s`. ' + 'This ensures that `getDerivedStateFromProps` arguments have a consistent shape.', componentName, instance.state === null ? 'null' : 'undefined', componentName);
            }
          }

          if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;

            if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
              foundWillMountName = 'componentWillMount';
            } else if (typeof instance.UNSAFE_componentWillMount === 'function') {
              foundWillMountName = 'UNSAFE_componentWillMount';
            }

            if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
              foundWillReceivePropsName = 'componentWillReceiveProps';
            } else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
              foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
            }

            if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
              foundWillUpdateName = 'componentWillUpdate';
            } else if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
              foundWillUpdateName = 'UNSAFE_componentWillUpdate';
            }

            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
              var _componentName = getComponentNameFromType(ctor) || 'Component';

              var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';

              if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + '%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\n' + 'The above lifecycles should be removed. Learn more about this warning here:\n' + 'https://reactjs.org/link/unsafe-component-lifecycles', _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
              }
            }
          }
        }

        if (isLegacyContextConsumer) {
          cacheContext(workInProgress, unmaskedContext, context);
        }

        return instance;
      }

      function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;

        if (typeof instance.componentWillMount === 'function') {
          instance.componentWillMount();
        }

        if (typeof instance.UNSAFE_componentWillMount === 'function') {
          instance.UNSAFE_componentWillMount();
        }

        if (oldState !== instance.state) {
          {
            error('%s.componentWillMount(): Assigning directly to this.state is ' + "deprecated (except inside a component's " + 'constructor). Use setState instead.', getComponentNameFromFiber(workInProgress) || 'Component');
          }
          classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
      }

      function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;

        if (typeof instance.componentWillReceiveProps === 'function') {
          instance.componentWillReceiveProps(newProps, nextContext);
        }

        if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
          instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        }

        if (instance.state !== oldState) {
          {
            var componentName = getComponentNameFromFiber(workInProgress) || 'Component';

            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
              didWarnAboutStateAssignmentForComponent.add(componentName);
              error('%s.componentWillReceiveProps(): Assigning directly to ' + "this.state is deprecated (except inside a component's " + 'constructor). Use setState instead.', componentName);
            }
          }
          classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
      }

      function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        {
          checkClassInstance(workInProgress, ctor, newProps);
        }
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;

        if (typeof contextType === 'object' && contextType !== null) {
          instance.context = _readContext(contextType);
        } else {
          var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }

        {
          if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || 'Component';

            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
              didWarnAboutDirectlyAssigningPropsToState.add(componentName);
              error('%s: It is not recommended to assign props directly to state ' + "because updates to props won't be reflected in state. " + 'In most cases, it is better to use props directly.', componentName);
            }
          }

          if (workInProgress.mode & StrictLegacyMode) {
            ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
          }

          {
            ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
          }
        }
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;

        if (typeof getDerivedStateFromProps === 'function') {
          applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
          instance.state = workInProgress.memoizedState;
        }

        if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
          callComponentWillMount(workInProgress, instance);
          processUpdateQueue(workInProgress, newProps, instance, renderLanes);
          instance.state = workInProgress.memoizedState;
        }

        if (typeof instance.componentDidMount === 'function') {
          var fiberFlags = Update;
          {
            fiberFlags |= LayoutStatic;
          }

          if ((workInProgress.mode & StrictEffectsMode) !== NoMode) {
            fiberFlags |= MountLayoutDev;
          }

          workInProgress.flags |= fiberFlags;
        }
      }

      function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;

        if (typeof contextType === 'object' && contextType !== null) {
          nextContext = _readContext(contextType);
        } else {
          var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }

        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function';

        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
          if (oldProps !== newProps || oldContext !== nextContext) {
            callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
          }
        }

        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;

        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
          if (typeof instance.componentDidMount === 'function') {
            var fiberFlags = Update;
            {
              fiberFlags |= LayoutStatic;
            }

            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) {
              fiberFlags |= MountLayoutDev;
            }

            workInProgress.flags |= fiberFlags;
          }

          return false;
        }

        if (typeof getDerivedStateFromProps === 'function') {
          applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
          newState = workInProgress.memoizedState;
        }

        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);

        if (shouldUpdate) {
          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
            if (typeof instance.componentWillMount === 'function') {
              instance.componentWillMount();
            }

            if (typeof instance.UNSAFE_componentWillMount === 'function') {
              instance.UNSAFE_componentWillMount();
            }
          }

          if (typeof instance.componentDidMount === 'function') {
            var _fiberFlags = Update;
            {
              _fiberFlags |= LayoutStatic;
            }

            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) {
              _fiberFlags |= MountLayoutDev;
            }

            workInProgress.flags |= _fiberFlags;
          }
        } else {
          if (typeof instance.componentDidMount === 'function') {
            var _fiberFlags2 = Update;
            {
              _fiberFlags2 |= LayoutStatic;
            }

            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) {
              _fiberFlags2 |= MountLayoutDev;
            }

            workInProgress.flags |= _fiberFlags2;
          }

          workInProgress.memoizedProps = newProps;
          workInProgress.memoizedState = newState;
        }

        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
      }

      function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;

        if (typeof contextType === 'object' && contextType !== null) {
          nextContext = _readContext(contextType);
        } else {
          var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }

        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function';

        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
          if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) {
            callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
          }
        }

        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;

        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing() && !enableLazyContextPropagation) {
          if (typeof instance.componentDidUpdate === 'function') {
            if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.flags |= Update;
            }
          }

          if (typeof instance.getSnapshotBeforeUpdate === 'function') {
            if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.flags |= Snapshot;
            }
          }

          return false;
        }

        if (typeof getDerivedStateFromProps === 'function') {
          applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
          newState = workInProgress.memoizedState;
        }

        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) || enableLazyContextPropagation;

        if (shouldUpdate) {
          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
            if (typeof instance.componentWillUpdate === 'function') {
              instance.componentWillUpdate(newProps, newState, nextContext);
            }

            if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
              instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
          }

          if (typeof instance.componentDidUpdate === 'function') {
            workInProgress.flags |= Update;
          }

          if (typeof instance.getSnapshotBeforeUpdate === 'function') {
            workInProgress.flags |= Snapshot;
          }
        } else {
          if (typeof instance.componentDidUpdate === 'function') {
            if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.flags |= Update;
            }
          }

          if (typeof instance.getSnapshotBeforeUpdate === 'function') {
            if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.flags |= Snapshot;
            }
          }

          workInProgress.memoizedProps = newProps;
          workInProgress.memoizedState = newState;
        }

        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
      }

      var forkStack = [];
      var forkStackIndex = 0;
      var treeForkProvider = null;
      var treeForkCount = 0;
      var idStack = [];
      var idStackIndex = 0;
      var treeContextProvider = null;
      var treeContextId = 1;
      var treeContextOverflow = '';

      function isForkedChild(workInProgress) {
        warnIfNotHydrating();
        return (workInProgress.flags & Forked) !== NoFlags;
      }

      function getForksAtLevel(workInProgress) {
        warnIfNotHydrating();
        return treeForkCount;
      }

      function getTreeId() {
        var overflow = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
      }

      function pushTreeFork(workInProgress, totalChildren) {
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
      }

      function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        var baseOverflow = treeContextOverflow;
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength;

        if (length > 30) {
          var numberOfOverflowBits = baseLength - baseLength % 5;
          var newOverflowBits = (1 << numberOfOverflowBits) - 1;
          var newOverflow = (baseId & newOverflowBits).toString(32);
          var restOfBaseId = baseId >> numberOfOverflowBits;
          var restOfBaseLength = baseLength - numberOfOverflowBits;
          var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
          var restOfNewBits = slot << restOfBaseLength;
          var id = restOfNewBits | restOfBaseId;
          var overflow = newOverflow + baseOverflow;
          treeContextId = 1 << restOfLength | id;
          treeContextOverflow = overflow;
        } else {
          var newBits = slot << baseLength;

          var _id = newBits | baseId;

          var _overflow = baseOverflow;
          treeContextId = 1 << length | _id;
          treeContextOverflow = _overflow;
        }
      }

      function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating();
        var returnFiber = workInProgress["return"];

        if (returnFiber !== null) {
          var numberOfForks = 1;
          var slotIndex = 0;
          pushTreeFork(workInProgress, numberOfForks);
          pushTreeId(workInProgress, numberOfForks, slotIndex);
        }
      }

      function getBitLength(number) {
        return 32 - clz32(number);
      }

      function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
      }

      function popTreeContext(workInProgress) {
        while (workInProgress === treeForkProvider) {
          treeForkProvider = forkStack[--forkStackIndex];
          forkStack[forkStackIndex] = null;
          treeForkCount = forkStack[--forkStackIndex];
          forkStack[forkStackIndex] = null;
        }

        while (workInProgress === treeContextProvider) {
          treeContextProvider = idStack[--idStackIndex];
          idStack[idStackIndex] = null;
          treeContextOverflow = idStack[--idStackIndex];
          idStack[idStackIndex] = null;
          treeContextId = idStack[--idStackIndex];
          idStack[idStackIndex] = null;
        }
      }

      function getSuspendedTreeContext() {
        warnIfNotHydrating();

        if (treeContextProvider !== null) {
          return {
            id: treeContextId,
            overflow: treeContextOverflow
          };
        } else {
          return null;
        }
      }

      function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
      }

      function warnIfNotHydrating() {
        {
          if (!getIsHydrating()) {
            error('Expected to be hydrating. This is a bug in React. Please file ' + 'an issue.');
          }
        }
      }

      var hydrationParentFiber = null;
      var nextHydratableInstance = null;
      var isHydrating = false;
      var didSuspendOrErrorDEV = false;
      var hydrationErrors = null;

      function warnIfHydrating() {
        {
          if (isHydrating) {
            error('We should not be hydrating here. This is a bug in React. Please file a bug.');
          }
        }
      }

      function markDidThrowWhileHydratingDEV() {
        {
          didSuspendOrErrorDEV = true;
        }
      }

      function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChildWithinContainer(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        return true;
      }

      function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance, treeContext) {
        nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(suspenseInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;

        if (treeContext !== null) {
          restoreSuspendedTreeContext(fiber, treeContext);
        }

        return true;
      }

      function warnUnhydratedInstance(returnFiber, instance) {
        {
          switch (returnFiber.tag) {
            case HostRoot:
              {
                didNotHydrateInstanceWithinContainer(returnFiber.stateNode.containerInfo, instance);
                break;
              }

            case HostComponent:
              {
                var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance, isConcurrentMode);
                break;
              }

            case SuspenseComponent:
              {
                var suspenseState = returnFiber.memoizedState;
                if (suspenseState.dehydrated !== null) didNotHydrateInstanceWithinSuspenseInstance(suspenseState.dehydrated, instance);
                break;
              }
          }
        }
      }

      function deleteHydratableInstance(returnFiber, instance) {
        warnUnhydratedInstance(returnFiber, instance);
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete["return"] = returnFiber;
        var deletions = returnFiber.deletions;

        if (deletions === null) {
          returnFiber.deletions = [childToDelete];
          returnFiber.flags |= ChildDeletion;
        } else {
          deletions.push(childToDelete);
        }
      }

      function warnNonhydratedInstance(returnFiber, fiber) {
        {
          if (didSuspendOrErrorDEV) {
            return;
          }

          switch (returnFiber.tag) {
            case HostRoot:
              {
                var parentContainer = returnFiber.stateNode.containerInfo;

                switch (fiber.tag) {
                  case HostComponent:
                    var type = fiber.type;
                    didNotFindHydratableInstanceWithinContainer(parentContainer, type);
                    break;

                  case HostText:
                    var text = fiber.pendingProps;
                    didNotFindHydratableTextInstanceWithinContainer(parentContainer, text);
                    break;
                }

                break;
              }

            case HostComponent:
              {
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;

                switch (fiber.tag) {
                  case HostComponent:
                    {
                      var _type = fiber.type;
                      var _props = fiber.pendingProps;
                      var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                      didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props, isConcurrentMode);
                      break;
                    }

                  case HostText:
                    {
                      var _text = fiber.pendingProps;

                      var _isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;

                      didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text, _isConcurrentMode);
                      break;
                    }
                }

                break;
              }

            case SuspenseComponent:
              {
                var suspenseState = returnFiber.memoizedState;
                var _parentInstance = suspenseState.dehydrated;
                if (_parentInstance !== null) switch (fiber.tag) {
                  case HostComponent:
                    var _type2 = fiber.type;
                    didNotFindHydratableInstanceWithinSuspenseInstance(_parentInstance, _type2);
                    break;

                  case HostText:
                    var _text2 = fiber.pendingProps;
                    didNotFindHydratableTextInstanceWithinSuspenseInstance(_parentInstance, _text2);
                    break;
                }
                break;
              }

            default:
              return;
          }
        }
      }

      function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        warnNonhydratedInstance(returnFiber, fiber);
      }

      function tryHydrate(fiber, nextInstance) {
        switch (fiber.tag) {
          case HostComponent:
            {
              var type = fiber.type;
              var instance = canHydrateInstance(nextInstance, type);

              if (instance !== null) {
                fiber.stateNode = instance;
                hydrationParentFiber = fiber;
                nextHydratableInstance = getFirstHydratableChild(instance);
                return true;
              }

              return false;
            }

          case HostText:
            {
              var text = fiber.pendingProps;
              var textInstance = canHydrateTextInstance(nextInstance, text);

              if (textInstance !== null) {
                fiber.stateNode = textInstance;
                hydrationParentFiber = fiber;
                nextHydratableInstance = null;
                return true;
              }

              return false;
            }

          case SuspenseComponent:
            {
              var suspenseInstance = canHydrateSuspenseInstance(nextInstance);

              if (suspenseInstance !== null) {
                var suspenseState = {
                  dehydrated: suspenseInstance,
                  treeContext: getSuspendedTreeContext(),
                  retryLane: OffscreenLane
                };
                fiber.memoizedState = suspenseState;
                var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                dehydratedFragment["return"] = fiber;
                fiber.child = dehydratedFragment;
                hydrationParentFiber = fiber;
                nextHydratableInstance = null;
                return true;
              }

              return false;
            }

          default:
            return false;
        }
      }

      function shouldClientRenderOnMismatch(fiber) {
        return (fiber.mode & ConcurrentMode) !== NoMode && (fiber.flags & DidCapture) === NoFlags;
      }

      function throwOnHydrationMismatch(fiber) {
        throw new Error('Hydration failed because the initial UI does not match what was ' + 'rendered on the server.');
      }

      function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) {
          return;
        }

        var nextInstance = nextHydratableInstance;

        if (!nextInstance) {
          if (shouldClientRenderOnMismatch(fiber)) {
            warnNonhydratedInstance(hydrationParentFiber, fiber);
            throwOnHydrationMismatch();
          }

          insertNonHydratedInstance(hydrationParentFiber, fiber);
          isHydrating = false;
          hydrationParentFiber = fiber;
          return;
        }

        var firstAttemptedInstance = nextInstance;

        if (!tryHydrate(fiber, nextInstance)) {
          if (shouldClientRenderOnMismatch(fiber)) {
            warnNonhydratedInstance(hydrationParentFiber, fiber);
            throwOnHydrationMismatch();
          }

          nextInstance = getNextHydratableSibling(firstAttemptedInstance);
          var prevHydrationParentFiber = hydrationParentFiber;

          if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
          }

          deleteHydratableInstance(prevHydrationParentFiber, firstAttemptedInstance);
        }
      }

      function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var shouldWarnIfMismatchDev = !didSuspendOrErrorDEV;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber, shouldWarnIfMismatchDev);
        fiber.updateQueue = updatePayload;

        if (updatePayload !== null) {
          return true;
        }

        return false;
      }

      function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);

        if (shouldUpdate) {
          var returnFiber = hydrationParentFiber;

          if (returnFiber !== null) {
            switch (returnFiber.tag) {
              case HostRoot:
                {
                  var parentContainer = returnFiber.stateNode.containerInfo;
                  var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                  didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent, isConcurrentMode);
                  break;
                }

              case HostComponent:
                {
                  var parentType = returnFiber.type;
                  var parentProps = returnFiber.memoizedProps;
                  var parentInstance = returnFiber.stateNode;

                  var _isConcurrentMode2 = (returnFiber.mode & ConcurrentMode) !== NoMode;

                  didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent, _isConcurrentMode2);
                  break;
                }
            }
          }
        }

        return shouldUpdate;
      }

      function prepareToHydrateHostSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;

        if (!suspenseInstance) {
          throw new Error('Expected to have a hydrated suspense instance. ' + 'This error is likely caused by a bug in React. Please file an issue.');
        }

        hydrateSuspenseInstance(suspenseInstance, fiber);
      }

      function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;

        if (!suspenseInstance) {
          throw new Error('Expected to have a hydrated suspense instance. ' + 'This error is likely caused by a bug in React. Please file an issue.');
        }

        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
      }

      function popToNextHostParent(fiber) {
        var parent = fiber["return"];

        while (parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent) {
          parent = parent["return"];
        }

        hydrationParentFiber = parent;
      }

      function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) {
          return false;
        }

        if (!isHydrating) {
          popToNextHostParent(fiber);
          isHydrating = true;
          return false;
        }

        if (fiber.tag !== HostRoot && (fiber.tag !== HostComponent || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps))) {
          var nextInstance = nextHydratableInstance;

          if (nextInstance) {
            if (shouldClientRenderOnMismatch(fiber)) {
              warnIfUnhydratedTailNodes(fiber);
              throwOnHydrationMismatch();
            } else {
              while (nextInstance) {
                deleteHydratableInstance(fiber, nextInstance);
                nextInstance = getNextHydratableSibling(nextInstance);
              }
            }
          }
        }

        popToNextHostParent(fiber);

        if (fiber.tag === SuspenseComponent) {
          nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        } else {
          nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        }

        return true;
      }

      function hasUnhydratedTailNodes() {
        return isHydrating && nextHydratableInstance !== null;
      }

      function warnIfUnhydratedTailNodes(fiber) {
        var nextInstance = nextHydratableInstance;

        while (nextInstance) {
          warnUnhydratedInstance(fiber, nextInstance);
          nextInstance = getNextHydratableSibling(nextInstance);
        }
      }

      function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
        didSuspendOrErrorDEV = false;
      }

      function upgradeHydrationErrorsToRecoverable() {
        if (hydrationErrors !== null) {
          queueRecoverableErrors(hydrationErrors);
          hydrationErrors = null;
        }
      }

      function getIsHydrating() {
        return isHydrating;
      }

      function queueHydrationError(error) {
        if (hydrationErrors === null) {
          hydrationErrors = [error];
        } else {
          hydrationErrors.push(error);
        }
      }

      var didWarnAboutMaps;
      var didWarnAboutGenerators;
      var didWarnAboutStringRefs;
      var ownerHasKeyUseWarning;
      var ownerHasFunctionTypeWarning;

      var warnForMissingKey = function warnForMissingKey(child, returnFiber) {};

      {
        didWarnAboutMaps = false;
        didWarnAboutGenerators = false;
        didWarnAboutStringRefs = {};
        ownerHasKeyUseWarning = {};
        ownerHasFunctionTypeWarning = {};

        warnForMissingKey = function warnForMissingKey(child, returnFiber) {
          if (child === null || typeof child !== 'object') {
            return;
          }

          if (!child._store || child._store.validated || child.key != null) {
            return;
          }

          if (typeof child._store !== 'object') {
            throw new Error('React Component in warnForMissingKey should have a _store. ' + 'This error is likely caused by a bug in React. Please file an issue.');
          }

          child._store.validated = true;
          var componentName = getComponentNameFromFiber(returnFiber) || 'Component';

          if (ownerHasKeyUseWarning[componentName]) {
            return;
          }

          ownerHasKeyUseWarning[componentName] = true;
          error('Each child in a list should have a unique ' + '"key" prop. See https://reactjs.org/link/warning-keys for ' + 'more information.');
        };
      }

      function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;

        if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
          {
            if ((returnFiber.mode & StrictLegacyMode || warnAboutStringRefs) && !(element._owner && element._self && element._owner.stateNode !== element._self)) {
              var componentName = getComponentNameFromFiber(returnFiber) || 'Component';

              if (!didWarnAboutStringRefs[componentName]) {
                {
                  error('A string ref, "%s", has been found within a strict mode tree. ' + 'String refs are a source of potential bugs and should be avoided. ' + 'We recommend using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', mixedRef);
                }
                didWarnAboutStringRefs[componentName] = true;
              }
            }
          }

          if (element._owner) {
            var owner = element._owner;
            var inst;

            if (owner) {
              var ownerFiber = owner;

              if (ownerFiber.tag !== ClassComponent) {
                throw new Error('Function components cannot have string refs. ' + 'We recommend using useRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref');
              }

              inst = ownerFiber.stateNode;
            }

            if (!inst) {
              throw new Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a " + 'bug in React. Please file an issue.');
            }

            var resolvedInst = inst;
            {
              checkPropStringCoercion(mixedRef, 'ref');
            }
            var stringRef = '' + mixedRef;

            if (current !== null && current.ref !== null && typeof current.ref === 'function' && current.ref._stringRef === stringRef) {
              return current.ref;
            }

            var ref = function ref(value) {
              var refs = resolvedInst.refs;

              if (refs === emptyRefsObject) {
                refs = resolvedInst.refs = {};
              }

              if (value === null) {
                delete refs[stringRef];
              } else {
                refs[stringRef] = value;
              }
            };

            ref._stringRef = stringRef;
            return ref;
          } else {
            if (typeof mixedRef !== 'string') {
              throw new Error('Expected ref to be a function, a string, an object returned by React.createRef(), or null.');
            }

            if (!element._owner) {
              throw new Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of" + ' the following reasons:\n' + '1. You may be adding a ref to a function component\n' + "2. You may be adding a ref to a component that was not created inside a component's render method\n" + '3. You have multiple copies of React loaded\n' + 'See https://reactjs.org/link/refs-must-have-owner for more information.');
            }
          }
        }

        return mixedRef;
      }

      function throwOnInvalidObjectType(returnFiber, newChild) {
        var childString = Object.prototype.toString.call(newChild);
        throw new Error("Objects are not valid as a React child (found: " + (childString === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : childString) + "). " + 'If you meant to render a collection of children, use an array ' + 'instead.');
      }

      function warnOnFunctionType(returnFiber) {
        {
          var componentName = getComponentNameFromFiber(returnFiber) || 'Component';

          if (ownerHasFunctionTypeWarning[componentName]) {
            return;
          }

          ownerHasFunctionTypeWarning[componentName] = true;
          error('Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.');
        }
      }

      function resolveLazy(lazyType) {
        var payload = lazyType._payload;
        var init = lazyType._init;
        return init(payload);
      }

      function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
          if (!shouldTrackSideEffects) {
            return;
          }

          var deletions = returnFiber.deletions;

          if (deletions === null) {
            returnFiber.deletions = [childToDelete];
            returnFiber.flags |= ChildDeletion;
          } else {
            deletions.push(childToDelete);
          }
        }

        function deleteRemainingChildren(returnFiber, currentFirstChild) {
          if (!shouldTrackSideEffects) {
            return null;
          }

          var childToDelete = currentFirstChild;

          while (childToDelete !== null) {
            deleteChild(returnFiber, childToDelete);
            childToDelete = childToDelete.sibling;
          }

          return null;
        }

        function mapRemainingChildren(returnFiber, currentFirstChild) {
          var existingChildren = new Map();
          var existingChild = currentFirstChild;

          while (existingChild !== null) {
            if (existingChild.key !== null) {
              existingChildren.set(existingChild.key, existingChild);
            } else {
              existingChildren.set(existingChild.index, existingChild);
            }

            existingChild = existingChild.sibling;
          }

          return existingChildren;
        }

        function useFiber(fiber, pendingProps) {
          var clone = createWorkInProgress(fiber, pendingProps);
          clone.index = 0;
          clone.sibling = null;
          return clone;
        }

        function placeChild(newFiber, lastPlacedIndex, newIndex) {
          newFiber.index = newIndex;

          if (!shouldTrackSideEffects) {
            newFiber.flags |= Forked;
            return lastPlacedIndex;
          }

          var current = newFiber.alternate;

          if (current !== null) {
            var oldIndex = current.index;

            if (oldIndex < lastPlacedIndex) {
              newFiber.flags |= Placement;
              return lastPlacedIndex;
            } else {
              return oldIndex;
            }
          } else {
            newFiber.flags |= Placement;
            return lastPlacedIndex;
          }
        }

        function placeSingleChild(newFiber) {
          if (shouldTrackSideEffects && newFiber.alternate === null) {
            newFiber.flags |= Placement;
          }

          return newFiber;
        }

        function updateTextNode(returnFiber, current, textContent, lanes) {
          if (current === null || current.tag !== HostText) {
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created["return"] = returnFiber;
            return created;
          } else {
            var existing = useFiber(current, textContent);
            existing["return"] = returnFiber;
            return existing;
          }
        }

        function updateElement(returnFiber, current, element, lanes) {
          var elementType = element.type;

          if (elementType === REACT_FRAGMENT_TYPE) {
            return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
          }

          if (current !== null) {
            if (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || typeof elementType === 'object' && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type) {
              var existing = useFiber(current, element.props);
              existing.ref = coerceRef(returnFiber, current, element);
              existing["return"] = returnFiber;
              {
                existing._debugSource = element._source;
                existing._debugOwner = element._owner;
              }
              return existing;
            }
          }

          var created = createFiberFromElement(element, returnFiber.mode, lanes);
          created.ref = coerceRef(returnFiber, current, element);
          created["return"] = returnFiber;
          return created;
        }

        function updatePortal(returnFiber, current, portal, lanes) {
          if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created["return"] = returnFiber;
            return created;
          } else {
            var existing = useFiber(current, portal.children || []);
            existing["return"] = returnFiber;
            return existing;
          }
        }

        function updateFragment(returnFiber, current, fragment, lanes, key) {
          if (current === null || current.tag !== Fragment) {
            var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
            created["return"] = returnFiber;
            return created;
          } else {
            var existing = useFiber(current, fragment);
            existing["return"] = returnFiber;
            return existing;
          }
        }

        function createChild(returnFiber, newChild, lanes) {
          if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
            var created = createFiberFromText('' + newChild, returnFiber.mode, lanes);
            created["return"] = returnFiber;
            return created;
          }

          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                {
                  var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);

                  _created.ref = coerceRef(returnFiber, null, newChild);
                  _created["return"] = returnFiber;
                  return _created;
                }

              case REACT_PORTAL_TYPE:
                {
                  var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);

                  _created2["return"] = returnFiber;
                  return _created2;
                }

              case REACT_LAZY_TYPE:
                {
                  var payload = newChild._payload;
                  var init = newChild._init;
                  return createChild(returnFiber, init(payload), lanes);
                }
            }

            if (isArray(newChild) || getIteratorFn(newChild)) {
              var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);

              _created3["return"] = returnFiber;
              return _created3;
            }

            throwOnInvalidObjectType(returnFiber, newChild);
          }

          {
            if (typeof newChild === 'function') {
              warnOnFunctionType(returnFiber);
            }
          }
          return null;
        }

        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
          var key = oldFiber !== null ? oldFiber.key : null;

          if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
            if (key !== null) {
              return null;
            }

            return updateTextNode(returnFiber, oldFiber, '' + newChild, lanes);
          }

          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                {
                  if (newChild.key === key) {
                    return updateElement(returnFiber, oldFiber, newChild, lanes);
                  } else {
                    return null;
                  }
                }

              case REACT_PORTAL_TYPE:
                {
                  if (newChild.key === key) {
                    return updatePortal(returnFiber, oldFiber, newChild, lanes);
                  } else {
                    return null;
                  }
                }

              case REACT_LAZY_TYPE:
                {
                  var payload = newChild._payload;
                  var init = newChild._init;
                  return updateSlot(returnFiber, oldFiber, init(payload), lanes);
                }
            }

            if (isArray(newChild) || getIteratorFn(newChild)) {
              if (key !== null) {
                return null;
              }

              return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            }

            throwOnInvalidObjectType(returnFiber, newChild);
          }

          {
            if (typeof newChild === 'function') {
              warnOnFunctionType(returnFiber);
            }
          }
          return null;
        }

        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
          if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
            var matchedFiber = existingChildren.get(newIdx) || null;
            return updateTextNode(returnFiber, matchedFiber, '' + newChild, lanes);
          }

          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                {
                  var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;

                  return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                }

              case REACT_PORTAL_TYPE:
                {
                  var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;

                  return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                }

              case REACT_LAZY_TYPE:
                var payload = newChild._payload;
                var init = newChild._init;
                return updateFromMap(existingChildren, returnFiber, newIdx, init(payload), lanes);
            }

            if (isArray(newChild) || getIteratorFn(newChild)) {
              var _matchedFiber3 = existingChildren.get(newIdx) || null;

              return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
            }

            throwOnInvalidObjectType(returnFiber, newChild);
          }

          {
            if (typeof newChild === 'function') {
              warnOnFunctionType(returnFiber);
            }
          }
          return null;
        }

        function warnOnInvalidKey(child, knownKeys, returnFiber) {
          {
            if (typeof child !== 'object' || child === null) {
              return knownKeys;
            }

            switch (child.$$typeof) {
              case REACT_ELEMENT_TYPE:
              case REACT_PORTAL_TYPE:
                warnForMissingKey(child, returnFiber);
                var key = child.key;

                if (typeof key !== 'string') {
                  break;
                }

                if (knownKeys === null) {
                  knownKeys = new Set();
                  knownKeys.add(key);
                  break;
                }

                if (!knownKeys.has(key)) {
                  knownKeys.add(key);
                  break;
                }

                error('Encountered two children with the same key, `%s`. ' + 'Keys should be unique so that components maintain their identity ' + 'across updates. Non-unique keys may cause children to be ' + 'duplicated and/or omitted — the behavior is unsupported and ' + 'could change in a future version.', key);
                break;

              case REACT_LAZY_TYPE:
                var payload = child._payload;
                var init = child._init;
                warnOnInvalidKey(init(payload), knownKeys, returnFiber);
                break;
            }
          }
          return knownKeys;
        }

        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
          {
            var knownKeys = null;

            for (var i = 0; i < newChildren.length; i++) {
              var child = newChildren[i];
              knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
          }
          var resultingFirstChild = null;
          var previousNewFiber = null;
          var oldFiber = currentFirstChild;
          var lastPlacedIndex = 0;
          var newIdx = 0;
          var nextOldFiber = null;

          for (; oldFiber !== null && newIdx < newChildren.length; newIdx++) {
            if (oldFiber.index > newIdx) {
              nextOldFiber = oldFiber;
              oldFiber = null;
            } else {
              nextOldFiber = oldFiber.sibling;
            }

            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);

            if (newFiber === null) {
              if (oldFiber === null) {
                oldFiber = nextOldFiber;
              }

              break;
            }

            if (shouldTrackSideEffects) {
              if (oldFiber && newFiber.alternate === null) {
                deleteChild(returnFiber, oldFiber);
              }
            }

            lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);

            if (previousNewFiber === null) {
              resultingFirstChild = newFiber;
            } else {
              previousNewFiber.sibling = newFiber;
            }

            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
          }

          if (newIdx === newChildren.length) {
            deleteRemainingChildren(returnFiber, oldFiber);

            if (getIsHydrating()) {
              var numberOfForks = newIdx;
              pushTreeFork(returnFiber, numberOfForks);
            }

            return resultingFirstChild;
          }

          if (oldFiber === null) {
            for (; newIdx < newChildren.length; newIdx++) {
              var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);

              if (_newFiber === null) {
                continue;
              }

              lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);

              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber;
              } else {
                previousNewFiber.sibling = _newFiber;
              }

              previousNewFiber = _newFiber;
            }

            if (getIsHydrating()) {
              var _numberOfForks = newIdx;
              pushTreeFork(returnFiber, _numberOfForks);
            }

            return resultingFirstChild;
          }

          var existingChildren = mapRemainingChildren(returnFiber, oldFiber);

          for (; newIdx < newChildren.length; newIdx++) {
            var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);

            if (_newFiber2 !== null) {
              if (shouldTrackSideEffects) {
                if (_newFiber2.alternate !== null) {
                  existingChildren["delete"](_newFiber2.key === null ? newIdx : _newFiber2.key);
                }
              }

              lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);

              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber2;
              } else {
                previousNewFiber.sibling = _newFiber2;
              }

              previousNewFiber = _newFiber2;
            }
          }

          if (shouldTrackSideEffects) {
            existingChildren.forEach(function (child) {
              return deleteChild(returnFiber, child);
            });
          }

          if (getIsHydrating()) {
            var _numberOfForks2 = newIdx;
            pushTreeFork(returnFiber, _numberOfForks2);
          }

          return resultingFirstChild;
        }

        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
          var iteratorFn = getIteratorFn(newChildrenIterable);

          if (typeof iteratorFn !== 'function') {
            throw new Error('An object is not an iterable. This error is likely caused by a bug in ' + 'React. Please file an issue.');
          }

          {
            if (typeof Symbol === 'function' && newChildrenIterable[Symbol.toStringTag] === 'Generator') {
              if (!didWarnAboutGenerators) {
                error('Using Generators as children is unsupported and will likely yield ' + 'unexpected results because enumerating a generator mutates it. ' + 'You may convert it to an array with `Array.from()` or the ' + '`[...spread]` operator before rendering. Keep in mind ' + 'you might need to polyfill these features for older browsers.');
              }

              didWarnAboutGenerators = true;
            }

            if (newChildrenIterable.entries === iteratorFn) {
              if (!didWarnAboutMaps) {
                error('Using Maps as children is not supported. ' + 'Use an array of keyed ReactElements instead.');
              }

              didWarnAboutMaps = true;
            }

            var _newChildren = iteratorFn.call(newChildrenIterable);

            if (_newChildren) {
              var knownKeys = null;

              var _step = _newChildren.next();

              for (; !_step.done; _step = _newChildren.next()) {
                var child = _step.value;
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
              }
            }
          }
          var newChildren = iteratorFn.call(newChildrenIterable);

          if (newChildren == null) {
            throw new Error('An iterable object provided no iterator.');
          }

          var resultingFirstChild = null;
          var previousNewFiber = null;
          var oldFiber = currentFirstChild;
          var lastPlacedIndex = 0;
          var newIdx = 0;
          var nextOldFiber = null;
          var step = newChildren.next();

          for (; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()) {
            if (oldFiber.index > newIdx) {
              nextOldFiber = oldFiber;
              oldFiber = null;
            } else {
              nextOldFiber = oldFiber.sibling;
            }

            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);

            if (newFiber === null) {
              if (oldFiber === null) {
                oldFiber = nextOldFiber;
              }

              break;
            }

            if (shouldTrackSideEffects) {
              if (oldFiber && newFiber.alternate === null) {
                deleteChild(returnFiber, oldFiber);
              }
            }

            lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);

            if (previousNewFiber === null) {
              resultingFirstChild = newFiber;
            } else {
              previousNewFiber.sibling = newFiber;
            }

            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
          }

          if (step.done) {
            deleteRemainingChildren(returnFiber, oldFiber);

            if (getIsHydrating()) {
              var numberOfForks = newIdx;
              pushTreeFork(returnFiber, numberOfForks);
            }

            return resultingFirstChild;
          }

          if (oldFiber === null) {
            for (; !step.done; newIdx++, step = newChildren.next()) {
              var _newFiber3 = createChild(returnFiber, step.value, lanes);

              if (_newFiber3 === null) {
                continue;
              }

              lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);

              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber3;
              } else {
                previousNewFiber.sibling = _newFiber3;
              }

              previousNewFiber = _newFiber3;
            }

            if (getIsHydrating()) {
              var _numberOfForks3 = newIdx;
              pushTreeFork(returnFiber, _numberOfForks3);
            }

            return resultingFirstChild;
          }

          var existingChildren = mapRemainingChildren(returnFiber, oldFiber);

          for (; !step.done; newIdx++, step = newChildren.next()) {
            var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);

            if (_newFiber4 !== null) {
              if (shouldTrackSideEffects) {
                if (_newFiber4.alternate !== null) {
                  existingChildren["delete"](_newFiber4.key === null ? newIdx : _newFiber4.key);
                }
              }

              lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);

              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber4;
              } else {
                previousNewFiber.sibling = _newFiber4;
              }

              previousNewFiber = _newFiber4;
            }
          }

          if (shouldTrackSideEffects) {
            existingChildren.forEach(function (child) {
              return deleteChild(returnFiber, child);
            });
          }

          if (getIsHydrating()) {
            var _numberOfForks4 = newIdx;
            pushTreeFork(returnFiber, _numberOfForks4);
          }

          return resultingFirstChild;
        }

        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
          if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
            deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
            var existing = useFiber(currentFirstChild, textContent);
            existing["return"] = returnFiber;
            return existing;
          }

          deleteRemainingChildren(returnFiber, currentFirstChild);
          var created = createFiberFromText(textContent, returnFiber.mode, lanes);
          created["return"] = returnFiber;
          return created;
        }

        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
          var key = element.key;
          var child = currentFirstChild;

          while (child !== null) {
            if (child.key === key) {
              var elementType = element.type;

              if (elementType === REACT_FRAGMENT_TYPE) {
                if (child.tag === Fragment) {
                  deleteRemainingChildren(returnFiber, child.sibling);
                  var existing = useFiber(child, element.props.children);
                  existing["return"] = returnFiber;
                  {
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                  }
                  return existing;
                }
              } else {
                if (child.elementType === elementType || isCompatibleFamilyForHotReloading(child, element) || typeof elementType === 'object' && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === child.type) {
                  deleteRemainingChildren(returnFiber, child.sibling);

                  var _existing = useFiber(child, element.props);

                  _existing.ref = coerceRef(returnFiber, child, element);
                  _existing["return"] = returnFiber;
                  {
                    _existing._debugSource = element._source;
                    _existing._debugOwner = element._owner;
                  }
                  return _existing;
                }
              }

              deleteRemainingChildren(returnFiber, child);
              break;
            } else {
              deleteChild(returnFiber, child);
            }

            child = child.sibling;
          }

          if (element.type === REACT_FRAGMENT_TYPE) {
            var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
            created["return"] = returnFiber;
            return created;
          } else {
            var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);

            _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
            _created4["return"] = returnFiber;
            return _created4;
          }
        }

        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
          var key = portal.key;
          var child = currentFirstChild;

          while (child !== null) {
            if (child.key === key) {
              if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                deleteRemainingChildren(returnFiber, child.sibling);
                var existing = useFiber(child, portal.children || []);
                existing["return"] = returnFiber;
                return existing;
              } else {
                deleteRemainingChildren(returnFiber, child);
                break;
              }
            } else {
              deleteChild(returnFiber, child);
            }

            child = child.sibling;
          }

          var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
          created["return"] = returnFiber;
          return created;
        }

        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
          var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;

          if (isUnkeyedTopLevelFragment) {
            newChild = newChild.props.children;
          }

          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));

              case REACT_PORTAL_TYPE:
                return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));

              case REACT_LAZY_TYPE:
                var payload = newChild._payload;
                var init = newChild._init;
                return reconcileChildFibers(returnFiber, currentFirstChild, init(payload), lanes);
            }

            if (isArray(newChild)) {
              return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            }

            if (getIteratorFn(newChild)) {
              return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }

            throwOnInvalidObjectType(returnFiber, newChild);
          }

          if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
            return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, lanes));
          }

          {
            if (typeof newChild === 'function') {
              warnOnFunctionType(returnFiber);
            }
          }
          return deleteRemainingChildren(returnFiber, currentFirstChild);
        }

        return reconcileChildFibers;
      }

      var reconcileChildFibers = ChildReconciler(true);
      var mountChildFibers = ChildReconciler(false);

      function cloneChildFibers(current, workInProgress) {
        if (current !== null && workInProgress.child !== current.child) {
          throw new Error('Resuming work not yet implemented.');
        }

        if (workInProgress.child === null) {
          return;
        }

        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild["return"] = workInProgress;

        while (currentChild.sibling !== null) {
          currentChild = currentChild.sibling;
          newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
          newChild["return"] = workInProgress;
        }

        newChild.sibling = null;
      }

      function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;

        while (child !== null) {
          resetWorkInProgress(child, lanes);
          child = child.sibling;
        }
      }

      var NO_CONTEXT = {};
      var contextStackCursor$1 = createCursor(NO_CONTEXT);
      var contextFiberStackCursor = createCursor(NO_CONTEXT);
      var rootInstanceStackCursor = createCursor(NO_CONTEXT);

      function requiredContext(c) {
        if (c === NO_CONTEXT) {
          throw new Error('Expected host context to exist. This error is likely caused by a bug ' + 'in React. Please file an issue.');
        }

        return c;
      }

      function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
      }

      function pushHostContainer(fiber, nextRootInstance) {
        push(rootInstanceStackCursor, nextRootInstance, fiber);
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance);
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
      }

      function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
      }

      function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
      }

      function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type);

        if (context === nextContext) {
          return;
        }

        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
      }

      function popHostContext(fiber) {
        if (contextFiberStackCursor.current !== fiber) {
          return;
        }

        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
      }

      var DefaultSuspenseContext = 0;
      var SubtreeSuspenseContextMask = 1;
      var InvisibleParentSuspenseContext = 1;
      var ForceSuspenseFallback = 2;
      var suspenseStackCursor = createCursor(DefaultSuspenseContext);

      function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
      }

      function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
      }

      function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
      }

      function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
      }

      function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
      }

      function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
      }

      function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        var nextState = workInProgress.memoizedState;

        if (nextState !== null) {
          if (nextState.dehydrated !== null) {
            return true;
          }

          return false;
        }
        {
          return true;
        }
      }

      function findFirstSuspended(row) {
        var node = row;

        while (node !== null) {
          if (node.tag === SuspenseComponent) {
            var state = node.memoizedState;

            if (state !== null) {
              var dehydrated = state.dehydrated;

              if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) {
                return node;
              }
            }
          } else if (node.tag === SuspenseListComponent && node.memoizedProps.revealOrder !== undefined) {
            var didSuspend = (node.flags & DidCapture) !== NoFlags;

            if (didSuspend) {
              return node;
            }
          } else if (node.child !== null) {
            node.child["return"] = node;
            node = node.child;
            continue;
          }

          if (node === row) {
            return null;
          }

          while (node.sibling === null) {
            if (node["return"] === null || node["return"] === row) {
              return null;
            }

            node = node["return"];
          }

          node.sibling["return"] = node["return"];
          node = node.sibling;
        }

        return null;
      }

      var NoFlags$1 = 0;
      var HasEffect = 1;
      var Insertion = 2;
      var Layout = 4;
      var Passive$1 = 8;
      var workInProgressSources = [];

      function resetWorkInProgressVersions() {
        for (var i = 0; i < workInProgressSources.length; i++) {
          var mutableSource = workInProgressSources[i];
          {
            mutableSource._workInProgressVersionPrimary = null;
          }
        }

        workInProgressSources.length = 0;
      }

      function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source);

        if (root.mutableSourceEagerHydrationData == null) {
          root.mutableSourceEagerHydrationData = [mutableSource, version];
        } else {
          root.mutableSourceEagerHydrationData.push(mutableSource, version);
        }
      }

      var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher,
          ReactCurrentBatchConfig$2 = ReactSharedInternals.ReactCurrentBatchConfig;
      var didWarnAboutMismatchedHooksForComponent;
      var didWarnUncachedGetSnapshot;
      {
        didWarnAboutMismatchedHooksForComponent = new Set();
      }
      var renderLanes = NoLanes;
      var currentlyRenderingFiber$1 = null;
      var currentHook = null;
      var workInProgressHook = null;
      var didScheduleRenderPhaseUpdate = false;
      var didScheduleRenderPhaseUpdateDuringThisPass = false;
      var localIdCounter = 0;
      var globalClientIdCounter = 0;
      var RE_RENDER_LIMIT = 25;
      var currentHookNameInDev = null;
      var hookTypesDev = null;
      var hookTypesUpdateIndexDev = -1;
      var ignorePreviousDependencies = false;

      function mountHookTypesDev() {
        {
          var hookName = currentHookNameInDev;

          if (hookTypesDev === null) {
            hookTypesDev = [hookName];
          } else {
            hookTypesDev.push(hookName);
          }
        }
      }

      function updateHookTypesDev() {
        {
          var hookName = currentHookNameInDev;

          if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;

            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) {
              warnOnHookMismatchInDev(hookName);
            }
          }
        }
      }

      function checkDepsAreArrayDev(deps) {
        {
          if (deps !== undefined && deps !== null && !isArray(deps)) {
            error('%s received a final argument that is not an array (instead, received `%s`). When ' + 'specified, the final argument must be an array.', currentHookNameInDev, typeof deps);
          }
        }
      }

      function warnOnHookMismatchInDev(currentHookName) {
        {
          var componentName = getComponentNameFromFiber(currentlyRenderingFiber$1);

          if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);

            if (hookTypesDev !== null) {
              var table = '';
              var secondColumnStart = 30;

              for (var i = 0; i <= hookTypesUpdateIndexDev; i++) {
                var oldHookName = hookTypesDev[i];
                var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                var row = i + 1 + ". " + oldHookName;

                while (row.length < secondColumnStart) {
                  row += ' ';
                }

                row += newHookName + '\n';
                table += row;
              }

              error('React has detected a change in the order of Hooks called by %s. ' + 'This will lead to bugs and errors if not fixed. ' + 'For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n' + '   Previous render            Next render\n' + '   ------------------------------------------------------\n' + '%s' + '   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n', componentName, table);
            }
          }
        }
      }

      function throwInvalidHookError() {
        throw new Error('Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for' + ' one of the following reasons:\n' + '1. You might have mismatching versions of React and the renderer (such as React DOM)\n' + '2. You might be breaking the Rules of Hooks\n' + '3. You might have more than one copy of React in the same app\n' + 'See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.');
      }

      function areHookInputsEqual(nextDeps, prevDeps) {
        {
          if (ignorePreviousDependencies) {
            return false;
          }
        }

        if (prevDeps === null) {
          {
            error('%s received a final argument during this render, but not during ' + 'the previous render. Even though the final argument is optional, ' + 'its type cannot change between renders.', currentHookNameInDev);
          }
          return false;
        }

        {
          if (nextDeps.length !== prevDeps.length) {
            error('The final argument passed to %s changed size between renders. The ' + 'order and size of this array must remain constant.\n\n' + 'Previous: %s\n' + 'Incoming: %s', currentHookNameInDev, "[" + prevDeps.join(', ') + "]", "[" + nextDeps.join(', ') + "]");
          }
        }

        for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
          if (objectIs(nextDeps[i], prevDeps[i])) {
            continue;
          }

          return false;
        }

        return true;
      }

      function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        {
          hookTypesDev = current !== null ? current._debugHookTypes : null;
          hookTypesUpdateIndexDev = -1;
          ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        }
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes;
        {
          if (current !== null && current.memoizedState !== null) {
            ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
          } else if (hookTypesDev !== null) {
            ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
          } else {
            ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
          }
        }
        var children = Component(props, secondArg);

        if (didScheduleRenderPhaseUpdateDuringThisPass) {
          var numberOfReRenders = 0;

          do {
            didScheduleRenderPhaseUpdateDuringThisPass = false;
            localIdCounter = 0;

            if (numberOfReRenders >= RE_RENDER_LIMIT) {
              throw new Error('Too many re-renders. React limits the number of renders to prevent ' + 'an infinite loop.');
            }

            numberOfReRenders += 1;
            {
              ignorePreviousDependencies = false;
            }
            currentHook = null;
            workInProgressHook = null;
            workInProgress.updateQueue = null;
            {
              hookTypesUpdateIndexDev = -1;
            }
            ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
            children = Component(props, secondArg);
          } while (didScheduleRenderPhaseUpdateDuringThisPass);
        }

        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        {
          workInProgress._debugHookTypes = hookTypesDev;
        }
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        {
          currentHookNameInDev = null;
          hookTypesDev = null;
          hookTypesUpdateIndexDev = -1;

          if (current !== null && (current.flags & StaticMask) !== (workInProgress.flags & StaticMask) && (current.mode & ConcurrentMode) !== NoMode) {
            error('Internal React error: Expected static flag was missing. Please ' + 'notify the React team.');
          }
        }
        didScheduleRenderPhaseUpdate = false;

        if (didRenderTooFewHooks) {
          throw new Error('Rendered fewer hooks than expected. This may be caused by an accidental ' + 'early return statement.');
        }

        return children;
      }

      function checkDidRenderIdHook() {
        var didRenderIdHook = localIdCounter !== 0;
        localIdCounter = 0;
        return didRenderIdHook;
      }

      function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue;

        if ((workInProgress.mode & StrictEffectsMode) !== NoMode) {
          workInProgress.flags &= ~(MountPassiveDev | MountLayoutDev | Passive | Update);
        } else {
          workInProgress.flags &= ~(Passive | Update);
        }

        current.lanes = removeLanes(current.lanes, lanes);
      }

      function resetHooksAfterThrow() {
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;

        if (didScheduleRenderPhaseUpdate) {
          var hook = currentlyRenderingFiber$1.memoizedState;

          while (hook !== null) {
            var queue = hook.queue;

            if (queue !== null) {
              queue.pending = null;
            }

            hook = hook.next;
          }

          didScheduleRenderPhaseUpdate = false;
        }

        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        {
          hookTypesDev = null;
          hookTypesUpdateIndexDev = -1;
          currentHookNameInDev = null;
          isUpdatingOpaqueValueInRenderPhase = false;
        }
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        localIdCounter = 0;
      }

      function mountWorkInProgressHook() {
        var hook = {
          memoizedState: null,
          baseState: null,
          baseQueue: null,
          queue: null,
          next: null
        };

        if (workInProgressHook === null) {
          currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        } else {
          workInProgressHook = workInProgressHook.next = hook;
        }

        return workInProgressHook;
      }

      function updateWorkInProgressHook() {
        var nextCurrentHook;

        if (currentHook === null) {
          var current = currentlyRenderingFiber$1.alternate;

          if (current !== null) {
            nextCurrentHook = current.memoizedState;
          } else {
            nextCurrentHook = null;
          }
        } else {
          nextCurrentHook = currentHook.next;
        }

        var nextWorkInProgressHook;

        if (workInProgressHook === null) {
          nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        } else {
          nextWorkInProgressHook = workInProgressHook.next;
        }

        if (nextWorkInProgressHook !== null) {
          workInProgressHook = nextWorkInProgressHook;
          nextWorkInProgressHook = workInProgressHook.next;
          currentHook = nextCurrentHook;
        } else {
          if (nextCurrentHook === null) {
            throw new Error('Rendered more hooks than during the previous render.');
          }

          currentHook = nextCurrentHook;
          var newHook = {
            memoizedState: currentHook.memoizedState,
            baseState: currentHook.baseState,
            baseQueue: currentHook.baseQueue,
            queue: currentHook.queue,
            next: null
          };

          if (workInProgressHook === null) {
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
          } else {
            workInProgressHook = workInProgressHook.next = newHook;
          }
        }

        return workInProgressHook;
      }

      function createFunctionComponentUpdateQueue() {
        return {
          lastEffect: null,
          stores: null
        };
      }

      function basicStateReducer(state, action) {
        return typeof action === 'function' ? action(state) : action;
      }

      function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;

        if (init !== undefined) {
          initialState = init(initialArg);
        } else {
          initialState = initialArg;
        }

        hook.memoizedState = hook.baseState = initialState;
        var queue = {
          pending: null,
          interleaved: null,
          lanes: NoLanes,
          dispatch: null,
          lastRenderedReducer: reducer,
          lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, queue);
        return [hook.memoizedState, dispatch];
      }

      function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;

        if (queue === null) {
          throw new Error('Should have a queue. This is likely a bug in React. Please file an issue.');
        }

        queue.lastRenderedReducer = reducer;
        var current = currentHook;
        var baseQueue = current.baseQueue;
        var pendingQueue = queue.pending;

        if (pendingQueue !== null) {
          if (baseQueue !== null) {
            var baseFirst = baseQueue.next;
            var pendingFirst = pendingQueue.next;
            baseQueue.next = pendingFirst;
            pendingQueue.next = baseFirst;
          }

          {
            if (current.baseQueue !== baseQueue) {
              error('Internal error: Expected work-in-progress queue to be a clone. ' + 'This is a bug in React.');
            }
          }
          current.baseQueue = baseQueue = pendingQueue;
          queue.pending = null;
        }

        if (baseQueue !== null) {
          var first = baseQueue.next;
          var newState = current.baseState;
          var newBaseState = null;
          var newBaseQueueFirst = null;
          var newBaseQueueLast = null;
          var update = first;

          do {
            var updateLane = update.lane;

            if (!isSubsetOfLanes(renderLanes, updateLane)) {
              var clone = {
                lane: updateLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
              };

              if (newBaseQueueLast === null) {
                newBaseQueueFirst = newBaseQueueLast = clone;
                newBaseState = newState;
              } else {
                newBaseQueueLast = newBaseQueueLast.next = clone;
              }

              currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
              markSkippedUpdateLanes(updateLane);
            } else {
              if (newBaseQueueLast !== null) {
                var _clone = {
                  lane: NoLane,
                  action: update.action,
                  hasEagerState: update.hasEagerState,
                  eagerState: update.eagerState,
                  next: null
                };
                newBaseQueueLast = newBaseQueueLast.next = _clone;
              }

              if (update.hasEagerState) {
                newState = update.eagerState;
              } else {
                var action = update.action;
                newState = reducer(newState, action);
              }
            }

            update = update.next;
          } while (update !== null && update !== first);

          if (newBaseQueueLast === null) {
            newBaseState = newState;
          } else {
            newBaseQueueLast.next = newBaseQueueFirst;
          }

          if (!objectIs(newState, hook.memoizedState)) {
            markWorkInProgressReceivedUpdate();
          }

          hook.memoizedState = newState;
          hook.baseState = newBaseState;
          hook.baseQueue = newBaseQueueLast;
          queue.lastRenderedState = newState;
        }

        var lastInterleaved = queue.interleaved;

        if (lastInterleaved !== null) {
          var interleaved = lastInterleaved;

          do {
            var interleavedLane = interleaved.lane;
            currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, interleavedLane);
            markSkippedUpdateLanes(interleavedLane);
            interleaved = interleaved.next;
          } while (interleaved !== lastInterleaved);
        } else if (baseQueue === null) {
          queue.lanes = NoLanes;
        }

        var dispatch = queue.dispatch;
        return [hook.memoizedState, dispatch];
      }

      function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;

        if (queue === null) {
          throw new Error('Should have a queue. This is likely a bug in React. Please file an issue.');
        }

        queue.lastRenderedReducer = reducer;
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;

        if (lastRenderPhaseUpdate !== null) {
          queue.pending = null;
          var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
          var update = firstRenderPhaseUpdate;

          do {
            var action = update.action;
            newState = reducer(newState, action);
            update = update.next;
          } while (update !== firstRenderPhaseUpdate);

          if (!objectIs(newState, hook.memoizedState)) {
            markWorkInProgressReceivedUpdate();
          }

          hook.memoizedState = newState;

          if (hook.baseQueue === null) {
            hook.baseState = newState;
          }

          queue.lastRenderedState = newState;
        }

        return [newState, dispatch];
      }

      function mountMutableSource(source, getSnapshot, subscribe) {
        {
          return undefined;
        }
      }

      function updateMutableSource(source, getSnapshot, subscribe) {
        {
          return undefined;
        }
      }

      function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = mountWorkInProgressHook();
        var nextSnapshot;
        var isHydrating = getIsHydrating();

        if (isHydrating) {
          if (getServerSnapshot === undefined) {
            throw new Error('Missing getServerSnapshot, which is required for ' + 'server-rendered content. Will revert to client rendering.');
          }

          nextSnapshot = getServerSnapshot();
          {
            if (!didWarnUncachedGetSnapshot) {
              if (nextSnapshot !== getServerSnapshot()) {
                error('The result of getServerSnapshot should be cached to avoid an infinite loop');
                didWarnUncachedGetSnapshot = true;
              }
            }
          }
        } else {
          nextSnapshot = getSnapshot();
          {
            if (!didWarnUncachedGetSnapshot) {
              var cachedSnapshot = getSnapshot();

              if (!objectIs(nextSnapshot, cachedSnapshot)) {
                error('The result of getSnapshot should be cached to avoid an infinite loop');
                didWarnUncachedGetSnapshot = true;
              }
            }
          }
          var root = getWorkInProgressRoot();

          if (root === null) {
            throw new Error('Expected a work-in-progress root. This is a bug in React. Please file an issue.');
          }

          if (!includesBlockingLane(root, renderLanes)) {
            pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
          }
        }

        hook.memoizedState = nextSnapshot;
        var inst = {
          value: nextSnapshot,
          getSnapshot: getSnapshot
        };
        hook.queue = inst;
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [subscribe]);
        fiber.flags |= Passive;
        pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
        return nextSnapshot;
      }

      function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = updateWorkInProgressHook();
        var nextSnapshot = getSnapshot();
        {
          if (!didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();

            if (!objectIs(nextSnapshot, cachedSnapshot)) {
              error('The result of getSnapshot should be cached to avoid an infinite loop');
              didWarnUncachedGetSnapshot = true;
            }
          }
        }
        var prevSnapshot = hook.memoizedState;
        var snapshotChanged = !objectIs(prevSnapshot, nextSnapshot);

        if (snapshotChanged) {
          hook.memoizedState = nextSnapshot;
          markWorkInProgressReceivedUpdate();
        }

        var inst = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [subscribe]);

        if (inst.getSnapshot !== getSnapshot || snapshotChanged || workInProgressHook !== null && workInProgressHook.memoizedState.tag & HasEffect) {
          fiber.flags |= Passive;
          pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
          var root = getWorkInProgressRoot();

          if (root === null) {
            throw new Error('Expected a work-in-progress root. This is a bug in React. Please file an issue.');
          }

          if (!includesBlockingLane(root, renderLanes)) {
            pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
          }
        }

        return nextSnapshot;
      }

      function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= StoreConsistency;
        var check = {
          getSnapshot: getSnapshot,
          value: renderedSnapshot
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;

        if (componentUpdateQueue === null) {
          componentUpdateQueue = createFunctionComponentUpdateQueue();
          currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
          componentUpdateQueue.stores = [check];
        } else {
          var stores = componentUpdateQueue.stores;

          if (stores === null) {
            componentUpdateQueue.stores = [check];
          } else {
            stores.push(check);
          }
        }
      }

      function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot;

        if (checkIfSnapshotChanged(inst)) {
          forceStoreRerender(fiber);
        }
      }

      function subscribeToStore(fiber, inst, subscribe) {
        var handleStoreChange = function handleStoreChange() {
          if (checkIfSnapshotChanged(inst)) {
            forceStoreRerender(fiber);
          }
        };

        return subscribe(handleStoreChange);
      }

      function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;

        try {
          var nextValue = latestGetSnapshot();
          return !objectIs(prevValue, nextValue);
        } catch (error) {
          return true;
        }
      }

      function forceStoreRerender(fiber) {
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
      }

      function mountState(initialState) {
        var hook = mountWorkInProgressHook();

        if (typeof initialState === 'function') {
          initialState = initialState();
        }

        hook.memoizedState = hook.baseState = initialState;
        var queue = {
          pending: null,
          interleaved: null,
          lanes: NoLanes,
          dispatch: null,
          lastRenderedReducer: basicStateReducer,
          lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        return [hook.memoizedState, dispatch];
      }

      function updateState(initialState) {
        return updateReducer(basicStateReducer);
      }

      function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
      }

      function pushEffect(tag, create, destroy, deps) {
        var effect = {
          tag: tag,
          create: create,
          destroy: destroy,
          deps: deps,
          next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;

        if (componentUpdateQueue === null) {
          componentUpdateQueue = createFunctionComponentUpdateQueue();
          currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
          componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
          var lastEffect = componentUpdateQueue.lastEffect;

          if (lastEffect === null) {
            componentUpdateQueue.lastEffect = effect.next = effect;
          } else {
            var firstEffect = lastEffect.next;
            lastEffect.next = effect;
            effect.next = firstEffect;
            componentUpdateQueue.lastEffect = effect;
          }
        }

        return effect;
      }

      function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        {
          var _ref2 = {
            current: initialValue
          };
          hook.memoizedState = _ref2;
          return _ref2;
        }
      }

      function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
      }

      function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
      }

      function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;

        if (currentHook !== null) {
          var prevEffect = currentHook.memoizedState;
          destroy = prevEffect.destroy;

          if (nextDeps !== null) {
            var prevDeps = prevEffect.deps;

            if (areHookInputsEqual(nextDeps, prevDeps)) {
              hook.memoizedState = pushEffect(hookFlags, create, destroy, nextDeps);
              return;
            }
          }
        }

        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
      }

      function mountEffect(create, deps) {
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) {
          return mountEffectImpl(MountPassiveDev | Passive | PassiveStatic, Passive$1, create, deps);
        } else {
          return mountEffectImpl(Passive | PassiveStatic, Passive$1, create, deps);
        }
      }

      function updateEffect(create, deps) {
        return updateEffectImpl(Passive, Passive$1, create, deps);
      }

      function mountInsertionEffect(create, deps) {
        return mountEffectImpl(Update, Insertion, create, deps);
      }

      function updateInsertionEffect(create, deps) {
        return updateEffectImpl(Update, Insertion, create, deps);
      }

      function mountLayoutEffect(create, deps) {
        var fiberFlags = Update;
        {
          fiberFlags |= LayoutStatic;
        }

        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) {
          fiberFlags |= MountLayoutDev;
        }

        return mountEffectImpl(fiberFlags, Layout, create, deps);
      }

      function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
      }

      function imperativeHandleEffect(create, ref) {
        if (typeof ref === 'function') {
          var refCallback = ref;

          var _inst = create();

          refCallback(_inst);
          return function () {
            refCallback(null);
          };
        } else if (ref !== null && ref !== undefined) {
          var refObject = ref;
          {
            if (!refObject.hasOwnProperty('current')) {
              error('Expected useImperativeHandle() first argument to either be a ' + 'ref callback or React.createRef() object. Instead received: %s.', 'an object with keys {' + Object.keys(refObject).join(', ') + '}');
            }
          }

          var _inst2 = create();

          refObject.current = _inst2;
          return function () {
            refObject.current = null;
          };
        }
      }

      function mountImperativeHandle(ref, create, deps) {
        {
          if (typeof create !== 'function') {
            error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
          }
        }
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
        var fiberFlags = Update;
        {
          fiberFlags |= LayoutStatic;
        }

        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) {
          fiberFlags |= MountLayoutDev;
        }

        return mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
      }

      function updateImperativeHandle(ref, create, deps) {
        {
          if (typeof create !== 'function') {
            error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
          }
        }
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
      }

      function mountDebugValue(value, formatterFn) {}

      var updateDebugValue = mountDebugValue;

      function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [callback, nextDeps];
        return callback;
      }

      function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;

        if (prevState !== null) {
          if (nextDeps !== null) {
            var prevDeps = prevState[1];

            if (areHookInputsEqual(nextDeps, prevDeps)) {
              return prevState[0];
            }
          }
        }

        hook.memoizedState = [callback, nextDeps];
        return callback;
      }

      function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [nextValue, nextDeps];
        return nextValue;
      }

      function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;

        if (prevState !== null) {
          if (nextDeps !== null) {
            var prevDeps = prevState[1];

            if (areHookInputsEqual(nextDeps, prevDeps)) {
              return prevState[0];
            }
          }
        }

        var nextValue = nextCreate();
        hook.memoizedState = [nextValue, nextDeps];
        return nextValue;
      }

      function mountDeferredValue(value) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = value;
        return value;
      }

      function updateDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        var resolvedCurrentHook = currentHook;
        var prevValue = resolvedCurrentHook.memoizedState;
        return updateDeferredValueImpl(hook, prevValue, value);
      }

      function rerenderDeferredValue(value) {
        var hook = updateWorkInProgressHook();

        if (currentHook === null) {
          hook.memoizedState = value;
          return value;
        } else {
          var prevValue = currentHook.memoizedState;
          return updateDeferredValueImpl(hook, prevValue, value);
        }
      }

      function updateDeferredValueImpl(hook, prevValue, value) {
        var shouldDeferValue = !includesOnlyNonUrgentLanes(renderLanes);

        if (shouldDeferValue) {
          if (!objectIs(value, prevValue)) {
            var deferredLane = claimNextTransitionLane();
            currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, deferredLane);
            markSkippedUpdateLanes(deferredLane);
            hook.baseState = true;
          }

          return prevValue;
        } else {
          if (hook.baseState) {
            hook.baseState = false;
            markWorkInProgressReceivedUpdate();
          }

          hook.memoizedState = value;
          return value;
        }
      }

      function startTransition(setPending, callback, options) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(higherEventPriority(previousPriority, ContinuousEventPriority));
        setPending(true);
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition = {};
        var currentTransition = ReactCurrentBatchConfig$2.transition;
        {
          ReactCurrentBatchConfig$2.transition._updatedFibers = new Set();
        }

        try {
          setPending(false);
          callback();
        } finally {
          setCurrentUpdatePriority(previousPriority);
          ReactCurrentBatchConfig$2.transition = prevTransition;
          {
            if (prevTransition === null && currentTransition._updatedFibers) {
              var updatedFibersCount = currentTransition._updatedFibers.size;

              if (updatedFibersCount > 10) {
                warn('Detected a large number of updates inside startTransition. ' + 'If this is due to a subscription please re-write it to use React provided hooks. ' + 'Otherwise concurrent mode guarantees are off the table.');
              }

              currentTransition._updatedFibers.clear();
            }
          }
        }
      }

      function mountTransition() {
        var _mountState = mountState(false),
            isPending = _mountState[0],
            setPending = _mountState[1];

        var start = startTransition.bind(null, setPending);
        var hook = mountWorkInProgressHook();
        hook.memoizedState = start;
        return [isPending, start];
      }

      function updateTransition() {
        var _updateState = updateState(),
            isPending = _updateState[0];

        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [isPending, start];
      }

      function rerenderTransition() {
        var _rerenderState = rerenderState(),
            isPending = _rerenderState[0];

        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [isPending, start];
      }

      var isUpdatingOpaqueValueInRenderPhase = false;

      function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        {
          return isUpdatingOpaqueValueInRenderPhase;
        }
      }

      function mountId() {
        var hook = mountWorkInProgressHook();
        var root = getWorkInProgressRoot();
        var identifierPrefix = root.identifierPrefix;
        var id;

        if (getIsHydrating()) {
          var treeId = getTreeId();
          id = ':' + identifierPrefix + 'R' + treeId;
          var localId = localIdCounter++;

          if (localId > 0) {
            id += 'H' + localId.toString(32);
          }

          id += ':';
        } else {
          var globalClientId = globalClientIdCounter++;
          id = ':' + identifierPrefix + 'r' + globalClientId.toString(32) + ':';
        }

        hook.memoizedState = id;
        return id;
      }

      function updateId() {
        var hook = updateWorkInProgressHook();
        var id = hook.memoizedState;
        return id;
      }

      function dispatchReducerAction(fiber, queue, action) {
        {
          if (typeof arguments[3] === 'function') {
            error("State updates from the useState() and useReducer() Hooks don't support the " + 'second callback argument. To execute a side effect after ' + 'rendering, declare it in the component body with useEffect().');
          }
        }
        var lane = requestUpdateLane(fiber);
        var update = {
          lane: lane,
          action: action,
          hasEagerState: false,
          eagerState: null,
          next: null
        };

        if (isRenderPhaseUpdate(fiber)) {
          enqueueRenderPhaseUpdate(queue, update);
        } else {
          enqueueUpdate$1(fiber, queue, update);
          var eventTime = requestEventTime();
          var root = scheduleUpdateOnFiber(fiber, lane, eventTime);

          if (root !== null) {
            entangleTransitionUpdate(root, queue, lane);
          }
        }

        markUpdateInDevTools(fiber, lane);
      }

      function dispatchSetState(fiber, queue, action) {
        {
          if (typeof arguments[3] === 'function') {
            error("State updates from the useState() and useReducer() Hooks don't support the " + 'second callback argument. To execute a side effect after ' + 'rendering, declare it in the component body with useEffect().');
          }
        }
        var lane = requestUpdateLane(fiber);
        var update = {
          lane: lane,
          action: action,
          hasEagerState: false,
          eagerState: null,
          next: null
        };

        if (isRenderPhaseUpdate(fiber)) {
          enqueueRenderPhaseUpdate(queue, update);
        } else {
          enqueueUpdate$1(fiber, queue, update);
          var alternate = fiber.alternate;

          if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
            var lastRenderedReducer = queue.lastRenderedReducer;

            if (lastRenderedReducer !== null) {
              var prevDispatcher;
              {
                prevDispatcher = ReactCurrentDispatcher$1.current;
                ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              }

              try {
                var currentState = queue.lastRenderedState;
                var eagerState = lastRenderedReducer(currentState, action);
                update.hasEagerState = true;
                update.eagerState = eagerState;

                if (objectIs(eagerState, currentState)) {
                  return;
                }
              } catch (error) {} finally {
                {
                  ReactCurrentDispatcher$1.current = prevDispatcher;
                }
              }
            }
          }

          var eventTime = requestEventTime();
          var root = scheduleUpdateOnFiber(fiber, lane, eventTime);

          if (root !== null) {
            entangleTransitionUpdate(root, queue, lane);
          }
        }

        markUpdateInDevTools(fiber, lane);
      }

      function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1;
      }

      function enqueueRenderPhaseUpdate(queue, update) {
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        var pending = queue.pending;

        if (pending === null) {
          update.next = update;
        } else {
          update.next = pending.next;
          pending.next = update;
        }

        queue.pending = update;
      }

      function enqueueUpdate$1(fiber, queue, update, lane) {
        if (isInterleavedUpdate(fiber)) {
          var interleaved = queue.interleaved;

          if (interleaved === null) {
            update.next = update;
            pushInterleavedQueue(queue);
          } else {
            update.next = interleaved.next;
            interleaved.next = update;
          }

          queue.interleaved = update;
        } else {
          var pending = queue.pending;

          if (pending === null) {
            update.next = update;
          } else {
            update.next = pending.next;
            pending.next = update;
          }

          queue.pending = update;
        }
      }

      function entangleTransitionUpdate(root, queue, lane) {
        if (isTransitionLane(lane)) {
          var queueLanes = queue.lanes;
          queueLanes = intersectLanes(queueLanes, root.pendingLanes);
          var newQueueLanes = mergeLanes(queueLanes, lane);
          queue.lanes = newQueueLanes;
          markRootEntangled(root, newQueueLanes);
        }
      }

      function markUpdateInDevTools(fiber, lane, action) {
        {
          markStateUpdateScheduled(fiber, lane);
        }
      }

      var ContextOnlyDispatcher = {
        readContext: _readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
      };
      var HooksDispatcherOnMountInDEV = null;
      var HooksDispatcherOnMountWithHookTypesInDEV = null;
      var HooksDispatcherOnUpdateInDEV = null;
      var HooksDispatcherOnRerenderInDEV = null;
      var InvalidNestedHooksDispatcherOnMountInDEV = null;
      var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
      var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
      {
        var warnInvalidContextAccess = function warnInvalidContextAccess() {
          error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
        };

        var warnInvalidHookAccess = function warnInvalidHookAccess() {
          error('Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. ' + 'You can only call Hooks at the top level of your React function. ' + 'For more information, see ' + 'https://reactjs.org/link/rules-of-hooks');
        };

        HooksDispatcherOnMountInDEV = {
          readContext: function readContext(context) {
            return _readContext(context);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
          },
          useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            mountHookTypesDev();
            return _readContext(context);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
          },
          useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountInsertionEffect(create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

            try {
              return mountMemo(create, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

            try {
              return mountReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            mountHookTypesDev();
            return mountRef(initialValue);
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

            try {
              return mountState(initialState);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            mountHookTypesDev();
            return mountDebugValue();
          },
          useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            mountHookTypesDev();
            return mountDeferredValue(value);
          },
          useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            mountHookTypesDev();
            return mountTransition();
          },
          useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            mountHookTypesDev();
            return mountMutableSource();
          },
          useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
          },
          useId: function useId() {
            currentHookNameInDev = 'useId';
            mountHookTypesDev();
            return mountId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
        HooksDispatcherOnMountWithHookTypesInDEV = {
          readContext: function readContext(context) {
            return _readContext(context);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return mountCallback(callback, deps);
          },
          useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return _readContext(context);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return mountEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
          },
          useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            updateHookTypesDev();
            return mountInsertionEffect(create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

            try {
              return mountMemo(create, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

            try {
              return mountReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return mountRef(initialValue);
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

            try {
              return mountState(initialState);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return mountDebugValue();
          },
          useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return mountDeferredValue(value);
          },
          useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return mountTransition();
          },
          useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return mountMutableSource();
          },
          useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
          },
          useId: function useId() {
            currentHookNameInDev = 'useId';
            updateHookTypesDev();
            return mountId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
        HooksDispatcherOnUpdateInDEV = {
          readContext: function readContext(context) {
            return _readContext(context);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return _readContext(context);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

            try {
              return updateReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

            try {
              return updateState(initialState);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
          },
          useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return updateDeferredValue(value);
          },
          useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return updateTransition();
          },
          useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return updateMutableSource();
          },
          useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
          },
          useId: function useId() {
            currentHookNameInDev = 'useId';
            updateHookTypesDev();
            return updateId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
        HooksDispatcherOnRerenderInDEV = {
          readContext: function readContext(context) {
            return _readContext(context);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return _readContext(context);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;

            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;

            try {
              return rerenderReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;

            try {
              return rerenderState(initialState);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
          },
          useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return rerenderDeferredValue(value);
          },
          useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return rerenderTransition();
          },
          useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return updateMutableSource();
          },
          useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
          },
          useId: function useId() {
            currentHookNameInDev = 'useId';
            updateHookTypesDev();
            return updateId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
        InvalidNestedHooksDispatcherOnMountInDEV = {
          readContext: function readContext(context) {
            warnInvalidContextAccess();
            return _readContext(context);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
          },
          useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return _readContext(context);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
          },
          useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountInsertionEffect(create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

            try {
              return mountMemo(create, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

            try {
              return mountReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

            try {
              return mountState(initialState);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
          },
          useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
          },
          useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
          },
          useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource();
          },
          useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
          },
          useId: function useId() {
            currentHookNameInDev = 'useId';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
        InvalidNestedHooksDispatcherOnUpdateInDEV = {
          readContext: function readContext(context) {
            warnInvalidContextAccess();
            return _readContext(context);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return _readContext(context);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

            try {
              return updateReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

            try {
              return updateState(initialState);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
          },
          useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
          },
          useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
          },
          useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
          },
          useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
          },
          useId: function useId() {
            currentHookNameInDev = 'useId';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
        InvalidNestedHooksDispatcherOnRerenderInDEV = {
          readContext: function readContext(context) {
            warnInvalidContextAccess();
            return _readContext(context);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return _readContext(context);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

            try {
              return rerenderReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

            try {
              return rerenderState(initialState);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
          },
          useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
          },
          useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
          },
          useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
          },
          useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
          },
          useId: function useId() {
            currentHookNameInDev = 'useId';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
      }
      var now$1 = Scheduler.unstable_now;
      var commitTime = 0;
      var layoutEffectStartTime = -1;
      var profilerStartTime = -1;
      var passiveEffectStartTime = -1;
      var currentUpdateIsNested = false;
      var nestedUpdateScheduled = false;

      function isCurrentUpdateNested() {
        return currentUpdateIsNested;
      }

      function markNestedUpdateScheduled() {
        {
          nestedUpdateScheduled = true;
        }
      }

      function resetNestedUpdateFlag() {
        {
          currentUpdateIsNested = false;
          nestedUpdateScheduled = false;
        }
      }

      function syncNestedUpdateFlag() {
        {
          currentUpdateIsNested = nestedUpdateScheduled;
          nestedUpdateScheduled = false;
        }
      }

      function getCommitTime() {
        return commitTime;
      }

      function recordCommitTime() {
        commitTime = now$1();
      }

      function startProfilerTimer(fiber) {
        profilerStartTime = now$1();

        if (fiber.actualStartTime < 0) {
          fiber.actualStartTime = now$1();
        }
      }

      function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
      }

      function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
          var elapsedTime = now$1() - profilerStartTime;
          fiber.actualDuration += elapsedTime;

          if (overrideBaseTime) {
            fiber.selfBaseDuration = elapsedTime;
          }

          profilerStartTime = -1;
        }
      }

      function recordLayoutEffectDuration(fiber) {
        if (layoutEffectStartTime >= 0) {
          var elapsedTime = now$1() - layoutEffectStartTime;
          layoutEffectStartTime = -1;
          var parentFiber = fiber["return"];

          while (parentFiber !== null) {
            switch (parentFiber.tag) {
              case HostRoot:
                var root = parentFiber.stateNode;
                root.effectDuration += elapsedTime;
                return;

              case Profiler:
                var parentStateNode = parentFiber.stateNode;
                parentStateNode.effectDuration += elapsedTime;
                return;
            }

            parentFiber = parentFiber["return"];
          }
        }
      }

      function recordPassiveEffectDuration(fiber) {
        if (passiveEffectStartTime >= 0) {
          var elapsedTime = now$1() - passiveEffectStartTime;
          passiveEffectStartTime = -1;
          var parentFiber = fiber["return"];

          while (parentFiber !== null) {
            switch (parentFiber.tag) {
              case HostRoot:
                var root = parentFiber.stateNode;

                if (root !== null) {
                  root.passiveEffectDuration += elapsedTime;
                }

                return;

              case Profiler:
                var parentStateNode = parentFiber.stateNode;

                if (parentStateNode !== null) {
                  parentStateNode.passiveEffectDuration += elapsedTime;
                }

                return;
            }

            parentFiber = parentFiber["return"];
          }
        }
      }

      function startLayoutEffectTimer() {
        layoutEffectStartTime = now$1();
      }

      function startPassiveEffectTimer() {
        passiveEffectStartTime = now$1();
      }

      function transferActualDuration(fiber) {
        var child = fiber.child;

        while (child) {
          fiber.actualDuration += child.actualDuration;
          child = child.sibling;
        }
      }

      function createCapturedValue(value, source) {
        return {
          value: value,
          source: source,
          stack: getStackByFiberInDevAndProd(source)
        };
      }

      function showErrorDialog(boundary, errorInfo) {
        return true;
      }

      function logCapturedError(boundary, errorInfo) {
        try {
          var logError = showErrorDialog(boundary, errorInfo);

          if (logError === false) {
            return;
          }

          var error = errorInfo.value;

          if (true) {
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : '';

            if (error != null && error._suppressLogging) {
              if (boundary.tag === ClassComponent) {
                return;
              }

              console['error'](error);
            }

            var componentName = source ? getComponentNameFromFiber(source) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : 'The above error occurred in one of your React components:';
            var errorBoundaryMessage;

            if (boundary.tag === HostRoot) {
              errorBoundaryMessage = 'Consider adding an error boundary to your tree to customize error handling behavior.\n' + 'Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.';
            } else {
              var errorBoundaryName = getComponentNameFromFiber(boundary) || 'Anonymous';
              errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            }

            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage);
            console['error'](combinedMessage);
          } else {
            console['error'](error);
          }
        } catch (e) {
          setTimeout(function () {
            throw e;
          });
        }
      }

      var PossiblyWeakMap$1 = typeof WeakMap === 'function' ? WeakMap : Map;

      function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        update.payload = {
          element: null
        };
        var error = errorInfo.value;

        update.callback = function () {
          onUncaughtError(error);
          logCapturedError(fiber, errorInfo);
        };

        return update;
      }

      function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;

        if (typeof getDerivedStateFromError === 'function') {
          var error$1 = errorInfo.value;

          update.payload = function () {
            return getDerivedStateFromError(error$1);
          };

          update.callback = function () {
            {
              markFailedErrorBoundaryForHotReloading(fiber);
            }
            logCapturedError(fiber, errorInfo);
          };
        }

        var inst = fiber.stateNode;

        if (inst !== null && typeof inst.componentDidCatch === 'function') {
          update.callback = function callback() {
            {
              markFailedErrorBoundaryForHotReloading(fiber);
            }
            logCapturedError(fiber, errorInfo);

            if (typeof getDerivedStateFromError !== 'function') {
              markLegacyErrorBoundaryAsFailed(this);
            }

            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
              componentStack: stack !== null ? stack : ''
            });
            {
              if (typeof getDerivedStateFromError !== 'function') {
                if (!includesSomeLane(fiber.lanes, SyncLane)) {
                  error('%s: Error boundaries should implement getDerivedStateFromError(). ' + 'In that method, return a state update to display an error message or fallback UI.', getComponentNameFromFiber(fiber) || 'Unknown');
                }
              }
            }
          };
        }

        return update;
      }

      function attachPingListener(root, wakeable, lanes) {
        var pingCache = root.pingCache;
        var threadIDs;

        if (pingCache === null) {
          pingCache = root.pingCache = new PossiblyWeakMap$1();
          threadIDs = new Set();
          pingCache.set(wakeable, threadIDs);
        } else {
          threadIDs = pingCache.get(wakeable);

          if (threadIDs === undefined) {
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
          }
        }

        if (!threadIDs.has(lanes)) {
          threadIDs.add(lanes);
          var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
          {
            if (isDevToolsPresent) {
              restorePendingUpdaters(root, lanes);
            }
          }
          wakeable.then(ping, ping);
        }
      }

      function attachRetryListener(suspenseBoundary, root, wakeable, lanes) {
        var wakeables = suspenseBoundary.updateQueue;

        if (wakeables === null) {
          var updateQueue = new Set();
          updateQueue.add(wakeable);
          suspenseBoundary.updateQueue = updateQueue;
        } else {
          wakeables.add(wakeable);
        }
      }

      function resetSuspendedComponent(sourceFiber, rootRenderLanes) {
        var tag = sourceFiber.tag;

        if ((sourceFiber.mode & ConcurrentMode) === NoMode && (tag === FunctionComponent || tag === ForwardRef || tag === SimpleMemoComponent)) {
          var currentSource = sourceFiber.alternate;

          if (currentSource) {
            sourceFiber.updateQueue = currentSource.updateQueue;
            sourceFiber.memoizedState = currentSource.memoizedState;
            sourceFiber.lanes = currentSource.lanes;
          } else {
            sourceFiber.updateQueue = null;
            sourceFiber.memoizedState = null;
          }
        }
      }

      function getNearestSuspenseBoundaryToCapture(returnFiber) {
        var node = returnFiber;

        do {
          if (node.tag === SuspenseComponent && shouldCaptureSuspense(node)) {
            return node;
          }

          node = node["return"];
        } while (node !== null);

        return null;
      }

      function markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes) {
        if ((suspenseBoundary.mode & ConcurrentMode) === NoMode) {
          if (suspenseBoundary === returnFiber) {
            suspenseBoundary.flags |= ShouldCapture;
          } else {
            suspenseBoundary.flags |= DidCapture;
            sourceFiber.flags |= ForceUpdateForLegacySuspense;
            sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);

            if (sourceFiber.tag === ClassComponent) {
              var currentSourceFiber = sourceFiber.alternate;

              if (currentSourceFiber === null) {
                sourceFiber.tag = IncompleteClassComponent;
              } else {
                var update = createUpdate(NoTimestamp, SyncLane);
                update.tag = ForceUpdate;
                enqueueUpdate(sourceFiber, update);
              }
            }

            sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
          }

          return suspenseBoundary;
        }

        suspenseBoundary.flags |= ShouldCapture;
        suspenseBoundary.lanes = rootRenderLanes;
        return suspenseBoundary;
      }

      function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        sourceFiber.flags |= Incomplete;
        {
          if (isDevToolsPresent) {
            restorePendingUpdaters(root, rootRenderLanes);
          }
        }

        if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
          var wakeable = value;
          resetSuspendedComponent(sourceFiber);
          {
            if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
              markDidThrowWhileHydratingDEV();
            }
          }
          var suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);

          if (suspenseBoundary !== null) {
            suspenseBoundary.flags &= ~ForceClientRender;
            markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes);

            if (suspenseBoundary.mode & ConcurrentMode) {
              attachPingListener(root, wakeable, rootRenderLanes);
            }

            attachRetryListener(suspenseBoundary, root, wakeable);
            return;
          } else {
            if (!includesSyncLane(rootRenderLanes)) {
              attachPingListener(root, wakeable, rootRenderLanes);
              renderDidSuspendDelayIfPossible();
              return;
            }

            var uncaughtSuspenseError = new Error('A component suspended while responding to synchronous input. This ' + 'will cause the UI to be replaced with a loading indicator. To ' + 'fix, updates that suspend should be wrapped ' + 'with startTransition.');
            value = uncaughtSuspenseError;
          }
        } else {
          if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
            markDidThrowWhileHydratingDEV();

            var _suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);

            if (_suspenseBoundary !== null) {
              if ((_suspenseBoundary.flags & ShouldCapture) === NoFlags) {
                _suspenseBoundary.flags |= ForceClientRender;
              }

              markSuspenseBoundaryShouldCapture(_suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes);
              queueHydrationError(value);
              return;
            }
          }
        }

        renderDidError(value);
        value = createCapturedValue(value, sourceFiber);
        var workInProgress = returnFiber;

        do {
          switch (workInProgress.tag) {
            case HostRoot:
              {
                var _errorInfo = value;
                workInProgress.flags |= ShouldCapture;
                var lane = pickArbitraryLane(rootRenderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                var update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                enqueueCapturedUpdate(workInProgress, update);
                return;
              }

            case ClassComponent:
              var errorInfo = value;
              var ctor = workInProgress.type;
              var instance = workInProgress.stateNode;

              if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                workInProgress.flags |= ShouldCapture;

                var _lane = pickArbitraryLane(rootRenderLanes);

                workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane);

                var _update = createClassErrorUpdate(workInProgress, errorInfo, _lane);

                enqueueCapturedUpdate(workInProgress, _update);
                return;
              }

              break;
          }

          workInProgress = workInProgress["return"];
        } while (workInProgress !== null);
      }

      function getSuspendedCache() {
        {
          return null;
        }
      }

      function markUpdate(workInProgress) {
        workInProgress.flags |= Update;
      }

      function markRef(workInProgress) {
        workInProgress.flags |= Ref;
        {
          workInProgress.flags |= RefStatic;
        }
      }

      var appendAllChildren;
      var updateHostContainer;
      var updateHostComponent;
      var updateHostText;
      {
        appendAllChildren = function appendAllChildren(parent, workInProgress, needsVisibilityToggle, isHidden) {
          var node = workInProgress.child;

          while (node !== null) {
            if (node.tag === HostComponent || node.tag === HostText) {
              appendInitialChild(parent, node.stateNode);
            } else if (node.tag === HostPortal) ;else if (node.child !== null) {
              node.child["return"] = node;
              node = node.child;
              continue;
            }

            if (node === workInProgress) {
              return;
            }

            while (node.sibling === null) {
              if (node["return"] === null || node["return"] === workInProgress) {
                return;
              }

              node = node["return"];
            }

            node.sibling["return"] = node["return"];
            node = node.sibling;
          }
        };

        updateHostContainer = function updateHostContainer(current, workInProgress) {};

        updateHostComponent = function updateHostComponent(current, workInProgress, type, newProps, rootContainerInstance) {
          var oldProps = current.memoizedProps;

          if (oldProps === newProps) {
            return;
          }

          var instance = workInProgress.stateNode;
          var currentHostContext = getHostContext();
          var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext);
          workInProgress.updateQueue = updatePayload;

          if (updatePayload) {
            markUpdate(workInProgress);
          }
        };

        updateHostText = function updateHostText(current, workInProgress, oldText, newText) {
          if (oldText !== newText) {
            markUpdate(workInProgress);
          }
        };
      }

      function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) {
          return;
        }

        switch (renderState.tailMode) {
          case 'hidden':
            {
              var tailNode = renderState.tail;
              var lastTailNode = null;

              while (tailNode !== null) {
                if (tailNode.alternate !== null) {
                  lastTailNode = tailNode;
                }

                tailNode = tailNode.sibling;
              }

              if (lastTailNode === null) {
                renderState.tail = null;
              } else {
                lastTailNode.sibling = null;
              }

              break;
            }

          case 'collapsed':
            {
              var _tailNode = renderState.tail;
              var _lastTailNode = null;

              while (_tailNode !== null) {
                if (_tailNode.alternate !== null) {
                  _lastTailNode = _tailNode;
                }

                _tailNode = _tailNode.sibling;
              }

              if (_lastTailNode === null) {
                if (!hasRenderedATailFallback && renderState.tail !== null) {
                  renderState.tail.sibling = null;
                } else {
                  renderState.tail = null;
                }
              } else {
                _lastTailNode.sibling = null;
              }

              break;
            }
        }
      }

      function bubbleProperties(completedWork) {
        var didBailout = completedWork.alternate !== null && completedWork.alternate.child === completedWork.child;
        var newChildLanes = NoLanes;
        var subtreeFlags = NoFlags;

        if (!didBailout) {
          if ((completedWork.mode & ProfileMode) !== NoMode) {
            var actualDuration = completedWork.actualDuration;
            var treeBaseDuration = completedWork.selfBaseDuration;
            var child = completedWork.child;

            while (child !== null) {
              newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
              subtreeFlags |= child.subtreeFlags;
              subtreeFlags |= child.flags;
              actualDuration += child.actualDuration;
              treeBaseDuration += child.treeBaseDuration;
              child = child.sibling;
            }

            completedWork.actualDuration = actualDuration;
            completedWork.treeBaseDuration = treeBaseDuration;
          } else {
            var _child = completedWork.child;

            while (_child !== null) {
              newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
              subtreeFlags |= _child.subtreeFlags;
              subtreeFlags |= _child.flags;
              _child["return"] = completedWork;
              _child = _child.sibling;
            }
          }

          completedWork.subtreeFlags |= subtreeFlags;
        } else {
          if ((completedWork.mode & ProfileMode) !== NoMode) {
            var _treeBaseDuration = completedWork.selfBaseDuration;
            var _child2 = completedWork.child;

            while (_child2 !== null) {
              newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child2.lanes, _child2.childLanes));
              subtreeFlags |= _child2.subtreeFlags & StaticMask;
              subtreeFlags |= _child2.flags & StaticMask;
              _treeBaseDuration += _child2.treeBaseDuration;
              _child2 = _child2.sibling;
            }

            completedWork.treeBaseDuration = _treeBaseDuration;
          } else {
            var _child3 = completedWork.child;

            while (_child3 !== null) {
              newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child3.lanes, _child3.childLanes));
              subtreeFlags |= _child3.subtreeFlags & StaticMask;
              subtreeFlags |= _child3.flags & StaticMask;
              _child3["return"] = completedWork;
              _child3 = _child3.sibling;
            }
          }

          completedWork.subtreeFlags |= subtreeFlags;
        }

        completedWork.childLanes = newChildLanes;
        return didBailout;
      }

      function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps;
        popTreeContext(workInProgress);

        switch (workInProgress.tag) {
          case IndeterminateComponent:
          case LazyComponent:
          case SimpleMemoComponent:
          case FunctionComponent:
          case ForwardRef:
          case Fragment:
          case Mode:
          case Profiler:
          case ContextConsumer:
          case MemoComponent:
            bubbleProperties(workInProgress);
            return null;

          case ClassComponent:
            {
              var Component = workInProgress.type;

              if (isContextProvider(Component)) {
                popContext(workInProgress);
              }

              bubbleProperties(workInProgress);
              return null;
            }

          case HostRoot:
            {
              var fiberRoot = workInProgress.stateNode;
              popHostContainer(workInProgress);
              popTopLevelContextObject(workInProgress);
              resetWorkInProgressVersions();

              if (fiberRoot.pendingContext) {
                fiberRoot.context = fiberRoot.pendingContext;
                fiberRoot.pendingContext = null;
              }

              if (current === null || current.child === null) {
                var wasHydrated = popHydrationState(workInProgress);

                if (wasHydrated) {
                  markUpdate(workInProgress);
                } else {
                  if (current !== null) {
                    var prevState = current.memoizedState;

                    if (!prevState.isDehydrated || (workInProgress.flags & ForceClientRender) !== NoFlags) {
                      workInProgress.flags |= Snapshot;
                      upgradeHydrationErrorsToRecoverable();
                    }
                  }
                }
              }

              updateHostContainer(current, workInProgress);
              bubbleProperties(workInProgress);
              return null;
            }

          case HostComponent:
            {
              popHostContext(workInProgress);
              var rootContainerInstance = getRootHostContainer();
              var type = workInProgress.type;

              if (current !== null && workInProgress.stateNode != null) {
                updateHostComponent(current, workInProgress, type, newProps, rootContainerInstance);

                if (current.ref !== workInProgress.ref) {
                  markRef(workInProgress);
                }
              } else {
                if (!newProps) {
                  if (workInProgress.stateNode === null) {
                    throw new Error('We must have new props for new mounts. This error is likely ' + 'caused by a bug in React. Please file an issue.');
                  }

                  bubbleProperties(workInProgress);
                  return null;
                }

                var currentHostContext = getHostContext();

                var _wasHydrated = popHydrationState(workInProgress);

                if (_wasHydrated) {
                  if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) {
                    markUpdate(workInProgress);
                  }
                } else {
                  var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                  appendAllChildren(instance, workInProgress, false, false);
                  workInProgress.stateNode = instance;

                  if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) {
                    markUpdate(workInProgress);
                  }
                }

                if (workInProgress.ref !== null) {
                  markRef(workInProgress);
                }
              }

              bubbleProperties(workInProgress);
              return null;
            }

          case HostText:
            {
              var newText = newProps;

              if (current && workInProgress.stateNode != null) {
                var oldText = current.memoizedProps;
                updateHostText(current, workInProgress, oldText, newText);
              } else {
                if (typeof newText !== 'string') {
                  if (workInProgress.stateNode === null) {
                    throw new Error('We must have new props for new mounts. This error is likely ' + 'caused by a bug in React. Please file an issue.');
                  }
                }

                var _rootContainerInstance = getRootHostContainer();

                var _currentHostContext = getHostContext();

                var _wasHydrated2 = popHydrationState(workInProgress);

                if (_wasHydrated2) {
                  if (prepareToHydrateHostTextInstance(workInProgress)) {
                    markUpdate(workInProgress);
                  }
                } else {
                  workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
              }

              bubbleProperties(workInProgress);
              return null;
            }

          case SuspenseComponent:
            {
              popSuspenseContext(workInProgress);
              var nextState = workInProgress.memoizedState;

              if (hasUnhydratedTailNodes() && (workInProgress.mode & ConcurrentMode) !== NoMode && (workInProgress.flags & DidCapture) === NoFlags) {
                warnIfUnhydratedTailNodes(workInProgress);
                resetHydrationState();
                workInProgress.flags |= ForceClientRender | Incomplete | ShouldCapture;
                return workInProgress;
              }

              if (nextState !== null && nextState.dehydrated !== null) {
                var _wasHydrated3 = popHydrationState(workInProgress);

                if (current === null) {
                  if (!_wasHydrated3) {
                    throw new Error('A dehydrated suspense component was completed without a hydrated node. ' + 'This is probably a bug in React.');
                  }

                  prepareToHydrateHostSuspenseInstance(workInProgress);
                  bubbleProperties(workInProgress);
                  {
                    if ((workInProgress.mode & ProfileMode) !== NoMode) {
                      var isTimedOutSuspense = nextState !== null;

                      if (isTimedOutSuspense) {
                        var primaryChildFragment = workInProgress.child;

                        if (primaryChildFragment !== null) {
                          workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                        }
                      }
                    }
                  }
                  return null;
                } else {
                  resetHydrationState();

                  if ((workInProgress.flags & DidCapture) === NoFlags) {
                    workInProgress.memoizedState = null;
                  }

                  workInProgress.flags |= Update;
                  bubbleProperties(workInProgress);
                  {
                    if ((workInProgress.mode & ProfileMode) !== NoMode) {
                      var _isTimedOutSuspense = nextState !== null;

                      if (_isTimedOutSuspense) {
                        var _primaryChildFragment = workInProgress.child;

                        if (_primaryChildFragment !== null) {
                          workInProgress.treeBaseDuration -= _primaryChildFragment.treeBaseDuration;
                        }
                      }
                    }
                  }
                  return null;
                }
              }

              upgradeHydrationErrorsToRecoverable();

              if ((workInProgress.flags & DidCapture) !== NoFlags) {
                workInProgress.lanes = renderLanes;

                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                  transferActualDuration(workInProgress);
                }

                return workInProgress;
              }

              var nextDidTimeout = nextState !== null;
              var prevDidTimeout = false;

              if (current === null) {
                popHydrationState(workInProgress);
              } else {
                var _prevState = current.memoizedState;
                prevDidTimeout = _prevState !== null;
              }

              if (nextDidTimeout !== prevDidTimeout) {
                if (nextDidTimeout) {
                  var _offscreenFiber2 = workInProgress.child;
                  _offscreenFiber2.flags |= Visibility;

                  if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
                    var hasInvisibleChildContext = current === null && (workInProgress.memoizedProps.unstable_avoidThisFallback !== true || !enableSuspenseAvoidThisFallback);

                    if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) {
                      renderDidSuspend();
                    } else {
                      renderDidSuspendDelayIfPossible();
                    }
                  }
                }
              }

              var wakeables = workInProgress.updateQueue;

              if (wakeables !== null) {
                workInProgress.flags |= Update;
              }

              bubbleProperties(workInProgress);
              {
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                  if (nextDidTimeout) {
                    var _primaryChildFragment2 = workInProgress.child;

                    if (_primaryChildFragment2 !== null) {
                      workInProgress.treeBaseDuration -= _primaryChildFragment2.treeBaseDuration;
                    }
                  }
                }
              }
              return null;
            }

          case HostPortal:
            popHostContainer(workInProgress);
            updateHostContainer(current, workInProgress);

            if (current === null) {
              preparePortalMount(workInProgress.stateNode.containerInfo);
            }

            bubbleProperties(workInProgress);
            return null;

          case ContextProvider:
            var context = workInProgress.type._context;
            popProvider(context, workInProgress);
            bubbleProperties(workInProgress);
            return null;

          case IncompleteClassComponent:
            {
              var _Component = workInProgress.type;

              if (isContextProvider(_Component)) {
                popContext(workInProgress);
              }

              bubbleProperties(workInProgress);
              return null;
            }

          case SuspenseListComponent:
            {
              popSuspenseContext(workInProgress);
              var renderState = workInProgress.memoizedState;

              if (renderState === null) {
                bubbleProperties(workInProgress);
                return null;
              }

              var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
              var renderedTail = renderState.rendering;

              if (renderedTail === null) {
                if (!didSuspendAlready) {
                  var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);

                  if (!cannotBeSuspended) {
                    var row = workInProgress.child;

                    while (row !== null) {
                      var suspended = findFirstSuspended(row);

                      if (suspended !== null) {
                        didSuspendAlready = true;
                        workInProgress.flags |= DidCapture;
                        cutOffTailIfNeeded(renderState, false);
                        var newThenables = suspended.updateQueue;

                        if (newThenables !== null) {
                          workInProgress.updateQueue = newThenables;
                          workInProgress.flags |= Update;
                        }

                        workInProgress.subtreeFlags = NoFlags;
                        resetChildFibers(workInProgress, renderLanes);
                        pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                        return workInProgress.child;
                      }

                      row = row.sibling;
                    }
                  }

                  if (renderState.tail !== null && now() > getRenderTargetTime()) {
                    workInProgress.flags |= DidCapture;
                    didSuspendAlready = true;
                    cutOffTailIfNeeded(renderState, false);
                    workInProgress.lanes = SomeRetryLane;
                  }
                } else {
                  cutOffTailIfNeeded(renderState, false);
                }
              } else {
                if (!didSuspendAlready) {
                  var _suspended = findFirstSuspended(renderedTail);

                  if (_suspended !== null) {
                    workInProgress.flags |= DidCapture;
                    didSuspendAlready = true;
                    var _newThenables = _suspended.updateQueue;

                    if (_newThenables !== null) {
                      workInProgress.updateQueue = _newThenables;
                      workInProgress.flags |= Update;
                    }

                    cutOffTailIfNeeded(renderState, true);

                    if (renderState.tail === null && renderState.tailMode === 'hidden' && !renderedTail.alternate && !getIsHydrating()) {
                      bubbleProperties(workInProgress);
                      return null;
                    }
                  } else if (now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                    workInProgress.flags |= DidCapture;
                    didSuspendAlready = true;
                    cutOffTailIfNeeded(renderState, false);
                    workInProgress.lanes = SomeRetryLane;
                  }
                }

                if (renderState.isBackwards) {
                  renderedTail.sibling = workInProgress.child;
                  workInProgress.child = renderedTail;
                } else {
                  var previousSibling = renderState.last;

                  if (previousSibling !== null) {
                    previousSibling.sibling = renderedTail;
                  } else {
                    workInProgress.child = renderedTail;
                  }

                  renderState.last = renderedTail;
                }
              }

              if (renderState.tail !== null) {
                var next = renderState.tail;
                renderState.rendering = next;
                renderState.tail = next.sibling;
                renderState.renderingStartTime = now();
                next.sibling = null;
                var suspenseContext = suspenseStackCursor.current;

                if (didSuspendAlready) {
                  suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                } else {
                  suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                }

                pushSuspenseContext(workInProgress, suspenseContext);
                return next;
              }

              bubbleProperties(workInProgress);
              return null;
            }

          case ScopeComponent:
            {
              break;
            }

          case OffscreenComponent:
          case LegacyHiddenComponent:
            {
              popRenderLanes(workInProgress);
              var _nextState = workInProgress.memoizedState;
              var nextIsHidden = _nextState !== null;

              if (current !== null) {
                var _prevState2 = current.memoizedState;
                var prevIsHidden = _prevState2 !== null;

                if (prevIsHidden !== nextIsHidden && !enableLegacyHidden) {
                  workInProgress.flags |= Visibility;
                }
              }

              if (!nextIsHidden || (workInProgress.mode & ConcurrentMode) === NoMode) {
                bubbleProperties(workInProgress);
              } else {
                if (includesSomeLane(subtreeRenderLanes, OffscreenLane)) {
                  bubbleProperties(workInProgress);
                  {
                    if (workInProgress.subtreeFlags & (Placement | Update)) {
                      workInProgress.flags |= Visibility;
                    }
                  }
                }
              }

              return null;
            }

          case CacheComponent:
            {
              return null;
            }

          case TracingMarkerComponent:
            {
              return null;
            }
        }

        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + 'React. Please file an issue.');
      }

      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var didReceiveUpdate = false;
      var didWarnAboutBadClass;
      var didWarnAboutModulePatternComponent;
      var didWarnAboutContextTypeOnFunctionComponent;
      var didWarnAboutGetDerivedStateOnFunctionComponent;
      var didWarnAboutFunctionRefs;
      var didWarnAboutReassigningProps;
      var didWarnAboutRevealOrder;
      var didWarnAboutTailOptions;
      {
        didWarnAboutBadClass = {};
        didWarnAboutModulePatternComponent = {};
        didWarnAboutContextTypeOnFunctionComponent = {};
        didWarnAboutGetDerivedStateOnFunctionComponent = {};
        didWarnAboutFunctionRefs = {};
        didWarnAboutReassigningProps = false;
        didWarnAboutRevealOrder = {};
        didWarnAboutTailOptions = {};
      }

      function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) {
          workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        } else {
          workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
        }
      }

      function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
      }

      function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        {
          if (workInProgress.type !== workInProgress.elementType) {
            var innerPropTypes = Component.propTypes;

            if (innerPropTypes) {
              checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(Component));
            }
          }
        }
        var render = Component.render;
        var ref = workInProgress.ref;
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        {
          markComponentRenderStarted(workInProgress);
        }
        {
          ReactCurrentOwner$1.current = workInProgress;
          setIsRendering(true);
          nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
          hasId = checkDidRenderIdHook();

          if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);

            try {
              nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
              hasId = checkDidRenderIdHook();
            } finally {
              setIsStrictModeForDevtools(false);
            }
          }

          setIsRendering(false);
        }
        {
          markComponentRenderStopped();
        }

        if (current !== null && !didReceiveUpdate) {
          bailoutHooks(current, workInProgress, renderLanes);
          return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }

        if (getIsHydrating() && hasId) {
          pushMaterializedTreeId(workInProgress);
        }

        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
      }

      function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (current === null) {
          var type = Component.type;

          if (isSimpleFunctionComponent(type) && Component.compare === null && Component.defaultProps === undefined) {
            var resolvedType = type;
            {
              resolvedType = resolveFunctionForHotReloading(type);
            }
            workInProgress.tag = SimpleMemoComponent;
            workInProgress.type = resolvedType;
            {
              validateFunctionComponentInDev(workInProgress, type);
            }
            return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, renderLanes);
          }

          {
            var innerPropTypes = type.propTypes;

            if (innerPropTypes) {
              checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(type));
            }
          }
          var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
          child.ref = workInProgress.ref;
          child["return"] = workInProgress;
          workInProgress.child = child;
          return child;
        }

        {
          var _type = Component.type;
          var _innerPropTypes = _type.propTypes;

          if (_innerPropTypes) {
            checkPropTypes(_innerPropTypes, nextProps, 'prop', getComponentNameFromType(_type));
          }
        }
        var currentChild = current.child;
        var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);

        if (!hasScheduledUpdateOrContext) {
          var prevProps = currentChild.memoizedProps;
          var compare = Component.compare;
          compare = compare !== null ? compare : shallowEqual;

          if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) {
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
          }
        }

        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild["return"] = workInProgress;
        workInProgress.child = newChild;
        return newChild;
      }

      function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        {
          if (workInProgress.type !== workInProgress.elementType) {
            var outerMemoType = workInProgress.elementType;

            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
              var lazyComponent = outerMemoType;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;

              try {
                outerMemoType = init(payload);
              } catch (x) {
                outerMemoType = null;
              }

              var outerPropTypes = outerMemoType && outerMemoType.propTypes;

              if (outerPropTypes) {
                checkPropTypes(outerPropTypes, nextProps, 'prop', getComponentNameFromType(outerMemoType));
              }
            }
          }
        }

        if (current !== null) {
          var prevProps = current.memoizedProps;

          if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
            didReceiveUpdate = false;
            workInProgress.pendingProps = nextProps = prevProps;

            if (!checkScheduledUpdateOrContext(current, renderLanes)) {
              workInProgress.lanes = current.lanes;
              return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
              didReceiveUpdate = true;
            }
          }
        }

        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
      }

      function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;

        if (nextProps.mode === 'hidden' || enableLegacyHidden) {
          if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            var nextState = {
              baseLanes: NoLanes,
              cachePool: null,
              transitions: null
            };
            workInProgress.memoizedState = nextState;
            pushRenderLanes(workInProgress, renderLanes);
          } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
            var spawnedCachePool = null;
            var nextBaseLanes;

            if (prevState !== null) {
              var prevBaseLanes = prevState.baseLanes;
              nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
            } else {
              nextBaseLanes = renderLanes;
            }

            workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
            var _nextState = {
              baseLanes: nextBaseLanes,
              cachePool: spawnedCachePool,
              transitions: null
            };
            workInProgress.memoizedState = _nextState;
            workInProgress.updateQueue = null;
            pushRenderLanes(workInProgress, nextBaseLanes);
            return null;
          } else {
            var _nextState2 = {
              baseLanes: NoLanes,
              cachePool: null,
              transitions: null
            };
            workInProgress.memoizedState = _nextState2;
            var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
            pushRenderLanes(workInProgress, subtreeRenderLanes);
          }
        } else {
          var _subtreeRenderLanes;

          if (prevState !== null) {
            _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes);
            workInProgress.memoizedState = null;
          } else {
            _subtreeRenderLanes = renderLanes;
          }

          pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }

        {
          reconcileChildren(current, workInProgress, nextChildren, renderLanes);
          return workInProgress.child;
        }
      }

      function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
      }

      function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
      }

      function updateProfiler(current, workInProgress, renderLanes) {
        {
          workInProgress.flags |= Update;
          {
            var stateNode = workInProgress.stateNode;
            stateNode.effectDuration = 0;
            stateNode.passiveEffectDuration = 0;
          }
        }
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
      }

      function markRef$1(current, workInProgress) {
        var ref = workInProgress.ref;

        if (current === null && ref !== null || current !== null && current.ref !== ref) {
          workInProgress.flags |= Ref;
          {
            workInProgress.flags |= RefStatic;
          }
        }
      }

      function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        {
          if (workInProgress.type !== workInProgress.elementType) {
            var innerPropTypes = Component.propTypes;

            if (innerPropTypes) {
              checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(Component));
            }
          }
        }
        var context;
        {
          var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
          context = getMaskedContext(workInProgress, unmaskedContext);
        }
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        {
          markComponentRenderStarted(workInProgress);
        }
        {
          ReactCurrentOwner$1.current = workInProgress;
          setIsRendering(true);
          nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
          hasId = checkDidRenderIdHook();

          if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);

            try {
              nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
              hasId = checkDidRenderIdHook();
            } finally {
              setIsStrictModeForDevtools(false);
            }
          }

          setIsRendering(false);
        }
        {
          markComponentRenderStopped();
        }

        if (current !== null && !didReceiveUpdate) {
          bailoutHooks(current, workInProgress, renderLanes);
          return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }

        if (getIsHydrating() && hasId) {
          pushMaterializedTreeId(workInProgress);
        }

        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
      }

      function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        {
          switch (shouldError(workInProgress)) {
            case false:
              {
                var _instance = workInProgress.stateNode;
                var ctor = workInProgress.type;
                var tempInstance = new ctor(workInProgress.memoizedProps, _instance.context);
                var state = tempInstance.state;

                _instance.updater.enqueueSetState(_instance, state, null);

                break;
              }

            case true:
              {
                workInProgress.flags |= DidCapture;
                workInProgress.flags |= ShouldCapture;
                var error$1 = new Error('Simulated error coming from DevTools');
                var lane = pickArbitraryLane(renderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                var update = createClassErrorUpdate(workInProgress, createCapturedValue(error$1, workInProgress), lane);
                enqueueCapturedUpdate(workInProgress, update);
                break;
              }
          }

          if (workInProgress.type !== workInProgress.elementType) {
            var innerPropTypes = Component.propTypes;

            if (innerPropTypes) {
              checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(Component));
            }
          }
        }
        var hasContext;

        if (isContextProvider(Component)) {
          hasContext = true;
          pushContextProvider(workInProgress);
        } else {
          hasContext = false;
        }

        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;

        if (instance === null) {
          if (current !== null) {
            current.alternate = null;
            workInProgress.alternate = null;
            workInProgress.flags |= Placement;
          }

          constructClassInstance(workInProgress, Component, nextProps);
          mountClassInstance(workInProgress, Component, nextProps, renderLanes);
          shouldUpdate = true;
        } else if (current === null) {
          shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        } else {
          shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        }

        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        {
          var inst = workInProgress.stateNode;

          if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) {
              error('It looks like %s is reassigning its own `this.props` while rendering. ' + 'This is not supported and can lead to confusing bugs.', getComponentNameFromFiber(workInProgress) || 'a component');
            }

            didWarnAboutReassigningProps = true;
          }
        }
        return nextUnitOfWork;
      }

      function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        markRef$1(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;

        if (!shouldUpdate && !didCaptureError) {
          if (hasContext) {
            invalidateContextProvider(workInProgress, Component, false);
          }

          return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }

        var instance = workInProgress.stateNode;
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;

        if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
          nextChildren = null;
          {
            stopProfilerTimerIfRunning();
          }
        } else {
          {
            markComponentRenderStarted(workInProgress);
          }
          {
            setIsRendering(true);
            nextChildren = instance.render();

            if (workInProgress.mode & StrictLegacyMode) {
              setIsStrictModeForDevtools(true);

              try {
                instance.render();
              } finally {
                setIsStrictModeForDevtools(false);
              }
            }

            setIsRendering(false);
          }
          {
            markComponentRenderStopped();
          }
        }

        workInProgress.flags |= PerformedWork;

        if (current !== null && didCaptureError) {
          forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        } else {
          reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }

        workInProgress.memoizedState = instance.state;

        if (hasContext) {
          invalidateContextProvider(workInProgress, Component, true);
        }

        return workInProgress.child;
      }

      function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;

        if (root.pendingContext) {
          pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        } else if (root.context) {
          pushTopLevelContextObject(workInProgress, root.context, false);
        }

        pushHostContainer(workInProgress, root.containerInfo);
      }

      function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);

        if (current === null) {
          throw new Error('Should have a current fiber. This is a bug in React.');
        }

        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState.element;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState;
        var nextChildren = nextState.element;

        if (prevState.isDehydrated) {
          var overrideState = {
            element: nextChildren,
            isDehydrated: false,
            cache: nextState.cache,
            pendingSuspenseBoundaries: nextState.pendingSuspenseBoundaries,
            transitions: nextState.transitions
          };
          var updateQueue = workInProgress.updateQueue;
          updateQueue.baseState = overrideState;
          workInProgress.memoizedState = overrideState;

          if (workInProgress.flags & ForceClientRender) {
            var recoverableError = new Error('There was an error while hydrating. Because the error happened outside ' + 'of a Suspense boundary, the entire root will switch to ' + 'client rendering.');
            return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError);
          } else if (nextChildren !== prevChildren) {
            var _recoverableError = new Error('This root received an early update, before anything was able ' + 'hydrate. Switched the entire root to client rendering.');

            return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, _recoverableError);
          } else {
            enterHydrationState(workInProgress);
            var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
            workInProgress.child = child;
            var node = child;

            while (node) {
              node.flags = node.flags & ~Placement | Hydrating;
              node = node.sibling;
            }
          }
        } else {
          resetHydrationState();

          if (nextChildren === prevChildren) {
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
          }

          reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }

        return workInProgress.child;
      }

      function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError) {
        resetHydrationState();
        queueHydrationError(recoverableError);
        workInProgress.flags |= ForceClientRender;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
      }

      function updateHostComponent$1(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);

        if (current === null) {
          tryToClaimNextHydratableInstance(workInProgress);
        }

        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);

        if (isDirectTextChild) {
          nextChildren = null;
        } else if (prevProps !== null && shouldSetTextContent(type, prevProps)) {
          workInProgress.flags |= ContentReset;
        }

        markRef$1(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
      }

      function updateHostText$1(current, workInProgress) {
        if (current === null) {
          tryToClaimNextHydratableInstance(workInProgress);
        }

        return null;
      }

      function mountLazyComponent(_current, workInProgress, elementType, renderLanes) {
        if (_current !== null) {
          _current.alternate = null;
          workInProgress.alternate = null;
          workInProgress.flags |= Placement;
        }

        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload);
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;

        switch (resolvedTag) {
          case FunctionComponent:
            {
              {
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
              }
              child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
              return child;
            }

          case ClassComponent:
            {
              {
                workInProgress.type = Component = resolveClassForHotReloading(Component);
              }
              child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
              return child;
            }

          case ForwardRef:
            {
              {
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
              }
              child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
              return child;
            }

          case MemoComponent:
            {
              {
                if (workInProgress.type !== workInProgress.elementType) {
                  var outerPropTypes = Component.propTypes;

                  if (outerPropTypes) {
                    checkPropTypes(outerPropTypes, resolvedProps, 'prop', getComponentNameFromType(Component));
                  }
                }
              }
              child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), renderLanes);
              return child;
            }
        }

        var hint = '';
        {
          if (Component !== null && typeof Component === 'object' && Component.$$typeof === REACT_LAZY_TYPE) {
            hint = ' Did you wrap a component in React.lazy() more than once?';
          }
        }
        throw new Error("Element type is invalid. Received a promise that resolves to: " + Component + ". " + ("Lazy element type must resolve to a class or function." + hint));
      }

      function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        if (_current !== null) {
          _current.alternate = null;
          workInProgress.alternate = null;
          workInProgress.flags |= Placement;
        }

        workInProgress.tag = ClassComponent;
        var hasContext;

        if (isContextProvider(Component)) {
          hasContext = true;
          pushContextProvider(workInProgress);
        } else {
          hasContext = false;
        }

        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
      }

      function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        if (_current !== null) {
          _current.alternate = null;
          workInProgress.alternate = null;
          workInProgress.flags |= Placement;
        }

        var props = workInProgress.pendingProps;
        var context;
        {
          var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
          context = getMaskedContext(workInProgress, unmaskedContext);
        }
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        var hasId;
        {
          markComponentRenderStarted(workInProgress);
        }
        {
          if (Component.prototype && typeof Component.prototype.render === 'function') {
            var componentName = getComponentNameFromType(Component) || 'Unknown';

            if (!didWarnAboutBadClass[componentName]) {
              error("The <%s /> component appears to have a render method, but doesn't extend React.Component. " + 'This is likely to cause errors. Change %s to extend React.Component instead.', componentName, componentName);
              didWarnAboutBadClass[componentName] = true;
            }
          }

          if (workInProgress.mode & StrictLegacyMode) {
            ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
          }

          setIsRendering(true);
          ReactCurrentOwner$1.current = workInProgress;
          value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
          hasId = checkDidRenderIdHook();
          setIsRendering(false);
        }
        {
          markComponentRenderStopped();
        }
        workInProgress.flags |= PerformedWork;
        {
          if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || 'Unknown';

            if (!didWarnAboutModulePatternComponent[_componentName]) {
              error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName, _componentName, _componentName);
              didWarnAboutModulePatternComponent[_componentName] = true;
            }
          }
        }

        if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
          {
            var _componentName2 = getComponentNameFromType(Component) || 'Unknown';

            if (!didWarnAboutModulePatternComponent[_componentName2]) {
              error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName2, _componentName2, _componentName2);
              didWarnAboutModulePatternComponent[_componentName2] = true;
            }
          }
          workInProgress.tag = ClassComponent;
          workInProgress.memoizedState = null;
          workInProgress.updateQueue = null;
          var hasContext = false;

          if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
          } else {
            hasContext = false;
          }

          workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
          initializeUpdateQueue(workInProgress);
          adoptClassInstance(workInProgress, value);
          mountClassInstance(workInProgress, Component, props, renderLanes);
          return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
          workInProgress.tag = FunctionComponent;
          {
            if (workInProgress.mode & StrictLegacyMode) {
              setIsStrictModeForDevtools(true);

              try {
                value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                hasId = checkDidRenderIdHook();
              } finally {
                setIsStrictModeForDevtools(false);
              }
            }
          }

          if (getIsHydrating() && hasId) {
            pushMaterializedTreeId(workInProgress);
          }

          reconcileChildren(null, workInProgress, value, renderLanes);
          {
            validateFunctionComponentInDev(workInProgress, Component);
          }
          return workInProgress.child;
        }
      }

      function validateFunctionComponentInDev(workInProgress, Component) {
        {
          if (Component) {
            if (Component.childContextTypes) {
              error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
            }
          }

          if (workInProgress.ref !== null) {
            var info = '';
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();

            if (ownerName) {
              info += '\n\nCheck the render method of `' + ownerName + '`.';
            }

            var warningKey = ownerName || '';
            var debugSource = workInProgress._debugSource;

            if (debugSource) {
              warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
            }

            if (!didWarnAboutFunctionRefs[warningKey]) {
              didWarnAboutFunctionRefs[warningKey] = true;
              error('Function components cannot be given refs. ' + 'Attempts to access this ref will fail. ' + 'Did you mean to use React.forwardRef()?%s', info);
            }
          }

          if (typeof Component.getDerivedStateFromProps === 'function') {
            var _componentName3 = getComponentNameFromType(Component) || 'Unknown';

            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
              error('%s: Function components do not support getDerivedStateFromProps.', _componentName3);
              didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
          }

          if (typeof Component.contextType === 'object' && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || 'Unknown';

            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
              error('%s: Function components do not support contextType.', _componentName4);
              didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
          }
        }
      }

      var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: NoLane
      };

      function mountSuspenseOffscreenState(renderLanes) {
        return {
          baseLanes: renderLanes,
          cachePool: getSuspendedCache(),
          transitions: null
        };
      }

      function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        var cachePool = null;
        return {
          baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes),
          cachePool: cachePool,
          transitions: prevOffscreenState.transitions
        };
      }

      function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        if (current !== null) {
          var suspenseState = current.memoizedState;

          if (suspenseState === null) {
            return false;
          }
        }

        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
      }

      function getRemainingWorkInPrimaryTree(current, renderLanes) {
        return removeLanes(current.childLanes, renderLanes);
      }

      function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        {
          if (shouldSuspend(workInProgress)) {
            workInProgress.flags |= DidCapture;
          }
        }
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;

        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
          showFallback = true;
          workInProgress.flags &= ~DidCapture;
        } else {
          if (current === null || current.memoizedState !== null) {
            {
              suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
            }
          }
        }

        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext);

        if (current === null) {
          tryToClaimNextHydratableInstance(workInProgress);
          var suspenseState = workInProgress.memoizedState;

          if (suspenseState !== null) {
            var dehydrated = suspenseState.dehydrated;

            if (dehydrated !== null) {
              return mountDehydratedSuspenseComponent(workInProgress, dehydrated);
            }
          }

          var nextPrimaryChildren = nextProps.children;
          var nextFallbackChildren = nextProps.fallback;

          if (showFallback) {
            var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
            var primaryChildFragment = workInProgress.child;
            primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
            workInProgress.memoizedState = SUSPENDED_MARKER;
            return fallbackFragment;
          } else {
            return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
          }
        } else {
          var prevState = current.memoizedState;

          if (prevState !== null) {
            var _dehydrated = prevState.dehydrated;

            if (_dehydrated !== null) {
              if (!didSuspend) {
                return updateDehydratedSuspenseComponent(current, workInProgress, _dehydrated, prevState, renderLanes);
              } else if (workInProgress.flags & ForceClientRender) {
                workInProgress.flags &= ~ForceClientRender;
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, new Error('There was an error while hydrating this Suspense boundary. ' + 'Switched to client rendering.'));
              } else if (workInProgress.memoizedState !== null) {
                workInProgress.child = current.child;
                workInProgress.flags |= DidCapture;
                return null;
              } else {
                var _nextPrimaryChildren = nextProps.children;
                var _nextFallbackChildren = nextProps.fallback;
                var fallbackChildFragment = mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, _nextPrimaryChildren, _nextFallbackChildren, renderLanes);
                var _primaryChildFragment2 = workInProgress.child;
                _primaryChildFragment2.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
              }
            }

            if (showFallback) {
              var _nextFallbackChildren2 = nextProps.fallback;
              var _nextPrimaryChildren2 = nextProps.children;

              var _fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren2, _nextFallbackChildren2, renderLanes);

              var _primaryChildFragment3 = workInProgress.child;
              var prevOffscreenState = current.child.memoizedState;
              _primaryChildFragment3.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
              _primaryChildFragment3.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
              workInProgress.memoizedState = SUSPENDED_MARKER;
              return _fallbackChildFragment;
            } else {
              var _nextPrimaryChildren3 = nextProps.children;

              var _primaryChildFragment4 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren3, renderLanes);

              workInProgress.memoizedState = null;
              return _primaryChildFragment4;
            }
          } else {
            if (showFallback) {
              var _nextFallbackChildren3 = nextProps.fallback;
              var _nextPrimaryChildren4 = nextProps.children;

              var _fallbackChildFragment2 = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren4, _nextFallbackChildren3, renderLanes);

              var _primaryChildFragment5 = workInProgress.child;
              var _prevOffscreenState = current.child.memoizedState;
              _primaryChildFragment5.memoizedState = _prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(_prevOffscreenState, renderLanes);
              _primaryChildFragment5.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
              workInProgress.memoizedState = SUSPENDED_MARKER;
              return _fallbackChildFragment2;
            } else {
              var _nextPrimaryChildren5 = nextProps.children;

              var _primaryChildFragment6 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren5, renderLanes);

              workInProgress.memoizedState = null;
              return _primaryChildFragment6;
            }
          }
        }
      }

      function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
          mode: 'visible',
          children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
        primaryChildFragment["return"] = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
      }

      function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
          mode: 'hidden',
          children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;

        if ((mode & ConcurrentMode) === NoMode && progressedPrimaryFragment !== null) {
          primaryChildFragment = progressedPrimaryFragment;
          primaryChildFragment.childLanes = NoLanes;
          primaryChildFragment.pendingProps = primaryChildProps;

          if (workInProgress.mode & ProfileMode) {
            primaryChildFragment.actualDuration = 0;
            primaryChildFragment.actualStartTime = -1;
            primaryChildFragment.selfBaseDuration = 0;
            primaryChildFragment.treeBaseDuration = 0;
          }

          fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
          primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
          fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }

        primaryChildFragment["return"] = workInProgress;
        fallbackChildFragment["return"] = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
      }

      function mountWorkInProgressOffscreenFiber(offscreenProps, mode, renderLanes) {
        return createFiberFromOffscreen(offscreenProps, mode, NoLanes, null);
      }

      function updateWorkInProgressOffscreenFiber(current, offscreenProps) {
        return createWorkInProgress(current, offscreenProps);
      }

      function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
          mode: 'visible',
          children: primaryChildren
        });

        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
          primaryChildFragment.lanes = renderLanes;
        }

        primaryChildFragment["return"] = workInProgress;
        primaryChildFragment.sibling = null;

        if (currentFallbackChildFragment !== null) {
          var deletions = workInProgress.deletions;

          if (deletions === null) {
            workInProgress.deletions = [currentFallbackChildFragment];
            workInProgress.flags |= ChildDeletion;
          } else {
            deletions.push(currentFallbackChildFragment);
          }
        }

        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
      }

      function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
          mode: 'hidden',
          children: primaryChildren
        };
        var primaryChildFragment;

        if ((mode & ConcurrentMode) === NoMode && workInProgress.child !== currentPrimaryChildFragment) {
          var progressedPrimaryFragment = workInProgress.child;
          primaryChildFragment = progressedPrimaryFragment;
          primaryChildFragment.childLanes = NoLanes;
          primaryChildFragment.pendingProps = primaryChildProps;

          if (workInProgress.mode & ProfileMode) {
            primaryChildFragment.actualDuration = 0;
            primaryChildFragment.actualStartTime = -1;
            primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
            primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
          }

          workInProgress.deletions = null;
        } else {
          primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps);
          primaryChildFragment.subtreeFlags = currentPrimaryChildFragment.subtreeFlags & StaticMask;
        }

        var fallbackChildFragment;

        if (currentFallbackChildFragment !== null) {
          fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        } else {
          fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
          fallbackChildFragment.flags |= Placement;
        }

        fallbackChildFragment["return"] = workInProgress;
        primaryChildFragment["return"] = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
      }

      function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, recoverableError) {
        if (recoverableError !== null) {
          queueHydrationError(recoverableError);
        }

        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        var nextProps = workInProgress.pendingProps;
        var primaryChildren = nextProps.children;
        var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren);
        primaryChildFragment.flags |= Placement;
        workInProgress.memoizedState = null;
        return primaryChildFragment;
      }

      function mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var fiberMode = workInProgress.mode;
        var primaryChildProps = {
          mode: 'visible',
          children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, fiberMode);
        var fallbackChildFragment = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null);
        fallbackChildFragment.flags |= Placement;
        primaryChildFragment["return"] = workInProgress;
        fallbackChildFragment["return"] = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;

        if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
          reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        }

        return fallbackChildFragment;
      }

      function mountDehydratedSuspenseComponent(workInProgress, suspenseInstance, renderLanes) {
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
          {
            error('Cannot hydrate Suspense in legacy mode. Switch from ' + 'ReactDOM.hydrate(element, container) to ' + 'ReactDOMClient.hydrateRoot(container, <App />)' + '.render(element) or remove the Suspense components from ' + 'the server rendered components.');
          }
          workInProgress.lanes = laneToLanes(SyncLane);
        } else if (isSuspenseInstanceFallback(suspenseInstance)) {
          workInProgress.lanes = laneToLanes(DefaultHydrationLane);
        } else {
          workInProgress.lanes = laneToLanes(OffscreenLane);
        }

        return null;
      }

      function updateDehydratedSuspenseComponent(current, workInProgress, suspenseInstance, suspenseState, renderLanes) {
        warnIfHydrating();

        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
          return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, null);
        }

        if (isSuspenseInstanceFallback(suspenseInstance)) {
          return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, new Error('The server could not finish this Suspense boundary, likely ' + 'due to an error during server rendering. Switched to ' + 'client rendering.'));
        }

        var hasContextChanged = includesSomeLane(renderLanes, current.childLanes);

        if (didReceiveUpdate || hasContextChanged) {
          var root = getWorkInProgressRoot();

          if (root !== null) {
            var attemptHydrationAtLane = getBumpedLaneForHydration(root, renderLanes);

            if (attemptHydrationAtLane !== NoLane && attemptHydrationAtLane !== suspenseState.retryLane) {
              suspenseState.retryLane = attemptHydrationAtLane;
              var eventTime = NoTimestamp;
              scheduleUpdateOnFiber(current, attemptHydrationAtLane, eventTime);
            }
          }

          renderDidSuspendDelayIfPossible();
          return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, new Error('This Suspense boundary received an update before it finished ' + 'hydrating. This caused the boundary to switch to client rendering. ' + 'The usual way to fix this is to wrap the original update ' + 'in startTransition.'));
        } else if (isSuspenseInstancePending(suspenseInstance)) {
          workInProgress.flags |= DidCapture;
          workInProgress.child = current.child;
          var retry = retryDehydratedSuspenseBoundary.bind(null, current);
          registerSuspenseInstanceRetry(suspenseInstance, retry);
          return null;
        } else {
          reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress, suspenseInstance, suspenseState.treeContext);
          var nextProps = workInProgress.pendingProps;
          var primaryChildren = nextProps.children;
          var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren);
          primaryChildFragment.flags |= Hydrating;
          return primaryChildFragment;
        }
      }

      function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;

        if (alternate !== null) {
          alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        }

        scheduleContextWorkOnParentPath(fiber["return"], renderLanes, propagationRoot);
      }

      function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        var node = firstChild;

        while (node !== null) {
          if (node.tag === SuspenseComponent) {
            var state = node.memoizedState;

            if (state !== null) {
              scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            }
          } else if (node.tag === SuspenseListComponent) {
            scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
          } else if (node.child !== null) {
            node.child["return"] = node;
            node = node.child;
            continue;
          }

          if (node === workInProgress) {
            return;
          }

          while (node.sibling === null) {
            if (node["return"] === null || node["return"] === workInProgress) {
              return;
            }

            node = node["return"];
          }

          node.sibling["return"] = node["return"];
          node = node.sibling;
        }
      }

      function findLastContentRow(firstChild) {
        var row = firstChild;
        var lastContentRow = null;

        while (row !== null) {
          var currentRow = row.alternate;

          if (currentRow !== null && findFirstSuspended(currentRow) === null) {
            lastContentRow = row;
          }

          row = row.sibling;
        }

        return lastContentRow;
      }

      function validateRevealOrder(revealOrder) {
        {
          if (revealOrder !== undefined && revealOrder !== 'forwards' && revealOrder !== 'backwards' && revealOrder !== 'together' && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;

            if (typeof revealOrder === 'string') {
              switch (revealOrder.toLowerCase()) {
                case 'together':
                case 'forwards':
                case 'backwards':
                  {
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                  }

                case 'forward':
                case 'backward':
                  {
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                  }

                default:
                  error('"%s" is not a supported revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);
                  break;
              }
            } else {
              error('%s is not a supported value for revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);
            }
          }
        }
      }

      function validateTailOptions(tailMode, revealOrder) {
        {
          if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== 'collapsed' && tailMode !== 'hidden') {
              didWarnAboutTailOptions[tailMode] = true;
              error('"%s" is not a supported value for tail on <SuspenseList />. ' + 'Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== 'forwards' && revealOrder !== 'backwards') {
              didWarnAboutTailOptions[tailMode] = true;
              error('<SuspenseList tail="%s" /> is only valid if revealOrder is ' + '"forwards" or "backwards". ' + 'Did you mean to specify revealOrder="forwards"?', tailMode);
            }
          }
        }
      }

      function validateSuspenseListNestedChild(childSlot, index) {
        {
          var isAnArray = isArray(childSlot);
          var isIterable = !isAnArray && typeof getIteratorFn(childSlot) === 'function';

          if (isAnArray || isIterable) {
            var type = isAnArray ? 'array' : 'iterable';
            error('A nested %s was passed to row #%s in <SuspenseList />. Wrap it in ' + 'an additional SuspenseList to configure its revealOrder: ' + '<SuspenseList revealOrder=...> ... ' + '<SuspenseList revealOrder=...>{%s}</SuspenseList> ... ' + '</SuspenseList>', type, index, type);
            return false;
          }
        }
        return true;
      }

      function validateSuspenseListChildren(children, revealOrder) {
        {
          if ((revealOrder === 'forwards' || revealOrder === 'backwards') && children !== undefined && children !== null && children !== false) {
            if (isArray(children)) {
              for (var i = 0; i < children.length; i++) {
                if (!validateSuspenseListNestedChild(children[i], i)) {
                  return;
                }
              }
            } else {
              var iteratorFn = getIteratorFn(children);

              if (typeof iteratorFn === 'function') {
                var childrenIterator = iteratorFn.call(children);

                if (childrenIterator) {
                  var step = childrenIterator.next();
                  var _i = 0;

                  for (; !step.done; step = childrenIterator.next()) {
                    if (!validateSuspenseListNestedChild(step.value, _i)) {
                      return;
                    }

                    _i++;
                  }
                }
              } else {
                error('A single row was passed to a <SuspenseList revealOrder="%s" />. ' + 'This is not useful since it needs multiple rows. ' + 'Did you mean to pass multiple children or an array?', revealOrder);
              }
            }
          }
        }
      }

      function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress.memoizedState;

        if (renderState === null) {
          workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode
          };
        } else {
          renderState.isBackwards = isBackwards;
          renderState.rendering = null;
          renderState.renderingStartTime = 0;
          renderState.last = lastContentRow;
          renderState.tail = tail;
          renderState.tailMode = tailMode;
        }
      }

      function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);

        if (shouldForceFallback) {
          suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
          workInProgress.flags |= DidCapture;
        } else {
          var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;

          if (didSuspendBefore) {
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
          }

          suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }

        pushSuspenseContext(workInProgress, suspenseContext);

        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
          workInProgress.memoizedState = null;
        } else {
          switch (revealOrder) {
            case 'forwards':
              {
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;

                if (lastContentRow === null) {
                  tail = workInProgress.child;
                  workInProgress.child = null;
                } else {
                  tail = lastContentRow.sibling;
                  lastContentRow.sibling = null;
                }

                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode);
                break;
              }

            case 'backwards':
              {
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;

                while (row !== null) {
                  var currentRow = row.alternate;

                  if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                    workInProgress.child = row;
                    break;
                  }

                  var nextRow = row.sibling;
                  row.sibling = _tail;
                  _tail = row;
                  row = nextRow;
                }

                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode);
                break;
              }

            case 'together':
              {
                initSuspenseListRenderState(workInProgress, false, null, null, undefined);
                break;
              }

            default:
              {
                workInProgress.memoizedState = null;
              }
          }
        }

        return workInProgress.child;
      }

      function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;

        if (current === null) {
          workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        } else {
          reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }

        return workInProgress.child;
      }

      var hasWarnedAboutUsingNoValuePropOnContextProvider = false;

      function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        {
          if (!('value' in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
              hasWarnedAboutUsingNoValuePropOnContextProvider = true;
              error('The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?');
            }
          }

          var providerPropTypes = workInProgress.type.propTypes;

          if (providerPropTypes) {
            checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider');
          }
        }
        pushProvider(workInProgress, context, newValue);
        {
          if (oldProps !== null) {
            var oldValue = oldProps.value;

            if (objectIs(oldValue, newValue)) {
              if (oldProps.children === newProps.children && !hasContextChanged()) {
                return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
              }
            } else {
              propagateContextChange(workInProgress, context, renderLanes);
            }
          }
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
      }

      var hasWarnedAboutUsingContextAsConsumer = false;

      function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type;
        {
          if (context._context === undefined) {
            if (context !== context.Consumer) {
              if (!hasWarnedAboutUsingContextAsConsumer) {
                hasWarnedAboutUsingContextAsConsumer = true;
                error('Rendering <Context> directly is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
              }
            }
          } else {
            context = context._context;
          }
        }
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        {
          if (typeof render !== 'function') {
            error('A context consumer was rendered with multiple children, or a child ' + "that isn't a function. A context consumer expects a single child " + 'that is a function. If you did pass a function, make sure there ' + 'is no trailing or leading whitespace around it.');
          }
        }
        prepareToReadContext(workInProgress, renderLanes);

        var newValue = _readContext(context);

        {
          markComponentRenderStarted(workInProgress);
        }
        var newChildren;
        {
          ReactCurrentOwner$1.current = workInProgress;
          setIsRendering(true);
          newChildren = render(newValue);
          setIsRendering(false);
        }
        {
          markComponentRenderStopped();
        }
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
      }

      function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
      }

      function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) {
          workInProgress.dependencies = current.dependencies;
        }

        {
          stopProfilerTimerIfRunning();
        }
        markSkippedUpdateLanes(workInProgress.lanes);

        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) {
          {
            return null;
          }
        }

        cloneChildFibers(current, workInProgress);
        return workInProgress.child;
      }

      function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        {
          var returnFiber = oldWorkInProgress["return"];

          if (returnFiber === null) {
            throw new Error('Cannot swap the root fiber.');
          }

          current.alternate = null;
          oldWorkInProgress.alternate = null;
          newWorkInProgress.index = oldWorkInProgress.index;
          newWorkInProgress.sibling = oldWorkInProgress.sibling;
          newWorkInProgress["return"] = oldWorkInProgress["return"];
          newWorkInProgress.ref = oldWorkInProgress.ref;

          if (oldWorkInProgress === returnFiber.child) {
            returnFiber.child = newWorkInProgress;
          } else {
            var prevSibling = returnFiber.child;

            if (prevSibling === null) {
              throw new Error('Expected parent to have a child.');
            }

            while (prevSibling.sibling !== oldWorkInProgress) {
              prevSibling = prevSibling.sibling;

              if (prevSibling === null) {
                throw new Error('Expected to find the previous sibling.');
              }
            }

            prevSibling.sibling = newWorkInProgress;
          }

          var deletions = returnFiber.deletions;

          if (deletions === null) {
            returnFiber.deletions = [current];
            returnFiber.flags |= ChildDeletion;
          } else {
            deletions.push(current);
          }

          newWorkInProgress.flags |= Placement;
          return newWorkInProgress;
        }
      }

      function checkScheduledUpdateOrContext(current, renderLanes) {
        var updateLanes = current.lanes;

        if (includesSomeLane(updateLanes, renderLanes)) {
          return true;
        }

        return false;
      }

      function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        switch (workInProgress.tag) {
          case HostRoot:
            pushHostRootContext(workInProgress);
            resetHydrationState();
            break;

          case HostComponent:
            pushHostContext(workInProgress);
            break;

          case ClassComponent:
            {
              var Component = workInProgress.type;

              if (isContextProvider(Component)) {
                pushContextProvider(workInProgress);
              }

              break;
            }

          case HostPortal:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;

          case ContextProvider:
            {
              var newValue = workInProgress.memoizedProps.value;
              var context = workInProgress.type._context;
              pushProvider(workInProgress, context, newValue);
              break;
            }

          case Profiler:
            {
              var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);

              if (hasChildWork) {
                workInProgress.flags |= Update;
              }

              {
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
              }
            }
            break;

          case SuspenseComponent:
            {
              var state = workInProgress.memoizedState;

              if (state !== null) {
                if (state.dehydrated !== null) {
                  pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                  workInProgress.flags |= DidCapture;
                  return null;
                }

                var primaryChildFragment = workInProgress.child;
                var primaryChildLanes = primaryChildFragment.childLanes;

                if (includesSomeLane(renderLanes, primaryChildLanes)) {
                  return updateSuspenseComponent(current, workInProgress, renderLanes);
                } else {
                  pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                  var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);

                  if (child !== null) {
                    return child.sibling;
                  } else {
                    return null;
                  }
                }
              } else {
                pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
              }

              break;
            }

          case SuspenseListComponent:
            {
              var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;

              var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);

              if (didSuspendBefore) {
                if (_hasChildWork) {
                  return updateSuspenseListComponent(current, workInProgress, renderLanes);
                }

                workInProgress.flags |= DidCapture;
              }

              var renderState = workInProgress.memoizedState;

              if (renderState !== null) {
                renderState.rendering = null;
                renderState.tail = null;
                renderState.lastEffect = null;
              }

              pushSuspenseContext(workInProgress, suspenseStackCursor.current);

              if (_hasChildWork) {
                break;
              } else {
                return null;
              }
            }

          case OffscreenComponent:
          case LegacyHiddenComponent:
            {
              workInProgress.lanes = NoLanes;
              return updateOffscreenComponent(current, workInProgress, renderLanes);
            }
        }

        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
      }

      function beginWork(current, workInProgress, renderLanes) {
        {
          if (workInProgress._debugNeedsRemount && current !== null) {
            return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
          }
        }

        if (current !== null) {
          var oldProps = current.memoizedProps;
          var newProps = workInProgress.pendingProps;

          if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) {
            didReceiveUpdate = true;
          } else {
            var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);

            if (!hasScheduledUpdateOrContext && (workInProgress.flags & DidCapture) === NoFlags) {
              didReceiveUpdate = false;
              return attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            }

            if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
              didReceiveUpdate = true;
            } else {
              didReceiveUpdate = false;
            }
          }
        } else {
          didReceiveUpdate = false;

          if (getIsHydrating() && isForkedChild(workInProgress)) {
            var slotIndex = workInProgress.index;
            var numberOfForks = getForksAtLevel();
            pushTreeId(workInProgress, numberOfForks, slotIndex);
          }
        }

        workInProgress.lanes = NoLanes;

        switch (workInProgress.tag) {
          case IndeterminateComponent:
            {
              return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            }

          case LazyComponent:
            {
              var elementType = workInProgress.elementType;
              return mountLazyComponent(current, workInProgress, elementType, renderLanes);
            }

          case FunctionComponent:
            {
              var Component = workInProgress.type;
              var unresolvedProps = workInProgress.pendingProps;
              var resolvedProps = workInProgress.elementType === Component ? unresolvedProps : resolveDefaultProps(Component, unresolvedProps);
              return updateFunctionComponent(current, workInProgress, Component, resolvedProps, renderLanes);
            }

          case ClassComponent:
            {
              var _Component = workInProgress.type;
              var _unresolvedProps = workInProgress.pendingProps;

              var _resolvedProps = workInProgress.elementType === _Component ? _unresolvedProps : resolveDefaultProps(_Component, _unresolvedProps);

              return updateClassComponent(current, workInProgress, _Component, _resolvedProps, renderLanes);
            }

          case HostRoot:
            return updateHostRoot(current, workInProgress, renderLanes);

          case HostComponent:
            return updateHostComponent$1(current, workInProgress, renderLanes);

          case HostText:
            return updateHostText$1(current, workInProgress);

          case SuspenseComponent:
            return updateSuspenseComponent(current, workInProgress, renderLanes);

          case HostPortal:
            return updatePortalComponent(current, workInProgress, renderLanes);

          case ForwardRef:
            {
              var type = workInProgress.type;
              var _unresolvedProps2 = workInProgress.pendingProps;

              var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);

              return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            }

          case Fragment:
            return updateFragment(current, workInProgress, renderLanes);

          case Mode:
            return updateMode(current, workInProgress, renderLanes);

          case Profiler:
            return updateProfiler(current, workInProgress, renderLanes);

          case ContextProvider:
            return updateContextProvider(current, workInProgress, renderLanes);

          case ContextConsumer:
            return updateContextConsumer(current, workInProgress, renderLanes);

          case MemoComponent:
            {
              var _type2 = workInProgress.type;
              var _unresolvedProps3 = workInProgress.pendingProps;

              var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);

              {
                if (workInProgress.type !== workInProgress.elementType) {
                  var outerPropTypes = _type2.propTypes;

                  if (outerPropTypes) {
                    checkPropTypes(outerPropTypes, _resolvedProps3, 'prop', getComponentNameFromType(_type2));
                  }
                }
              }
              _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
              return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, renderLanes);
            }

          case SimpleMemoComponent:
            {
              return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            }

          case IncompleteClassComponent:
            {
              var _Component2 = workInProgress.type;
              var _unresolvedProps4 = workInProgress.pendingProps;

              var _resolvedProps4 = workInProgress.elementType === _Component2 ? _unresolvedProps4 : resolveDefaultProps(_Component2, _unresolvedProps4);

              return mountIncompleteClassComponent(current, workInProgress, _Component2, _resolvedProps4, renderLanes);
            }

          case SuspenseListComponent:
            {
              return updateSuspenseListComponent(current, workInProgress, renderLanes);
            }

          case ScopeComponent:
            {
              break;
            }

          case OffscreenComponent:
            {
              return updateOffscreenComponent(current, workInProgress, renderLanes);
            }
        }

        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + 'React. Please file an issue.');
      }

      function unwindWork(current, workInProgress, renderLanes) {
        popTreeContext(workInProgress);

        switch (workInProgress.tag) {
          case ClassComponent:
            {
              var Component = workInProgress.type;

              if (isContextProvider(Component)) {
                popContext(workInProgress);
              }

              var flags = workInProgress.flags;

              if (flags & ShouldCapture) {
                workInProgress.flags = flags & ~ShouldCapture | DidCapture;

                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                  transferActualDuration(workInProgress);
                }

                return workInProgress;
              }

              return null;
            }

          case HostRoot:
            {
              popHostContainer(workInProgress);
              popTopLevelContextObject(workInProgress);
              resetWorkInProgressVersions();
              var _flags = workInProgress.flags;

              if ((_flags & ShouldCapture) !== NoFlags && (_flags & DidCapture) === NoFlags) {
                workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                return workInProgress;
              }

              return null;
            }

          case HostComponent:
            {
              popHostContext(workInProgress);
              return null;
            }

          case SuspenseComponent:
            {
              popSuspenseContext(workInProgress);
              var suspenseState = workInProgress.memoizedState;

              if (suspenseState !== null && suspenseState.dehydrated !== null) {
                if (workInProgress.alternate === null) {
                  throw new Error('Threw in newly mounted dehydrated component. This is likely a bug in ' + 'React. Please file an issue.');
                }

                resetHydrationState();
              }

              var _flags2 = workInProgress.flags;

              if (_flags2 & ShouldCapture) {
                workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture;

                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                  transferActualDuration(workInProgress);
                }

                return workInProgress;
              }

              return null;
            }

          case SuspenseListComponent:
            {
              popSuspenseContext(workInProgress);
              return null;
            }

          case HostPortal:
            popHostContainer(workInProgress);
            return null;

          case ContextProvider:
            var context = workInProgress.type._context;
            popProvider(context, workInProgress);
            return null;

          case OffscreenComponent:
          case LegacyHiddenComponent:
            popRenderLanes(workInProgress);
            return null;

          case CacheComponent:
            return null;

          default:
            return null;
        }
      }

      function unwindInterruptedWork(current, interruptedWork, renderLanes) {
        popTreeContext(interruptedWork);

        switch (interruptedWork.tag) {
          case ClassComponent:
            {
              var childContextTypes = interruptedWork.type.childContextTypes;

              if (childContextTypes !== null && childContextTypes !== undefined) {
                popContext(interruptedWork);
              }

              break;
            }

          case HostRoot:
            {
              popHostContainer(interruptedWork);
              popTopLevelContextObject(interruptedWork);
              resetWorkInProgressVersions();
              break;
            }

          case HostComponent:
            {
              popHostContext(interruptedWork);
              break;
            }

          case HostPortal:
            popHostContainer(interruptedWork);
            break;

          case SuspenseComponent:
            popSuspenseContext(interruptedWork);
            break;

          case SuspenseListComponent:
            popSuspenseContext(interruptedWork);
            break;

          case ContextProvider:
            var context = interruptedWork.type._context;
            popProvider(context, interruptedWork);
            break;

          case OffscreenComponent:
          case LegacyHiddenComponent:
            popRenderLanes(interruptedWork);
            break;
        }
      }

      var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
      {
        didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
      }
      var offscreenSubtreeIsHidden = false;
      var offscreenSubtreeWasHidden = false;
      var PossiblyWeakSet = typeof WeakSet === 'function' ? WeakSet : Set;
      var nextEffect = null;
      var inProgressLanes = null;
      var inProgressRoot = null;

      function reportUncaughtErrorInDEV(error) {
        {
          invokeGuardedCallback(null, function () {
            throw error;
          });
          clearCaughtError();
        }
      }

      var callComponentWillUnmountWithTimer = function callComponentWillUnmountWithTimer(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;

        if (current.mode & ProfileMode) {
          try {
            startLayoutEffectTimer();
            instance.componentWillUnmount();
          } finally {
            recordLayoutEffectDuration(current);
          }
        } else {
          instance.componentWillUnmount();
        }
      };

      function safelyCallCommitHookLayoutEffectListMount(current, nearestMountedAncestor) {
        try {
          commitHookEffectListMount(Layout, current);
        } catch (error) {
          captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
      }

      function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        try {
          callComponentWillUnmountWithTimer(current, instance);
        } catch (error) {
          captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
      }

      function safelyCallComponentDidMount(current, nearestMountedAncestor, instance) {
        try {
          instance.componentDidMount();
        } catch (error) {
          captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
      }

      function safelyAttachRef(current, nearestMountedAncestor) {
        try {
          commitAttachRef(current);
        } catch (error) {
          captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
      }

      function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref;

        if (ref !== null) {
          if (typeof ref === 'function') {
            var retVal;

            try {
              if (enableProfilerTimer && enableProfilerCommitHooks && current.mode & ProfileMode) {
                try {
                  startLayoutEffectTimer();
                  retVal = ref(null);
                } finally {
                  recordLayoutEffectDuration(current);
                }
              } else {
                retVal = ref(null);
              }
            } catch (error) {
              captureCommitPhaseError(current, nearestMountedAncestor, error);
            }

            {
              if (typeof retVal === 'function') {
                error('Unexpected return value from a callback ref in %s. ' + 'A callback ref should not return a function.', getComponentNameFromFiber(current));
              }
            }
          } else {
            ref.current = null;
          }
        }
      }

      function safelyCallDestroy(current, nearestMountedAncestor, destroy) {
        try {
          destroy();
        } catch (error) {
          captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
      }

      var focusedInstanceHandle = null;
      var shouldFireAfterActiveInstanceBlur = false;

      function commitBeforeMutationEffects(root, firstChild) {
        focusedInstanceHandle = prepareForCommit();
        nextEffect = firstChild;
        commitBeforeMutationEffects_begin();
        var shouldFire = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = false;
        focusedInstanceHandle = null;
        return shouldFire;
      }

      function commitBeforeMutationEffects_begin() {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var child = fiber.child;

          if ((fiber.subtreeFlags & BeforeMutationMask) !== NoFlags && child !== null) {
            child["return"] = fiber;
            nextEffect = child;
          } else {
            commitBeforeMutationEffects_complete();
          }
        }
      }

      function commitBeforeMutationEffects_complete() {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          setCurrentFiber(fiber);

          try {
            commitBeforeMutationEffectsOnFiber(fiber);
          } catch (error) {
            captureCommitPhaseError(fiber, fiber["return"], error);
          }

          resetCurrentFiber();
          var sibling = fiber.sibling;

          if (sibling !== null) {
            sibling["return"] = fiber["return"];
            nextEffect = sibling;
            return;
          }

          nextEffect = fiber["return"];
        }
      }

      function commitBeforeMutationEffectsOnFiber(finishedWork) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;

        if ((flags & Snapshot) !== NoFlags) {
          setCurrentFiber(finishedWork);

          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
              {
                break;
              }

            case ClassComponent:
              {
                if (current !== null) {
                  var prevProps = current.memoizedProps;
                  var prevState = current.memoizedState;
                  var instance = finishedWork.stateNode;
                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error('Expected %s props to match memoized props before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentNameFromFiber(finishedWork) || 'instance');
                      }

                      if (instance.state !== finishedWork.memoizedState) {
                        error('Expected %s state to match memoized state before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentNameFromFiber(finishedWork) || 'instance');
                      }
                    }
                  }
                  var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                  {
                    var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;

                    if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                      didWarnSet.add(finishedWork.type);
                      error('%s.getSnapshotBeforeUpdate(): A snapshot value (or null) ' + 'must be returned. You have returned undefined.', getComponentNameFromFiber(finishedWork));
                    }
                  }
                  instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                }

                break;
              }

            case HostRoot:
              {
                {
                  var root = finishedWork.stateNode;
                  clearContainer(root.containerInfo);
                }
                break;
              }

            case HostComponent:
            case HostText:
            case HostPortal:
            case IncompleteClassComponent:
              break;

            default:
              {
                throw new Error('This unit of work tag should not have side-effects. This error is ' + 'likely caused by a bug in React. Please file an issue.');
              }
          }

          resetCurrentFiber();
        }
      }

      function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;

        if (lastEffect !== null) {
          var firstEffect = lastEffect.next;
          var effect = firstEffect;

          do {
            if ((effect.tag & flags) === flags) {
              var destroy = effect.destroy;
              effect.destroy = undefined;

              if (destroy !== undefined) {
                {
                  if ((flags & Passive$1) !== NoFlags$1) {
                    markComponentPassiveEffectUnmountStarted(finishedWork);
                  } else if ((flags & Layout) !== NoFlags$1) {
                    markComponentLayoutEffectUnmountStarted(finishedWork);
                  }
                }
                {
                  if ((flags & Insertion) !== NoFlags$1) {
                    setIsRunningInsertionEffect(true);
                  }
                }
                safelyCallDestroy(finishedWork, nearestMountedAncestor, destroy);
                {
                  if ((flags & Insertion) !== NoFlags$1) {
                    setIsRunningInsertionEffect(false);
                  }
                }
                {
                  if ((flags & Passive$1) !== NoFlags$1) {
                    markComponentPassiveEffectUnmountStopped();
                  } else if ((flags & Layout) !== NoFlags$1) {
                    markComponentLayoutEffectUnmountStopped();
                  }
                }
              }
            }

            effect = effect.next;
          } while (effect !== firstEffect);
        }
      }

      function commitHookEffectListMount(flags, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;

        if (lastEffect !== null) {
          var firstEffect = lastEffect.next;
          var effect = firstEffect;

          do {
            if ((effect.tag & flags) === flags) {
              {
                if ((flags & Passive$1) !== NoFlags$1) {
                  markComponentPassiveEffectMountStarted(finishedWork);
                } else if ((flags & Layout) !== NoFlags$1) {
                  markComponentLayoutEffectMountStarted(finishedWork);
                }
              }
              var create = effect.create;
              {
                if ((flags & Insertion) !== NoFlags$1) {
                  setIsRunningInsertionEffect(true);
                }
              }
              effect.destroy = create();
              {
                if ((flags & Insertion) !== NoFlags$1) {
                  setIsRunningInsertionEffect(false);
                }
              }
              {
                if ((flags & Passive$1) !== NoFlags$1) {
                  markComponentPassiveEffectMountStopped();
                } else if ((flags & Layout) !== NoFlags$1) {
                  markComponentLayoutEffectMountStopped();
                }
              }
              {
                var destroy = effect.destroy;

                if (destroy !== undefined && typeof destroy !== 'function') {
                  var hookName = void 0;

                  if ((effect.tag & Layout) !== NoFlags) {
                    hookName = 'useLayoutEffect';
                  } else if ((effect.tag & Insertion) !== NoFlags) {
                    hookName = 'useInsertionEffect';
                  } else {
                    hookName = 'useEffect';
                  }

                  var addendum = void 0;

                  if (destroy === null) {
                    addendum = ' You returned null. If your effect does not require clean ' + 'up, return undefined (or nothing).';
                  } else if (typeof destroy.then === 'function') {
                    addendum = '\n\nIt looks like you wrote ' + hookName + '(async () => ...) or returned a Promise. ' + 'Instead, write the async function inside your effect ' + 'and call it immediately:\n\n' + hookName + '(() => {\n' + '  async function fetchData() {\n' + '    // You can await here\n' + '    const response = await MyAPI.getData(someId);\n' + '    // ...\n' + '  }\n' + '  fetchData();\n' + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + 'Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching';
                  } else {
                    addendum = ' You returned: ' + destroy;
                  }

                  error('%s must not return anything besides a function, ' + 'which is used for clean-up.%s', hookName, addendum);
                }
              }
            }

            effect = effect.next;
          } while (effect !== firstEffect);
        }
      }

      function commitPassiveEffectDurations(finishedRoot, finishedWork) {
        {
          if ((finishedWork.flags & Update) !== NoFlags) {
            switch (finishedWork.tag) {
              case Profiler:
                {
                  var passiveEffectDuration = finishedWork.stateNode.passiveEffectDuration;
                  var _finishedWork$memoize = finishedWork.memoizedProps,
                      id = _finishedWork$memoize.id,
                      onPostCommit = _finishedWork$memoize.onPostCommit;
                  var commitTime = getCommitTime();
                  var phase = finishedWork.alternate === null ? 'mount' : 'update';
                  {
                    if (isCurrentUpdateNested()) {
                      phase = 'nested-update';
                    }
                  }

                  if (typeof onPostCommit === 'function') {
                    onPostCommit(id, phase, passiveEffectDuration, commitTime);
                  }

                  var parentFiber = finishedWork["return"];

                  outer: while (parentFiber !== null) {
                    switch (parentFiber.tag) {
                      case HostRoot:
                        var root = parentFiber.stateNode;
                        root.passiveEffectDuration += passiveEffectDuration;
                        break outer;

                      case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        parentStateNode.passiveEffectDuration += passiveEffectDuration;
                        break outer;
                    }

                    parentFiber = parentFiber["return"];
                  }

                  break;
                }
            }
          }
        }
      }

      function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork, committedLanes) {
        if ((finishedWork.flags & LayoutMask) !== NoFlags) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
              {
                if (!offscreenSubtreeWasHidden) {
                  if (finishedWork.mode & ProfileMode) {
                    try {
                      startLayoutEffectTimer();
                      commitHookEffectListMount(Layout | HasEffect, finishedWork);
                    } finally {
                      recordLayoutEffectDuration(finishedWork);
                    }
                  } else {
                    commitHookEffectListMount(Layout | HasEffect, finishedWork);
                  }
                }

                break;
              }

            case ClassComponent:
              {
                var instance = finishedWork.stateNode;

                if (finishedWork.flags & Update) {
                  if (!offscreenSubtreeWasHidden) {
                    if (current === null) {
                      {
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                          if (instance.props !== finishedWork.memoizedProps) {
                            error('Expected %s props to match memoized props before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentNameFromFiber(finishedWork) || 'instance');
                          }

                          if (instance.state !== finishedWork.memoizedState) {
                            error('Expected %s state to match memoized state before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentNameFromFiber(finishedWork) || 'instance');
                          }
                        }
                      }

                      if (finishedWork.mode & ProfileMode) {
                        try {
                          startLayoutEffectTimer();
                          instance.componentDidMount();
                        } finally {
                          recordLayoutEffectDuration(finishedWork);
                        }
                      } else {
                        instance.componentDidMount();
                      }
                    } else {
                      var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                      var prevState = current.memoizedState;
                      {
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                          if (instance.props !== finishedWork.memoizedProps) {
                            error('Expected %s props to match memoized props before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentNameFromFiber(finishedWork) || 'instance');
                          }

                          if (instance.state !== finishedWork.memoizedState) {
                            error('Expected %s state to match memoized state before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentNameFromFiber(finishedWork) || 'instance');
                          }
                        }
                      }

                      if (finishedWork.mode & ProfileMode) {
                        try {
                          startLayoutEffectTimer();
                          instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        } finally {
                          recordLayoutEffectDuration(finishedWork);
                        }
                      } else {
                        instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                      }
                    }
                  }
                }

                var updateQueue = finishedWork.updateQueue;

                if (updateQueue !== null) {
                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error('Expected %s props to match memoized props before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentNameFromFiber(finishedWork) || 'instance');
                      }

                      if (instance.state !== finishedWork.memoizedState) {
                        error('Expected %s state to match memoized state before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentNameFromFiber(finishedWork) || 'instance');
                      }
                    }
                  }
                  commitUpdateQueue(finishedWork, updateQueue, instance);
                }

                break;
              }

            case HostRoot:
              {
                var _updateQueue = finishedWork.updateQueue;

                if (_updateQueue !== null) {
                  var _instance = null;

                  if (finishedWork.child !== null) {
                    switch (finishedWork.child.tag) {
                      case HostComponent:
                        _instance = getPublicInstance(finishedWork.child.stateNode);
                        break;

                      case ClassComponent:
                        _instance = finishedWork.child.stateNode;
                        break;
                    }
                  }

                  commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }

                break;
              }

            case HostComponent:
              {
                var _instance2 = finishedWork.stateNode;

                if (current === null && finishedWork.flags & Update) {
                  var type = finishedWork.type;
                  var props = finishedWork.memoizedProps;
                  commitMount(_instance2, type, props);
                }

                break;
              }

            case HostText:
              {
                break;
              }

            case HostPortal:
              {
                break;
              }

            case Profiler:
              {
                {
                  var _finishedWork$memoize2 = finishedWork.memoizedProps,
                      onCommit = _finishedWork$memoize2.onCommit,
                      onRender = _finishedWork$memoize2.onRender;
                  var effectDuration = finishedWork.stateNode.effectDuration;
                  var commitTime = getCommitTime();
                  var phase = current === null ? 'mount' : 'update';
                  {
                    if (isCurrentUpdateNested()) {
                      phase = 'nested-update';
                    }
                  }

                  if (typeof onRender === 'function') {
                    onRender(finishedWork.memoizedProps.id, phase, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime);
                  }

                  {
                    if (typeof onCommit === 'function') {
                      onCommit(finishedWork.memoizedProps.id, phase, effectDuration, commitTime);
                    }

                    enqueuePendingPassiveProfilerEffect(finishedWork);
                    var parentFiber = finishedWork["return"];

                    outer: while (parentFiber !== null) {
                      switch (parentFiber.tag) {
                        case HostRoot:
                          var root = parentFiber.stateNode;
                          root.effectDuration += effectDuration;
                          break outer;

                        case Profiler:
                          var parentStateNode = parentFiber.stateNode;
                          parentStateNode.effectDuration += effectDuration;
                          break outer;
                      }

                      parentFiber = parentFiber["return"];
                    }
                  }
                }
                break;
              }

            case SuspenseComponent:
              {
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
              }

            case SuspenseListComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
              {
                break;
              }

            default:
              throw new Error('This unit of work tag should not have side-effects. This error is ' + 'likely caused by a bug in React. Please file an issue.');
          }
        }

        if (!offscreenSubtreeWasHidden) {
          {
            if (finishedWork.flags & Ref) {
              commitAttachRef(finishedWork);
            }
          }
        }
      }

      function reappearLayoutEffectsOnFiber(node) {
        switch (node.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent:
            {
              if (node.mode & ProfileMode) {
                try {
                  startLayoutEffectTimer();
                  safelyCallCommitHookLayoutEffectListMount(node, node["return"]);
                } finally {
                  recordLayoutEffectDuration(node);
                }
              } else {
                safelyCallCommitHookLayoutEffectListMount(node, node["return"]);
              }

              break;
            }

          case ClassComponent:
            {
              var instance = node.stateNode;

              if (typeof instance.componentDidMount === 'function') {
                safelyCallComponentDidMount(node, node["return"], instance);
              }

              safelyAttachRef(node, node["return"]);
              break;
            }

          case HostComponent:
            {
              safelyAttachRef(node, node["return"]);
              break;
            }
        }
      }

      function hideOrUnhideAllChildren(finishedWork, isHidden) {
        var hostSubtreeRoot = null;
        {
          var node = finishedWork;

          while (true) {
            if (node.tag === HostComponent) {
              if (hostSubtreeRoot === null) {
                hostSubtreeRoot = node;

                try {
                  var instance = node.stateNode;

                  if (isHidden) {
                    hideInstance(instance);
                  } else {
                    unhideInstance(node.stateNode, node.memoizedProps);
                  }
                } catch (error) {
                  captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                }
              }
            } else if (node.tag === HostText) {
              if (hostSubtreeRoot === null) {
                try {
                  var _instance3 = node.stateNode;

                  if (isHidden) {
                    hideTextInstance(_instance3);
                  } else {
                    unhideTextInstance(_instance3, node.memoizedProps);
                  }
                } catch (error) {
                  captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                }
              }
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;else if (node.child !== null) {
              node.child["return"] = node;
              node = node.child;
              continue;
            }

            if (node === finishedWork) {
              return;
            }

            while (node.sibling === null) {
              if (node["return"] === null || node["return"] === finishedWork) {
                return;
              }

              if (hostSubtreeRoot === node) {
                hostSubtreeRoot = null;
              }

              node = node["return"];
            }

            if (hostSubtreeRoot === node) {
              hostSubtreeRoot = null;
            }

            node.sibling["return"] = node["return"];
            node = node.sibling;
          }
        }
      }

      function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;

        if (ref !== null) {
          var instance = finishedWork.stateNode;
          var instanceToUse;

          switch (finishedWork.tag) {
            case HostComponent:
              instanceToUse = getPublicInstance(instance);
              break;

            default:
              instanceToUse = instance;
          }

          if (typeof ref === 'function') {
            var retVal;

            if (finishedWork.mode & ProfileMode) {
              try {
                startLayoutEffectTimer();
                retVal = ref(instanceToUse);
              } finally {
                recordLayoutEffectDuration(finishedWork);
              }
            } else {
              retVal = ref(instanceToUse);
            }

            {
              if (typeof retVal === 'function') {
                error('Unexpected return value from a callback ref in %s. ' + 'A callback ref should not return a function.', getComponentNameFromFiber(finishedWork));
              }
            }
          } else {
            {
              if (!ref.hasOwnProperty('current')) {
                error('Unexpected ref object provided for %s. ' + 'Use either a ref-setter function or React.createRef().', getComponentNameFromFiber(finishedWork));
              }
            }
            ref.current = instanceToUse;
          }
        }
      }

      function detachFiberMutation(fiber) {
        var alternate = fiber.alternate;

        if (alternate !== null) {
          alternate["return"] = null;
        }

        fiber["return"] = null;
      }

      function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;

        if (alternate !== null) {
          fiber.alternate = null;
          detachFiberAfterEffects(alternate);
        }

        {
          fiber.child = null;
          fiber.deletions = null;
          fiber.sibling = null;

          if (fiber.tag === HostComponent) {
            var hostInstance = fiber.stateNode;

            if (hostInstance !== null) {
              detachDeletedInstance(hostInstance);
            }
          }

          fiber.stateNode = null;
          {
            fiber._debugOwner = null;
          }
          {
            fiber["return"] = null;
            fiber.dependencies = null;
            fiber.memoizedProps = null;
            fiber.memoizedState = null;
            fiber.pendingProps = null;
            fiber.stateNode = null;
            fiber.updateQueue = null;
          }
        }
      }

      function getHostParentFiber(fiber) {
        var parent = fiber["return"];

        while (parent !== null) {
          if (isHostParent(parent)) {
            return parent;
          }

          parent = parent["return"];
        }

        throw new Error('Expected to find a host parent. This error is likely caused by a bug ' + 'in React. Please file an issue.');
      }

      function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
      }

      function getHostSibling(fiber) {
        var node = fiber;

        siblings: while (true) {
          while (node.sibling === null) {
            if (node["return"] === null || isHostParent(node["return"])) {
              return null;
            }

            node = node["return"];
          }

          node.sibling["return"] = node["return"];
          node = node.sibling;

          while (node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment) {
            if (node.flags & Placement) {
              continue siblings;
            }

            if (node.child === null || node.tag === HostPortal) {
              continue siblings;
            } else {
              node.child["return"] = node;
              node = node.child;
            }
          }

          if (!(node.flags & Placement)) {
            return node.stateNode;
          }
        }
      }

      function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork);

        switch (parentFiber.tag) {
          case HostComponent:
            {
              var parent = parentFiber.stateNode;

              if (parentFiber.flags & ContentReset) {
                resetTextContent(parent);
                parentFiber.flags &= ~ContentReset;
              }

              var before = getHostSibling(finishedWork);
              insertOrAppendPlacementNode(finishedWork, before, parent);
              break;
            }

          case HostRoot:
          case HostPortal:
            {
              var _parent = parentFiber.stateNode.containerInfo;

              var _before = getHostSibling(finishedWork);

              insertOrAppendPlacementNodeIntoContainer(finishedWork, _before, _parent);
              break;
            }

          default:
            throw new Error('Invalid host parent fiber. This error is likely caused by a bug ' + 'in React. Please file an issue.');
        }
      }

      function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;

        if (isHost) {
          var stateNode = node.stateNode;

          if (before) {
            insertInContainerBefore(parent, stateNode, before);
          } else {
            appendChildToContainer(parent, stateNode);
          }
        } else if (tag === HostPortal) ;else {
          var child = node.child;

          if (child !== null) {
            insertOrAppendPlacementNodeIntoContainer(child, before, parent);
            var sibling = child.sibling;

            while (sibling !== null) {
              insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
              sibling = sibling.sibling;
            }
          }
        }
      }

      function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;

        if (isHost) {
          var stateNode = node.stateNode;

          if (before) {
            insertBefore(parent, stateNode, before);
          } else {
            appendChild(parent, stateNode);
          }
        } else if (tag === HostPortal) ;else {
          var child = node.child;

          if (child !== null) {
            insertOrAppendPlacementNode(child, before, parent);
            var sibling = child.sibling;

            while (sibling !== null) {
              insertOrAppendPlacementNode(sibling, before, parent);
              sibling = sibling.sibling;
            }
          }
        }
      }

      var hostParent = null;
      var hostParentIsContainer = false;

      function commitDeletionEffects(root, returnFiber, deletedFiber) {
        {
          var parent = returnFiber;

          findParent: while (parent !== null) {
            switch (parent.tag) {
              case HostComponent:
                {
                  hostParent = parent.stateNode;
                  hostParentIsContainer = false;
                  break findParent;
                }

              case HostRoot:
                {
                  hostParent = parent.stateNode.containerInfo;
                  hostParentIsContainer = true;
                  break findParent;
                }

              case HostPortal:
                {
                  hostParent = parent.stateNode.containerInfo;
                  hostParentIsContainer = true;
                  break findParent;
                }
            }

            parent = parent["return"];
          }

          if (hostParent === null) {
            throw new Error('Expected to find a host parent. This error is likely caused by ' + 'a bug in React. Please file an issue.');
          }

          commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
          hostParent = null;
          hostParentIsContainer = false;
        }
        detachFiberMutation(deletedFiber);
      }

      function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        var child = parent.child;

        while (child !== null) {
          commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, child);
          child = child.sibling;
        }
      }

      function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        onCommitUnmount(deletedFiber);

        switch (deletedFiber.tag) {
          case HostComponent:
            {
              if (!offscreenSubtreeWasHidden) {
                safelyDetachRef(deletedFiber, nearestMountedAncestor);
              }
            }

          case HostText:
            {
              {
                var prevHostParent = hostParent;
                var prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;

                if (hostParent !== null) {
                  if (hostParentIsContainer) {
                    removeChildFromContainer(hostParent, deletedFiber.stateNode);
                  } else {
                    removeChild(hostParent, deletedFiber.stateNode);
                  }
                }
              }
              return;
            }

          case DehydratedFragment:
            {
              {
                if (hostParent !== null) {
                  if (hostParentIsContainer) {
                    clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode);
                  } else {
                    clearSuspenseBoundary(hostParent, deletedFiber.stateNode);
                  }
                }
              }
              return;
            }

          case HostPortal:
            {
              {
                var _prevHostParent = hostParent;
                var _prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = true;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = _prevHostParent;
                hostParentIsContainer = _prevHostParentIsContainer;
              }
              return;
            }

          case FunctionComponent:
          case ForwardRef:
          case MemoComponent:
          case SimpleMemoComponent:
            {
              if (!offscreenSubtreeWasHidden) {
                var updateQueue = deletedFiber.updateQueue;

                if (updateQueue !== null) {
                  var lastEffect = updateQueue.lastEffect;

                  if (lastEffect !== null) {
                    var firstEffect = lastEffect.next;
                    var effect = firstEffect;

                    do {
                      var _effect = effect,
                          destroy = _effect.destroy,
                          tag = _effect.tag;

                      if (destroy !== undefined) {
                        if ((tag & Insertion) !== NoFlags$1) {
                          safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                        } else if ((tag & Layout) !== NoFlags$1) {
                          {
                            markComponentLayoutEffectUnmountStarted(deletedFiber);
                          }

                          if (deletedFiber.mode & ProfileMode) {
                            startLayoutEffectTimer();
                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                            recordLayoutEffectDuration(deletedFiber);
                          } else {
                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                          }

                          {
                            markComponentLayoutEffectUnmountStopped();
                          }
                        }
                      }

                      effect = effect.next;
                    } while (effect !== firstEffect);
                  }
                }
              }

              recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
              return;
            }

          case ClassComponent:
            {
              if (!offscreenSubtreeWasHidden) {
                safelyDetachRef(deletedFiber, nearestMountedAncestor);
                var instance = deletedFiber.stateNode;

                if (typeof instance.componentWillUnmount === 'function') {
                  safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, instance);
                }
              }

              recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
              return;
            }

          case ScopeComponent:
            {
              recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
              return;
            }

          case OffscreenComponent:
            {
              if (deletedFiber.mode & ConcurrentMode) {
                var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || deletedFiber.memoizedState !== null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
              } else {
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
              }

              break;
            }

          default:
            {
              recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
              return;
            }
        }
      }

      function commitSuspenseCallback(finishedWork) {
      }

      function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;

        if (newState === null) {
          var current = finishedWork.alternate;

          if (current !== null) {
            var prevState = current.memoizedState;

            if (prevState !== null) {
              var suspenseInstance = prevState.dehydrated;

              if (suspenseInstance !== null) {
                commitHydratedSuspenseInstance(suspenseInstance);
              }
            }
          }
        }
      }

      function attachSuspenseRetryListeners(finishedWork) {
        var wakeables = finishedWork.updateQueue;

        if (wakeables !== null) {
          finishedWork.updateQueue = null;
          var retryCache = finishedWork.stateNode;

          if (retryCache === null) {
            retryCache = finishedWork.stateNode = new PossiblyWeakSet();
          }

          wakeables.forEach(function (wakeable) {
            var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);

            if (!retryCache.has(wakeable)) {
              retryCache.add(wakeable);
              {
                if (isDevToolsPresent) {
                  if (inProgressLanes !== null && inProgressRoot !== null) {
                    restorePendingUpdaters(inProgressRoot, inProgressLanes);
                  } else {
                    throw Error('Expected finished root and lanes to be set. This is a bug in React.');
                  }
                }
              }
              wakeable.then(retry, retry);
            }
          });
        }
      }

      function commitMutationEffects(root, finishedWork, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        setCurrentFiber(finishedWork);
        commitMutationEffectsOnFiber(finishedWork, root);
        setCurrentFiber(finishedWork);
        inProgressLanes = null;
        inProgressRoot = null;
      }

      function recursivelyTraverseMutationEffects(root, parentFiber, lanes) {
        var deletions = parentFiber.deletions;

        if (deletions !== null) {
          for (var i = 0; i < deletions.length; i++) {
            var childToDelete = deletions[i];

            try {
              commitDeletionEffects(root, parentFiber, childToDelete);
            } catch (error) {
              captureCommitPhaseError(childToDelete, parentFiber, error);
            }
          }
        }

        var prevDebugFiber = getCurrentFiber();

        if (parentFiber.subtreeFlags & MutationMask) {
          var child = parentFiber.child;

          while (child !== null) {
            setCurrentFiber(child);
            commitMutationEffectsOnFiber(child, root);
            child = child.sibling;
          }
        }

        setCurrentFiber(prevDebugFiber);
      }

      function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;

        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case MemoComponent:
          case SimpleMemoComponent:
            {
              recursivelyTraverseMutationEffects(root, finishedWork);
              commitReconciliationEffects(finishedWork);

              if (flags & Update) {
                try {
                  commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork["return"]);
                  commitHookEffectListMount(Insertion | HasEffect, finishedWork);
                } catch (error) {
                  captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                }

                if (finishedWork.mode & ProfileMode) {
                  try {
                    startLayoutEffectTimer();
                    commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork["return"]);
                  } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                  }

                  recordLayoutEffectDuration(finishedWork);
                } else {
                  try {
                    commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork["return"]);
                  } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                  }
                }
              }

              return;
            }

          case ClassComponent:
            {
              recursivelyTraverseMutationEffects(root, finishedWork);
              commitReconciliationEffects(finishedWork);

              if (flags & Ref) {
                if (current !== null) {
                  safelyDetachRef(current, current["return"]);
                }
              }

              return;
            }

          case HostComponent:
            {
              recursivelyTraverseMutationEffects(root, finishedWork);
              commitReconciliationEffects(finishedWork);

              if (flags & Ref) {
                if (current !== null) {
                  safelyDetachRef(current, current["return"]);
                }
              }

              {
                if (finishedWork.flags & ContentReset) {
                  var instance = finishedWork.stateNode;

                  try {
                    resetTextContent(instance);
                  } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                  }
                }

                if (flags & Update) {
                  var _instance4 = finishedWork.stateNode;

                  if (_instance4 != null) {
                    var newProps = finishedWork.memoizedProps;
                    var oldProps = current !== null ? current.memoizedProps : newProps;
                    var type = finishedWork.type;
                    var updatePayload = finishedWork.updateQueue;
                    finishedWork.updateQueue = null;

                    if (updatePayload !== null) {
                      try {
                        commitUpdate(_instance4, updatePayload, type, oldProps, newProps, finishedWork);
                      } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                      }
                    }
                  }
                }
              }
              return;
            }

          case HostText:
            {
              recursivelyTraverseMutationEffects(root, finishedWork);
              commitReconciliationEffects(finishedWork);

              if (flags & Update) {
                {
                  if (finishedWork.stateNode === null) {
                    throw new Error('This should have a text node initialized. This error is likely ' + 'caused by a bug in React. Please file an issue.');
                  }

                  var textInstance = finishedWork.stateNode;
                  var newText = finishedWork.memoizedProps;
                  var oldText = current !== null ? current.memoizedProps : newText;

                  try {
                    commitTextUpdate(textInstance, oldText, newText);
                  } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                  }
                }
              }

              return;
            }

          case HostRoot:
            {
              recursivelyTraverseMutationEffects(root, finishedWork);
              commitReconciliationEffects(finishedWork);

              if (flags & Update) {
                {
                  if (current !== null) {
                    var prevRootState = current.memoizedState;

                    if (prevRootState.isDehydrated) {
                      try {
                        commitHydratedContainer(root.containerInfo);
                      } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                      }
                    }
                  }
                }
              }

              return;
            }

          case HostPortal:
            {
              recursivelyTraverseMutationEffects(root, finishedWork);
              commitReconciliationEffects(finishedWork);
              return;
            }

          case SuspenseComponent:
            {
              recursivelyTraverseMutationEffects(root, finishedWork);
              commitReconciliationEffects(finishedWork);
              var offscreenFiber = finishedWork.child;

              if (offscreenFiber.flags & Visibility) {
                var newState = offscreenFiber.memoizedState;
                var isHidden = newState !== null;

                if (isHidden) {
                  var wasHidden = offscreenFiber.alternate !== null && offscreenFiber.alternate.memoizedState !== null;

                  if (!wasHidden) {
                    markCommitTimeOfFallback();
                  }
                }
              }

              if (flags & Update) {
                try {
                  commitSuspenseCallback(finishedWork);
                } catch (error) {
                  captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                }

                attachSuspenseRetryListeners(finishedWork);
              }

              return;
            }

          case OffscreenComponent:
            {
              var _wasHidden = current !== null && current.memoizedState !== null;

              if (finishedWork.mode & ConcurrentMode) {
                var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _wasHidden;
                recursivelyTraverseMutationEffects(root, finishedWork);
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
              } else {
                recursivelyTraverseMutationEffects(root, finishedWork);
              }

              commitReconciliationEffects(finishedWork);

              if (flags & Visibility) {
                var _newState = finishedWork.memoizedState;

                var _isHidden = _newState !== null;

                var offscreenBoundary = finishedWork;
                {
                  hideOrUnhideAllChildren(offscreenBoundary, _isHidden);
                }
                {
                  if (_isHidden) {
                    if (!_wasHidden) {
                      if ((offscreenBoundary.mode & ConcurrentMode) !== NoMode) {
                        nextEffect = offscreenBoundary;
                        var offscreenChild = offscreenBoundary.child;

                        while (offscreenChild !== null) {
                          nextEffect = offscreenChild;
                          disappearLayoutEffects_begin(offscreenChild);
                          offscreenChild = offscreenChild.sibling;
                        }
                      }
                    }
                  }
                }
              }

              return;
            }

          case SuspenseListComponent:
            {
              recursivelyTraverseMutationEffects(root, finishedWork);
              commitReconciliationEffects(finishedWork);

              if (flags & Update) {
                attachSuspenseRetryListeners(finishedWork);
              }

              return;
            }

          case ScopeComponent:
            {
              return;
            }

          default:
            {
              recursivelyTraverseMutationEffects(root, finishedWork);
              commitReconciliationEffects(finishedWork);
              return;
            }
        }
      }

      function commitReconciliationEffects(finishedWork) {
        var flags = finishedWork.flags;

        if (flags & Placement) {
          try {
            commitPlacement(finishedWork);
          } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork["return"], error);
          }

          finishedWork.flags &= ~Placement;
        }

        if (flags & Hydrating) {
          finishedWork.flags &= ~Hydrating;
        }
      }

      function commitLayoutEffects(finishedWork, root, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        nextEffect = finishedWork;
        commitLayoutEffects_begin(finishedWork, root, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
      }

      function commitLayoutEffects_begin(subtreeRoot, root, committedLanes) {
        var isModernRoot = (subtreeRoot.mode & ConcurrentMode) !== NoMode;

        while (nextEffect !== null) {
          var fiber = nextEffect;
          var firstChild = fiber.child;

          if (fiber.tag === OffscreenComponent && isModernRoot) {
            var isHidden = fiber.memoizedState !== null;
            var newOffscreenSubtreeIsHidden = isHidden || offscreenSubtreeIsHidden;

            if (newOffscreenSubtreeIsHidden) {
              commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
              continue;
            } else {
              var current = fiber.alternate;
              var wasHidden = current !== null && current.memoizedState !== null;
              var newOffscreenSubtreeWasHidden = wasHidden || offscreenSubtreeWasHidden;
              var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden;
              var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
              offscreenSubtreeIsHidden = newOffscreenSubtreeIsHidden;
              offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden;

              if (offscreenSubtreeWasHidden && !prevOffscreenSubtreeWasHidden) {
                nextEffect = fiber;
                reappearLayoutEffects_begin(fiber);
              }

              var child = firstChild;

              while (child !== null) {
                nextEffect = child;
                commitLayoutEffects_begin(child, root, committedLanes);
                child = child.sibling;
              }

              nextEffect = fiber;
              offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
              offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
              commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
              continue;
            }
          }

          if ((fiber.subtreeFlags & LayoutMask) !== NoFlags && firstChild !== null) {
            firstChild["return"] = fiber;
            nextEffect = firstChild;
          } else {
            commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
          }
        }
      }

      function commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes) {
        while (nextEffect !== null) {
          var fiber = nextEffect;

          if ((fiber.flags & LayoutMask) !== NoFlags) {
            var current = fiber.alternate;
            setCurrentFiber(fiber);

            try {
              commitLayoutEffectOnFiber(root, current, fiber, committedLanes);
            } catch (error) {
              captureCommitPhaseError(fiber, fiber["return"], error);
            }

            resetCurrentFiber();
          }

          if (fiber === subtreeRoot) {
            nextEffect = null;
            return;
          }

          var sibling = fiber.sibling;

          if (sibling !== null) {
            sibling["return"] = fiber["return"];
            nextEffect = sibling;
            return;
          }

          nextEffect = fiber["return"];
        }
      }

      function disappearLayoutEffects_begin(subtreeRoot) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var firstChild = fiber.child;

          switch (fiber.tag) {
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
              {
                if (fiber.mode & ProfileMode) {
                  try {
                    startLayoutEffectTimer();
                    commitHookEffectListUnmount(Layout, fiber, fiber["return"]);
                  } finally {
                    recordLayoutEffectDuration(fiber);
                  }
                } else {
                  commitHookEffectListUnmount(Layout, fiber, fiber["return"]);
                }

                break;
              }

            case ClassComponent:
              {
                safelyDetachRef(fiber, fiber["return"]);
                var instance = fiber.stateNode;

                if (typeof instance.componentWillUnmount === 'function') {
                  safelyCallComponentWillUnmount(fiber, fiber["return"], instance);
                }

                break;
              }

            case HostComponent:
              {
                safelyDetachRef(fiber, fiber["return"]);
                break;
              }

            case OffscreenComponent:
              {
                var isHidden = fiber.memoizedState !== null;

                if (isHidden) {
                  disappearLayoutEffects_complete(subtreeRoot);
                  continue;
                }

                break;
              }
          }

          if (firstChild !== null) {
            firstChild["return"] = fiber;
            nextEffect = firstChild;
          } else {
            disappearLayoutEffects_complete(subtreeRoot);
          }
        }
      }

      function disappearLayoutEffects_complete(subtreeRoot) {
        while (nextEffect !== null) {
          var fiber = nextEffect;

          if (fiber === subtreeRoot) {
            nextEffect = null;
            return;
          }

          var sibling = fiber.sibling;

          if (sibling !== null) {
            sibling["return"] = fiber["return"];
            nextEffect = sibling;
            return;
          }

          nextEffect = fiber["return"];
        }
      }

      function reappearLayoutEffects_begin(subtreeRoot) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var firstChild = fiber.child;

          if (fiber.tag === OffscreenComponent) {
            var isHidden = fiber.memoizedState !== null;

            if (isHidden) {
              reappearLayoutEffects_complete(subtreeRoot);
              continue;
            }
          }

          if (firstChild !== null) {
            firstChild["return"] = fiber;
            nextEffect = firstChild;
          } else {
            reappearLayoutEffects_complete(subtreeRoot);
          }
        }
      }

      function reappearLayoutEffects_complete(subtreeRoot) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          setCurrentFiber(fiber);

          try {
            reappearLayoutEffectsOnFiber(fiber);
          } catch (error) {
            captureCommitPhaseError(fiber, fiber["return"], error);
          }

          resetCurrentFiber();

          if (fiber === subtreeRoot) {
            nextEffect = null;
            return;
          }

          var sibling = fiber.sibling;

          if (sibling !== null) {
            sibling["return"] = fiber["return"];
            nextEffect = sibling;
            return;
          }

          nextEffect = fiber["return"];
        }
      }

      function commitPassiveMountEffects(root, finishedWork, committedLanes, committedTransitions) {
        nextEffect = finishedWork;
        commitPassiveMountEffects_begin(finishedWork, root, committedLanes, committedTransitions);
      }

      function commitPassiveMountEffects_begin(subtreeRoot, root, committedLanes, committedTransitions) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var firstChild = fiber.child;

          if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && firstChild !== null) {
            firstChild["return"] = fiber;
            nextEffect = firstChild;
          } else {
            commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions);
          }
        }
      }

      function commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions) {
        while (nextEffect !== null) {
          var fiber = nextEffect;

          if ((fiber.flags & Passive) !== NoFlags) {
            setCurrentFiber(fiber);

            try {
              commitPassiveMountOnFiber(root, fiber, committedLanes, committedTransitions);
            } catch (error) {
              captureCommitPhaseError(fiber, fiber["return"], error);
            }

            resetCurrentFiber();
          }

          if (fiber === subtreeRoot) {
            nextEffect = null;
            return;
          }

          var sibling = fiber.sibling;

          if (sibling !== null) {
            sibling["return"] = fiber["return"];
            nextEffect = sibling;
            return;
          }

          nextEffect = fiber["return"];
        }
      }

      function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent:
            {
              if (finishedWork.mode & ProfileMode) {
                startPassiveEffectTimer();

                try {
                  commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                } finally {
                  recordPassiveEffectDuration(finishedWork);
                }
              } else {
                commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
              }

              break;
            }
        }
      }

      function commitPassiveUnmountEffects(firstChild) {
        nextEffect = firstChild;
        commitPassiveUnmountEffects_begin();
      }

      function commitPassiveUnmountEffects_begin() {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var child = fiber.child;

          if ((nextEffect.flags & ChildDeletion) !== NoFlags) {
            var deletions = fiber.deletions;

            if (deletions !== null) {
              for (var i = 0; i < deletions.length; i++) {
                var fiberToDelete = deletions[i];
                nextEffect = fiberToDelete;
                commitPassiveUnmountEffectsInsideOfDeletedTree_begin(fiberToDelete, fiber);
              }

              {
                var previousFiber = fiber.alternate;

                if (previousFiber !== null) {
                  var detachedChild = previousFiber.child;

                  if (detachedChild !== null) {
                    previousFiber.child = null;

                    do {
                      var detachedSibling = detachedChild.sibling;
                      detachedChild.sibling = null;
                      detachedChild = detachedSibling;
                    } while (detachedChild !== null);
                  }
                }
              }
              nextEffect = fiber;
            }
          }

          if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && child !== null) {
            child["return"] = fiber;
            nextEffect = child;
          } else {
            commitPassiveUnmountEffects_complete();
          }
        }
      }

      function commitPassiveUnmountEffects_complete() {
        while (nextEffect !== null) {
          var fiber = nextEffect;

          if ((fiber.flags & Passive) !== NoFlags) {
            setCurrentFiber(fiber);
            commitPassiveUnmountOnFiber(fiber);
            resetCurrentFiber();
          }

          var sibling = fiber.sibling;

          if (sibling !== null) {
            sibling["return"] = fiber["return"];
            nextEffect = sibling;
            return;
          }

          nextEffect = fiber["return"];
        }
      }

      function commitPassiveUnmountOnFiber(finishedWork) {
        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent:
            {
              if (finishedWork.mode & ProfileMode) {
                startPassiveEffectTimer();
                commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork["return"]);
                recordPassiveEffectDuration(finishedWork);
              } else {
                commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork["return"]);
              }

              break;
            }
        }
      }

      function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          setCurrentFiber(fiber);
          commitPassiveUnmountInsideDeletedTreeOnFiber(fiber, nearestMountedAncestor);
          resetCurrentFiber();
          var child = fiber.child;

          if (child !== null) {
            child["return"] = fiber;
            nextEffect = child;
          } else {
            commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot);
          }
        }
      }

      function commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var sibling = fiber.sibling;
          var returnFiber = fiber["return"];
          {
            detachFiberAfterEffects(fiber);

            if (fiber === deletedSubtreeRoot) {
              nextEffect = null;
              return;
            }
          }

          if (sibling !== null) {
            sibling["return"] = returnFiber;
            nextEffect = sibling;
            return;
          }

          nextEffect = returnFiber;
        }
      }

      function commitPassiveUnmountInsideDeletedTreeOnFiber(current, nearestMountedAncestor) {
        switch (current.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent:
            {
              if (current.mode & ProfileMode) {
                startPassiveEffectTimer();
                commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                recordPassiveEffectDuration(current);
              } else {
                commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
              }

              break;
            }
        }
      }

      function invokeLayoutEffectMountInDEV(fiber) {
        {
          switch (fiber.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
              {
                try {
                  commitHookEffectListMount(Layout | HasEffect, fiber);
                } catch (error) {
                  captureCommitPhaseError(fiber, fiber["return"], error);
                }

                break;
              }

            case ClassComponent:
              {
                var instance = fiber.stateNode;

                try {
                  instance.componentDidMount();
                } catch (error) {
                  captureCommitPhaseError(fiber, fiber["return"], error);
                }

                break;
              }
          }
        }
      }

      function invokePassiveEffectMountInDEV(fiber) {
        {
          switch (fiber.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
              {
                try {
                  commitHookEffectListMount(Passive$1 | HasEffect, fiber);
                } catch (error) {
                  captureCommitPhaseError(fiber, fiber["return"], error);
                }

                break;
              }
          }
        }
      }

      function invokeLayoutEffectUnmountInDEV(fiber) {
        {
          switch (fiber.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
              {
                try {
                  commitHookEffectListUnmount(Layout | HasEffect, fiber, fiber["return"]);
                } catch (error) {
                  captureCommitPhaseError(fiber, fiber["return"], error);
                }

                break;
              }

            case ClassComponent:
              {
                var instance = fiber.stateNode;

                if (typeof instance.componentWillUnmount === 'function') {
                  safelyCallComponentWillUnmount(fiber, fiber["return"], instance);
                }

                break;
              }
          }
        }
      }

      function invokePassiveEffectUnmountInDEV(fiber) {
        {
          switch (fiber.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
              {
                try {
                  commitHookEffectListUnmount(Passive$1 | HasEffect, fiber, fiber["return"]);
                } catch (error) {
                  captureCommitPhaseError(fiber, fiber["return"], error);
                }
              }
          }
        }
      }

      var COMPONENT_TYPE = 0;
      var HAS_PSEUDO_CLASS_TYPE = 1;
      var ROLE_TYPE = 2;
      var TEST_NAME_TYPE = 3;
      var TEXT_TYPE = 4;

      if (typeof Symbol === 'function' && Symbol["for"]) {
        var symbolFor = Symbol["for"];
        COMPONENT_TYPE = symbolFor('selector.component');
        HAS_PSEUDO_CLASS_TYPE = symbolFor('selector.has_pseudo_class');
        ROLE_TYPE = symbolFor('selector.role');
        TEST_NAME_TYPE = symbolFor('selector.test_id');
        TEXT_TYPE = symbolFor('selector.text');
      }

      var commitHooks = [];

      function onCommitRoot$1() {
        {
          commitHooks.forEach(function (commitHook) {
            return commitHook();
          });
        }
      }

      var ReactCurrentActQueue = ReactSharedInternals.ReactCurrentActQueue;

      function isLegacyActEnvironment(fiber) {
        {
          var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== 'undefined' ? IS_REACT_ACT_ENVIRONMENT : undefined;
          var jestIsDefined = typeof jest !== 'undefined';
          return jestIsDefined && isReactActEnvironmentGlobal !== false;
        }
      }

      function isConcurrentActEnvironment() {
        {
          var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== 'undefined' ? IS_REACT_ACT_ENVIRONMENT : undefined;

          if (!isReactActEnvironmentGlobal && ReactCurrentActQueue.current !== null) {
            error('The current testing environment is not configured to support ' + 'act(...)');
          }

          return isReactActEnvironmentGlobal;
        }
      }

      var ceil = Math.ceil;
      var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher,
          ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner,
          ReactCurrentBatchConfig$3 = ReactSharedInternals.ReactCurrentBatchConfig,
          ReactCurrentActQueue$1 = ReactSharedInternals.ReactCurrentActQueue;
      var NoContext = 0;
      var BatchedContext = 1;
      var RenderContext = 2;
      var CommitContext = 4;
      var RootInProgress = 0;
      var RootFatalErrored = 1;
      var RootErrored = 2;
      var RootSuspended = 3;
      var RootSuspendedWithDelay = 4;
      var RootCompleted = 5;
      var RootDidNotComplete = 6;
      var executionContext = NoContext;
      var workInProgressRoot = null;
      var workInProgress = null;
      var workInProgressRootRenderLanes = NoLanes;
      var subtreeRenderLanes = NoLanes;
      var subtreeRenderLanesCursor = createCursor(NoLanes);
      var workInProgressRootExitStatus = RootInProgress;
      var workInProgressRootFatalError = null;
      var workInProgressRootIncludedLanes = NoLanes;
      var workInProgressRootSkippedLanes = NoLanes;
      var workInProgressRootInterleavedUpdatedLanes = NoLanes;
      var workInProgressRootPingedLanes = NoLanes;
      var workInProgressRootConcurrentErrors = null;
      var workInProgressRootRecoverableErrors = null;
      var globalMostRecentFallbackTime = 0;
      var FALLBACK_THROTTLE_MS = 500;
      var workInProgressRootRenderTargetTime = Infinity;
      var RENDER_TIMEOUT_MS = 500;
      var workInProgressTransitions = null;

      function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
      }

      function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
      }

      var hasUncaughtError = false;
      var firstUncaughtError = null;
      var legacyErrorBoundariesThatAlreadyFailed = null;
      var rootDoesHavePassiveEffects = false;
      var rootWithPendingPassiveEffects = null;
      var pendingPassiveEffectsLanes = NoLanes;
      var pendingPassiveProfilerEffects = [];
      var pendingPassiveTransitions = null;
      var NESTED_UPDATE_LIMIT = 50;
      var nestedUpdateCount = 0;
      var rootWithNestedUpdates = null;
      var isFlushingPassiveEffects = false;
      var didScheduleUpdateDuringPassiveEffects = false;
      var NESTED_PASSIVE_UPDATE_LIMIT = 50;
      var nestedPassiveUpdateCount = 0;
      var rootWithPassiveNestedUpdates = null;
      var currentEventTime = NoTimestamp;
      var currentEventTransitionLane = NoLanes;
      var isRunningInsertionEffect = false;

      function getWorkInProgressRoot() {
        return workInProgressRoot;
      }

      function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          return now();
        }

        if (currentEventTime !== NoTimestamp) {
          return currentEventTime;
        }

        currentEventTime = now();
        return currentEventTime;
      }

      function requestUpdateLane(fiber) {
        var mode = fiber.mode;

        if ((mode & ConcurrentMode) === NoMode) {
          return SyncLane;
        } else if ((executionContext & RenderContext) !== NoContext && workInProgressRootRenderLanes !== NoLanes) {
          return pickArbitraryLane(workInProgressRootRenderLanes);
        }

        var isTransition = requestCurrentTransition() !== NoTransition;

        if (isTransition) {
          if (ReactCurrentBatchConfig$3.transition !== null) {
            var transition = ReactCurrentBatchConfig$3.transition;

            if (!transition._updatedFibers) {
              transition._updatedFibers = new Set();
            }

            transition._updatedFibers.add(fiber);
          }

          if (currentEventTransitionLane === NoLane) {
            currentEventTransitionLane = claimNextTransitionLane();
          }

          return currentEventTransitionLane;
        }

        var updateLane = getCurrentUpdatePriority();

        if (updateLane !== NoLane) {
          return updateLane;
        }

        var eventLane = getCurrentEventPriority();
        return eventLane;
      }

      function requestRetryLane(fiber) {
        var mode = fiber.mode;

        if ((mode & ConcurrentMode) === NoMode) {
          return SyncLane;
        }

        return claimNextRetryLane();
      }

      function scheduleUpdateOnFiber(fiber, lane, eventTime) {
        checkForNestedUpdates();
        {
          if (isRunningInsertionEffect) {
            error('useInsertionEffect must not schedule updates.');
          }
        }
        var root = markUpdateLaneFromFiberToRoot(fiber, lane);

        if (root === null) {
          return null;
        }

        {
          if (isFlushingPassiveEffects) {
            didScheduleUpdateDuringPassiveEffects = true;
          }
        }
        markRootUpdated(root, lane, eventTime);

        if ((executionContext & RenderContext) !== NoLanes && root === workInProgressRoot) {
          warnAboutRenderPhaseUpdatesInDEV(fiber);
        } else {
          {
            if (isDevToolsPresent) {
              addFiberToLanesMap(root, fiber, lane);
            }
          }
          warnIfUpdatesNotWrappedWithActDEV(fiber);

          if (root === workInProgressRoot) {
            if ((executionContext & RenderContext) === NoContext) {
              workInProgressRootInterleavedUpdatedLanes = mergeLanes(workInProgressRootInterleavedUpdatedLanes, lane);
            }

            if (workInProgressRootExitStatus === RootSuspendedWithDelay) {
              markRootSuspended$1(root, workInProgressRootRenderLanes);
            }
          }

          ensureRootIsScheduled(root, eventTime);

          if (lane === SyncLane && executionContext === NoContext && (fiber.mode & ConcurrentMode) === NoMode && !ReactCurrentActQueue$1.isBatchingLegacy) {
            resetRenderTimer();
            flushSyncCallbacksOnlyInLegacyMode();
          }
        }

        return root;
      }

      function scheduleInitialHydrationOnRoot(root, lane, eventTime) {
        var current = root.current;
        current.lanes = lane;
        markRootUpdated(root, lane, eventTime);
        ensureRootIsScheduled(root, eventTime);
      }

      function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;

        if (alternate !== null) {
          alternate.lanes = mergeLanes(alternate.lanes, lane);
        }

        {
          if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) {
            warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
          }
        }
        var node = sourceFiber;
        var parent = sourceFiber["return"];

        while (parent !== null) {
          parent.childLanes = mergeLanes(parent.childLanes, lane);
          alternate = parent.alternate;

          if (alternate !== null) {
            alternate.childLanes = mergeLanes(alternate.childLanes, lane);
          } else {
            {
              if ((parent.flags & (Placement | Hydrating)) !== NoFlags) {
                warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
              }
            }
          }

          node = parent;
          parent = parent["return"];
        }

        if (node.tag === HostRoot) {
          var root = node.stateNode;
          return root;
        } else {
          return null;
        }
      }

      function isInterleavedUpdate(fiber, lane) {
        return (workInProgressRoot !== null || hasInterleavedUpdates()) && (fiber.mode & ConcurrentMode) !== NoMode && (executionContext & RenderContext) === NoContext;
      }

      function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode;
        markStarvedLanesAsExpired(root, currentTime);
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);

        if (nextLanes === NoLanes) {
          if (existingCallbackNode !== null) {
            cancelCallback$1(existingCallbackNode);
          }

          root.callbackNode = null;
          root.callbackPriority = NoLane;
          return;
        }

        var newCallbackPriority = getHighestPriorityLane(nextLanes);
        var existingCallbackPriority = root.callbackPriority;

        if (existingCallbackPriority === newCallbackPriority && !(ReactCurrentActQueue$1.current !== null && existingCallbackNode !== fakeActCallbackNode)) {
          {
            if (existingCallbackNode == null && existingCallbackPriority !== SyncLane) {
              error('Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.');
            }
          }
          return;
        }

        if (existingCallbackNode != null) {
          cancelCallback$1(existingCallbackNode);
        }

        var newCallbackNode;

        if (newCallbackPriority === SyncLane) {
          if (root.tag === LegacyRoot) {
            if (ReactCurrentActQueue$1.isBatchingLegacy !== null) {
              ReactCurrentActQueue$1.didScheduleLegacyUpdate = true;
            }

            scheduleLegacySyncCallback(performSyncWorkOnRoot.bind(null, root));
          } else {
            scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
          }

          {
            if (ReactCurrentActQueue$1.current !== null) {
              ReactCurrentActQueue$1.current.push(flushSyncCallbacks);
            } else {
              scheduleMicrotask(function () {
                if (executionContext === NoContext) {
                  flushSyncCallbacks();
                }
              });
            }
          }
          newCallbackNode = null;
        } else {
          var schedulerPriorityLevel;

          switch (lanesToEventPriority(nextLanes)) {
            case DiscreteEventPriority:
              schedulerPriorityLevel = ImmediatePriority;
              break;

            case ContinuousEventPriority:
              schedulerPriorityLevel = UserBlockingPriority;
              break;

            case DefaultEventPriority:
              schedulerPriorityLevel = NormalPriority;
              break;

            case IdleEventPriority:
              schedulerPriorityLevel = IdlePriority;
              break;

            default:
              schedulerPriorityLevel = NormalPriority;
              break;
          }

          newCallbackNode = scheduleCallback$1(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }

        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
      }

      function performConcurrentWorkOnRoot(root, didTimeout) {
        {
          resetNestedUpdateFlag();
        }
        currentEventTime = NoTimestamp;
        currentEventTransitionLane = NoLanes;

        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          throw new Error('Should not already be working.');
        }

        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();

        if (didFlushPassiveEffects) {
          if (root.callbackNode !== originalCallbackNode) {
            return null;
          }
        }

        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);

        if (lanes === NoLanes) {
          return null;
        }

        var shouldTimeSlice = !includesBlockingLane(root, lanes) && !includesExpiredLane(root, lanes) && !didTimeout;
        var exitStatus = shouldTimeSlice ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes);

        if (exitStatus !== RootInProgress) {
          if (exitStatus === RootErrored) {
            var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);

            if (errorRetryLanes !== NoLanes) {
              lanes = errorRetryLanes;
              exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
            }
          }

          if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
          }

          if (exitStatus === RootDidNotComplete) {
            markRootSuspended$1(root, lanes);
          } else {
            var renderWasConcurrent = !includesBlockingLane(root, lanes);
            var finishedWork = root.current.alternate;

            if (renderWasConcurrent && !isRenderConsistentWithExternalStores(finishedWork)) {
              exitStatus = renderRootSync(root, lanes);

              if (exitStatus === RootErrored) {
                var _errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);

                if (_errorRetryLanes !== NoLanes) {
                  lanes = _errorRetryLanes;
                  exitStatus = recoverFromConcurrentError(root, _errorRetryLanes);
                }
              }

              if (exitStatus === RootFatalErrored) {
                var _fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw _fatalError;
              }
            }

            root.finishedWork = finishedWork;
            root.finishedLanes = lanes;
            finishConcurrentRender(root, exitStatus, lanes);
          }
        }

        ensureRootIsScheduled(root, now());

        if (root.callbackNode === originalCallbackNode) {
          return performConcurrentWorkOnRoot.bind(null, root);
        }

        return null;
      }

      function recoverFromConcurrentError(root, errorRetryLanes) {
        var errorsFromFirstAttempt = workInProgressRootConcurrentErrors;

        if (isRootDehydrated(root)) {
          var rootWorkInProgress = prepareFreshStack(root, errorRetryLanes);
          rootWorkInProgress.flags |= ForceClientRender;
          {
            errorHydratingContainer(root.containerInfo);
          }
        }

        var exitStatus = renderRootSync(root, errorRetryLanes);

        if (exitStatus !== RootErrored) {
          var errorsFromSecondAttempt = workInProgressRootRecoverableErrors;
          workInProgressRootRecoverableErrors = errorsFromFirstAttempt;

          if (errorsFromSecondAttempt !== null) {
            queueRecoverableErrors(errorsFromSecondAttempt);
          }
        }

        return exitStatus;
      }

      function queueRecoverableErrors(errors) {
        if (workInProgressRootRecoverableErrors === null) {
          workInProgressRootRecoverableErrors = errors;
        } else {
          workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
        }
      }

      function finishConcurrentRender(root, exitStatus, lanes) {
        switch (exitStatus) {
          case RootInProgress:
          case RootFatalErrored:
            {
              throw new Error('Root did not complete. This is a bug in React.');
            }

          case RootErrored:
            {
              commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
              break;
            }

          case RootSuspended:
            {
              markRootSuspended$1(root, lanes);

              if (includesOnlyRetries(lanes) && !shouldForceFlushFallbacksInDEV()) {
                var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now();

                if (msUntilTimeout > 10) {
                  var nextLanes = getNextLanes(root, NoLanes);

                  if (nextLanes !== NoLanes) {
                    break;
                  }

                  var suspendedLanes = root.suspendedLanes;

                  if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                    var eventTime = requestEventTime();
                    markRootPinged(root, suspendedLanes);
                    break;
                  }

                  root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), msUntilTimeout);
                  break;
                }
              }

              commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
              break;
            }

          case RootSuspendedWithDelay:
            {
              markRootSuspended$1(root, lanes);

              if (includesOnlyTransitions(lanes)) {
                break;
              }

              if (!shouldForceFlushFallbacksInDEV()) {
                var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                var eventTimeMs = mostRecentEventTime;
                var timeElapsedMs = now() - eventTimeMs;

                var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs;

                if (_msUntilTimeout > 10) {
                  root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), _msUntilTimeout);
                  break;
                }
              }

              commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
              break;
            }

          case RootCompleted:
            {
              commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
              break;
            }

          default:
            {
              throw new Error('Unknown root exit status.');
            }
        }
      }

      function isRenderConsistentWithExternalStores(finishedWork) {
        var node = finishedWork;

        while (true) {
          if (node.flags & StoreConsistency) {
            var updateQueue = node.updateQueue;

            if (updateQueue !== null) {
              var checks = updateQueue.stores;

              if (checks !== null) {
                for (var i = 0; i < checks.length; i++) {
                  var check = checks[i];
                  var getSnapshot = check.getSnapshot;
                  var renderedValue = check.value;

                  try {
                    if (!objectIs(getSnapshot(), renderedValue)) {
                      return false;
                    }
                  } catch (error) {
                    return false;
                  }
                }
              }
            }
          }

          var child = node.child;

          if (node.subtreeFlags & StoreConsistency && child !== null) {
            child["return"] = node;
            node = child;
            continue;
          }

          if (node === finishedWork) {
            return true;
          }

          while (node.sibling === null) {
            if (node["return"] === null || node["return"] === finishedWork) {
              return true;
            }

            node = node["return"];
          }

          node.sibling["return"] = node["return"];
          node = node.sibling;
        }

        return true;
      }

      function markRootSuspended$1(root, suspendedLanes) {
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootInterleavedUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
      }

      function performSyncWorkOnRoot(root) {
        {
          syncNestedUpdateFlag();
        }

        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          throw new Error('Should not already be working.');
        }

        flushPassiveEffects();
        var lanes = getNextLanes(root, NoLanes);

        if (!includesSomeLane(lanes, SyncLane)) {
          ensureRootIsScheduled(root, now());
          return null;
        }

        var exitStatus = renderRootSync(root, lanes);

        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
          var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);

          if (errorRetryLanes !== NoLanes) {
            lanes = errorRetryLanes;
            exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
          }
        }

        if (exitStatus === RootFatalErrored) {
          var fatalError = workInProgressRootFatalError;
          prepareFreshStack(root, NoLanes);
          markRootSuspended$1(root, lanes);
          ensureRootIsScheduled(root, now());
          throw fatalError;
        }

        if (exitStatus === RootDidNotComplete) {
          throw new Error('Root did not complete. This is a bug in React.');
        }

        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
        ensureRootIsScheduled(root, now());
        return null;
      }

      function flushRoot(root, lanes) {
        if (lanes !== NoLanes) {
          markRootEntangled(root, mergeLanes(lanes, SyncLane));
          ensureRootIsScheduled(root, now());

          if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
            resetRenderTimer();
            flushSyncCallbacks();
          }
        }
      }

      function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;

        try {
          return fn(a);
        } finally {
          executionContext = prevExecutionContext;

          if (executionContext === NoContext && !ReactCurrentActQueue$1.isBatchingLegacy) {
            resetRenderTimer();
            flushSyncCallbacksOnlyInLegacyMode();
          }
        }
      }

      function discreteUpdates(fn, a, b, c, d) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;

        try {
          ReactCurrentBatchConfig$3.transition = null;
          setCurrentUpdatePriority(DiscreteEventPriority);
          return fn(a, b, c, d);
        } finally {
          setCurrentUpdatePriority(previousPriority);
          ReactCurrentBatchConfig$3.transition = prevTransition;

          if (executionContext === NoContext) {
            resetRenderTimer();
          }
        }
      }

      function flushSync(fn) {
        if (rootWithPendingPassiveEffects !== null && rootWithPendingPassiveEffects.tag === LegacyRoot && (executionContext & (RenderContext | CommitContext)) === NoContext) {
          flushPassiveEffects();
        }

        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        var previousPriority = getCurrentUpdatePriority();

        try {
          ReactCurrentBatchConfig$3.transition = null;
          setCurrentUpdatePriority(DiscreteEventPriority);

          if (fn) {
            return fn();
          } else {
            return undefined;
          }
        } finally {
          setCurrentUpdatePriority(previousPriority);
          ReactCurrentBatchConfig$3.transition = prevTransition;
          executionContext = prevExecutionContext;

          if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
            flushSyncCallbacks();
          }
        }
      }

      function isAlreadyRendering() {
        return (executionContext & (RenderContext | CommitContext)) !== NoContext;
      }

      function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
      }

      function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
      }

      function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;

        if (timeoutHandle !== noTimeout) {
          root.timeoutHandle = noTimeout;
          cancelTimeout(timeoutHandle);
        }

        if (workInProgress !== null) {
          var interruptedWork = workInProgress["return"];

          while (interruptedWork !== null) {
            var current = interruptedWork.alternate;
            unwindInterruptedWork(current, interruptedWork);
            interruptedWork = interruptedWork["return"];
          }
        }

        workInProgressRoot = root;
        var rootWorkInProgress = createWorkInProgress(root.current, null);
        workInProgress = rootWorkInProgress;
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootInterleavedUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        workInProgressRootConcurrentErrors = null;
        workInProgressRootRecoverableErrors = null;
        enqueueInterleavedUpdates();
        {
          ReactStrictModeWarnings.discardPendingWarnings();
        }
        return rootWorkInProgress;
      }

      function handleError(root, thrownValue) {
        do {
          var erroredWork = workInProgress;

          try {
            resetContextDependencies();
            resetHooksAfterThrow();
            resetCurrentFiber();
            ReactCurrentOwner$2.current = null;

            if (erroredWork === null || erroredWork["return"] === null) {
              workInProgressRootExitStatus = RootFatalErrored;
              workInProgressRootFatalError = thrownValue;
              workInProgress = null;
              return;
            }

            if (enableProfilerTimer && erroredWork.mode & ProfileMode) {
              stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
            }

            if (enableSchedulingProfiler) {
              markComponentRenderStopped();

              if (thrownValue !== null && typeof thrownValue === 'object' && typeof thrownValue.then === 'function') {
                var wakeable = thrownValue;
                markComponentSuspended(erroredWork, wakeable, workInProgressRootRenderLanes);
              } else {
                markComponentErrored(erroredWork, thrownValue, workInProgressRootRenderLanes);
              }
            }

            throwException(root, erroredWork["return"], erroredWork, thrownValue, workInProgressRootRenderLanes);
            completeUnitOfWork(erroredWork);
          } catch (yetAnotherThrownValue) {
            thrownValue = yetAnotherThrownValue;

            if (workInProgress === erroredWork && erroredWork !== null) {
              erroredWork = erroredWork["return"];
              workInProgress = erroredWork;
            } else {
              erroredWork = workInProgress;
            }

            continue;
          }

          return;
        } while (true);
      }

      function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;

        if (prevDispatcher === null) {
          return ContextOnlyDispatcher;
        } else {
          return prevDispatcher;
        }
      }

      function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
      }

      function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
      }

      function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
      }

      function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootInProgress) {
          workInProgressRootExitStatus = RootSuspended;
        }
      }

      function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootInProgress || workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootErrored) {
          workInProgressRootExitStatus = RootSuspendedWithDelay;
        }

        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootInterleavedUpdatedLanes))) {
          markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
        }
      }

      function renderDidError(error) {
        if (workInProgressRootExitStatus !== RootSuspendedWithDelay) {
          workInProgressRootExitStatus = RootErrored;
        }

        if (workInProgressRootConcurrentErrors === null) {
          workInProgressRootConcurrentErrors = [error];
        } else {
          workInProgressRootConcurrentErrors.push(error);
        }
      }

      function renderHasNotSuspendedYet() {
        return workInProgressRootExitStatus === RootInProgress;
      }

      function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher();

        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
          {
            if (isDevToolsPresent) {
              var memoizedUpdaters = root.memoizedUpdaters;

              if (memoizedUpdaters.size > 0) {
                restorePendingUpdaters(root, workInProgressRootRenderLanes);
                memoizedUpdaters.clear();
              }

              movePendingFibersToMemoized(root, lanes);
            }
          }
          workInProgressTransitions = getTransitionsForLanes();
          prepareFreshStack(root, lanes);
        }

        {
          markRenderStarted(lanes);
        }

        do {
          try {
            workLoopSync();
            break;
          } catch (thrownValue) {
            handleError(root, thrownValue);
          }
        } while (true);

        resetContextDependencies();
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);

        if (workInProgress !== null) {
          throw new Error('Cannot commit an incomplete root. This error is likely caused by a ' + 'bug in React. Please file an issue.');
        }

        {
          markRenderStopped();
        }
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
      }

      function workLoopSync() {
        while (workInProgress !== null) {
          performUnitOfWork(workInProgress);
        }
      }

      function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher();

        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
          {
            if (isDevToolsPresent) {
              var memoizedUpdaters = root.memoizedUpdaters;

              if (memoizedUpdaters.size > 0) {
                restorePendingUpdaters(root, workInProgressRootRenderLanes);
                memoizedUpdaters.clear();
              }

              movePendingFibersToMemoized(root, lanes);
            }
          }
          workInProgressTransitions = getTransitionsForLanes();
          resetRenderTimer();
          prepareFreshStack(root, lanes);
        }

        {
          markRenderStarted(lanes);
        }

        do {
          try {
            workLoopConcurrent();
            break;
          } catch (thrownValue) {
            handleError(root, thrownValue);
          }
        } while (true);

        resetContextDependencies();
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;

        if (workInProgress !== null) {
          {
            markRenderYielded();
          }
          return RootInProgress;
        } else {
          {
            markRenderStopped();
          }
          workInProgressRoot = null;
          workInProgressRootRenderLanes = NoLanes;
          return workInProgressRootExitStatus;
        }
      }

      function workLoopConcurrent() {
        while (workInProgress !== null && !shouldYield()) {
          performUnitOfWork(workInProgress);
        }
      }

      function performUnitOfWork(unitOfWork) {
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;

        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
          startProfilerTimer(unitOfWork);
          next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
          stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else {
          next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        }

        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;

        if (next === null) {
          completeUnitOfWork(unitOfWork);
        } else {
          workInProgress = next;
        }

        ReactCurrentOwner$2.current = null;
      }

      function completeUnitOfWork(unitOfWork) {
        var completedWork = unitOfWork;

        do {
          var current = completedWork.alternate;
          var returnFiber = completedWork["return"];

          if ((completedWork.flags & Incomplete) === NoFlags) {
            setCurrentFiber(completedWork);
            var next = void 0;

            if ((completedWork.mode & ProfileMode) === NoMode) {
              next = completeWork(current, completedWork, subtreeRenderLanes);
            } else {
              startProfilerTimer(completedWork);
              next = completeWork(current, completedWork, subtreeRenderLanes);
              stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
            }

            resetCurrentFiber();

            if (next !== null) {
              workInProgress = next;
              return;
            }
          } else {
            var _next = unwindWork(current, completedWork);

            if (_next !== null) {
              _next.flags &= HostEffectMask;
              workInProgress = _next;
              return;
            }

            if ((completedWork.mode & ProfileMode) !== NoMode) {
              stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
              var actualDuration = completedWork.actualDuration;
              var child = completedWork.child;

              while (child !== null) {
                actualDuration += child.actualDuration;
                child = child.sibling;
              }

              completedWork.actualDuration = actualDuration;
            }

            if (returnFiber !== null) {
              returnFiber.flags |= Incomplete;
              returnFiber.subtreeFlags = NoFlags;
              returnFiber.deletions = null;
            } else {
              workInProgressRootExitStatus = RootDidNotComplete;
              workInProgress = null;
              return;
            }
          }

          var siblingFiber = completedWork.sibling;

          if (siblingFiber !== null) {
            workInProgress = siblingFiber;
            return;
          }

          completedWork = returnFiber;
          workInProgress = completedWork;
        } while (completedWork !== null);

        if (workInProgressRootExitStatus === RootInProgress) {
          workInProgressRootExitStatus = RootCompleted;
        }
      }

      function commitRoot(root, recoverableErrors, transitions) {
        var previousUpdateLanePriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;

        try {
          ReactCurrentBatchConfig$3.transition = null;
          setCurrentUpdatePriority(DiscreteEventPriority);
          commitRootImpl(root, recoverableErrors, transitions, previousUpdateLanePriority);
        } finally {
          ReactCurrentBatchConfig$3.transition = prevTransition;
          setCurrentUpdatePriority(previousUpdateLanePriority);
        }

        return null;
      }

      function commitRootImpl(root, recoverableErrors, transitions, renderPriorityLevel) {
        do {
          flushPassiveEffects();
        } while (rootWithPendingPassiveEffects !== null);

        flushRenderPhaseStrictModeWarningsInDEV();

        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          throw new Error('Should not already be working.');
        }

        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        {
          markCommitStarted(lanes);
        }

        if (finishedWork === null) {
          {
            markCommitStopped();
          }
          return null;
        } else {
          {
            if (lanes === NoLanes) {
              error('root.finishedLanes should not be empty during a commit. This is a ' + 'bug in React.');
            }
          }
        }

        root.finishedWork = null;
        root.finishedLanes = NoLanes;

        if (finishedWork === root.current) {
          throw new Error('Cannot commit the same tree as before. This error is likely caused by ' + 'a bug in React. Please file an issue.');
        }

        root.callbackNode = null;
        root.callbackPriority = NoLane;
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes);

        if (root === workInProgressRoot) {
          workInProgressRoot = null;
          workInProgress = null;
          workInProgressRootRenderLanes = NoLanes;
        }

        if ((finishedWork.subtreeFlags & PassiveMask) !== NoFlags || (finishedWork.flags & PassiveMask) !== NoFlags) {
          if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            pendingPassiveTransitions = transitions;
            scheduleCallback$1(NormalPriority, function () {
              flushPassiveEffects();
              return null;
            });
          }
        }

        var subtreeHasEffects = (finishedWork.subtreeFlags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        var rootHasEffect = (finishedWork.flags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;

        if (subtreeHasEffects || rootHasEffect) {
          var prevTransition = ReactCurrentBatchConfig$3.transition;
          ReactCurrentBatchConfig$3.transition = null;
          var previousPriority = getCurrentUpdatePriority();
          setCurrentUpdatePriority(DiscreteEventPriority);
          var prevExecutionContext = executionContext;
          executionContext |= CommitContext;
          ReactCurrentOwner$2.current = null;
          var shouldFireAfterActiveInstanceBlur = commitBeforeMutationEffects(root, finishedWork);
          {
            recordCommitTime();
          }
          commitMutationEffects(root, finishedWork, lanes);
          resetAfterCommit();
          root.current = finishedWork;
          {
            markLayoutEffectsStarted(lanes);
          }
          commitLayoutEffects(finishedWork, root, lanes);
          {
            markLayoutEffectsStopped();
          }
          requestPaint();
          executionContext = prevExecutionContext;
          setCurrentUpdatePriority(previousPriority);
          ReactCurrentBatchConfig$3.transition = prevTransition;
        } else {
          root.current = finishedWork;
          {
            recordCommitTime();
          }
        }

        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;

        if (rootDoesHavePassiveEffects) {
          rootDoesHavePassiveEffects = false;
          rootWithPendingPassiveEffects = root;
          pendingPassiveEffectsLanes = lanes;
        } else {
          {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
          }
        }

        remainingLanes = root.pendingLanes;

        if (remainingLanes === NoLanes) {
          legacyErrorBoundariesThatAlreadyFailed = null;
        }

        {
          if (!rootDidHavePassiveEffects) {
            commitDoubleInvokeEffectsInDEV(root.current, false);
          }
        }
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        {
          if (isDevToolsPresent) {
            root.memoizedUpdaters.clear();
          }
        }
        {
          onCommitRoot$1();
        }
        ensureRootIsScheduled(root, now());

        if (recoverableErrors !== null) {
          var onRecoverableError = root.onRecoverableError;

          for (var i = 0; i < recoverableErrors.length; i++) {
            var recoverableError = recoverableErrors[i];
            onRecoverableError(recoverableError);
          }
        }

        if (hasUncaughtError) {
          hasUncaughtError = false;
          var error$1 = firstUncaughtError;
          firstUncaughtError = null;
          throw error$1;
        }

        if (includesSomeLane(pendingPassiveEffectsLanes, SyncLane) && root.tag !== LegacyRoot) {
          flushPassiveEffects();
        }

        remainingLanes = root.pendingLanes;

        if (includesSomeLane(remainingLanes, SyncLane)) {
          {
            markNestedUpdateScheduled();
          }

          if (root === rootWithNestedUpdates) {
            nestedUpdateCount++;
          } else {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = root;
          }
        } else {
          nestedUpdateCount = 0;
        }

        flushSyncCallbacks();
        {
          markCommitStopped();
        }
        return null;
      }

      function flushPassiveEffects() {
        if (rootWithPendingPassiveEffects !== null) {
          var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes);
          var priority = lowerEventPriority(DefaultEventPriority, renderPriority);
          var prevTransition = ReactCurrentBatchConfig$3.transition;
          var previousPriority = getCurrentUpdatePriority();

          try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(priority);
            return flushPassiveEffectsImpl();
          } finally {
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
          }
        }

        return false;
      }

      function enqueuePendingPassiveProfilerEffect(fiber) {
        {
          pendingPassiveProfilerEffects.push(fiber);

          if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function () {
              flushPassiveEffects();
              return null;
            });
          }
        }
      }

      function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) {
          return false;
        }

        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null;
        pendingPassiveEffectsLanes = NoLanes;

        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          throw new Error('Cannot flush passive effects while already rendering.');
        }

        {
          isFlushingPassiveEffects = true;
          didScheduleUpdateDuringPassiveEffects = false;
        }
        {
          markPassiveEffectsStarted(lanes);
        }
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountEffects(root.current);
        commitPassiveMountEffects(root, root.current, lanes, transitions);
        {
          var profilerEffects = pendingPassiveProfilerEffects;
          pendingPassiveProfilerEffects = [];

          for (var i = 0; i < profilerEffects.length; i++) {
            var _fiber = profilerEffects[i];
            commitPassiveEffectDurations(root, _fiber);
          }
        }
        {
          markPassiveEffectsStopped();
        }
        {
          commitDoubleInvokeEffectsInDEV(root.current, true);
        }
        executionContext = prevExecutionContext;
        flushSyncCallbacks();
        {
          if (didScheduleUpdateDuringPassiveEffects) {
            if (root === rootWithPassiveNestedUpdates) {
              nestedPassiveUpdateCount++;
            } else {
              nestedPassiveUpdateCount = 0;
              rootWithPassiveNestedUpdates = root;
            }
          } else {
            nestedPassiveUpdateCount = 0;
          }

          isFlushingPassiveEffects = false;
          didScheduleUpdateDuringPassiveEffects = false;
        }
        onPostCommitRoot(root);
        {
          var stateNode = root.current.stateNode;
          stateNode.effectDuration = 0;
          stateNode.passiveEffectDuration = 0;
        }
        return true;
      }

      function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
      }

      function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) {
          legacyErrorBoundariesThatAlreadyFailed = new Set([instance]);
        } else {
          legacyErrorBoundariesThatAlreadyFailed.add(instance);
        }
      }

      function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
          hasUncaughtError = true;
          firstUncaughtError = error;
        }
      }

      var onUncaughtError = prepareToThrowUncaughtError;

      function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValue(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        enqueueUpdate(rootFiber, update);
        var eventTime = requestEventTime();
        var root = markUpdateLaneFromFiberToRoot(rootFiber, SyncLane);

        if (root !== null) {
          markRootUpdated(root, SyncLane, eventTime);
          ensureRootIsScheduled(root, eventTime);
        }
      }

      function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error$1) {
        {
          reportUncaughtErrorInDEV(error$1);
          setIsRunningInsertionEffect(false);
        }

        if (sourceFiber.tag === HostRoot) {
          captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error$1);
          return;
        }

        var fiber = null;
        {
          fiber = nearestMountedAncestor;
        }

        while (fiber !== null) {
          if (fiber.tag === HostRoot) {
            captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error$1);
            return;
          } else if (fiber.tag === ClassComponent) {
            var ctor = fiber.type;
            var instance = fiber.stateNode;

            if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
              var errorInfo = createCapturedValue(error$1, sourceFiber);
              var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
              enqueueUpdate(fiber, update);
              var eventTime = requestEventTime();
              var root = markUpdateLaneFromFiberToRoot(fiber, SyncLane);

              if (root !== null) {
                markRootUpdated(root, SyncLane, eventTime);
                ensureRootIsScheduled(root, eventTime);
              }

              return;
            }
          }

          fiber = fiber["return"];
        }

        {
          error('Internal React error: Attempted to capture a commit phase error ' + 'inside a detached tree. This indicates a bug in React. Likely ' + 'causes include deleting the same fiber more than once, committing an ' + 'already-finished tree, or an inconsistent return pointer.\n\n' + 'Error message:\n\n%s', error$1);
        }
      }

      function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;

        if (pingCache !== null) {
          pingCache["delete"](wakeable);
        }

        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        warnIfSuspenseResolutionNotWrappedWithActDEV(root);

        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
          if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) {
            prepareFreshStack(root, NoLanes);
          } else {
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
          }
        }

        ensureRootIsScheduled(root, eventTime);
      }

      function retryTimedOutBoundary(boundaryFiber, retryLane) {
        if (retryLane === NoLane) {
          retryLane = requestRetryLane(boundaryFiber);
        }

        var eventTime = requestEventTime();
        var root = markUpdateLaneFromFiberToRoot(boundaryFiber, retryLane);

        if (root !== null) {
          markRootUpdated(root, retryLane, eventTime);
          ensureRootIsScheduled(root, eventTime);
        }
      }

      function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryLane = NoLane;

        if (suspenseState !== null) {
          retryLane = suspenseState.retryLane;
        }

        retryTimedOutBoundary(boundaryFiber, retryLane);
      }

      function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane;
        var retryCache;

        switch (boundaryFiber.tag) {
          case SuspenseComponent:
            retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;

            if (suspenseState !== null) {
              retryLane = suspenseState.retryLane;
            }

            break;

          case SuspenseListComponent:
            retryCache = boundaryFiber.stateNode;
            break;

          default:
            throw new Error('Pinged unknown suspense boundary type. ' + 'This is probably a bug in React.');
        }

        if (retryCache !== null) {
          retryCache["delete"](wakeable);
        }

        retryTimedOutBoundary(boundaryFiber, retryLane);
      }

      function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
      }

      function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
          nestedUpdateCount = 0;
          rootWithNestedUpdates = null;
          throw new Error('Maximum update depth exceeded. This can happen when a component ' + 'repeatedly calls setState inside componentWillUpdate or ' + 'componentDidUpdate. React limits the number of nested updates to ' + 'prevent infinite loops.');
        }

        {
          if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
            error('Maximum update depth exceeded. This can happen when a component ' + "calls setState inside useEffect, but useEffect either doesn't " + 'have a dependency array, or one of the dependencies changes on ' + 'every render.');
          }
        }
      }

      function flushRenderPhaseStrictModeWarningsInDEV() {
        {
          ReactStrictModeWarnings.flushLegacyContextWarning();
          {
            ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
          }
        }
      }

      function commitDoubleInvokeEffectsInDEV(fiber, hasPassiveEffects) {
        {
          setCurrentFiber(fiber);
          invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectUnmountInDEV);

          if (hasPassiveEffects) {
            invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectUnmountInDEV);
          }

          invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectMountInDEV);

          if (hasPassiveEffects) {
            invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectMountInDEV);
          }

          resetCurrentFiber();
        }
      }

      function invokeEffectsInDev(firstChild, fiberFlags, invokeEffectFn) {
        {
          var current = firstChild;
          var subtreeRoot = null;

          while (current !== null) {
            var primarySubtreeFlag = current.subtreeFlags & fiberFlags;

            if (current !== subtreeRoot && current.child !== null && primarySubtreeFlag !== NoFlags) {
              current = current.child;
            } else {
              if ((current.flags & fiberFlags) !== NoFlags) {
                invokeEffectFn(current);
              }

              if (current.sibling !== null) {
                current = current.sibling;
              } else {
                current = subtreeRoot = current["return"];
              }
            }
          }
        }
      }

      var didWarnStateUpdateForNotYetMountedComponent = null;

      function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        {
          if ((executionContext & RenderContext) !== NoContext) {
            return;
          }

          if (!(fiber.mode & ConcurrentMode)) {
            return;
          }

          var tag = fiber.tag;

          if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent) {
            return;
          }

          var componentName = getComponentNameFromFiber(fiber) || 'ReactComponent';

          if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) {
              return;
            }

            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
          } else {
            didWarnStateUpdateForNotYetMountedComponent = new Set([componentName]);
          }

          var previousFiber = current;

          try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. " + 'This indicates that you have a side-effect in your render function that ' + 'asynchronously later calls tries to update the component. Move this work to ' + 'useEffect instead.');
          } finally {
            if (previousFiber) {
              setCurrentFiber(fiber);
            } else {
              resetCurrentFiber();
            }
          }
        }
      }

      var beginWork$1;
      {
        var dummyFiber = null;

        beginWork$1 = function beginWork$1(current, unitOfWork, lanes) {
          var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);

          try {
            return beginWork(current, unitOfWork, lanes);
          } catch (originalError) {
            if (originalError !== null && typeof originalError === 'object' && typeof originalError.then === 'function') {
              throw originalError;
            }

            resetContextDependencies();
            resetHooksAfterThrow();
            unwindInterruptedWork(current, unitOfWork);
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);

            if (unitOfWork.mode & ProfileMode) {
              startProfilerTimer(unitOfWork);
            }

            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);

            if (hasCaughtError()) {
              var replayError = clearCaughtError();

              if (typeof replayError === 'object' && replayError !== null && replayError._suppressLogging && typeof originalError === 'object' && originalError !== null && !originalError._suppressLogging) {
                originalError._suppressLogging = true;
              }
            }

            throw originalError;
          }
        };
      }
      var didWarnAboutUpdateInRender = false;
      var didWarnAboutUpdateInRenderForAnotherComponent;
      {
        didWarnAboutUpdateInRenderForAnotherComponent = new Set();
      }

      function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        {
          if (isRendering && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) {
            switch (fiber.tag) {
              case FunctionComponent:
              case ForwardRef:
              case SimpleMemoComponent:
                {
                  var renderingComponentName = workInProgress && getComponentNameFromFiber(workInProgress) || 'Unknown';
                  var dedupeKey = renderingComponentName;

                  if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentNameFromFiber(fiber) || 'Unknown';
                    error('Cannot update a component (`%s`) while rendering a ' + 'different component (`%s`). To locate the bad setState() call inside `%s`, ' + 'follow the stack trace as described in https://reactjs.org/link/setstate-in-render', setStateComponentName, renderingComponentName, renderingComponentName);
                  }

                  break;
                }

              case ClassComponent:
                {
                  if (!didWarnAboutUpdateInRender) {
                    error('Cannot update during an existing state transition (such as ' + 'within `render`). Render methods should be a pure ' + 'function of props and state.');
                    didWarnAboutUpdateInRender = true;
                  }

                  break;
                }
            }
          }
        }
      }

      function restorePendingUpdaters(root, lanes) {
        {
          if (isDevToolsPresent) {
            var memoizedUpdaters = root.memoizedUpdaters;
            memoizedUpdaters.forEach(function (schedulingFiber) {
              addFiberToLanesMap(root, schedulingFiber, lanes);
            });
          }
        }
      }

      var fakeActCallbackNode = {};

      function scheduleCallback$1(priorityLevel, callback) {
        {
          var actQueue = ReactCurrentActQueue$1.current;

          if (actQueue !== null) {
            actQueue.push(callback);
            return fakeActCallbackNode;
          } else {
            return scheduleCallback(priorityLevel, callback);
          }
        }
      }

      function cancelCallback$1(callbackNode) {
        if (callbackNode === fakeActCallbackNode) {
          return;
        }

        return cancelCallback(callbackNode);
      }

      function shouldForceFlushFallbacksInDEV() {
        return ReactCurrentActQueue$1.current !== null;
      }

      function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        {
          if (fiber.mode & ConcurrentMode) {
            if (!isConcurrentActEnvironment()) {
              return;
            }
          } else {
            if (!isLegacyActEnvironment()) {
              return;
            }

            if (executionContext !== NoContext) {
              return;
            }

            if (fiber.tag !== FunctionComponent && fiber.tag !== ForwardRef && fiber.tag !== SimpleMemoComponent) {
              return;
            }
          }

          if (ReactCurrentActQueue$1.current === null) {
            var previousFiber = current;

            try {
              setCurrentFiber(fiber);
              error('An update to %s inside a test was not wrapped in act(...).\n\n' + 'When testing, code that causes React state updates should be ' + 'wrapped into act(...):\n\n' + 'act(() => {\n' + '  /* fire events that update state */\n' + '});\n' + '/* assert on the output */\n\n' + "This ensures that you're testing the behavior the user would see " + 'in the browser.' + ' Learn more at https://reactjs.org/link/wrap-tests-with-act', getComponentNameFromFiber(fiber));
            } finally {
              if (previousFiber) {
                setCurrentFiber(fiber);
              } else {
                resetCurrentFiber();
              }
            }
          }
        }
      }

      function warnIfSuspenseResolutionNotWrappedWithActDEV(root) {
        {
          if (root.tag !== LegacyRoot && isConcurrentActEnvironment() && ReactCurrentActQueue$1.current === null) {
            error('A suspended resource finished loading inside a test, but the event ' + 'was not wrapped in act(...).\n\n' + 'When testing, code that resolves suspended data should be wrapped ' + 'into act(...):\n\n' + 'act(() => {\n' + '  /* finish loading suspended data */\n' + '});\n' + '/* assert on the output */\n\n' + "This ensures that you're testing the behavior the user would see " + 'in the browser.' + ' Learn more at https://reactjs.org/link/wrap-tests-with-act');
          }
        }
      }

      function setIsRunningInsertionEffect(isRunning) {
        {
          isRunningInsertionEffect = isRunning;
        }
      }

      var resolveFamily = null;
      var failedBoundaries = null;

      var setRefreshHandler = function setRefreshHandler(handler) {
        {
          resolveFamily = handler;
        }
      };

      function resolveFunctionForHotReloading(type) {
        {
          if (resolveFamily === null) {
            return type;
          }

          var family = resolveFamily(type);

          if (family === undefined) {
            return type;
          }

          return family.current;
        }
      }

      function resolveClassForHotReloading(type) {
        return resolveFunctionForHotReloading(type);
      }

      function resolveForwardRefForHotReloading(type) {
        {
          if (resolveFamily === null) {
            return type;
          }

          var family = resolveFamily(type);

          if (family === undefined) {
            if (type !== null && type !== undefined && typeof type.render === 'function') {
              var currentRender = resolveFunctionForHotReloading(type.render);

              if (type.render !== currentRender) {
                var syntheticType = {
                  $$typeof: REACT_FORWARD_REF_TYPE,
                  render: currentRender
                };

                if (type.displayName !== undefined) {
                  syntheticType.displayName = type.displayName;
                }

                return syntheticType;
              }
            }

            return type;
          }

          return family.current;
        }
      }

      function isCompatibleFamilyForHotReloading(fiber, element) {
        {
          if (resolveFamily === null) {
            return false;
          }

          var prevType = fiber.elementType;
          var nextType = element.type;
          var needsCompareFamilies = false;
          var $$typeofNextType = typeof nextType === 'object' && nextType !== null ? nextType.$$typeof : null;

          switch (fiber.tag) {
            case ClassComponent:
              {
                if (typeof nextType === 'function') {
                  needsCompareFamilies = true;
                }

                break;
              }

            case FunctionComponent:
              {
                if (typeof nextType === 'function') {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }

                break;
              }

            case ForwardRef:
              {
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }

                break;
              }

            case MemoComponent:
            case SimpleMemoComponent:
              {
                if ($$typeofNextType === REACT_MEMO_TYPE) {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }

                break;
              }

            default:
              return false;
          }

          if (needsCompareFamilies) {
            var prevFamily = resolveFamily(prevType);

            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) {
              return true;
            }
          }

          return false;
        }
      }

      function markFailedErrorBoundaryForHotReloading(fiber) {
        {
          if (resolveFamily === null) {
            return;
          }

          if (typeof WeakSet !== 'function') {
            return;
          }

          if (failedBoundaries === null) {
            failedBoundaries = new WeakSet();
          }

          failedBoundaries.add(fiber);
        }
      }

      var scheduleRefresh = function scheduleRefresh(root, update) {
        {
          if (resolveFamily === null) {
            return;
          }

          var staleFamilies = update.staleFamilies,
              updatedFamilies = update.updatedFamilies;
          flushPassiveEffects();
          flushSync(function () {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
          });
        }
      };

      var scheduleRoot = function scheduleRoot(root, element) {
        {
          if (root.context !== emptyContextObject) {
            return;
          }

          flushPassiveEffects();
          flushSync(function () {
            updateContainer(element, root, null, null);
          });
        }
      };

      function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        {
          var alternate = fiber.alternate,
              child = fiber.child,
              sibling = fiber.sibling,
              tag = fiber.tag,
              type = fiber.type;
          var candidateType = null;

          switch (tag) {
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
              candidateType = type;
              break;

            case ForwardRef:
              candidateType = type.render;
              break;
          }

          if (resolveFamily === null) {
            throw new Error('Expected resolveFamily to be set during hot reload.');
          }

          var needsRender = false;
          var needsRemount = false;

          if (candidateType !== null) {
            var family = resolveFamily(candidateType);

            if (family !== undefined) {
              if (staleFamilies.has(family)) {
                needsRemount = true;
              } else if (updatedFamilies.has(family)) {
                if (tag === ClassComponent) {
                  needsRemount = true;
                } else {
                  needsRender = true;
                }
              }
            }
          }

          if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) {
              needsRemount = true;
            }
          }

          if (needsRemount) {
            fiber._debugNeedsRemount = true;
          }

          if (needsRemount || needsRender) {
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          }

          if (child !== null && !needsRemount) {
            scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
          }

          if (sibling !== null) {
            scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
          }
        }
      }

      var findHostInstancesForRefresh = function findHostInstancesForRefresh(root, families) {
        {
          var hostInstances = new Set();
          var types = new Set(families.map(function (family) {
            return family.current;
          }));
          findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
          return hostInstances;
        }
      };

      function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        {
          var child = fiber.child,
              sibling = fiber.sibling,
              tag = fiber.tag,
              type = fiber.type;
          var candidateType = null;

          switch (tag) {
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
              candidateType = type;
              break;

            case ForwardRef:
              candidateType = type.render;
              break;
          }

          var didMatch = false;

          if (candidateType !== null) {
            if (types.has(candidateType)) {
              didMatch = true;
            }
          }

          if (didMatch) {
            findHostInstancesForFiberShallowly(fiber, hostInstances);
          } else {
            if (child !== null) {
              findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
            }
          }

          if (sibling !== null) {
            findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
          }
        }
      }

      function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        {
          var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);

          if (foundHostInstances) {
            return;
          }

          var node = fiber;

          while (true) {
            switch (node.tag) {
              case HostComponent:
                hostInstances.add(node.stateNode);
                return;

              case HostPortal:
                hostInstances.add(node.stateNode.containerInfo);
                return;

              case HostRoot:
                hostInstances.add(node.stateNode.containerInfo);
                return;
            }

            if (node["return"] === null) {
              throw new Error('Expected to reach root first.');
            }

            node = node["return"];
          }
        }
      }

      function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        {
          var node = fiber;
          var foundHostInstances = false;

          while (true) {
            if (node.tag === HostComponent) {
              foundHostInstances = true;
              hostInstances.add(node.stateNode);
            } else if (node.child !== null) {
              node.child["return"] = node;
              node = node.child;
              continue;
            }

            if (node === fiber) {
              return foundHostInstances;
            }

            while (node.sibling === null) {
              if (node["return"] === null || node["return"] === fiber) {
                return foundHostInstances;
              }

              node = node["return"];
            }

            node.sibling["return"] = node["return"];
            node = node.sibling;
          }
        }
        return false;
      }

      var hasBadMapPolyfill;
      {
        hasBadMapPolyfill = false;

        try {
          var nonExtensibleObject = Object.preventExtensions({});
          new Map([[nonExtensibleObject, null]]);
          new Set([nonExtensibleObject]);
        } catch (e) {
          hasBadMapPolyfill = true;
        }
      }

      function FiberNode(tag, pendingProps, key, mode) {
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null;
        this["return"] = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode;
        this.flags = NoFlags;
        this.subtreeFlags = NoFlags;
        this.deletions = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        {
          this.actualDuration = Number.NaN;
          this.actualStartTime = Number.NaN;
          this.selfBaseDuration = Number.NaN;
          this.treeBaseDuration = Number.NaN;
          this.actualDuration = 0;
          this.actualStartTime = -1;
          this.selfBaseDuration = 0;
          this.treeBaseDuration = 0;
        }
        {
          this._debugSource = null;
          this._debugOwner = null;
          this._debugNeedsRemount = false;
          this._debugHookTypes = null;

          if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') {
            Object.preventExtensions(this);
          }
        }
      }

      var createFiber = function createFiber(tag, pendingProps, key, mode) {
        return new FiberNode(tag, pendingProps, key, mode);
      };

      function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }

      function isSimpleFunctionComponent(type) {
        return typeof type === 'function' && !shouldConstruct$1(type) && type.defaultProps === undefined;
      }

      function resolveLazyComponentTag(Component) {
        if (typeof Component === 'function') {
          return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        } else if (Component !== undefined && Component !== null) {
          var $$typeof = Component.$$typeof;

          if ($$typeof === REACT_FORWARD_REF_TYPE) {
            return ForwardRef;
          }

          if ($$typeof === REACT_MEMO_TYPE) {
            return MemoComponent;
          }
        }

        return IndeterminateComponent;
      }

      function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;

        if (workInProgress === null) {
          workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
          workInProgress.elementType = current.elementType;
          workInProgress.type = current.type;
          workInProgress.stateNode = current.stateNode;
          {
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
          }
          workInProgress.alternate = current;
          current.alternate = workInProgress;
        } else {
          workInProgress.pendingProps = pendingProps;
          workInProgress.type = current.type;
          workInProgress.flags = NoFlags;
          workInProgress.subtreeFlags = NoFlags;
          workInProgress.deletions = null;
          {
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
          }
        }

        workInProgress.flags = current.flags & StaticMask;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue;
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
          lanes: currentDependencies.lanes,
          firstContext: currentDependencies.firstContext
        };
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        {
          workInProgress.selfBaseDuration = current.selfBaseDuration;
          workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        {
          workInProgress._debugNeedsRemount = current._debugNeedsRemount;

          switch (workInProgress.tag) {
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
              workInProgress.type = resolveFunctionForHotReloading(current.type);
              break;

            case ClassComponent:
              workInProgress.type = resolveClassForHotReloading(current.type);
              break;

            case ForwardRef:
              workInProgress.type = resolveForwardRefForHotReloading(current.type);
              break;
          }
        }
        return workInProgress;
      }

      function resetWorkInProgress(workInProgress, renderLanes) {
        workInProgress.flags &= StaticMask | Placement;
        var current = workInProgress.alternate;

        if (current === null) {
          workInProgress.childLanes = NoLanes;
          workInProgress.lanes = renderLanes;
          workInProgress.child = null;
          workInProgress.subtreeFlags = NoFlags;
          workInProgress.memoizedProps = null;
          workInProgress.memoizedState = null;
          workInProgress.updateQueue = null;
          workInProgress.dependencies = null;
          workInProgress.stateNode = null;
          {
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
          }
        } else {
          workInProgress.childLanes = current.childLanes;
          workInProgress.lanes = current.lanes;
          workInProgress.child = current.child;
          workInProgress.subtreeFlags = NoFlags;
          workInProgress.deletions = null;
          workInProgress.memoizedProps = current.memoizedProps;
          workInProgress.memoizedState = current.memoizedState;
          workInProgress.updateQueue = current.updateQueue;
          workInProgress.type = current.type;
          var currentDependencies = current.dependencies;
          workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
          };
          {
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
          }
        }

        return workInProgress;
      }

      function createHostRootFiber(tag, isStrictMode, concurrentUpdatesByDefaultOverride) {
        var mode;

        if (tag === ConcurrentRoot) {
          mode = ConcurrentMode;

          if (isStrictMode === true) {
            mode |= StrictLegacyMode;
            {
              mode |= StrictEffectsMode;
            }
          }
        } else {
          mode = NoMode;
        }

        if (isDevToolsPresent) {
          mode |= ProfileMode;
        }

        return createFiber(HostRoot, null, null, mode);
      }

      function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent;
        var resolvedType = type;

        if (typeof type === 'function') {
          if (shouldConstruct$1(type)) {
            fiberTag = ClassComponent;
            {
              resolvedType = resolveClassForHotReloading(resolvedType);
            }
          } else {
            {
              resolvedType = resolveFunctionForHotReloading(resolvedType);
            }
          }
        } else if (typeof type === 'string') {
          fiberTag = HostComponent;
        } else {
          getTag: switch (type) {
            case REACT_FRAGMENT_TYPE:
              return createFiberFromFragment(pendingProps.children, mode, lanes, key);

            case REACT_STRICT_MODE_TYPE:
              fiberTag = Mode;
              mode |= StrictLegacyMode;

              if ((mode & ConcurrentMode) !== NoMode) {
                mode |= StrictEffectsMode;
              }

              break;

            case REACT_PROFILER_TYPE:
              return createFiberFromProfiler(pendingProps, mode, lanes, key);

            case REACT_SUSPENSE_TYPE:
              return createFiberFromSuspense(pendingProps, mode, lanes, key);

            case REACT_SUSPENSE_LIST_TYPE:
              return createFiberFromSuspenseList(pendingProps, mode, lanes, key);

            case REACT_OFFSCREEN_TYPE:
              return createFiberFromOffscreen(pendingProps, mode, lanes, key);

            case REACT_LEGACY_HIDDEN_TYPE:
            case REACT_SCOPE_TYPE:
            case REACT_CACHE_TYPE:
            case REACT_TRACING_MARKER_TYPE:
            case REACT_DEBUG_TRACING_MODE_TYPE:
            default:
              {
                if (typeof type === 'object' && type !== null) {
                  switch (type.$$typeof) {
                    case REACT_PROVIDER_TYPE:
                      fiberTag = ContextProvider;
                      break getTag;

                    case REACT_CONTEXT_TYPE:
                      fiberTag = ContextConsumer;
                      break getTag;

                    case REACT_FORWARD_REF_TYPE:
                      fiberTag = ForwardRef;
                      {
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                      }
                      break getTag;

                    case REACT_MEMO_TYPE:
                      fiberTag = MemoComponent;
                      break getTag;

                    case REACT_LAZY_TYPE:
                      fiberTag = LazyComponent;
                      resolvedType = null;
                      break getTag;
                  }
                }

                var info = '';
                {
                  if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
                    info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and " + 'named imports.';
                  }

                  var ownerName = owner ? getComponentNameFromFiber(owner) : null;

                  if (ownerName) {
                    info += '\n\nCheck the render method of `' + ownerName + '`.';
                  }
                }
                throw new Error('Element type is invalid: expected a string (for built-in ' + 'components) or a class/function (for composite components) ' + ("but got: " + (type == null ? type : typeof type) + "." + info));
              }
          }
        }

        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        {
          fiber._debugOwner = owner;
        }
        return fiber;
      }

      function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        {
          owner = element._owner;
        }
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        {
          fiber._debugSource = element._source;
          fiber._debugOwner = element._owner;
        }
        return fiber;
      }

      function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
      }

      function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        {
          if (typeof pendingProps.id !== 'string') {
            error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof pendingProps.id);
          }
        }
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        {
          fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
          };
        }
        return fiber;
      }

      function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
      }

      function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
      }

      function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        var primaryChildInstance = {};
        fiber.stateNode = primaryChildInstance;
        return fiber;
      }

      function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
      }

      function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode);
        fiber.elementType = 'DELETED';
        return fiber;
      }

      function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
      }

      function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
          containerInfo: portal.containerInfo,
          pendingChildren: null,
          implementation: portal.implementation
        };
        return fiber;
      }

      function assignFiberPropertiesInDEV(target, source) {
        if (target === null) {
          target = createFiber(IndeterminateComponent, null, null, NoMode);
        }

        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target["return"] = source["return"];
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.subtreeFlags = source.subtreeFlags;
        target.deletions = source.deletions;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        {
          target.actualDuration = source.actualDuration;
          target.actualStartTime = source.actualStartTime;
          target.selfBaseDuration = source.selfBaseDuration;
          target.treeBaseDuration = source.treeBaseDuration;
        }
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
      }

      function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.callbackNode = null;
        this.callbackPriority = NoLane;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.identifierPrefix = identifierPrefix;
        this.onRecoverableError = onRecoverableError;
        {
          this.mutableSourceEagerHydrationData = null;
        }
        {
          this.effectDuration = 0;
          this.passiveEffectDuration = 0;
        }
        {
          this.memoizedUpdaters = new Set();
          var pendingUpdatersLaneMap = this.pendingUpdatersLaneMap = [];

          for (var _i = 0; _i < TotalLanes; _i++) {
            pendingUpdatersLaneMap.push(new Set());
          }
        }
        {
          switch (tag) {
            case ConcurrentRoot:
              this._debugRootType = hydrate ? 'hydrateRoot()' : 'createRoot()';
              break;

            case LegacyRoot:
              this._debugRootType = hydrate ? 'hydrate()' : 'render()';
              break;
          }
        }
      }

      function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError);
        var uninitializedFiber = createHostRootFiber(tag, isStrictMode);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        {
          var _initialState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: null,
            transitions: null,
            pendingSuspenseBoundaries: null
          };
          uninitializedFiber.memoizedState = _initialState;
        }
        initializeUpdateQueue(uninitializedFiber);
        return root;
      }

      var ReactVersion = '18.1.0';

      function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        {
          checkKeyStringCoercion(key);
        }
        return {
          $$typeof: REACT_PORTAL_TYPE,
          key: key == null ? null : '' + key,
          children: children,
          containerInfo: containerInfo,
          implementation: implementation
        };
      }

      var didWarnAboutNestedUpdates;
      var didWarnAboutFindNodeInStrictMode;
      {
        didWarnAboutNestedUpdates = false;
        didWarnAboutFindNodeInStrictMode = {};
      }

      function getContextForSubtree(parentComponent) {
        if (!parentComponent) {
          return emptyContextObject;
        }

        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);

        if (fiber.tag === ClassComponent) {
          var Component = fiber.type;

          if (isContextProvider(Component)) {
            return processChildContext(fiber, Component, parentContext);
          }
        }

        return parentContext;
      }

      function findHostInstanceWithWarning(component, methodName) {
        {
          var fiber = get(component);

          if (fiber === undefined) {
            if (typeof component.render === 'function') {
              throw new Error('Unable to find node on an unmounted component.');
            } else {
              var keys = Object.keys(component).join(',');
              throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys);
            }
          }

          var hostFiber = findCurrentHostFiber(fiber);

          if (hostFiber === null) {
            return null;
          }

          if (hostFiber.mode & StrictLegacyMode) {
            var componentName = getComponentNameFromFiber(fiber) || 'Component';

            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
              didWarnAboutFindNodeInStrictMode[componentName] = true;
              var previousFiber = current;

              try {
                setCurrentFiber(hostFiber);

                if (fiber.mode & StrictLegacyMode) {
                  error('%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which is inside StrictMode. ' + 'Instead, add a ref directly to the element you want to reference. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-find-node', methodName, methodName, componentName);
                } else {
                  error('%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which renders StrictMode children. ' + 'Instead, add a ref directly to the element you want to reference. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-find-node', methodName, methodName, componentName);
                }
              } finally {
                if (previousFiber) {
                  setCurrentFiber(previousFiber);
                } else {
                  resetCurrentFiber();
                }
              }
            }
          }

          return hostFiber.stateNode;
        }
      }

      function createContainer(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = false;
        var initialChildren = null;
        return createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
      }

      function createHydrationContainer(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = true;
        var root = createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        root.context = getContextForSubtree(null);
        var current = root.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current);
        var update = createUpdate(eventTime, lane);
        update.callback = callback !== undefined && callback !== null ? callback : null;
        enqueueUpdate(current, update);
        scheduleInitialHydrationOnRoot(root, lane, eventTime);
        return root;
      }

      function updateContainer(element, container, parentComponent, callback) {
        {
          onScheduleRoot(container, element);
        }
        var current$1 = container.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current$1);
        {
          markRenderScheduled(lane);
        }
        var context = getContextForSubtree(parentComponent);

        if (container.context === null) {
          container.context = context;
        } else {
          container.pendingContext = context;
        }

        {
          if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error('Render methods should be a pure function of props and state; ' + 'triggering nested component updates from render is not allowed. ' + 'If necessary, trigger nested updates in componentDidUpdate.\n\n' + 'Check the render method of %s.', getComponentNameFromFiber(current) || 'Unknown');
          }
        }
        var update = createUpdate(eventTime, lane);
        update.payload = {
          element: element
        };
        callback = callback === undefined ? null : callback;

        if (callback !== null) {
          {
            if (typeof callback !== 'function') {
              error('render(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callback);
            }
          }
          update.callback = callback;
        }

        enqueueUpdate(current$1, update);
        var root = scheduleUpdateOnFiber(current$1, lane, eventTime);

        if (root !== null) {
          entangleTransitions(root, current$1, lane);
        }

        return lane;
      }

      function getPublicRootInstance(container) {
        var containerFiber = container.current;

        if (!containerFiber.child) {
          return null;
        }

        switch (containerFiber.child.tag) {
          case HostComponent:
            return getPublicInstance(containerFiber.child.stateNode);

          default:
            return containerFiber.child.stateNode;
        }
      }

      function attemptSynchronousHydration$1(fiber) {
        switch (fiber.tag) {
          case HostRoot:
            var root = fiber.stateNode;

            if (isRootDehydrated(root)) {
              var lanes = getHighestPriorityPendingLanes(root);
              flushRoot(root, lanes);
            }

            break;

          case SuspenseComponent:
            var eventTime = requestEventTime();
            flushSync(function () {
              return scheduleUpdateOnFiber(fiber, SyncLane, eventTime);
            });
            var retryLane = SyncLane;
            markRetryLaneIfNotHydrated(fiber, retryLane);
            break;
        }
      }

      function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;

        if (suspenseState !== null && suspenseState.dehydrated !== null) {
          suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
        }
      }

      function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;

        if (alternate) {
          markRetryLaneImpl(alternate, retryLane);
        }
      }

      function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) {
          return;
        }

        var eventTime = requestEventTime();
        var lane = SelectiveHydrationLane;
        scheduleUpdateOnFiber(fiber, lane, eventTime);
        markRetryLaneIfNotHydrated(fiber, lane);
      }

      function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) {
          return;
        }

        var eventTime = requestEventTime();
        var lane = requestUpdateLane(fiber);
        scheduleUpdateOnFiber(fiber, lane, eventTime);
        markRetryLaneIfNotHydrated(fiber, lane);
      }

      function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);

        if (hostFiber === null) {
          return null;
        }

        return hostFiber.stateNode;
      }

      var shouldErrorImpl = function shouldErrorImpl(fiber) {
        return null;
      };

      function shouldError(fiber) {
        return shouldErrorImpl(fiber);
      }

      var shouldSuspendImpl = function shouldSuspendImpl(fiber) {
        return false;
      };

      function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
      }

      var overrideHookState = null;
      var overrideHookStateDeletePath = null;
      var overrideHookStateRenamePath = null;
      var overrideProps = null;
      var overridePropsDeletePath = null;
      var overridePropsRenamePath = null;
      var scheduleUpdate = null;
      var setErrorHandler = null;
      var setSuspenseHandler = null;
      {
        var copyWithDeleteImpl = function copyWithDeleteImpl(obj, path, index) {
          var key = path[index];
          var updated = isArray(obj) ? obj.slice() : assign({}, obj);

          if (index + 1 === path.length) {
            if (isArray(updated)) {
              updated.splice(key, 1);
            } else {
              delete updated[key];
            }

            return updated;
          }

          updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
          return updated;
        };

        var copyWithDelete = function copyWithDelete(obj, path) {
          return copyWithDeleteImpl(obj, path, 0);
        };

        var copyWithRenameImpl = function copyWithRenameImpl(obj, oldPath, newPath, index) {
          var oldKey = oldPath[index];
          var updated = isArray(obj) ? obj.slice() : assign({}, obj);

          if (index + 1 === oldPath.length) {
            var newKey = newPath[index];
            updated[newKey] = updated[oldKey];

            if (isArray(updated)) {
              updated.splice(oldKey, 1);
            } else {
              delete updated[oldKey];
            }
          } else {
            updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
          }

          return updated;
        };

        var copyWithRename = function copyWithRename(obj, oldPath, newPath) {
          if (oldPath.length !== newPath.length) {
            warn('copyWithRename() expects paths of the same length');
            return;
          } else {
            for (var i = 0; i < newPath.length - 1; i++) {
              if (oldPath[i] !== newPath[i]) {
                warn('copyWithRename() expects paths to be the same except for the deepest key');
                return;
              }
            }
          }

          return copyWithRenameImpl(obj, oldPath, newPath, 0);
        };

        var copyWithSetImpl = function copyWithSetImpl(obj, path, index, value) {
          if (index >= path.length) {
            return value;
          }

          var key = path[index];
          var updated = isArray(obj) ? obj.slice() : assign({}, obj);
          updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
          return updated;
        };

        var copyWithSet = function copyWithSet(obj, path, value) {
          return copyWithSetImpl(obj, path, 0, value);
        };

        var findHook = function findHook(fiber, id) {
          var currentHook = fiber.memoizedState;

          while (currentHook !== null && id > 0) {
            currentHook = currentHook.next;
            id--;
          }

          return currentHook;
        };

        overrideHookState = function overrideHookState(fiber, id, path, value) {
          var hook = findHook(fiber, id);

          if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState;
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          }
        };

        overrideHookStateDeletePath = function overrideHookStateDeletePath(fiber, id, path) {
          var hook = findHook(fiber, id);

          if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState;
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          }
        };

        overrideHookStateRenamePath = function overrideHookStateRenamePath(fiber, id, oldPath, newPath) {
          var hook = findHook(fiber, id);

          if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState;
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          }
        };

        overrideProps = function overrideProps(fiber, path, value) {
          fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);

          if (fiber.alternate) {
            fiber.alternate.pendingProps = fiber.pendingProps;
          }

          scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        };

        overridePropsDeletePath = function overridePropsDeletePath(fiber, path) {
          fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);

          if (fiber.alternate) {
            fiber.alternate.pendingProps = fiber.pendingProps;
          }

          scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        };

        overridePropsRenamePath = function overridePropsRenamePath(fiber, oldPath, newPath) {
          fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);

          if (fiber.alternate) {
            fiber.alternate.pendingProps = fiber.pendingProps;
          }

          scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        };

        scheduleUpdate = function scheduleUpdate(fiber) {
          scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        };

        setErrorHandler = function setErrorHandler(newShouldErrorImpl) {
          shouldErrorImpl = newShouldErrorImpl;
        };

        setSuspenseHandler = function setSuspenseHandler(newShouldSuspendImpl) {
          shouldSuspendImpl = newShouldSuspendImpl;
        };
      }

      function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);

        if (hostFiber === null) {
          return null;
        }

        return hostFiber.stateNode;
      }

      function emptyFindFiberByHostInstance(instance) {
        return null;
      }

      function getCurrentFiberForDevTools() {
        return current;
      }

      function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
          bundleType: devToolsConfig.bundleType,
          version: devToolsConfig.version,
          rendererPackageName: devToolsConfig.rendererPackageName,
          rendererConfig: devToolsConfig.rendererConfig,
          overrideHookState: overrideHookState,
          overrideHookStateDeletePath: overrideHookStateDeletePath,
          overrideHookStateRenamePath: overrideHookStateRenamePath,
          overrideProps: overrideProps,
          overridePropsDeletePath: overridePropsDeletePath,
          overridePropsRenamePath: overridePropsRenamePath,
          setErrorHandler: setErrorHandler,
          setSuspenseHandler: setSuspenseHandler,
          scheduleUpdate: scheduleUpdate,
          currentDispatcherRef: ReactCurrentDispatcher,
          findHostInstanceByFiber: findHostInstanceByFiber,
          findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
          findHostInstancesForRefresh: findHostInstancesForRefresh,
          scheduleRefresh: scheduleRefresh,
          scheduleRoot: scheduleRoot,
          setRefreshHandler: setRefreshHandler,
          getCurrentFiber: getCurrentFiberForDevTools,
          reconcilerVersion: ReactVersion
        });
      }

      var defaultOnRecoverableError = typeof reportError === 'function' ? reportError : function (error) {
        console['error'](error);
      };

      function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
      }

      ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function (children) {
        var root = this._internalRoot;

        if (root === null) {
          throw new Error('Cannot update an unmounted root.');
        }

        {
          if (typeof arguments[1] === 'function') {
            error('render(...): does not support the second callback argument. ' + 'To execute a side effect after rendering, declare it in a component body with useEffect().');
          } else if (isValidContainer(arguments[1])) {
            error('You passed a container to the second argument of root.render(...). ' + "You don't need to pass it again since you already passed it to create the root.");
          } else if (typeof arguments[1] !== 'undefined') {
            error('You passed a second argument to root.render(...) but it only accepts ' + 'one argument.');
          }

          var container = root.containerInfo;

          if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);

            if (hostInstance) {
              if (hostInstance.parentNode !== container) {
                error('render(...): It looks like the React-rendered content of the ' + 'root container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + "root.unmount() to empty a root's container.");
              }
            }
          }
        }
        updateContainer(children, root, null, null);
      };

      ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function () {
        {
          if (typeof arguments[0] === 'function') {
            error('unmount(...): does not support a callback argument. ' + 'To execute a side effect after rendering, declare it in a component body with useEffect().');
          }
        }
        var root = this._internalRoot;

        if (root !== null) {
          this._internalRoot = null;
          var container = root.containerInfo;
          {
            if (isAlreadyRendering()) {
              error('Attempted to synchronously unmount a root while React was already ' + 'rendering. React cannot finish unmounting the root until the ' + 'current render has completed, which may lead to a race condition.');
            }
          }
          flushSync(function () {
            updateContainer(null, root, null, null);
          });
          unmarkContainerAsRoot(container);
        }
      };

      function createRoot(container, options) {
        if (!isValidContainer(container)) {
          throw new Error('createRoot(...): Target container is not a DOM element.');
        }

        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = '';
        var onRecoverableError = defaultOnRecoverableError;

        if (options !== null && options !== undefined) {
          {
            if (options.hydrate) {
              warn('hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.');
            } else {
              if (typeof options === 'object' && options !== null && options.$$typeof === REACT_ELEMENT_TYPE) {
                error('You passed a JSX element to createRoot. You probably meant to ' + 'call root.render instead. ' + 'Example usage:\n\n' + '  let root = createRoot(domContainer);\n' + '  root.render(<App />);');
              }
            }
          }

          if (options.unstable_strictMode === true) {
            isStrictMode = true;
          }

          if (options.identifierPrefix !== undefined) {
            identifierPrefix = options.identifierPrefix;
          }

          if (options.onRecoverableError !== undefined) {
            onRecoverableError = options.onRecoverableError;
          }
        }

        var root = createContainer(container, ConcurrentRoot, null, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        return new ReactDOMRoot(root);
      }

      function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
      }

      function scheduleHydration(target) {
        if (target) {
          queueExplicitHydrationTarget(target);
        }
      }

      ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = scheduleHydration;

      function hydrateRoot(container, initialChildren, options) {
        if (!isValidContainer(container)) {
          throw new Error('hydrateRoot(...): Target container is not a DOM element.');
        }

        warnIfReactDOMContainerInDEV(container);
        {
          if (initialChildren === undefined) {
            error('Must provide initial children as second argument to hydrateRoot. ' + 'Example usage: hydrateRoot(domContainer, <App />)');
          }
        }
        var hydrationCallbacks = options != null ? options : null;
        var mutableSources = options != null && options.hydratedSources || null;
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = '';
        var onRecoverableError = defaultOnRecoverableError;

        if (options !== null && options !== undefined) {
          if (options.unstable_strictMode === true) {
            isStrictMode = true;
          }

          if (options.identifierPrefix !== undefined) {
            identifierPrefix = options.identifierPrefix;
          }

          if (options.onRecoverableError !== undefined) {
            onRecoverableError = options.onRecoverableError;
          }
        }

        var root = createHydrationContainer(initialChildren, null, container, ConcurrentRoot, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        listenToAllSupportedEvents(container);

        if (mutableSources) {
          for (var i = 0; i < mutableSources.length; i++) {
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
          }
        }

        return new ReactDOMHydrationRoot(root);
      }

      function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || !disableCommentsAsDOMContainers));
      }

      function isValidContainerLegacy(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === ' react-mount-point-unstable '));
      }

      function warnIfReactDOMContainerInDEV(container) {
        {
          if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') {
            error('createRoot(): Creating roots directly with document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try using a container element created ' + 'for your app.');
          }

          if (isContainerMarkedAsRoot(container)) {
            if (container._reactRootContainer) {
              error('You are calling ReactDOMClient.createRoot() on a container that was previously ' + 'passed to ReactDOM.render(). This is not supported.');
            } else {
              error('You are calling ReactDOMClient.createRoot() on a container that ' + 'has already been passed to createRoot() before. Instead, call ' + 'root.render() on the existing root instead if you want to update it.');
            }
          }
        }
      }

      var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
      var topLevelUpdateWarnings;
      {
        topLevelUpdateWarnings = function topLevelUpdateWarnings(container) {
          if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer.current);

            if (hostInstance) {
              if (hostInstance.parentNode !== container) {
                error('render(...): It looks like the React-rendered content of this ' + 'container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + 'ReactDOM.unmountComponentAtNode to empty a container.');
              }
            }
          }

          var isRootRenderedBySomeReact = !!container._reactRootContainer;
          var rootEl = getReactRootElementInContainer(container);
          var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));

          if (hasNonRootReactChild && !isRootRenderedBySomeReact) {
            error('render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.');
          }

          if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') {
            error('render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.');
          }
        };
      }

      function getReactRootElementInContainer(container) {
        if (!container) {
          return null;
        }

        if (container.nodeType === DOCUMENT_NODE) {
          return container.documentElement;
        } else {
          return container.firstChild;
        }
      }

      function noopOnRecoverableError() {}

      function legacyCreateRootFromDOMContainer(container, initialChildren, parentComponent, callback, isHydrationContainer) {
        if (isHydrationContainer) {
          if (typeof callback === 'function') {
            var originalCallback = callback;

            callback = function callback() {
              var instance = getPublicRootInstance(root);
              originalCallback.call(instance);
            };
          }

          var root = createHydrationContainer(initialChildren, callback, container, LegacyRoot, null, false, false, '', noopOnRecoverableError);
          container._reactRootContainer = root;
          markContainerAsRoot(root.current, container);
          var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
          listenToAllSupportedEvents(rootContainerElement);
          flushSync();
          return root;
        } else {
          var rootSibling;

          while (rootSibling = container.lastChild) {
            container.removeChild(rootSibling);
          }

          if (typeof callback === 'function') {
            var _originalCallback = callback;

            callback = function callback() {
              var instance = getPublicRootInstance(_root);

              _originalCallback.call(instance);
            };
          }

          var _root = createContainer(container, LegacyRoot, null, false, false, '', noopOnRecoverableError);

          container._reactRootContainer = _root;
          markContainerAsRoot(_root.current, container);

          var _rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;

          listenToAllSupportedEvents(_rootContainerElement);
          flushSync(function () {
            updateContainer(initialChildren, _root, parentComponent, callback);
          });
          return _root;
        }
      }

      function warnOnInvalidCallback$1(callback, callerName) {
        {
          if (callback !== null && typeof callback !== 'function') {
            error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
          }
        }
      }

      function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        {
          topLevelUpdateWarnings(container);
          warnOnInvalidCallback$1(callback === undefined ? null : callback, 'render');
        }
        var maybeRoot = container._reactRootContainer;
        var root;

        if (!maybeRoot) {
          root = legacyCreateRootFromDOMContainer(container, children, parentComponent, callback, forceHydrate);
        } else {
          root = maybeRoot;

          if (typeof callback === 'function') {
            var originalCallback = callback;

            callback = function callback() {
              var instance = getPublicRootInstance(root);
              originalCallback.call(instance);
            };
          }

          updateContainer(children, root, parentComponent, callback);
        }

        return getPublicRootInstance(root);
      }

      function findDOMNode(componentOrElement) {
        {
          var owner = ReactCurrentOwner$3.current;

          if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;

            if (!warnedAboutRefsInRender) {
              error('%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentNameFromType(owner.type) || 'A component');
            }

            owner.stateNode._warnedAboutRefsInRender = true;
          }
        }

        if (componentOrElement == null) {
          return null;
        }

        if (componentOrElement.nodeType === ELEMENT_NODE) {
          return componentOrElement;
        }

        {
          return findHostInstanceWithWarning(componentOrElement, 'findDOMNode');
        }
      }

      function hydrate(element, container, callback) {
        {
          error('ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot ' + 'instead. Until you switch to the new API, your app will behave as ' + "if it's running React 17. Learn " + 'more: https://reactjs.org/link/switch-to-createroot');
        }

        if (!isValidContainerLegacy(container)) {
          throw new Error('Target container is not a DOM element.');
        }

        {
          var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;

          if (isModernRoot) {
            error('You are calling ReactDOM.hydrate() on a container that was previously ' + 'passed to ReactDOMClient.createRoot(). This is not supported. ' + 'Did you mean to call hydrateRoot(container, element)?');
          }
        }
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
      }

      function render(element, container, callback) {
        {
          error('ReactDOM.render is no longer supported in React 18. Use createRoot ' + 'instead. Until you switch to the new API, your app will behave as ' + "if it's running React 17. Learn " + 'more: https://reactjs.org/link/switch-to-createroot');
        }

        if (!isValidContainerLegacy(container)) {
          throw new Error('Target container is not a DOM element.');
        }

        {
          var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;

          if (isModernRoot) {
            error('You are calling ReactDOM.render() on a container that was previously ' + 'passed to ReactDOMClient.createRoot(). This is not supported. ' + 'Did you mean to call root.render(element)?');
          }
        }
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
      }

      function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        {
          error('ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported ' + 'in React 18. Consider using a portal instead. Until you switch to ' + "the createRoot API, your app will behave as if it's running React " + '17. Learn more: https://reactjs.org/link/switch-to-createroot');
        }

        if (!isValidContainerLegacy(containerNode)) {
          throw new Error('Target container is not a DOM element.');
        }

        if (parentComponent == null || !has(parentComponent)) {
          throw new Error('parentComponent must be a valid React Component');
        }

        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
      }

      function unmountComponentAtNode(container) {
        if (!isValidContainerLegacy(container)) {
          throw new Error('unmountComponentAtNode(...): Target container is not a DOM element.');
        }

        {
          var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;

          if (isModernRoot) {
            error('You are calling ReactDOM.unmountComponentAtNode() on a container that was previously ' + 'passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?');
          }
        }

        if (container._reactRootContainer) {
          {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);

            if (renderedByDifferentReact) {
              error("unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.');
            }
          }
          flushSync(function () {
            legacyRenderSubtreeIntoContainer(null, null, container, false, function () {
              container._reactRootContainer = null;
              unmarkContainerAsRoot(container);
            });
          });
          return true;
        } else {
          {
            var _rootEl = getReactRootElementInContainer(container);

            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl));
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainerLegacy(container.parentNode) && !!container.parentNode._reactRootContainer;

            if (hasNonRootReactChild) {
              error("unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.');
            }
          }
          return false;
        }
      }

      setAttemptSynchronousHydration(attemptSynchronousHydration$1);
      setAttemptContinuousHydration(attemptContinuousHydration$1);
      setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
      setGetCurrentUpdatePriority(getCurrentUpdatePriority);
      setAttemptHydrationAtPriority(runWithPriority);
      {
        if (typeof Map !== 'function' || Map.prototype == null || typeof Map.prototype.forEach !== 'function' || typeof Set !== 'function' || Set.prototype == null || typeof Set.prototype.clear !== 'function' || typeof Set.prototype.forEach !== 'function') {
          error('React depends on Map and Set built-in types. Make sure that you load a ' + 'polyfill in older browsers. https://reactjs.org/link/react-polyfills');
        }
      }
      setRestoreImplementation(restoreControlledState$3);
      setBatchingImplementation(batchedUpdates$1, discreteUpdates, flushSync);

      function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        if (!isValidContainer(container)) {
          throw new Error('Target container is not a DOM element.');
        }

        return createPortal(children, container, null, key);
      }

      function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
      }

      var Internals = {
        usingClientEntryPoint: false,
        Events: [getInstanceFromNode, getNodeFromInstance, getFiberCurrentPropsFromNode, enqueueStateRestore, restoreStateIfNeeded, batchedUpdates$1]
      };

      function createRoot$1(container, options) {
        {
          if (!Internals.usingClientEntryPoint && !false) {
            error('You are importing createRoot from "react-dom" which is not supported. ' + 'You should instead import it from "react-dom/client".');
          }
        }
        return createRoot(container, options);
      }

      function hydrateRoot$1(container, initialChildren, options) {
        {
          if (!Internals.usingClientEntryPoint && !false) {
            error('You are importing hydrateRoot from "react-dom" which is not supported. ' + 'You should instead import it from "react-dom/client".');
          }
        }
        return hydrateRoot(container, initialChildren, options);
      }

      function flushSync$1(fn) {
        {
          if (isAlreadyRendering()) {
            error('flushSync was called from inside a lifecycle method. React cannot ' + 'flush when React is already rendering. Consider moving this call to ' + 'a scheduler task or micro task.');
          }
        }
        return flushSync(fn);
      }

      var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: 'react-dom'
      });
      {
        if (!foundDevTools && canUseDOM && window.top === window.self) {
          if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
            var protocol = window.location.protocol;

            if (/^(https?|file):$/.test(protocol)) {
              console.info('%cDownload the React DevTools ' + 'for a better development experience: ' + 'https://reactjs.org/link/react-devtools' + (protocol === 'file:' ? '\nYou might need to use a local HTTP server (instead of file://): ' + 'https://reactjs.org/link/react-devtools-faq' : ''), 'font-weight:bold');
            }
          }
        }
      }
      exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Internals;
      exports.createPortal = createPortal$1;
      exports.createRoot = createRoot$1;
      exports.findDOMNode = findDOMNode;
      exports.flushSync = flushSync$1;
      exports.hydrate = hydrate;
      exports.hydrateRoot = hydrateRoot$1;
      exports.render = render;
      exports.unmountComponentAtNode = unmountComponentAtNode;
      exports.unstable_batchedUpdates = batchedUpdates$1;
      exports.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
      exports.version = ReactVersion;

      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }
    })();
  }
});

var reactDom = createCommonjsModule(function (module) {

  function checkDCE() {
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') {
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      throw new Error('^_^');
    }

    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
      console.error(err);
    }
  }

  if (process.env.NODE_ENV === 'production') {
    checkDCE();
    module.exports = reactDom_production_min;
  } else {
    module.exports = reactDom_development;
  }
});

var Portal = function Portal(props) {
  var mount = document.getElementById("portal_root");

  if (props.target) {
    mount = document.getElementById(props.target);
  }

  return reactDom.createPortal(props.children, mount);
};

function useClickOutside(ref, callback, open, enabled) {
  useEffect(function () {
    if (open && enabled) {
      var handleClickOutside = function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          callback(event.target);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return function () {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [ref, open, enabled]);
}

var DropDown = React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(Fragment$1, null, props.open && /*#__PURE__*/React__default.createElement(Portal, null, /*#__PURE__*/React__default.createElement(DropDownP, _extends({
    key: 'filter_bar',
    parent_ref: ref
  }, props), props.children)));
});

function DropDownP(props) {
  var _useState = useState({}),
      position = _useState[0],
      setPosition = _useState[1];

  var screentype = props.screentype,
      posx = props.posx,
      posy = props.posy,
      closeOnClickOutside = props.closeOnClickOutside,
      open = props.open,
      onClose = props.onClose;
  var wrapperRef = React__default.useRef(null);
  useClickOutside(wrapperRef, onClose, open, closeOnClickOutside);
  useEffect(function () {
    var dimensions = props.parent_ref.current.getBoundingClientRect();
    var pos;

    if (screentype === "spreadsheet") {
      console.log("DROPDOWNJS: GOING THROW SPREADHSEET");
      pos = {
        position: 'absolute',
        left: posx,
        top: posy,
        width: dimensions.width,
        zIndex: '9999'
      };
    } else if (screentype === "form") {
      console.log("DROPDOWNJS: GOING THROW FORM");
      pos = {
        position: 'absolute',
        left: dimensions.left,
        top: posy,
        width: dimensions.width,
        zIndex: '9999'
      };
    } else {
      console.log("DROPDOWNJS: GOING THROW ELSE");
      pos = {
        position: 'absolute',
        left: dimensions.left,
        top: dimensions.y + window.scrollY + dimensions.height,
        width: dimensions.width,
        zIndex: '9999'
      };
    }

    if (props.modifiers) {
      pos.width += props.modifiers.width || '100%';
      pos.left += props.modifiers.left || 0;
      pos.top += props.modifiers.top || 0;
    }

    setPosition(pos);
  }, [props.parent_ref]);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    ref: wrapperRef
  }, props, {
    style: position
  }), props.children);
}

function CalendarPicker(props) {
  return /*#__PURE__*/React__default.createElement(DropDown, {
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    ref: props.calendar_ref,
    open: props.open,
    onClose: props.close,
    modifiers: props.modifiers
  }, /*#__PURE__*/React__default.createElement(Calendar, _extends({
    onChange: props.onChange,
    value: props.value
  }, props.extra_props)));
}

var base_cls$3 = " py-2 px-2 rounded font-medium text-sm outline-none ";
var colors = {
  'primary': ' bg-primary text-white hover:bg-primary-lighten',
  'secondary': ' bg-secondary text-white',
  'transparent': 'bg-transparent text-primary hover:bg-light-selected rounded-full',
  'disabled': ' bg-disabled text-gray-500',
  'warning': ' bg-transparent text-gray-500 hover:text-red-600 rounded-full'
};
function IconButton(props) {
  var cls = function cls() {
    var base = props.className ? props.className.concat(base_cls$3) : base_cls$3;
    return base.concat(colors[props.color]);
  };

  return /*#__PURE__*/React__default.createElement("button", {
    type: props.type || 'button',
    className: cls(),
    style: props.style,
    onClick: props.onClick
  }, props.children);
}

var _path$1;

function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$2.apply(this, arguments);
}

function SvgCalendar(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/createElement("path", {
    d: "M1 4c0-1.1.9-2 2-2h14a2 2 0 012 2v14a2 2 0 01-2 2H3a2 2 0 01-2-2V4zm2 2v12h14V6H3zm2-6h2v2H5V0zm8 0h2v2h-2V0zM5 9h2v2H5V9zm0 4h2v2H5v-2zm4-4h2v2H9V9zm0 4h2v2H9v-2zm4-4h2v2h-2V9zm0 4h2v2h-2v-2z"
  })));
}

var base_cls$4 = "bg-transparent focus:placeholder-transparent placeholder-gray-900  placeholder-opacity-50 focus:outline-none rounded-lg w-full appearance-none";
var initialState = {
  'calendar_open': false,
  'calendar_value': "",
  'input_value': "",
  'value': "",
  'changed': false
};

function DateField(props) {
  var calendar_ref = React__default.createRef();

  var _useReducer = useReducer(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var state_attrs = props.state_attrs,
      field = props.field,
      record = props.record;
  var minDate = field.get_min_value(record);
  var extra_props = {};

  if (minDate) {
    extra_props['minDate'] = minDate;
  }

  function reducer(state, action) {
    switch (action.type) {
      case 'SET_VALUE':
        var calendar_value = action.payload.value._isValid ? moment(action.payload.value).toDate() : moment().toDate();
        var value = action.payload.value._isValid ? action.payload.value : "";
        var input_value = action.payload.value._isValid ? common$1.formatDate(action.payload.value, props.field.type) : "";
        return _extends({}, state, {
          calendar_value: calendar_value,
          value: value,
          input_value: input_value,
          changed: false
        });

      case 'SET_INPUT_VALUE':
        return _extends({}, state, {
          input_value: action.payload.value,
          changed: true
        });

      case 'SET_CALENDAR_OPEN':
        var calopen = !state.calendar_open;
        var changed = action.payload.changed ? action.payload.changed : false;
        return _extends({}, state, {
          calendar_open: calopen,
          changed: changed
        });

      default:
        throw new Error("Invalid Action".concat(action.type));
    }
  }

  useEffect(function () {
    dispatch({
      type: 'SET_VALUE',
      payload: {
        value: props.value
      }
    });
  }, [props.value]);

  function formatValue(value) {
    if (!value) {
      return null;
    }

    switch (field.type) {
      case 'date':
        return moment.utc(value).format('YYYY-MM-DD');

      case 'datetime':
        return moment.utc(value).format('YYYY-MM-DD HH:mm:ss');

      default:
        throw new Error("Invalid Type".concat(props.type));
    }
  }

  function setValue(value) {
    props.onChange("", formatValue(value));
    dispatch({
      type: 'SET_CALENDAR_OPEN',
      payload: {
        changed: true
      }
    });
  }

  function onChangeInput(e) {
    dispatch({
      type: 'SET_INPUT_VALUE',
      payload: {
        value: e.target.value
      }
    });
  }

  function toogleCalendar() {
    dispatch({
      type: 'SET_CALENDAR_OPEN',
      payload: {}
    });
  }

  function getEsValue(value) {
    var date = moment(value, 'DD-MM-YYYY HH:mm:ss');

    if (!date._isValid) {
      return null;
    }

    return date;
  }

  function onBlurInput(e) {
    if (state.changed) {
      props.onChange("", formatValue(getEsValue(e.target.value)));
    }
  }

  function handleKeyDown(e) {
    if (state.changed) {
      if (sheet_navigation_signals.includes(e.key)) {
        setValue(getEsValue(e.target.value));
      }
    }
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React__default.createElement("input", {
    id: field.id || field.name,
    autoFocus: props.autoFocus,
    name: field.name,
    label: field.description,
    required: state_attrs.required,
    readOnly: state_attrs.readonly,
    className: base_cls$4,
    value: state.input_value,
    onChange: onChangeInput,
    onBlur: onBlurInput,
    placeholder: field.description,
    style: props.style,
    onKeyDown: handleKeyDown
  }), !state_attrs.readonly && /*#__PURE__*/React__default.createElement("div", {
    style: {
      maxHeight: '1rem'
    },
    ref: calendar_ref
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    style: {
      padding: 0
    },
    onClick: function onClick(e) {
      toogleCalendar();
    },
    color: "transparent"
  }, /*#__PURE__*/React__default.createElement(SvgCalendar, {
    style: {
      width: '.8em',
      height: '1rem'
    },
    className: "fill-current  text-xl cursor-pointer w-4 h-2"
  }))), /*#__PURE__*/React__default.createElement(CalendarPicker, {
    open: state.calendar_open,
    value: state.calendar_value,
    onClose: function onClose() {
      return true;
    },
    calendar_ref: calendar_ref,
    onChange: setValue,
    modifiers: {
      left: -200,
      width: 200
    },
    extra_props: extra_props
  }));
}

function CheckBox(props) {
  return /*#__PURE__*/React__default.createElement("input", {
    id: props.id || props.name,
    ref: props.inputRef,
    name: props.name,
    label: props.label,
    required: props.required,
    readOnly: props.readOnly,
    className: props.className,
    checked: props.value === true,
    onChange: props.onChange,
    onBlur: props.onBlur,
    type: "checkbox",
    onKeyDown: props.onKeyDown,
    style: props.style,
    autoFocus: props.autoFocus
  });
}

var base_cls$5 = "text-center";

function BooleanField(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "w-full text-center"
  }, /*#__PURE__*/React__default.createElement(CheckBox, {
    id: props.id || props.name,
    inputRef: props.inputRef,
    name: props.name,
    label: props.label,
    required: props.required,
    readOnly: props.readOnly,
    className: base_cls$5,
    value: props.value,
    onChange: function onChange(e) {
      props.onChange(e, e.target.checked);
    },
    onBlur: props.onBlur,
    type: "checkbox",
    onKeyDown: props.handleKeyDown,
    style: props.style,
    autoFocus: props.autoFocus
  }));
}

var O2MField = observer(function O2MField(props) {
  var field = props.field,
      record = props.record,
      state_attrs = props.state_attrs;
  var height = field.height ? parseInt(field.height) * 70 / 100 : 300 * 70 / 100;
  var key_fields = computed(function () {
    return field.get_key_fields_values(record);
  }).get();
  var error = record._errors[field.name];
  var error_cls = error ? "border-red-600 border-2 rounded-lg" : "";
  useEffect(function () {
    field.initialize(record);
  }, [record.id]);
  useEffect(function () {
    if (key_fields) {
      field.reload();
    }
  }, [key_fields]);
  useEffect(function () {
    field.screen.set_readonly(state_attrs.readonly);
  }, [state_attrs.readonly]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx("overflow-hidden", error_cls),
    style: {
      overflow: 'hidden',
      height: '100%',
      paddingTop: '0.5rem'
    }
  }, field.screen && /*#__PURE__*/React__default.createElement(View_, {
    screen: field.screen,
    height: height
  }));
});

var base_cls$6 = "bg-transparent focus:placeholder-transparent placeholder-gray-900  placeholder-opacity-50 focus:outline-none rounded-lg w-full appearance-none leading-normal";

function TextField(props) {
  var field = props.field,
      isModal = props.isModal,
      state_attrs = props.state_attrs,
      onFocus = props.onFocus,
      setModalValue = props.setModalValue,
      modalValue = props.modalValue;

  var handleOnChange = function handleOnChange(e) {
    if (isModal) {
      setModalValue(e.target.value);
    } else {
      props.onChange(e, e.target.value);
    }
  };

  return /*#__PURE__*/React__default.createElement("textarea", {
    id: props.id || props.name,
    autoFocus: props.autoFocus,
    "data-ismodal": isModal,
    ref: props.inputRef,
    name: props.name,
    label: props.label,
    required: state_attrs.required,
    readOnly: state_attrs.readonly,
    className: props.modalClass ? base_cls$6.concat(props.modalClass) : base_cls$6,
    value: isModal ? modalValue : props.value,
    onChange: function onChange(e) {
      return handleOnChange(e);
    },
    onBlur: props.onBlur,
    type: field.hide_value ? 'password' : '',
    placeholder: field.description,
    onKeyDown: props.handleKeyDown,
    style: props.style,
    autoComplete: "off",
    onFocus: onFocus
  });
}

function HtmlField(props) {
  var isModal = props.isModal,
      field = props.field,
      modalValue = props.modalValue,
      setModalValue = props.setModalValue,
      state_attrs = props.state_attrs,
      value = props.value;
  var editorRef = useRef(null);

  function onBlurEditor(event, editor) {
    if (!editor) {
      editor = editorRef.current.editor;
    }

    var body = editor.dom.getRoot().innerHTML;

    if (isModal) {
      setModalValue(body);
    } else {
      props.onChange(false, body);
      editor.setDirty(false);
    }
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, field.no_wrap && state_attrs.readonly ? /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: value
    }
  }) : /*#__PURE__*/React__default.createElement(Editor, {
    onInit: function onInit(evt, editor) {
      return editorRef.current = editor;
    },
    initialValue: isModal ? modalValue : value,
    tinymceScriptSrc: process.env.PUBLIC_URL + '/tinymce/tinymce.min.js',
    init: {
      height: 700,
      menubar: true,
      branding: false,
      elementpath: false,
      plugins: ['advlist autolink lists link image charmap print preview anchor', 'searchreplace visualblocks code fullscreen', 'insertdatetime media table paste code help autoresize'],
      menu: {
        file: {
          title: 'File',
          items: 'newdocument restoredraft | preview | print '
        },
        edit: {
          title: 'Edit',
          items: 'undo redo | cut copy paste | selectall | searchreplace'
        },
        view: {
          title: 'View',
          items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen'
        },
        insert: {
          title: 'Insert',
          items: 'tryton_image tryton_stylesheet | link media template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor toc | insertdatetime'
        },
        format: {
          title: 'Format',
          items: 'italic bold underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align | forecolor backcolor | removeformat'
        },
        tools: {
          title: 'Tools',
          items: 'spellchecker spellcheckerlanguage | code wordcount'
        },
        table: {
          title: 'Table',
          items: 'inserttable | cell row column | tableprops deletetable'
        },
        help: {
          title: 'Help',
          items: 'help'
        }
      },
      toolbar: state_attrs.readonly ? false : 'undo redo | formatselect | ' + 'bold italic backcolor | alignleft aligncenter ' + 'alignright alignjustify | bullist numlist outdent indent | ' + 'removeformat | help',
      content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
    },
    onBlur: onBlurEditor,
    disabled: props.previewEditor ? props.previewEditor : state_attrs.readonly
  }));
}

var _path$2;

function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$3.apply(this, arguments);
}

function SvgDownload(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/createElement("path", {
    d: "M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z"
  })));
}

var widgets = {
  'image': function image(_ref) {
    var value = _ref.value;
    return /*#__PURE__*/React__default.createElement("img", {
      style: {
        maxHeight: '90%'
      },
      src: value
    });
  },
  'base': function base(_ref2) {
    var value = _ref2.value,
        field = _ref2.field,
        record = _ref2.record;
    return /*#__PURE__*/React__default.createElement(BaseWidget, {
      value: value,
      field: field,
      record: record
    });
  }
};

function BaseWidget(props) {
  var field = props.field,
      record = props.record;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(IconButton, {
    style: {
      padding: 0
    },
    onClick: function onClick() {
      return field.download_content(record);
    },
    color: "transparent"
  }, /*#__PURE__*/React__default.createElement(SvgDownload, {
    style: {
      width: '.8em',
      height: '1rem'
    },
    className: "fill-current  text-xl cursor-pointer w-4 h-2"
  })));
}

function BinaryField(props) {
  var field = props.field,
      record = props.record;
  var loading = field.is_loading(record);
  var widget = field.attributes.widget || 'base';
  return /*#__PURE__*/React__default.createElement(Fragment$1, null, loading ? /*#__PURE__*/React__default.createElement("div", {
    className: "flex justify-end content-end",
    style: {
      minHeight: '1.5rem'
    }
  }, /*#__PURE__*/React__default.createElement(SvgNavigationMore, {
    style: {
      width: '1.2em',
      height: '1.2em'
    },
    className: "fill-current text-xl cursor-pointer w-4 h-2 scale-left-to-right"
  })) : /*#__PURE__*/React__default.createElement(Fragment$1, null, field.has_value(record) ?
  /*#__PURE__*/
  React__default.createElement(Fragment$1, null, widgets[widget]({
    value: props.value,
    field: field,
    record: record
  })) : ""));
}

var FormulaField = observer(function FormulaField(props) {
  var field = props.field,
      record = props.record;
  var loading = record._values[field.name] ? record._values[field.name].loading : true;
  return /*#__PURE__*/React__default.createElement(Fragment$1, null, loading ? /*#__PURE__*/React__default.createElement("div", {
    className: "flex justify-end content-end",
    style: {
      minHeight: '1.5rem'
    }
  }, /*#__PURE__*/React__default.createElement(SvgNavigationMore, {
    style: {
      width: '1.2em',
      height: '1.2em'
    },
    className: "fill-current text-xl cursor-pointer w-4 h-2 scale-left-to-right"
  })) : /*#__PURE__*/React__default.createElement(Fragment$1, null, props.children));
});

var base_cls$7 = "bg-transparent focus:placeholder-transparent placeholder-gray-900  placeholder-opacity-50 focus:outline-none rounded-lg w-full appearance-none leading-normal";
var FloatField = observer(function FloatField(props) {
  var field = props.field,
      state_attrs = props.state_attrs,
      onFocus = props.onFocus,
      record = props.record;

  var _useState = useState(''),
      formatted_value = _useState[0],
      setFormattedValue = _useState[1];

  useEffect(function () {
    var val = field.get_formatted_value(record);

    if (val !== formatted_value) {
      setFormattedValue(val);
    }
  }, []);

  function validateKey(key) {
    return /[0-9]|[-]|[.]|[,]|[e]|[E]/.test(key);
  }

  function handleKeyPress(e) {
    if (!validateKey(e.key)) {
      return e.preventDefault();
    }
  }

  function onBlur(e) {
    props.onBlur(e, Number(e.target.value));
    setFormattedValue(field.get_formatted_value(record));
  }

  function onChange(e) {
    setFormattedValue(e.target.value);
    props.onChange(e, e.target.value);
  }

  return /*#__PURE__*/React__default.createElement("input", {
    id: props.id || props.name,
    autoFocus: props.autoFocus,
    ref: props.inputRef,
    name: props.name,
    label: props.label,
    required: state_attrs.required,
    readOnly: state_attrs.readonly,
    className: base_cls$7,
    value: formatted_value,
    onBlur: onBlur,
    onChange: onChange,
    type: field.hide_value ? 'password' : 'float',
    placeholder: field.description,
    onKeyPress: handleKeyPress,
    onKeyDown: props.handleKeyDown,
    style: props.style,
    autoComplete: "off",
    onFocus: onFocus
  });
});

var _path$3;

function _extends$4() {
  _extends$4 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$4.apply(this, arguments);
}

function SvgSearch(props) {
  return /*#__PURE__*/createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/createElement("path", {
    d: "M12.9 14.32a8 8 0 111.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 108 2a6 6 0 000 12z"
  })));
}

function BinaryField$1(props) {
  var field = props.field,
      record = props.record;
  var loading = field.is_loading(record);
  var inputRef = useRef(null);

  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex justify-between"
  }, loading ? /*#__PURE__*/React__default.createElement("div", {
    className: "flex justify-end content-end",
    style: {
      minHeight: '1.5rem'
    }
  }, /*#__PURE__*/React__default.createElement(SvgNavigationMore, {
    style: {
      width: '1.2em',
      height: '1.2em'
    },
    className: "fill-current text-xl cursor-pointer w-4 h-2 scale-left-to-right"
  })) : /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red-600"
  }, "Implementation Pending")));
}

var _path$4;

function _extends$5() {
  _extends$5 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$5.apply(this, arguments);
}

function SvgChevronDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/createElement("path", {
    d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
  })));
}

var _path$5;

function _extends$6() {
  _extends$6 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$6.apply(this, arguments);
}

function SvgClose(props) {
  return /*#__PURE__*/createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/createElement("path", {
    d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
  })));
}

function ChoseColor(props) {
  var colorPickerRef = useRef();
  var color = props.color,
      closePalette = props.closePalette,
      onChange = props.onChange,
      openColorPicker = props.openColorPicker,
      togglePalette = props.togglePalette;

  var rgbaString = function rgbaString() {
    return color && color.startsWith("rgba") ? color : colord(color).toRgbString();
  };

  return /*#__PURE__*/React__default.createElement(Fragment, null, !props.readOnly ? !color ? /*#__PURE__*/React__default.createElement(IconButton, {
    className: "relative rounded-full my-auto",
    onClick: function onClick(e) {
      return togglePalette(e);
    },
    color: "transparent"
  }, openColorPicker ? /*#__PURE__*/React__default.createElement(SvgClose, {
    style: {
      width: '.8em',
      height: '.8em'
    },
    className: "fill-current text-xl cursor-pointer"
  }) : /*#__PURE__*/React__default.createElement(SvgChevronDown, {
    style: {
      width: '.8em',
      height: '.8em'
    },
    className: "fill-current text-xl cursor-pointer"
  })) : /*#__PURE__*/React__default.createElement("div", {
    ref: colorPickerRef,
    className: "relative cursor-pointer rounded-full my-auto h-5 w-5",
    style: {
      backgroundColor: color
    },
    onClick: function onClick(e) {
      return togglePalette(e);
    }
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: "relative cursor-default rounded-full my-auto h-5 w-5",
    style: {
      backgroundColor: color
    }
  }), openColorPicker && /*#__PURE__*/React__default.createElement(DropDown, {
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    ref: colorPickerRef,
    open: openColorPicker,
    onClose: function onClose() {
      return closePalette(false);
    },
    isspreadsheet: props.isSpreadsheet,
    posx: props.posX,
    posy: props.posY,
    screentype: props.screenType
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "absolute rounded-lg shadow-lg z-40"
  }, /*#__PURE__*/React__default.createElement(RgbaStringColorPicker, {
    color: rgbaString(),
    onChange: onChange
  }))));
}

var base_cls$8 = "bg-transparent focus:placeholder-transparent placeholder-gray-900  placeholder-opacity-50 focus:outline-none rounded-lg w-full appearance-none leading-normal";

function ColorPicker(props) {
  var field = props.field,
      onFocus = props.onFocus,
      state_attrs = props.state_attrs;

  var _useState = useState(false),
      openColorPicker = _useState[0],
      setOpenColorPicker = _useState[1];

  var _useState2 = useState(null),
      posX = _useState2[0],
      setPosX = _useState2[1];

  var _useState3 = useState(null),
      posY = _useState3[0],
      setPosY = _useState3[1];

  var isSpreadsheet = field.screen.type === "spreadsheet";
  var screenType = field.screen.type;

  var togglePalette = function togglePalette(e) {
    if (!openColorPicker) {
      if (isSpreadsheet) {
        var gridWidth = parseInt(document.getElementById("body_grid").style.width);
        var gridHeight = parseInt(document.getElementById("body_grid").style.height);

        if (e.clientX > gridWidth) {
          setPosX(!(e.clientX - gridWidth > 60) ? e.clientX - 200 : gridWidth - 20);
          setPosY(e.clientY > gridHeight ? e.clientY - 215 : e.clientY + 25);
        } else if (gridWidth - e.clientX > 15 && gridWidth - e.clientX < 180) {
          setPosX(gridWidth - e.clientX > 15 ? e.clientX - 200 : gridWidth - 20);
          setPosY(e.clientY > gridHeight ? e.clientY - 215 : e.clientY + 25);
        } else {
          setPosX(e.clientX);
          setPosY(e.clientY > gridHeight ? e.clientY - 215 : e.clientY + 25);
        }
      } else {
        var formSize = e.target.parentElement.parentElement.parentElement.parentElement.parentElement.getBoundingClientRect();
        setPosX(e.clientX - 170);
        setPosY(e.clientY < 272 ? Math.abs(formSize.y) + e.clientY + 95 : Math.abs(formSize.y) + e.clientY - 135);
      }
    }

    setOpenColorPicker(!openColorPicker);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex justify-between align-middle"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: field.screen.type === "form" ? "w-4/5" : "w-40"
  }, /*#__PURE__*/React__default.createElement("input", {
    id: props.id || props.name,
    autoFocus: props.autoFocus,
    ref: props.inputRef,
    name: props.name,
    label: props.label,
    required: state_attrs.required,
    readOnly: state_attrs.readonly,
    className: base_cls$8,
    value: props.value,
    onChange: function onChange(e) {
      props.onChange(e, e.target.value);
    },
    onBlur: props.onBlur,
    placeholder: field.description,
    onKeyDown: props.handleKeyDown,
    style: props.style,
    autoComplete: "off",
    onFocus: onFocus
  })), /*#__PURE__*/React__default.createElement(ChoseColor, {
    color: props.value,
    closePalette: setOpenColorPicker,
    onChange: function onChange(e) {
      props.onChange(e, e);
    },
    field: field,
    openColorPicker: openColorPicker,
    posX: posX,
    posY: posY,
    readOnly: state_attrs.readonly,
    screenType: screenType,
    togglePalette: togglePalette,
    value: props.value
  }));
}

function EmptyWidget(props) {
  var field = props.field;
  var widget = field.attributes.widget;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red-600"
  }, "Sorry, the widget ", widget, " does not exist."));
}

function Modal(props) {
  var style = {
    position: 'absolute',
    top: props.top ? props.top : '50%',
    left: props.left ? props.left : '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    zIndex: '9999'
  };
  return /*#__PURE__*/React__default.createElement(Fragment$1, null, props.open && /*#__PURE__*/React__default.createElement(Portal, {
    target: props.target
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "absolute bg-modal-background inset-0 z-40"
  }, props.paper ? /*#__PURE__*/React__default.createElement(Paper, {
    targetRef: props.containerRefModal,
    className: props.className,
    style: props.style ? _extends({}, style, props.style) : style
  }, props.children) : /*#__PURE__*/React__default.createElement("div", {
    ref: props.containerRefModal,
    className: props.className,
    style: props.style ? _extends({}, style, props.style) : style
  }, props.children))));
}

var base_cls$9 = " py-2 px-2 rounded w-full font-medium text-sm outline-none";
var list_cls = " font-bold py-1 px-1 rounded-full outline-none";
var colors$1 = {
  'primary': ' bg-primary text-white hover:bg-primary-lighten',
  'secondary': ' bg-secondary text-white',
  'disabled': ' bg-disabled text-grey-500',
  'transparent': ' bg-transparent text-primary hover:bg-light-selected'
};
function FormButton(props) {
  var state_attrs = props.state_attrs;

  var cls = function cls() {
    var base = props.variant === "list" ? list_cls : base_cls$9;
    base = props.className ? base.concat(props.className) : base;
    var color = props.readonly ? 'disabled' : props.color;
    return base.concat(colors$1[color]);
  };

  return /*#__PURE__*/React__default.createElement("button", {
    type: props.type || 'button',
    className: cls(),
    style: _extends({
      display: state_attrs.invisible ? 'none' : ''
    }, props.style),
    disabled: state_attrs.readonly,
    variant: props.variant,
    onClick: props.onClick
  }, props.children);
}

var _path$6;

function _extends$7() {
  _extends$7 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$7.apply(this, arguments);
}

function SvgCheveronLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/createElement("path", {
    d: "M7.05 9.293L6.343 10 12 15.657l1.414-1.414L9.172 10l4.242-4.243L12 4.343z"
  })));
}

var _path$7;

function _extends$8() {
  _extends$8 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$8.apply(this, arguments);
}

function SvgCheveronRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/createElement("path", {
    d: "M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"
  })));
}

var _path$8;

function _extends$9() {
  _extends$9 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$9.apply(this, arguments);
}

function SvgEditPencil(props) {
  return /*#__PURE__*/createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/createElement("path", {
    d: "M12.3 3.7l4 4L4 20H0v-4L12.3 3.7zm1.4-1.4L16 0l4 4-2.3 2.3-4-4z"
  })));
}

var _path$9;

function _extends$a() {
  _extends$a = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$a.apply(this, arguments);
}

function SvgScreenFull(props) {
  return /*#__PURE__*/createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/createElement("path", {
    d: "M2.8 15.8L0 13v7h7l-2.8-2.8 4.34-4.32-1.42-1.42L2.8 15.8zM17.2 4.2L20 7V0h-7l2.8 2.8-4.34 4.32 1.42 1.42L17.2 4.2zm-1.4 13L13 20h7v-7l-2.8 2.8-4.32-4.34-1.42 1.42 4.33 4.33zM4.2 2.8L7 0H0v7l2.8-2.8 4.32 4.34 1.42-1.42L4.2 2.8z"
  })));
}

function Item(props) {
  var checkValues = props.checkValues,
      handleOneLeft = props.handleOneLeft,
      handleOneRight = props.handleOneRight,
      item = props.item,
      isReadonly = props.isReadonly,
      listType = props.listType;

  var _useState = useState(false),
      selected = _useState[0],
      setSelected = _useState[1];

  var selectItem = function selectItem(item) {
    setSelected(!selected);
    checkValues(item);
  };

  return /*#__PURE__*/React__default.createElement(Fragment, null, isReadonly ? /*#__PURE__*/React__default.createElement("div", {
    className: "items-center my-1"
  }, listType === "posible" ? /*#__PURE__*/React__default.createElement("p", {
    className: "text-sm p-2"
  }, item.rec_name ? item.rec_name : item.label) : /*#__PURE__*/React__default.createElement("div", {
    className: "w-full flex justify-end"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "text-sm p-2"
  }, item.rec_name ? item.rec_name : item.label))) : /*#__PURE__*/React__default.createElement("div", {
    className: "flex items-center justify-between my-1 hover:bg-light-selected " + (selected ? 'bg-light-selected' : '')
  }, listType === "posible" ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "cursor-pointer w-4/5",
    onClick: function onClick() {
      return selectItem(item);
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "text-sm p-2"
  }, item.rec_name ? item.rec_name : item.label)), /*#__PURE__*/React__default.createElement(IconButton, {
    className: "rounded-full p-2 z-40 hover:bg-light-selected",
    onClick: function onClick() {
      return handleOneRight(item);
    }
  }, /*#__PURE__*/React__default.createElement(SvgCheveronRight, {
    className: "fill-current text-primary h-3 w-3"
  }))) : /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(IconButton, {
    className: "rounded-full p-2 z-40 hover:bg-light-selected",
    onClick: function onClick() {
      return handleOneLeft(item);
    }
  }, /*#__PURE__*/React__default.createElement(SvgCheveronLeft, {
    className: "fill-current text-primary h-3 w-3"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "cursor-pointer w-4/5 flex justify-end",
    onClick: function onClick() {
      return selectItem(item);
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "text-sm p-2"
  }, item.rec_name ? item.rec_name : item.label)))));
}

function ListItem(props) {
  var items = props.items,
      saveChanges = props.saveChanges,
      selectedItems = props.selectedItems,
      title = props.title;
  useEffect(function () {
    saveChanges && saveChanges();
  }, [selectedItems]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "p-1 border border-gray-400 rounded-lg",
    style: {
      height: "456px",
      width: "400px"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-medium text-center"
  }, title), /*#__PURE__*/React__default.createElement("hr", null), /*#__PURE__*/React__default.createElement("div", {
    className: "m-3"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: '380px'
    },
    className: "" + (items && items.length > 10 ? 'overflow-y-scroll' : '')
  }, items && items.map(function (item, i) {
    return /*#__PURE__*/React__default.createElement(Item, {
      key: item.id ? item.id : i,
      checkValues: props.checkValues,
      isReadonly: props.isReadonly,
      item: item,
      handleClickLeft: props.handleClickLeft,
      handleClickRight: props.handleClickRight,
      handleOneLeft: props.handleOneLeft,
      handleOneRight: props.handleOneRight,
      listType: props.listType
    });
  }))));
}

var DEFAULT_TEMPLATE = {
  'background_color': "",
  'type': 'standard',
  'color': ""
};

function Tooltip(props) {
  var children = props.children,
      content = props.content,
      template = props.template;
  var theme = useContext(ThemeContext);
  var tooltip_template = template ? theme.getTooltipTemplate(template) : DEFAULT_TEMPLATE;
  return /*#__PURE__*/React__default.createElement(ReactTooltipLite, {
    background: tooltip_template.background_color,
    tipContentClassName: " text-gray-800  text-xs font-medium",
    tipContentHover: true,
    eventOff: "onClick",
    mouseOutDelay: 0,
    color: tooltip_template.color,
    content: tooltip_template.type === 'standard' ? content : /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: content
      }
    })
  }, children);
}

var base_cls$a = "bg-transparent focus:placeholder-transparent placeholder-gray-900  placeholder-opacity-50 focus:outline-none rounded-lg w-full appearance-none leading-normal cursor-pointer";

function TransferList(props) {
  var autoFocus = props.autoFocus,
      field = props.field,
      handleAllLeft = props.handleAllLeft,
      handleAllRight = props.handleAllRight,
      handleCheckedLeft = props.handleCheckedLeft,
      handleCheckedRight = props.handleCheckedRight,
      handleOneLeft = props.handleOneLeft,
      handleOneRight = props.handleOneRight,
      handleToggle = props.handleToggle,
      leftChecked = props.leftChecked,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      posible = props.posible,
      record = props.record,
      rightChecked = props.rightChecked,
      selected = props.selected,
      state_attrs = props.state_attrs;
  var transferListHeight = props.transferListHeight ? props.transferListHeight : 468;

  var _useState = useState(false),
      openTransferList = _useState[0],
      setOpenTransferList = _useState[1];

  var transferListRef = useRef();
  var isSpreadsheet = field.screen.type === "spreadsheet";
  var isReadonly = field.readonly;

  var saveChanges = function saveChanges() {
    if (field.type === "multi_link") {
      field.set_value(selected, record);
      onBlur(false, selected);
    } else {
      onChange(false, selected);
      onBlur(false, selected);
    }
  };

  var closeTransferList = function closeTransferList() {
    setOpenTransferList(false);
  };

  var saveTansferListModal = function saveTansferListModal() {
    setOpenTransferList(false);
    saveChanges();
  };

  useClickOutside(transferListRef, closeTransferList, openTransferList);
  return /*#__PURE__*/React__default.createElement(Fragment, null, isSpreadsheet ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "flex justify-between align-middle"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: field.screen.type === "form" ? "w-4/5" : "w-40",
    onClick: function onClick() {
      return setOpenTransferList(true);
    }
  }, /*#__PURE__*/React__default.createElement("input", {
    id: props.id || props.name,
    autoFocus: autoFocus,
    ref: props.inputRef,
    name: props.name,
    label: props.label,
    required: state_attrs.required,
    readOnly: state_attrs.readonly,
    className: base_cls$a,
    value: field.get_string_value(record),
    onChange: function onChange() {
      return setOpenTransferList(true);
    },
    onBlur: onBlur,
    placeholder: field.description,
    onKeyDown: props.handleKeyDown,
    style: props.style,
    autoComplete: "off",
    onFocus: onFocus
  })), /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick(e) {
      return setOpenTransferList(true);
    },
    className: "justify-end px-2 my-1 h-8 w-6",
    color: "transparent"
  }, isReadonly ? /*#__PURE__*/React__default.createElement(SvgScreenFull, {
    className: "fill-current text-primary h-3 w-3 z-40"
  }) : /*#__PURE__*/React__default.createElement(SvgEditPencil, {
    className: "fill-current text-primary h-3 w-3 z-40"
  }))), openTransferList && /*#__PURE__*/React__default.createElement(Modal, {
    open: openTransferList,
    style: {
      height: isReadonly ? '480px' : '530px',
      width: '532px'
    },
    containerRefModal: transferListRef,
    className: (isReadonly ? 'bg-gray-200' : 'bg-white') + " shadow-xl"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: transferListHeight + "px",
      padding: '16px'
    },
    className: "flex justify-between"
  }, /*#__PURE__*/React__default.createElement(ListItem, {
    checkValues: handleToggle,
    handleClickRight: handleCheckedRight,
    handleOneRight: handleOneRight,
    isReadonly: isReadonly,
    items: posible,
    listType: "posible",
    record: record,
    title: "Posibles"
  }), isReadonly ? /*#__PURE__*/React__default.createElement("div", {
    className: "p-10"
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: "py-10"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "py-10"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "m-2 p-2"
  }, /*#__PURE__*/React__default.createElement(Tooltip, {
    content: "A\xF1anadir todos",
    type: "standard"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    className: "rounded-full border border-gray-400 h-14 w-14 p-2 z-40 " + (posible && posible.length === 0 ? "opacity-50 cursor-not-allowed" : "hover:bg-light-selected"),
    disabled: posible && posible.length === 0,
    onClick: function onClick() {
      return handleAllRight();
    }
  }, /*#__PURE__*/React__default.createElement(SvgCheveronRight, {
    className: "fill-current text-primary h-6 w-6"
  }), /*#__PURE__*/React__default.createElement(SvgCheveronRight, {
    className: "fill-current text-primary h-6 w-6"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "m-2 p-2"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    className: "rounded-full border border-gray-400 h-10 w-10 p-2 z-40 " + (leftChecked && !leftChecked.length > 0 ? "opacity-50 cursor-not-allowed" : "hover:bg-light-selected"),
    disabled: leftChecked && !leftChecked.length > 0,
    onClick: function onClick() {
      return handleCheckedRight();
    }
  }, /*#__PURE__*/React__default.createElement(SvgCheveronRight, {
    className: "fill-current text-primary h-5 w-5"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "m-2 p-2"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    className: "rounded-full border border-gray-400 h-10 w-10 p-2 z-40 " + (rightChecked && !rightChecked.length > 0 ? "opacity-50 cursor-not-allowed" : "hover:bg-light-selected"),
    disabled: rightChecked && !rightChecked.length > 0,
    onClick: function onClick() {
      return handleCheckedLeft();
    }
  }, /*#__PURE__*/React__default.createElement(SvgCheveronLeft, {
    className: "fill-current text-primary h-5 w-5"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "m-2 p-2"
  }, /*#__PURE__*/React__default.createElement(Tooltip, {
    content: "Eliminar todos",
    type: field.tooltip_type
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    className: "rounded-full border border-gray-400 h-14 w-14 p-2 z-40 " + (selected && selected.length === 0 ? "opacity-50 cursor-not-allowed" : "hover:bg-light-selected"),
    disabled: selected && selected.length === 0,
    onClick: function onClick() {
      return handleAllLeft();
    }
  }, /*#__PURE__*/React__default.createElement(SvgCheveronLeft, {
    className: "fill-current text-primary h-6 w-6"
  }), /*#__PURE__*/React__default.createElement(SvgCheveronLeft, {
    className: "fill-current text-primary h-6 w-6"
  })))))), /*#__PURE__*/React__default.createElement(ListItem, {
    checkValues: handleToggle,
    handleClickLeft: handleCheckedLeft,
    handleOneLeft: handleOneLeft,
    isReadonly: isReadonly,
    items: selected,
    listType: "selected",
    record: record,
    title: "Selecteds"
  })), !isReadonly && /*#__PURE__*/React__default.createElement("div", {
    className: "flex justify-center pt-4"
  }, /*#__PURE__*/React__default.createElement(FormButton, {
    state_attrs: state_attrs,
    variant: "list",
    color: "transparent",
    className: " mr-1",
    onClick: function onClick() {
      return saveTansferListModal();
    }
  }, "Guardar"), /*#__PURE__*/React__default.createElement(FormButton, {
    state_attrs: state_attrs,
    variant: "list",
    color: "transparent",
    className: " ml-1",
    onClick: function onClick() {
      return setOpenTransferList(false);
    }
  }, "Cancelar")))) : /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: transferListHeight + "px",
      padding: '10px'
    },
    className: "flex justify-between"
  }, /*#__PURE__*/React__default.createElement(ListItem, {
    checkValues: handleToggle,
    handleClickRight: handleCheckedRight,
    handleOneRight: handleOneRight,
    isReadonly: isReadonly,
    items: posible,
    listType: "posible",
    saveChanges: saveChanges,
    record: record,
    title: "Posibles"
  }), isReadonly ? /*#__PURE__*/React__default.createElement("div", {
    className: "p-10"
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: "py-10"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "py-10"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "m-2 p-2"
  }, /*#__PURE__*/React__default.createElement(Tooltip, {
    content: "A\xF1anadir todos",
    type: "standard"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    className: "rounded-full border border-gray-400 h-14 w-14 p-2 z-40 " + (posible && posible.length === 0 ? "opacity-50 cursor-not-allowed" : "hover:bg-light-selected"),
    disabled: posible && posible.length === 0,
    onClick: function onClick() {
      return handleAllRight();
    }
  }, /*#__PURE__*/React__default.createElement(SvgCheveronRight, {
    className: "fill-current text-primary h-6 w-6"
  }), /*#__PURE__*/React__default.createElement(SvgCheveronRight, {
    className: "fill-current text-primary h-6 w-6"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "m-2 p-2"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    className: "rounded-full border border-gray-400 h-10 w-10 p-2 z-40 " + (leftChecked && !leftChecked.length > 0 ? "opacity-50 cursor-not-allowed" : "hover:bg-light-selected"),
    disabled: leftChecked && !leftChecked.length > 0,
    onClick: function onClick() {
      return handleCheckedRight();
    }
  }, /*#__PURE__*/React__default.createElement(SvgCheveronRight, {
    className: "fill-current text-primary h-5 w-5"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "m-2 p-2"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    className: "rounded-full border border-gray-400 h-10 w-10 p-2 z-40 " + (rightChecked && !rightChecked.length > 0 ? "opacity-50 cursor-not-allowed" : "hover:bg-light-selected"),
    disabled: rightChecked && !rightChecked.length > 0,
    onClick: function onClick() {
      return handleCheckedLeft();
    }
  }, /*#__PURE__*/React__default.createElement(SvgCheveronLeft, {
    className: "fill-current text-primary h-5 w-5"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "m-2 p-2"
  }, /*#__PURE__*/React__default.createElement(Tooltip, {
    content: "Eliminar todos",
    type: field.tooltip_type
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    className: "rounded-full border border-gray-400 h-14 w-14 p-2 z-40 " + (selected && selected.length === 0 ? "opacity-50 cursor-not-allowed" : "hover:bg-light-selected"),
    disabled: selected && selected.length === 0,
    onClick: function onClick() {
      return handleAllLeft();
    }
  }, /*#__PURE__*/React__default.createElement(SvgCheveronLeft, {
    className: "fill-current text-primary h-6 w-6"
  }), /*#__PURE__*/React__default.createElement(SvgCheveronLeft, {
    className: "fill-current text-primary h-6 w-6"
  })))))), /*#__PURE__*/React__default.createElement(ListItem, {
    checkValues: handleToggle,
    handleClickLeft: handleCheckedLeft,
    handleOneLeft: handleOneLeft,
    isReadonly: isReadonly,
    items: selected,
    listType: "selected",
    record: record,
    saveChanges: saveChanges,
    selectedItems: selected,
    title: "Selecteds"
  })));
}

function MultiLink(props) {
  var field = props.field,
      state_attrs = props.state_attrs,
      record = props.record;

  var _useState = useState([]),
      posible = _useState[0],
      setPosible = _useState[1];

  var _useState2 = useState([]),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = useState([]),
      checked = _useState3[0],
      setChecked = _useState3[1];

  var values = field.get_value(record);

  var _useState4 = useState(""),
      wKey = _useState4[0],
      setWkey = _useState4[1];

  var key_fields = field.get_key_fields_values && computed(function () {
    return field.get_key_fields_values(record);
  }).get();
  useEffect(function () {
    var newK = "";

    for (var k in key_fields) {
      newK = newK.concat(key_fields[k]);
    }

    if (newK !== wKey) {
      console.log("I HAVE A NEW KEY");
      console.log(field.name);
      console.log(newK);
      console.log(wKey);
      setWkey(newK);
    }
  }, [key_fields]);
  useEffect(function () {
    field.getOptions(record).then(function (options) {
      if (values && values.length > 0) {
        addPosibleValues(options, values);
      } else {
        setPosible(options);
      }
    });
  }, [field, record]);

  function addPosibleValues(posibles, selecteds) {
    setPosible([]);
    var posibleIDs = [];
    var posibleNames = [];
    var selectedIDs = [];
    var setposibles = [];

    for (var i = 0; i < posibles.length; i++) {
      posibleIDs.push(posibles[i].id);
      posibleNames.push(posibles[i].rec_name);
    }

    for (var i = 0; i < selecteds.length; i++) {
      selectedIDs.push(selecteds[i].id);
    }

    var posibleValues = not(posibleIDs, selectedIDs);

    for (var i = 0; i < posibleValues.length; i++) {
      setposibles.push({
        id: posibleValues[i],
        rec_name: posibleNames[posibleValues[i] - 1]
      });
    }

    setPosible(setposibles);
    setSelected(selecteds);
  }

  function not(a, b) {
    return a.filter(function (value) {
      return b.indexOf(value) === -1;
    });
  }

  function intersection(checkedValues, actualValues) {
    return checkedValues.filter(function (value) {
      return actualValues.indexOf(value) !== -1;
    });
  }

  var leftChecked = intersection(checked, posible);
  var rightChecked = intersection(checked, selected);

  var handleToggle = function handleToggle(value) {
    var currentIndex = checked.indexOf(value);
    var newChecked = [].concat(checked);

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  var handleOneRight = function handleOneRight(item) {
    setSelected(selected.concat(item));
    setPosible(not(posible, [item]));
    setChecked(not(checked, [item]));
  };

  var handleAllRight = function handleAllRight() {
    setSelected(selected.concat(posible));
    setPosible([]);
  };

  var handleCheckedRight = function handleCheckedRight() {
    setSelected(selected.concat(leftChecked));
    setPosible(not(posible, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  var handleCheckedLeft = function handleCheckedLeft() {
    setPosible(posible.concat(rightChecked));
    setSelected(not(selected, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  var handleOneLeft = function handleOneLeft(item) {
    setPosible(posible.concat(item));
    setSelected(not(selected, [item]));
    setChecked(not(checked, [item]));
  };

  var handleAllLeft = function handleAllLeft() {
    setPosible(posible.concat(selected));
    setSelected([]);
  };

  return /*#__PURE__*/React__default.createElement(TransferList, {
    addPosibleValues: addPosibleValues,
    autoFocus: props.autoFocus,
    field: field,
    handleAllLeft: handleAllLeft,
    handleAllRight: handleAllRight,
    handleCheckedLeft: handleCheckedLeft,
    handleCheckedRight: handleCheckedRight,
    handleKeyDown: props.handleKeyDown,
    handleOneLeft: handleOneLeft,
    handleOneRight: handleOneRight,
    handleToggle: handleToggle,
    leftChecked: leftChecked,
    onBlur: props.handleFieldBlur,
    onChange: props.onChange,
    onFocus: props.onFocus,
    posible: posible,
    style: props.style,
    rightChecked: rightChecked,
    record: record,
    selected: selected,
    setPosible: setPosible,
    state_attrs: state_attrs
  });
}

function MultiSelection(props) {
  var field = props.field,
      state_attrs = props.state_attrs,
      record = props.record;

  var _useState = useState([]),
      posible = _useState[0],
      setPosible = _useState[1];

  var _useState2 = useState([]),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = useState([]),
      checked = _useState3[0],
      setChecked = _useState3[1];

  var values = field.get_value(record);
  useEffect(function () {
    if (values && values.length > 0) {
      setPosible(not(field.selection_options, values));
      setSelected(values);
    } else {
      setPosible(field.selection_options);
    }
  }, [field, record]);

  function not(a, b) {
    return a.filter(function (value) {
      return b.indexOf(value) === -1;
    });
  }

  function intersection(checkedValues, actualValues) {
    return checkedValues.filter(function (value) {
      return actualValues.indexOf(value) !== -1;
    });
  }

  var leftChecked = intersection(checked, posible);
  var rightChecked = intersection(checked, selected);

  var handleToggle = function handleToggle(value) {
    var currentIndex = checked.indexOf(value);
    var newChecked = [].concat(checked);

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  var handleOneRight = function handleOneRight(item) {
    setSelected(selected.concat(item));
    setPosible(not(posible, [item]));
    setChecked(not(checked, [item]));
  };

  var handleAllRight = function handleAllRight() {
    setSelected(selected.concat(posible));
    setPosible([]);
  };

  var handleCheckedRight = function handleCheckedRight() {
    setSelected(selected.concat(leftChecked));
    setPosible(not(posible, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  var handleCheckedLeft = function handleCheckedLeft() {
    setPosible(posible.concat(rightChecked));
    setSelected(not(selected, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  var handleOneLeft = function handleOneLeft(item) {
    setPosible(posible.concat(item));
    setSelected(not(selected, [item]));
    setChecked(not(checked, [item]));
  };

  var handleAllLeft = function handleAllLeft() {
    setPosible(posible.concat(selected));
    setSelected([]);
  };

  return /*#__PURE__*/React__default.createElement(TransferList, {
    autoFocus: props.autoFocus,
    field: field,
    handleAllLeft: handleAllLeft,
    handleAllRight: handleAllRight,
    handleCheckedLeft: handleCheckedLeft,
    handleCheckedRight: handleCheckedRight,
    handleKeyDown: props.handleKeyDown,
    handleOneLeft: handleOneLeft,
    handleOneRight: handleOneRight,
    handleToggle: handleToggle,
    leftChecked: leftChecked,
    onBlur: props.handleFieldBlur,
    onChange: props.onChange,
    onFocus: props.onFocus,
    posible: posible,
    style: props.style,
    rightChecked: rightChecked,
    record: record,
    selected: selected,
    setPosible: setPosible,
    state_attrs: state_attrs
  });
}

var definitions = {
  'binary': {
    'image': BinaryField$1
  },
  'char': {
    'color_picker': ColorPicker
  },
  'multi_selection': {
    'transfer_list': MultiSelection
  },
  'multi_link': {
    'transfer_list': MultiLink
  }
};

var get = function get(field_type, name) {
  if (definitions[field_type] && definitions[field_type][name]) {
    return definitions[field_type][name];
  } else {
    return EmptyWidget;
  }
};

var widgets$1 = {
  get: get
};

function FormDivider(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: props.invisible ? 'none' : ''
    },
    className: "bg-modal-background text-gray-700 text-sm font-medium rounded px-2 w-full"
  }, props.text);
}

var NO_WRAP_FIELDS = ['one2many', 'button', 'divider'];

var renderFormulaField = function renderFormulaField(_ref) {
  var props = _ref.props,
      value = _ref.value,
      onChange = _ref.onChange,
      handleFieldBlur = _ref.handleFieldBlur,
      state_attrs = _ref.state_attrs,
      record = _ref.record,
      noWrap = _ref.noWrap;

  var child_props = _extends({}, props, {
    field: props.field.field_widget
  });

  return /*#__PURE__*/React__default.createElement(FormulaField, _extends({}, props, {
    value: value
  }), noWrap ? /*#__PURE__*/React__default.createElement(Fragment$1, null, props.field.field_widget.get_string_value(record, value)) : /*#__PURE__*/React__default.createElement(Fragment$1, null, /*#__PURE__*/React__default.createElement(Fragment$1, null, fields[props.field.formula_field_widget]({
    props: child_props,
    value: value,
    onChange: onChange,
    state_attrs: state_attrs,
    handleFieldBlur: handleFieldBlur,
    record: record
  }))));
};

var fields = {
  'float': function float(_ref2) {
    var props = _ref2.props,
        value = _ref2.value,
        onChange = _ref2.onChange,
        handleFieldBlur = _ref2.handleFieldBlur,
        state_attrs = _ref2.state_attrs,
        onFocus = _ref2.onFocus,
        record = _ref2.record;
    return /*#__PURE__*/React__default.createElement(FloatField, _extends({}, props, {
      value: value,
      onFocus: onFocus,
      onBlur: handleFieldBlur,
      onChange: onChange,
      state_attrs: state_attrs,
      record: record
    }));
  },
  'char': function char(_ref3) {
    var props = _ref3.props,
        value = _ref3.value,
        onChange = _ref3.onChange,
        handleFieldBlur = _ref3.handleFieldBlur,
        state_attrs = _ref3.state_attrs,
        onFocus = _ref3.onFocus;
    return /*#__PURE__*/React__default.createElement(BaseField, _extends({}, props, {
      value: value,
      onFocus: onFocus,
      onBlur: handleFieldBlur,
      onChange: onChange,
      state_attrs: state_attrs
    }));
  },
  'integer': function integer(_ref4) {
    var props = _ref4.props,
        value = _ref4.value,
        onChange = _ref4.onChange,
        handleFieldBlur = _ref4.handleFieldBlur,
        state_attrs = _ref4.state_attrs,
        onFocus = _ref4.onFocus;
    return /*#__PURE__*/React__default.createElement(BaseField, _extends({}, props, {
      value: value,
      onFocus: onFocus,
      onBlur: handleFieldBlur,
      onChange: onChange,
      state_attrs: state_attrs
    }));
  },
  'text': function text(_ref5) {
    var props = _ref5.props,
        value = _ref5.value,
        onChange = _ref5.onChange,
        handleFieldBlur = _ref5.handleFieldBlur,
        state_attrs = _ref5.state_attrs,
        onFocus = _ref5.onFocus;
    return /*#__PURE__*/React__default.createElement(TextField, _extends({}, props, {
      value: value,
      onBlur: handleFieldBlur,
      onFocus: onFocus,
      onChange: onChange,
      state_attrs: state_attrs
    }));
  },
  'date': function date(_ref6) {
    var props = _ref6.props,
        value = _ref6.value,
        onChange = _ref6.onChange,
        state_attrs = _ref6.state_attrs,
        handleFieldBlur = _ref6.handleFieldBlur;
    return /*#__PURE__*/React__default.createElement(DateField, _extends({}, props, {
      value: value,
      onBlur: handleFieldBlur,
      state_attrs: state_attrs,
      onChange: onChange
    }));
  },
  'many2one': function many2one(_ref7) {
    var props = _ref7.props,
        save = _ref7.save,
        state_attrs = _ref7.state_attrs,
        handleFieldBlur = _ref7.handleFieldBlur;
    return /*#__PURE__*/React__default.createElement(AsyncSelectField, _extends({
      saveOnBlur: save,
      state_attrs: state_attrs,
      onBlur: handleFieldBlur
    }, props));
  },
  'selection': function selection(_ref8) {
    var props = _ref8.props,
        onChange = _ref8.onChange,
        state_attrs = _ref8.state_attrs,
        handleFieldBlur = _ref8.handleFieldBlur;
    return /*#__PURE__*/React__default.createElement(SelectField, _extends({
      onChange: onChange,
      state_attrs: state_attrs,
      onBlur: handleFieldBlur
    }, props));
  },
  'boolean': function boolean(_ref9) {
    var props = _ref9.props,
        handleFieldBlur = _ref9.handleFieldBlur;
    return /*#__PURE__*/React__default.createElement(BooleanField, _extends({
      onBlur: handleFieldBlur
    }, props));
  },
  'multi_selection': function multi_selection(_ref10) {
    var props = _ref10.props,
        onChange = _ref10.onChange,
        state_attrs = _ref10.state_attrs,
        handleFieldBlur = _ref10.handleFieldBlur;
    return /*#__PURE__*/React__default.createElement(SelectField, _extends({
      onChange: onChange,
      multi: true,
      onBlur: handleFieldBlur,
      state_attrs: state_attrs
    }, props));
  },
  'one2many': function one2many(_ref11) {
    var props = _ref11.props,
        handleInnerOnChange = _ref11.handleInnerOnChange,
        state_attrs = _ref11.state_attrs;
    return /*#__PURE__*/React__default.createElement(O2MField, _extends({}, props, {
      state_attrs: state_attrs,
      onChange: handleInnerOnChange
    }));
  },
  'multi_link': function multi_link(_ref12) {
    var props = _ref12.props,
        save = _ref12.save,
        state_attrs = _ref12.state_attrs,
        handleFieldBlur = _ref12.handleFieldBlur;
    return /*#__PURE__*/React__default.createElement(AsyncSelectField, _extends({
      saveOnBlur: save,
      state_attrs: state_attrs,
      onBlur: handleFieldBlur
    }, props, {
      multi: true
    }));
  },
  'datetime': function datetime(_ref13) {
    var props = _ref13.props,
        value = _ref13.value,
        onChange = _ref13.onChange,
        state_attrs = _ref13.state_attrs,
        handleFieldBlur = _ref13.handleFieldBlur;
    return /*#__PURE__*/React__default.createElement(DateField, _extends({}, props, {
      value: value,
      state_attrs: state_attrs,
      onBlur: handleFieldBlur,
      onChange: onChange
    }));
  },
  'lookup': function lookup(_ref14) {
    var props = _ref14.props,
        value = _ref14.value,
        onChange = _ref14.onChange,
        handleFieldBlur = _ref14.handleFieldBlur,
        state_attrs = _ref14.state_attrs;
    return /*#__PURE__*/React__default.createElement(LookUpField, _extends({}, props, {
      value: value,
      onBlur: handleFieldBlur,
      onChange: onChange,
      state_attrs: state_attrs
    }));
  },
  'html': function html(_ref15) {
    var props = _ref15.props,
        value = _ref15.value,
        onChange = _ref15.onChange,
        handleFieldBlur = _ref15.handleFieldBlur,
        state_attrs = _ref15.state_attrs;
    return /*#__PURE__*/React__default.createElement(HtmlField, _extends({}, props, {
      value: value,
      onBlur: handleFieldBlur,
      onChange: onChange,
      state_attrs: state_attrs
    }));
  },
  'binary': function binary(_ref16) {
    var props = _ref16.props,
        value = _ref16.value,
        onChange = _ref16.onChange,
        handleFieldBlur = _ref16.handleFieldBlur,
        state_attrs = _ref16.state_attrs;
    return /*#__PURE__*/React__default.createElement(BinaryField, _extends({}, props, {
      value: value,
      onBlur: handleFieldBlur,
      onChange: onChange,
      state_attrs: state_attrs
    }));
  },
  'formula': function formula(_ref17) {
    var props = _ref17.props,
        value = _ref17.value,
        onChange = _ref17.onChange,
        handleFieldBlur = _ref17.handleFieldBlur,
        state_attrs = _ref17.state_attrs,
        record = _ref17.record,
        noWrap = _ref17.noWrap;
    return renderFormulaField({
      props: props,
      value: value,
      onChange: onChange,
      handleFieldBlur: handleFieldBlur,
      state_attrs: state_attrs,
      record: record,
      noWrap: noWrap
    });
  },
  'button': function button(_ref18) {
    var props = _ref18.props,
        state_attrs = _ref18.state_attrs,
        record = _ref18.record;
    return /*#__PURE__*/React__default.createElement(FormButton, _extends({}, props, {
      style: props.field.style || {},
      color: props.field.button_variant,
      onClick: function onClick(e) {
        props.field.action.execute([record], false);
      },
      state_attrs: state_attrs
    }), props.field.description);
  },
  'divider': function divider(_ref19) {
    var props = _ref19.props,
        state_attrs = _ref19.state_attrs;
    return /*#__PURE__*/React__default.createElement(FormDivider, _extends({}, props, {
      state_attrs: state_attrs,
      text: props.field.description
    }));
  }
};
var Field = observer(function Field(props) {
  var field = props.field,
      record = props.record;
  var value = field.get_value(record);
  var state_attrs = field.get_state_attrs(record) || {};

  function onChange(e, value) {
    record.setFieldInEdition(field.name);
    return field.set_value(value, record);
  }

  useEffect(function () {
    return function cleanup() {
      record.setFieldInEdition(false);
    };
  }, []);

  function onBlur(e, new_value) {
    record.setFieldInEdition(false);
    return field.custom_on_change({
      value: new_value,
      record: record
    });
  }

  function onFocus(e) {}

  var getField = function getField() {
    if (state_attrs.invisible) {
      return /*#__PURE__*/React__default.createElement(Fragment$1, null);
    }

    var type = field.type;

    if (field.attributes.widget) {
      return /*#__PURE__*/React__default.createElement(Fragment$1, null, widgets$1.get(type, field.attributes.widget)(_extends({}, props, {
        value: value,
        onChange: onChange,
        state_attrs: state_attrs,
        onFocus: onFocus,
        handleFieldBlur: onBlur,
        record: record
      })));
    }

    if (fields[type]) {
      var field_component = /*#__PURE__*/React__default.createElement(Fragment$1, null, fields[type]({
        props: props,
        value: value,
        onChange: onChange,
        state_attrs: state_attrs,
        onFocus: onFocus,
        handleFieldBlur: onBlur,
        record: record,
        noWrap: props.noWrap
      }));

      if (props.show_tooltip && field.tooltip) {
        return /*#__PURE__*/React__default.createElement(Tooltip, {
          content: field.tooltip.content,
          template: field.tooltip.template
        }, field_component);
      } else {
        return field_component;
      }
    }
  };

  return /*#__PURE__*/React__default.createElement(Fragment$1, null, field.no_wrap || props.noWrap || NO_WRAP_FIELDS.includes(field.type) ? /*#__PURE__*/React__default.createElement(Fragment$1, null, getField()) : /*#__PURE__*/React__default.createElement(FieldWrapper, _extends({
    state_attrs: state_attrs,
    value: value,
    style: {
      display: state_attrs.invisible ? 'none' : ''
    }
  }, props), getField()));
});

var fullscreen_style = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  right: 'auto',
  bottom: 'auto',
  marginRight: '-50%',
  transform: 'translateX(-50%) translateY(calc(-50% - .5px))',
  zIndex: '9999',
  fontSmoothing: 'subpixel-antialiased'
};
var LoadingIndicator = React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement("div", null, props.show && ref && /*#__PURE__*/React__default.createElement(Portal, null, /*#__PURE__*/React__default.createElement(LoadingIndicatorComp, _extends({
    key: 'loading',
    parent_ref: ref
  }, props))));
});

function LoadingIndicatorComp(props) {
  var _useState = useState({}),
      position = _useState[0],
      setPosition = _useState[1];

  var fullscreen = props.fullscreen,
      modifiers = props.modifiers;
  var cls = fullscreen ? 'absolute bg-modal-background inset-0 z-40' : 'flex items-center justify-center';
  useEffect(function () {
    if (!fullscreen) {
      var dimensions = props.parent_ref.current.getBoundingClientRect();
      var pos = {
        position: 'absolute',
        left: dimensions.left,
        top: dimensions.top,
        width: dimensions.width,
        height: dimensions.height,
        zIndex: '9999'
      };

      if (props.modifiers) {
        pos.width += modifiers.width || 0;
        pos.left += modifiers.left || 0;
        pos.top += modifiers.top || 0;
        pos.height = modifiers.height || 0;
      }

      setPosition(pos);
    }
  }, [props.parent_ref, modifiers, fullscreen]);
  return (
    /*#__PURE__*/
    React__default.createElement("div", _extends({
      className: cls
    }, props, {
      style: !fullscreen ? position : {}
    }), /*#__PURE__*/React__default.createElement("div", {
      style: fullscreen ? fullscreen_style : {}
    }, /*#__PURE__*/React__default.createElement("svg", {
      className: "ml-1 mr-3 h-10 w-10 text-primary animation_spin",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24"
    }, /*#__PURE__*/React__default.createElement("circle", {
      className: "opacity-25",
      cx: "12",
      cy: "12",
      r: "10",
      stroke: "currentColor",
      strokeWidth: "4"
    }), /*#__PURE__*/React__default.createElement("path", {
      className: "opacity-75",
      fill: "currentColor",
      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    }))))
  );
}

var _path$a;

function _extends$b() {
  _extends$b = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$b.apply(this, arguments);
}

function SvgReport(props) {
  return /*#__PURE__*/createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$a || (_path$a = /*#__PURE__*/createElement("path", {
    d: "M16 2h4v15a3 3 0 01-3 3H3a3 3 0 01-3-3V0h16v2zm0 2v13a1 1 0 001 1 1 1 0 001-1V4h-2zM2 2v15a1 1 0 001 1h11.17a2.98 2.98 0 01-.17-1V2H2zm2 8h8v2H4v-2zm0 4h8v2H4v-2zM4 4h8v4H4V4z"
  })));
}

var _path$b;

function _extends$c() {
  _extends$c = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$c.apply(this, arguments);
}

function SvgLink(props) {
  return /*#__PURE__*/createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$b || (_path$b = /*#__PURE__*/createElement("path", {
    d: "M9.26 13a2 2 0 01.01-2.01A3 3 0 009 5H5a3 3 0 000 6h.08a6.06 6.06 0 000 2H5A5 5 0 015 3h4a5 5 0 01.26 10zm1.48-6a2 2 0 01-.01 2.01A3 3 0 0011 15h4a3 3 0 000-6h-.08a6.06 6.06 0 000-2H15a5 5 0 010 10h-4a5 5 0 01-.26-10z"
  })));
}

var _path$c;

function _extends$d() {
  _extends$d = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$d.apply(this, arguments);
}

function SvgAction(props) {
  return /*#__PURE__*/createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$c || (_path$c = /*#__PURE__*/createElement("path", {
    d: "M3.94 6.5L2.22 3.64l1.42-1.42L6.5 3.94c.52-.3 1.1-.54 1.7-.7L9 0h2l.8 3.24c.6.16 1.18.4 1.7.7l2.86-1.72 1.42 1.42-1.72 2.86c.3.52.54 1.1.7 1.7L20 9v2l-3.24.8c-.16.6-.4 1.18-.7 1.7l1.72 2.86-1.42 1.42-2.86-1.72c-.52.3-1.1.54-1.7.7L11 20H9l-.8-3.24c-.6-.16-1.18-.4-1.7-.7l-2.86 1.72-1.42-1.42 1.72-2.86c-.3-.52-.54-1.1-.7-1.7L0 11V9l3.24-.8c.16-.6.4-1.18.7-1.7zM10 13a3 3 0 100-6 3 3 0 000 6z"
  })));
}

var _path$d;

function _extends$e() {
  _extends$e = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$e.apply(this, arguments);
}

function SvgViewShow(props) {
  return /*#__PURE__*/createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$d || (_path$d = /*#__PURE__*/createElement("path", {
    d: "M.2 10a11 11 0 0119.6 0A11 11 0 01.2 10zm9.8 4a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 110-4 2 2 0 010 4z"
  })));
}

var _path$e;

function _extends$f() {
  _extends$f = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$f.apply(this, arguments);
}

function SvgDotsHorizontalTriple(props) {
  return /*#__PURE__*/createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$e || (_path$e = /*#__PURE__*/createElement("path", {
    d: "M10 12a2 2 0 110-4 2 2 0 010 4zm0-6a2 2 0 110-4 2 2 0 010 4zm0 12a2 2 0 110-4 2 2 0 010 4z"
  })));
}

var _path$f;

function _extends$g() {
  _extends$g = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$g.apply(this, arguments);
}

function SvgMinusSolid(props) {
  return /*#__PURE__*/createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$f || (_path$f = /*#__PURE__*/createElement("path", {
    d: "M10 20a10 10 0 110-20 10 10 0 010 20zm5-11H5v2h10V9z"
  })));
}

var _path$g;

function _extends$h() {
  _extends$h = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$h.apply(this, arguments);
}

function SvgAddSolid(props) {
  return /*#__PURE__*/createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$g || (_path$g = /*#__PURE__*/createElement("path", {
    d: "M11 9V5H9v4H5v2h4v4h2v-4h4V9h-4zm-1 11a10 10 0 110-20 10 10 0 010 20z"
  })));
}

var MenuContent = React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement("div", {
    ref: ref
  }, /*#__PURE__*/React__default.createElement(Paper, {
    style: props.position
  }, props.options.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "text-xs text-gray-800 font-medium py-2 px-2 cursor-pointer hover:bg-light-hover hover:text-primary border-t-0.5 border-gray-300",
      key: index,
      onClick: function onClick(e) {
        return item.onClick(e, item.id);
      }
    }, item.label);
  })));
});
function DropDownMenu(props) {
  var _useState = useState({}),
      position = _useState[0],
      setPosition = _useState[1];

  var width = 150;
  var content_ref = React__default.createRef();
  useClickOutside(content_ref, props.onClose, props.open, true);
  useEffect(function () {
    if (props.anchor) {
      var rect = props.anchor.getBoundingClientRect();
      console.log("RECT");
      console.log(rect);
      var left = rect.x + rect.width / 2;
      var top = rect.y + window.scrollY + rect.height;

      if (window.innerWidth - left < width) {
        left = left - width;
      }

      var pos = {
        position: 'absolute',
        left: left,
        top: top,
        width: width,
        zIndex: '9999'
      };
      setPosition(pos);
    }
  }, [props.anchor]);
  return /*#__PURE__*/React__default.createElement(Fragment$1, null, props.open && /*#__PURE__*/React__default.createElement(Portal, null, /*#__PURE__*/React__default.createElement(MenuContent, _extends({
    ref: content_ref,
    position: position
  }, props))));
}

var ViewEditorDropdown = observer(function ViewEditorDropdown(props) {
  var _React$useState = React__default.useState(false),
      anchorEl = _React$useState[0],
      setAnchorEl = _React$useState[1];

  var _React$useState2 = React__default.useState(false),
      openMenu = _React$useState2[0],
      setOpenMenu = _React$useState2[1];

  var screen = props.screen;
  var menu_options = screen.editor.edition_options || [];

  function onIconClick(e) {
    console.log("clicking");
    setAnchorEl(e.currentTarget);
    toogleMenu();
  }

  function toogleMenu() {
    setOpenMenu(!openMenu);
  }

  return /*#__PURE__*/React__default.createElement(Fragment$1, null, /*#__PURE__*/React__default.createElement(DropDownMenu, {
    id: "actions-menu",
    anchor: anchorEl,
    options: menu_options,
    open: openMenu,
    onClose: toogleMenu
  }), /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick(e) {
      onIconClick(e);
    },
    color: "transparent"
  }, /*#__PURE__*/React__default.createElement(SvgEditPencil, {
    style: {
      width: '.8em',
      height: '.8em'
    },
    className: "fill-current  text-xl cursor-pointer w-4 h-2"
  })));
});

var _path$h;

function _extends$i() {
  _extends$i = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$i.apply(this, arguments);
}

function SvgFilter(props) {
  return /*#__PURE__*/createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path$h || (_path$h = /*#__PURE__*/createElement("path", {
    d: "M21 3H5a1 1 0 00-1 1v2.59c0 .523.213 1.037.583 1.407L10 13.414V21a1.001 1.001 0 001.447.895l4-2c.339-.17.553-.516.553-.895v-5.586l5.417-5.417c.37-.37.583-.884.583-1.407V4a1 1 0 00-1-1zm-6.707 9.293A.996.996 0 0014 13v5.382l-2 1V13a.996.996 0 00-.293-.707L6 6.59V5h14.001l.002 1.583-5.71 5.71z"
  })));
}

var customStyles$2 = {
  menu: function menu(provided, state) {
    return _extends({}, provided, {
      borderRadius: "0px",
      marginTop: "0px",
      width: "10em"
    });
  },
  control: function control(provided, state) {
    return _extends({}, provided, {
      border: "0px",
      backgroundColor: "transparent",
      boxShadow: "none",
      height: "100%"
    });
  },
  menuPortal: function menuPortal(provided, state) {
    return _extends({}, provided, {
      zIndex: 9999
    });
  },
  valueContainer: function valueContainer(provided, state) {
    return {};
  }
};
var Filter = observer(function Filter(props) {
  var filter = props.filter,
      removeFilter = props.removeFilter,
      record = props.record,
      containerStyle = props.containerStyle;
  return /*#__PURE__*/React__default.createElement("div", {
    style: containerStyle,
    className: "w-auto border-b-2 py-2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "flex"
  }, !filter.is_field_readonly && /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick() {
      removeFilter(filter);
    },
    color: "warning"
  }, /*#__PURE__*/React__default.createElement(SvgClose, {
    style: {
      width: ".8em",
      height: ".8em"
    },
    className: "fill-current text-base cursor-pointer w-4 h-2"
  })), !filter.hide_modifiers && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "35%"
    }
  }, /*#__PURE__*/React__default.createElement(Select, {
    isSearchable: true,
    value: filter.field,
    styles: customStyles$2,
    placeholder: "Campo",
    isDisabled: filter.is_field_readonly,
    menuPosition: "fixed",
    onChange: function onChange(value) {
      filter.setField(value);
    },
    options: filter.field_options,
    getOptionValue: function getOptionValue(option) {
      return option["id"];
    },
    getOptionLabel: function getOptionLabel(option) {
      return option["description"];
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "25%"
    }
  }, /*#__PURE__*/React__default.createElement(Select, {
    isSearchable: true,
    value: filter.operator,
    styles: customStyles$2,
    placeholder: "Operador",
    isDisabled: filter.is_operator_readonly,
    menuPosition: "fixed",
    onChange: function onChange(value) {
      filter.setOperator(value);
    },
    options: filter.operator_options
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: filter.hide_modifiers ? "100%" : "40%"
    }
  }, filter.field && /*#__PURE__*/React__default.createElement(Field, {
    field: filter.field,
    record: record
  }))));
});

var QuickFilters = observer(function QuickFilters(props) {
  var screen = props.screen;
  var record = screen.filters.record;
  var quick_filters = screen.filters ? screen.filters.quick_filters : [];
  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex-grow flex items-center  w-full overflow-hidden"
  }, quick_filters.map(function (qf) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: qf.field.id
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "w-1/2 border-l border-r border-t border-gray-300 mr-2"
    }, /*#__PURE__*/React__default.createElement(Filter, {
      filter: qf,
      removeFilter: function removeFilter() {},
      record: record,
      containerStyle: {
        'padding': 0
      }
    })));
  }));
});
var FilterBar = observer(function FilterBar(props) {
  var screen = props.screen,
      parent_ref = props.parent_ref;
  var filters = screen.filters;
  var record = filters.record;

  var _useState = useState(false),
      filters_open = _useState[0],
      setFiltersOpen = _useState[1];

  var changueColorIcon = filters.some_applied == true ? 'fill-current text-red-600 text-2xl cursor-pointer rounded' : 'fill-current  text-2xl cursor-pointer w-4 h-2';

  function toogleFilters() {
    setFiltersOpen(!filters_open);
  }

  function addFilter() {
    return filters.addFilter();
  }

  function removeFilter(filter) {
    return filters.removeFilter(filter);
  }

  function search() {
    var search_started = filters.search();

    if (search_started) {
      toogleFilters();
    }
  }

  return /*#__PURE__*/React__default.createElement(Fragment$1, null, /*#__PURE__*/React__default.createElement(QuickFilters, {
    screen: screen
  }), /*#__PURE__*/React__default.createElement(IconButton, {
    color: "transparent",
    className: "text-primary"
  }, /*#__PURE__*/React__default.createElement(SvgFilter, {
    color: "primary",
    style: {
      width: '0.8em',
      height: '0.8em'
    },
    className: changueColorIcon,
    onClick: toogleFilters
  })), filters_open && /*#__PURE__*/React__default.createElement(DropDown, {
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        search();
      }
    },
    ref: parent_ref,
    open: filters_open,
    onClose: toogleFilters
  }, /*#__PURE__*/React__default.createElement(Paper, {
    className: "mt-1 border-t-2 pt-4 rounded"
  }, /*#__PURE__*/React__default.createElement("div", null, filters.active_filters.map(function (filter, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      className: "px-8"
    }, /*#__PURE__*/React__default.createElement(Filter, {
      index: index,
      filter: filter,
      removeFilter: removeFilter,
      record: record
    }));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "flex items-center justify-between pb-2 pt-3 px-10 w-full"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
    className: "py-2 px-2 text-sm font-medium cursor-pointer text-primary rounded hover:bg-light-selected",
    onClick: function onClick(e) {
      addFilter();
    }
  }, "+ A\xF1adir Filtro")), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FormButton, {
    color: "primary",
    state_attrs: {
      invisible: false,
      readonly: false
    },
    onClick: function onClick(e) {
      search();
    }
  }, "BUSCAR"))))));
});

var FilterChip = observer(function FilterChip(props) {
  var filter = props.filter,
      record = props.record,
      removeFilter = props.removeFilter;
  var description = filter.field.description;
  var operator_label = filter.operator ? filter.operator.label : false;
  var value = filter.field ? filter.field.get_string_value(record) : false;
  var valid = description && operator_label && value;
  return /*#__PURE__*/React__default.createElement(Fragment$1, null, valid && /*#__PURE__*/React__default.createElement("div", {
    className: "cursor-default flex mr-1 rounded bg-white border border-gray-300 text-gray-600 font-semibold "
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "flex m-2"
  }, /*#__PURE__*/React__default.createElement("p", null, description), /*#__PURE__*/React__default.createElement("p", {
    className: "mx-1"
  }, "|"), /*#__PURE__*/React__default.createElement("p", null, operator_label), /*#__PURE__*/React__default.createElement("p", {
    className: "mx-1"
  }, "|"), /*#__PURE__*/React__default.createElement("p", {
    className: "text-primary"
  }, value)), !filter.required && /*#__PURE__*/React__default.createElement(IconButton, {
    color: "warning"
  }, /*#__PURE__*/React__default.createElement(SvgClose, {
    className: "fill-current h-3",
    onClick: function onClick() {
      removeFilter(filter);
    }
  }))));
});
var FiltersActive = observer(function FiltersActive(props) {
  var filters = props.filters;
  var filtersActive = filters.active_filters;
  var record = filters.record;

  function removeFilter(filter) {
    filters.removeFilter(filter);
    return filters.search();
  }

  return filtersActive.length > 0 ? /*#__PURE__*/React__default.createElement("div", {
    className: "text-left text-xs py-2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "flex "
  }, filtersActive.map(function (filter, index) {
    return /*#__PURE__*/React__default.createElement(Fragment$1, null, /*#__PURE__*/React__default.createElement(FilterChip, {
      filter: filter,
      record: record,
      removeFilter: removeFilter,
      key: index
    }));
  }))) : "";
});

var _customSelectStyles;
var customSelectStyles = (_customSelectStyles = {
  menu: function menu(provided, state) {
    return _extends({}, provided, {
      borderRadius: '0px',
      marginTop: '0px'
    });
  },
  control: function control(provided, state) {
    return _extends({}, provided, {
      border: '0px',
      backgroundColor: 'transparent',
      boxShadow: 'none',
      minHeight: '0px'
    });
  },
  indicatorSeparator: function indicatorSeparator(provided, state) {
    return _extends({}, provided, {
      display: 'none'
    });
  },
  dropdownIndicator: function dropdownIndicator(provided, state) {
    return _extends({}, provided, {
      cursor: 'pointer',
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: '1.5rem',
      color: 'inherit'
    });
  },
  input: function input(provided, state) {
    return _extends({}, provided, {
      margin: 0,
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: '1.5rem'
    });
  },
  valueContainer: function valueContainer(provided, state) {
    return _extends({}, provided, {
      cursor: 'pointer',
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: '1.5rem'
    });
  },
  singleValue: function singleValue(provided, state) {
    return _extends({}, provided, {
      cursor: 'pointer',
      padding: 0,
      maxHeight: '1.5rem',
      fontSize: 'inherit',
      fontWeight: 'inherit',
      color: 'inherit',
      fontFamily: 'inherit'
    });
  }
}, _customSelectStyles["menu"] = function menu(provided, state) {
  return _extends({}, provided, {
    cursor: 'pointer',
    fontSize: '0.75rem',
    fontWeight: '500',
    color: 'rgba(113, 128, 150,1)',
    fontFamily: 'inherit'
  });
}, _customSelectStyles.option = function option(provided, state) {
  return _extends({}, provided, {
    cursor: 'pointer'
  });
}, _customSelectStyles.menuPortal = function menuPortal(provided, state) {
  return _extends({}, provided, {
    zIndex: 9999
  });
}, _customSelectStyles);
var NewRecordButton = observer(function NewRecordButton(props) {
  var screen = props.screen;
  var readonly = screen.readonly;
  var add_record_button = screen.add_record_button;

  if (readonly || !add_record_button) {
    return /*#__PURE__*/React__default.createElement(Fragment$1, null);
  }

  return /*#__PURE__*/React__default.createElement(Fragment$1, null, add_record_button.text ? /*#__PURE__*/React__default.createElement("div", {
    className: "py-1 mr-2 flex items-center"
  }, /*#__PURE__*/React__default.createElement(FormButton, {
    variant: "list",
    state_attrs: {},
    className: " truncate text-xs  py-1 px-2",
    color: add_record_button.color || 'primary',
    onClick: function onClick(e) {
      add_record_button.execute();
    }
  }, add_record_button.text)) : /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick(e) {
      screen.add_record_button.execute();
    },
    color: "transparent"
  }, /*#__PURE__*/React__default.createElement(SvgAddSolid, {
    style: {
      width: '.8em',
      height: '.8em'
    },
    className: "fill-current  text-xl cursor-pointer w-4 h-2"
  })));
});
var AddNewRecordButton = observer(function AddNewRecordButton(props) {
  var createRow = function createRow(rowIndex, columnIndex) {
    try {
      if (!rowIndex || rowIndex === props.rowCount) {
        rowIndex = props.rowCount + 1;
        columnIndex = 1;
      }

      var record = screen.data.addRecord({
        values: {},
        index: rowIndex
      });
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var screen = props.screen;
  var default_save_action = screen.default_save_action;

  if (screen.readonly || default_save_action && default_save_action.invisible) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  }

  return /*#__PURE__*/React__default.createElement(IconButton, {
    color: "transparent",
    onClick: function onClick() {
      return createRow();
    }
  }, /*#__PURE__*/React__default.createElement(SvgAddSolid, {
    style: {
      width: '.8em',
      height: '.8em'
    },
    className: "fill-current text-xl cursor-pointer w-4 h-2"
  }));
});
var ActionsBar = observer(function ActionsBar(props) {
  var screen = props.screen,
      parent_ref = props.parent_ref;
  var actions = screen.actions;

  var _React$useState = React__default.useState(false),
      anchorEl = _React$useState[0],
      setAnchorEl = _React$useState[1];

  var _React$useState2 = React__default.useState(false),
      openMenu = _React$useState2[0],
      setOpenMenu = _React$useState2[1];

  var _React$useState3 = React__default.useState([]),
      menuOptions = _React$useState3[0],
      setMenuOptions = _React$useState3[1];

  var selected_qty = screen.selected_records ? screen.selected_records.length : 0;
  var readonly = screen.readonly;
  var link_actions = screen.link_actions;
  var report_actions = screen.report_actions;
  var action_actions = screen.action_actions;
  var view_group_actions = screen.view_group_actions;
  var general_actions = screen.general_actions;
  var delete_action = screen.delete_action;
  var button_actions = screen.button_actions;
  var editor_actions = screen.editor.edition_options;

  function executeAction(e, id) {
    var action = actions.find(function (act) {
      return act.id === id;
    });
    action.execute();
  }

  function onClickButton(e, type) {
    setAnchorEl(e.currentTarget);
    var menu_actions = [];

    switch (type) {
      case 'link':
        menu_actions = link_actions;
        break;

      case 'general_menu':
        menu_actions = general_actions;
        break;

      case 'report':
        menu_actions = report_actions;
        break;

      default:
        menu_actions = [];
        break;
    }

    setMenuOptions(menu_actions.map(function (act) {
      return {
        label: act.description,
        id: act.id,
        onClick: executeAction
      };
    }));
    setOpenMenu(true);
  }

  function closeMenu(e) {
    setAnchorEl(false);
    setOpenMenu(false);
  }

  var isVisible = function isVisible(action) {
    return action.visible_on_select ? selected_qty > 0 : true;
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex"
  }, props.isSpreadsheet && /*#__PURE__*/React__default.createElement(AddNewRecordButton, {
    rowCount: props.rowCount,
    screen: screen
  }), /*#__PURE__*/React__default.createElement(Fragment$1, null, screen.filterable ?
  /*#__PURE__*/
  React__default.createElement(FilterBar, {
    className: "fill-current  text-xl cursor-pointer w-4 h-2",
    screen: screen,
    parent_ref: parent_ref
  }) : ""), screen.add_record_button !== false &&
  /*#__PURE__*/
  React__default.createElement(NewRecordButton, {
    screen: screen
  }), delete_action !== false && /*#__PURE__*/React__default.createElement(Fragment$1, null, !readonly && isVisible(delete_action) && /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick(e) {
      executeAction(e, delete_action.id);
    },
    color: "warning"
  }, /*#__PURE__*/React__default.createElement(SvgMinusSolid, {
    style: {
      width: '.8em',
      height: '.8em'
    },
    className: "fill-current  text-xl cursor-pointer w-4 h-2"
  }))), props.search && /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: props.toogleSearch,
    color: "transparent"
  }, /*#__PURE__*/React__default.createElement(SvgSearch, {
    style: {
      width: '.8em',
      height: '.8em'
    },
    className: "fill-current  text-xl cursor-pointer w-4 h-2"
  })), view_group_actions.length !== 0 && /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick(e) {
      onClickButton(e, 'view_group');
    },
    color: "transparent"
  }, /*#__PURE__*/React__default.createElement(SvgViewShow, {
    style: {
      width: '.8em',
      height: '.8em'
    },
    className: "fill-current  text-xl cursor-pointer w-4 h-2"
  })), link_actions.length !== 0 && /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick(e) {
      onClickButton(e, 'link');
    },
    color: "transparent"
  }, /*#__PURE__*/React__default.createElement(SvgLink, {
    style: {
      width: '.8em',
      height: '.8em'
    },
    className: "fill-current  text-xl cursor-pointer w-4 h-2"
  })), report_actions.length !== 0 && /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick(e) {
      onClickButton(e, 'report');
    },
    color: "transparent"
  }, /*#__PURE__*/React__default.createElement(SvgReport, {
    style: {
      width: '.8em',
      height: '.8em'
    },
    className: "fill-current  text-xl cursor-pointer w-4 h-2"
  })), action_actions.length !== 0 && /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick(e) {
      onClickButton(e, 'action');
    },
    color: "transparent"
  }, /*#__PURE__*/React__default.createElement(SvgAction, {
    style: {
      width: '.8em',
      height: '.8em'
    },
    className: "fill-current  text-xl cursor-pointer w-4 h-2"
  })), general_actions.length !== 0 && /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick(e) {
      onClickButton(e, 'general_menu');
    },
    color: "transparent"
  }, /*#__PURE__*/React__default.createElement(SvgDotsHorizontalTriple, {
    style: {
      width: '.8em',
      height: '.8em'
    },
    className: "fill-current  text-xl cursor-pointer w-4 h-2"
  })), props.extra_action_menu ? /*#__PURE__*/React__default.createElement(Fragment$1, null, props.extra_action_menu) : "", editor_actions && editor_actions.length !== 0 && /*#__PURE__*/React__default.createElement(ViewEditorDropdown, {
    screen: screen
  }), button_actions.map(function (action) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: action.id
    }, isVisible(action) && /*#__PURE__*/React__default.createElement("div", {
      className: "py-1 mr-2 flex items-center"
    }, /*#__PURE__*/React__default.createElement(FormButton, {
      variant: "list",
      state_attrs: {},
      className: " truncate text-xs  py-1 px-2",
      color: action.button_color || 'transparent',
      onClick: function onClick(e) {
        action.execute();
      }
    }, action.description)));
  }), /*#__PURE__*/React__default.createElement(DropDownMenu, {
    id: "actions-menu",
    anchor: anchorEl,
    options: menuOptions,
    open: Boolean(openMenu),
    onClose: closeMenu
  }));
});
var SpreadsheetHeader = observer(function SpreadsheetHeader(props) {
  var screen = props.screen;
  var _screen$data = screen.data,
      limit = _screen$data.limit,
      pagination_enabled = _screen$data.pagination_enabled,
      page_size_options = _screen$data.page_size_options,
      page_qty = _screen$data.page_qty,
      current_page = _screen$data.current_page;
  var val = page_size_options.find(function (o) {
    return o.value == limit;
  });

  function onChangeLimit(value) {
    screen.set_limit(parseInt(value.value));
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex h-full w-40"
  }, pagination_enabled && /*#__PURE__*/React__default.createElement("div", {
    className: "block border-l w-full text-gray-600 border-r border-gray-300 text-xs font-medium"
  }, /*#__PURE__*/React__default.createElement("sup", {
    className: "px-10"
  }, "P\xE1gina ", current_page, " de ", page_qty), /*#__PURE__*/React__default.createElement("div", {
    className: "hover:text-primary",
    style: {
      margin: '-10px 15px 0 16px'
    }
  }, " ", /*#__PURE__*/React__default.createElement(Select, {
    isSearchable: false,
    value: val,
    styles: customSelectStyles,
    menuPortalTarget: document.body,
    menuPosition: 'fixed',
    onChange: function onChange(value) {
      return onChangeLimit(value);
    },
    options: page_size_options
  }))));
});
var RecordCounter = observer(function RecordCounter(props) {
  var screen = props.screen,
      className = props.className,
      style = props.style;
  var count = screen.data.count;
  var cls = "flex items-center justify-center text-gray-600 border-r border-l border-gray-300 text-xs font-medium ".concat(className);
  return /*#__PURE__*/React__default.createElement("div", {
    className: cls,
    style: style
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "w-20 mr-2 ml-2"
  }, count, " Resultados"));
});
var PaginationControl = observer(function PaginationControl(props) {
  var screen = props.screen;
  var pagination_enabled = screen.data.pagination_enabled;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React__default.createElement(RecordCounter, {
    screen: screen
  }), pagination_enabled && /*#__PURE__*/React__default.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick(e) {
      screen.data.prevPage();
    },
    color: "transparent"
  }, /*#__PURE__*/React__default.createElement(SvgCheveronLeft, {
    style: {
      width: '.8em',
      height: '.8em'
    },
    className: "fill-current  text-xl cursor-pointer w-4 h-2"
  }))), /*#__PURE__*/React__default.createElement("div", null, ['list', 'spreadsheet'].includes(screen.type) && /*#__PURE__*/React__default.createElement(SpreadsheetHeader, {
    screen: screen
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick(e) {
      screen.data.nextPage();
    },
    color: "transparent"
  }, /*#__PURE__*/React__default.createElement(SvgCheveronRight, {
    style: {
      width: '.8em',
      height: '.8em'
    },
    className: "fill-current  text-xl cursor-pointer w-4 h-2"
  })))));
});
var ViewHeader = observer(function ViewHeader(props) {
  var _useState = useState(false),
      search = _useState[0],
      setSearch = _useState[1];

  var screen = props.screen,
      hide_toolbar = props.hide_toolbar,
      title_classname = props.title_classname,
      container_classname = props.container_classname;
  var _screen$data2 = screen.data,
      pagination_enabled = _screen$data2.pagination_enabled,
      show_records_count = _screen$data2.show_records_count;
  var selected_qty = screen.selected_records ? screen.selected_records.length : 0;
  var title = screen.title;
  var base_container_cls = "w-full flex justify-between mb-2";
  var container_cls = container_classname ? clsx(container_classname, base_container_cls) : base_container_cls;
  var isSmartOption = screen.smart_sort_options && screen.smart_sort_options.length > 0 ? true : false;

  function toogleSearch() {
    setSearch(!search);
  }

  var changueSmartOrder = function changueSmartOrder(e) {
    var fieldName = e.field.rec_name;
    var valueName = e.value;
    screen.set_order(fieldName, valueName);
  };

  var ref = React__default.createRef();
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: container_cls
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: ref,
    className: "w-full flex items-center justify-between px-2 appearance-none leading-normal mb-1 "
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col-span-4 flex h-full items-center overflow-hidden"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: window.innerWidth * 20 / 100
    },
    className: title_classname ? title_classname : "text-md text-left text-gray-600 font-medium overflow-ellipsis overflow-hidden whitespace-nowrap"
  }, title)), selected_qty > 0 && !hide_toolbar && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "text-sm bg-light-selected px-2 py-1 rounded-full text-primary text-left text-gray-600 font-medium"
  }, selected_qty, " registros seleccionados")), !hide_toolbar && /*#__PURE__*/React__default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React__default.createElement(ActionsBar, {
    parent_ref: ref,
    toogleSearch: toogleSearch,
    search: props.filter_bar ? true : false,
    screen: screen,
    isSpreadsheet: props.isSpreadsheet,
    extra_action_menu: props.extra_action_menu,
    rowCount: props.rowCount
  }))), isSmartOption ? /*#__PURE__*/React__default.createElement("div", {
    className: "flex items-center border-l border-gray-300"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "hover:text-primary w-40 text-gray-600  text-xs font-medium"
  }, /*#__PURE__*/React__default.createElement(Select, {
    placeholder: 'Ordenar',
    options: screen.smart_sort_options,
    onChange: function onChange(value) {
      return changueSmartOrder(value);
    },
    getOptionLabel: function getOptionLabel(option) {
      return option.name;
    },
    getOptionValue: function getOptionValue(option) {
      return option.name;
    },
    styles: customSelectStyles
  }))) : '', pagination_enabled ? /*#__PURE__*/React__default.createElement(PaginationControl, {
    screen: screen
  }) : /*#__PURE__*/React__default.createElement(Fragment$1, null, show_records_count && /*#__PURE__*/React__default.createElement(RecordCounter, {
    screen: screen,
    className: "px-4",
    style: {
      border: '0px'
    }
  }))), screen.filterable && !screen.field_instance ? /*#__PURE__*/React__default.createElement(FiltersActive, {
    filters: screen.filters
  }) : "");
});

var FormField = observer(function FormField(props) {
  var field = props.field,
      record = props.record;
  var state_attrs = field.get_state_attrs(record);
  var cls = field.grid_cls;
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: state_attrs.invisible ? 'none' : ''
    },
    key: field.name,
    className: cls
  }, /*#__PURE__*/React__default.createElement(Field, {
    field: field,
    record: record,
    variant: "outlined",
    show_tooltip: true
  }));
});
var FormView = observer(function FormView(props) {
  var container_ref = React__default.createRef();
  var screen = props.screen;
  var fields = screen.visible_fields;
  var record = screen.active_record;
  var loading = screen.processing;
  var default_columns = screen.default_columns;
  var columns_classname = "grid-cols-" + default_columns;
  var grid = clsx("flex-grow grid  w-full gap-x-5 gap-y-4 py-4 px-4", columns_classname);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: container_ref
  }, /*#__PURE__*/React__default.createElement(Paper, {
    className: "py-2 px-2 rounded",
    style: props.containerStyle
  }, /*#__PURE__*/React__default.createElement(ViewHeader, {
    screen: screen,
    title_classname: "text-xl px-6 py-1 text-gray-800",
    hide_toolbar: props.hide_toolbar,
    isSpreadsheet: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: grid
  }, fields && record ? /*#__PURE__*/React__default.createElement(Fragment$1, null, fields.map(function (field, index) {
    return /*#__PURE__*/React__default.createElement(FormField, {
      key: field.id,
      field: field,
      record: record,
      default_columns: default_columns
    });
  })) : ""), /*#__PURE__*/React__default.createElement(LoadingIndicator, {
    ref: container_ref,
    show: loading,
    fullscreen: true
  })));
});

var ActionWidget = observer(function ActionWidget(props) {
  var widget = props.widget,
      height = props.height;
  var image = widget.image;
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: height
    },
    className: "flex bg-white shadow-xl flex-col w-1/2 px-4 py-4 text-center",
    onClick: function onClick() {
      widget.action.execute([]);
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "img-fluid",
    style: {
      display: 'inline-block'
    },
    src: image,
    alt: widget.name
  }), /*#__PURE__*/React__default.createElement("div", null, widget.name));
});

var SupersetDashboard = observer(function SupersetDashboard(props) {
  var height = props.height,
      widget = props.widget;
  var width = (window.innerWidth * 80 / 100).toString();
  var iframe_style = "height:" + height + "px" + ";width:" + width + "px";
  var enabled = widget.isEnabled();
  useEffect(function () {
    if (enabled && document.getElementById("superset_container")) {
      widget.embedSupersetDashboard(document.getElementById("superset_container"), iframe_style);
    }
  }, []);
  return (
    /*#__PURE__*/
    React__default.createElement("div", {
      id: "superset_container",
      className: "w-full"
    }, !enabled && /*#__PURE__*/React__default.createElement("div", null, "BI is not enabled. Please contact your consultant."))
  );
});

var widgets_map = {
  'view': function view(_ref) {
    var widget = _ref.widget,
        height = _ref.height;
    return /*#__PURE__*/React__default.createElement(View_, {
      screen: widget.screen,
      container: "base",
      height: height,
      hide_toolbar: false
    });
  },
  'action': function action(_ref2) {
    var widget = _ref2.widget,
        height = _ref2.height;
    return /*#__PURE__*/React__default.createElement(ActionWidget, {
      widget: widget,
      height: height
    });
  },
  'superset_dashboard': function superset_dashboard(_ref3) {
    var widget = _ref3.widget,
        height = _ref3.height,
        screen = _ref3.screen;
    return /*#__PURE__*/React__default.createElement(SupersetDashboard, {
      widget: widget,
      height: height,
      screen: screen,
      target: "board_base"
    });
  }
};
var widgetColspan = {
  1: "md:col-span-1",
  2: "md:col-span-2",
  3: "md:col-span-3",
  4: "md:col-span-4"
};
var boardColumns = {
  1: 'grid-cols-1 ',
  2: 'grid-cols-2 ',
  3: "grid-cols-3 ",
  4: "grid-cols-4 "
};

function WidgetContainer(props) {
  var widget = props.widget;
  var backgroundColor = widget.type === 'view' ? ' bg-white shadow-xl ' : ' bg-transparent ';
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      overflow: 'hidden'
    },
    className: "  w-full px-2 py-2 ".concat(widgetColspan[widget.colspan] || 4).concat(backgroundColor)
  }, props.children);
}

var BoardView = observer(function BoardView(props) {
  var screen = props.screen;
  var columns = screen.default_columns;
  var widgets = screen.widgets;

  var baseGridClass = function baseGridClass() {
    var base_cls = "flex-grow grid w-full  gap-x-5 gap-y-4 py-4 px-4 ";

    if (columns) {
      base_cls = base_cls.concat(boardColumns[columns]);
    }

    return base_cls;
  };

  return (
    /*#__PURE__*/
    React__default.createElement("div", {
      id: "board_base",
      className: baseGridClass()
    }, widgets.map(function (widget, index) {
      return /*#__PURE__*/React__default.createElement(WidgetContainer, {
        position: index,
        key: widget.id,
        widget: widget
      }, widgets_map[widget.type]({
        widget: widget,
        height: window.innerHeight * widget.height,
        screen: screen
      }));
    }))
  );
});

function DefaultContainer(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: props.className,
    style: props.style || {}
  }, props.children);
}

var Surfaces = {
  'paper': Paper,
  'base': DefaultContainer
};

function Container(props) {
  var Surface = Surfaces[props.type];
  return /*#__PURE__*/React__default.createElement(Surface, props, props.children);
}

var LineGraph = observer(function LineGraph(props) {
  var graph = props.graph;
  var x_legend = graph.x_legend;
  var y_legend = graph.y_legend;
  var data = graph.screen.data_values;
  console.log("LINE GRAPH VALUES");
  console.log(data);
  return /*#__PURE__*/React__default.createElement(Fragment$1, null, /*#__PURE__*/React__default.createElement(ResponsiveLine, {
    data: data,
    margin: {
      top: 50,
      right: 110,
      bottom: 50,
      left: 60
    },
    xScale: {
      type: 'point'
    },
    yScale: {
      type: 'linear',
      min: 'auto',
      max: 'auto',
      stacked: true,
      reverse: false
    },
    yFormat: " >-.2f",
    axisTop: null,
    axisRight: null,
    axisBottom: {
      orient: 'bottom',
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: x_legend,
      legendOffset: 36,
      legendPosition: 'middle'
    },
    axisLeft: {
      orient: 'left',
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: y_legend,
      legendOffset: -40,
      legendPosition: 'middle'
    },
    pointSize: 10,
    pointColor: {
      theme: 'background'
    },
    pointBorderWidth: 2,
    pointBorderColor: {
      from: 'serieColor'
    },
    pointLabelYOffset: -12,
    useMesh: true,
    legends: [{
      anchor: 'bottom-right',
      direction: 'column',
      justify: false,
      translateX: 100,
      translateY: 0,
      itemsSpacing: 0,
      itemDirection: 'left-to-right',
      itemWidth: 80,
      itemHeight: 20,
      itemOpacity: 0.75,
      symbolSize: 12,
      symbolShape: 'circle',
      symbolBorderColor: 'rgba(0, 0, 0, .5)',
      effects: [{
        on: 'hover',
        style: {
          itemBackground: 'rgba(0, 0, 0, .03)',
          itemOpacity: 1
        }
      }]
    }]
  }));
});

var BarGraph = observer(function BarGraph(props) {
  var graph = props.graph;
  var legend = graph.x_legend;
  var y_legend = graph.y_legend;
  var data = graph.screen.data_values;
  var format = graph.x_labels ? function (value) {
    return graph.x_labels[value];
  } : function (value) {
    return value;
  };
  var tooltip_format = graph.x_labels ? function (id) {
    return graph.x_labels[id];
  } : function (id) {
    return id;
  };

  function get_tooltip(datum) {
    return /*#__PURE__*/React__default.createElement("strong", {
      className: "px-2 py-2 bg-white text-xs",
      style: {
        zIndex: 9999,
        color: datum.color
      }
    }, tooltip_format(datum.data.id), " : ", datum.data.value);
  }

  function onBarClick(bar) {
    console.log("BAR RECEIVED ON CLICK");
    console.log(bar);

    if (graph.screen.default_action) {
      var record = graph.screen.data.get_record_by_id(bar.data.id);
      graph.screen.default_action.execute([record]);
    }
  }

  return /*#__PURE__*/React__default.createElement(ResponsiveBar, {
    data: data,
    keys: ['value'],
    indexBy: graph.groupby,
    margin: {
      top: 10,
      right: 20,
      bottom: 50,
      left: 60
    },
    colorBy: "index",
    padding: 0.3,
    colors: {
      scheme: 'nivo'
    },
    borderColor: {
      from: 'color',
      modifiers: [['darker', 1.6]]
    },
    axisTop: null,
    axisRight: null,
    tooltip: function tooltip(e) {
      return get_tooltip(e);
    },
    axisBottom: {
      tickSize: 6,
      tickPadding: 5,
      tickRotation: 0,
      legend: legend,
      legendPosition: 'middle',
      legendOffset: 32,
      field: graph.x_field,
      field_labels: graph.x_labels,
      format: format
    },
    axisLeft: {
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: y_legend,
      legendPosition: 'middle',
      legendOffset: -50
    },
    labelSkipWidth: 12,
    labelSkipHeight: 12,
    groupMode: "grouped",
    labelTextColor: {
      from: 'color',
      modifiers: [['darker', 1.6]]
    },
    animate: true,
    motionStiffness: 90,
    motionDamping: 15,
    onClick: onBarClick
  });
});

var PieGraph = observer(function PieGraph(props) {
  var graph = props.graph;
  var legend = graph.x_legend;
  var data = graph.screen.data_values;
  var label_format = graph.x_labels ? function (value) {
    return graph.x_labels[value.id];
  } : function (value) {
    return value.label;
  };
  var tooltip_format = graph.x_labels ? function (id) {
    return graph.x_labels[id];
  } : function (id) {
    return id;
  };
  console.log("Graph x labels");
  console.log(graph.x_labels);
  console.log("DATA i have");
  console.log(data);

  function get_tooltip(_ref) {
    var datum = _ref.datum;
    return /*#__PURE__*/React__default.createElement("strong", {
      className: "px-2 py-2 bg-white text-xs",
      style: {
        zIndex: 9999,
        color: datum.color
      }
    }, tooltip_format(datum.id), " : ", datum.data.value);
  }

  function onSliceClick(slice) {
    if (graph.screen.default_action) {
      var record = graph.screen.data.get_record_by_id(slice.id);
      graph.screen.default_action.execute([record]);
    }
  }

  return /*#__PURE__*/React__default.createElement(ResponsivePie, {
    data: data,
    margin: {
      top: 20,
      right: 80,
      bottom: 30,
      left: 80
    },
    isInteractive: true,
    activeInnerRadiusOffset: 6,
    activeOuterRadiusOffset: 11,
    padAngle: 0.7,
    cornerRadius: 3,
    axisBottom: {
      tickSize: 6,
      tickPadding: 5,
      tickRotation: 0,
      legend: legend,
      legendPosition: 'middle',
      legendOffset: 32,
      field: graph.x_field,
      field_labels: graph.x_labels,
      format: label_format
    },
    colors: {
      scheme: 'nivo'
    },
    borderWidth: 1,
    borderColor: {
      from: 'color',
      modifiers: [['darker', 0.2]]
    },
    arcLinkLabel: label_format,
    tooltip: function tooltip(e) {
      return get_tooltip(e);
    },
    slicesLabelsSkipAngle: 10,
    slicesLabelsTextColor: "#333333",
    onClick: onSliceClick,
    animate: true,
    motionStiffness: 90,
    motionDamping: 15,
    arcLinkLabelsSkipAngle: 10,
    arcLinkLabelsTextColor: {
      from: 'color',
      modifiers: [['darker', 1]]
    },
    arcLinkLabelsThickness: 2,
    arcLinkLabelsColor: {
      from: 'color'
    },
    arcLabelsSkipAngle: 10,
    arcLabelsTextColor: {
      from: 'color',
      modifiers: [['darker', 10]]
    }
  });
});

var GraphToolbar = observer(function GraphView(props) {
  var screen = props.screen;

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var ref = React__default.createRef();

  function toogleData() {
    setOpen(false);
    screen.switch_view();
  }

  return /*#__PURE__*/React__default.createElement("div", {
    ref: ref
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick(e) {
      setOpen(!open);
    },
    color: "transparent"
  }, /*#__PURE__*/React__default.createElement(SvgAction, {
    style: {
      width: '.8em',
      height: '.8em'
    },
    className: "fill-current  text-xl cursor-pointer w-4 h-2"
  })), /*#__PURE__*/React__default.createElement(DropDown, {
    open: open,
    ref: ref,
    modifiers: {
      'left': -200,
      'width': 200,
      'height': 200
    }
  }, /*#__PURE__*/React__default.createElement(Paper, null, /*#__PURE__*/React__default.createElement("div", {
    onClick: toogleData,
    className: "w-full border border-gray-300 px-2 py-2 font-sm cursor-pointer"
  }, "Show Data"))));
});
var GraphView = observer(function GraphView(props) {
  var screen = props.screen,
      container = props.container;
  var graph = screen.active_graph;
  var show_data = screen.show_data,
      data_screen = screen.data_screen;

  function getGraph() {
    if (graph.type === 'bar') {
      return /*#__PURE__*/React__default.createElement(BarGraph, {
        graph: graph
      });
    } else if (graph.type === 'pie') {
      return /*#__PURE__*/React__default.createElement(PieGraph, {
        graph: graph,
        height: props.height
      });
    } else if (graph.type === 'line') {
      return /*#__PURE__*/React__default.createElement(LineGraph, {
        graph: graph,
        height: props.height
      });
    }
  }

  return /*#__PURE__*/React__default.createElement(Fragment$1, null, /*#__PURE__*/React__default.createElement(ViewHeader, {
    screen: screen,
    isSpreadsheet: false,
    hide_toolbar: props.hide_toolbar,
    extra_action_menu: /*#__PURE__*/React__default.createElement(GraphToolbar, {
      screen: screen
    }),
    container_classname: props.height ? false : "rounded bg-white border border-gray-300"
  }), /*#__PURE__*/React__default.createElement(Container, {
    type: container ? container : 'paper',
    style: {
      height: props.height ? props.height : window.innerHeight * 0.8
    },
    className: "px-2 py-2 pb-4 border overflow-hidden"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "relative flex flex-col",
    style: {
      height: '100%',
      width: '100%'
    }
  }, show_data ? /*#__PURE__*/React__default.createElement(Fragment$1, null, /*#__PURE__*/React__default.createElement(View_, {
    screen: data_screen,
    height: props.height ? props.height : window.innerHeight * 0.8,
    headless: true
  })) : /*#__PURE__*/React__default.createElement(Fragment$1, null, getGraph()))));
});

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (canUseDOM) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

var ArrowNavigation = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(ArrowNavigation, _React$PureComponent);

  function ArrowNavigation() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      scrollToColumn: 0,
      scrollToRow: 0,
      instanceProps: {
        prevScrollToColumn: 0,
        prevScrollToRow: 0
      }
    };
    _this._columnStartIndex = 0;
    _this._columnStopIndex = 0;
    _this._rowStartIndex = 0;
    _this._rowStopIndex = 0;

    _this._onSectionRendered = function (_ref) {
      var columnStartIndex = _ref.columnStartIndex,
          columnStopIndex = _ref.columnStopIndex,
          rowStartIndex = _ref.rowStartIndex,
          rowStopIndex = _ref.rowStopIndex;
      _this._columnStartIndex = columnStartIndex;
      _this._columnStopIndex = columnStopIndex;
      _this._rowStartIndex = rowStartIndex;
      _this._rowStopIndex = rowStopIndex;
    };

    return _this;
  }

  ArrowNavigation.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.isControlled) {
      return {};
    }

    if (nextProps.scrollToColumn !== prevState.instanceProps.prevScrollToColumn || nextProps.scrollToRow !== prevState.instanceProps.prevScrollToRow) {
      return _extends({}, prevState, {
        scrollToColumn: nextProps.scrollToColumn,
        scrollToRow: nextProps.scrollToRow,
        instanceProps: {
          prevScrollToColumn: nextProps.scrollToColumn,
          prevScrollToRow: nextProps.scrollToRow
        }
      });
    }

    return {};
  };

  var _proto = ArrowNavigation.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        onKeyDown = _this$props.onKeyDown;

    var _this$_getScrollState = this._getScrollState(),
        scrollToColumn = _this$_getScrollState.scrollToColumn,
        scrollToRow = _this$_getScrollState.scrollToRow;

    return /*#__PURE__*/createElement("div", {
      id: "arrow_navigator",
      tabIndex: "-1",
      className: className,
      onKeyDown: onKeyDown
    }, children({
      onSectionRendered: this._onSectionRendered,
      scrollToColumn: scrollToColumn,
      scrollToRow: scrollToRow
    }));
  };

  _proto._getScrollState = function _getScrollState() {
    return this.props;
  };

  return ArrowNavigation;
}(PureComponent);

ArrowNavigation.defaultProps = {
  disabled: false,
  isControlled: false,
  mode: 'edges',
  scrollToColumn: 0,
  scrollToRow: 0
};
polyfill(ArrowNavigation);

var HtmlView = observer(function HtmlView(props) {
  var screen = props.screen;
  var content = screen ? screen.content && screen.content : props.htmlValue;
  var loading = screen.processing;
  var container_ref = React__default.createRef();
  return /*#__PURE__*/React__default.createElement("div", {
    ref: container_ref
  }, /*#__PURE__*/React__default.createElement(Paper, {
    shadowClass: "shadow-none",
    className: props.fromCell ? "" : "py-2 px-2 rounded",
    style: props.containerStyle
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: content
    }
  }), /*#__PURE__*/React__default.createElement(LoadingIndicator, {
    ref: container_ref,
    show: loading,
    fullscreen: true
  })));
});

var field_align = {
  'button': 'center'
};
var get_field_align = function get_field_align(type) {
  if (field_align[type]) {
    return field_align[type];
  }

  return 'left';
};

var RENDER_FIELDS = ['binary', 'formula'];
var Cell = observer(function Cell(props) {
  var field = props.field,
      rowIndex = props.rowIndex,
      columnIndex = props.columnIndex,
      focusCell = props.focusCell,
      activeCell = props.activeCell,
      cell_key = props.cell_key,
      record = props.record,
      focusInGrid = props.focusInGrid,
      style = props.style,
      screen = props.screen,
      isSpreadsheet = props.isSpreadsheet;
  var isSelected = screen.is_selected(record.id);
  var state_attrs = field.get_state_attrs(record);
  var readonly = state_attrs ? state_attrs.readonly : field.readonly;
  var error = record._errors[field.name];
  var field_style = field.get_style(record);

  var cell_style = _extends({}, field_style, style);

  var containerRefModal = React__default.useRef(null);

  var _React$useState = React__default.useState(null),
      posX = _React$useState[0],
      setPosX = _React$useState[1];

  var _React$useState2 = React__default.useState(null),
      posY = _React$useState2[0],
      setPosY = _React$useState2[1];

  var _React$useState3 = React__default.useState(false),
      showPreviewModal = _React$useState3[0],
      setShowPreviewModal = _React$useState3[1];

  var _React$useState4 = React__default.useState(false),
      showEditModal = _React$useState4[0],
      setShowEditModal = _React$useState4[1];

  var _React$useState5 = React__default.useState(false);

  var _React$useState6 = React__default.useState(""),
      modalValue = _React$useState6[0],
      setModalValue = _React$useState6[1];

  var cellRef = React__default.useRef(null);
  React__default.useEffect(function () {
    if (isSpreadsheet) {
      if (field.type === "text" || field.type === "html") {
        setModalValue(field.get_value(record));
      }
    }
  }, [field, isSpreadsheet, record]);

  var getRowClass = function getRowClass(rowIndex, key) {
    var rowClass = isSpreadsheet ? 'TableEvenRow editableGrid' : rowIndex % 2 === 0 ? "TableEvenRow" : "TableOddRow";

    if (readonly && isSpreadsheet) {
      rowClass = clsx(rowClass, "border border-gray-300 bg-gray-200");
    }

    if (isSelected) {
      rowClass = clsx(rowClass, "bg-light-selected rowHiglighted");
    }

    if (error) {
      rowClass = clsx(rowClass, "bg-red-200");
    }

    if (activeCell) {
      rowClass = clsx(rowClass, 'focusedCell');
    }

    rowClass = clsx(rowClass, 'text-'.concat(get_field_align(field.type)));
    return rowClass;
  };

  var rowClass = getRowClass(rowIndex);

  var getValue = function getValue() {
    if (field.type === 'button') {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "leading-none pt-2 text-center"
      }, /*#__PURE__*/React__default.createElement(FormButton, {
        state_attrs: state_attrs,
        variant: "list",
        color: field.button_variant,
        onClick: function onClick(e) {
          e.stopPropagation();
          field.action.execute([record], false, false, false, false, {
            parent_ref: cellRef,
            posx: e.clientX,
            posy: e.clientY
          });
        }
      }, field.description));
    } else if (RENDER_FIELDS.includes(field.type)) {
      return /*#__PURE__*/React__default.createElement(Field, {
        key: cell_key,
        field: field,
        record: record,
        noWrap: true,
        autoFocus: false,
        handleInnerValue: false,
        focusInGrid: focusInGrid
      });
    } else if (field.type === "html" || field.type === "text") {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "flex justify-between align-middle"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "w-40"
      }, field.type === "html" ? /*#__PURE__*/React__default.createElement(HtmlView, {
        fromCell: true,
        htmlValue: field.get_string_value(record)
      }) : field.get_string_value(record)), isSpreadsheet && /*#__PURE__*/React__default.createElement(IconButton, {
        onClick: function onClick(e) {
          return onClickEditButton(e);
        },
        className: "justify-end px-2 my-1 h-8 w-6",
        color: "transparent"
      }, /*#__PURE__*/React__default.createElement(SvgEditPencil, {
        className: "fill-current text-primary h-3 w-3 z-40"
      })));
    } else {
      return field.get_string_value(record);
    }
  };

  var getField = function getField() {
    if (field.type == 'button') {
      return getValue();
    }

    if (field.type === "html" || field.type === "text") {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "flex justify-between align-middle"
      }, field.type === "html" ? /*#__PURE__*/React__default.createElement("div", {
        className: "w-40"
      }, /*#__PURE__*/React__default.createElement(HtmlView, {
        fromCell: true,
        htmlValue: field.get_string_value(record)
      })) : /*#__PURE__*/React__default.createElement(Field, {
        key: cell_key,
        field: field,
        record: record,
        noWrap: true,
        autoFocus: true,
        handleInnerValue: false,
        focusInGrid: focusInGrid
      }), /*#__PURE__*/React__default.createElement(IconButton, {
        onClick: function onClick(e) {
          return onClickEditButton(e);
        },
        className: "justify-end px-2 my-1 h-8 w-6",
        color: "transparent"
      }, /*#__PURE__*/React__default.createElement(SvgEditPencil, {
        className: "fill-current text-primary h-3 w-3 z-40"
      })));
    } else {
      return /*#__PURE__*/React__default.createElement(Field, {
        key: cell_key,
        field: field,
        record: record,
        noWrap: true,
        autoFocus: true,
        handleInnerValue: false,
        focusInGrid: focusInGrid
      });
    }
  };

  function onClickEditButton(e) {
    e.stopPropagation();
    setShowPreviewModal(false);
    setShowEditModal(true);
  }

  function onClickSaveButton(e) {
    e.stopPropagation();
    setShowPreviewModal(false);
    setShowEditModal(false);
    record.setFieldInEdition(field.name);
    return field.set_value(modalValue, record);
  }

  function closeEditModal() {
    setShowEditModal(false);
    setModalValue(field.get_value(record));
  }

  var previewModal = function previewModal() {
    return /*#__PURE__*/React__default.createElement(Modal, {
      style: {
        left: posX,
        top: posY,
        width: '400px',
        height: '206px'
      },
      modalType: "preview",
      open: showPreviewModal,
      containerRefModal: containerRefModal,
      showModalPreview: setShowPreviewModal,
      paper: true,
      target: "portal_preview"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "w-full h-40 overflow-x-hidden overflow-y-scroll"
    }, /*#__PURE__*/React__default.createElement(Field, {
      key: cell_key,
      field: field,
      record: record,
      noWrap: true,
      autoFocus: true,
      handleInnerValue: false,
      focusInGrid: focusInGrid,
      previewEditor: true
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "flex justify-center"
    }, isSpreadsheet && /*#__PURE__*/React__default.createElement(FormButton, {
      state_attrs: state_attrs,
      variant: "list",
      color: "transparent",
      className: " mr-1 my-2",
      onClick: function onClick(e) {
        return onClickEditButton(e);
      }
    }, "Editar"), /*#__PURE__*/React__default.createElement(FormButton, {
      state_attrs: {},
      variant: "list",
      color: "transparent",
      className: " ml-1 my-2",
      onClick: function onClick() {
        return setShowPreviewModal(false);
      }
    }, "Cerrar")));
  };

  var editModal = function editModal() {
    if (field.type === "text") {
      return /*#__PURE__*/React__default.createElement(Modal, {
        style: {
          height: '438px',
          width: '532px'
        },
        modalType: "edition",
        open: showEditModal,
        containerRefModal: containerRefModal,
        showModalEdit: setShowEditModal,
        paper: true,
        saveRecord: props.saveRecord
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          height: '400px',
          paddingLeft: '14px',
          paddingRight: '14px',
          paddingTop: '14px',
          paddingBottom: '8px'
        },
        className: "w-full"
      }, /*#__PURE__*/React__default.createElement(Field, {
        key: cell_key,
        field: field,
        record: record,
        noWrap: true,
        isModal: showEditModal,
        autoFocus: true,
        handleInnerValue: false,
        modalClass: " h-full resize-none",
        focusInGrid: focusInGrid,
        setModalValue: setModalValue,
        modalValue: modalValue
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "flex justify-center"
      }, /*#__PURE__*/React__default.createElement(FormButton, {
        state_attrs: state_attrs,
        variant: "list",
        color: "transparent",
        className: " mr-1",
        onClick: function onClick(e) {
          return onClickSaveButton(e);
        }
      }, "Guardar"), /*#__PURE__*/React__default.createElement(FormButton, {
        state_attrs: {},
        variant: "list",
        color: "transparent",
        className: " ml-1",
        onClick: function onClick() {
          return closeEditModal();
        }
      }, "Cerrar")));
    } else {
      return /*#__PURE__*/React__default.createElement(Modal, {
        style: {
          height: '438px',
          width: '532px'
        },
        modalType: "edition",
        open: showEditModal,
        containerRefModal: containerRefModal,
        showModalEdit: setShowEditModal,
        paper: true,
        saveRecord: props.saveRecord
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          height: '400px'
        },
        className: "w-full overflow-x-hidden overflow-y-scroll"
      }, /*#__PURE__*/React__default.createElement(Field, {
        key: cell_key,
        field: field,
        record: record,
        noWrap: true,
        isModal: showEditModal,
        autoFocus: true,
        handleInnerValue: false,
        focusInGrid: focusInGrid,
        setModalValue: setModalValue,
        modalValue: modalValue
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "flex justify-center"
      }, /*#__PURE__*/React__default.createElement(FormButton, {
        state_attrs: state_attrs,
        variant: "list",
        color: "transparent",
        className: " mr-1 my-2",
        onClick: function onClick(e) {
          return onClickSaveButton(e);
        }
      }, "Guardar"), /*#__PURE__*/React__default.createElement(FormButton, {
        state_attrs: {},
        variant: "list",
        color: "transparent",
        className: " ml-1 my-2",
        onClick: function onClick() {
          return closeEditModal();
        }
      }, "Cerrar")));
    }
  };

  function onClickCell(e) {
    if (["html", "text"].includes(field.type)) {
      if (field.type === "text") {
        setShowEditModal(true);
      } else {
        var gridWidth = parseInt(document.getElementById("body_grid").style.width);

        if (e.clientX > gridWidth) {
          setPosX(!(e.clientX - gridWidth > 60) ? e.clientX - 200 : gridWidth - 20);
          setPosY(e.clientY);
        } else if (gridWidth - e.clientX > 15 && gridWidth - e.clientX < 180) {
          setPosX(gridWidth - e.clientX > 15 ? e.clientX - 200 : gridWidth - 20);
          setPosY(e.clientY);
        } else {
          setPosX(e.clientX);
          setPosY(e.clientY);
        }

        setShowPreviewModal(true);
      }
    }

    if (isSpreadsheet) {
      focusCell({
        key: cell_key,
        columnIndex: columnIndex,
        rowIndex: rowIndex,
        event: e
      });
    } else {
      var toogle = true;
      var range = false;

      if (e.nativeEvent.shiftKey || e.nativeEvent.metaKey || e.nativeEvent.ctrlKey) {
        toogle = false;

        if (e.nativeEvent.shiftKey) {
          range = true;
        }
      }

      screen.changeSelection({
        index: rowIndex,
        toogle: toogle,
        range: range
      });
    }
  }

  function onDoubleClick(e) {
    e.preventDefault();
    e.stopPropagation();

    if (!isSpreadsheet) {
      if (screen.default_action) {
        screen.default_action.execute([record]);
      }
    }
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: rowClass,
    tabIndex: "-1",
    ref: cellRef,
    onClick: onClickCell,
    onDoubleClick: onDoubleClick,
    style: cell_style
  }, !activeCell || readonly ? getValue() : getField()), showPreviewModal && previewModal(), showEditModal && editModal());
});

var initialState$1 = {
  scrollToRow: -1,
  scrollToColumn: -1,
  activeCell: ''
};
var SpreadsheetBody = observer(function SpreadsheetBody(props) {
  var createRow = function createRow(rowIndex, columnIndex) {
    try {
      if (!rowIndex || rowIndex === props.rowCount) {
        rowIndex = props.rowCount + 1;
        columnIndex = 1;
      }

      var record = screen.data.addRecord({
        values: {},
        index: rowIndex
      });
      screen.set_active_record(record);
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var screen = props.screen;
  var fields = screen.visible_fields;
  var data = screen.data.records;
  var isSpreadsheet = screen.type === 'spreadsheet';

  var _useReducer = useReducer(reducer, initialState$1),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var containerRef = useRef(null);

  var _useState = useState(false),
      focusInGrid = _useState[0],
      setFocusIn = _useState[1];

  var rowCount = data.length;
  useClickOutside(containerRef, focusOut, focusInGrid);

  function reducer(state, action) {
    var new_state = _extends({}, state);

    switch (action.type) {
      case 'RESET':
        return initialState$1;

      case 'SET_ACTIVE_CELL':
        new_state.scrollToRow = action.payload.scrollToRow;
        new_state.scrollToColumn = action.payload.scrollToColumn;
        new_state.activeCell = action.payload.activeCell;
        return _extends({}, state, new_state);
    }
  }

  var scrollToRow = state.scrollToRow,
      scrollToColumn = state.scrollToColumn,
      activeCell = state.activeCell;
  useEffect(function () {
    var key = "";
    focusCell({
      key: key,
      rowIndex: -1,
      columnIndex: -1
    });
  }, [props.orderedColumn]);

  function save_active_record() {
    var saved = true;

    if (screen.active_record) {
      if (Object.keys(screen.active_record._changed).length) {
        if (!screen.default_save_action) {
          screen.notifications.addSnack({
            message: "No default save action defined",
            level: 'error'
          });
          return false;
        } else if (!screen.default_save_action.execute([data[scrollToRow]])) {
          saved = false;
        }
      }
    }

    return saved;
  }

  function focusCell(_ref) {
    var key = _ref.key,
        columnIndex = _ref.columnIndex,
        rowIndex = _ref.rowIndex;
    var fr = scrollToRow;

    if (fr !== rowIndex) {
      if (screen.auto_save) {
        if (!save_active_record()) {
          return;
        }
      }

      screen.set_active_record(data[rowIndex]);
    }

    dispatch({
      type: 'SET_ACTIVE_CELL',
      payload: {
        scrollToRow: rowIndex,
        scrollToColumn: columnIndex,
        activeCell: key
      }
    });
  }

  function renderBodyCell(_ref2) {
    var columnIndex = _ref2.columnIndex,
        key = _ref2.key,
        rowIndex = _ref2.rowIndex,
        style = _ref2.style;

    if (columnIndex < 1) {
      return;
    }

    var column = fields[columnIndex];
    var ac = activeCell === key;
    var record;
    record = data[rowIndex];
    return /*#__PURE__*/React__default.createElement(Cell, {
      cell_key: key,
      key: key,
      field: column,
      rowIndex: rowIndex,
      columnIndex: columnIndex,
      activeCell: ac,
      style: style,
      focusCell: focusCell,
      record: record,
      getLazyValues: props.getLazyValues,
      focusInGrid: focusInGrid,
      isSpreadsheet: isSpreadsheet,
      screen: screen,
      saveRecord: save_active_record
    });
  }

  function createKey(scrollToRow, scrollToColumn) {
    return scrollToRow.toString().concat('-').concat(scrollToColumn.toString());
  }

  function onKeyDown(event) {
    var rowCount = props.rowCount,
        columnCount = props.columnCount;

    if (!isSpreadsheet) {
      return;
    }

    var scrollToColumnPrevious = state.scrollToColumn,
        scrollToRowPrevious = state.scrollToRow;
    var scrollToColumn = state.scrollToColumn,
        scrollToRow = state.scrollToRow;

    switch (event.key) {
      case 'ArrowDown':
        if (event.target.readOnly) {
          scrollToRow = Math.min(scrollToRow + 1, rowCount - 1);
        } else if (event.target.dataset.ismodal === "true") {
          return;
        } else if (event.target.nodeName === 'INPUT' && event.target.id.includes("react-select")) {
          scrollToRow = Math.min(scrollToRow + 1, rowCount - 1);
        } else if (event.target.nodeName === 'INPUT' && event.target.selectionStart !== event.target.value.length) {
          scrollToRow = Math.min(scrollToRow + 1, rowCount - 1);
        } else {
          scrollToRow = Math.min(scrollToRow + 1, rowCount - 1);
        }

        break;

      case 'Enter':
        if (event.shiftKey) {
          if (screen.auto_save) {
            if (!save_active_record()) {
              return;
            }
          }

          scrollToRow = scrollToRow + 1;
          dispatch({
            type: 'SET_ACTIVE_CELL',
            payload: {
              scrollToRow: scrollToRow,
              scrollToColumn: scrollToColumn,
              activeCell: createKey(scrollToRow, scrollToColumn)
            }
          });
          return createRow(scrollToRow, scrollToColumn);
        } else if (event.target.dataset.ismodal === "true") {
          return;
        } else {
          scrollToRow = Math.min(scrollToRow + 1, rowCount - 1);
        }

        break;

      case 'ArrowLeft':
        if (event.target.readOnly) {
          scrollToColumn = Math.max(scrollToColumn - 1, 1);
        } else if (event.target.dataset.ismodal === "true") {
          return;
        } else if (event.target.type === "number") {
          event.target.type = "text";
          return;
        }

        if (event.target.nodeName === 'INPUT' && event.target.selectionStart) {
          return;
        } else {
          scrollToColumn = Math.max(scrollToColumn - 1, 1);
        }

        break;

      case 'ArrowRight':
        if (event.target.readOnly) {
          scrollToColumn = Math.min(scrollToColumn + 1, columnCount - 1);
        } else if (event.target.dataset.ismodal === "true") {
          return;
        } else if (event.target.type === "number") {
          event.target.type = "text";
          event.target.selectionStart = event.target.value.length;
          return;
        } else if (event.target.nodeName === 'INPUT' && event.target.selectionStart !== event.target.value.length) {
          return;
        } else {
          scrollToColumn = Math.min(scrollToColumn + 1, columnCount - 1);
        }

        break;

      case 'Tab':
        event.preventDefault();

        if (event.shiftKey) {
          scrollToColumn = Math.max(scrollToColumn - 1, 1);
        } else {
          scrollToColumn = Math.min(scrollToColumn + 1, columnCount - 1);
        }

        break;

      case 'ArrowUp':
        if (event.target.readOnly) {
          scrollToRow = Math.max(scrollToRow - 1, 0);
        } else if (event.target.dataset.ismodal === "true") {
          return;
        } else if (event.target.nodeName === 'INPUT' && event.target.selectionStart) {
          scrollToRow = Math.max(scrollToRow - 1, 0);
        } else {
          scrollToRow = Math.max(scrollToRow - 1, 0);
        }

        break;
    }

    if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
      event.preventDefault();
      var key = createKey(scrollToRow, scrollToColumn);
      focusCell({
        key: key,
        columnIndex: scrollToColumn,
        rowIndex: scrollToRow,
        event: event
      });
    }
  }

  function focusOut(target) {
    if (!target.id.includes('react-select')) {
      setFocusIn(false);
    }
  }

  return /*#__PURE__*/React__default.createElement("div", {
    ref: containerRef,
    onClick: function onClick() {
      setFocusIn(true);
    },
    onPaste: function onPaste(e) {
      console.log("RUNNING ON PASTE");
      console.log(e.clipboardData);

      if (activeCell) {
        e.preventDefault();
        return screen.pasteValuesFromClipboard({
          columnIndex: scrollToColumn,
          rowIndex: scrollToRow,
          event: e
        });
      }
    }
  }, /*#__PURE__*/React__default.createElement(ArrowNavigation, {
    columnCount: props.columnCount,
    isControlled: true,
    disabled: !isSpreadsheet,
    onKeyDown: onKeyDown,
    rowCount: rowCount,
    scrollToColumn: scrollToColumn,
    scrollToRow: scrollToRow
  }, function (_ref3) {
    var onSectionRendered = _ref3.onSectionRendered,
        scrollToColumn = _ref3.scrollToColumn,
        scrollToRow = _ref3.scrollToRow;
    return /*#__PURE__*/React__default.createElement(Grid, {
      id: "body_grid",
      className: "BodyGrid",
      tabIndex: -1,
      columnWidth: function columnWidth(_ref4) {
        var index = _ref4.index;
        return props.columnWidth({
          index: index,
          width: props.width
        });
      },
      columnCount: props.columnCount,
      height: props.height,
      onScroll: props.onScroll,
      overscanColumnCount: props.overscanColumnCount,
      overscanRowCount: props.overscanRowCount,
      cellRenderer: renderBodyCell,
      rowHeight: props.rowHeight,
      rowCount: props.rowCount,
      ref: props.gridRef,
      width: props.width,
      onSectionRendered: onSectionRendered,
      scrollToColumn: scrollToColumn,
      scrollToRow: scrollToRow,
      getLazyValues: props.getLazyValues
    });
  }));
});

var LeftSideCell = observer(function LeftSideCell(props) {
  var rowIndex = props.rowIndex,
      changeSelection = props.changeSelection,
      screen = props.screen,
      className = props.className,
      isSpreadsheet = props.isSpreadsheet;
  var isSelected = screen.is_selected(screen.get_record_by_index(rowIndex).id);
  var cls = isSelected ? clsx(className, "bg-light-selected") : className;

  if (screen.readonly && isSpreadsheet) {
    cls = clsx(cls, 'border border-gray-300 bg-gray-200');
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: cls
  }, /*#__PURE__*/React__default.createElement("input", {
    checked: isSelected,
    type: "checkbox",
    size: "small",
    color: "primary",
    style: {
      padding: 0
    },
    onChange: function onChange(e) {
      changeSelection(e, rowIndex);
    }
  }));
});

var _path$i;

function _extends$j() {
  _extends$j = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$j.apply(this, arguments);
}

function SvgChevronUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$j({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$i || (_path$i = /*#__PURE__*/createElement("path", {
    d: "M10.707 7.05L10 6.343 4.343 12l1.414 1.414L10 9.172l4.243 4.242L15.657 12z"
  })));
}

var SpreadsheetHeader$1 = observer(function SpreadsheetHeader(props) {
  var screen = props.screen;
  var orderedColumn = screen.ordered_column;
  var columnCount = screen.visible_fields.length;
  var width = props.width;

  var onColumnClick = function onColumnClick(e, column_name) {
    screen.set_order(column_name);
  };

  function renderHeaderCell(_ref) {
    var columnIndex = _ref.columnIndex,
        key = _ref.key,
        style = _ref.style;

    if (columnIndex < 1) {
      return;
    }

    var column = screen.visible_fields[columnIndex];
    var sortable = column.sortable;
    var containerClass = "headerCell";
    var contentClassName = 'headerCellContent ' + 'justify-'.concat(get_field_align(column.type));
    return /*#__PURE__*/React__default.createElement("div", {
      className: containerClass,
      key: key,
      style: style
    }, /*#__PURE__*/React__default.createElement("div", {
      className: contentClassName,
      style: {
        cursor: sortable ? "pointer" : ""
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      onClick: sortable ? function (e) {
        onColumnClick(e, column.name);
      } : function () {},
      style: {
        textOverflow: 'ellipsis',
        overflow: 'hidden'
      }
    }, column.tooltip ? /*#__PURE__*/React__default.createElement(Tooltip, {
      content: column.tooltip,
      type: column.tooltip_type
    }, column.description) : column.description), sortable && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, orderedColumn.name === column.name && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, orderedColumn.order === 'DESC' ? /*#__PURE__*/React__default.createElement(SvgChevronDown, {
      style: {
        width: '1em',
        height: '1em'
      },
      className: "fill-current text-xl cursor-pointer w-4 h-4 mr-1 md:mr-4 ml-2"
    }) : /*#__PURE__*/React__default.createElement(SvgChevronUp, {
      style: {
        width: '1em',
        height: '1em'
      },
      className: "fill-current text-xl cursor-pointer w-4 h-4 mr-1 md:mr-4 ml-2"
    }))), /*#__PURE__*/React__default.createElement(Draggable, {
      axis: "x",
      defaultClassName: "DragHandle",
      defaultClassNameDragging: "DragHandleActive",
      onStop: function onStop(event, data) {
        return props.onResizeStop({
          columnIndex: columnIndex
        });
      },
      onDrag: function onDrag(event, data) {
        return props.resizeColumn({
          deltaX: data.x,
          columnIndex: columnIndex,
          lastX: data.lastX,
          width: width
        });
      },
      position: {
        x: 0,
        y: 0
      },
      zIndex: 999
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "DragHandleIcon"
    }, "||"))));
  }

  return /*#__PURE__*/React__default.createElement(Grid, {
    className: "HeaderGrid",
    columnWidth: function columnWidth(_ref2) {
      var index = _ref2.index;
      return props.columnWidth({
        index: index,
        width: width
      });
    },
    columnCount: columnCount,
    height: props.rowHeight,
    overscanColumnCount: 0,
    cellRenderer: renderHeaderCell,
    rowHeight: props.rowHeight,
    rowCount: 1,
    scrollLeft: props.scrollLeft,
    ref: props.gridHeaderRef,
    width: process.env.NODE_ENV === 'test' ? 900 : props.width
  });
});

var HeaderSelector = observer(function HeaderSelector(props) {
  var screen = props.screen;
  var checked = screen.all_records_selected;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "leftCheckbox"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "checkbox",
    checked: checked,
    style: {
      padding: 0
    },
    onChange: function onChange(e) {
      screen.toogleSelectAll(e.target.checked);
    }
  }));
});

var Spreadsheet = observer(function Spreadsheet(props) {
  var screen = props.screen;

  var _useState = useState(-1);

  var _useState2 = useState(-1);

  var _useState3 = useState({}),
      columnWidthMap = _useState3[0],
      setColumnWidthMap = _useState3[1];

  var _useState4 = useState({}),
      selectedIndex = _useState4[0];

  var _useState5 = useState({});

  var gridHeader = useRef(null);
  var gridBody = useRef(null);
  var navigator = useRef(null);
  var height = props.height ? props.height : window.innerHeight * 75 / 100;
  var overscanColumnCount = 0;
  var overscanRowCount = 5;
  var rowHeight = 40;
  var columnCount = screen.visible_fields.length;
  var rowCount = screen.data.records.length;
  var isSpreadsheet = screen.type === 'spreadsheet';
  var container_ref = React__default.createRef();
  var selected_records = screen.selected_records;
  useEffect(function () {
    var columns = [].concat(screen.visible_fields);

    var map = _extends({}, columnWidthMap);

    map.sizes = {};
    columns.forEach(function (column, index) {
      var column_width = column.width;

      if (column_width && column_width.includes('%')) {
        column_width = function column_width(width) {
          return (width - 20) * parseInt(column.width.replace('%', '')) / 100;
        };
      } else {
        column_width = parseInt(column_width) || 200;
      }

      map.sizes[index] = column_width;
    });
    setColumnWidthMap(map);
  }, [screen.visible_fields]);

  function onResizeStop(_ref) {
    var map = columnWidthMap;
    map.column_on_drag = false;
    setColumnWidthMap(map);
  }

  function getColumnWidth(_ref2) {
    var index = _ref2.index,
        width = _ref2.width;

    switch (index) {
      case 0:
        return 20;

      default:
        {
          var size = columnWidthMap.sizes[index];

          if (!size) {
            return 200;
          } else if (typeof size === 'function') {
            return size(width);
          } else {
            return columnWidthMap.sizes[index];
          }
        }
    }
  }

  var changeSelection = function changeSelection(e, rowIndex) {
    screen.changeSelection({
      index: rowIndex
    });
  };

  function resizeColumn(_ref3) {
    var deltaX = _ref3.deltaX,
        columnIndex = _ref3.columnIndex,
        lastX = _ref3.lastX,
        width = _ref3.width;

    var map = _extends({}, columnWidthMap);

    var current_width = map.sizes[columnIndex];

    if (typeof current_width == 'function') {
      current_width = getColumnWidth({
        index: columnIndex,
        width: width
      });
    }

    var new_width = Math.max(50, current_width + (deltaX - lastX));
    map.sizes[columnIndex] = new_width;
    map.column_on_drag = columnIndex;
    setColumnWidthMap(map);
    gridHeader.current.recomputeGridSize({
      columnIndex: 0,
      rowIndex: 0
    });
    gridBody.current.recomputeGridSize({
      columnIndex: 0,
      rowIndex: 0
    });
  }

  function renderLeftHeaderCell(_ref4) {
    var key = _ref4.key,
        style = _ref4.style;
    return /*#__PURE__*/React__default.createElement("div", {
      key: key,
      style: style
    }, /*#__PURE__*/React__default.createElement(HeaderSelector, {
      screen: screen
    }));
  }

  function renderLeftSideCell(_ref5) {
    var key = _ref5.key,
        rowIndex = _ref5.rowIndex,
        style = _ref5.style;
    var rowClass = rowIndex % 2 === 0 ? "TableEvenRow" : "TableOddRow";
    rowClass = clsx("leftCheckbox", rowClass);
    return /*#__PURE__*/React__default.createElement("div", {
      key: key,
      style: style
    }, /*#__PURE__*/React__default.createElement(LeftSideCell, {
      className: rowClass,
      isSpreadsheet: screen.type == 'spreadsheet',
      screen: screen,
      rowIndex: rowIndex,
      changeSelection: changeSelection
    }));
  }

  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(LoadingIndicator, {
    ref: container_ref,
    show: screen.data.loading
  }), !props.headless && /*#__PURE__*/React__default.createElement(ViewHeader, _extends({
    screen: screen,
    hide_toolbar: props.hide_toolbar,
    isSpreadsheet: isSpreadsheet,
    container_classname: props.height ? false : "rounded bg-white border border-gray-300",
    rowCount: rowCount
  }, props.header_props)), /*#__PURE__*/React__default.createElement(ScrollSync, null, function (_ref6) {
    var onScroll = _ref6.onScroll,
        scrollLeft = _ref6.scrollLeft,
        scrollTop = _ref6.scrollTop;
    return /*#__PURE__*/React__default.createElement(Container, {
      type: props.container || 'paper',
      className: "px-2 border overflow-hidden rounded"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "GridRow"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "LeftSideGridContainer",
      style: {
        position: 'absolute',
        left: 0,
        top: 0
      }
    }, /*#__PURE__*/React__default.createElement(Grid, {
      cellRenderer: renderLeftHeaderCell,
      className: "HeaderGrid",
      width: 20,
      height: rowHeight,
      rowHeight: rowHeight,
      columnWidth: getColumnWidth,
      rowCount: 1,
      columnCount: 1
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "LeftSideGridContainer",
      style: {
        position: 'absolute',
        left: 0,
        top: rowHeight
      }
    }, /*#__PURE__*/React__default.createElement(Grid, {
      overscanColumnCount: overscanColumnCount,
      overscanRowCount: overscanRowCount,
      cellRenderer: renderLeftSideCell,
      columnWidth: getColumnWidth,
      columnCount: 1,
      className: "LeftSideGrid",
      height: height - scrollbarSize(),
      rowHeight: rowHeight,
      rowCount: rowCount,
      scrollTop: scrollTop,
      width: 20
    })), /*#__PURE__*/React__default.createElement("div", {
      ref: container_ref,
      className: "GridColumn"
    }, /*#__PURE__*/React__default.createElement(AutoSizer, {
      disableHeight: true
    }, function (_ref7) {
      var width = _ref7.width;
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          height: rowHeight,
          width: width - scrollbarSize()
        }
      }, /*#__PURE__*/React__default.createElement(SpreadsheetHeader$1, {
        screen: screen,
        scrollLeft: scrollLeft,
        rowHeight: rowHeight,
        gridHeaderRef: gridHeader,
        width: width,
        columnWidthMap: columnWidthMap,
        columnWidth: getColumnWidth,
        onResizeStop: onResizeStop,
        resizeColumn: resizeColumn
      })), /*#__PURE__*/React__default.createElement("div", {
        style: {
          color: 'black',
          width: width
        }
      }, /*#__PURE__*/React__default.createElement(SpreadsheetBody, {
        className: "BodyGrid",
        screen: screen,
        columnWidth: getColumnWidth,
        columnCount: columnCount,
        height: height,
        onScroll: onScroll,
        overscanColumnCount: overscanColumnCount,
        selectedIndex: selectedIndex,
        overscanRowCount: overscanRowCount,
        rowHeight: rowHeight,
        rowCount: rowCount,
        gridRef: gridBody,
        width: width,
        disableAutoSave: props.disableAutoSave,
        getDefaultValues: props.getDefaultValues,
        onDataChange: props.onDataChange,
        prepareValues: props.prepareValues,
        selected_records: selected_records
      })));
    }))));
  }));
});

var ModalView = observer(function ModalView(props) {
  var screen = props.screen;
  var modal_style = screen.style_modifiers.styles.modal || {};

  var style = _extends({
    height: 'calc(100% - 101px)',
    backgroundColor: 'transparent',
    boxShadow: 'none'
  }, modal_style);

  var classname = screen.style_modifiers.classnames.modal || "";
  return /*#__PURE__*/React__default.createElement(Modal$1, {
    open: props.open,
    className: "sm:w-8/12 z-50 overflow-scroll ".concat(classname),
    paper: false,
    onRequestClose: function onRequestClose() {
      props.close(false);
    },
    style: style
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "w-full bg-white px-2 py-2"
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: function onClick(e) {
      screen.group.removeScreen(screen.id);
    },
    color: "warning"
  }, /*#__PURE__*/React__default.createElement(SvgClose, {
    style: {
      width: '.8em',
      height: '.8em'
    },
    className: "fill-current  text-xl cursor-pointer w-4 h-2"
  }))), /*#__PURE__*/React__default.createElement(View_, {
    screen: screen,
    height: modal_style.height ? modal_style.height * 60 / 100 : false
  })));
});

var field_renderers = ['binary', 'formula'];
var FieldValue = observer(function FieldValue(props) {
  var field = props.field,
      record = props.record;
  var ftype = field.type;

  function getFieldValue() {
    if (ftype === 'html') {
      return /*#__PURE__*/React__default.createElement("div", {
        contentEditable: "false",
        dangerouslySetInnerHTML: {
          __html: field.get_string_value(record)
        }
      });
    } else if (field_renderers.includes(ftype)) {
      return /*#__PURE__*/React__default.createElement(Field, {
        field: field,
        record: record,
        variant: "outlined",
        noWrap: true
      });
    }

    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, field.get_string_value(record));
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "text-xs text-gray-600 font-medium ".concat(field.grid_cls)
  }, getFieldValue());
});
var FieldsGrid = observer(function FieldsGrid(props) {
  var fields = props.fields,
      record = props.record,
      default_columns = props.default_columns;
  var columns_classname = "grid-cols-" + default_columns;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex-grow grid w-full gap-y-5 gap-x-4 py-4 px-4 " + columns_classname
  }, fields && record ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, fields.map(function (field, index) {
    return /*#__PURE__*/React__default.createElement(FieldValue, {
      field: field,
      record: record
    });
  })) : "");
});
var ListCardItem = observer(function Cell(props) {
  var screen = props.screen,
      record = props.record;
  var default_columns = screen.default_columns;
  var primary_fields = screen.mobile_primary_fields;
  var header_image_field = screen.mobile_record_image_header_field;
  var isSelected = screen.is_selected(record.id);

  function getHeaderImage() {
    var field_value = header_image_field.get_value(record);
    var uri = field_value ? field_value.data : false;

    if (!uri) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
    }

    return /*#__PURE__*/React__default.createElement("img", {
      style: {
        height: '100%'
      },
      className: "img-fluid",
      src: uri
    });
  }

  return /*#__PURE__*/React__default.createElement(Container, {
    type: "paper",
    className: "border border-gray-300",
    shadowClass: "shadow-md"
  }, (header_image_field || record.mobile_record_titile) && /*#__PURE__*/React__default.createElement("div", {
    className: "flex px-2 py-2 text-gray-600 text-sm",
    style: {
      width: '100%'
    }
  }, header_image_field ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, getHeaderImage()) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, record.mobile_record_title)), primary_fields.length && /*#__PURE__*/React__default.createElement(FieldsGrid, {
    fields: primary_fields,
    record: record,
    default_columns: default_columns
  }));
});

var cache = new CellMeasurerCache({
  defaultHeight: 50,
  fixedWidth: true
});
var CardList = observer(function Spreadsheet(props) {
  var screen = props.screen;

  var _useState = useState({});

  var height = !screen.data.records.length ? 50 : props.height ? props.height : window.innerHeight * 75 / 100;
  var overscanRowCount = 5;
  var rowCount = screen.data.records.length;
  var container_ref = React__default.createRef();
  var data = screen.data.records;

  function _rowRenderer(_ref) {
    var index = _ref.index,
        parent = _ref.parent,
        key = _ref.key,
        style = _ref.style;
    var record = data[index];
    return /*#__PURE__*/React__default.createElement(CellMeasurer, {
      cache: cache,
      columnIndex: 0,
      key: key,
      parent: parent,
      rowIndex: index
    }, function (_ref2) {
      var registerChild = _ref2.registerChild;
      return /*#__PURE__*/React__default.createElement("div", {
        key: key,
        ref: registerChild,
        style: style,
        className: "px-2 py-2"
      }, /*#__PURE__*/React__default.createElement(ListCardItem, {
        record: record,
        screen: screen
      }));
    });
  }

  return /*#__PURE__*/React__default.createElement("div", {
    ref: container_ref,
    className: " flex justify-center  bg-white"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React__default.createElement(LoadingIndicator, {
    ref: container_ref,
    show: screen.data.loading
  }), !props.headless && /*#__PURE__*/React__default.createElement("div", {
    className: "px-2"
  }, /*#__PURE__*/React__default.createElement(ViewHeader, _extends({
    screen: screen,
    hide_toolbar: props.hide_toolbar,
    isSpreadsheet: false
  }, props.header_props))), /*#__PURE__*/React__default.createElement(AutoSizer, {
    disableHeight: true,
    className: "mt-2"
  }, function (_ref3) {
    var width = _ref3.width;
    return /*#__PURE__*/React__default.createElement(List, {
      ref: "List",
      height: height,
      overscanRowCount: overscanRowCount,
      rowCount: rowCount,
      deferredMeasurementCache: cache,
      rowHeight: cache.rowHeight,
      rowRenderer: _rowRenderer,
      width: width
    });
  })));
});

var _customSelectStyles$1;
var customSelectStyles$1 = (_customSelectStyles$1 = {
  menu: function menu(provided, state) {
    return _extends({}, provided, {
      borderRadius: '0px',
      marginTop: '0px'
    });
  },
  control: function control(provided, state) {
    return _extends({}, provided, {
      border: '0px',
      backgroundColor: 'transparent',
      boxShadow: 'none',
      minHeight: '0px'
    });
  },
  indicatorSeparator: function indicatorSeparator(provided, state) {
    return _extends({}, provided, {
      display: 'none'
    });
  },
  dropdownIndicator: function dropdownIndicator(provided, state) {
    return _extends({}, provided, {
      cursor: 'pointer',
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: '1.5rem',
      color: 'inherit'
    });
  },
  input: function input(provided, state) {
    return _extends({}, provided, {
      margin: 0,
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: '1.5rem'
    });
  },
  valueContainer: function valueContainer(provided, state) {
    return _extends({}, provided, {
      cursor: 'pointer',
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: '1.5rem'
    });
  },
  singleValue: function singleValue(provided, state) {
    return _extends({}, provided, {
      cursor: 'pointer',
      padding: 0,
      maxHeight: '1.5rem',
      fontSize: 'inherit',
      fontWeight: 'inherit',
      color: 'inherit',
      fontFamily: 'inherit'
    });
  }
}, _customSelectStyles$1["menu"] = function menu(provided, state) {
  return _extends({}, provided, {
    cursor: 'pointer',
    fontSize: '0.75rem',
    fontWeight: '500',
    color: 'rgba(113, 128, 150,1)',
    fontFamily: 'inherit',
    zIndex: 9999
  });
}, _customSelectStyles$1.option = function option(provided, state) {
  return _extends({}, provided, {
    cursor: 'pointer'
  });
}, _customSelectStyles$1.menuPortal = function menuPortal(provided, state) {
  return _extends({}, provided, {
    zIndex: 9999
  });
}, _customSelectStyles$1);
var CalendarView = observer(function CalendarView(props) {
  var screen = props.screen;
  var data = screen.data.records;
  var localizer = momentLocalizer(moment);
  var height = props.height ? props.height : window.innerHeight * 90 / 100;
  var view_types = screen.view_types;

  var _useState = useState('Mes'),
      viewSelected = _useState[0],
      setViewSelected = _useState[1];

  var filtersInCalendar = true;
  var ref = React__default.createRef();

  function onRangeChange(range) {
    var nameView = range;
    range === 'month' ? nameView = 'Mes' : range === 'week' ? nameView = 'Semana' : range === 'day' ? nameView = 'Dia' : range === 'agenda' ? nameView = 'Agenda' : range === 'work_week' ? nameView = 'Semana Laboral' : nameView = 'undefined';
    setViewSelected(nameView);
  }

  var Toolbar = function Toolbar(props) {
    var optionView = props.views.map(function (view) {
      return {
        value: view,
        label: view === 'month' ? 'Mes' : view === 'week' ? 'Semana' : view === 'day' ? 'Dia' : view === 'agenda' ? 'Agenda' : view === 'work_week' ? 'Semana Laboral' : 'undefined'
      };
    });

    var selectView = function selectView(view) {
      props.onView(view);
    };

    var goToPrevious = function goToPrevious() {
      props.onNavigate('PREV');
    };

    var goToNext = function goToNext() {
      props.onNavigate('NEXT');
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: "w-full"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "flex text-s text-gray-800 "
    }, /*#__PURE__*/React__default.createElement("div", {
      className: " flex w-2/5 pt-1"
    }, /*#__PURE__*/React__default.createElement("p", {
      className: " mx-2 mr-2 text-md text-left flex items-center  text-gray-600 font-medium "
    }, screen.title)), /*#__PURE__*/React__default.createElement("div", {
      ref: ref,
      className: "flex w-3/5  justify-between"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "flex  justify-center py-3"
    }, /*#__PURE__*/React__default.createElement(IconButton, {
      onClick: goToPrevious,
      className: "text-primary",
      color: "transparent"
    }, /*#__PURE__*/React__default.createElement(SvgCheveronLeft, {
      style: {
        width: '.8em',
        height: '.8em'
      },
      className: "fill-current text-primary text-2xl cursor-pointer rounded"
    })), /*#__PURE__*/React__default.createElement("p", {
      className: "flex w-48 text-m justify-center items-center"
    }, props.label), /*#__PURE__*/React__default.createElement(IconButton, {
      onClick: goToNext,
      color: "transparent"
    }, /*#__PURE__*/React__default.createElement(SvgCheveronRight, {
      style: {
        width: '0.8em',
        height: '0.8em'
      },
      className: "fill-current text-primary text-2xl cursor-pointer rounded"
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "flex py-3"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "hover:text-primary w-40 text-gray-600  text-xs font-medium"
    }, /*#__PURE__*/React__default.createElement(Select, {
      styles: customSelectStyles$1,
      placeholder: viewSelected,
      options: optionView,
      onChange: function onChange(value) {
        return selectView(value.value);
      },
      getOptionValue: function getOptionValue(option) {
        return option.value;
      },
      getOptionLabel: function getOptionLabel(option) {
        return option.label;
      }
    }))), screen.filterable ? /*#__PURE__*/React__default.createElement(IconButton, {
      color: "transparent",
      className: "text-primary"
    }, /*#__PURE__*/React__default.createElement(FilterBar, {
      style: {
        width: '.8em',
        height: '.8em'
      },
      className: "fill-current text-xl cursor-pointer",
      filters: screen.filters,
      filtersInCalendar: screen.filters.active_filters.length > 0 ? filtersInCalendar : false,
      parent_ref: ref
    })) : ""))));
  };

  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: height
    },
    className: " w-full bg-white "
  }, /*#__PURE__*/React__default.createElement(Calendar$1, {
    selectable: true,
    popup: true,
    events: data,
    views: view_types,
    step: 60,
    showMultiDayTimes: true,
    titleAccessor: function titleAccessor(event) {
      return screen.get_title_value(event);
    },
    startAccessor: function startAccessor(event) {
      return screen.get_start_date_value(event);
    },
    endAccessor: function endAccessor(event) {
      return screen.get_end_date_value(event);
    },
    allDayAccessor: function allDayAccessor(event) {
      return screen.all_day_events;
    },
    onSelectEvent: function onSelectEvent(event) {
      screen.view_event_detail([event]);
    },
    onSelectSlot: function onSelectSlot(info) {
      screen.new_event(info);
    },
    localizer: localizer,
    onView: onRangeChange,
    messages: {
      'month': 'Mes',
      'week': 'Semana',
      'day': 'Dia',
      'agenda': 'Agenda',
      'work_week': 'Semana de trabajo',
      'today': 'Hoy',
      'previous': '<',
      'next': '>'
    },
    timeslots: 1,
    min: new Date(0, 0, 0, 10, 0, 0),
    max: new Date(0, 0, 0, 22, 0, 0),
    components: {
      toolbar: Toolbar
    },
    formats: {
      dayFormat: 'dd MM YYYY',
      timeGutterFormat: 'ha',
      dayHeaderFormat: 'DD MMMM, YYYY'
    },
    defaultDate: new Date(),
    defaultView: "month"
  }));
});

var View_ = observer(function View_(props) {
  var type = props.screen.type;
  var loadingFields = props.screen.loadingFields;
  var modal_childs = props.screen.modal_childs.screens || {};
  var container = props.container;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !loadingFields && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, type === "list" || type === "spreadsheet" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, props.screen.fields.length > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, props.screen.list_type == 'card_list' ? /*#__PURE__*/React__default.createElement(CardList, {
    screen: props.screen,
    height: props.height,
    headless: props.headless,
    hide_toolbar: props.hide_toolbar,
    container: container
  }) : /*#__PURE__*/React__default.createElement(Spreadsheet, {
    screen: props.screen,
    height: props.height,
    headless: props.headless,
    hide_toolbar: props.hide_toolbar,
    container: container
  }))) : type === "form" ? /*#__PURE__*/React__default.createElement(FormView, {
    screen: props.screen,
    containerStyle: props.containerStyle || {},
    container: container
  }) : type === "calendar" ? /*#__PURE__*/React__default.createElement(CalendarView, {
    screen: props.screen,
    containerStyle: props.containerStyle || {},
    container: container
  }) : type === "html" ? /*#__PURE__*/React__default.createElement(HtmlView, {
    screen: props.screen,
    height: props.height,
    container: container
  }) : type === "board" ? /*#__PURE__*/React__default.createElement(BoardView, {
    screen: props.screen,
    container: container
  }) : type === "graph" ? /*#__PURE__*/React__default.createElement(GraphView, {
    screen: props.screen,
    height: props.height,
    hide_toolbar: props.hide_toolbar,
    container: container
  }) : type === "custom" ? /*#__PURE__*/React__default.createElement("div", null, "TODO: Custom views") : /*#__PURE__*/React__default.createElement("div", null, "Not supported view"), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, Object.keys(modal_childs).map(function (s, i) {
    return /*#__PURE__*/React__default.createElement(ModalView, {
      key: i,
      open: true,
      screen: modal_childs[s]
    });
  }))));
});

function Item$1(props) {
  var title = props.title,
      description = props.description,
      _onClick = props.onClick,
      view_definition = props.view_definition;
  return /*#__PURE__*/React__default.createElement("div", {
    onClick: function onClick() {
      _onClick(view_definition);
    },
    className: "bg-white border border-gray-300 px-2 py-2 cursor-pointer hover:bg-light-selected"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: '#24435f'
    },
    className: "text-sm text-gray-600 font-bold"
  }, title), /*#__PURE__*/React__default.createElement("div", {
    className: "text-xs text-gray-600"
  }, description));
}

function OptionList(props) {
  var options = props.options,
      onSelectWizard = props.onSelectWizard,
      close = props.close;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "px-4 py-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-row mb-4 justify-between items-center w-full"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: '#24435f'
    },
    className: "text-xl text-gray-600  font-medium"
  }, "A\xF1adir"), /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick(e) {
      close();
    },
    color: "warning"
  }, /*#__PURE__*/React__default.createElement(SvgClose, {
    style: {
      width: '.8em',
      height: '.8em'
    },
    className: "fill-current  text-xl cursor-pointer w-4 h-2"
  }))), options.map(function (option, index) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, /*#__PURE__*/React__default.createElement(Item$1, {
      title: option.name,
      description: option.description,
      view_definition: option.view,
      onClick: onSelectWizard
    }));
  }));
}

function ViewContainer(props) {
  var reloadAndClose = function reloadAndClose(record, screen) {
    try {
      return Promise.resolve(screen.default_save_action.execute([record], false, false, true)).then(function (view_data) {
        return Promise.resolve(app_context.connection.loadRoutes()).then(function () {
          var route_id = false;

          for (var v in view_data) {
            route_id = view_data[v].id;
          }

          console.log("ROUTE ID FOUND");
          console.log(route_id);
          var route = app_context.connection.getRouteById(route_id);
          console.log("ROUTE");
          console.log(route);

          if (route) {
            history.push(route.path);
          }

          close();
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var view_definition = props.view_definition,
      dispatch = props.dispatch,
      close = props.close;
  var app_context = useContext(AppContext);
  var screen = app_context.addScreen(view_definition, false, {}, {}, true, true, false, true, true, true, false);
  var history = useHistory();
  var actions_map = {};

  actions_map['save'] = function (records) {
    reloadAndClose(records[0], screen);
  };

  screen.set_actions_map(actions_map);

  function goBack() {
    var value = {
      view_definition: {}
    };
    dispatch({
      type: 'BACK',
      payload: {
        value: value
      }
    });
  }

  return /*#__PURE__*/React__default.createElement(Fragment$1, null, /*#__PURE__*/React__default.createElement("div", {
    className: "text-right px-2 flex justify-start"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: function onClick(e) {
      goBack();
    },
    color: "transparent"
  }, /*#__PURE__*/React__default.createElement(SvgCheveronLeft, {
    style: {
      width: '1.5em',
      height: '1.5em'
    },
    className: "fill-current text-xl cursor-pointer w-4 h-2"
  }))), screen && /*#__PURE__*/React__default.createElement(View_, {
    screen: screen,
    containerStyle: {
      backgroundColor: 'transparent',
      boxShadow: 'none'
    }
  }));
}

var ViewWizardSelector = observer(function ViewWizardSelector(props) {
  var initialState = {
    'step': 1,
    'view_definition': {}
  };
  var open = props.open,
      close = props.close;
  var connection = useContext(SessionContext);

  var _useReducer = useReducer(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var options = connection.editor_config ? connection.editor_config.view_wizards : [];
  var style = state.step === 2 ? {
    height: 'calc(100% - 101px)'
  } : {};

  function reducer(state, action) {
    switch (action.type) {
      case 'NEXT':
        var next = state.step + 1;
        return _extends({}, state, action.payload.value, {
          step: next
        });

      case 'BACK':
        var back = state.step - 1;
        return _extends({}, state, action.payload.value, {
          step: back
        });

      default:
        throw new Error("Invalid Action".concat(action.type));
    }
  }

  function onSelectWizard(view_definition) {
    console.log("View definition getted");
    console.log(view_definition);
    var value = {
      view_definition: view_definition
    };
    dispatch({
      type: 'NEXT',
      payload: {
        value: value
      }
    });
  }

  return /*#__PURE__*/React__default.createElement(Modal$1, {
    open: open,
    className: "sm:w-6/12 z-50 overflow-scroll bg-white  ",
    paper: true,
    onRequestClose: function onRequestClose() {
      close(false);
    },
    style: style
  }, state.step === 1 ? /*#__PURE__*/React__default.createElement(OptionList, {
    options: options,
    onSelectWizard: onSelectWizard,
    close: close
  }) : state.step === 2 ? /*#__PURE__*/React__default.createElement(ViewContainer, {
    view_definition: state.view_definition,
    dispatch: dispatch,
    close: close
  }) : /*#__PURE__*/React__default.createElement(Fragment$1, null));
});

var sizes = {
  'mobile': {
    maxWidth: 639
  },
  'sm': {
    minWidth: 640,
    maxWidth: 767
  },
  'md': {
    minWidth: 768,
    maxWidth: 1023
  },
  'lg': {
    minWidth: 1024,
    maxWidth: 1279
  },
  'xl': {
    minWidth: 1280
  }
};

var getLimits = function getLimits(screen, up, down) {
  var limits = _extends({}, sizes[screen]);

  if (up) {
    delete limits['maxWidth'];
  }

  if (down) {
    delete limits['minWidth'];
  }

  return limits;
};

var IsScreen = function IsScreen(props) {
  var limits = getLimits(props.type, props.up, props.down);
  var res = useMediaQuery(limits);
  return res;
};
var Mobile = function Mobile(props) {
  var limits = getLimits('mobile', props.up, props.down);
  var isMobile = useMediaQuery(limits);
  return isMobile ? props.children : null;
};
var Sm = function Sm(props) {
  var limits = getLimits('sm', props.up, props.down);
  var isDesktop = useMediaQuery(limits);
  return isDesktop ? props.children : null;
};
var Md$1 = function Md(props) {
  var limits = getLimits('md', props.up, props.down);
  var isTablet = useMediaQuery(limits);
  return isTablet ? props.children : null;
};
var Lg$1 = function Lg(props) {
  var limits = getLimits('lg', props.up, props.down);
  var Lg = useMediaQuery(limits);
  return Lg ? props.children : null;
};
var Xl = function Xl(props) {
  var limits = getLimits('xl', props.up, props.down);
  var Xl = useMediaQuery(limits);
  return Xl ? props.children : null;
};
var Screens = {
  Mobile: Mobile,
  Sm: Sm,
  Md: Md$1,
  Lg: Lg$1,
  Xl: Xl,
  IsScreen: IsScreen
};

export { DropDown, DropDownMenu, Field, FormButton, IconButton, Paper, Portal, Screens, ViewWizardSelector, View_, common };
//# sourceMappingURL=index.modern.js.map
